(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global.BpmnJS = factory());
}(this, (function () {
    'use strict';
    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn, module) {
        return module = {exports: {}}, fn(module, module.exports), module.exports;
    }

    var inherits_browser = createCommonjsModule(function (module) {
        if (typeof Object.create === 'function') {
            module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                    constructor: {
                        value: ctor,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
            };
        } else {
            module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function () {
                };
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
            };
        }
    });
    var hat_1 = createCommonjsModule(function (module) {
        var hat = module.exports = function (bits, base) {
            if (!base) base = 16;
            if (bits === undefined) bits = 128;
            if (bits <= 0) return '0';
            var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
            for (var i = 2; digits === Infinity; i *= 2) {
                digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
            }
            var rem = digits - Math.floor(digits);
            var res = '';
            for (var i = 0; i < Math.floor(digits); i++) {
                var x = Math.floor(Math.random() * base).toString(base);
                res = x + res;
            }
            if (rem) {
                var b = Math.pow(base, rem);
                var x = Math.floor(Math.random() * b).toString(base);
                res = x + res;
            }
            var parsed = parseInt(res, base);
            if (parsed !== Infinity && parsed >= Math.pow(2, bits)) {
                return hat(bits, base)
            } else return res;
        };
        hat.rack = function (bits, base, expandBy) {
            var fn = function (data) {
                var iters = 0;
                do {
                    if (iters++ > 10) {
                        if (expandBy) bits += expandBy; else throw new Error('too many ID collisions, use more bits')
                    }
                    var id = hat(bits, base);
                } while (Object.hasOwnProperty.call(hats, id));
                hats[id] = data;
                return id;
            };
            var hats = fn.hats = {};
            fn.get = function (id) {
                return fn.hats[id];
            };
            fn.set = function (id, value) {
                fn.hats[id] = value;
                return fn;
            };
            fn.bits = bits || 128;
            fn.base = base || 16;
            return fn;
        };
    });

    function Ids(seed) {
        if (!(this instanceof Ids)) {
            return new Ids(seed);
        }
        seed = seed || [128, 36, 1];
        this._seed = seed.length ? hat_1.rack(seed[0], seed[1], seed[2]) : seed;
    }

    var ids = Ids;
    Ids.prototype.next = function (element) {
        return this._seed(element || true);
    };
    Ids.prototype.nextPrefixed = function (prefix, element) {
        var id;
        do {
            id = prefix + this.next(true);
        } while (this.assigned(id));
        this.claim(id, element);
        return id;
    };
    Ids.prototype.claim = function (id, element) {
        this._seed.set(id, element || true);
    };
    Ids.prototype.assigned = function (id) {
        return this._seed.get(id) || false;
    };
    Ids.prototype.unclaim = function (id) {
        delete this._seed.hats[id];
    };
    Ids.prototype.clear = function () {
        var hats = this._seed.hats, id;
        for (id in hats) {
            this.unclaim(id);
        }
    };

    function flatten(arr) {
        return Array.prototype.concat.apply([], arr);
    }

    var nativeToString = Object.prototype.toString;
    var nativeHasOwnProperty = Object.prototype.hasOwnProperty;

    function isUndefined(obj) {
        return obj === undefined;
    }

    function isDefined(obj) {
        return obj !== undefined;
    }

    function isArray(obj) {
        return nativeToString.call(obj) === '[object Array]';
    }

    function isObject(obj) {
        return nativeToString.call(obj) === '[object Object]';
    }

    function isNumber(obj) {
        return nativeToString.call(obj) === '[object Number]';
    }

    function isFunction(obj) {
        return nativeToString.call(obj) === '[object Function]';
    }

    function isString(obj) {
        return nativeToString.call(obj) === '[object String]';
    }

    function ensureArray(obj) {
        if (isArray(obj)) {
            return;
        }
        throw new Error('must supply array');
    }

    function has(target, key) {
        return nativeHasOwnProperty.call(target, key);
    }

    function find(collection, matcher) {
        matcher = toMatcher(matcher);
        var match;
        forEach(collection, function (val, key) {
            if (matcher(val, key)) {
                match = val;
                return false;
            }
        });
        return match;
    }

    function findIndex(collection, matcher) {
        matcher = toMatcher(matcher);
        var idx = isArray(collection) ? -1 : undefined;
        forEach(collection, function (val, key) {
            if (matcher(val, key)) {
                idx = key;
                return false;
            }
        });
        return idx;
    }

    function filter(collection, matcher) {
        var result = [];
        forEach(collection, function (val, key) {
            if (matcher(val, key)) {
                result.push(val);
            }
        });
        return result;
    }

    function forEach(collection, iterator) {
        if (isUndefined(collection)) {
            return;
        }
        var convertKey = isArray(collection) ? toNum : identity;
        for (var key in collection) {
            if (has(collection, key)) {
                var val = collection[key];
                var result = iterator(val, convertKey(key));
                if (result === false) {
                    return;
                }
            }
        }
    }

    function without(arr, matcher) {
        if (isUndefined(arr)) {
            return [];
        }
        ensureArray(arr);
        matcher = toMatcher(matcher);
        return arr.filter(function (el, idx) {
            return !matcher(el, idx);
        });
    }

    function reduce(collection, iterator, result) {
        forEach(collection, function (value, idx) {
            result = iterator(result, value, idx);
        });
        return result;
    }

    function every(collection, matcher) {
        return reduce(collection, function (matches, val, key) {
            return matches && matcher(val, key);
        }, true);
    }

    function some(collection, matcher) {
        return !!find(collection, matcher);
    }

    function map(collection, fn) {
        var result = [];
        forEach(collection, function (val, key) {
            result.push(fn(val, key));
        });
        return result;
    }

    function keys(collection) {
        return collection && Object.keys(collection) || [];
    }

    function size(collection) {
        return keys(collection).length;
    }

    function values(collection) {
        return map(collection, function (val) {
            return val;
        });
    }

    function groupBy(collection, extractor) {
        var grouped = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        extractor = toExtractor(extractor);
        forEach(collection, function (val) {
            var discriminator = extractor(val) || '_';
            var group = grouped[discriminator];
            if (!group) {
                group = grouped[discriminator] = [];
            }
            group.push(val);
        });
        return grouped;
    }

    function uniqueBy(extractor) {
        extractor = toExtractor(extractor);
        var grouped = {};
        for (var _len = arguments.length, collections = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            collections[_key - 1] = arguments[_key];
        }
        forEach(collections, function (c) {
            return groupBy(c, extractor, grouped);
        });
        var result = map(grouped, function (val, key) {
            return val[0];
        });
        return result;
    }

    var unionBy = uniqueBy;

    function sortBy(collection, extractor) {
        extractor = toExtractor(extractor);
        var sorted = [];
        forEach(collection, function (value, key) {
            var disc = extractor(value, key);
            var entry = {d: disc, v: value};
            for (var idx = 0; idx < sorted.length; idx++) {
                var d = sorted[idx].d;
                if (disc < d) {
                    sorted.splice(idx, 0, entry);
                    return;
                }
            }
            sorted.push(entry);
        });
        return map(sorted, function (e) {
            return e.v;
        });
    }

    function matchPattern(pattern) {
        return function (el) {
            return every(pattern, function (val, key) {
                return el[key] === val;
            });
        };
    }

    function toExtractor(extractor) {
        return isFunction(extractor) ? extractor : function (e) {
            return e[extractor];
        };
    }

    function toMatcher(matcher) {
        return isFunction(matcher) ? matcher : function (e) {
            return e === matcher;
        };
    }

    function identity(arg) {
        return arg;
    }

    function toNum(arg) {
        return Number(arg);
    }

    function debounce(fn, timeout) {
        var timer;
        var lastArgs;
        var lastThis;
        var lastNow;

        function fire() {
            var now = Date.now();
            var scheduledDiff = lastNow + timeout - now;
            if (scheduledDiff > 0) {
                return schedule(scheduledDiff);
            }
            fn.apply(lastThis, lastArgs);
            timer = lastNow = lastArgs = lastThis = undefined;
        }

        function schedule(timeout) {
            timer = setTimeout(fire, timeout);
        }

        return function () {
            lastNow = Date.now();
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }
            lastArgs = args;
            lastThis = this;
            if (!timer) {
                schedule(timeout);
            }
        };
    }

    function bind(fn, target) {
        return fn.bind(target);
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };

    function assign(target) {
        for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            others[_key - 1] = arguments[_key];
        }
        return _extends.apply(undefined, [target].concat(others));
    }

    function pick(target, properties) {
        var result = {};
        var obj = Object(target);
        forEach(properties, function (prop) {
            if (prop in obj) {
                result[prop] = target[prop];
            }
        });
        return result;
    }

    function omit(target, properties) {
        var result = {};
        var obj = Object(target);
        forEach(obj, function (prop, key) {
            if (properties.indexOf(key) === -1) {
                result[key] = prop;
            }
        });
        return result;
    }

    function attr(el, name, val) {
        if (arguments.length == 2) {
            return el.getAttribute(name);
        }
        if (val === null) {
            return el.removeAttribute(name);
        }
        el.setAttribute(name, val);
        return el;
    }

    var indexOf = [].indexOf;
    var indexof = function (arr, obj) {
        if (indexOf) return arr.indexOf(obj);
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i] === obj) return i;
        }
        return -1;
    };
    var re = /\s+/;
    var toString = Object.prototype.toString;

    function classes(el) {
        return new ClassList(el);
    }

    function ClassList(el) {
        if (!el || !el.nodeType) {
            throw new Error('A DOM element reference is required');
        }
        this.el = el;
        this.list = el.classList;
    }

    ClassList.prototype.add = function (name) {
        if (this.list) {
            this.list.add(name);
            return this;
        }
        var arr = this.array();
        var i = indexof(arr, name);
        if (!~i) arr.push(name);
        this.el.className = arr.join(' ');
        return this;
    };
    ClassList.prototype.remove = function (name) {
        if ('[object RegExp]' == toString.call(name)) {
            return this.removeMatching(name);
        }
        if (this.list) {
            this.list.remove(name);
            return this;
        }
        var arr = this.array();
        var i = indexof(arr, name);
        if (~i) arr.splice(i, 1);
        this.el.className = arr.join(' ');
        return this;
    };
    ClassList.prototype.removeMatching = function (re) {
        var arr = this.array();
        for (var i = 0; i < arr.length; i++) {
            if (re.test(arr[i])) {
                this.remove(arr[i]);
            }
        }
        return this;
    };
    ClassList.prototype.toggle = function (name, force) {
        if (this.list) {
            if ('undefined' !== typeof force) {
                if (force !== this.list.toggle(name, force)) {
                    this.list.toggle(name);
                }
            } else {
                this.list.toggle(name);
            }
            return this;
        }
        if ('undefined' !== typeof force) {
            if (!force) {
                this.remove(name);
            } else {
                this.add(name);
            }
        } else {
            if (this.has(name)) {
                this.remove(name);
            } else {
                this.add(name);
            }
        }
        return this;
    };
    ClassList.prototype.array = function () {
        var className = this.el.getAttribute('class') || '';
        var str = className.replace(/^\s+|\s+$/g, '');
        var arr = str.split(re);
        if ('' === arr[0]) arr.shift();
        return arr;
    };
    ClassList.prototype.has = ClassList.prototype.contains = function (name) {
        return this.list ? this.list.contains(name) : !!~indexof(this.array(), name);
    };

    function clear(el) {
        var c;
        while (el.childNodes.length) {
            c = el.childNodes[0];
            el.removeChild(c);
        }
        return el;
    }

    var proto = Element.prototype;
    var vendor = proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
    var matchesSelector = match;

    function match(el, selector) {
        if (vendor) return vendor.call(el, selector);
        var nodes = el.parentNode.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; ++i) {
            if (nodes[i] == el) return true;
        }
        return false;
    }

    var closest = function (element, selector, checkYoSelf) {
        var parent = checkYoSelf ? element : element.parentNode;
        while (parent && parent !== document) {
            if (matchesSelector(parent, selector)) return parent;
            parent = parent.parentNode;
        }
    };
    var bind$1 = window.addEventListener ? 'addEventListener' : 'attachEvent',
        unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
        prefix = bind$1 !== 'addEventListener' ? 'on' : '';
    var bind_1 = function (el, type, fn, capture) {
        el[bind$1](prefix + type, fn, capture || false);
        return fn;
    };
    var unbind_1 = function (el, type, fn, capture) {
        el[unbind](prefix + type, fn, capture || false);
        return fn;
    };
    var componentEvent = {bind: bind_1, unbind: unbind_1};
    var forceCaptureEvents = ['focus', 'blur'];
    var bind$1$1 = function (el, selector, type, fn, capture) {
        if (forceCaptureEvents.indexOf(type) !== -1) capture = true;
        return componentEvent.bind(el, type, function (e) {
            var target = e.target || e.srcElement;
            e.delegateTarget = closest(target, selector, true, el);
            if (e.delegateTarget) fn.call(el, e);
        }, capture);
    };
    var unbind$1 = function (el, type, fn, capture) {
        if (forceCaptureEvents.indexOf(type) !== -1) capture = true;
        componentEvent.unbind(el, type, fn, capture);
    };
    var delegateEvents = {bind: bind$1$1, unbind: unbind$1};
    var domify = parse;
    var innerHTMLBug = false;
    var bugTestDiv;
    if (typeof document !== 'undefined') {
        bugTestDiv = document.createElement('div');
        bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
        innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
        bugTestDiv = undefined;
    }
    var map$1 = {
        legend: [1, '<fieldset>', '</fieldset>'],
        tr: [2, '<table><tbody>', '</tbody></table>'],
        col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
        _default: innerHTMLBug ? [1, 'X<div>', '</div>'] : [0, '', '']
    };
    map$1.td = map$1.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
    map$1.option = map$1.optgroup = [1, '<select multiple="multiple">', '</select>'];
    map$1.thead = map$1.tbody = map$1.colgroup = map$1.caption = map$1.tfoot = [1, '<table>', '</table>'];
    map$1.polyline = map$1.ellipse = map$1.polygon = map$1.circle = map$1.text = map$1.line = map$1.path = map$1.rect = map$1.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">', '</svg>'];

    function parse(html, doc) {
        if ('string' != typeof html) throw new TypeError('String expected');
        if (!doc) doc = document;
        var m = /<([\w:]+)/.exec(html);
        if (!m) return doc.createTextNode(html);
        html = html.replace(/^\s+|\s+$/g, '');
        var tag = m[1];
        if (tag == 'body') {
            var el = doc.createElement('html');
            el.innerHTML = html;
            return el.removeChild(el.lastChild);
        }
        var wrap = map$1[tag] || map$1._default;
        var depth = wrap[0];
        var prefix = wrap[1];
        var suffix = wrap[2];
        var el = doc.createElement('div');
        el.innerHTML = prefix + html + suffix;
        while (depth--) el = el.lastChild;
        if (el.firstChild == el.lastChild) {
            return el.removeChild(el.firstChild);
        }
        var fragment = doc.createDocumentFragment();
        while (el.firstChild) {
            fragment.appendChild(el.removeChild(el.firstChild));
        }
        return fragment;
    }

    var proto$1 = typeof Element !== 'undefined' ? Element.prototype : {};
    var vendor$1 = proto$1.matches || proto$1.matchesSelector || proto$1.webkitMatchesSelector || proto$1.mozMatchesSelector || proto$1.msMatchesSelector || proto$1.oMatchesSelector;
    var matchesSelector$1 = match$1;

    function match$1(el, selector) {
        if (!el || el.nodeType !== 1) return false;
        if (vendor$1) return vendor$1.call(el, selector);
        var nodes = el.parentNode.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i] == el) return true;
        }
        return false;
    }

    function query(selector, el) {
        el = el || document;
        return el.querySelector(selector);
    }

    function all(selector, el) {
        el = el || document;
        return el.querySelectorAll(selector);
    }

    function remove(el) {
        el.parentNode && el.parentNode.removeChild(el);
    }

    function ensureImported(element, target) {
        if (element.ownerDocument !== target.ownerDocument) {
            try {
                return target.ownerDocument.importNode(element, true);
            } catch (e) {
            }
        }
        return element;
    }

    function appendTo(element, target) {
        return target.appendChild(ensureImported(element, target));
    }

    function append(target, node) {
        appendTo(node, target);
        return target;
    }

    var LENGTH_ATTR = 2;
    var CSS_PROPERTIES = {
        'alignment-baseline': 1,
        'baseline-shift': 1,
        'clip': 1,
        'clip-path': 1,
        'clip-rule': 1,
        'color': 1,
        'color-interpolation': 1,
        'color-interpolation-filters': 1,
        'color-profile': 1,
        'color-rendering': 1,
        'cursor': 1,
        'direction': 1,
        'display': 1,
        'dominant-baseline': 1,
        'enable-background': 1,
        'fill': 1,
        'fill-opacity': 1,
        'fill-rule': 1,
        'filter': 1,
        'flood-color': 1,
        'flood-opacity': 1,
        'font': 1,
        'font-family': 1,
        'font-size': LENGTH_ATTR,
        'font-size-adjust': 1,
        'font-stretch': 1,
        'font-style': 1,
        'font-variant': 1,
        'font-weight': 1,
        'glyph-orientation-horizontal': 1,
        'glyph-orientation-vertical': 1,
        'image-rendering': 1,
        'kerning': 1,
        'letter-spacing': 1,
        'lighting-color': 1,
        'marker': 1,
        'marker-end': 1,
        'marker-mid': 1,
        'marker-start': 1,
        'mask': 1,
        'opacity': 1,
        'overflow': 1,
        'pointer-events': 1,
        'shape-rendering': 1,
        'stop-color': 1,
        'stop-opacity': 1,
        'stroke': 1,
        'stroke-dasharray': 1,
        'stroke-dashoffset': 1,
        'stroke-linecap': 1,
        'stroke-linejoin': 1,
        'stroke-miterlimit': 1,
        'stroke-opacity': 1,
        'stroke-width': LENGTH_ATTR,
        'text-anchor': 1,
        'text-decoration': 1,
        'text-rendering': 1,
        'unicode-bidi': 1,
        'visibility': 1,
        'word-spacing': 1,
        'writing-mode': 1
    };

    function getAttribute(node, name) {
        if (CSS_PROPERTIES[name]) {
            return node.style[name];
        } else {
            return node.getAttributeNS(null, name);
        }
    }

    function setAttribute(node, name, value) {
        var hyphenated = name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        var type = CSS_PROPERTIES[hyphenated];
        if (type) {
            if (type === LENGTH_ATTR && typeof value === 'number') {
                value = String(value) + 'px';
            }
            node.style[hyphenated] = value;
        } else {
            node.setAttributeNS(null, name, value);
        }
    }

    function setAttributes(node, attrs) {
        var names = Object.keys(attrs), i, name;
        for (i = 0, name; (name = names[i]); i++) {
            setAttribute(node, name, attrs[name]);
        }
    }

    function attr$1(node, name, value) {
        if (typeof name === 'string') {
            if (value !== undefined) {
                setAttribute(node, name, value);
            } else {
                return getAttribute(node, name);
            }
        } else {
            setAttributes(node, name);
        }
        return node;
    }

    function index(arr, obj) {
        if (arr.indexOf) {
            return arr.indexOf(obj);
        }
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i] === obj) {
                return i;
            }
        }
        return -1;
    }

    var re$1 = /\s+/;
    var toString$1 = Object.prototype.toString;

    function defined(o) {
        return typeof o !== 'undefined';
    }

    function classes$1(el) {
        return new ClassList$1(el);
    }

    function ClassList$1(el) {
        if (!el || !el.nodeType) {
            throw new Error('A DOM element reference is required');
        }
        this.el = el;
        this.list = el.classList;
    }

    ClassList$1.prototype.add = function (name) {
        if (this.list) {
            this.list.add(name);
            return this;
        }
        var arr = this.array();
        var i = index(arr, name);
        if (!~i) {
            arr.push(name);
        }
        if (defined(this.el.className.baseVal)) {
            this.el.className.baseVal = arr.join(' ');
        } else {
            this.el.className = arr.join(' ');
        }
        return this;
    };
    ClassList$1.prototype.remove = function (name) {
        if ('[object RegExp]' === toString$1.call(name)) {
            return this.removeMatching(name);
        }
        if (this.list) {
            this.list.remove(name);
            return this;
        }
        var arr = this.array();
        var i = index(arr, name);
        if (~i) {
            arr.splice(i, 1);
        }
        this.el.className.baseVal = arr.join(' ');
        return this;
    };
    ClassList$1.prototype.removeMatching = function (re) {
        var arr = this.array();
        for (var i = 0; i < arr.length; i++) {
            if (re.test(arr[i])) {
                this.remove(arr[i]);
            }
        }
        return this;
    };
    ClassList$1.prototype.toggle = function (name, force) {
        if (this.list) {
            if (defined(force)) {
                if (force !== this.list.toggle(name, force)) {
                    this.list.toggle(name);
                }
            } else {
                this.list.toggle(name);
            }
            return this;
        }
        if (defined(force)) {
            if (!force) {
                this.remove(name);
            } else {
                this.add(name);
            }
        } else {
            if (this.has(name)) {
                this.remove(name);
            } else {
                this.add(name);
            }
        }
        return this;
    };
    ClassList$1.prototype.array = function () {
        var className = this.el.getAttribute('class') || '';
        var str = className.replace(/^\s+|\s+$/g, '');
        var arr = str.split(re$1);
        if ('' === arr[0]) {
            arr.shift();
        }
        return arr;
    };
    ClassList$1.prototype.has = ClassList$1.prototype.contains = function (name) {
        return (this.list ? this.list.contains(name) : !!~index(this.array(), name));
    };

    function remove$1(element) {
        var parent = element.parentNode;
        if (parent) {
            parent.removeChild(element);
        }
        return element;
    }

    function clear$1(element) {
        var child;
        while ((child = element.firstChild)) {
            remove$1(child);
        }
        return element;
    }

    function clone(element) {
        return element.cloneNode(true);
    }

    var ns = {svg: 'http://www.w3.org/2000/svg'};
    var SVG_START = '<svg xmlns="' + ns.svg + '"';

    function parse$1(svg) {
        var unwrap = false;
        if (svg.substring(0, 4) === '<svg') {
            if (svg.indexOf(ns.svg) === -1) {
                svg = SVG_START + svg.substring(4);
            }
        } else {
            svg = SVG_START + '>' + svg + '</svg>';
            unwrap = true;
        }
        var parsed = parseDocument(svg);
        if (!unwrap) {
            return parsed;
        }
        var fragment = document.createDocumentFragment();
        var parent = parsed.firstChild;
        while (parent.firstChild) {
            fragment.appendChild(parent.firstChild);
        }
        return fragment;
    }

    function parseDocument(svg) {
        var parser;
        parser = new DOMParser();
        parser.async = false;
        return parser.parseFromString(svg, 'text/xml');
    }

    function create(name, attrs) {
        var element;
        if (name.charAt(0) === '<') {
            element = parse$1(name).firstChild;
            element = document.importNode(element, true);
        } else {
            element = document.createElementNS(ns.svg, name);
        }
        if (attrs) {
            attr$1(element, attrs);
        }
        return element;
    }

    var node = create('svg');

    function extend(object, props) {
        var i, k, keys = Object.keys(props);
        for (i = 0; (k = keys[i]); i++) {
            object[k] = props[k];
        }
        return object;
    }

    function createMatrix(a, b, c, d, e, f) {
        var matrix = node.createSVGMatrix();
        switch (arguments.length) {
            case 0:
                return matrix;
            case 6:
                a = {a: a, b: b, c: c, d: d, e: e, f: f};
                break;
        }
        return extend(matrix, a);
    }

    function createTransform(matrix) {
        if (matrix) {
            return node.createSVGTransformFromMatrix(matrix);
        } else {
            return node.createSVGTransform();
        }
    }

    var TEXT_ENTITIES = /([&<>]{1})/g;
    var ATTR_ENTITIES = /([\n\r"]{1})/g;
    var ENTITY_REPLACEMENT = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '\''};

    function escape(str, pattern) {
        function replaceFn(match, entity) {
            return ENTITY_REPLACEMENT[entity] || entity;
        }

        return str.replace(pattern, replaceFn);
    }

    function serialize(node, output) {
        var i, len, attrMap, attrNode, childNodes;
        switch (node.nodeType) {
            case 3:
                output.push(escape(node.textContent, TEXT_ENTITIES));
                break;
            case 1:
                output.push('<', node.tagName);
                if (node.hasAttributes()) {
                    attrMap = node.attributes;
                    for (i = 0, len = attrMap.length; i < len; ++i) {
                        attrNode = attrMap.item(i);
                        output.push(' ', attrNode.name, '="', escape(attrNode.value, ATTR_ENTITIES), '"');
                    }
                }
                if (node.hasChildNodes()) {
                    output.push('>');
                    childNodes = node.childNodes;
                    for (i = 0, len = childNodes.length; i < len; ++i) {
                        serialize(childNodes.item(i), output);
                    }
                    output.push('</', node.tagName, '>');
                } else {
                    output.push('/>');
                }
                break;
            case 8:
                output.push('<!--', escape(node.nodeValue, TEXT_ENTITIES), '-->');
                break;
            case 4:
                output.push('<![CDATA[', node.nodeValue, ']]>');
                break;
            default:
                throw new Error('unable to handle node ' + node.nodeType);
        }
        return output;
    }

    function set(element, svg) {
        var parsed = parse$1(svg);
        clear$1(element);
        if (!svg) {
            return;
        }
        if (!isFragment(parsed)) {
            parsed = parsed.documentElement;
        }
        var nodes = slice(parsed.childNodes);
        for (var i = 0; i < nodes.length; i++) {
            appendTo(nodes[i], element);
        }
    }

    function get(element) {
        var child = element.firstChild, output = [];
        while (child) {
            serialize(child, output);
            child = child.nextSibling;
        }
        return output.join('');
    }

    function isFragment(node) {
        return node.nodeName === '#document-fragment';
    }

    function innerSVG(element, svg) {
        if (svg !== undefined) {
            try {
                set(element, svg);
            } catch (e) {
                throw new Error('error parsing SVG: ' + e.message);
            }
            return element;
        } else {
            return get(element);
        }
    }

    function slice(arr) {
        return Array.prototype.slice.call(arr);
    }

    function wrapMatrix(transformList, transform) {
        if (transform instanceof SVGMatrix) {
            return transformList.createSVGTransformFromMatrix(transform);
        } else {
            return transform;
        }
    }

    function setTransforms(transformList, transforms) {
        var i, t;
        transformList.clear();
        for (i = 0; (t = transforms[i]); i++) {
            transformList.appendItem(wrapMatrix(transformList, t));
        }
        transformList.consolidate();
    }

    function transform(node, transforms) {
        var transformList = node.transform.baseVal;
        if (arguments.length === 1) {
            return transformList.consolidate();
        } else {
            if (transforms.length) {
                setTransforms(transformList, transforms);
            } else {
                transformList.initialize(wrapMatrix(transformList, transforms));
            }
        }
    }

    var CLASS_PATTERN = /^class /;

    function isClass(fn) {
        return CLASS_PATTERN.test(fn.toString());
    }

    function isArray$1(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }

    function annotate() {
        var args = Array.prototype.slice.call(arguments);
        if (args.length === 1 && isArray$1(args[0])) {
            args = args[0];
        }
        var fn = args.pop();
        fn.$inject = args;
        return fn;
    }

    var CONSTRUCTOR_ARGS = /constructor\s*[^(]*\(\s*([^)]*)\)/m;
    var FN_ARGS = /^function\s*[^(]*\(\s*([^)]*)\)/m;
    var FN_ARG = /\/\*([^*]*)\*\//m;

    function parse$2(fn) {
        if (typeof fn !== 'function') {
            throw new Error('Cannot annotate "' + fn + '". Expected a function!');
        }
        var match = fn.toString().match(isClass(fn) ? CONSTRUCTOR_ARGS : FN_ARGS);
        if (!match) {
            return [];
        }
        return match[1] && match[1].split(',').map(function (arg) {
            match = arg.match(FN_ARG);
            return match ? match[1].trim() : arg.trim();
        }) || [];
    }

    function Module() {
        var providers = [];
        this.factory = function (name, factory) {
            providers.push([name, 'factory', factory]);
            return this;
        };
        this.value = function (name, value) {
            providers.push([name, 'value', value]);
            return this;
        };
        this.type = function (name, type) {
            providers.push([name, 'type', type]);
            return this;
        };
        this.forEach = function (iterator) {
            providers.forEach(iterator);
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }
            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    function Injector(modules, parent) {
        parent = parent || {
            get: function get(name, strict) {
                currentlyResolving.push(name);
                if (strict === false) {
                    return null;
                } else {
                    throw error('No provider for "' + name + '"!');
                }
            }
        };
        var currentlyResolving = [];
        var providers = this._providers = Object.create(parent._providers || null);
        var instances = this._instances = Object.create(null);
        var self = instances.injector = this;
        var error = function error(msg) {
            var stack = currentlyResolving.join(' -> ');
            currentlyResolving.length = 0;
            return new Error(stack ? msg + ' (Resolving: ' + stack + ')' : msg);
        };
        var get = function get(name, strict) {
            if (!providers[name] && name.indexOf('.') !== -1) {
                var parts = name.split('.');
                var pivot = get(parts.shift());
                while (parts.length) {
                    pivot = pivot[parts.shift()];
                }
                return pivot;
            }
            if (hasProp(instances, name)) {
                return instances[name];
            }
            if (hasProp(providers, name)) {
                if (currentlyResolving.indexOf(name) !== -1) {
                    currentlyResolving.push(name);
                    throw error('Cannot resolve circular dependency!');
                }
                currentlyResolving.push(name);
                instances[name] = providers[name][0](providers[name][1]);
                currentlyResolving.pop();
                return instances[name];
            }
            return parent.get(name, strict);
        };
        var fnDef = function fnDef(fn) {
            var locals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (typeof fn !== 'function') {
                if (isArray$1(fn)) {
                    fn = annotate(fn.slice());
                } else {
                    throw new Error('Cannot invoke "' + fn + '". Expected a function!');
                }
            }
            var inject = fn.$inject || parse$2(fn);
            var dependencies = inject.map(function (dep) {
                if (hasProp(locals, dep)) {
                    return locals[dep];
                } else {
                    return get(dep);
                }
            });
            return {fn: fn, dependencies: dependencies};
        };
        var instantiate = function instantiate(Type) {
            var _fnDef = fnDef(Type), dependencies = _fnDef.dependencies, fn = _fnDef.fn;
            return new (Function.prototype.bind.apply(fn, [null].concat(_toConsumableArray(dependencies))))();
        };
        var invoke = function invoke(func, context, locals) {
            var _fnDef2 = fnDef(func, locals), dependencies = _fnDef2.dependencies, fn = _fnDef2.fn;
            return fn.call.apply(fn, [context].concat(_toConsumableArray(dependencies)));
        };
        var createPrivateInjectorFactory = function createPrivateInjectorFactory(privateChildInjector) {
            return annotate(function (key) {
                return privateChildInjector.get(key);
            });
        };
        var createChild = function createChild(modules, forceNewInstances) {
            if (forceNewInstances && forceNewInstances.length) {
                var fromParentModule = Object.create(null);
                var matchedScopes = Object.create(null);
                var privateInjectorsCache = [];
                var privateChildInjectors = [];
                var privateChildFactories = [];
                var provider;
                var cacheIdx;
                var privateChildInjector;
                var privateChildInjectorFactory;
                for (var name in providers) {
                    provider = providers[name];
                    if (forceNewInstances.indexOf(name) !== -1) {
                        if (provider[2] === 'private') {
                            cacheIdx = privateInjectorsCache.indexOf(provider[3]);
                            if (cacheIdx === -1) {
                                privateChildInjector = provider[3].createChild([], forceNewInstances);
                                privateChildInjectorFactory = createPrivateInjectorFactory(privateChildInjector);
                                privateInjectorsCache.push(provider[3]);
                                privateChildInjectors.push(privateChildInjector);
                                privateChildFactories.push(privateChildInjectorFactory);
                                fromParentModule[name] = [privateChildInjectorFactory, name, 'private', privateChildInjector];
                            } else {
                                fromParentModule[name] = [privateChildFactories[cacheIdx], name, 'private', privateChildInjectors[cacheIdx]];
                            }
                        } else {
                            fromParentModule[name] = [provider[2], provider[1]];
                        }
                        matchedScopes[name] = true;
                    }
                    if ((provider[2] === 'factory' || provider[2] === 'type') && provider[1].$scope) {
                        forceNewInstances.forEach(function (scope) {
                            if (provider[1].$scope.indexOf(scope) !== -1) {
                                fromParentModule[name] = [provider[2], provider[1]];
                                matchedScopes[scope] = true;
                            }
                        });
                    }
                }
                forceNewInstances.forEach(function (scope) {
                    if (!matchedScopes[scope]) {
                        throw new Error('No provider for "' + scope + '". Cannot use provider from the parent!');
                    }
                });
                modules.unshift(fromParentModule);
            }
            return new Injector(modules, self);
        };
        var factoryMap = {
            factory: invoke, type: instantiate, value: function value(_value) {
                return _value;
            }
        };
        modules.forEach(function (module) {
            function arrayUnwrap(type, value) {
                if (type !== 'value' && isArray$1(value)) {
                    value = annotate(value.slice());
                }
                return value;
            }

            if (module instanceof Module) {
                module.forEach(function (provider) {
                    var name = provider[0];
                    var type = provider[1];
                    var value = provider[2];
                    providers[name] = [factoryMap[type], arrayUnwrap(type, value), type];
                });
            } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object') {
                if (module.__exports__) {
                    var clonedModule = Object.keys(module).reduce(function (m, key) {
                        if (key.substring(0, 2) !== '__') {
                            m[key] = module[key];
                        }
                        return m;
                    }, Object.create(null));
                    var privateInjector = new Injector((module.__modules__ || []).concat([clonedModule]), self);
                    var getFromPrivateInjector = annotate(function (key) {
                        return privateInjector.get(key);
                    });
                    module.__exports__.forEach(function (key) {
                        providers[key] = [getFromPrivateInjector, key, 'private', privateInjector];
                    });
                } else {
                    Object.keys(module).forEach(function (name) {
                        if (module[name][2] === 'private') {
                            providers[name] = module[name];
                            return;
                        }
                        var type = module[name][0];
                        var value = module[name][1];
                        providers[name] = [factoryMap[type], arrayUnwrap(type, value), type];
                    });
                }
            }
        });
        this.get = get;
        this.invoke = invoke;
        this.instantiate = instantiate;
        this.createChild = createChild;
    }

    function hasProp(obj, prop) {
        return Object.hasOwnProperty.call(obj, prop);
    }

    var DEFAULT_RENDER_PRIORITY = 1000;

    function BaseRenderer(eventBus, renderPriority) {
        var self = this;
        renderPriority = renderPriority || DEFAULT_RENDER_PRIORITY;
        eventBus.on(['render.shape', 'render.connection'], renderPriority, function (evt, context) {
            var type = evt.type, element = context.element, visuals = context.gfx;
            if (self.canRender(element)) {
                if (type === 'render.shape') {
                    return self.drawShape(visuals, element);
                } else {
                    return self.drawConnection(visuals, element);
                }
            }
        });
        eventBus.on(['render.getShapePath', 'render.getConnectionPath'], renderPriority, function (evt, element) {
            if (self.canRender(element)) {
                if (evt.type === 'render.getShapePath') {
                    return self.getShapePath(element);
                } else {
                    return self.getConnectionPath(element);
                }
            }
        });
    }

    BaseRenderer.prototype.canRender = function () {
    };
    BaseRenderer.prototype.drawShape = function () {
    };
    BaseRenderer.prototype.drawConnection = function () {
    };
    BaseRenderer.prototype.getShapePath = function () {
    };
    BaseRenderer.prototype.getConnectionPath = function () {
    };

    function componentsToPath(elements) {
        return elements.join(',').replace(/,?([A-z]),?/g, '$1');
    }

    function toSVGPoints(points) {
        var result = '';
        for (var i = 0, p; (p = points[i]); i++) {
            result += p.x + ',' + p.y + ' ';
        }
        return result;
    }

    function createLine(points, attrs) {
        var line = create('polyline');
        attr$1(line, {points: toSVGPoints(points)});
        if (attrs) {
            attr$1(line, attrs);
        }
        return line;
    }

    function updateLine(gfx, points) {
        attr$1(gfx, {points: toSVGPoints(points)});
        return gfx;
    }

    var DEFAULT_RENDER_PRIORITY$1 = 1;

    function DefaultRenderer(eventBus, styles) {
        BaseRenderer.call(this, eventBus, DEFAULT_RENDER_PRIORITY$1);
        this.CONNECTION_STYLE = styles.style(['no-fill'], {strokeWidth: 5, stroke: 'fuchsia'});
        this.SHAPE_STYLE = styles.style({fill: 'white', stroke: 'fuchsia', strokeWidth: 2});
    }

    inherits_browser(DefaultRenderer, BaseRenderer);
    DefaultRenderer.prototype.canRender = function () {
        return true;
    };
    DefaultRenderer.prototype.drawShape = function drawShape(visuals, element) {
        var rect = create('rect');
        attr$1(rect, {x: 0, y: 0, width: element.width || 0, height: element.height || 0});
        attr$1(rect, this.SHAPE_STYLE);
        append(visuals, rect);
        return rect;
    };
    DefaultRenderer.prototype.drawConnection = function drawConnection(visuals, connection) {
        var line = createLine(connection.waypoints, this.CONNECTION_STYLE);
        append(visuals, line);
        return line;
    };
    DefaultRenderer.prototype.getShapePath = function getShapePath(shape) {
        var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
        var shapePath = [['M', x, y], ['l', width, 0], ['l', 0, height], ['l', -width, 0], ['z']];
        return componentsToPath(shapePath);
    };
    DefaultRenderer.prototype.getConnectionPath = function getConnectionPath(connection) {
        var waypoints = connection.waypoints;
        var idx, point, connectionPath = [];
        for (idx = 0; (point = waypoints[idx]); idx++) {
            point = point.original || point;
            connectionPath.push([idx === 0 ? 'M' : 'L', point.x, point.y]);
        }
        return componentsToPath(connectionPath);
    };
    DefaultRenderer.$inject = ['eventBus', 'styles'];

    function Styles() {
        var defaultTraits = {
            'no-fill': {fill: 'none'},
            'no-border': {strokeOpacity: 0.0},
            'no-events': {pointerEvents: 'none'}
        };
        var self = this;
        this.cls = function (className, traits, additionalAttrs) {
            var attrs = this.style(traits, additionalAttrs);
            return assign(attrs, {'class': className});
        };
        this.style = function (traits, additionalAttrs) {
            if (!isArray(traits) && !additionalAttrs) {
                additionalAttrs = traits;
                traits = [];
            }
            var attrs = reduce(traits, function (attrs, t) {
                return assign(attrs, defaultTraits[t] || {});
            }, {});
            return additionalAttrs ? assign(attrs, additionalAttrs) : attrs;
        };
        this.computeStyle = function (custom, traits, defaultStyles) {
            if (!isArray(traits)) {
                defaultStyles = traits;
                traits = [];
            }
            return self.style(traits || [], assign({}, defaultStyles, custom || {}));
        };
    }

    var DrawModule = {
        __init__: ['defaultRenderer'],
        defaultRenderer: ['type', DefaultRenderer],
        styles: ['type', Styles]
    };

    function remove$2(collection, element) {
        if (!collection || !element) {
            return -1;
        }
        var idx = collection.indexOf(element);
        if (idx !== -1) {
            collection.splice(idx, 1);
        }
        return idx;
    }

    function add(collection, element, idx) {
        if (!collection || !element) {
            return;
        }
        if (typeof idx !== 'number') {
            idx = -1;
        }
        var currentIdx = collection.indexOf(element);
        if (currentIdx !== -1) {
            if (currentIdx === idx) {
                return;
            } else {
                if (idx !== -1) {
                    collection.splice(currentIdx, 1);
                } else {
                    return;
                }
            }
        }
        if (idx !== -1) {
            collection.splice(idx, 0, element);
        } else {
            collection.push(element);
        }
    }

    function indexOf$1(collection, element) {
        if (!collection || !element) {
            return -1;
        }
        return collection.indexOf(element);
    }

    function add$1(elements, e, unique) {
        var canAdd = !unique || elements.indexOf(e) === -1;
        if (canAdd) {
            elements.push(e);
        }
        return canAdd;
    }

    function eachElement(elements, fn, depth) {
        depth = depth || 0;
        if (!isArray(elements)) {
            elements = [elements];
        }
        forEach(elements, function (s, i) {
            var filter$$1 = fn(s, i, depth);
            if (isArray(filter$$1) && filter$$1.length) {
                eachElement(filter$$1, fn, depth + 1);
            }
        });
    }

    function selfAndChildren(elements, unique, maxDepth) {
        var result = [], processedChildren = [];
        eachElement(elements, function (element, i, depth) {
            add$1(result, element, unique);
            var children = element.children;
            if (maxDepth === -1 || depth < maxDepth) {
                if (children && add$1(processedChildren, children, unique)) {
                    return children;
                }
            }
        });
        return result;
    }

    function selfAndAllChildren(elements, allowDuplicates) {
        return selfAndChildren(elements, !allowDuplicates, -1);
    }

    function getClosure(elements, isTopLevel, closure) {
        if (isUndefined(isTopLevel)) {
            isTopLevel = true;
        }
        if (isObject(isTopLevel)) {
            closure = isTopLevel;
            isTopLevel = true;
        }
        closure = closure || {};
        var allShapes = copyObject(closure.allShapes), allConnections = copyObject(closure.allConnections),
            enclosedElements = copyObject(closure.enclosedElements),
            enclosedConnections = copyObject(closure.enclosedConnections);
        var topLevel = copyObject(closure.topLevel, isTopLevel && groupBy(elements, function (e) {
            return e.id;
        }));

        function handleConnection(c) {
            if (topLevel[c.source.id] && topLevel[c.target.id]) {
                topLevel[c.id] = [c];
            }
            if (allShapes[c.source.id] && allShapes[c.target.id]) {
                enclosedConnections[c.id] = enclosedElements[c.id] = c;
            }
            allConnections[c.id] = c;
        }

        function handleElement(element) {
            enclosedElements[element.id] = element;
            if (element.waypoints) {
                enclosedConnections[element.id] = allConnections[element.id] = element;
            } else {
                allShapes[element.id] = element;
                forEach(element.incoming, handleConnection);
                forEach(element.outgoing, handleConnection);
                return element.children;
            }
        }

        eachElement(elements, handleElement);
        return {
            allShapes: allShapes,
            allConnections: allConnections,
            topLevel: topLevel,
            enclosedConnections: enclosedConnections,
            enclosedElements: enclosedElements
        };
    }

    function getBBox(elements, stopRecursion) {
        stopRecursion = !!stopRecursion;
        if (!isArray(elements)) {
            elements = [elements];
        }
        var minX, minY, maxX, maxY;
        forEach(elements, function (element) {
            var bbox = element;
            if (element.waypoints && !stopRecursion) {
                bbox = getBBox(element.waypoints, true);
            }
            var x = bbox.x, y = bbox.y, height = bbox.height || 0, width = bbox.width || 0;
            if (x < minX || minX === undefined) {
                minX = x;
            }
            if (y < minY || minY === undefined) {
                minY = y;
            }
            if ((x + width) > maxX || maxX === undefined) {
                maxX = x + width;
            }
            if ((y + height) > maxY || maxY === undefined) {
                maxY = y + height;
            }
        });
        return {x: minX, y: minY, height: maxY - minY, width: maxX - minX};
    }

    function getEnclosedElements(elements, bbox) {
        var filteredElements = {};
        forEach(elements, function (element) {
            var e = element;
            if (e.waypoints) {
                e = getBBox(e);
            }
            if (!isNumber(bbox.y) && (e.x > bbox.x)) {
                filteredElements[element.id] = element;
            }
            if (!isNumber(bbox.x) && (e.y > bbox.y)) {
                filteredElements[element.id] = element;
            }
            if (e.x > bbox.x && e.y > bbox.y) {
                if (isNumber(bbox.width) && isNumber(bbox.height) && e.width + e.x < bbox.width + bbox.x && e.height + e.y < bbox.height + bbox.y) {
                    filteredElements[element.id] = element;
                } else if (!isNumber(bbox.width) || !isNumber(bbox.height)) {
                    filteredElements[element.id] = element;
                }
            }
        });
        return filteredElements;
    }

    function getType(element) {
        if ('waypoints' in element) {
            return 'connection';
        }
        if ('x' in element) {
            return 'shape';
        }
        return 'root';
    }

    function copyObject(src1, src2) {
        return assign({}, src1 || {}, src2 || {});
    }

    function round(number, resolution) {
        return Math.round(number * resolution) / resolution;
    }

    function ensurePx(number) {
        return isNumber(number) ? number + 'px' : number;
    }

    function createContainer(options) {
        options = assign({}, {width: '100%', height: '100%'}, options);
        var container = options.container || document.body;
        var parent = document.createElement('div');
        parent.setAttribute('class', 'djs-container');
        assign(parent.style, {
            position: 'relative',
            overflow: 'hidden',
            width: ensurePx(options.width),
            height: ensurePx(options.height)
        });
        container.appendChild(parent);
        return parent;
    }

    function createGroup(parent, cls, childIndex) {
        var group = create('g');
        classes$1(group).add(cls);
        var index = childIndex !== undefined ? childIndex : parent.childNodes.length - 1;
        parent.insertBefore(group, parent.childNodes[index] || null);
        return group;
    }

    var BASE_LAYER = 'base';
    var REQUIRED_MODEL_ATTRS = {shape: ['x', 'y', 'width', 'height'], connection: ['waypoints']};

    function Canvas(config, eventBus, graphicsFactory, elementRegistry) {
        this._eventBus = eventBus;
        this._elementRegistry = elementRegistry;
        this._graphicsFactory = graphicsFactory;
        this._init(config || {});
    }

    Canvas.$inject = ['config.canvas', 'eventBus', 'graphicsFactory', 'elementRegistry'];
    Canvas.prototype._init = function (config) {
        var eventBus = this._eventBus;
        var container = this._container = createContainer(config);
        var svg = this._svg = create('svg');
        attr$1(svg, {width: '100%', height: '100%'});
        append(container, svg);
        var viewport = this._viewport = createGroup(svg, 'viewport');
        this._layers = {};
        if (config.deferUpdate !== false) {
            this._viewboxChanged = debounce(bind(this._viewboxChanged, this), 300);
        }
        eventBus.on('diagram.init', function () {
            eventBus.fire('canvas.init', {svg: svg, viewport: viewport});
        }, this);
        eventBus.on(['shape.added', 'connection.added', 'shape.removed', 'connection.removed', 'elements.changed'], function () {
            delete this._cachedViewbox;
        }, this);
        eventBus.on('diagram.destroy', 500, this._destroy, this);
        eventBus.on('diagram.clear', 500, this._clear, this);
    };
    Canvas.prototype._destroy = function (emit) {
        this._eventBus.fire('canvas.destroy', {svg: this._svg, viewport: this._viewport});
        var parent = this._container.parentNode;
        if (parent) {
            parent.removeChild(this._container);
        }
        delete this._svg;
        delete this._container;
        delete this._layers;
        delete this._rootElement;
        delete this._viewport;
    };
    Canvas.prototype._clear = function () {
        var self = this;
        var allElements = this._elementRegistry.getAll();
        allElements.forEach(function (element) {
            var type = getType(element);
            if (type === 'root') {
                self.setRootElement(null, true);
            } else {
                self._removeElement(element, type);
            }
        });
        delete this._cachedViewbox;
    };
    Canvas.prototype.getDefaultLayer = function () {
        return this.getLayer(BASE_LAYER, 0);
    };
    Canvas.prototype.getLayer = function (name, index) {
        if (!name) {
            throw new Error('must specify a name');
        }
        var layer = this._layers[name];
        if (!layer) {
            layer = this._layers[name] = this._createLayer(name, index);
        }
        if (typeof index !== 'undefined' && layer.index !== index) {
            throw new Error('layer <' + name + '> already created at index <' + index + '>');
        }
        return layer.group;
    };
    Canvas.prototype._createLayer = function (name, index) {
        if (!index) {
            index = 0;
        }
        var childIndex = reduce(this._layers, function (childIndex, layer) {
            if (index >= layer.index) {
                childIndex++;
            }
            return childIndex;
        }, 0);
        return {group: createGroup(this._viewport, 'layer-' + name, childIndex), index: index};
    };
    Canvas.prototype.getContainer = function () {
        return this._container;
    };
    Canvas.prototype._updateMarker = function (element, marker, add$$1) {
        var container;
        if (!element.id) {
            element = this._elementRegistry.get(element);
        }
        container = this._elementRegistry._elements[element.id];
        if (!container) {
            return;
        }
        forEach([container.gfx, container.secondaryGfx], function (gfx) {
            if (gfx) {
                if (add$$1) {
                    classes$1(gfx).add(marker);
                } else {
                    classes$1(gfx).remove(marker);
                }
            }
        });
        this._eventBus.fire('element.marker.update', {
            element: element,
            gfx: container.gfx,
            marker: marker,
            add: !!add$$1
        });
    };
    Canvas.prototype.addMarker = function (element, marker) {
        this._updateMarker(element, marker, true);
    };
    Canvas.prototype.removeMarker = function (element, marker) {
        this._updateMarker(element, marker, false);
    };
    Canvas.prototype.hasMarker = function (element, marker) {
        if (!element.id) {
            element = this._elementRegistry.get(element);
        }
        var gfx = this.getGraphics(element);
        return classes$1(gfx).has(marker);
    };
    Canvas.prototype.toggleMarker = function (element, marker) {
        if (this.hasMarker(element, marker)) {
            this.removeMarker(element, marker);
        } else {
            this.addMarker(element, marker);
        }
    };
    Canvas.prototype.getRootElement = function () {
        if (!this._rootElement) {
            this.setRootElement({id: '__implicitroot', children: []});
        }
        return this._rootElement;
    };
    Canvas.prototype.setRootElement = function (element, override) {
        if (element) {
            this._ensureValid('root', element);
        }
        var currentRoot = this._rootElement, elementRegistry = this._elementRegistry, eventBus = this._eventBus;
        if (currentRoot) {
            if (!override) {
                throw new Error('rootElement already set, need to specify override');
            }
            eventBus.fire('root.remove', {element: currentRoot});
            eventBus.fire('root.removed', {element: currentRoot});
            elementRegistry.remove(currentRoot);
        }
        if (element) {
            var gfx = this.getDefaultLayer();
            eventBus.fire('root.add', {element: element});
            elementRegistry.add(element, gfx, this._svg);
            eventBus.fire('root.added', {element: element, gfx: gfx});
        }
        this._rootElement = element;
        return element;
    };
    Canvas.prototype._ensureValid = function (type, element) {
        if (!element.id) {
            throw new Error('element must have an id');
        }
        if (this._elementRegistry.get(element.id)) {
            throw new Error('element with id ' + element.id + ' already exists');
        }
        var requiredAttrs = REQUIRED_MODEL_ATTRS[type];
        var valid = every(requiredAttrs, function (attr$$1) {
            return typeof element[attr$$1] !== 'undefined';
        });
        if (!valid) {
            throw new Error('must supply { ' + requiredAttrs.join(', ') + ' } with ' + type);
        }
    };
    Canvas.prototype._setParent = function (element, parent, parentIndex) {
        add(parent.children, element, parentIndex);
        element.parent = parent;
    };
    Canvas.prototype._addElement = function (type, element, parent, parentIndex) {
        parent = parent || this.getRootElement();
        var eventBus = this._eventBus, graphicsFactory = this._graphicsFactory;
        this._ensureValid(type, element);
        eventBus.fire(type + '.add', {element: element, parent: parent});
        this._setParent(element, parent, parentIndex);
        var gfx = graphicsFactory.create(type, element, parentIndex);
        this._elementRegistry.add(element, gfx);
        graphicsFactory.update(type, element, gfx);
        eventBus.fire(type + '.added', {element: element, gfx: gfx});
        return element;
    };
    Canvas.prototype.addShape = function (shape, parent, parentIndex) {
        return this._addElement('shape', shape, parent, parentIndex);
    };
    Canvas.prototype.addConnection = function (connection, parent, parentIndex) {
        return this._addElement('connection', connection, parent, parentIndex);
    };
    Canvas.prototype._removeElement = function (element, type) {
        var elementRegistry = this._elementRegistry, graphicsFactory = this._graphicsFactory, eventBus = this._eventBus;
        element = elementRegistry.get(element.id || element);
        if (!element) {
            return;
        }
        eventBus.fire(type + '.remove', {element: element});
        graphicsFactory.remove(element);
        remove$2(element.parent && element.parent.children, element);
        element.parent = null;
        eventBus.fire(type + '.removed', {element: element});
        elementRegistry.remove(element);
        return element;
    };
    Canvas.prototype.removeShape = function (shape) {
        return this._removeElement(shape, 'shape');
    };
    Canvas.prototype.removeConnection = function (connection) {
        return this._removeElement(connection, 'connection');
    };
    Canvas.prototype.getGraphics = function (element, secondary) {
        return this._elementRegistry.getGraphics(element, secondary);
    };
    Canvas.prototype._changeViewbox = function (changeFn) {
        this._eventBus.fire('canvas.viewbox.changing');
        changeFn.apply(this);
        this._cachedViewbox = null;
        this._viewboxChanged();
    };
    Canvas.prototype._viewboxChanged = function () {
        this._eventBus.fire('canvas.viewbox.changed', {viewbox: this.viewbox()});
    };
    Canvas.prototype.viewbox = function (box) {
        if (box === undefined && this._cachedViewbox) {
            return this._cachedViewbox;
        }
        var viewport = this._viewport, innerBox, outerBox = this.getSize(), matrix, transform$$1, scale, x, y;
        if (!box) {
            innerBox = this.getDefaultLayer().getBBox();
            transform$$1 = transform(viewport);
            matrix = transform$$1 ? transform$$1.matrix : createMatrix();
            scale = round(matrix.a, 1000);
            x = round(-matrix.e || 0, 1000);
            y = round(-matrix.f || 0, 1000);
            box = this._cachedViewbox = {
                x: x ? x / scale : 0,
                y: y ? y / scale : 0,
                width: outerBox.width / scale,
                height: outerBox.height / scale,
                scale: scale,
                inner: {width: innerBox.width, height: innerBox.height, x: innerBox.x, y: innerBox.y},
                outer: outerBox
            };
            return box;
        } else {
            this._changeViewbox(function () {
                scale = Math.min(outerBox.width / box.width, outerBox.height / box.height);
                var matrix = this._svg.createSVGMatrix().scale(scale).translate(-box.x, -box.y);
                transform(viewport, matrix);
            });
        }
        return box;
    };
    Canvas.prototype.scroll = function (delta) {
        var node = this._viewport;
        var matrix = node.getCTM();
        if (delta) {
            this._changeViewbox(function () {
                delta = assign({dx: 0, dy: 0}, delta || {});
                matrix = this._svg.createSVGMatrix().translate(delta.dx, delta.dy).multiply(matrix);
                setCTM(node, matrix);
            });
        }
        return {x: matrix.e, y: matrix.f};
    };
    Canvas.prototype.zoom = function (newScale, center) {
        if (!newScale) {
            return this.viewbox(newScale).scale;
        }
        if (newScale === 'fit-viewport') {
            return this._fitViewport(center);
        }
        var outer, matrix;
        this._changeViewbox(function () {
            if (typeof center !== 'object') {
                outer = this.viewbox().outer;
                center = {x: outer.width / 2, y: outer.height / 2};
            }
            matrix = this._setZoom(newScale, center);
        });
        return round(matrix.a, 1000);
    };

    function setCTM(node, m) {
        var mstr = 'matrix(' + m.a + ',' + m.b + ',' + m.c + ',' + m.d + ',' + m.e + ',' + m.f + ')';
        node.setAttribute('transform', mstr);
    }

    Canvas.prototype._fitViewport = function (center) {
        var vbox = this.viewbox(), outer = vbox.outer, inner = vbox.inner, newScale, newViewbox;
        if (inner.x >= 0 && inner.y >= 0 && inner.x + inner.width <= outer.width && inner.y + inner.height <= outer.height && !center) {
            newViewbox = {
                x: 0,
                y: 0,
                width: Math.max(inner.width + inner.x, outer.width),
                height: Math.max(inner.height + inner.y, outer.height)
            };
        } else {
            newScale = Math.min(1, outer.width / inner.width, outer.height / inner.height);
            newViewbox = {
                x: inner.x + (center ? inner.width / 2 - outer.width / newScale / 2 : 0),
                y: inner.y + (center ? inner.height / 2 - outer.height / newScale / 2 : 0),
                width: outer.width / newScale,
                height: outer.height / newScale
            };
        }
        this.viewbox(newViewbox);
        return this.viewbox(false).scale;
    };
    Canvas.prototype._setZoom = function (scale, center) {
        var svg = this._svg, viewport = this._viewport;
        var matrix = svg.createSVGMatrix();
        var point = svg.createSVGPoint();
        var centerPoint, originalPoint, currentMatrix, scaleMatrix, newMatrix;
        currentMatrix = viewport.getCTM();
        var currentScale = currentMatrix.a;
        if (center) {
            centerPoint = assign(point, center);
            originalPoint = centerPoint.matrixTransform(currentMatrix.inverse());
            scaleMatrix = matrix.translate(originalPoint.x, originalPoint.y).scale(1 / currentScale * scale).translate(-originalPoint.x, -originalPoint.y);
            newMatrix = currentMatrix.multiply(scaleMatrix);
        } else {
            newMatrix = matrix.scale(scale);
        }
        setCTM(this._viewport, newMatrix);
        return newMatrix;
    };
    Canvas.prototype.getSize = function () {
        return {width: this._container.clientWidth, height: this._container.clientHeight};
    };
    Canvas.prototype.getAbsoluteBBox = function (element) {
        var vbox = this.viewbox();
        var bbox;
        if (element.waypoints) {
            var gfx = this.getGraphics(element);
            bbox = gfx.getBBox();
        } else {
            bbox = element;
        }
        var x = bbox.x * vbox.scale - vbox.x * vbox.scale;
        var y = bbox.y * vbox.scale - vbox.y * vbox.scale;
        var width = bbox.width * vbox.scale;
        var height = bbox.height * vbox.scale;
        return {x: x, y: y, width: width, height: height};
    };
    Canvas.prototype.resized = function () {
        delete this._cachedViewbox;
        this._eventBus.fire('canvas.resized');
    };
    var ELEMENT_ID = 'data-element-id';

    function ElementRegistry(eventBus) {
        this._elements = {};
        this._eventBus = eventBus;
    }

    ElementRegistry.$inject = ['eventBus'];
    ElementRegistry.prototype.add = function (element, gfx, secondaryGfx) {
        var id = element.id;
        this._validateId(id);
        attr$1(gfx, ELEMENT_ID, id);
        if (secondaryGfx) {
            attr$1(secondaryGfx, ELEMENT_ID, id);
        }
        this._elements[id] = {element: element, gfx: gfx, secondaryGfx: secondaryGfx};
    };
    ElementRegistry.prototype.remove = function (element) {
        var elements = this._elements, id = element.id || element, container = id && elements[id];
        if (container) {
            attr$1(container.gfx, ELEMENT_ID, '');
            if (container.secondaryGfx) {
                attr$1(container.secondaryGfx, ELEMENT_ID, '');
            }
            delete elements[id];
        }
    };
    ElementRegistry.prototype.updateId = function (element, newId) {
        this._validateId(newId);
        if (typeof element === 'string') {
            element = this.get(element);
        }
        this._eventBus.fire('element.updateId', {element: element, newId: newId});
        var gfx = this.getGraphics(element), secondaryGfx = this.getGraphics(element, true);
        this.remove(element);
        element.id = newId;
        this.add(element, gfx, secondaryGfx);
    };
    ElementRegistry.prototype.get = function (filter) {
        var id;
        if (typeof filter === 'string') {
            id = filter;
        } else {
            id = filter && attr$1(filter, ELEMENT_ID);
        }
        var container = this._elements[id];
        return container && container.element;
    };
    ElementRegistry.prototype.filter = function (fn) {
        var filtered = [];
        this.forEach(function (element, gfx) {
            if (fn(element, gfx)) {
                filtered.push(element);
            }
        });
        return filtered;
    };
    ElementRegistry.prototype.getAll = function () {
        return this.filter(function (e) {
            return e;
        });
    };
    ElementRegistry.prototype.forEach = function (fn) {
        var map = this._elements;
        Object.keys(map).forEach(function (id) {
            var container = map[id], element = container.element, gfx = container.gfx;
            return fn(element, gfx);
        });
    };
    ElementRegistry.prototype.getGraphics = function (filter, secondary) {
        var id = filter.id || filter;
        var container = this._elements[id];
        return container && (secondary ? container.secondaryGfx : container.gfx);
    };
    ElementRegistry.prototype._validateId = function (id) {
        if (!id) {
            throw new Error('element must have an id');
        }
        if (this._elements[id]) {
            throw new Error('element with id ' + id + ' already added');
        }
    };

    function extend$1(collection, refs, property, target) {
        var inverseProperty = property.inverse;
        Object.defineProperty(collection, 'remove', {
            value: function (element) {
                var idx = this.indexOf(element);
                if (idx !== -1) {
                    this.splice(idx, 1);
                    refs.unset(element, inverseProperty, target);
                }
                return element;
            }
        });
        Object.defineProperty(collection, 'contains', {
            value: function (element) {
                return this.indexOf(element) !== -1;
            }
        });
        Object.defineProperty(collection, 'add', {
            value: function (element, idx) {
                var currentIdx = this.indexOf(element);
                if (typeof idx === 'undefined') {
                    if (currentIdx !== -1) {
                        return;
                    }
                    idx = this.length;
                }
                if (currentIdx !== -1) {
                    this.splice(currentIdx, 1);
                }
                this.splice(idx, 0, element);
                if (currentIdx === -1) {
                    refs.set(element, inverseProperty, target);
                }
            }
        });
        Object.defineProperty(collection, '__refs_collection', {value: true});
        return collection;
    }

    function isExtended(collection) {
        return collection.__refs_collection === true;
    }

    var extend_1 = extend$1;
    var isExtended_1 = isExtended;
    var collection = {extend: extend_1, isExtended: isExtended_1};

    function hasOwnProperty(e, property) {
        return Object.prototype.hasOwnProperty.call(e, property.name || property);
    }

    function defineCollectionProperty(ref, property, target) {
        var collection$$1 = collection.extend(target[property.name] || [], ref, property, target);
        Object.defineProperty(target, property.name, {enumerable: property.enumerable, value: collection$$1});
        if (collection$$1.length) {
            collection$$1.forEach(function (o) {
                ref.set(o, property.inverse, target);
            });
        }
    }

    function defineProperty(ref, property, target) {
        var inverseProperty = property.inverse;
        var _value = target[property.name];
        Object.defineProperty(target, property.name, {
            configurable: property.configurable,
            enumerable: property.enumerable,
            get: function () {
                return _value;
            },
            set: function (value) {
                if (value === _value) {
                    return;
                }
                var old = _value;
                _value = null;
                if (old) {
                    ref.unset(old, inverseProperty, target);
                }
                _value = value;
                ref.set(_value, inverseProperty, target);
            }
        });
    }

    function Refs(a, b) {
        if (!(this instanceof Refs)) {
            return new Refs(a, b);
        }
        a.inverse = b;
        b.inverse = a;
        this.props = {};
        this.props[a.name] = a;
        this.props[b.name] = b;
    }

    Refs.prototype.bind = function (target, property) {
        if (typeof property === 'string') {
            if (!this.props[property]) {
                throw new Error('no property <' + property + '> in ref');
            }
            property = this.props[property];
        }
        if (property.collection) {
            defineCollectionProperty(this, property, target);
        } else {
            defineProperty(this, property, target);
        }
    };
    Refs.prototype.ensureRefsCollection = function (target, property) {
        var collection$$1 = target[property.name];
        if (!collection.isExtended(collection$$1)) {
            defineCollectionProperty(this, property, target);
        }
        return collection$$1;
    };
    Refs.prototype.ensureBound = function (target, property) {
        if (!hasOwnProperty(target, property)) {
            this.bind(target, property);
        }
    };
    Refs.prototype.unset = function (target, property, value) {
        if (target) {
            this.ensureBound(target, property);
            if (property.collection) {
                this.ensureRefsCollection(target, property).remove(value);
            } else {
                target[property.name] = undefined;
            }
        }
    };
    Refs.prototype.set = function (target, property, value) {
        if (target) {
            this.ensureBound(target, property);
            if (property.collection) {
                this.ensureRefsCollection(target, property).add(value);
            } else {
                target[property.name] = value;
            }
        }
    };
    var refs = Refs;
    var objectRefs = refs;
    var Collection = collection;
    objectRefs.Collection = Collection;
    var parentRefs = new objectRefs({name: 'children', enumerable: true, collection: true}, {name: 'parent'}),
        labelRefs = new objectRefs({name: 'labels', enumerable: true, collection: true}, {name: 'labelTarget'}),
        attacherRefs = new objectRefs({name: 'attachers', collection: true}, {name: 'host'}),
        outgoingRefs = new objectRefs({name: 'outgoing', collection: true}, {name: 'source'}),
        incomingRefs = new objectRefs({name: 'incoming', collection: true}, {name: 'target'});

    function Base() {
        Object.defineProperty(this, 'businessObject', {writable: true});
        Object.defineProperty(this, 'label', {
            get: function () {
                return this.labels[0];
            }, set: function (newLabel) {
                var label = this.label, labels = this.labels;
                if (!newLabel && label) {
                    labels.remove(label);
                } else {
                    labels.add(newLabel, 0);
                }
            }
        });
        parentRefs.bind(this, 'parent');
        labelRefs.bind(this, 'labels');
        outgoingRefs.bind(this, 'outgoing');
        incomingRefs.bind(this, 'incoming');
    }

    function Shape() {
        Base.call(this);
        parentRefs.bind(this, 'children');
        attacherRefs.bind(this, 'host');
        attacherRefs.bind(this, 'attachers');
    }

    inherits_browser(Shape, Base);

    function Root() {
        Shape.call(this);
    }

    inherits_browser(Root, Shape);

    function Label() {
        Shape.call(this);
        labelRefs.bind(this, 'labelTarget');
    }

    inherits_browser(Label, Shape);

    function Connection() {
        Base.call(this);
        outgoingRefs.bind(this, 'source');
        incomingRefs.bind(this, 'target');
    }

    inherits_browser(Connection, Base);
    var types = {connection: Connection, shape: Shape, label: Label, root: Root};

    function create$1(type, attrs) {
        var Type = types[type];
        if (!Type) {
            throw new Error('unknown type: <' + type + '>');
        }
        return assign(new Type(), attrs);
    }

    function ElementFactory() {
        this._uid = 12;
    }

    ElementFactory.prototype.createRoot = function (attrs) {
        return this.create('root', attrs);
    };
    ElementFactory.prototype.createLabel = function (attrs) {
        return this.create('label', attrs);
    };
    ElementFactory.prototype.createShape = function (attrs) {
        return this.create('shape', attrs);
    };
    ElementFactory.prototype.createConnection = function (attrs) {
        return this.create('connection', attrs);
    };
    ElementFactory.prototype.create = function (type, attrs) {
        attrs = assign({}, attrs || {});
        if (!attrs.id) {
            attrs.id = type + '_' + (this._uid++);
        }
        return create$1(type, attrs);
    };
    var FN_REF = '__fn';
    var DEFAULT_PRIORITY = 1000;
    var slice$1 = Array.prototype.slice;

    function EventBus() {
        this._listeners = {};
        this.on('diagram.destroy', 1, this._destroy, this);
    }

    EventBus.prototype.on = function (events, priority, callback, that) {
        events = isArray(events) ? events : [events];
        if (isFunction(priority)) {
            that = callback;
            callback = priority;
            priority = DEFAULT_PRIORITY;
        }
        if (!isNumber(priority)) {
            throw new Error('priority must be a number');
        }
        var actualCallback = callback;
        if (that) {
            actualCallback = bind(callback, that);
            actualCallback[FN_REF] = callback[FN_REF] || callback;
        }
        var self = this;
        events.forEach(function (e) {
            self._addListener(e, {priority: priority, callback: actualCallback, next: null});
        });
    };
    EventBus.prototype.once = function (event, priority, callback, that) {
        var self = this;
        if (isFunction(priority)) {
            that = callback;
            callback = priority;
            priority = DEFAULT_PRIORITY;
        }
        if (!isNumber(priority)) {
            throw new Error('priority must be a number');
        }

        function wrappedCallback() {
            var result = callback.apply(that, arguments);
            self.off(event, wrappedCallback);
            return result;
        }

        wrappedCallback[FN_REF] = callback;
        this.on(event, priority, wrappedCallback);
    };
    EventBus.prototype.off = function (events, callback) {
        events = isArray(events) ? events : [events];
        var self = this;
        events.forEach(function (event) {
            self._removeListener(event, callback);
        });
    };
    EventBus.prototype.createEvent = function (data) {
        var event = new InternalEvent();
        event.init(data);
        return event;
    };
    EventBus.prototype.fire = function (type, data) {
        var event, firstListener, returnValue, args;
        args = slice$1.call(arguments);
        if (typeof type === 'object') {
            event = type;
            type = event.type;
        }
        if (!type) {
            throw new Error('no event type specified');
        }
        firstListener = this._listeners[type];
        if (!firstListener) {
            return;
        }
        if (data instanceof InternalEvent) {
            event = data;
        } else {
            event = this.createEvent(data);
        }
        args[0] = event;
        var originalType = event.type;
        if (type !== originalType) {
            event.type = type;
        }
        try {
            returnValue = this._invokeListeners(event, args, firstListener);
        } finally {
            if (type !== originalType) {
                event.type = originalType;
            }
        }
        if (returnValue === undefined && event.defaultPrevented) {
            returnValue = false;
        }
        return returnValue;
    };
    EventBus.prototype.handleError = function (error) {
        return this.fire('error', {error: error}) === false;
    };
    EventBus.prototype._destroy = function () {
        this._listeners = {};
    };
    EventBus.prototype._invokeListeners = function (event, args, listener) {
        var returnValue;
        while (listener) {
            if (event.cancelBubble) {
                break;
            }
            returnValue = this._invokeListener(event, args, listener);
            listener = listener.next;
        }
        return returnValue;
    };
    EventBus.prototype._invokeListener = function (event, args, listener) {
        var returnValue;
        try {
            returnValue = invokeFunction(listener.callback, args);
            if (returnValue !== undefined) {
                event.returnValue = returnValue;
                event.stopPropagation();
            }
            if (returnValue === false) {
                event.preventDefault();
            }
        } catch (e) {
            if (!this.handleError(e)) {
                console.error('unhandled error in event listener');
                console.error(e.stack);
                throw e;
            }
        }
        return returnValue;
    };
    EventBus.prototype._addListener = function (event, newListener) {
        var listener = this._getListeners(event), previousListener;
        if (!listener) {
            this._setListeners(event, newListener);
            return;
        }
        while (listener) {
            if (listener.priority < newListener.priority) {
                newListener.next = listener;
                if (previousListener) {
                    previousListener.next = newListener;
                } else {
                    this._setListeners(event, newListener);
                }
                return;
            }
            previousListener = listener;
            listener = listener.next;
        }
        previousListener.next = newListener;
    };
    EventBus.prototype._getListeners = function (name) {
        return this._listeners[name];
    };
    EventBus.prototype._setListeners = function (name, listener) {
        this._listeners[name] = listener;
    };
    EventBus.prototype._removeListener = function (event, callback) {
        var listener = this._getListeners(event), nextListener, previousListener, listenerCallback;
        if (!callback) {
            this._setListeners(event, null);
            return;
        }
        while (listener) {
            nextListener = listener.next;
            listenerCallback = listener.callback;
            if (listenerCallback === callback || listenerCallback[FN_REF] === callback) {
                if (previousListener) {
                    previousListener.next = nextListener;
                } else {
                    this._setListeners(event, nextListener);
                }
            }
            previousListener = listener;
            listener = nextListener;
        }
    };

    function InternalEvent() {
    }

    InternalEvent.prototype.stopPropagation = function () {
        this.cancelBubble = true;
    };
    InternalEvent.prototype.preventDefault = function () {
        this.defaultPrevented = true;
    };
    InternalEvent.prototype.init = function (data) {
        assign(this, data || {});
    };

    function invokeFunction(fn, args) {
        return fn.apply(null, args);
    }

    function getVisual(gfx) {
        return query('.djs-visual', gfx);
    }

    function getChildren(gfx) {
        return gfx.parentNode.childNodes[1];
    }

    function transform$1(gfx, x, y, angle, amount) {
        var translate = createTransform();
        translate.setTranslate(x, y);
        var rotate = createTransform();
        rotate.setRotate(angle, 0, 0);
        var scale = createTransform();
        scale.setScale(amount || 1, amount || 1);
        transform(gfx, [translate, rotate, scale]);
    }

    function translate(gfx, x, y) {
        var translate = createTransform();
        translate.setTranslate(x, y);
        transform(gfx, translate);
    }

    function rotate(gfx, angle) {
        var rotate = createTransform();
        rotate.setRotate(angle, 0, 0);
        transform(gfx, rotate);
    }

    function GraphicsFactory(eventBus, elementRegistry) {
        this._eventBus = eventBus;
        this._elementRegistry = elementRegistry;
    }

    GraphicsFactory.$inject = ['eventBus', 'elementRegistry'];
    GraphicsFactory.prototype._getChildren = function (element) {
        var gfx = this._elementRegistry.getGraphics(element);
        var childrenGfx;
        if (!element.parent) {
            childrenGfx = gfx;
        } else {
            childrenGfx = getChildren(gfx);
            if (!childrenGfx) {
                childrenGfx = create('g');
                classes$1(childrenGfx).add('djs-children');
                append(gfx.parentNode, childrenGfx);
            }
        }
        return childrenGfx;
    };
    GraphicsFactory.prototype._clear = function (gfx) {
        var visual = getVisual(gfx);
        clear(visual);
        return visual;
    };
    GraphicsFactory.prototype._createContainer = function (type, childrenGfx, parentIndex) {
        var outerGfx = create('g');
        classes$1(outerGfx).add('djs-group');
        if (typeof parentIndex !== 'undefined') {
            prependTo$1(outerGfx, childrenGfx, childrenGfx.childNodes[parentIndex]);
        } else {
            append(childrenGfx, outerGfx);
        }
        var gfx = create('g');
        classes$1(gfx).add('djs-element');
        classes$1(gfx).add('djs-' + type);
        append(outerGfx, gfx);
        var visual = create('g');
        classes$1(visual).add('djs-visual');
        append(gfx, visual);
        return gfx;
    };
    GraphicsFactory.prototype.create = function (type, element, parentIndex) {
        var childrenGfx = this._getChildren(element.parent);
        return this._createContainer(type, childrenGfx, parentIndex);
    };
    GraphicsFactory.prototype.updateContainments = function (elements) {
        var self = this, elementRegistry = this._elementRegistry, parents;
        parents = reduce(elements, function (map$$1, e) {
            if (e.parent) {
                map$$1[e.parent.id] = e.parent;
            }
            return map$$1;
        }, {});
        forEach(parents, function (parent) {
            var children = parent.children;
            if (!children) {
                return;
            }
            var childGfx = self._getChildren(parent);
            forEach(children.slice().reverse(), function (c) {
                var gfx = elementRegistry.getGraphics(c);
                prependTo$1(gfx.parentNode, childGfx);
            });
        });
    };
    GraphicsFactory.prototype.drawShape = function (visual, element) {
        var eventBus = this._eventBus;
        return eventBus.fire('render.shape', {gfx: visual, element: element});
    };
    GraphicsFactory.prototype.getShapePath = function (element) {
        var eventBus = this._eventBus;
        return eventBus.fire('render.getShapePath', element);
    };
    GraphicsFactory.prototype.drawConnection = function (visual, element) {
        var eventBus = this._eventBus;
        return eventBus.fire('render.connection', {gfx: visual, element: element});
    };
    GraphicsFactory.prototype.getConnectionPath = function (waypoints) {
        var eventBus = this._eventBus;
        return eventBus.fire('render.getConnectionPath', waypoints);
    };
    GraphicsFactory.prototype.update = function (type, element, gfx) {
        if (!element.parent) {
            return;
        }
        var visual = this._clear(gfx);
        if (type === 'shape') {
            this.drawShape(visual, element);
            translate(gfx, element.x, element.y);
        } else if (type === 'connection') {
            this.drawConnection(visual, element);
        } else {
            throw new Error('unknown type: ' + type);
        }
        if (element.hidden) {
            attr$1(gfx, 'display', 'none');
        } else {
            attr$1(gfx, 'display', 'block');
        }
    };
    GraphicsFactory.prototype.remove = function (element) {
        var gfx = this._elementRegistry.getGraphics(element);
        remove$1(gfx.parentNode);
    };

    function prependTo$1(newNode, parentNode, siblingNode) {
        parentNode.insertBefore(newNode, siblingNode || parentNode.firstChild);
    }

    var CoreModule = {
        __depends__: [DrawModule],
        __init__: ['canvas'],
        canvas: ['type', Canvas],
        elementRegistry: ['type', ElementRegistry],
        elementFactory: ['type', ElementFactory],
        eventBus: ['type', EventBus],
        graphicsFactory: ['type', GraphicsFactory]
    };

    function bootstrap(bootstrapModules) {
        var modules = [], components = [];

        function hasModule(m) {
            return modules.indexOf(m) >= 0;
        }

        function addModule(m) {
            modules.push(m);
        }

        function visit(m) {
            if (hasModule(m)) {
                return;
            }
            (m.__depends__ || []).forEach(visit);
            if (hasModule(m)) {
                return;
            }
            addModule(m);
            (m.__init__ || []).forEach(function (c) {
                components.push(c);
            });
        }

        bootstrapModules.forEach(visit);
        var injector = new Injector(modules);
        components.forEach(function (c) {
            try {
                injector[typeof c === 'string' ? 'get' : 'invoke'](c);
            } catch (e) {
                console.error('Failed to instantiate component');
                console.error(e.stack);
                throw e;
            }
        });
        return injector;
    }

    function createInjector(options) {
        options = options || {};
        var configModule = {'config': ['value', options]};
        var modules = [configModule, CoreModule].concat(options.modules || []);
        return bootstrap(modules);
    }

    function Diagram(options, injector) {
        this.injector = injector = injector || createInjector(options);
        this.get = injector.get;
        this.invoke = injector.invoke;
        this.get('eventBus').fire('diagram.init');
    }

    Diagram.prototype.destroy = function () {
        this.get('eventBus').fire('diagram.destroy');
    };
    Diagram.prototype.clear = function () {
        this.get('eventBus').fire('diagram.clear');
    };

    function Base$1() {
    }

    Base$1.prototype.get = function (name) {
        return this.$model.properties.get(this, name);
    };
    Base$1.prototype.set = function (name, value) {
        this.$model.properties.set(this, name, value);
    };

    function Factory(model, properties) {
        this.model = model;
        this.properties = properties;
    }

    Factory.prototype.createType = function (descriptor) {
        var model = this.model;
        var props = this.properties, prototype = Object.create(Base$1.prototype);
        forEach(descriptor.properties, function (p) {
            if (!p.isMany && p.default !== undefined) {
                prototype[p.name] = p.default;
            }
        });
        props.defineModel(prototype, model);
        props.defineDescriptor(prototype, descriptor);
        var name = descriptor.ns.name;

        function ModdleElement(attrs) {
            props.define(this, '$type', {value: name, enumerable: true});
            props.define(this, '$attrs', {value: {}});
            props.define(this, '$parent', {writable: true});
            forEach(attrs, bind(function (val, key) {
                this.set(key, val);
            }, this));
        }

        ModdleElement.prototype = prototype;
        ModdleElement.hasType = prototype.$instanceOf = this.model.hasType;
        props.defineModel(ModdleElement, model);
        props.defineDescriptor(ModdleElement, descriptor);
        return ModdleElement;
    };
    var BUILTINS = {String: true, Boolean: true, Integer: true, Real: true, Element: true};
    var TYPE_CONVERTERS = {
        String: function (s) {
            return s;
        }, Boolean: function (s) {
            return s === 'true';
        }, Integer: function (s) {
            return parseInt(s, 10);
        }, Real: function (s) {
            return parseFloat(s, 10);
        }
    };

    function coerceType(type, value) {
        var converter = TYPE_CONVERTERS[type];
        if (converter) {
            return converter(value);
        } else {
            return value;
        }
    }

    function isBuiltIn(type) {
        return !!BUILTINS[type];
    }

    function isSimple(type) {
        return !!TYPE_CONVERTERS[type];
    }

    function parseName(name, defaultPrefix) {
        var parts = name.split(/:/), localName, prefix;
        if (parts.length === 1) {
            localName = name;
            prefix = defaultPrefix;
        } else if (parts.length === 2) {
            localName = parts[1];
            prefix = parts[0];
        } else {
            throw new Error('expected <prefix:localName> or <localName>, got ' + name);
        }
        name = (prefix ? prefix + ':' : '') + localName;
        return {name: name, prefix: prefix, localName: localName};
    }

    function DescriptorBuilder(nameNs) {
        this.ns = nameNs;
        this.name = nameNs.name;
        this.allTypes = [];
        this.allTypesByName = {};
        this.properties = [];
        this.propertiesByName = {};
    }

    DescriptorBuilder.prototype.build = function () {
        return pick(this, ['ns', 'name', 'allTypes', 'allTypesByName', 'properties', 'propertiesByName', 'bodyProperty', 'idProperty']);
    };
    DescriptorBuilder.prototype.addProperty = function (p, idx, validate) {
        if (typeof idx === 'boolean') {
            validate = idx;
            idx = undefined;
        }
        this.addNamedProperty(p, validate !== false);
        var properties = this.properties;
        if (idx !== undefined) {
            properties.splice(idx, 0, p);
        } else {
            properties.push(p);
        }
    };
    DescriptorBuilder.prototype.replaceProperty = function (oldProperty, newProperty, replace) {
        var oldNameNs = oldProperty.ns;
        var props = this.properties, propertiesByName = this.propertiesByName,
            rename = oldProperty.name !== newProperty.name;
        if (oldProperty.isId) {
            if (!newProperty.isId) {
                throw new Error('property <' + newProperty.ns.name + '> must be id property ' + 'to refine <' + oldProperty.ns.name + '>');
            }
            this.setIdProperty(newProperty, false);
        }
        if (oldProperty.isBody) {
            if (!newProperty.isBody) {
                throw new Error('property <' + newProperty.ns.name + '> must be body property ' + 'to refine <' + oldProperty.ns.name + '>');
            }
            this.setBodyProperty(newProperty, false);
        }
        var idx = props.indexOf(oldProperty);
        if (idx === -1) {
            throw new Error('property <' + oldNameNs.name + '> not found in property list');
        }
        props.splice(idx, 1);
        this.addProperty(newProperty, replace ? undefined : idx, rename);
        propertiesByName[oldNameNs.name] = propertiesByName[oldNameNs.localName] = newProperty;
    };
    DescriptorBuilder.prototype.redefineProperty = function (p, targetPropertyName, replace) {
        var nsPrefix = p.ns.prefix;
        var parts = targetPropertyName.split('#');
        var name = parseName(parts[0], nsPrefix);
        var attrName = parseName(parts[1], name.prefix).name;
        var redefinedProperty = this.propertiesByName[attrName];
        if (!redefinedProperty) {
            throw new Error('refined property <' + attrName + '> not found');
        } else {
            this.replaceProperty(redefinedProperty, p, replace);
        }
        delete p.redefines;
    };
    DescriptorBuilder.prototype.addNamedProperty = function (p, validate) {
        var ns = p.ns, propsByName = this.propertiesByName;
        if (validate) {
            this.assertNotDefined(p, ns.name);
            this.assertNotDefined(p, ns.localName);
        }
        propsByName[ns.name] = propsByName[ns.localName] = p;
    };
    DescriptorBuilder.prototype.removeNamedProperty = function (p) {
        var ns = p.ns, propsByName = this.propertiesByName;
        delete propsByName[ns.name];
        delete propsByName[ns.localName];
    };
    DescriptorBuilder.prototype.setBodyProperty = function (p, validate) {
        if (validate && this.bodyProperty) {
            throw new Error('body property defined multiple times ' + '(<' + this.bodyProperty.ns.name + '>, <' + p.ns.name + '>)');
        }
        this.bodyProperty = p;
    };
    DescriptorBuilder.prototype.setIdProperty = function (p, validate) {
        if (validate && this.idProperty) {
            throw new Error('id property defined multiple times ' + '(<' + this.idProperty.ns.name + '>, <' + p.ns.name + '>)');
        }
        this.idProperty = p;
    };
    DescriptorBuilder.prototype.assertNotDefined = function (p, name) {
        var propertyName = p.name, definedProperty = this.propertiesByName[propertyName];
        if (definedProperty) {
            throw new Error('property <' + propertyName + '> already defined; ' + 'override of <' + definedProperty.definedBy.ns.name + '#' + definedProperty.ns.name + '> by ' + '<' + p.definedBy.ns.name + '#' + p.ns.name + '> not allowed without redefines');
        }
    };
    DescriptorBuilder.prototype.hasProperty = function (name) {
        return this.propertiesByName[name];
    };
    DescriptorBuilder.prototype.addTrait = function (t, inherited) {
        var typesByName = this.allTypesByName, types = this.allTypes;
        var typeName = t.name;
        if (typeName in typesByName) {
            return;
        }
        forEach(t.properties, bind(function (p) {
            p = assign({}, p, {name: p.ns.localName, inherited: inherited});
            Object.defineProperty(p, 'definedBy', {value: t});
            var replaces = p.replaces, redefines = p.redefines;
            if (replaces || redefines) {
                this.redefineProperty(p, replaces || redefines, replaces);
            } else {
                if (p.isBody) {
                    this.setBodyProperty(p);
                }
                if (p.isId) {
                    this.setIdProperty(p);
                }
                this.addProperty(p);
            }
        }, this));
        types.push(t);
        typesByName[typeName] = t;
    };

    function Registry(packages, properties) {
        this.packageMap = {};
        this.typeMap = {};
        this.packages = [];
        this.properties = properties;
        forEach(packages, bind(this.registerPackage, this));
    }

    Registry.prototype.getPackage = function (uriOrPrefix) {
        return this.packageMap[uriOrPrefix];
    };
    Registry.prototype.getPackages = function () {
        return this.packages;
    };
    Registry.prototype.registerPackage = function (pkg) {
        pkg = assign({}, pkg);
        var pkgMap = this.packageMap;
        ensureAvailable(pkgMap, pkg, 'prefix');
        ensureAvailable(pkgMap, pkg, 'uri');
        forEach(pkg.types, bind(function (descriptor) {
            this.registerType(descriptor, pkg);
        }, this));
        pkgMap[pkg.uri] = pkgMap[pkg.prefix] = pkg;
        this.packages.push(pkg);
    };
    Registry.prototype.registerType = function (type, pkg) {
        type = assign({}, type, {
            superClass: (type.superClass || []).slice(),
            extends: (type.extends || []).slice(),
            properties: (type.properties || []).slice(),
            meta: assign((type.meta || {}))
        });
        var ns = parseName(type.name, pkg.prefix), name = ns.name, propertiesByName = {};
        forEach(type.properties, bind(function (p) {
            var propertyNs = parseName(p.name, ns.prefix), propertyName = propertyNs.name;
            if (!isBuiltIn(p.type)) {
                p.type = parseName(p.type, propertyNs.prefix).name;
            }
            assign(p, {ns: propertyNs, name: propertyName});
            propertiesByName[propertyName] = p;
        }, this));
        assign(type, {ns: ns, name: name, propertiesByName: propertiesByName});
        forEach(type.extends, bind(function (extendsName) {
            var extended = this.typeMap[extendsName];
            extended.traits = extended.traits || [];
            extended.traits.push(name);
        }, this));
        this.definePackage(type, pkg);
        this.typeMap[name] = type;
    };
    Registry.prototype.mapTypes = function (nsName, iterator, trait) {
        var type = isBuiltIn(nsName.name) ? {name: nsName.name} : this.typeMap[nsName.name];
        var self = this;

        function traverseTrait(cls) {
            return traverseSuper(cls, true);
        }

        function traverseSuper(cls, trait) {
            var parentNs = parseName(cls, isBuiltIn(cls) ? '' : nsName.prefix);
            self.mapTypes(parentNs, iterator, trait);
        }

        if (!type) {
            throw new Error('unknown type <' + nsName.name + '>');
        }
        forEach(type.superClass, trait ? traverseTrait : traverseSuper);
        iterator(type, !trait);
        forEach(type.traits, traverseTrait);
    };
    Registry.prototype.getEffectiveDescriptor = function (name) {
        var nsName = parseName(name);
        var builder = new DescriptorBuilder(nsName);
        this.mapTypes(nsName, function (type, inherited) {
            builder.addTrait(type, inherited);
        });
        var descriptor = builder.build();
        this.definePackage(descriptor, descriptor.allTypes[descriptor.allTypes.length - 1].$pkg);
        return descriptor;
    };
    Registry.prototype.definePackage = function (target, pkg) {
        this.properties.define(target, '$pkg', {value: pkg});
    };

    function ensureAvailable(packageMap, pkg, identifierKey) {
        var value = pkg[identifierKey];
        if (value in packageMap) {
            throw new Error('package with ' + identifierKey + ' <' + value + '> already defined');
        }
    }

    function Properties(model) {
        this.model = model;
    }

    Properties.prototype.set = function (target, name, value) {
        var property = this.model.getPropertyDescriptor(target, name);
        var propertyName = property && property.name;
        if (isUndefined$1(value)) {
            if (property) {
                delete target[propertyName];
            } else {
                delete target.$attrs[name];
            }
        } else {
            if (property) {
                if (propertyName in target) {
                    target[propertyName] = value;
                } else {
                    defineProperty$1(target, property, value);
                }
            } else {
                target.$attrs[name] = value;
            }
        }
    };
    Properties.prototype.get = function (target, name) {
        var property = this.model.getPropertyDescriptor(target, name);
        if (!property) {
            return target.$attrs[name];
        }
        var propertyName = property.name;
        if (!target[propertyName] && property.isMany) {
            defineProperty$1(target, property, []);
        }
        return target[propertyName];
    };
    Properties.prototype.define = function (target, name, options) {
        Object.defineProperty(target, name, options);
    };
    Properties.prototype.defineDescriptor = function (target, descriptor) {
        this.define(target, '$descriptor', {value: descriptor});
    };
    Properties.prototype.defineModel = function (target, model) {
        this.define(target, '$model', {value: model});
    };

    function isUndefined$1(val) {
        return typeof val === 'undefined';
    }

    function defineProperty$1(target, property, value) {
        Object.defineProperty(target, property.name, {
            enumerable: !property.isReference,
            writable: true,
            value: value,
            configurable: true
        });
    }

    function Moddle(packages) {
        this.properties = new Properties(this);
        this.factory = new Factory(this, this.properties);
        this.registry = new Registry(packages, this.properties);
        this.typeCache = {};
    }

    Moddle.prototype.create = function (descriptor, attrs) {
        var Type = this.getType(descriptor);
        if (!Type) {
            throw new Error('unknown type <' + descriptor + '>');
        }
        return new Type(attrs);
    };
    Moddle.prototype.getType = function (descriptor) {
        var cache = this.typeCache;
        var name = isString(descriptor) ? descriptor : descriptor.ns.name;
        var type = cache[name];
        if (!type) {
            descriptor = this.registry.getEffectiveDescriptor(name);
            type = cache[name] = this.factory.createType(descriptor);
        }
        return type;
    };
    Moddle.prototype.createAny = function (name, nsUri, properties) {
        var nameNs = parseName(name);
        var element = {
            $type: name, $instanceOf: function (type) {
                return type === this.$type;
            }
        };
        var descriptor = {
            name: name,
            isGeneric: true,
            ns: {prefix: nameNs.prefix, localName: nameNs.localName, uri: nsUri}
        };
        this.properties.defineDescriptor(element, descriptor);
        this.properties.defineModel(element, this);
        this.properties.define(element, '$parent', {enumerable: false, writable: true});
        forEach(properties, function (a, key) {
            if (isObject(a) && a.value !== undefined) {
                element[a.name] = a.value;
            } else {
                element[key] = a;
            }
        });
        return element;
    };
    Moddle.prototype.getPackage = function (uriOrPrefix) {
        return this.registry.getPackage(uriOrPrefix);
    };
    Moddle.prototype.getPackages = function () {
        return this.registry.getPackages();
    };
    Moddle.prototype.getElementDescriptor = function (element) {
        return element.$descriptor;
    };
    Moddle.prototype.hasType = function (element, type) {
        if (type === undefined) {
            type = element;
            element = this;
        }
        var descriptor = element.$model.getElementDescriptor(element);
        return (type in descriptor.allTypesByName);
    };
    Moddle.prototype.getPropertyDescriptor = function (element, property) {
        return this.getElementDescriptor(element).propertiesByName[property];
    };
    Moddle.prototype.getTypeDescriptor = function (type) {
        return this.registry.typeMap[type];
    };
    var tinyStack = createCommonjsModule(function (module, exports) {
        var _createClass = function () {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }

            return function (Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        (function (global) {
            var TinyStack = function () {
                function TinyStack() {
                    _classCallCheck(this, TinyStack);
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }
                    this.data = [null].concat(args);
                    this.top = this.data.length - 1;
                }

                _createClass(TinyStack, [{
                    key: "clear", value: function clear() {
                        this.data.length = 1;
                        this.top = 0;
                        return this;
                    }
                }, {
                    key: "empty", value: function empty() {
                        return this.top === 0;
                    }
                }, {
                    key: "length", value: function length() {
                        return this.top;
                    }
                }, {
                    key: "peek", value: function peek() {
                        return this.data[this.top];
                    }
                }, {
                    key: "pop", value: function pop() {
                        var result = void 0;
                        if (this.top > 0) {
                            result = this.data.pop();
                            this.top--;
                        }
                        return result;
                    }
                }, {
                    key: "push", value: function push(arg) {
                        this.data[++this.top] = arg;
                        return this;
                    }
                }, {
                    key: "search", value: function search(arg) {
                        var index = this.data.indexOf(arg);
                        return index === -1 ? -1 : this.data.length - index;
                    }
                }]);
                return TinyStack;
            }();

            function factory() {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }
                return new (Function.prototype.bind.apply(TinyStack, [null].concat(args)))();
            }

            {
                module.exports = factory;
            }
        })(typeof window !== "undefined" ? window : commonjsGlobal);
    });
    var fromCharCode = String.fromCharCode;
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    var ENTITY_PATTERN = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/ig;
    var ENTITY_MAPPING = {'amp': '&', 'apos': '\'', 'gt': '>', 'lt': '<', 'quot': '"'};
    Object.keys(ENTITY_MAPPING).forEach(function (k) {
        ENTITY_MAPPING[k.toUpperCase()] = ENTITY_MAPPING[k];
    });

    function replaceEntities(_, d, x, z) {
        if (z) {
            if (hasOwnProperty$1.call(ENTITY_MAPPING, z)) {
                return ENTITY_MAPPING[z];
            } else {
                return '&' + z + ';';
            }
        }
        if (d) {
            return fromCharCode(d);
        }
        return fromCharCode(parseInt(x, 16));
    }

    function decodeEntities(s) {
        if (s.length > 3 && s.indexOf('&') !== -1) {
            return s.replace(ENTITY_PATTERN, replaceEntities);
        }
        return s;
    }

    var XSI_URI = 'http://www.w3.org/2001/XMLSchema-instance';
    var XSI_PREFIX = 'xsi';
    var XSI_TYPE = 'xsi:type';
    var NON_WHITESPACE_OUTSIDE_ROOT_NODE = 'non-whitespace outside of root node';

    function error(msg) {
        return new Error(msg);
    }

    function missingNamespaceForPrefix(prefix) {
        return 'missing namespace for prefix <' + prefix + '>';
    }

    function getter(getFn) {
        return {'get': getFn, 'enumerable': true};
    }

    function cloneNsMatrix(nsMatrix) {
        var clone = {}, key;
        for (key in nsMatrix) {
            clone[key] = nsMatrix[key];
        }
        return clone;
    }

    function uriPrefix(prefix) {
        return prefix + '$uri';
    }

    function buildNsMatrix(nsUriToPrefix) {
        var nsMatrix = {}, uri, prefix;
        for (uri in nsUriToPrefix) {
            prefix = nsUriToPrefix[uri];
            nsMatrix[prefix] = prefix;
            nsMatrix[uriPrefix(prefix)] = uri;
        }
        return nsMatrix;
    }

    function noopGetContext() {
        return {'line': 0, 'column': 0};
    }

    function throwFunc(err) {
        throw err;
    }

    function Parser(options) {
        if (!this) {
            return new Parser(options);
        }
        var proxy = options && options['proxy'];
        var onText, onOpenTag, onCloseTag, onCDATA, onError = throwFunc, onWarning, onComment, onQuestion, onAttention;
        var getContext = noopGetContext;
        var maybeNS = false;
        var isNamespace = false;
        var returnError = null;
        var parseStop = false;
        var nsUriToPrefix;

        function handleError(err) {
            if (!(err instanceof Error)) {
                err = error(err);
            }
            returnError = err;
            onError(err, getContext);
        }

        function handleWarning(err) {
            if (!onWarning) {
                return;
            }
            if (!(err instanceof Error)) {
                err = error(err);
            }
            onWarning(err, getContext);
        }

        this['on'] = function (name, cb) {
            if (typeof cb !== 'function') {
                throw error('required args <name, cb>');
            }
            switch (name) {
                case'openTag':
                    onOpenTag = cb;
                    break;
                case'text':
                    onText = cb;
                    break;
                case'closeTag':
                    onCloseTag = cb;
                    break;
                case'error':
                    onError = cb;
                    break;
                case'warn':
                    onWarning = cb;
                    break;
                case'cdata':
                    onCDATA = cb;
                    break;
                case'attention':
                    onAttention = cb;
                    break;
                case'question':
                    onQuestion = cb;
                    break;
                case'comment':
                    onComment = cb;
                    break;
                default:
                    throw error('unsupported event: ' + name);
            }
            return this;
        };
        this['ns'] = function (nsMap) {
            if (typeof nsMap === 'undefined') {
                nsMap = {};
            }
            if (typeof nsMap !== 'object') {
                throw error('required args <nsMap={}>');
            }
            var _nsUriToPrefix = {}, k;
            for (k in nsMap) {
                _nsUriToPrefix[k] = nsMap[k];
            }
            _nsUriToPrefix[XSI_URI] = XSI_PREFIX;
            isNamespace = true;
            nsUriToPrefix = _nsUriToPrefix;
            return this;
        };
        this['parse'] = function (xml) {
            if (typeof xml !== 'string') {
                throw error('required args <xml=string>');
            }
            returnError = null;
            parse(xml);
            getContext = noopGetContext;
            parseStop = false;
            return returnError;
        };
        this['stop'] = function () {
            parseStop = true;
        };

        function parse(xml) {
            var nsMatrixStack = isNamespace ? [] : null, nsMatrix = isNamespace ? buildNsMatrix(nsUriToPrefix) : null,
                _nsMatrix, nodeStack = [], anonymousNsCount = 0, tagStart = false, tagEnd = false, i = 0, j = 0, x, y,
                q, w, xmlns, elementName, _elementName, elementProxy;
            var attrsString = '', attrsStart = 0, cachedAttrs;

            function getAttrs() {
                if (cachedAttrs !== null) {
                    return cachedAttrs;
                }
                var nsUri, nsUriPrefix, nsName, defaultAlias = isNamespace && nsMatrix['xmlns'],
                    attrList = isNamespace && maybeNS ? [] : null, i = attrsStart, s = attrsString, l = s.length,
                    hasNewMatrix, newalias, value, alias, name, attrs = {}, seenAttrs = {}, skipAttr, w, j;
                parseAttr:for (; i < l; i++) {
                    skipAttr = false;
                    w = s.charCodeAt(i);
                    if (w === 32 || (w < 14 && w > 8)) {
                        continue;
                    }
                    if (w < 65 || w > 122 || (w > 90 && w < 97)) {
                        if (w !== 95 && w !== 58) {
                            handleWarning('illegal first char attribute name');
                            skipAttr = true;
                        }
                    }
                    for (j = i + 1; j < l; j++) {
                        w = s.charCodeAt(j);
                        if (w > 96 && w < 123 || w > 64 && w < 91 || w > 47 && w < 59 || w === 46 || w === 45 || w === 95) {
                            continue;
                        }
                        if (w === 32 || (w < 14 && w > 8)) {
                            handleWarning('missing attribute value');
                            i = j;
                            continue parseAttr;
                        }
                        if (w === 61) {
                            break;
                        }
                        handleWarning('illegal attribute name char');
                        skipAttr = true;
                    }
                    name = s.substring(i, j);
                    if (name === 'xmlns:xmlns') {
                        handleWarning('illegal declaration of xmlns');
                        skipAttr = true;
                    }
                    w = s.charCodeAt(j + 1);
                    if (w === 34) {
                        j = s.indexOf('"', i = j + 2);
                        if (j === -1) {
                            j = s.indexOf('\'', i);
                            if (j !== -1) {
                                handleWarning('attribute value quote missmatch');
                                skipAttr = true;
                            }
                        }
                    } else if (w === 39) {
                        j = s.indexOf('\'', i = j + 2);
                        if (j === -1) {
                            j = s.indexOf('"', i);
                            if (j !== -1) {
                                handleWarning('attribute value quote missmatch');
                                skipAttr = true;
                            }
                        }
                    } else {
                        handleWarning('missing attribute value quotes');
                        skipAttr = true;
                        for (j = j + 1; j < l; j++) {
                            w = s.charCodeAt(j + 1);
                            if (w === 32 || (w < 14 && w > 8)) {
                                break;
                            }
                        }
                    }
                    if (j === -1) {
                        handleWarning('missing closing quotes');
                        j = l;
                        skipAttr = true;
                    }
                    if (!skipAttr) {
                        value = s.substring(i, j);
                    }
                    i = j;
                    for (; j + 1 < l; j++) {
                        w = s.charCodeAt(j + 1);
                        if (w === 32 || (w < 14 && w > 8)) {
                            break;
                        }
                        if (i === j) {
                            handleWarning('illegal character after attribute end');
                            skipAttr = true;
                        }
                    }
                    i = j + 1;
                    if (skipAttr) {
                        continue parseAttr;
                    }
                    if (name in seenAttrs) {
                        handleWarning('attribute <' + name + '> already defined');
                        continue;
                    }
                    seenAttrs[name] = true;
                    if (!isNamespace) {
                        attrs[name] = value;
                        continue;
                    }
                    if (maybeNS) {
                        newalias = (name === 'xmlns' ? 'xmlns' : (name.charCodeAt(0) === 120 && name.substr(0, 6) === 'xmlns:') ? name.substr(6) : null);
                        if (newalias !== null) {
                            nsUri = decodeEntities(value);
                            nsUriPrefix = uriPrefix(newalias);
                            alias = nsUriToPrefix[nsUri];
                            if (!alias) {
                                if ((newalias === 'xmlns') || (nsUriPrefix in nsMatrix && nsMatrix[nsUriPrefix] !== nsUri)) {
                                    do {
                                        alias = 'ns' + (anonymousNsCount++);
                                    } while (typeof nsMatrix[alias] !== 'undefined');
                                } else {
                                    alias = newalias;
                                }
                                nsUriToPrefix[nsUri] = alias;
                            }
                            if (nsMatrix[newalias] !== alias) {
                                if (!hasNewMatrix) {
                                    nsMatrix = cloneNsMatrix(nsMatrix);
                                    hasNewMatrix = true;
                                }
                                nsMatrix[newalias] = alias;
                                if (newalias === 'xmlns') {
                                    nsMatrix[uriPrefix(alias)] = nsUri;
                                    defaultAlias = alias;
                                }
                                nsMatrix[nsUriPrefix] = nsUri;
                            }
                            attrs[name] = value;
                            continue;
                        }
                        attrList.push(name, value);
                        continue;
                    }
                    w = name.indexOf(':');
                    if (w === -1) {
                        attrs[name] = value;
                        continue;
                    }
                    if (!(nsName = nsMatrix[name.substring(0, w)])) {
                        handleWarning(missingNamespaceForPrefix(name.substring(0, w)));
                        continue;
                    }
                    name = defaultAlias === nsName ? name.substr(w + 1) : nsName + name.substr(w);
                    if (name === XSI_TYPE) {
                        w = value.indexOf(':');
                        if (w !== -1) {
                            nsName = value.substring(0, w);
                            nsName = nsMatrix[nsName] || nsName;
                            value = nsName + value.substring(w);
                        } else {
                            value = defaultAlias + ':' + value;
                        }
                    }
                    attrs[name] = value;
                }
                if (maybeNS) {
                    for (i = 0, l = attrList.length; i < l; i++) {
                        name = attrList[i++];
                        value = attrList[i];
                        w = name.indexOf(':');
                        if (w !== -1) {
                            if (!(nsName = nsMatrix[name.substring(0, w)])) {
                                handleWarning(missingNamespaceForPrefix(name.substring(0, w)));
                                continue;
                            }
                            name = defaultAlias === nsName ? name.substr(w + 1) : nsName + name.substr(w);
                            if (name === XSI_TYPE) {
                                w = value.indexOf(':');
                                if (w !== -1) {
                                    nsName = value.substring(0, w);
                                    nsName = nsMatrix[nsName] || nsName;
                                    value = nsName + value.substring(w);
                                } else {
                                    value = defaultAlias + ':' + value;
                                }
                            }
                        }
                        attrs[name] = value;
                    }
                }
                return cachedAttrs = attrs;
            }

            function getParseContext() {
                var splitsRe = /(\r\n|\r|\n)/g;
                var line = 0;
                var column = 0;
                var startOfLine = 0;
                var endOfLine = j;
                var match;
                var data;
                while (i >= startOfLine) {
                    match = splitsRe.exec(xml);
                    if (!match) {
                        break;
                    }
                    endOfLine = match[0].length + match.index;
                    if (endOfLine > i) {
                        break;
                    }
                    line += 1;
                    startOfLine = endOfLine;
                }
                if (i == -1) {
                    column = endOfLine;
                    data = xml.substring(j);
                } else if (j === 0) {
                    console.log(i - startOfLine);
                    data = xml.substring(j, i);
                } else {
                    column = i - startOfLine;
                    data = (j == -1 ? xml.substring(i) : xml.substring(i, j + 1));
                }
                return {'data': data, 'line': line, 'column': column};
            }

            getContext = getParseContext;
            if (proxy) {
                elementProxy = Object.create({}, {
                    'name': getter(function () {
                        return elementName;
                    }), 'originalName': getter(function () {
                        return _elementName;
                    }), 'attrs': getter(getAttrs), 'ns': getter(function () {
                        return nsMatrix;
                    })
                });
            }
            while (j !== -1) {
                if (xml.charCodeAt(j) === 60) {
                    i = j;
                } else {
                    i = xml.indexOf('<', j);
                }
                if (i === -1) {
                    if (nodeStack.length) {
                        return handleError('unexpected end of file');
                    }
                    if (j === 0) {
                        return handleError('missing start tag');
                    }
                    if (j < xml.length) {
                        if (xml.substring(j).trim()) {
                            handleWarning(NON_WHITESPACE_OUTSIDE_ROOT_NODE);
                        }
                    }
                    return;
                }
                if (j !== i) {
                    if (nodeStack.length) {
                        if (onText) {
                            onText(xml.substring(j, i), decodeEntities, getContext);
                            if (parseStop) {
                                return;
                            }
                        }
                    } else {
                        if (xml.substring(j, i).trim()) {
                            handleWarning(NON_WHITESPACE_OUTSIDE_ROOT_NODE);
                            if (parseStop) {
                                return;
                            }
                        }
                    }
                }
                w = xml.charCodeAt(i + 1);
                if (w === 33) {
                    w = xml.charCodeAt(i + 2);
                    if (w === 91 && xml.substr(i + 3, 6) === 'CDATA[') {
                        j = xml.indexOf(']]>', i);
                        if (j === -1) {
                            return handleError('unclosed cdata');
                        }
                        if (onCDATA) {
                            onCDATA(xml.substring(i + 9, j), getContext);
                            if (parseStop) {
                                return;
                            }
                        }
                        j += 3;
                        continue;
                    }
                    if (w === 45 && xml.charCodeAt(i + 3) === 45) {
                        j = xml.indexOf('-->', i);
                        if (j === -1) {
                            return handleError('unclosed comment');
                        }
                        if (onComment) {
                            onComment(xml.substring(i + 4, j), decodeEntities, getContext);
                            if (parseStop) {
                                return;
                            }
                        }
                        j += 3;
                        continue;
                    }
                    j = xml.indexOf('>', i + 1);
                    if (j === -1) {
                        return handleError('unclosed tag');
                    }
                    if (onAttention) {
                        onAttention(xml.substring(i, j + 1), decodeEntities, getContext);
                        if (parseStop) {
                            return;
                        }
                    }
                    j += 1;
                    continue;
                }
                if (w === 63) {
                    j = xml.indexOf('?>', i);
                    if (j === -1) {
                        return handleError('unclosed question');
                    }
                    if (onQuestion) {
                        onQuestion(xml.substring(i, j + 2), getContext);
                        if (parseStop) {
                            return;
                        }
                    }
                    j += 2;
                    continue;
                }
                j = xml.indexOf('>', i + 1);
                if (j == -1) {
                    return handleError('unclosed tag');
                }
                cachedAttrs = {};
                if (w === 47) {
                    tagStart = false;
                    tagEnd = true;
                    if (!nodeStack.length) {
                        return handleError('missing open tag');
                    }
                    x = elementName = nodeStack.pop();
                    q = i + 2 + x.length;
                    if (xml.substring(i + 2, q) !== x) {
                        return handleError('closing tag mismatch');
                    }
                    for (; q < j; q++) {
                        w = xml.charCodeAt(q);
                        if (w === 32 || (w > 8 && w < 14)) {
                            continue;
                        }
                        return handleError('close tag');
                    }
                } else {
                    if (xml.charCodeAt(j - 1) === 47) {
                        x = elementName = xml.substring(i + 1, j - 1);
                        tagStart = true;
                        tagEnd = true;
                    } else {
                        x = elementName = xml.substring(i + 1, j);
                        tagStart = true;
                        tagEnd = false;
                    }
                    if (!(w > 96 && w < 123 || w > 64 && w < 91 || w === 95 || w === 58)) {
                        return handleError('illegal first char nodeName');
                    }
                    for (q = 1, y = x.length; q < y; q++) {
                        w = x.charCodeAt(q);
                        if (w > 96 && w < 123 || w > 64 && w < 91 || w > 47 && w < 59 || w === 45 || w === 95 || w == 46) {
                            continue;
                        }
                        if (w === 32 || (w < 14 && w > 8)) {
                            elementName = x.substring(0, q);
                            cachedAttrs = null;
                            break;
                        }
                        return handleError('invalid nodeName');
                    }
                    if (!tagEnd) {
                        nodeStack.push(elementName);
                    }
                }
                if (isNamespace) {
                    _nsMatrix = nsMatrix;
                    if (tagStart) {
                        if (!tagEnd) {
                            nsMatrixStack.push(_nsMatrix);
                        }
                        if (cachedAttrs === null) {
                            if ((maybeNS = x.indexOf('xmlns', q) !== -1)) {
                                attrsStart = q;
                                attrsString = x;
                                getAttrs();
                                maybeNS = false;
                            }
                        }
                    }
                    _elementName = elementName;
                    w = elementName.indexOf(':');
                    if (w !== -1) {
                        xmlns = nsMatrix[elementName.substring(0, w)];
                        if (!xmlns) {
                            return handleError('missing namespace on <' + _elementName + '>');
                        }
                        elementName = elementName.substr(w + 1);
                    } else {
                        xmlns = nsMatrix['xmlns'];
                    }
                    if (xmlns) {
                        elementName = xmlns + ':' + elementName;
                    }
                }
                if (tagStart) {
                    attrsStart = q;
                    attrsString = x;
                    if (onOpenTag) {
                        if (proxy) {
                            onOpenTag(elementProxy, decodeEntities, tagEnd, getContext);
                        } else {
                            onOpenTag(elementName, getAttrs, decodeEntities, tagEnd, getContext);
                        }
                        if (parseStop) {
                            return;
                        }
                    }
                }
                if (tagEnd) {
                    if (onCloseTag) {
                        onCloseTag(proxy ? elementProxy : elementName, decodeEntities, tagStart, getContext);
                        if (parseStop) {
                            return;
                        }
                    }
                    if (isNamespace) {
                        if (!tagStart) {
                            nsMatrix = nsMatrixStack.pop();
                        } else {
                            nsMatrix = _nsMatrix;
                        }
                    }
                }
                j += 1;
            }
        }
    }

    function hasLowerCaseAlias(pkg) {
        return pkg.xml && pkg.xml.tagAlias === 'lowerCase';
    }

    var DEFAULT_NS_MAP = {'xsi': 'http://www.w3.org/2001/XMLSchema-instance'};
    var XSI_TYPE$1 = 'xsi:type';

    function serializeFormat(element) {
        return element.xml && element.xml.serialize;
    }

    function serializeAsType(element) {
        return serializeFormat(element) === XSI_TYPE$1;
    }

    function serializeAsProperty(element) {
        return serializeFormat(element) === 'property';
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function aliasToName(aliasNs, pkg) {
        if (!hasLowerCaseAlias(pkg)) {
            return aliasNs.name;
        }
        return aliasNs.prefix + ':' + capitalize(aliasNs.localName);
    }

    function prefixedToName(nameNs, pkg) {
        var name = nameNs.name, localName = nameNs.localName;
        var typePrefix = pkg.xml && pkg.xml.typePrefix;
        if (typePrefix && localName.indexOf(typePrefix) === 0) {
            return nameNs.prefix + ':' + localName.slice(typePrefix.length);
        } else {
            return name;
        }
    }

    function normalizeXsiTypeName(name, model) {
        var nameNs = parseName(name);
        var pkg = model.getPackage(nameNs.prefix);
        return prefixedToName(nameNs, pkg);
    }

    function error$1(message) {
        return new Error(message);
    }

    function getModdleDescriptor(element) {
        return element.$descriptor;
    }

    function defer(fn) {
        setTimeout(fn, 0);
    }

    function Context(options) {
        assign(this, options);
        this.elementsById = {};
        this.references = [];
        this.warnings = [];
        this.addReference = function (reference) {
            this.references.push(reference);
        };
        this.addElement = function (element) {
            if (!element) {
                throw error$1('expected element');
            }
            var elementsById = this.elementsById;
            var descriptor = getModdleDescriptor(element);
            var idProperty = descriptor.idProperty, id;
            if (idProperty) {
                id = element.get(idProperty.name);
                if (id) {
                    if (elementsById[id]) {
                        throw error$1('duplicate ID <' + id + '>');
                    }
                    elementsById[id] = element;
                }
            }
        };
        this.addWarning = function (warning) {
            this.warnings.push(warning);
        };
    }

    function BaseHandler() {
    }

    BaseHandler.prototype.handleEnd = function () {
    };
    BaseHandler.prototype.handleText = function () {
    };
    BaseHandler.prototype.handleNode = function () {
    };

    function NoopHandler() {
    }

    NoopHandler.prototype = Object.create(BaseHandler.prototype);
    NoopHandler.prototype.handleNode = function () {
        return this;
    };

    function BodyHandler() {
    }

    BodyHandler.prototype = Object.create(BaseHandler.prototype);
    BodyHandler.prototype.handleText = function (text) {
        this.body = (this.body || '') + text;
    };

    function ReferenceHandler(property, context) {
        this.property = property;
        this.context = context;
    }

    ReferenceHandler.prototype = Object.create(BodyHandler.prototype);
    ReferenceHandler.prototype.handleNode = function (node) {
        if (this.element) {
            throw error$1('expected no sub nodes');
        } else {
            this.element = this.createReference(node);
        }
        return this;
    };
    ReferenceHandler.prototype.handleEnd = function () {
        this.element.id = this.body;
    };
    ReferenceHandler.prototype.createReference = function (node) {
        return {property: this.property.ns.name, id: ''};
    };

    function ValueHandler(propertyDesc, element) {
        this.element = element;
        this.propertyDesc = propertyDesc;
    }

    ValueHandler.prototype = Object.create(BodyHandler.prototype);
    ValueHandler.prototype.handleEnd = function () {
        var value = this.body || '', element = this.element, propertyDesc = this.propertyDesc;
        value = coerceType(propertyDesc.type, value);
        if (propertyDesc.isMany) {
            element.get(propertyDesc.name).push(value);
        } else {
            element.set(propertyDesc.name, value);
        }
    };

    function BaseElementHandler() {
    }

    BaseElementHandler.prototype = Object.create(BodyHandler.prototype);
    BaseElementHandler.prototype.handleNode = function (node) {
        var parser = this, element = this.element;
        if (!element) {
            element = this.element = this.createElement(node);
            this.context.addElement(element);
        } else {
            parser = this.handleChild(node);
        }
        return parser;
    };

    function ElementHandler(model, typeName, context) {
        this.model = model;
        this.type = model.getType(typeName);
        this.context = context;
    }

    ElementHandler.prototype = Object.create(BaseElementHandler.prototype);
    ElementHandler.prototype.addReference = function (reference) {
        this.context.addReference(reference);
    };
    ElementHandler.prototype.handleEnd = function () {
        var value = this.body, element = this.element, descriptor = getModdleDescriptor(element),
            bodyProperty = descriptor.bodyProperty;
        if (bodyProperty && value !== undefined) {
            value = coerceType(bodyProperty.type, value);
            element.set(bodyProperty.name, value);
        }
    };
    ElementHandler.prototype.createElement = function (node) {
        var attributes = node.attributes, Type = this.type, descriptor = getModdleDescriptor(Type),
            context = this.context, instance = new Type({}), model = this.model, propNameNs;
        forEach(attributes, function (value, name) {
            var prop = descriptor.propertiesByName[name], values$$1;
            if (prop && prop.isReference) {
                if (!prop.isMany) {
                    context.addReference({element: instance, property: prop.ns.name, id: value});
                } else {
                    values$$1 = value.split(' ');
                    forEach(values$$1, function (v) {
                        context.addReference({element: instance, property: prop.ns.name, id: v});
                    });
                }
            } else {
                if (prop) {
                    value = coerceType(prop.type, value);
                } else if (name !== 'xmlns') {
                    propNameNs = parseName(name, descriptor.ns.prefix);
                    if (model.getPackage(propNameNs.prefix)) {
                        context.addWarning({
                            message: 'unknown attribute <' + name + '>',
                            element: instance,
                            property: name,
                            value: value
                        });
                    }
                }
                instance.set(name, value);
            }
        });
        return instance;
    };
    ElementHandler.prototype.getPropertyForNode = function (node) {
        var name = node.name;
        var nameNs = parseName(name);
        var type = this.type, model = this.model, descriptor = getModdleDescriptor(type);
        var propertyName = nameNs.name, property = descriptor.propertiesByName[propertyName], elementTypeName,
            elementType;
        if (property) {
            if (serializeAsType(property)) {
                elementTypeName = node.attributes[XSI_TYPE$1];
                if (elementTypeName) {
                    elementTypeName = normalizeXsiTypeName(elementTypeName, model);
                    elementType = model.getType(elementTypeName);
                    return assign({}, property, {effectiveType: getModdleDescriptor(elementType).name});
                }
            }
            return property;
        }
        var pkg = model.getPackage(nameNs.prefix);
        if (pkg) {
            elementTypeName = aliasToName(nameNs, pkg);
            elementType = model.getType(elementTypeName);
            property = find(descriptor.properties, function (p) {
                return !p.isVirtual && !p.isReference && !p.isAttribute && elementType.hasType(p.type);
            });
            if (property) {
                return assign({}, property, {effectiveType: getModdleDescriptor(elementType).name});
            }
        } else {
            property = find(descriptor.properties, function (p) {
                return !p.isReference && !p.isAttribute && p.type === 'Element';
            });
            if (property) {
                return property;
            }
        }
        throw error$1('unrecognized element <' + nameNs.name + '>');
    };
    ElementHandler.prototype.toString = function () {
        return 'ElementDescriptor[' + getModdleDescriptor(this.type).name + ']';
    };
    ElementHandler.prototype.valueHandler = function (propertyDesc, element) {
        return new ValueHandler(propertyDesc, element);
    };
    ElementHandler.prototype.referenceHandler = function (propertyDesc) {
        return new ReferenceHandler(propertyDesc, this.context);
    };
    ElementHandler.prototype.handler = function (type) {
        if (type === 'Element') {
            return new GenericElementHandler(this.model, type, this.context);
        } else {
            return new ElementHandler(this.model, type, this.context);
        }
    };
    ElementHandler.prototype.handleChild = function (node) {
        var propertyDesc, type, element, childHandler;
        propertyDesc = this.getPropertyForNode(node);
        element = this.element;
        type = propertyDesc.effectiveType || propertyDesc.type;
        if (isSimple(type)) {
            return this.valueHandler(propertyDesc, element);
        }
        if (propertyDesc.isReference) {
            childHandler = this.referenceHandler(propertyDesc).handleNode(node);
        } else {
            childHandler = this.handler(type).handleNode(node);
        }
        var newElement = childHandler.element;
        if (newElement !== undefined) {
            if (propertyDesc.isMany) {
                element.get(propertyDesc.name).push(newElement);
            } else {
                element.set(propertyDesc.name, newElement);
            }
            if (propertyDesc.isReference) {
                assign(newElement, {element: element});
                this.context.addReference(newElement);
            } else {
                newElement.$parent = element;
            }
        }
        return childHandler;
    };

    function RootElementHandler(model, typeName, context) {
        ElementHandler.call(this, model, typeName, context);
    }

    RootElementHandler.prototype = Object.create(ElementHandler.prototype);
    RootElementHandler.prototype.createElement = function (node) {
        var name = node.name, nameNs = parseName(name), model = this.model, type = this.type,
            pkg = model.getPackage(nameNs.prefix), typeName = pkg && aliasToName(nameNs, pkg) || name;
        if (!type.hasType(typeName)) {
            throw error$1('unexpected element <' + node.originalName + '>');
        }
        return ElementHandler.prototype.createElement.call(this, node);
    };

    function GenericElementHandler(model, typeName, context) {
        this.model = model;
        this.context = context;
    }

    GenericElementHandler.prototype = Object.create(BaseElementHandler.prototype);
    GenericElementHandler.prototype.createElement = function (node) {
        var name = node.name, ns = parseName(name), prefix = ns.prefix, uri = node.ns[prefix + '$uri'],
            attributes = node.attributes;
        return this.model.createAny(name, uri, attributes);
    };
    GenericElementHandler.prototype.handleChild = function (node) {
        var handler = new GenericElementHandler(this.model, 'Element', this.context).handleNode(node),
            element = this.element;
        var newElement = handler.element, children;
        if (newElement !== undefined) {
            children = element.$children = element.$children || [];
            children.push(newElement);
            newElement.$parent = element;
        }
        return handler;
    };
    GenericElementHandler.prototype.handleText = function (text) {
        this.body = this.body || '' + text;
    };
    GenericElementHandler.prototype.handleEnd = function () {
        if (this.body) {
            this.element.$body = this.body;
        }
    };

    function Reader(options) {
        if (options instanceof Moddle) {
            options = {model: options};
        }
        assign(this, {lax: false}, options);
    }

    Reader.prototype.fromXML = function (xml, options, done) {
        var rootHandler = options.rootHandler;
        if (options instanceof ElementHandler) {
            rootHandler = options;
            options = {};
        } else {
            if (typeof options === 'string') {
                rootHandler = this.handler(options);
                options = {};
            } else if (typeof rootHandler === 'string') {
                rootHandler = this.handler(rootHandler);
            }
        }
        var model = this.model, lax = this.lax;
        var context = new Context(assign({}, options, {rootHandler: rootHandler})), parser = new Parser({proxy: true}),
            stack = new tinyStack();
        rootHandler.context = context;
        stack.push(rootHandler);

        function handleError(err, getContext, lax) {
            var ctx = getContext();
            var line = ctx.line, column = ctx.column, data = ctx.data;
            if (data.charAt(0) === '<' && data.indexOf(' ') !== -1) {
                data = data.slice(0, data.indexOf(' ')) + '>';
            }
            var message = 'unparsable content ' + (data ? data + ' ' : '') + 'detected\n\t' + 'line: ' + line + '\n\t' + 'column: ' + column + '\n\t' + 'nested error: ' + err.message;
            if (lax) {
                context.addWarning({message: message, error: err});
                console.warn('could not parse node');
                console.warn(err);
                return true;
            } else {
                console.error('could not parse document');
                console.error(err);
                throw error$1(message);
            }
        }

        function handleWarning(err, getContext) {
            return handleError(err, getContext, true);
        }

        function resolveReferences() {
            var elementsById = context.elementsById;
            var references = context.references;
            var i, r;
            for (i = 0; (r = references[i]); i++) {
                var element = r.element;
                var reference = elementsById[r.id];
                var property = getModdleDescriptor(element).propertiesByName[r.property];
                if (!reference) {
                    context.addWarning({
                        message: 'unresolved reference <' + r.id + '>',
                        element: r.element,
                        property: r.property,
                        value: r.id
                    });
                }
                if (property.isMany) {
                    var collection = element.get(property.name), idx = collection.indexOf(r);
                    if (idx === -1) {
                        idx = collection.length;
                    }
                    if (!reference) {
                        collection.splice(idx, 1);
                    } else {
                        collection[idx] = reference;
                    }
                } else {
                    element.set(property.name, reference);
                }
            }
        }

        function handleClose() {
            stack.pop().handleEnd();
        }

        var PREAMBLE_START_PATTERN = /^<\?xml /i;
        var ENCODING_PATTERN = / encoding="([^"]+)"/i;
        var UTF_8_PATTERN = /^utf-8$/i;

        function handleQuestion(question) {
            if (!PREAMBLE_START_PATTERN.test(question)) {
                return;
            }
            var match = ENCODING_PATTERN.exec(question);
            var encoding = match && match[1];
            if (!encoding || UTF_8_PATTERN.test(encoding)) {
                return;
            }
            context.addWarning({message: 'unsupported document encoding <' + encoding + '>, ' + 'falling back to UTF-8'});
        }

        function handleOpen(node, getContext) {
            var handler = stack.peek();
            try {
                stack.push(handler.handleNode(node));
            } catch (err) {
                if (handleError(err, getContext, lax)) {
                    stack.push(new NoopHandler());
                }
            }
        }

        function handleCData(text) {
            stack.peek().handleText(text);
        }

        function handleText(text) {
            text = text.trim();
            if (!text) {
                return;
            }
            stack.peek().handleText(text);
        }

        var uriMap = model.getPackages().reduce(function (uriMap, p) {
            uriMap[p.uri] = p.prefix;
            return uriMap;
        }, {});
        parser.ns(uriMap).on('openTag', function (obj, decodeStr, selfClosing, getContext) {
            var attrs = obj.attrs || {};
            var decodedAttrs = Object.keys(attrs).reduce(function (d, key) {
                var value = decodeStr(attrs[key]);
                d[key] = value;
                return d;
            }, {});
            var node = {name: obj.name, originalName: obj.originalName, attributes: decodedAttrs, ns: obj.ns};
            handleOpen(node, getContext);
        }).on('question', handleQuestion).on('closeTag', handleClose).on('cdata', handleCData).on('text', function (text, decodeEntities$$1) {
            handleText(decodeEntities$$1(text));
        }).on('error', handleError).on('warn', handleWarning);
        defer(function () {
            var err;
            try {
                parser.parse(xml);
                resolveReferences();
            } catch (e) {
                err = e;
            }
            var element = rootHandler.element;
            if (!err && !element) {
                err = error$1('failed to parse document as <' + rootHandler.type.$descriptor.name + '>');
            }
            done(err, err ? undefined : element, context);
        });
    };
    Reader.prototype.handler = function (name) {
        return new RootElementHandler(this.model, name);
    };
    var XML_PREAMBLE = '<?xml version="1.0" encoding="UTF-8"?>\n';
    var ESCAPE_ATTR_CHARS = /<|>|'|"|&|\n\r|\n/g;
    var ESCAPE_CHARS = /<|>|&/g;

    function Namespaces(parent) {
        var prefixMap = {};
        var uriMap = {};
        var used = {};
        var wellknown = [];
        var custom = [];
        this.byUri = function (uri) {
            return uriMap[uri] || (parent && parent.byUri(uri));
        };
        this.add = function (ns, isWellknown) {
            uriMap[ns.uri] = ns;
            if (isWellknown) {
                wellknown.push(ns);
            } else {
                custom.push(ns);
            }
            this.mapPrefix(ns.prefix, ns.uri);
        };
        this.uriByPrefix = function (prefix) {
            return prefixMap[prefix || 'xmlns'];
        };
        this.mapPrefix = function (prefix, uri) {
            prefixMap[prefix || 'xmlns'] = uri;
        };
        this.logUsed = function (ns) {
            var uri = ns.uri;
            used[uri] = this.byUri(uri);
        };
        this.getUsed = function (ns) {
            function isUsed(ns) {
                return used[ns.uri];
            }

            var allNs = [].concat(wellknown, custom);
            return allNs.filter(isUsed);
        };
    }

    function lower(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    function nameToAlias(name, pkg) {
        if (hasLowerCaseAlias(pkg)) {
            return lower(name);
        } else {
            return name;
        }
    }

    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }

    function nsName(ns) {
        if (isString(ns)) {
            return ns;
        } else {
            return (ns.prefix ? ns.prefix + ':' : '') + ns.localName;
        }
    }

    function getNsAttrs(namespaces) {
        return map(namespaces.getUsed(), function (ns) {
            var name = 'xmlns' + (ns.prefix ? ':' + ns.prefix : '');
            return {name: name, value: ns.uri};
        });
    }

    function getElementNs(ns, descriptor) {
        if (descriptor.isGeneric) {
            return assign({localName: descriptor.ns.localName}, ns);
        } else {
            return assign({localName: nameToAlias(descriptor.ns.localName, descriptor.$pkg)}, ns);
        }
    }

    function getPropertyNs(ns, descriptor) {
        return assign({localName: descriptor.ns.localName}, ns);
    }

    function getSerializableProperties(element) {
        var descriptor = element.$descriptor;
        return filter(descriptor.properties, function (p) {
            var name = p.name;
            if (p.isVirtual) {
                return false;
            }
            if (!element.hasOwnProperty(name)) {
                return false;
            }
            var value = element[name];
            if (value === p.default) {
                return false;
            }
            if (value === null) {
                return false;
            }
            return p.isMany ? value.length : true;
        });
    }

    var ESCAPE_ATTR_MAP = {'\n': '#10', '\n\r': '#10', '"': '#34', '\'': '#39', '<': '#60', '>': '#62', '&': '#38'};
    var ESCAPE_MAP = {'<': 'lt', '>': 'gt', '&': 'amp'};

    function escape$1(str, charPattern, replaceMap) {
        str = isString(str) ? str : '' + str;
        return str.replace(charPattern, function (s) {
            return '&' + replaceMap[s] + ';';
        });
    }

    function escapeAttr(str) {
        return escape$1(str, ESCAPE_ATTR_CHARS, ESCAPE_ATTR_MAP);
    }

    function escapeBody(str) {
        return escape$1(str, ESCAPE_CHARS, ESCAPE_MAP);
    }

    function filterAttributes(props) {
        return filter(props, function (p) {
            return p.isAttr;
        });
    }

    function filterContained(props) {
        return filter(props, function (p) {
            return !p.isAttr;
        });
    }

    function ReferenceSerializer(tagName) {
        this.tagName = tagName;
    }

    ReferenceSerializer.prototype.build = function (element) {
        this.element = element;
        return this;
    };
    ReferenceSerializer.prototype.serializeTo = function (writer) {
        writer.appendIndent().append('<' + this.tagName + '>' + this.element.id + '</' + this.tagName + '>').appendNewLine();
    };

    function BodySerializer() {
    }

    BodySerializer.prototype.serializeValue = BodySerializer.prototype.serializeTo = function (writer) {
        writer.append(this.escape ? escapeBody(this.value) : this.value);
    };
    BodySerializer.prototype.build = function (prop, value) {
        this.value = value;
        if (prop.type === 'String' && value.search(ESCAPE_CHARS) !== -1) {
            this.escape = true;
        }
        return this;
    };

    function ValueSerializer(tagName) {
        this.tagName = tagName;
    }

    inherits(ValueSerializer, BodySerializer);
    ValueSerializer.prototype.serializeTo = function (writer) {
        writer.appendIndent().append('<' + this.tagName + '>');
        this.serializeValue(writer);
        writer.append('</' + this.tagName + '>').appendNewLine();
    };

    function ElementSerializer(parent, propertyDescriptor) {
        this.body = [];
        this.attrs = [];
        this.parent = parent;
        this.propertyDescriptor = propertyDescriptor;
    }

    ElementSerializer.prototype.build = function (element) {
        this.element = element;
        var elementDescriptor = element.$descriptor, propertyDescriptor = this.propertyDescriptor;
        var otherAttrs, properties;
        var isGeneric = elementDescriptor.isGeneric;
        if (isGeneric) {
            otherAttrs = this.parseGeneric(element);
        } else {
            otherAttrs = this.parseNsAttributes(element);
        }
        if (propertyDescriptor) {
            this.ns = this.nsPropertyTagName(propertyDescriptor);
        } else {
            this.ns = this.nsTagName(elementDescriptor);
        }
        this.tagName = this.addTagName(this.ns);
        if (!isGeneric) {
            properties = getSerializableProperties(element);
            this.parseAttributes(filterAttributes(properties));
            this.parseContainments(filterContained(properties));
        }
        this.parseGenericAttributes(element, otherAttrs);
        return this;
    };
    ElementSerializer.prototype.nsTagName = function (descriptor) {
        var effectiveNs = this.logNamespaceUsed(descriptor.ns);
        return getElementNs(effectiveNs, descriptor);
    };
    ElementSerializer.prototype.nsPropertyTagName = function (descriptor) {
        var effectiveNs = this.logNamespaceUsed(descriptor.ns);
        return getPropertyNs(effectiveNs, descriptor);
    };
    ElementSerializer.prototype.isLocalNs = function (ns) {
        return ns.uri === this.ns.uri;
    };
    ElementSerializer.prototype.nsAttributeName = function (element) {
        var ns;
        if (isString(element)) {
            ns = parseName(element);
        } else {
            ns = element.ns;
        }
        if (element.inherited) {
            return {localName: ns.localName};
        }
        var effectiveNs = this.logNamespaceUsed(ns);
        this.getNamespaces().logUsed(effectiveNs);
        if (this.isLocalNs(effectiveNs)) {
            return {localName: ns.localName};
        } else {
            return assign({localName: ns.localName}, effectiveNs);
        }
    };
    ElementSerializer.prototype.parseGeneric = function (element) {
        var self = this, body = this.body;
        var attributes = [];
        forEach(element, function (val, key) {
            var nonNsAttr;
            if (key === '$body') {
                body.push(new BodySerializer().build({type: 'String'}, val));
            } else if (key === '$children') {
                forEach(val, function (child) {
                    body.push(new ElementSerializer(self).build(child));
                });
            } else if (key.indexOf('$') !== 0) {
                nonNsAttr = self.parseNsAttribute(element, key, val);
                if (nonNsAttr) {
                    attributes.push({name: key, value: val});
                }
            }
        });
        return attributes;
    };
    ElementSerializer.prototype.parseNsAttribute = function (element, name, value) {
        var model = element.$model;
        var nameNs = parseName(name);
        var ns;
        if (nameNs.prefix === 'xmlns') {
            ns = {prefix: nameNs.localName, uri: value};
        }
        if (!nameNs.prefix && nameNs.localName === 'xmlns') {
            ns = {uri: value};
        }
        if (!ns) {
            return {name: name, value: value};
        }
        if (model && model.getPackage(value)) {
            this.logNamespace(ns, true, true);
        } else {
            var actualNs = this.logNamespaceUsed(ns, true);
            this.getNamespaces().logUsed(actualNs);
        }
    };
    ElementSerializer.prototype.parseNsAttributes = function (element, attrs) {
        var self = this;
        var genericAttrs = element.$attrs;
        var attributes = [];
        forEach(genericAttrs, function (value, name) {
            var nonNsAttr = self.parseNsAttribute(element, name, value);
            if (nonNsAttr) {
                attributes.push(nonNsAttr);
            }
        });
        return attributes;
    };
    ElementSerializer.prototype.parseGenericAttributes = function (element, attributes) {
        var self = this;
        forEach(attributes, function (attr) {
            if (attr.name === XSI_TYPE$1) {
                return;
            }
            try {
                self.addAttribute(self.nsAttributeName(attr.name), attr.value);
            } catch (e) {
                console.warn('missing namespace information for ', attr.name, '=', attr.value, 'on', element, e);
            }
        });
    };
    ElementSerializer.prototype.parseContainments = function (properties) {
        var self = this, body = this.body, element = this.element;
        forEach(properties, function (p) {
            var value = element.get(p.name), isReference = p.isReference, isMany = p.isMany;
            if (!isMany) {
                value = [value];
            }
            if (p.isBody) {
                body.push(new BodySerializer().build(p, value[0]));
            } else if (isSimple(p.type)) {
                forEach(value, function (v) {
                    body.push(new ValueSerializer(self.addTagName(self.nsPropertyTagName(p))).build(p, v));
                });
            } else if (isReference) {
                forEach(value, function (v) {
                    body.push(new ReferenceSerializer(self.addTagName(self.nsPropertyTagName(p))).build(v));
                });
            } else {
                var asType = serializeAsType(p), asProperty = serializeAsProperty(p);
                forEach(value, function (v) {
                    var serializer;
                    if (asType) {
                        serializer = new TypeSerializer(self, p);
                    } else if (asProperty) {
                        serializer = new ElementSerializer(self, p);
                    } else {
                        serializer = new ElementSerializer(self);
                    }
                    body.push(serializer.build(v));
                });
            }
        });
    };
    ElementSerializer.prototype.getNamespaces = function (local) {
        var namespaces = this.namespaces, parent = this.parent, parentNamespaces;
        if (!namespaces) {
            parentNamespaces = parent && parent.getNamespaces();
            if (local || !parentNamespaces) {
                this.namespaces = namespaces = new Namespaces(parentNamespaces);
            } else {
                namespaces = parentNamespaces;
            }
        }
        return namespaces;
    };
    ElementSerializer.prototype.logNamespace = function (ns, wellknown, local) {
        var namespaces = this.getNamespaces(local);
        var nsUri = ns.uri, nsPrefix = ns.prefix;
        var existing = namespaces.byUri(nsUri);
        if (!existing) {
            namespaces.add(ns, wellknown);
        }
        namespaces.mapPrefix(nsPrefix, nsUri);
        return ns;
    };
    ElementSerializer.prototype.logNamespaceUsed = function (ns, local) {
        var element = this.element, model = element.$model, namespaces = this.getNamespaces(local);
        var prefix = ns.prefix, uri = ns.uri, newPrefix, idx, wellknownUri;
        if (!prefix && !uri) {
            return {localName: ns.localName};
        }
        wellknownUri = DEFAULT_NS_MAP[prefix] || model && (model.getPackage(prefix) || {}).uri;
        uri = uri || wellknownUri || namespaces.uriByPrefix(prefix);
        if (!uri) {
            throw new Error('no namespace uri given for prefix <' + prefix + '>');
        }
        ns = namespaces.byUri(uri);
        if (!ns) {
            newPrefix = prefix;
            idx = 1;
            while (namespaces.uriByPrefix(newPrefix)) {
                newPrefix = prefix + '_' + idx++;
            }
            ns = this.logNamespace({prefix: newPrefix, uri: uri}, wellknownUri === uri);
        }
        if (prefix) {
            namespaces.mapPrefix(prefix, uri);
        }
        return ns;
    };
    ElementSerializer.prototype.parseAttributes = function (properties) {
        var self = this, element = this.element;
        forEach(properties, function (p) {
            var value = element.get(p.name);
            if (p.isReference) {
                if (!p.isMany) {
                    value = value.id;
                } else {
                    var values$$1 = [];
                    forEach(value, function (v) {
                        values$$1.push(v.id);
                    });
                    value = values$$1.join(' ');
                }
            }
            self.addAttribute(self.nsAttributeName(p), value);
        });
    };
    ElementSerializer.prototype.addTagName = function (nsTagName) {
        var actualNs = this.logNamespaceUsed(nsTagName);
        this.getNamespaces().logUsed(actualNs);
        return nsName(nsTagName);
    };
    ElementSerializer.prototype.addAttribute = function (name, value) {
        var attrs = this.attrs;
        if (isString(value)) {
            value = escapeAttr(value);
        }
        attrs.push({name: name, value: value});
    };
    ElementSerializer.prototype.serializeAttributes = function (writer) {
        var attrs = this.attrs, namespaces = this.namespaces;
        if (namespaces) {
            attrs = getNsAttrs(namespaces).concat(attrs);
        }
        forEach(attrs, function (a) {
            writer.append(' ').append(nsName(a.name)).append('="').append(a.value).append('"');
        });
    };
    ElementSerializer.prototype.serializeTo = function (writer) {
        var firstBody = this.body[0], indent = firstBody && firstBody.constructor !== BodySerializer;
        writer.appendIndent().append('<' + this.tagName);
        this.serializeAttributes(writer);
        writer.append(firstBody ? '>' : ' />');
        if (firstBody) {
            if (indent) {
                writer.appendNewLine().indent();
            }
            forEach(this.body, function (b) {
                b.serializeTo(writer);
            });
            if (indent) {
                writer.unindent().appendIndent();
            }
            writer.append('</' + this.tagName + '>');
        }
        writer.appendNewLine();
    };

    function TypeSerializer(parent, propertyDescriptor) {
        ElementSerializer.call(this, parent, propertyDescriptor);
    }

    inherits(TypeSerializer, ElementSerializer);
    TypeSerializer.prototype.parseNsAttributes = function (element) {
        var attributes = ElementSerializer.prototype.parseNsAttributes.call(this, element);
        var descriptor = element.$descriptor;
        if (descriptor.name === this.propertyDescriptor.type) {
            return attributes;
        }
        var typeNs = this.typeNs = this.nsTagName(descriptor);
        this.getNamespaces().logUsed(this.typeNs);
        var pkg = element.$model.getPackage(typeNs.uri), typePrefix = (pkg.xml && pkg.xml.typePrefix) || '';
        this.addAttribute(this.nsAttributeName(XSI_TYPE$1), (typeNs.prefix ? typeNs.prefix + ':' : '') + typePrefix + descriptor.ns.localName);
        return attributes;
    };
    TypeSerializer.prototype.isLocalNs = function (ns) {
        return ns.uri === (this.typeNs || this.ns).uri;
    };

    function SavingWriter() {
        this.value = '';
        this.write = function (str) {
            this.value += str;
        };
    }

    function FormatingWriter(out, format) {
        var indent = [''];
        this.append = function (str) {
            out.write(str);
            return this;
        };
        this.appendNewLine = function () {
            if (format) {
                out.write('\n');
            }
            return this;
        };
        this.appendIndent = function () {
            if (format) {
                out.write(indent.join('  '));
            }
            return this;
        };
        this.indent = function () {
            indent.push('');
            return this;
        };
        this.unindent = function () {
            indent.pop();
            return this;
        };
    }

    function Writer(options) {
        options = assign({format: false, preamble: true}, options || {});

        function toXML(tree, writer) {
            var internalWriter = writer || new SavingWriter();
            var formatingWriter = new FormatingWriter(internalWriter, options.format);
            if (options.preamble) {
                formatingWriter.append(XML_PREAMBLE);
            }
            new ElementSerializer().build(tree).serializeTo(formatingWriter);
            if (!writer) {
                return internalWriter.value;
            }
        }

        return {toXML: toXML};
    }

    function BpmnModdle(packages, options) {
        Moddle.call(this, packages, options);
    }

    BpmnModdle.prototype = Object.create(Moddle.prototype);
    BpmnModdle.prototype.fromXML = function (xmlStr, typeName, options, done) {
        if (!isString(typeName)) {
            done = options;
            options = typeName;
            typeName = 'bpmn:Definitions';
        }
        if (isFunction(options)) {
            done = options;
            options = {};
        }
        var reader = new Reader(assign({model: this, lax: true}, options));
        var rootHandler = reader.handler(typeName);
        reader.fromXML(xmlStr, rootHandler, done);
    };
    BpmnModdle.prototype.toXML = function (element, options, done) {
        if (isFunction(options)) {
            done = options;
            options = {};
        }
        var writer = new Writer(options);
        var result;
        var err;
        try {
            result = writer.toXML(element);
        } catch (e) {
            err = e;
        }
        return done(err, result);
    };
    var name = "BPMN20";
    var uri = "http://www.omg.org/spec/BPMN/20100524/MODEL";
    var associations = [];
    var types$1 = [{
        name: "Interface",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "operations",
            type: "Operation",
            isMany: true
        }, {name: "implementationRef", type: "String", isAttr: true}]
    }, {
        name: "Operation",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "inMessageRef",
            type: "Message",
            isReference: true
        }, {name: "outMessageRef", type: "Message", isReference: true}, {
            name: "errorRef",
            type: "Error",
            isMany: true,
            isReference: true
        }, {name: "implementationRef", type: "String", isAttr: true}]
    }, {name: "EndPoint", superClass: ["RootElement"]}, {
        name: "Auditing",
        superClass: ["BaseElement"]
    }, {
        name: "GlobalTask",
        superClass: ["CallableElement"],
        properties: [{name: "resources", type: "ResourceRole", isMany: true}]
    }, {name: "Monitoring", superClass: ["BaseElement"]}, {
        name: "Performer",
        superClass: ["ResourceRole"]
    }, {
        name: "Process",
        superClass: ["FlowElementsContainer", "CallableElement"],
        properties: [{name: "processType", type: "ProcessType", isAttr: true}, {
            name: "isClosed",
            isAttr: true,
            type: "Boolean"
        }, {name: "auditing", type: "Auditing"}, {name: "monitoring", type: "Monitoring"}, {
            name: "properties",
            type: "Property",
            isMany: true
        }, {
            name: "laneSets",
            type: "LaneSet",
            isMany: true,
            replaces: "FlowElementsContainer#laneSets"
        }, {
            name: "flowElements",
            type: "FlowElement",
            isMany: true,
            replaces: "FlowElementsContainer#flowElements"
        }, {name: "artifacts", type: "Artifact", isMany: true}, {
            name: "resources",
            type: "ResourceRole",
            isMany: true
        }, {name: "correlationSubscriptions", type: "CorrelationSubscription", isMany: true}, {
            name: "supports",
            type: "Process",
            isMany: true,
            isReference: true
        }, {
            name: "definitionalCollaborationRef",
            type: "Collaboration",
            isAttr: true,
            isReference: true
        }, {name: "isExecutable", isAttr: true, type: "Boolean"}]
    }, {
        name: "LaneSet",
        superClass: ["BaseElement"],
        properties: [{name: "lanes", type: "Lane", isMany: true}, {name: "name", isAttr: true, type: "String"}]
    }, {
        name: "Lane",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "partitionElementRef",
            type: "BaseElement",
            isAttr: true,
            isReference: true
        }, {name: "partitionElement", type: "BaseElement"}, {
            name: "flowNodeRef",
            type: "FlowNode",
            isMany: true,
            isReference: true
        }, {name: "childLaneSet", type: "LaneSet", xml: {serialize: "xsi:type"}}]
    }, {name: "GlobalManualTask", superClass: ["GlobalTask"]}, {
        name: "ManualTask",
        superClass: ["Task"]
    }, {
        name: "UserTask",
        superClass: ["Task"],
        properties: [{name: "renderings", type: "Rendering", isMany: true}, {
            name: "implementation",
            isAttr: true,
            type: "String"
        }]
    }, {name: "Rendering", superClass: ["BaseElement"]}, {
        name: "HumanPerformer",
        superClass: ["Performer"]
    }, {name: "PotentialOwner", superClass: ["HumanPerformer"]}, {
        name: "GlobalUserTask",
        superClass: ["GlobalTask"],
        properties: [{name: "implementation", isAttr: true, type: "String"}, {
            name: "renderings",
            type: "Rendering",
            isMany: true
        }]
    }, {
        name: "Gateway",
        isAbstract: true,
        superClass: ["FlowNode"],
        properties: [{name: "gatewayDirection", type: "GatewayDirection", "default": "Unspecified", isAttr: true}]
    }, {
        name: "EventBasedGateway",
        superClass: ["Gateway"],
        properties: [{name: "instantiate", "default": false, isAttr: true, type: "Boolean"}, {
            name: "eventGatewayType",
            type: "EventBasedGatewayType",
            isAttr: true,
            "default": "Exclusive"
        }]
    }, {
        name: "ComplexGateway",
        superClass: ["Gateway"],
        properties: [{name: "activationCondition", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "default",
            type: "SequenceFlow",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ExclusiveGateway",
        superClass: ["Gateway"],
        properties: [{name: "default", type: "SequenceFlow", isAttr: true, isReference: true}]
    }, {
        name: "InclusiveGateway",
        superClass: ["Gateway"],
        properties: [{name: "default", type: "SequenceFlow", isAttr: true, isReference: true}]
    }, {name: "ParallelGateway", superClass: ["Gateway"]}, {
        name: "RootElement",
        isAbstract: true,
        superClass: ["BaseElement"]
    }, {
        name: "Relationship",
        superClass: ["BaseElement"],
        properties: [{name: "type", isAttr: true, type: "String"}, {
            name: "direction",
            type: "RelationshipDirection",
            isAttr: true
        }, {name: "source", isMany: true, isReference: true, type: "Element"}, {
            name: "target",
            isMany: true,
            isReference: true,
            type: "Element"
        }]
    }, {
        name: "BaseElement",
        isAbstract: true,
        properties: [{name: "id", isAttr: true, type: "String", isId: true}, {
            name: "documentation",
            type: "Documentation",
            isMany: true
        }, {
            name: "extensionDefinitions",
            type: "ExtensionDefinition",
            isMany: true,
            isReference: true
        }, {name: "extensionElements", type: "ExtensionElements"}]
    }, {
        name: "Extension",
        properties: [{name: "mustUnderstand", "default": false, isAttr: true, type: "Boolean"}, {
            name: "definition",
            type: "ExtensionDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ExtensionDefinition",
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "extensionAttributeDefinitions",
            type: "ExtensionAttributeDefinition",
            isMany: true
        }]
    }, {
        name: "ExtensionAttributeDefinition",
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "type",
            isAttr: true,
            type: "String"
        }, {name: "isReference", "default": false, isAttr: true, type: "Boolean"}, {
            name: "extensionDefinition",
            type: "ExtensionDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ExtensionElements",
        properties: [{name: "valueRef", isAttr: true, isReference: true, type: "Element"}, {
            name: "values",
            type: "Element",
            isMany: true
        }, {
            name: "extensionAttributeDefinition",
            type: "ExtensionAttributeDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "Documentation",
        superClass: ["BaseElement"],
        properties: [{name: "text", type: "String", isBody: true}, {
            name: "textFormat",
            "default": "text/plain",
            isAttr: true,
            type: "String"
        }]
    }, {
        name: "Event",
        isAbstract: true,
        superClass: ["FlowNode", "InteractionNode"],
        properties: [{name: "properties", type: "Property", isMany: true}]
    }, {name: "IntermediateCatchEvent", superClass: ["CatchEvent"]}, {
        name: "IntermediateThrowEvent",
        superClass: ["ThrowEvent"]
    }, {name: "EndEvent", superClass: ["ThrowEvent"]}, {
        name: "StartEvent",
        superClass: ["CatchEvent"],
        properties: [{name: "isInterrupting", "default": true, isAttr: true, type: "Boolean"}]
    }, {
        name: "ThrowEvent",
        isAbstract: true,
        superClass: ["Event"],
        properties: [{name: "dataInputs", type: "DataInput", isMany: true}, {
            name: "dataInputAssociations",
            type: "DataInputAssociation",
            isMany: true
        }, {name: "inputSet", type: "InputSet"}, {
            name: "eventDefinitions",
            type: "EventDefinition",
            isMany: true
        }, {name: "eventDefinitionRef", type: "EventDefinition", isMany: true, isReference: true}]
    }, {
        name: "CatchEvent",
        isAbstract: true,
        superClass: ["Event"],
        properties: [{name: "parallelMultiple", isAttr: true, type: "Boolean", "default": false}, {
            name: "dataOutputs",
            type: "DataOutput",
            isMany: true
        }, {name: "dataOutputAssociations", type: "DataOutputAssociation", isMany: true}, {
            name: "outputSet",
            type: "OutputSet"
        }, {name: "eventDefinitions", type: "EventDefinition", isMany: true}, {
            name: "eventDefinitionRef",
            type: "EventDefinition",
            isMany: true,
            isReference: true
        }]
    }, {
        name: "BoundaryEvent",
        superClass: ["CatchEvent"],
        properties: [{name: "cancelActivity", "default": true, isAttr: true, type: "Boolean"}, {
            name: "attachedToRef",
            type: "Activity",
            isAttr: true,
            isReference: true
        }]
    }, {name: "EventDefinition", isAbstract: true, superClass: ["RootElement"]}, {
        name: "CancelEventDefinition",
        superClass: ["EventDefinition"]
    }, {
        name: "ErrorEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "errorRef", type: "Error", isAttr: true, isReference: true}]
    }, {name: "TerminateEventDefinition", superClass: ["EventDefinition"]}, {
        name: "EscalationEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "escalationRef", type: "Escalation", isAttr: true, isReference: true}]
    }, {
        name: "Escalation",
        properties: [{name: "structureRef", type: "ItemDefinition", isAttr: true, isReference: true}, {
            name: "name",
            isAttr: true,
            type: "String"
        }, {name: "escalationCode", isAttr: true, type: "String"}],
        superClass: ["RootElement"]
    }, {
        name: "CompensateEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "waitForCompletion", isAttr: true, type: "Boolean", "default": true}, {
            name: "activityRef",
            type: "Activity",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "TimerEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "timeDate", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "timeCycle",
            type: "Expression",
            xml: {serialize: "xsi:type"}
        }, {name: "timeDuration", type: "Expression", xml: {serialize: "xsi:type"}}]
    }, {
        name: "LinkEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "target",
            type: "LinkEventDefinition",
            isAttr: true,
            isReference: true
        }, {name: "source", type: "LinkEventDefinition", isMany: true, isReference: true}]
    }, {
        name: "MessageEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "messageRef", type: "Message", isAttr: true, isReference: true}, {
            name: "operationRef",
            type: "Operation",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ConditionalEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "condition", type: "Expression", xml: {serialize: "xsi:type"}}]
    }, {
        name: "SignalEventDefinition",
        superClass: ["EventDefinition"],
        properties: [{name: "signalRef", type: "Signal", isAttr: true, isReference: true}]
    }, {
        name: "Signal",
        superClass: ["RootElement"],
        properties: [{name: "structureRef", type: "ItemDefinition", isAttr: true, isReference: true}, {
            name: "name",
            isAttr: true,
            type: "String"
        }]
    }, {name: "ImplicitThrowEvent", superClass: ["ThrowEvent"]}, {
        name: "DataState",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}]
    }, {
        name: "ItemAwareElement",
        superClass: ["BaseElement"],
        properties: [{
            name: "itemSubjectRef",
            type: "ItemDefinition",
            isAttr: true,
            isReference: true
        }, {name: "dataState", type: "DataState"}]
    }, {
        name: "DataAssociation",
        superClass: ["BaseElement"],
        properties: [{name: "assignment", type: "Assignment", isMany: true}, {
            name: "sourceRef",
            type: "ItemAwareElement",
            isMany: true,
            isReference: true
        }, {name: "targetRef", type: "ItemAwareElement", isReference: true}, {
            name: "transformation",
            type: "FormalExpression",
            xml: {serialize: "property"}
        }]
    }, {
        name: "DataInput",
        superClass: ["ItemAwareElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "isCollection",
            "default": false,
            isAttr: true,
            type: "Boolean"
        }, {
            name: "inputSetRef",
            type: "InputSet",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {
            name: "inputSetWithOptional",
            type: "InputSet",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {name: "inputSetWithWhileExecuting", type: "InputSet", isVirtual: true, isMany: true, isReference: true}]
    }, {
        name: "DataOutput",
        superClass: ["ItemAwareElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "isCollection",
            "default": false,
            isAttr: true,
            type: "Boolean"
        }, {
            name: "outputSetRef",
            type: "OutputSet",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {
            name: "outputSetWithOptional",
            type: "OutputSet",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {name: "outputSetWithWhileExecuting", type: "OutputSet", isVirtual: true, isMany: true, isReference: true}]
    }, {
        name: "InputSet",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "dataInputRefs",
            type: "DataInput",
            isMany: true,
            isReference: true
        }, {
            name: "optionalInputRefs",
            type: "DataInput",
            isMany: true,
            isReference: true
        }, {
            name: "whileExecutingInputRefs",
            type: "DataInput",
            isMany: true,
            isReference: true
        }, {name: "outputSetRefs", type: "OutputSet", isMany: true, isReference: true}]
    }, {
        name: "OutputSet",
        superClass: ["BaseElement"],
        properties: [{name: "dataOutputRefs", type: "DataOutput", isMany: true, isReference: true}, {
            name: "name",
            isAttr: true,
            type: "String"
        }, {name: "inputSetRefs", type: "InputSet", isMany: true, isReference: true}, {
            name: "optionalOutputRefs",
            type: "DataOutput",
            isMany: true,
            isReference: true
        }, {name: "whileExecutingOutputRefs", type: "DataOutput", isMany: true, isReference: true}]
    }, {
        name: "Property",
        superClass: ["ItemAwareElement"],
        properties: [{name: "name", isAttr: true, type: "String"}]
    }, {name: "DataInputAssociation", superClass: ["DataAssociation"]}, {
        name: "DataOutputAssociation",
        superClass: ["DataAssociation"]
    }, {
        name: "InputOutputSpecification",
        superClass: ["BaseElement"],
        properties: [{name: "dataInputs", type: "DataInput", isMany: true}, {
            name: "dataOutputs",
            type: "DataOutput",
            isMany: true
        }, {name: "inputSets", type: "InputSet", isMany: true}, {name: "outputSets", type: "OutputSet", isMany: true}]
    }, {
        name: "DataObject",
        superClass: ["FlowElement", "ItemAwareElement"],
        properties: [{name: "isCollection", "default": false, isAttr: true, type: "Boolean"}]
    }, {
        name: "InputOutputBinding",
        properties: [{name: "inputDataRef", type: "InputSet", isAttr: true, isReference: true}, {
            name: "outputDataRef",
            type: "OutputSet",
            isAttr: true,
            isReference: true
        }, {name: "operationRef", type: "Operation", isAttr: true, isReference: true}]
    }, {
        name: "Assignment",
        superClass: ["BaseElement"],
        properties: [{name: "from", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "to",
            type: "Expression",
            xml: {serialize: "xsi:type"}
        }]
    }, {
        name: "DataStore",
        superClass: ["RootElement", "ItemAwareElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "capacity",
            isAttr: true,
            type: "Integer"
        }, {name: "isUnlimited", "default": true, isAttr: true, type: "Boolean"}]
    }, {
        name: "DataStoreReference",
        superClass: ["ItemAwareElement", "FlowElement"],
        properties: [{name: "dataStoreRef", type: "DataStore", isAttr: true, isReference: true}]
    }, {
        name: "DataObjectReference",
        superClass: ["ItemAwareElement", "FlowElement"],
        properties: [{name: "dataObjectRef", type: "DataObject", isAttr: true, isReference: true}]
    }, {
        name: "ConversationLink",
        superClass: ["BaseElement"],
        properties: [{name: "sourceRef", type: "InteractionNode", isAttr: true, isReference: true}, {
            name: "targetRef",
            type: "InteractionNode",
            isAttr: true,
            isReference: true
        }, {name: "name", isAttr: true, type: "String"}]
    }, {
        name: "ConversationAssociation",
        superClass: ["BaseElement"],
        properties: [{
            name: "innerConversationNodeRef",
            type: "ConversationNode",
            isAttr: true,
            isReference: true
        }, {name: "outerConversationNodeRef", type: "ConversationNode", isAttr: true, isReference: true}]
    }, {
        name: "CallConversation",
        superClass: ["ConversationNode"],
        properties: [{
            name: "calledCollaborationRef",
            type: "Collaboration",
            isAttr: true,
            isReference: true
        }, {name: "participantAssociations", type: "ParticipantAssociation", isMany: true}]
    }, {name: "Conversation", superClass: ["ConversationNode"]}, {
        name: "SubConversation",
        superClass: ["ConversationNode"],
        properties: [{name: "conversationNodes", type: "ConversationNode", isMany: true}]
    }, {
        name: "ConversationNode",
        isAbstract: true,
        superClass: ["InteractionNode", "BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "participantRef",
            type: "Participant",
            isMany: true,
            isReference: true
        }, {name: "messageFlowRefs", type: "MessageFlow", isMany: true, isReference: true}, {
            name: "correlationKeys",
            type: "CorrelationKey",
            isMany: true
        }]
    }, {name: "GlobalConversation", superClass: ["Collaboration"]}, {
        name: "PartnerEntity",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "participantRef",
            type: "Participant",
            isMany: true,
            isReference: true
        }]
    }, {
        name: "PartnerRole",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "participantRef",
            type: "Participant",
            isMany: true,
            isReference: true
        }]
    }, {
        name: "CorrelationProperty",
        superClass: ["RootElement"],
        properties: [{
            name: "correlationPropertyRetrievalExpression",
            type: "CorrelationPropertyRetrievalExpression",
            isMany: true
        }, {name: "name", isAttr: true, type: "String"}, {
            name: "type",
            type: "ItemDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "Error",
        superClass: ["RootElement"],
        properties: [{name: "structureRef", type: "ItemDefinition", isAttr: true, isReference: true}, {
            name: "name",
            isAttr: true,
            type: "String"
        }, {name: "errorCode", isAttr: true, type: "String"}]
    }, {
        name: "CorrelationKey",
        superClass: ["BaseElement"],
        properties: [{
            name: "correlationPropertyRef",
            type: "CorrelationProperty",
            isMany: true,
            isReference: true
        }, {name: "name", isAttr: true, type: "String"}]
    }, {
        name: "Expression",
        superClass: ["BaseElement"],
        isAbstract: false,
        properties: [{name: "body", type: "String", isBody: true}]
    }, {
        name: "FormalExpression",
        superClass: ["Expression"],
        properties: [{name: "language", isAttr: true, type: "String"}, {
            name: "evaluatesToTypeRef",
            type: "ItemDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "Message",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "itemRef",
            type: "ItemDefinition",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ItemDefinition",
        superClass: ["RootElement"],
        properties: [{name: "itemKind", type: "ItemKind", isAttr: true}, {
            name: "structureRef",
            type: "String",
            isAttr: true
        }, {name: "isCollection", "default": false, isAttr: true, type: "Boolean"}, {
            name: "import",
            type: "Import",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "FlowElement",
        isAbstract: true,
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "auditing",
            type: "Auditing"
        }, {name: "monitoring", type: "Monitoring"}, {
            name: "categoryValueRef",
            type: "CategoryValue",
            isMany: true,
            isReference: true
        }]
    }, {
        name: "SequenceFlow",
        superClass: ["FlowElement"],
        properties: [{name: "isImmediate", isAttr: true, type: "Boolean"}, {
            name: "conditionExpression",
            type: "Expression",
            xml: {serialize: "xsi:type"}
        }, {name: "sourceRef", type: "FlowNode", isAttr: true, isReference: true}, {
            name: "targetRef",
            type: "FlowNode",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "FlowElementsContainer",
        isAbstract: true,
        superClass: ["BaseElement"],
        properties: [{name: "laneSets", type: "LaneSet", isMany: true}, {
            name: "flowElements",
            type: "FlowElement",
            isMany: true
        }]
    }, {
        name: "CallableElement",
        isAbstract: true,
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "ioSpecification",
            type: "InputOutputSpecification",
            xml: {serialize: "property"}
        }, {name: "supportedInterfaceRef", type: "Interface", isMany: true, isReference: true}, {
            name: "ioBinding",
            type: "InputOutputBinding",
            isMany: true,
            xml: {serialize: "property"}
        }]
    }, {
        name: "FlowNode",
        isAbstract: true,
        superClass: ["FlowElement"],
        properties: [{name: "incoming", type: "SequenceFlow", isMany: true, isReference: true}, {
            name: "outgoing",
            type: "SequenceFlow",
            isMany: true,
            isReference: true
        }, {name: "lanes", type: "Lane", isVirtual: true, isMany: true, isReference: true}]
    }, {
        name: "CorrelationPropertyRetrievalExpression",
        superClass: ["BaseElement"],
        properties: [{name: "messagePath", type: "FormalExpression"}, {
            name: "messageRef",
            type: "Message",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "CorrelationPropertyBinding",
        superClass: ["BaseElement"],
        properties: [{name: "dataPath", type: "FormalExpression"}, {
            name: "correlationPropertyRef",
            type: "CorrelationProperty",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "Resource",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "resourceParameters",
            type: "ResourceParameter",
            isMany: true
        }]
    }, {
        name: "ResourceParameter",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "isRequired",
            isAttr: true,
            type: "Boolean"
        }, {name: "type", type: "ItemDefinition", isAttr: true, isReference: true}]
    }, {
        name: "CorrelationSubscription",
        superClass: ["BaseElement"],
        properties: [{
            name: "correlationKeyRef",
            type: "CorrelationKey",
            isAttr: true,
            isReference: true
        }, {name: "correlationPropertyBinding", type: "CorrelationPropertyBinding", isMany: true}]
    }, {
        name: "MessageFlow",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "sourceRef",
            type: "InteractionNode",
            isAttr: true,
            isReference: true
        }, {name: "targetRef", type: "InteractionNode", isAttr: true, isReference: true}, {
            name: "messageRef",
            type: "Message",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "MessageFlowAssociation",
        superClass: ["BaseElement"],
        properties: [{
            name: "innerMessageFlowRef",
            type: "MessageFlow",
            isAttr: true,
            isReference: true
        }, {name: "outerMessageFlowRef", type: "MessageFlow", isAttr: true, isReference: true}]
    }, {
        name: "InteractionNode",
        isAbstract: true,
        properties: [{
            name: "incomingConversationLinks",
            type: "ConversationLink",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {
            name: "outgoingConversationLinks",
            type: "ConversationLink",
            isVirtual: true,
            isMany: true,
            isReference: true
        }]
    }, {
        name: "Participant",
        superClass: ["InteractionNode", "BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "interfaceRef",
            type: "Interface",
            isMany: true,
            isReference: true
        }, {name: "participantMultiplicity", type: "ParticipantMultiplicity"}, {
            name: "endPointRefs",
            type: "EndPoint",
            isMany: true,
            isReference: true
        }, {name: "processRef", type: "Process", isAttr: true, isReference: true}]
    }, {
        name: "ParticipantAssociation",
        superClass: ["BaseElement"],
        properties: [{
            name: "innerParticipantRef",
            type: "Participant",
            isAttr: true,
            isReference: true
        }, {name: "outerParticipantRef", type: "Participant", isAttr: true, isReference: true}]
    }, {
        name: "ParticipantMultiplicity",
        properties: [{name: "minimum", "default": 0, isAttr: true, type: "Integer"}, {
            name: "maximum",
            "default": 1,
            isAttr: true,
            type: "Integer"
        }],
        superClass: ["BaseElement"]
    }, {
        name: "Collaboration",
        superClass: ["RootElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "isClosed",
            isAttr: true,
            type: "Boolean"
        }, {name: "participants", type: "Participant", isMany: true}, {
            name: "messageFlows",
            type: "MessageFlow",
            isMany: true
        }, {name: "artifacts", type: "Artifact", isMany: true}, {
            name: "conversations",
            type: "ConversationNode",
            isMany: true
        }, {name: "conversationAssociations", type: "ConversationAssociation"}, {
            name: "participantAssociations",
            type: "ParticipantAssociation",
            isMany: true
        }, {name: "messageFlowAssociations", type: "MessageFlowAssociation", isMany: true}, {
            name: "correlationKeys",
            type: "CorrelationKey",
            isMany: true
        }, {name: "choreographyRef", type: "Choreography", isMany: true, isReference: true}, {
            name: "conversationLinks",
            type: "ConversationLink",
            isMany: true
        }]
    }, {
        name: "ChoreographyActivity",
        isAbstract: true,
        superClass: ["FlowNode"],
        properties: [{
            name: "participantRef",
            type: "Participant",
            isMany: true,
            isReference: true
        }, {
            name: "initiatingParticipantRef",
            type: "Participant",
            isAttr: true,
            isReference: true
        }, {name: "correlationKeys", type: "CorrelationKey", isMany: true}, {
            name: "loopType",
            type: "ChoreographyLoopType",
            "default": "None",
            isAttr: true
        }]
    }, {
        name: "CallChoreography",
        superClass: ["ChoreographyActivity"],
        properties: [{
            name: "calledChoreographyRef",
            type: "Choreography",
            isAttr: true,
            isReference: true
        }, {name: "participantAssociations", type: "ParticipantAssociation", isMany: true}]
    }, {
        name: "SubChoreography",
        superClass: ["ChoreographyActivity", "FlowElementsContainer"],
        properties: [{name: "artifacts", type: "Artifact", isMany: true}]
    }, {
        name: "ChoreographyTask",
        superClass: ["ChoreographyActivity"],
        properties: [{name: "messageFlowRef", type: "MessageFlow", isMany: true, isReference: true}]
    }, {name: "Choreography", superClass: ["Collaboration", "FlowElementsContainer"]}, {
        name: "GlobalChoreographyTask",
        superClass: ["Choreography"],
        properties: [{name: "initiatingParticipantRef", type: "Participant", isAttr: true, isReference: true}]
    }, {
        name: "TextAnnotation",
        superClass: ["Artifact"],
        properties: [{name: "text", type: "String"}, {
            name: "textFormat",
            "default": "text/plain",
            isAttr: true,
            type: "String"
        }]
    }, {
        name: "Group",
        superClass: ["Artifact"],
        properties: [{name: "categoryValueRef", type: "CategoryValue", isAttr: true, isReference: true}]
    }, {
        name: "Association",
        superClass: ["Artifact"],
        properties: [{name: "associationDirection", type: "AssociationDirection", isAttr: true}, {
            name: "sourceRef",
            type: "BaseElement",
            isAttr: true,
            isReference: true
        }, {name: "targetRef", type: "BaseElement", isAttr: true, isReference: true}]
    }, {
        name: "Category",
        superClass: ["RootElement"],
        properties: [{name: "categoryValue", type: "CategoryValue", isMany: true}, {
            name: "name",
            isAttr: true,
            type: "String"
        }]
    }, {name: "Artifact", isAbstract: true, superClass: ["BaseElement"]}, {
        name: "CategoryValue",
        superClass: ["BaseElement"],
        properties: [{
            name: "categorizedFlowElements",
            type: "FlowElement",
            isVirtual: true,
            isMany: true,
            isReference: true
        }, {name: "value", isAttr: true, type: "String"}]
    }, {
        name: "Activity",
        isAbstract: true,
        superClass: ["FlowNode"],
        properties: [{name: "isForCompensation", "default": false, isAttr: true, type: "Boolean"}, {
            name: "default",
            type: "SequenceFlow",
            isAttr: true,
            isReference: true
        }, {
            name: "ioSpecification",
            type: "InputOutputSpecification",
            xml: {serialize: "property"}
        }, {name: "boundaryEventRefs", type: "BoundaryEvent", isMany: true, isReference: true}, {
            name: "properties",
            type: "Property",
            isMany: true
        }, {name: "dataInputAssociations", type: "DataInputAssociation", isMany: true}, {
            name: "dataOutputAssociations",
            type: "DataOutputAssociation",
            isMany: true
        }, {name: "startQuantity", "default": 1, isAttr: true, type: "Integer"}, {
            name: "resources",
            type: "ResourceRole",
            isMany: true
        }, {name: "completionQuantity", "default": 1, isAttr: true, type: "Integer"}, {
            name: "loopCharacteristics",
            type: "LoopCharacteristics"
        }]
    }, {
        name: "ServiceTask",
        superClass: ["Task"],
        properties: [{name: "implementation", isAttr: true, type: "String"}, {
            name: "operationRef",
            type: "Operation",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "SubProcess",
        superClass: ["Activity", "FlowElementsContainer", "InteractionNode"],
        properties: [{name: "triggeredByEvent", "default": false, isAttr: true, type: "Boolean"}, {
            name: "artifacts",
            type: "Artifact",
            isMany: true
        }]
    }, {
        name: "LoopCharacteristics",
        isAbstract: true,
        superClass: ["BaseElement"]
    }, {
        name: "MultiInstanceLoopCharacteristics",
        superClass: ["LoopCharacteristics"],
        properties: [{name: "isSequential", "default": false, isAttr: true, type: "Boolean"}, {
            name: "behavior",
            type: "MultiInstanceBehavior",
            "default": "All",
            isAttr: true
        }, {name: "loopCardinality", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "loopDataInputRef",
            type: "ItemAwareElement",
            isReference: true
        }, {name: "loopDataOutputRef", type: "ItemAwareElement", isReference: true}, {
            name: "inputDataItem",
            type: "DataInput",
            xml: {serialize: "property"}
        }, {
            name: "outputDataItem",
            type: "DataOutput",
            xml: {serialize: "property"}
        }, {
            name: "complexBehaviorDefinition",
            type: "ComplexBehaviorDefinition",
            isMany: true
        }, {
            name: "completionCondition",
            type: "Expression",
            xml: {serialize: "xsi:type"}
        }, {
            name: "oneBehaviorEventRef",
            type: "EventDefinition",
            isAttr: true,
            isReference: true
        }, {name: "noneBehaviorEventRef", type: "EventDefinition", isAttr: true, isReference: true}]
    }, {
        name: "StandardLoopCharacteristics",
        superClass: ["LoopCharacteristics"],
        properties: [{name: "testBefore", "default": false, isAttr: true, type: "Boolean"}, {
            name: "loopCondition",
            type: "Expression",
            xml: {serialize: "xsi:type"}
        }, {name: "loopMaximum", type: "Integer", isAttr: true}]
    }, {
        name: "CallActivity",
        superClass: ["Activity"],
        properties: [{name: "calledElement", type: "String", isAttr: true}]
    }, {name: "Task", superClass: ["Activity", "InteractionNode"]}, {
        name: "SendTask",
        superClass: ["Task"],
        properties: [{name: "implementation", isAttr: true, type: "String"}, {
            name: "operationRef",
            type: "Operation",
            isAttr: true,
            isReference: true
        }, {name: "messageRef", type: "Message", isAttr: true, isReference: true}]
    }, {
        name: "ReceiveTask",
        superClass: ["Task"],
        properties: [{name: "implementation", isAttr: true, type: "String"}, {
            name: "instantiate",
            "default": false,
            isAttr: true,
            type: "Boolean"
        }, {name: "operationRef", type: "Operation", isAttr: true, isReference: true}, {
            name: "messageRef",
            type: "Message",
            isAttr: true,
            isReference: true
        }]
    }, {
        name: "ScriptTask",
        superClass: ["Task"],
        properties: [{name: "scriptFormat", isAttr: true, type: "String"}, {name: "script", type: "String"}]
    }, {
        name: "BusinessRuleTask",
        superClass: ["Task"],
        properties: [{name: "implementation", isAttr: true, type: "String"}]
    }, {
        name: "AdHocSubProcess",
        superClass: ["SubProcess"],
        properties: [{name: "completionCondition", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "ordering",
            type: "AdHocOrdering",
            isAttr: true
        }, {name: "cancelRemainingInstances", "default": true, isAttr: true, type: "Boolean"}]
    }, {
        name: "Transaction",
        superClass: ["SubProcess"],
        properties: [{name: "protocol", isAttr: true, type: "String"}, {name: "method", isAttr: true, type: "String"}]
    }, {
        name: "GlobalScriptTask",
        superClass: ["GlobalTask"],
        properties: [{name: "scriptLanguage", isAttr: true, type: "String"}, {
            name: "script",
            isAttr: true,
            type: "String"
        }]
    }, {
        name: "GlobalBusinessRuleTask",
        superClass: ["GlobalTask"],
        properties: [{name: "implementation", isAttr: true, type: "String"}]
    }, {
        name: "ComplexBehaviorDefinition",
        superClass: ["BaseElement"],
        properties: [{name: "condition", type: "FormalExpression"}, {name: "event", type: "ImplicitThrowEvent"}]
    }, {
        name: "ResourceRole",
        superClass: ["BaseElement"],
        properties: [{name: "resourceRef", type: "Resource", isReference: true}, {
            name: "resourceParameterBindings",
            type: "ResourceParameterBinding",
            isMany: true
        }, {name: "resourceAssignmentExpression", type: "ResourceAssignmentExpression"}, {
            name: "name",
            isAttr: true,
            type: "String"
        }]
    }, {
        name: "ResourceParameterBinding",
        properties: [{name: "expression", type: "Expression", xml: {serialize: "xsi:type"}}, {
            name: "parameterRef",
            type: "ResourceParameter",
            isAttr: true,
            isReference: true
        }],
        superClass: ["BaseElement"]
    }, {
        name: "ResourceAssignmentExpression",
        properties: [{name: "expression", type: "Expression", xml: {serialize: "xsi:type"}}],
        superClass: ["BaseElement"]
    }, {
        name: "Import",
        properties: [{name: "importType", isAttr: true, type: "String"}, {
            name: "location",
            isAttr: true,
            type: "String"
        }, {name: "namespace", isAttr: true, type: "String"}]
    }, {
        name: "Definitions",
        superClass: ["BaseElement"],
        properties: [{name: "name", isAttr: true, type: "String"}, {
            name: "targetNamespace",
            isAttr: true,
            type: "String"
        }, {
            name: "expressionLanguage",
            "default": "http://www.w3.org/1999/XPath",
            isAttr: true,
            type: "String"
        }, {
            name: "typeLanguage",
            "default": "http://www.w3.org/2001/XMLSchema",
            isAttr: true,
            type: "String"
        }, {name: "imports", type: "Import", isMany: true}, {
            name: "extensions",
            type: "Extension",
            isMany: true
        }, {name: "rootElements", type: "RootElement", isMany: true}, {
            name: "diagrams",
            isMany: true,
            type: "bpmndi:BPMNDiagram"
        }, {name: "exporter", isAttr: true, type: "String"}, {
            name: "relationships",
            type: "Relationship",
            isMany: true
        }, {name: "exporterVersion", isAttr: true, type: "String"}]
    }];
    var enumerations = [{
        name: "ProcessType",
        literalValues: [{name: "None"}, {name: "Public"}, {name: "Private"}]
    }, {
        name: "GatewayDirection",
        literalValues: [{name: "Unspecified"}, {name: "Converging"}, {name: "Diverging"}, {name: "Mixed"}]
    }, {
        name: "EventBasedGatewayType",
        literalValues: [{name: "Parallel"}, {name: "Exclusive"}]
    }, {
        name: "RelationshipDirection",
        literalValues: [{name: "None"}, {name: "Forward"}, {name: "Backward"}, {name: "Both"}]
    }, {name: "ItemKind", literalValues: [{name: "Physical"}, {name: "Information"}]}, {
        name: "ChoreographyLoopType",
        literalValues: [{name: "None"}, {name: "Standard"}, {name: "MultiInstanceSequential"}, {name: "MultiInstanceParallel"}]
    }, {
        name: "AssociationDirection",
        literalValues: [{name: "None"}, {name: "One"}, {name: "Both"}]
    }, {
        name: "MultiInstanceBehavior",
        literalValues: [{name: "None"}, {name: "One"}, {name: "All"}, {name: "Complex"}]
    }, {name: "AdHocOrdering", literalValues: [{name: "Parallel"}, {name: "Sequential"}]}];
    var prefix$1 = "bpmn";
    var xml = {tagAlias: "lowerCase", typePrefix: "t"};
    var BpmnPackage = {
        name: name,
        uri: uri,
        associations: associations,
        types: types$1,
        enumerations: enumerations,
        prefix: prefix$1,
        xml: xml
    };
    var name$1 = "BPMNDI";
    var uri$1 = "http://www.omg.org/spec/BPMN/20100524/DI";
    var types$2 = [{
        name: "BPMNDiagram",
        properties: [{name: "plane", type: "BPMNPlane", redefines: "di:Diagram#rootElement"}, {
            name: "labelStyle",
            type: "BPMNLabelStyle",
            isMany: true
        }],
        superClass: ["di:Diagram"]
    }, {
        name: "BPMNPlane",
        properties: [{
            name: "bpmnElement",
            isAttr: true,
            isReference: true,
            type: "bpmn:BaseElement",
            redefines: "di:DiagramElement#modelElement"
        }],
        superClass: ["di:Plane"]
    }, {
        name: "BPMNShape",
        properties: [{
            name: "bpmnElement",
            isAttr: true,
            isReference: true,
            type: "bpmn:BaseElement",
            redefines: "di:DiagramElement#modelElement"
        }, {name: "isHorizontal", isAttr: true, type: "Boolean"}, {
            name: "isExpanded",
            isAttr: true,
            type: "Boolean"
        }, {name: "isMarkerVisible", isAttr: true, type: "Boolean"}, {
            name: "label",
            type: "BPMNLabel"
        }, {name: "isMessageVisible", isAttr: true, type: "Boolean"}, {
            name: "participantBandKind",
            type: "ParticipantBandKind",
            isAttr: true
        }, {name: "choreographyActivityShape", type: "BPMNShape", isAttr: true, isReference: true}],
        superClass: ["di:LabeledShape"]
    }, {
        name: "BPMNEdge",
        properties: [{name: "label", type: "BPMNLabel"}, {
            name: "bpmnElement",
            isAttr: true,
            isReference: true,
            type: "bpmn:BaseElement",
            redefines: "di:DiagramElement#modelElement"
        }, {
            name: "sourceElement",
            isAttr: true,
            isReference: true,
            type: "di:DiagramElement",
            redefines: "di:Edge#source"
        }, {
            name: "targetElement",
            isAttr: true,
            isReference: true,
            type: "di:DiagramElement",
            redefines: "di:Edge#target"
        }, {name: "messageVisibleKind", type: "MessageVisibleKind", isAttr: true, "default": "initiating"}],
        superClass: ["di:LabeledEdge"]
    }, {
        name: "BPMNLabel",
        properties: [{
            name: "labelStyle",
            type: "BPMNLabelStyle",
            isAttr: true,
            isReference: true,
            redefines: "di:DiagramElement#style"
        }],
        superClass: ["di:Label"]
    }, {name: "BPMNLabelStyle", properties: [{name: "font", type: "dc:Font"}], superClass: ["di:Style"]}];
    var enumerations$1 = [{
        name: "ParticipantBandKind",
        literalValues: [{name: "top_initiating"}, {name: "middle_initiating"}, {name: "bottom_initiating"}, {name: "top_non_initiating"}, {name: "middle_non_initiating"}, {name: "bottom_non_initiating"}]
    }, {name: "MessageVisibleKind", literalValues: [{name: "initiating"}, {name: "non_initiating"}]}];
    var associations$1 = [];
    var prefix$2 = "bpmndi";
    var BpmnDiPackage = {
        name: name$1,
        uri: uri$1,
        types: types$2,
        enumerations: enumerations$1,
        associations: associations$1,
        prefix: prefix$2
    };
    var name$2 = "DC";
    var uri$2 = "http://www.omg.org/spec/DD/20100524/DC";
    var types$3 = [{name: "Boolean"}, {name: "Integer"}, {name: "Real"}, {name: "String"}, {
        name: "Font",
        properties: [{name: "name", type: "String", isAttr: true}, {
            name: "size",
            type: "Real",
            isAttr: true
        }, {name: "isBold", type: "Boolean", isAttr: true}, {
            name: "isItalic",
            type: "Boolean",
            isAttr: true
        }, {name: "isUnderline", type: "Boolean", isAttr: true}, {
            name: "isStrikeThrough",
            type: "Boolean",
            isAttr: true
        }]
    }, {
        name: "Point",
        properties: [{name: "x", type: "Real", "default": "0", isAttr: true}, {
            name: "y",
            type: "Real",
            "default": "0",
            isAttr: true
        }]
    }, {
        name: "Bounds",
        properties: [{name: "x", type: "Real", "default": "0", isAttr: true}, {
            name: "y",
            type: "Real",
            "default": "0",
            isAttr: true
        }, {name: "width", type: "Real", isAttr: true}, {name: "height", type: "Real", isAttr: true}]
    }];
    var prefix$3 = "dc";
    var associations$2 = [];
    var DcPackage = {name: name$2, uri: uri$2, types: types$3, prefix: prefix$3, associations: associations$2};
    var name$3 = "DI";
    var uri$3 = "http://www.omg.org/spec/DD/20100524/DI";
    var types$4 = [{
        name: "DiagramElement",
        isAbstract: true,
        properties: [{name: "id", type: "String", isAttr: true, isId: true}, {
            name: "extension",
            type: "Extension"
        }, {
            name: "owningDiagram",
            type: "Diagram",
            isReadOnly: true,
            isVirtual: true,
            isReference: true
        }, {
            name: "owningElement",
            type: "DiagramElement",
            isReadOnly: true,
            isVirtual: true,
            isReference: true
        }, {
            name: "modelElement",
            isReadOnly: true,
            isVirtual: true,
            isReference: true,
            type: "Element"
        }, {name: "style", type: "Style", isReadOnly: true, isVirtual: true, isReference: true}, {
            name: "ownedElement",
            type: "DiagramElement",
            isReadOnly: true,
            isVirtual: true,
            isMany: true
        }]
    }, {name: "Node", isAbstract: true, superClass: ["DiagramElement"]}, {
        name: "Edge",
        isAbstract: true,
        superClass: ["DiagramElement"],
        properties: [{
            name: "source",
            type: "DiagramElement",
            isReadOnly: true,
            isVirtual: true,
            isReference: true
        }, {
            name: "target",
            type: "DiagramElement",
            isReadOnly: true,
            isVirtual: true,
            isReference: true
        }, {name: "waypoint", isUnique: false, isMany: true, type: "dc:Point", xml: {serialize: "xsi:type"}}]
    }, {
        name: "Diagram",
        isAbstract: true,
        properties: [{name: "id", type: "String", isAttr: true, isId: true}, {
            name: "rootElement",
            type: "DiagramElement",
            isReadOnly: true,
            isVirtual: true
        }, {name: "name", isAttr: true, type: "String"}, {
            name: "documentation",
            isAttr: true,
            type: "String"
        }, {name: "resolution", isAttr: true, type: "Real"}, {
            name: "ownedStyle",
            type: "Style",
            isReadOnly: true,
            isVirtual: true,
            isMany: true
        }]
    }, {
        name: "Shape",
        isAbstract: true,
        superClass: ["Node"],
        properties: [{name: "bounds", type: "dc:Bounds"}]
    }, {
        name: "Plane",
        isAbstract: true,
        superClass: ["Node"],
        properties: [{
            name: "planeElement",
            type: "DiagramElement",
            subsettedProperty: "DiagramElement-ownedElement",
            isMany: true
        }]
    }, {
        name: "LabeledEdge",
        isAbstract: true,
        superClass: ["Edge"],
        properties: [{
            name: "ownedLabel",
            type: "Label",
            isReadOnly: true,
            subsettedProperty: "DiagramElement-ownedElement",
            isVirtual: true,
            isMany: true
        }]
    }, {
        name: "LabeledShape",
        isAbstract: true,
        superClass: ["Shape"],
        properties: [{
            name: "ownedLabel",
            type: "Label",
            isReadOnly: true,
            subsettedProperty: "DiagramElement-ownedElement",
            isVirtual: true,
            isMany: true
        }]
    }, {
        name: "Label",
        isAbstract: true,
        superClass: ["Node"],
        properties: [{name: "bounds", type: "dc:Bounds"}]
    }, {
        name: "Style",
        isAbstract: true,
        properties: [{name: "id", type: "String", isAttr: true, isId: true}]
    }, {name: "Extension", properties: [{name: "values", type: "Element", isMany: true}]}];
    var associations$3 = [];
    var prefix$4 = "di";
    var xml$1 = {tagAlias: "lowerCase"};
    var DiPackage = {
        name: name$3,
        uri: uri$3,
        types: types$4,
        associations: associations$3,
        prefix: prefix$4,
        xml: xml$1
    };
    var name$4 = "bpmn.io colors for BPMN";
    var uri$4 = "http://bpmn.io/schema/bpmn/biocolor/1.0";
    var prefix$5 = "bioc";
    var types$5 = [{
        name: "ColoredShape",
        "extends": ["bpmndi:BPMNShape"],
        properties: [{name: "stroke", isAttr: true, type: "String"}, {name: "fill", isAttr: true, type: "String"}]
    }, {
        name: "ColoredEdge",
        "extends": ["bpmndi:BPMNEdge"],
        properties: [{name: "stroke", isAttr: true, type: "String"}, {name: "fill", isAttr: true, type: "String"}]
    }];
    var enumerations$2 = [];
    var associations$4 = [];
    var BiocPackage = {
        name: name$4,
        uri: uri$4,
        prefix: prefix$5,
        types: types$5,
        enumerations: enumerations$2,
        associations: associations$4
    };
    var packages = {bpmn: BpmnPackage, bpmndi: BpmnDiPackage, dc: DcPackage, di: DiPackage, bioc: BiocPackage};

    function BpmnModdle$1(additionalPackages, options) {
        var pks = assign({}, packages, additionalPackages);
        return new BpmnModdle(pks, options);
    }

    function elementToString(e) {
        if (!e) {
            return '<null>';
        }
        return '<' + e.$type + (e.id ? ' id="' + e.id : '') + '" />';
    }

    var diRefs = new objectRefs({name: 'bpmnElement', enumerable: true}, {name: 'di', configurable: true});

    function is(element, type) {
        return element.$instanceOf(type);
    }

    function findDisplayCandidate(definitions) {
        return find(definitions.rootElements, function (e) {
            return is(e, 'bpmn:Process') || is(e, 'bpmn:Collaboration');
        });
    }

    function BpmnTreeWalker(handler, translate) {
        var handledElements = {};
        var deferred = [];

        function contextual(fn, ctx) {
            return function (e) {
                fn(e, ctx);
            };
        }

        function handled(element) {
            handledElements[element.id] = element;
        }

        function isHandled(element) {
            return handledElements[element.id];
        }

        function visit(element, ctx) {
            var gfx = element.gfx;
            if (gfx) {
                throw new Error(translate('already rendered {element}', {element: elementToString(element)}));
            }
            return handler.element(element, ctx);
        }

        function visitRoot(element, diagram) {
            return handler.root(element, diagram);
        }

        function visitIfDi(element, ctx) {
            try {
                var gfx = element.di && visit(element, ctx);
                handled(element);
                return gfx;
            } catch (e) {
                logError(e.message, {element: element, error: e});
                console.error(translate('failed to import {element}', {element: elementToString(element)}));
                console.error(e);
            }
        }

        function logError(message, context) {
            handler.error(message, context);
        }

        function registerDi(di) {
            var bpmnElement = di.bpmnElement;
            if (bpmnElement) {
                if (bpmnElement.di) {
                    logError(translate('multiple DI elements defined for {element}', {element: elementToString(bpmnElement)}), {element: bpmnElement});
                } else {
                    diRefs.bind(bpmnElement, 'di');
                    bpmnElement.di = di;
                }
            } else {
                logError(translate('no bpmnElement referenced in {element}', {element: elementToString(di)}), {element: di});
            }
        }

        function handleDiagram(diagram) {
            handlePlane(diagram.plane);
        }

        function handlePlane(plane) {
            registerDi(plane);
            forEach(plane.planeElement, handlePlaneElement);
        }

        function handlePlaneElement(planeElement) {
            registerDi(planeElement);
        }

        function handleDefinitions(definitions, diagram) {
            var diagrams = definitions.diagrams;
            if (diagram && diagrams.indexOf(diagram) === -1) {
                throw new Error(translate('diagram not part of bpmn:Definitions'));
            }
            if (!diagram && diagrams && diagrams.length) {
                diagram = diagrams[0];
            }
            if (!diagram) {
                throw new Error(translate('no diagram to display'));
            }
            handleDiagram(diagram);
            var plane = diagram.plane;
            if (!plane) {
                throw new Error(translate('no plane for {element}', {element: elementToString(diagram)}));
            }
            var rootElement = plane.bpmnElement;
            if (!rootElement) {
                rootElement = findDisplayCandidate(definitions);
                if (!rootElement) {
                    throw new Error(translate('no process or collaboration to display'));
                } else {
                    logError(translate('correcting missing bpmnElement on {plane} to {rootElement}', {
                        plane: elementToString(plane),
                        rootElement: elementToString(rootElement)
                    }));
                    plane.bpmnElement = rootElement;
                    registerDi(plane);
                }
            }
            var ctx = visitRoot(rootElement, plane);
            if (is(rootElement, 'bpmn:Process')) {
                handleProcess(rootElement, ctx);
            } else if (is(rootElement, 'bpmn:Collaboration')) {
                handleCollaboration(rootElement, ctx);
                handleUnhandledProcesses(definitions.rootElements, ctx);
            } else {
                throw new Error(translate('unsupported bpmnElement for {plane}: {rootElement}', {
                    plane: elementToString(plane),
                    rootElement: elementToString(rootElement)
                }));
            }
            handleDeferred(deferred);
        }

        function handleDeferred() {
            var fn;
            while (deferred.length) {
                fn = deferred.shift();
                fn();
            }
        }

        function handleProcess(process, context) {
            handleFlowElementsContainer(process, context);
            handleIoSpecification(process.ioSpecification, context);
            handleArtifacts(process.artifacts, context);
            handled(process);
        }

        function handleUnhandledProcesses(rootElements) {
            var processes = filter(rootElements, function (e) {
                return !isHandled(e) && is(e, 'bpmn:Process') && e.laneSets;
            });
            processes.forEach(contextual(handleProcess));
        }

        function handleMessageFlow(messageFlow, context) {
            visitIfDi(messageFlow, context);
        }

        function handleMessageFlows(messageFlows, context) {
            forEach(messageFlows, contextual(handleMessageFlow, context));
        }

        function handleDataAssociation(association, context) {
            visitIfDi(association, context);
        }

        function handleDataInput(dataInput, context) {
            visitIfDi(dataInput, context);
        }

        function handleDataOutput(dataOutput, context) {
            visitIfDi(dataOutput, context);
        }

        function handleArtifact(artifact, context) {
            visitIfDi(artifact, context);
        }

        function handleArtifacts(artifacts, context) {
            forEach(artifacts, function (e) {
                if (is(e, 'bpmn:Association')) {
                    deferred.push(function () {
                        handleArtifact(e, context);
                    });
                } else {
                    handleArtifact(e, context);
                }
            });
        }

        function handleIoSpecification(ioSpecification, context) {
            if (!ioSpecification) {
                return;
            }
            forEach(ioSpecification.dataInputs, contextual(handleDataInput, context));
            forEach(ioSpecification.dataOutputs, contextual(handleDataOutput, context));
        }

        function handleSubProcess(subProcess, context) {
            handleFlowElementsContainer(subProcess, context);
            handleArtifacts(subProcess.artifacts, context);
        }

        function handleFlowNode(flowNode, context) {
            var childCtx = visitIfDi(flowNode, context);
            if (is(flowNode, 'bpmn:SubProcess')) {
                handleSubProcess(flowNode, childCtx || context);
            }
            if (is(flowNode, 'bpmn:Activity')) {
                handleIoSpecification(flowNode.ioSpecification, context);
            }
            deferred.push(function () {
                forEach(flowNode.dataInputAssociations, contextual(handleDataAssociation, context));
                forEach(flowNode.dataOutputAssociations, contextual(handleDataAssociation, context));
            });
        }

        function handleSequenceFlow(sequenceFlow, context) {
            visitIfDi(sequenceFlow, context);
        }

        function handleDataElement(dataObject, context) {
            visitIfDi(dataObject, context);
        }

        function handleBoundaryEvent(dataObject, context) {
            visitIfDi(dataObject, context);
        }

        function handleLane(lane, context) {
            deferred.push(function () {
                var newContext = visitIfDi(lane, context);
                if (lane.childLaneSet) {
                    handleLaneSet(lane.childLaneSet, newContext || context);
                }
                wireFlowNodeRefs(lane);
            });
        }

        function handleLaneSet(laneSet, context) {
            forEach(laneSet.lanes, contextual(handleLane, context));
        }

        function handleLaneSets(laneSets, context) {
            forEach(laneSets, contextual(handleLaneSet, context));
        }

        function handleFlowElementsContainer(container, context) {
            handleFlowElements(container.flowElements, context);
            if (container.laneSets) {
                handleLaneSets(container.laneSets, context);
            }
        }

        function handleFlowElements(flowElements, context) {
            forEach(flowElements, function (e) {
                if (is(e, 'bpmn:SequenceFlow')) {
                    deferred.push(function () {
                        handleSequenceFlow(e, context);
                    });
                } else if (is(e, 'bpmn:BoundaryEvent')) {
                    deferred.unshift(function () {
                        handleBoundaryEvent(e, context);
                    });
                } else if (is(e, 'bpmn:FlowNode')) {
                    handleFlowNode(e, context);
                } else if (is(e, 'bpmn:DataObject')) ; else if (is(e, 'bpmn:DataStoreReference')) {
                    handleDataElement(e, context);
                } else if (is(e, 'bpmn:DataObjectReference')) {
                    handleDataElement(e, context);
                } else {
                    logError(translate('unrecognized flowElement {element} in context {context}', {
                        element: elementToString(e),
                        context: (context ? elementToString(context.businessObject) : 'null')
                    }), {element: e, context: context});
                }
            });
        }

        function handleParticipant(participant, context) {
            var newCtx = visitIfDi(participant, context);
            var process = participant.processRef;
            if (process) {
                handleProcess(process, newCtx || context);
            }
        }

        function handleCollaboration(collaboration) {
            forEach(collaboration.participants, contextual(handleParticipant));
            handleArtifacts(collaboration.artifacts);
            deferred.push(function () {
                handleMessageFlows(collaboration.messageFlows);
            });
        }

        function wireFlowNodeRefs(lane) {
            forEach(lane.flowNodeRef, function (flowNode) {
                var lanes = flowNode.get('lanes');
                if (lanes) {
                    lanes.push(lane);
                }
            });
        }

        return {
            handleDeferred: handleDeferred,
            handleDefinitions: handleDefinitions,
            handleSubProcess: handleSubProcess,
            registerDi: registerDi
        };
    }

    function importBpmnDiagram(diagram, definitions, done) {
        var importer, eventBus, translate;
        var error, warnings = [];

        function render(definitions) {
            var visitor = {
                root: function (element) {
                    return importer.add(element);
                }, element: function (element, parentShape) {
                    return importer.add(element, parentShape);
                }, error: function (message, context) {
                    warnings.push({message: message, context: context});
                }
            };
            var walker = new BpmnTreeWalker(visitor, translate);
            walker.handleDefinitions(definitions);
        }

        try {
            importer = diagram.get('bpmnImporter');
            eventBus = diagram.get('eventBus');
            translate = diagram.get('translate');
            eventBus.fire('import.render.start', {definitions: definitions});
            render(definitions);
            eventBus.fire('import.render.complete', {error: error, warnings: warnings});
        } catch (e) {
            error = e;
        }
        done(error, warnings);
    }

    function is$1(element, type) {
        var bo = getBusinessObject(element);
        return bo && (typeof bo.$instanceOf === 'function') && bo.$instanceOf(type);
    }

    function getBusinessObject(element) {
        return (element && element.businessObject) || element;
    }

    function isExpanded(element) {
        if (is$1(element, 'bpmn:CallActivity')) {
            return false;
        }
        if (is$1(element, 'bpmn:SubProcess')) {
            return !!getBusinessObject(element).di.isExpanded;
        }
        if (is$1(element, 'bpmn:Participant')) {
            return !!getBusinessObject(element).processRef;
        }
        return true;
    }

    function isInterrupting(element) {
        return element && getBusinessObject(element).isInterrupting !== false;
    }

    function isEventSubProcess(element) {
        return element && !!getBusinessObject(element).triggeredByEvent;
    }

    function hasEventDefinition(element, eventType) {
        var bo = getBusinessObject(element), hasEventDefinition = false;
        if (bo.eventDefinitions) {
            forEach(bo.eventDefinitions, function (event) {
                if (is$1(event, eventType)) {
                    hasEventDefinition = true;
                }
            });
        }
        return hasEventDefinition;
    }

    function hasErrorEventDefinition(element) {
        return hasEventDefinition(element, 'bpmn:ErrorEventDefinition');
    }

    function hasEscalationEventDefinition(element) {
        return hasEventDefinition(element, 'bpmn:EscalationEventDefinition');
    }

    function hasCompensateEventDefinition(element) {
        return hasEventDefinition(element, 'bpmn:CompensateEventDefinition');
    }

    function isTypedEvent(event, eventDefinitionType, filter$$1) {
        function matches(definition, filter$$1) {
            return every(filter$$1, function (val, key) {
                return definition[key] == val;
            });
        }

        return some(event.eventDefinitions, function (definition) {
            return definition.$type === eventDefinitionType && matches(event, filter$$1);
        });
    }

    function isThrowEvent(event) {
        return (event.$type === 'bpmn:IntermediateThrowEvent') || (event.$type === 'bpmn:EndEvent');
    }

    function isCollection(element) {
        var dataObject = element.dataObjectRef;
        return element.isCollection || (dataObject && dataObject.isCollection);
    }

    function getDi(element) {
        return element.businessObject.di;
    }

    function getSemantic(element) {
        return element.businessObject;
    }

    function getFillColor(element, defaultColor) {
        return getDi(element).get('bioc:fill') || defaultColor || '#FAFAFA';
    }

    function getStrokeColor(element, defaultColor) {
        return getDi(element).get('bioc:stroke') || defaultColor || 'black';
    }

    function getCirclePath(shape) {
        var cx = shape.x + shape.width / 2, cy = shape.y + shape.height / 2, radius = shape.width / 2;
        var circlePath = [['M', cx, cy], ['m', 0, -radius], ['a', radius, radius, 0, 1, 1, 0, 2 * radius], ['a', radius, radius, 0, 1, 1, 0, -2 * radius], ['z']];
        return componentsToPath(circlePath);
    }

    function getRoundRectPath(shape, borderRadius) {
        var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
        var roundRectPath = [['M', x + borderRadius, y], ['l', width - borderRadius * 2, 0], ['a', borderRadius, borderRadius, 0, 0, 1, borderRadius, borderRadius], ['l', 0, height - borderRadius * 2], ['a', borderRadius, borderRadius, 0, 0, 1, -borderRadius, borderRadius], ['l', borderRadius * 2 - width, 0], ['a', borderRadius, borderRadius, 0, 0, 1, -borderRadius, -borderRadius], ['l', 0, borderRadius * 2 - height], ['a', borderRadius, borderRadius, 0, 0, 1, borderRadius, -borderRadius], ['z']];
        return componentsToPath(roundRectPath);
    }

    function getDiamondPath(shape) {
        var width = shape.width, height = shape.height, x = shape.x, y = shape.y, halfWidth = width / 2,
            halfHeight = height / 2;
        var diamondPath = [['M', x + halfWidth, y], ['l', halfWidth, halfHeight], ['l', -halfWidth, halfHeight], ['l', -halfWidth, -halfHeight], ['z']];
        return componentsToPath(diamondPath);
    }

    function getRectPath(shape) {
        var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
        var rectPath = [['M', x, y], ['l', width, 0], ['l', 0, height], ['l', -width, 0], ['z']];
        return componentsToPath(rectPath);
    }

    var RENDERER_IDS = new ids();
    var TASK_BORDER_RADIUS = 10;
    var INNER_OUTER_DIST = 3;
    var DEFAULT_FILL_OPACITY = .95, HIGH_FILL_OPACITY = .35;

    function BpmnRenderer(config, eventBus, styles, pathMap, canvas, textRenderer, priority) {
        BaseRenderer.call(this, eventBus, priority);
        var defaultFillColor = config && config.defaultFillColor,
            defaultStrokeColor = config && config.defaultStrokeColor;
        var rendererId = RENDERER_IDS.next();
        var markers = {};
        var computeStyle = styles.computeStyle;

        function addMarker(id, options) {
            var attrs = assign({
                fill: 'black',
                strokeWidth: 1,
                strokeLinecap: 'round',
                strokeDasharray: 'none'
            }, options.attrs);
            var ref = options.ref || {x: 0, y: 0};
            var scale$$1 = options.scale || 1;
            if (attrs.strokeDasharray === 'none') {
                attrs.strokeDasharray = [10000, 1];
            }
            var marker = create('marker');
            attr$1(options.element, attrs);
            append(marker, options.element);
            attr$1(marker, {
                id: id,
                viewBox: '0 0 20 20',
                refX: ref.x,
                refY: ref.y,
                markerWidth: 20 * scale$$1,
                markerHeight: 20 * scale$$1,
                orient: 'auto'
            });
            var defs = query('defs', canvas._svg);
            if (!defs) {
                defs = create('defs');
                append(canvas._svg, defs);
            }
            append(defs, marker);
            markers[id] = marker;
        }

        function marker(type, fill, stroke) {
            var id = type + '-' + fill + '-' + stroke + '-' + rendererId;
            if (!markers[id]) {
                createMarker(type, fill, stroke);
            }
            return 'url(#' + id + ')';
        }

        function createMarker(type, fill, stroke) {
            var id = type + '-' + fill + '-' + stroke + '-' + rendererId;
            if (type === 'sequenceflow-end') {
                var sequenceflowEnd = create('path');
                attr$1(sequenceflowEnd, {d: 'M 1 5 L 11 10 L 1 15 Z'});
                addMarker(id, {
                    element: sequenceflowEnd,
                    ref: {x: 11, y: 10},
                    scale: 0.5,
                    attrs: {fill: stroke, stroke: stroke}
                });
            }
            if (type === 'messageflow-start') {
                var messageflowStart = create('circle');
                attr$1(messageflowStart, {cx: 6, cy: 6, r: 3.5});
                addMarker(id, {element: messageflowStart, attrs: {fill: fill, stroke: stroke}, ref: {x: 6, y: 6}});
            }
            if (type === 'messageflow-end') {
                var messageflowEnd = create('path');
                attr$1(messageflowEnd, {d: 'm 1 5 l 0 -3 l 7 3 l -7 3 z'});
                addMarker(id, {
                    element: messageflowEnd,
                    attrs: {fill: fill, stroke: stroke, strokeLinecap: 'butt'},
                    ref: {x: 8.5, y: 5}
                });
            }
            if (type === 'association-start') {
                var associationStart = create('path');
                attr$1(associationStart, {d: 'M 11 5 L 1 10 L 11 15'});
                addMarker(id, {
                    element: associationStart,
                    attrs: {fill: 'none', stroke: stroke, strokeWidth: 1.5},
                    ref: {x: 1, y: 10},
                    scale: 0.5
                });
            }
            if (type === 'association-end') {
                var associationEnd = create('path');
                attr$1(associationEnd, {d: 'M 1 5 L 11 10 L 1 15'});
                addMarker(id, {
                    element: associationEnd,
                    attrs: {fill: 'none', stroke: stroke, strokeWidth: 1.5},
                    ref: {x: 12, y: 10},
                    scale: 0.5
                });
            }
            if (type === 'conditional-flow-marker') {
                var conditionalflowMarker = create('path');
                attr$1(conditionalflowMarker, {d: 'M 0 10 L 8 6 L 16 10 L 8 14 Z'});
                addMarker(id, {
                    element: conditionalflowMarker,
                    attrs: {fill: fill, stroke: stroke},
                    ref: {x: -1, y: 10},
                    scale: 0.5
                });
            }
            if (type === 'conditional-default-flow-marker') {
                var conditionaldefaultflowMarker = create('path');
                attr$1(conditionaldefaultflowMarker, {d: 'M 6 4 L 10 16'});
                addMarker(id, {
                    element: conditionaldefaultflowMarker,
                    attrs: {stroke: stroke},
                    ref: {x: 0, y: 10},
                    scale: 0.5
                });
            }
        }

        function drawCircle(parentGfx, width, height, offset, attrs) {
            if (isObject(offset)) {
                attrs = offset;
                offset = 0;
            }
            offset = offset || 0;
            attrs = computeStyle(attrs, {stroke: 'black', strokeWidth: 2, fill: 'white'});
            if (attrs.fill === 'none') {
                delete attrs.fillOpacity;
            }
            var cx = width / 2, cy = height / 2;
            var circle = create('circle');
            attr$1(circle, {cx: cx, cy: cy, r: Math.round((width + height) / 4 - offset)});
            attr$1(circle, attrs);
            append(parentGfx, circle);
            return circle;
        }

        function drawRect(parentGfx, width, height, r, offset, attrs) {
            if (isObject(offset)) {
                attrs = offset;
                offset = 0;
            }
            offset = offset || 0;
            attrs = computeStyle(attrs, {stroke: 'black', strokeWidth: 2, fill: 'white'});
            var rect = create('rect');
            attr$1(rect, {x: offset, y: offset, width: width - offset * 2, height: height - offset * 2, rx: r, ry: r});
            attr$1(rect, attrs);
            append(parentGfx, rect);
            return rect;
        }

        function drawDiamond(parentGfx, width, height, attrs) {
            var x_2 = width / 2;
            var y_2 = height / 2;
            var points = [{x: x_2, y: 0}, {x: width, y: y_2}, {x: x_2, y: height}, {x: 0, y: y_2}];
            var pointsString = points.map(function (point) {
                return point.x + ',' + point.y;
            }).join(' ');
            attrs = computeStyle(attrs, {stroke: 'black', strokeWidth: 2, fill: 'white'});
            var polygon = create('polygon');
            attr$1(polygon, {points: pointsString});
            attr$1(polygon, attrs);
            append(parentGfx, polygon);
            return polygon;
        }

        function drawLine(parentGfx, waypoints, attrs) {
            attrs = computeStyle(attrs, ['no-fill'], {stroke: 'black', strokeWidth: 2, fill: 'none'});
            var line = createLine(waypoints, attrs);
            append(parentGfx, line);
            return line;
        }

        function drawPath(parentGfx, d, attrs) {
            attrs = computeStyle(attrs, ['no-fill'], {strokeWidth: 2, stroke: 'black'});
            var path = create('path');
            attr$1(path, {d: d});
            attr$1(path, attrs);
            append(parentGfx, path);
            return path;
        }

        function drawMarker(type, parentGfx, path, attrs) {
            return drawPath(parentGfx, path, assign({'data-marker': type}, attrs));
        }

        function as(type) {
            return function (parentGfx, element) {
                return handlers[type](parentGfx, element);
            };
        }

        function renderer(type) {
            return handlers[type];
        }

        function renderEventContent(element, parentGfx) {
            var event = getSemantic(element);
            var isThrowing = isThrowEvent(event);
            if (isTypedEvent(event, 'bpmn:MessageEventDefinition')) {
                return renderer('bpmn:MessageEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:TimerEventDefinition')) {
                return renderer('bpmn:TimerEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:ConditionalEventDefinition')) {
                return renderer('bpmn:ConditionalEventDefinition')(parentGfx, element);
            }
            if (isTypedEvent(event, 'bpmn:SignalEventDefinition')) {
                return renderer('bpmn:SignalEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:CancelEventDefinition') && isTypedEvent(event, 'bpmn:TerminateEventDefinition', {parallelMultiple: false})) {
                return renderer('bpmn:MultipleEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:CancelEventDefinition') && isTypedEvent(event, 'bpmn:TerminateEventDefinition', {parallelMultiple: true})) {
                return renderer('bpmn:ParallelMultipleEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:EscalationEventDefinition')) {
                return renderer('bpmn:EscalationEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:LinkEventDefinition')) {
                return renderer('bpmn:LinkEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:ErrorEventDefinition')) {
                return renderer('bpmn:ErrorEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:CancelEventDefinition')) {
                return renderer('bpmn:CancelEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:CompensateEventDefinition')) {
                return renderer('bpmn:CompensateEventDefinition')(parentGfx, element, isThrowing);
            }
            if (isTypedEvent(event, 'bpmn:TerminateEventDefinition')) {
                return renderer('bpmn:TerminateEventDefinition')(parentGfx, element, isThrowing);
            }
            return null;
        }

        function renderLabel(parentGfx, label, options) {
            options = assign({size: {width: 100}}, options);
            var text = textRenderer.createText(label || '', options);
            classes$1(text).add('djs-label');
            append(parentGfx, text);
            return text;
        }

        function renderEmbeddedLabel(parentGfx, element, align) {
            var semantic = getSemantic(element);
            return renderLabel(parentGfx, semantic.name, {
                box: element,
                align: align,
                padding: 5,
                style: {fill: getStrokeColor(element, defaultStrokeColor)}
            });
        }

        function renderExternalLabel(parentGfx, element) {
            var semantic = getSemantic(element);
            var box = {width: 90, height: 30, x: element.width / 2 + element.x, y: element.height / 2 + element.y};
            return renderLabel(parentGfx, semantic.name, {
                box: box,
                fitBox: true,
                style: assign({}, textRenderer.getExternalStyle(), {fill: getStrokeColor(element, defaultStrokeColor)})
            });
        }

        function renderLaneLabel(parentGfx, text, element) {
            var textBox = renderLabel(parentGfx, text, {
                box: {height: 30, width: element.height},
                align: 'center-middle',
                style: {fill: getStrokeColor(element, defaultStrokeColor)}
            });
            var top = -1 * element.height;
            transform$1(textBox, 0, -top, 270);
        }

        function createPathFromConnection(connection) {
            var waypoints = connection.waypoints;
            var pathData = 'm  ' + waypoints[0].x + ',' + waypoints[0].y;
            for (var i = 1; i < waypoints.length; i++) {
                pathData += 'L' + waypoints[i].x + ',' + waypoints[i].y + ' ';
            }
            return pathData;
        }

        var handlers = this.handlers = {
            'bpmn:Event': function (parentGfx, element, attrs) {
                if (!('fillOpacity' in attrs)) {
                    attrs.fillOpacity = DEFAULT_FILL_OPACITY;
                }
                return drawCircle(parentGfx, element.width, element.height, attrs);
            },
            'bpmn:StartEvent': function (parentGfx, element) {
                var attrs = {
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                var semantic = getSemantic(element);
                if (!semantic.isInterrupting) {
                    attrs = {
                        strokeDasharray: '6',
                        strokeLinecap: 'round',
                        fill: getFillColor(element, defaultFillColor),
                        stroke: getStrokeColor(element, defaultStrokeColor)
                    };
                }
                var circle = renderer('bpmn:Event')(parentGfx, element, attrs);
                renderEventContent(element, parentGfx);
                return circle;
            },
            'bpmn:MessageEventDefinition': function (parentGfx, element, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_MESSAGE', {
                    xScaleFactor: 0.9,
                    yScaleFactor: 0.9,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.235, my: 0.315}
                });
                var fill = isThrowing ? getStrokeColor(element, defaultStrokeColor) : getFillColor(element, defaultFillColor);
                var stroke = isThrowing ? getFillColor(element, defaultFillColor) : getStrokeColor(element, defaultStrokeColor);
                var messagePath = drawPath(parentGfx, pathData, {strokeWidth: 1, fill: fill, stroke: stroke});
                return messagePath;
            },
            'bpmn:TimerEventDefinition': function (parentGfx, element) {
                var circle = drawCircle(parentGfx, element.width, element.height, 0.2 * element.height, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var pathData = pathMap.getScaledPath('EVENT_TIMER_WH', {
                    xScaleFactor: 0.75,
                    yScaleFactor: 0.75,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.5, my: 0.5}
                });
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    strokeLinecap: 'square',
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                for (var i = 0; i < 12; i++) {
                    var linePathData = pathMap.getScaledPath('EVENT_TIMER_LINE', {
                        xScaleFactor: 0.75,
                        yScaleFactor: 0.75,
                        containerWidth: element.width,
                        containerHeight: element.height,
                        position: {mx: 0.5, my: 0.5}
                    });
                    var width = element.width / 2;
                    var height = element.height / 2;
                    drawPath(parentGfx, linePathData, {
                        strokeWidth: 1,
                        strokeLinecap: 'square',
                        transform: 'rotate(' + (i * 30) + ',' + height + ',' + width + ')',
                        stroke: getStrokeColor(element, defaultStrokeColor)
                    });
                }
                return circle;
            },
            'bpmn:EscalationEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_ESCALATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.5, my: 0.2}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:ConditionalEventDefinition': function (parentGfx, event) {
                var pathData = pathMap.getScaledPath('EVENT_CONDITIONAL', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.5, my: 0.222}
                });
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:LinkEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_LINK', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.57, my: 0.263}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:ErrorEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_ERROR', {
                    xScaleFactor: 1.1,
                    yScaleFactor: 1.1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.2, my: 0.722}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:CancelEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_CANCEL_45', {
                    xScaleFactor: 1.0,
                    yScaleFactor: 1.0,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.638, my: -0.055}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                var path = drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
                rotate(path, 45);
                return path;
            },
            'bpmn:CompensateEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_COMPENSATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.22, my: 0.5}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:SignalEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_SIGNAL', {
                    xScaleFactor: 0.9,
                    yScaleFactor: 0.9,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.5, my: 0.2}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: fill,
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:MultipleEventDefinition': function (parentGfx, event, isThrowing) {
                var pathData = pathMap.getScaledPath('EVENT_MULTIPLE', {
                    xScaleFactor: 1.1,
                    yScaleFactor: 1.1,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.222, my: 0.36}
                });
                var fill = isThrowing ? getStrokeColor(event, defaultStrokeColor) : 'none';
                return drawPath(parentGfx, pathData, {strokeWidth: 1, fill: fill});
            },
            'bpmn:ParallelMultipleEventDefinition': function (parentGfx, event) {
                var pathData = pathMap.getScaledPath('EVENT_PARALLEL_MULTIPLE', {
                    xScaleFactor: 1.2,
                    yScaleFactor: 1.2,
                    containerWidth: event.width,
                    containerHeight: event.height,
                    position: {mx: 0.458, my: 0.194}
                });
                return drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getStrokeColor(event, defaultStrokeColor),
                    stroke: getStrokeColor(event, defaultStrokeColor)
                });
            },
            'bpmn:EndEvent': function (parentGfx, element) {
                var circle = renderer('bpmn:Event')(parentGfx, element, {
                    strokeWidth: 4,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                renderEventContent(element, parentGfx, true);
                return circle;
            },
            'bpmn:TerminateEventDefinition': function (parentGfx, element) {
                var circle = drawCircle(parentGfx, element.width, element.height, 8, {
                    strokeWidth: 3,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return circle;
            },
            'bpmn:IntermediateEvent': function (parentGfx, element) {
                var outer = renderer('bpmn:Event')(parentGfx, element, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                drawCircle(parentGfx, element.width, element.height, INNER_OUTER_DIST, {
                    strokeWidth: 1,
                    fill: getFillColor(element, 'none'),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                renderEventContent(element, parentGfx);
                return outer;
            },
            'bpmn:IntermediateCatchEvent': as('bpmn:IntermediateEvent'),
            'bpmn:IntermediateThrowEvent': as('bpmn:IntermediateEvent'),
            'bpmn:Activity': function (parentGfx, element, attrs) {
                attrs = attrs || {};
                if (!('fillOpacity' in attrs)) {
                    attrs.fillOpacity = DEFAULT_FILL_OPACITY;
                }
                return drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS, attrs);
            },
            'bpmn:Task': function (parentGfx, element) {
                var attrs = {
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                var rect = renderer('bpmn:Activity')(parentGfx, element, attrs);
                renderEmbeddedLabel(parentGfx, element, 'center-middle');
                attachTaskMarkers(parentGfx, element);
                return rect;
            },
            'bpmn:ServiceTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var pathDataBG = pathMap.getScaledPath('TASK_TYPE_SERVICE', {abspos: {x: 12, y: 18}});
                drawPath(parentGfx, pathDataBG, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var fillPathData = pathMap.getScaledPath('TASK_TYPE_SERVICE_FILL', {abspos: {x: 17.2, y: 18}});
                drawPath(parentGfx, fillPathData, {strokeWidth: 0, fill: getFillColor(element, defaultFillColor)});
                var pathData = pathMap.getScaledPath('TASK_TYPE_SERVICE', {abspos: {x: 17, y: 22}});
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return task;
            },
            'bpmn:UserTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var x = 15;
                var y = 12;
                var pathData = pathMap.getScaledPath('TASK_TYPE_USER_1', {abspos: {x: x, y: y}});
                drawPath(parentGfx, pathData, {
                    strokeWidth: 0.5,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var pathData2 = pathMap.getScaledPath('TASK_TYPE_USER_2', {abspos: {x: x, y: y}});
                drawPath(parentGfx, pathData2, {
                    strokeWidth: 0.5,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var pathData3 = pathMap.getScaledPath('TASK_TYPE_USER_3', {abspos: {x: x, y: y}});
                drawPath(parentGfx, pathData3, {
                    strokeWidth: 0.5,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return task;
            },
            'bpmn:ManualTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var pathData = pathMap.getScaledPath('TASK_TYPE_MANUAL', {abspos: {x: 17, y: 15}});
                drawPath(parentGfx, pathData, {
                    strokeWidth: 0.5,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return task;
            },
            'bpmn:SendTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var pathData = pathMap.getScaledPath('TASK_TYPE_SEND', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: 21,
                    containerHeight: 14,
                    position: {mx: 0.285, my: 0.357}
                });
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getFillColor(element, defaultFillColor)
                });
                return task;
            },
            'bpmn:ReceiveTask': function (parentGfx, element) {
                var semantic = getSemantic(element);
                var task = renderer('bpmn:Task')(parentGfx, element);
                var pathData;
                if (semantic.instantiate) {
                    drawCircle(parentGfx, 28, 28, 20 * 0.22, {strokeWidth: 1});
                    pathData = pathMap.getScaledPath('TASK_TYPE_INSTANTIATING_SEND', {abspos: {x: 7.77, y: 9.52}});
                } else {
                    pathData = pathMap.getScaledPath('TASK_TYPE_SEND', {
                        xScaleFactor: 0.9,
                        yScaleFactor: 0.9,
                        containerWidth: 21,
                        containerHeight: 14,
                        position: {mx: 0.3, my: 0.4}
                    });
                }
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return task;
            },
            'bpmn:ScriptTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var pathData = pathMap.getScaledPath('TASK_TYPE_SCRIPT', {abspos: {x: 15, y: 20}});
                drawPath(parentGfx, pathData, {strokeWidth: 1, stroke: getStrokeColor(element, defaultStrokeColor)});
                return task;
            },
            'bpmn:BusinessRuleTask': function (parentGfx, element) {
                var task = renderer('bpmn:Task')(parentGfx, element);
                var headerPathData = pathMap.getScaledPath('TASK_TYPE_BUSINESS_RULE_HEADER', {abspos: {x: 8, y: 8}});
                var businessHeaderPath = drawPath(parentGfx, headerPathData);
                attr$1(businessHeaderPath, {
                    strokeWidth: 1,
                    fill: getFillColor(element, '#aaaaaa'),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var headerData = pathMap.getScaledPath('TASK_TYPE_BUSINESS_RULE_MAIN', {abspos: {x: 8, y: 8}});
                var businessPath = drawPath(parentGfx, headerData);
                attr$1(businessPath, {strokeWidth: 1, stroke: getStrokeColor(element, defaultStrokeColor)});
                return task;
            },
            'bpmn:SubProcess': function (parentGfx, element, attrs) {
                attrs = assign({
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                }, attrs);
                var rect = renderer('bpmn:Activity')(parentGfx, element, attrs);
                var expanded = isExpanded(element);
                if (isEventSubProcess(element)) {
                    attr$1(rect, {strokeDasharray: '1,2'});
                }
                renderEmbeddedLabel(parentGfx, element, expanded ? 'center-top' : 'center-middle');
                if (expanded) {
                    attachTaskMarkers(parentGfx, element);
                } else {
                    attachTaskMarkers(parentGfx, element, ['SubProcessMarker']);
                }
                return rect;
            },
            'bpmn:AdHocSubProcess': function (parentGfx, element) {
                return renderer('bpmn:SubProcess')(parentGfx, element);
            },
            'bpmn:Transaction': function (parentGfx, element) {
                var outer = renderer('bpmn:SubProcess')(parentGfx, element);
                var innerAttrs = styles.style(['no-fill', 'no-events'], {stroke: getStrokeColor(element, defaultStrokeColor)});
                drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS - 2, INNER_OUTER_DIST, innerAttrs);
                return outer;
            },
            'bpmn:CallActivity': function (parentGfx, element) {
                return renderer('bpmn:SubProcess')(parentGfx, element, {strokeWidth: 3});
            },
            'bpmn:Participant': function (parentGfx, element) {
                var attrs = {
                    fillOpacity: DEFAULT_FILL_OPACITY,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                var lane = renderer('bpmn:Lane')(parentGfx, element, attrs);
                var expandedPool = isExpanded(element);
                if (expandedPool) {
                    drawLine(parentGfx, [{x: 30, y: 0}, {
                        x: 30,
                        y: element.height
                    }], {stroke: getStrokeColor(element, defaultStrokeColor)});
                    var text = getSemantic(element).name;
                    renderLaneLabel(parentGfx, text, element);
                } else {
                    var text2 = getSemantic(element).name;
                    renderLabel(parentGfx, text2, {
                        box: element,
                        align: 'center-middle',
                        style: {fill: getStrokeColor(element, defaultStrokeColor)}
                    });
                }
                var participantMultiplicity = !!(getSemantic(element).participantMultiplicity);
                if (participantMultiplicity) {
                    renderer('ParticipantMultiplicityMarker')(parentGfx, element);
                }
                return lane;
            },
            'bpmn:Lane': function (parentGfx, element, attrs) {
                var rect = drawRect(parentGfx, element.width, element.height, 0, assign({
                    fill: getFillColor(element, defaultFillColor),
                    fillOpacity: HIGH_FILL_OPACITY,
                    stroke: getStrokeColor(element, defaultStrokeColor)
                }, attrs));
                var semantic = getSemantic(element);
                if (semantic.$type === 'bpmn:Lane') {
                    var text = semantic.name;
                    renderLaneLabel(parentGfx, text, element);
                }
                return rect;
            },
            'bpmn:InclusiveGateway': function (parentGfx, element) {
                var diamond = renderer('bpmn:Gateway')(parentGfx, element);
                drawCircle(parentGfx, element.width, element.height, element.height * 0.24, {
                    strokeWidth: 2.5,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return diamond;
            },
            'bpmn:ExclusiveGateway': function (parentGfx, element) {
                var diamond = renderer('bpmn:Gateway')(parentGfx, element);
                var pathData = pathMap.getScaledPath('GATEWAY_EXCLUSIVE', {
                    xScaleFactor: 0.4,
                    yScaleFactor: 0.4,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.32, my: 0.3}
                });
                if ((getDi(element).isMarkerVisible)) {
                    drawPath(parentGfx, pathData, {
                        strokeWidth: 1,
                        fill: getStrokeColor(element, defaultStrokeColor),
                        stroke: getStrokeColor(element, defaultStrokeColor)
                    });
                }
                return diamond;
            },
            'bpmn:ComplexGateway': function (parentGfx, element) {
                var diamond = renderer('bpmn:Gateway')(parentGfx, element);
                var pathData = pathMap.getScaledPath('GATEWAY_COMPLEX', {
                    xScaleFactor: 0.5,
                    yScaleFactor: 0.5,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.46, my: 0.26}
                });
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return diamond;
            },
            'bpmn:ParallelGateway': function (parentGfx, element) {
                var diamond = renderer('bpmn:Gateway')(parentGfx, element);
                var pathData = pathMap.getScaledPath('GATEWAY_PARALLEL', {
                    xScaleFactor: 0.6,
                    yScaleFactor: 0.6,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.46, my: 0.2}
                });
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return diamond;
            },
            'bpmn:EventBasedGateway': function (parentGfx, element) {
                var semantic = getSemantic(element);
                var diamond = renderer('bpmn:Gateway')(parentGfx, element);
                drawCircle(parentGfx, element.width, element.height, element.height * 0.20, {
                    strokeWidth: 1,
                    fill: 'none',
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var type = semantic.eventGatewayType;
                var instantiate = !!semantic.instantiate;

                function drawEvent() {
                    var pathData = pathMap.getScaledPath('GATEWAY_EVENT_BASED', {
                        xScaleFactor: 0.18,
                        yScaleFactor: 0.18,
                        containerWidth: element.width,
                        containerHeight: element.height,
                        position: {mx: 0.36, my: 0.44}
                    });
                    var attrs = {
                        strokeWidth: 2,
                        fill: getFillColor(element, 'none'),
                        stroke: getStrokeColor(element, defaultStrokeColor)
                    };
                    drawPath(parentGfx, pathData, attrs);
                }

                if (type === 'Parallel') {
                    var pathData = pathMap.getScaledPath('GATEWAY_PARALLEL', {
                        xScaleFactor: 0.4,
                        yScaleFactor: 0.4,
                        containerWidth: element.width,
                        containerHeight: element.height,
                        position: {mx: 0.474, my: 0.296}
                    });
                    var parallelPath = drawPath(parentGfx, pathData);
                    attr$1(parallelPath, {strokeWidth: 1, fill: 'none'});
                } else if (type === 'Exclusive') {
                    if (!instantiate) {
                        var innerCircle = drawCircle(parentGfx, element.width, element.height, element.height * 0.26);
                        attr$1(innerCircle, {
                            strokeWidth: 1,
                            fill: 'none',
                            stroke: getStrokeColor(element, defaultStrokeColor)
                        });
                    }
                    drawEvent();
                }
                return diamond;
            },
            'bpmn:Gateway': function (parentGfx, element) {
                var attrs = {
                    fill: getFillColor(element, defaultFillColor),
                    fillOpacity: DEFAULT_FILL_OPACITY,
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                return drawDiamond(parentGfx, element.width, element.height, attrs);
            },
            'bpmn:SequenceFlow': function (parentGfx, element) {
                var pathData = createPathFromConnection(element);
                var fill = getFillColor(element, defaultFillColor),
                    stroke = getStrokeColor(element, defaultStrokeColor);
                var attrs = {
                    strokeLinejoin: 'round',
                    markerEnd: marker('sequenceflow-end', fill, stroke),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                var path = drawPath(parentGfx, pathData, attrs);
                var sequenceFlow = getSemantic(element);
                var source;
                if (element.source) {
                    source = element.source.businessObject;
                    if (sequenceFlow.conditionExpression && source.$instanceOf('bpmn:Activity')) {
                        attr$1(path, {markerStart: marker('conditional-flow-marker', fill, stroke)});
                    }
                    if (source.default && (source.$instanceOf('bpmn:Gateway') || source.$instanceOf('bpmn:Activity')) && source.default === sequenceFlow) {
                        attr$1(path, {markerStart: marker('conditional-default-flow-marker', fill, stroke)});
                    }
                }
                return path;
            },
            'bpmn:Association': function (parentGfx, element, attrs) {
                var semantic = getSemantic(element);
                var fill = getFillColor(element, defaultFillColor),
                    stroke = getStrokeColor(element, defaultStrokeColor);
                attrs = assign({
                    strokeDasharray: '0.5, 5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    stroke: getStrokeColor(element, defaultStrokeColor)
                }, attrs || {});
                if (semantic.associationDirection === 'One' || semantic.associationDirection === 'Both') {
                    attrs.markerEnd = marker('association-end', fill, stroke);
                }
                if (semantic.associationDirection === 'Both') {
                    attrs.markerStart = marker('association-start', fill, stroke);
                }
                return drawLine(parentGfx, element.waypoints, attrs);
            },
            'bpmn:DataInputAssociation': function (parentGfx, element) {
                var fill = getFillColor(element, defaultFillColor),
                    stroke = getStrokeColor(element, defaultStrokeColor);
                return renderer('bpmn:Association')(parentGfx, element, {markerEnd: marker('association-end', fill, stroke)});
            },
            'bpmn:DataOutputAssociation': function (parentGfx, element) {
                var fill = getFillColor(element, defaultFillColor),
                    stroke = getStrokeColor(element, defaultStrokeColor);
                return renderer('bpmn:Association')(parentGfx, element, {markerEnd: marker('association-end', fill, stroke)});
            },
            'bpmn:MessageFlow': function (parentGfx, element) {
                var semantic = getSemantic(element), di = getDi(element);
                var fill = getFillColor(element, defaultFillColor),
                    stroke = getStrokeColor(element, defaultStrokeColor);
                var pathData = createPathFromConnection(element);
                var attrs = {
                    markerEnd: marker('messageflow-end', fill, stroke),
                    markerStart: marker('messageflow-start', fill, stroke),
                    strokeDasharray: '10, 12',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '1.5px',
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                var path = drawPath(parentGfx, pathData, attrs);
                if (semantic.messageRef) {
                    var midPoint = path.getPointAtLength(path.getTotalLength() / 2);
                    var markerPathData = pathMap.getScaledPath('MESSAGE_FLOW_MARKER', {
                        abspos: {
                            x: midPoint.x,
                            y: midPoint.y
                        }
                    });
                    var messageAttrs = {strokeWidth: 1};
                    if (di.messageVisibleKind === 'initiating') {
                        messageAttrs.fill = 'white';
                        messageAttrs.stroke = 'black';
                    } else {
                        messageAttrs.fill = '#888';
                        messageAttrs.stroke = 'white';
                    }
                    drawPath(parentGfx, markerPathData, messageAttrs);
                }
                return path;
            },
            'bpmn:DataObject': function (parentGfx, element) {
                var pathData = pathMap.getScaledPath('DATA_OBJECT_PATH', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.474, my: 0.296}
                });
                var elementObject = drawPath(parentGfx, pathData, {
                    fill: getFillColor(element, defaultFillColor),
                    fillOpacity: DEFAULT_FILL_OPACITY,
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                var semantic = getSemantic(element);
                if (isCollection(semantic)) {
                    renderDataItemCollection(parentGfx, element);
                }
                return elementObject;
            },
            'bpmn:DataObjectReference': as('bpmn:DataObject'),
            'bpmn:DataInput': function (parentGfx, element) {
                var arrowPathData = pathMap.getRawPath('DATA_ARROW');
                var elementObject = renderer('bpmn:DataObject')(parentGfx, element);
                drawPath(parentGfx, arrowPathData, {strokeWidth: 1});
                return elementObject;
            },
            'bpmn:DataOutput': function (parentGfx, element) {
                var arrowPathData = pathMap.getRawPath('DATA_ARROW');
                var elementObject = renderer('bpmn:DataObject')(parentGfx, element);
                drawPath(parentGfx, arrowPathData, {strokeWidth: 1, fill: 'black'});
                return elementObject;
            },
            'bpmn:DataStoreReference': function (parentGfx, element) {
                var DATA_STORE_PATH = pathMap.getScaledPath('DATA_STORE', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0, my: 0.133}
                });
                var elementStore = drawPath(parentGfx, DATA_STORE_PATH, {
                    strokeWidth: 2,
                    fill: getFillColor(element, defaultFillColor),
                    fillOpacity: DEFAULT_FILL_OPACITY,
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                return elementStore;
            },
            'bpmn:BoundaryEvent': function (parentGfx, element) {
                var semantic = getSemantic(element), cancel = semantic.cancelActivity;
                var attrs = {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                };
                if (!cancel) {
                    attrs.strokeDasharray = '6';
                    attrs.strokeLinecap = 'round';
                }
                var outerAttrs = assign({}, attrs, {fillOpacity: 1});
                var innerAttrs = assign({}, attrs, {fill: 'none'});
                var outer = renderer('bpmn:Event')(parentGfx, element, outerAttrs);
                drawCircle(parentGfx, element.width, element.height, INNER_OUTER_DIST, innerAttrs);
                renderEventContent(element, parentGfx);
                return outer;
            },
            'bpmn:Group': function (parentGfx, element) {
                var semantic = getSemantic(element), di = getDi(element);
                var group = drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS, {
                    strokeWidth: 1,
                    strokeDasharray: '8,3,1,3',
                    fill: 'none',
                    pointerEvents: 'none'
                });
                var categoryValueRef = semantic.categoryValueRef || {};
                if (categoryValueRef.value) {
                    var box = di.label ? di.label.bounds : element;
                    renderLabel(parentGfx, categoryValueRef.value, {
                        box: box,
                        style: {fill: getStrokeColor(element, defaultStrokeColor)}
                    });
                }
                return group;
            },
            'label': function (parentGfx, element) {
                return renderExternalLabel(parentGfx, element);
            },
            'bpmn:TextAnnotation': function (parentGfx, element) {
                var style = {'fill': 'none', 'stroke': 'none'};
                var textElement = drawRect(parentGfx, element.width, element.height, 0, 0, style);
                var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.0, my: 0.0}
                });
                drawPath(parentGfx, textPathData, {stroke: getStrokeColor(element, defaultStrokeColor)});
                var text = getSemantic(element).text || '';
                renderLabel(parentGfx, text, {
                    box: element,
                    align: 'left-top',
                    padding: 5,
                    style: {fill: getStrokeColor(element, defaultStrokeColor)}
                });
                return textElement;
            },
            'ParticipantMultiplicityMarker': function (parentGfx, element) {
                var markerPath = pathMap.getScaledPath('MARKER_PARALLEL', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: ((element.width / 2) / element.width), my: (element.height - 15) / element.height}
                });
                drawMarker('participant-multiplicity', parentGfx, markerPath, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            },
            'SubProcessMarker': function (parentGfx, element) {
                var markerRect = drawRect(parentGfx, 14, 14, 0, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
                translate(markerRect, element.width / 2 - 7.5, element.height - 20);
                var markerPath = pathMap.getScaledPath('MARKER_SUB_PROCESS', {
                    xScaleFactor: 1.5,
                    yScaleFactor: 1.5,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: (element.width / 2 - 7.5) / element.width,
                        my: (element.height - 20) / element.height
                    }
                });
                drawMarker('sub-process', parentGfx, markerPath, {
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            },
            'ParallelMarker': function (parentGfx, element, position) {
                var markerPath = pathMap.getScaledPath('MARKER_PARALLEL', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: ((element.width / 2 + position.parallel) / element.width),
                        my: (element.height - 20) / element.height
                    }
                });
                drawMarker('parallel', parentGfx, markerPath, {
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            },
            'SequentialMarker': function (parentGfx, element, position) {
                var markerPath = pathMap.getScaledPath('MARKER_SEQUENTIAL', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: ((element.width / 2 + position.seq) / element.width),
                        my: (element.height - 19) / element.height
                    }
                });
                drawMarker('sequential', parentGfx, markerPath, {
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            },
            'CompensationMarker': function (parentGfx, element, position) {
                var markerMath = pathMap.getScaledPath('MARKER_COMPENSATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: ((element.width / 2 + position.compensation) / element.width),
                        my: (element.height - 13) / element.height
                    }
                });
                drawMarker('compensation', parentGfx, markerMath, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            },
            'LoopMarker': function (parentGfx, element, position) {
                var markerPath = pathMap.getScaledPath('MARKER_LOOP', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: ((element.width / 2 + position.loop) / element.width),
                        my: (element.height - 7) / element.height
                    }
                });
                drawMarker('loop', parentGfx, markerPath, {
                    strokeWidth: 1,
                    fill: getFillColor(element, defaultFillColor),
                    stroke: getStrokeColor(element, defaultStrokeColor),
                    strokeLinecap: 'round',
                    strokeMiterlimit: 0.5
                });
            },
            'AdhocMarker': function (parentGfx, element, position) {
                var markerPath = pathMap.getScaledPath('MARKER_ADHOC', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: ((element.width / 2 + position.adhoc) / element.width),
                        my: (element.height - 15) / element.height
                    }
                });
                drawMarker('adhoc', parentGfx, markerPath, {
                    strokeWidth: 1,
                    fill: getStrokeColor(element, defaultStrokeColor),
                    stroke: getStrokeColor(element, defaultStrokeColor)
                });
            }
        };

        function attachTaskMarkers(parentGfx, element, taskMarkers) {
            var obj = getSemantic(element);
            var subprocess = taskMarkers && taskMarkers.indexOf('SubProcessMarker') !== -1;
            var position;
            if (subprocess) {
                position = {seq: -21, parallel: -22, compensation: -42, loop: -18, adhoc: 10};
            } else {
                position = {seq: -3, parallel: -6, compensation: -27, loop: 0, adhoc: 10};
            }
            forEach(taskMarkers, function (marker) {
                renderer(marker)(parentGfx, element, position);
            });
            if (obj.isForCompensation) {
                renderer('CompensationMarker')(parentGfx, element, position);
            }
            if (obj.$type === 'bpmn:AdHocSubProcess') {
                renderer('AdhocMarker')(parentGfx, element, position);
            }
            var loopCharacteristics = obj.loopCharacteristics,
                isSequential = loopCharacteristics && loopCharacteristics.isSequential;
            if (loopCharacteristics) {
                if (isSequential === undefined) {
                    renderer('LoopMarker')(parentGfx, element, position);
                }
                if (isSequential === false) {
                    renderer('ParallelMarker')(parentGfx, element, position);
                }
                if (isSequential === true) {
                    renderer('SequentialMarker')(parentGfx, element, position);
                }
            }
        }

        function renderDataItemCollection(parentGfx, element) {
            var yPosition = (element.height - 16) / element.height;
            var pathData = pathMap.getScaledPath('DATA_OBJECT_COLLECTION_PATH', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {mx: 0.451, my: yPosition}
            });
            drawPath(parentGfx, pathData, {strokeWidth: 2});
        }

        this._drawPath = drawPath;
    }

    inherits_browser(BpmnRenderer, BaseRenderer);
    BpmnRenderer.$inject = ['config.bpmnRenderer', 'eventBus', 'styles', 'pathMap', 'canvas', 'textRenderer'];
    BpmnRenderer.prototype.canRender = function (element) {
        return is$1(element, 'bpmn:BaseElement');
    };
    BpmnRenderer.prototype.drawShape = function (parentGfx, element) {
        var type = element.type;
        var h = this.handlers[type];
        return h(parentGfx, element);
    };
    BpmnRenderer.prototype.drawConnection = function (parentGfx, element) {
        var type = element.type;
        var h = this.handlers[type];
        return h(parentGfx, element);
    };
    BpmnRenderer.prototype.getShapePath = function (element) {
        if (is$1(element, 'bpmn:Event')) {
            return getCirclePath(element);
        }
        if (is$1(element, 'bpmn:Activity')) {
            return getRoundRectPath(element, TASK_BORDER_RADIUS);
        }
        if (is$1(element, 'bpmn:Gateway')) {
            return getDiamondPath(element);
        }
        return getRectPath(element);
    };
    var DEFAULT_BOX_PADDING = 0;
    var DEFAULT_LABEL_SIZE = {width: 150, height: 50};

    function parseAlign(align) {
        var parts = align.split('-');
        return {horizontal: parts[0] || 'center', vertical: parts[1] || 'top'};
    }

    function parsePadding(padding) {
        if (isObject(padding)) {
            return assign({top: 0, left: 0, right: 0, bottom: 0}, padding);
        } else {
            return {top: padding, left: padding, right: padding, bottom: padding};
        }
    }

    function getTextBBox(text, fakeText) {
        fakeText.textContent = text;
        var textBBox;
        try {
            var bbox, emptyLine = text === '';
            fakeText.textContent = emptyLine ? 'dummy' : text;
            textBBox = fakeText.getBBox();
            bbox = {width: textBBox.width + textBBox.x * 2, height: textBBox.height};
            if (emptyLine) {
                bbox.width = 0;
            }
            return bbox;
        } catch (e) {
            return {width: 0, height: 0};
        }
    }

    function layoutNext(lines, maxWidth, fakeText) {
        var originalLine = lines.shift(), fitLine = originalLine;
        var textBBox;
        for (; ;) {
            textBBox = getTextBBox(fitLine, fakeText);
            textBBox.width = fitLine ? textBBox.width : 0;
            if (fitLine === ' ' || fitLine === '' || textBBox.width < Math.round(maxWidth) || fitLine.length < 2) {
                return fit(lines, fitLine, originalLine, textBBox);
            }
            fitLine = shortenLine(fitLine, textBBox.width, maxWidth);
        }
    }

    function fit(lines, fitLine, originalLine, textBBox) {
        if (fitLine.length < originalLine.length) {
            var remainder = originalLine.slice(fitLine.length).trim();
            lines.unshift(remainder);
        }
        return {width: textBBox.width, height: textBBox.height, text: fitLine};
    }

    function semanticShorten(line, maxLength) {
        var parts = line.split(/(\s|-)/g), part, shortenedParts = [], length = 0;
        if (parts.length > 1) {
            while ((part = parts.shift())) {
                if (part.length + length < maxLength) {
                    shortenedParts.push(part);
                    length += part.length;
                } else {
                    if (part === '-') {
                        shortenedParts.pop();
                    }
                    break;
                }
            }
        }
        return shortenedParts.join('');
    }

    function shortenLine(line, width, maxWidth) {
        var length = Math.max(line.length * (maxWidth / width), 1);
        var shortenedLine = semanticShorten(line, length);
        if (!shortenedLine) {
            shortenedLine = line.slice(0, Math.max(Math.round(length - 1), 1));
        }
        return shortenedLine;
    }

    function getHelperSvg() {
        var helperSvg = document.getElementById('helper-svg');
        if (!helperSvg) {
            helperSvg = create('svg');
            attr$1(helperSvg, {id: 'helper-svg', width: 0, height: 0, style: 'visibility: hidden; position: fixed'});
            document.body.appendChild(helperSvg);
        }
        return helperSvg;
    }

    function Text(config) {
        this._config = assign({}, {
            size: DEFAULT_LABEL_SIZE,
            padding: DEFAULT_BOX_PADDING,
            style: {},
            align: 'center-top'
        }, config || {});
    }

    Text.prototype.createText = function (text, options) {
        return this.layoutText(text, options).element;
    };
    Text.prototype.getDimensions = function (text, options) {
        return this.layoutText(text, options).dimensions;
    };
    Text.prototype.layoutText = function (text, options) {
        var box = assign({}, this._config.size, options.box), style = assign({}, this._config.style, options.style),
            align = parseAlign(options.align || this._config.align),
            padding = parsePadding(options.padding !== undefined ? options.padding : this._config.padding),
            fitBox = options.fitBox || false;
        var lineHeight = getLineHeight(style);
        var lines = text.split(/\r?\n/g), layouted = [];
        var maxWidth = box.width - padding.left - padding.right;
        var helperText = create('text');
        attr$1(helperText, {x: 0, y: 0});
        attr$1(helperText, style);
        var helperSvg = getHelperSvg();
        append(helperSvg, helperText);
        while (lines.length) {
            layouted.push(layoutNext(lines, maxWidth, helperText));
        }
        if (align.vertical === 'middle') {
            padding.top = padding.bottom = 0;
        }
        var totalHeight = reduce(layouted, function (sum, line, idx) {
            return sum + (lineHeight || line.height);
        }, 0) + padding.top + padding.bottom;
        var maxLineWidth = reduce(layouted, function (sum, line, idx) {
            return line.width > sum ? line.width : sum;
        }, 0);
        var y = padding.top;
        if (align.vertical === 'middle') {
            y += (box.height - totalHeight) / 2;
        }
        y -= (lineHeight || layouted[0].height) / 4;
        var textElement = create('text');
        attr$1(textElement, style);
        forEach(layouted, function (line) {
            var x;
            y += (lineHeight || line.height);
            switch (align.horizontal) {
                case'left':
                    x = padding.left;
                    break;
                case'right':
                    x = ((fitBox ? maxLineWidth : maxWidth) - padding.right - line.width);
                    break;
                default:
                    x = Math.max((((fitBox ? maxLineWidth : maxWidth) - line.width) / 2 + padding.left), 0);
            }
            var tspan = create('tspan');
            attr$1(tspan, {x: x, y: y});
            tspan.textContent = line.text;
            append(textElement, tspan);
        });
        remove$1(helperText);
        var dimensions = {width: maxLineWidth, height: totalHeight};
        return {dimensions: dimensions, element: textElement};
    };

    function getLineHeight(style) {
        if ('fontSize' in style && 'lineHeight' in style) {
            return style.lineHeight * parseInt(style.fontSize, 10);
        }
    }

    var DEFAULT_FONT_SIZE = 12;
    var LINE_HEIGHT_RATIO = 1.2;
    var MIN_TEXT_ANNOTATION_HEIGHT = 30;

    function TextRenderer(config) {
        var defaultStyle = assign({
            fontFamily: 'Arial, sans-serif',
            fontSize: DEFAULT_FONT_SIZE,
            fontWeight: 'normal',
            lineHeight: LINE_HEIGHT_RATIO
        }, config && config.defaultStyle || {});
        var fontSize = parseInt(defaultStyle.fontSize, 10) - 1;
        var externalStyle = assign({}, defaultStyle, {fontSize: fontSize}, config && config.externalStyle || {});
        var textUtil = new Text({style: defaultStyle});
        this.getExternalLabelBounds = function (bounds, text) {
            var layoutedDimensions = textUtil.getDimensions(text, {
                box: {
                    width: 90,
                    height: 30,
                    x: bounds.width / 2 + bounds.x,
                    y: bounds.height / 2 + bounds.y
                }, style: externalStyle
            });
            return {
                x: Math.round(bounds.x + bounds.width / 2 - layoutedDimensions.width / 2),
                y: Math.round(bounds.y),
                width: Math.ceil(layoutedDimensions.width),
                height: Math.ceil(layoutedDimensions.height)
            };
        };
        this.getTextAnnotationBounds = function (bounds, text) {
            var layoutedDimensions = textUtil.getDimensions(text, {
                box: bounds,
                style: defaultStyle,
                align: 'left-top',
                padding: 5
            });
            return {
                x: bounds.x,
                y: bounds.y,
                width: bounds.width,
                height: Math.max(MIN_TEXT_ANNOTATION_HEIGHT, Math.round(layoutedDimensions.height))
            };
        };
        this.createText = function (text, options) {
            return textUtil.createText(text, options || {});
        };
        this.getDefaultStyle = function () {
            return defaultStyle;
        };
        this.getExternalStyle = function () {
            return externalStyle;
        };
    }

    TextRenderer.$inject = ['config.textRenderer'];

    function PathMap() {
        this.pathMap = {
            'EVENT_MESSAGE': {
                d: 'm {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}',
                height: 36,
                width: 36,
                heightElements: [6, 14],
                widthElements: [10.5, 21]
            },
            'EVENT_SIGNAL': {
                d: 'M {mx},{my} l {e.x0},{e.y0} l -{e.x1},0 Z',
                height: 36,
                width: 36,
                heightElements: [18],
                widthElements: [10, 20]
            },
            'EVENT_ESCALATION': {
                d: 'M {mx},{my} l {e.x0},{e.y0} l -{e.x0},-{e.y1} l -{e.x0},{e.y1} Z',
                height: 36,
                width: 36,
                heightElements: [20, 7],
                widthElements: [8]
            },
            'EVENT_CONDITIONAL': {
                d: 'M {e.x0},{e.y0} l {e.x1},0 l 0,{e.y2} l -{e.x1},0 Z ' + 'M {e.x2},{e.y3} l {e.x0},0 ' + 'M {e.x2},{e.y4} l {e.x0},0 ' + 'M {e.x2},{e.y5} l {e.x0},0 ' + 'M {e.x2},{e.y6} l {e.x0},0 ' + 'M {e.x2},{e.y7} l {e.x0},0 ' + 'M {e.x2},{e.y8} l {e.x0},0 ',
                height: 36,
                width: 36,
                heightElements: [8.5, 14.5, 18, 11.5, 14.5, 17.5, 20.5, 23.5, 26.5],
                widthElements: [10.5, 14.5, 12.5]
            },
            'EVENT_LINK': {
                d: 'm {mx},{my} 0,{e.y0} -{e.x1},0 0,{e.y1} {e.x1},0 0,{e.y0} {e.x0},-{e.y2} -{e.x0},-{e.y2} z',
                height: 36,
                width: 36,
                heightElements: [4.4375, 6.75, 7.8125],
                widthElements: [9.84375, 13.5]
            },
            'EVENT_ERROR': {
                d: 'm {mx},{my} {e.x0},-{e.y0} {e.x1},-{e.y1} {e.x2},{e.y2} {e.x3},-{e.y3} -{e.x4},{e.y4} -{e.x5},-{e.y5} z',
                height: 36,
                width: 36,
                heightElements: [0.023, 8.737, 8.151, 16.564, 10.591, 8.714],
                widthElements: [0.085, 6.672, 6.97, 4.273, 5.337, 6.636]
            },
            'EVENT_CANCEL_45': {
                d: 'm {mx},{my} -{e.x1},0 0,{e.x0} {e.x1},0 0,{e.y1} {e.x0},0 ' + '0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z',
                height: 36,
                width: 36,
                heightElements: [4.75, 8.5],
                widthElements: [4.75, 8.5]
            },
            'EVENT_COMPENSATION': {
                d: 'm {mx},{my} {e.x0},-{e.y0} 0,{e.y1} z m {e.x1},-{e.y2} {e.x2},-{e.y3} 0,{e.y1} -{e.x2},-{e.y3} z',
                height: 36,
                width: 36,
                heightElements: [6.5, 13, 0.4, 6.1],
                widthElements: [9, 9.3, 8.7]
            },
            'EVENT_TIMER_WH': {
                d: 'M {mx},{my} l {e.x0},-{e.y0} m -{e.x0},{e.y0} l {e.x1},{e.y1} ',
                height: 36,
                width: 36,
                heightElements: [10, 2],
                widthElements: [3, 7]
            },
            'EVENT_TIMER_LINE': {
                d: 'M {mx},{my} ' + 'm {e.x0},{e.y0} l -{e.x1},{e.y1} ',
                height: 36,
                width: 36,
                heightElements: [10, 3],
                widthElements: [0, 0]
            },
            'EVENT_MULTIPLE': {
                d: 'm {mx},{my} {e.x1},-{e.y0} {e.x1},{e.y0} -{e.x0},{e.y1} -{e.x2},0 z',
                height: 36,
                width: 36,
                heightElements: [6.28099, 12.56199],
                widthElements: [3.1405, 9.42149, 12.56198]
            },
            'EVENT_PARALLEL_MULTIPLE': {
                d: 'm {mx},{my} {e.x0},0 0,{e.y1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} ' + '-{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z',
                height: 36,
                width: 36,
                heightElements: [2.56228, 7.68683],
                widthElements: [2.56228, 7.68683]
            },
            'GATEWAY_EXCLUSIVE': {
                d: 'm {mx},{my} {e.x0},{e.y0} {e.x1},{e.y0} {e.x2},0 {e.x4},{e.y2} ' + '{e.x4},{e.y1} {e.x2},0 {e.x1},{e.y3} {e.x0},{e.y3} ' + '{e.x3},0 {e.x5},{e.y1} {e.x5},{e.y2} {e.x3},0 z',
                height: 17.5,
                width: 17.5,
                heightElements: [8.5, 6.5312, -6.5312, -8.5],
                widthElements: [6.5, -6.5, 3, -3, 5, -5]
            },
            'GATEWAY_PARALLEL': {
                d: 'm {mx},{my} 0,{e.y1} -{e.x1},0 0,{e.y0} {e.x1},0 0,{e.y1} {e.x0},0 ' + '0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z',
                height: 30,
                width: 30,
                heightElements: [5, 12.5],
                widthElements: [5, 12.5]
            },
            'GATEWAY_EVENT_BASED': {
                d: 'm {mx},{my} {e.x0},{e.y0} {e.x0},{e.y1} {e.x1},{e.y2} {e.x2},0 z',
                height: 11,
                width: 11,
                heightElements: [-6, 6, 12, -12],
                widthElements: [9, -3, -12]
            },
            'GATEWAY_COMPLEX': {
                d: 'm {mx},{my} 0,{e.y0} -{e.x0},-{e.y1} -{e.x1},{e.y2} {e.x0},{e.y1} -{e.x2},0 0,{e.y3} ' + '{e.x2},0  -{e.x0},{e.y1} l {e.x1},{e.y2} {e.x0},-{e.y1} 0,{e.y0} {e.x3},0 0,-{e.y0} {e.x0},{e.y1} ' + '{e.x1},-{e.y2} -{e.x0},-{e.y1} {e.x2},0 0,-{e.y3} -{e.x2},0 {e.x0},-{e.y1} -{e.x1},-{e.y2} ' + '-{e.x0},{e.y1} 0,-{e.y0} -{e.x3},0 z',
                height: 17.125,
                width: 17.125,
                heightElements: [4.875, 3.4375, 2.125, 3],
                widthElements: [3.4375, 2.125, 4.875, 3]
            },
            'DATA_OBJECT_PATH': {
                d: 'm 0,0 {e.x1},0 {e.x0},{e.y0} 0,{e.y1} -{e.x2},0 0,-{e.y2} {e.x1},0 0,{e.y0} {e.x0},0',
                height: 61,
                width: 51,
                heightElements: [10, 50, 60],
                widthElements: [10, 40, 50, 60]
            },
            'DATA_OBJECT_COLLECTION_PATH': {
                d: 'm {mx}, {my} ' + 'm  0 15  l 0 -15 ' + 'm  4 15  l 0 -15 ' + 'm  4 15  l 0 -15 ',
                height: 61,
                width: 51,
                heightElements: [12],
                widthElements: [1, 6, 12, 15]
            },
            'DATA_ARROW': {
                d: 'm 5,9 9,0 0,-3 5,5 -5,5 0,-3 -9,0 z',
                height: 61,
                width: 51,
                heightElements: [],
                widthElements: []
            },
            'DATA_STORE': {
                d: 'm  {mx},{my} ' + 'l  0,{e.y2} ' + 'c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 ' + 'l  0,-{e.y2} ' + 'c -{e.x0},-{e.y1} -{e.x1},-{e.y1} -{e.x2},0' + 'c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 ' + 'm  -{e.x2},{e.y0}' + 'c  {e.x0},{e.y1} {e.x1},{e.y1} {e.x2},0' + 'm  -{e.x2},{e.y0}' + 'c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0',
                height: 61,
                width: 61,
                heightElements: [7, 10, 45],
                widthElements: [2, 58, 60]
            },
            'TEXT_ANNOTATION': {
                d: 'm {mx}, {my} m 10,0 l -10,0 l 0,{e.y0} l 10,0',
                height: 30,
                width: 10,
                heightElements: [30],
                widthElements: [10]
            },
            'MARKER_SUB_PROCESS': {
                d: 'm{mx},{my} m 7,2 l 0,10 m -5,-5 l 10,0',
                height: 10,
                width: 10,
                heightElements: [],
                widthElements: []
            },
            'MARKER_PARALLEL': {
                d: 'm{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10',
                height: 10,
                width: 10,
                heightElements: [],
                widthElements: []
            },
            'MARKER_SEQUENTIAL': {
                d: 'm{mx},{my} m 0,3 l 10,0 m -10,3 l 10,0 m -10,3 l 10,0',
                height: 10,
                width: 10,
                heightElements: [],
                widthElements: []
            },
            'MARKER_COMPENSATION': {
                d: 'm {mx},{my} 7,-5 0,10 z m 7.1,-0.3 6.9,-4.7 0,10 -6.9,-4.7 z',
                height: 10,
                width: 21,
                heightElements: [],
                widthElements: []
            },
            'MARKER_LOOP': {
                d: 'm {mx},{my} c 3.526979,0 6.386161,-2.829858 6.386161,-6.320661 0,-3.490806 -2.859182,-6.320661 ' + '-6.386161,-6.320661 -3.526978,0 -6.38616,2.829855 -6.38616,6.320661 0,1.745402 ' + '0.714797,3.325567 1.870463,4.469381 0.577834,0.571908 1.265885,1.034728 2.029916,1.35457 ' + 'l -0.718163,-3.909793 m 0.718163,3.909793 -3.885211,0.802902',
                height: 13.9,
                width: 13.7,
                heightElements: [],
                widthElements: []
            },
            'MARKER_ADHOC': {
                d: 'm {mx},{my} m 0.84461,2.64411 c 1.05533,-1.23780996 2.64337,-2.07882 4.29653,-1.97997996 2.05163,0.0805 ' + '3.85579,1.15803 5.76082,1.79107 1.06385,0.34139996 2.24454,0.1438 3.18759,-0.43767 0.61743,-0.33642 ' + '1.2775,-0.64078 1.7542,-1.17511 0,0.56023 0,1.12046 0,1.6807 -0.98706,0.96237996 -2.29792,1.62393996 ' + '-3.6918,1.66181996 -1.24459,0.0927 -2.46671,-0.2491 -3.59505,-0.74812 -1.35789,-0.55965 ' + '-2.75133,-1.33436996 -4.27027,-1.18121996 -1.37741,0.14601 -2.41842,1.13685996 -3.44288,1.96782996 z',
                height: 4,
                width: 15,
                heightElements: [],
                widthElements: []
            },
            'TASK_TYPE_SEND': {
                d: 'm {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}',
                height: 14,
                width: 21,
                heightElements: [6, 14],
                widthElements: [10.5, 21]
            },
            'TASK_TYPE_SCRIPT': {
                d: 'm {mx},{my} c 9.966553,-6.27276 -8.000926,-7.91932 2.968968,-14.938 l -8.802728,0 ' + 'c -10.969894,7.01868 6.997585,8.66524 -2.968967,14.938 z ' + 'm -7,-12 l 5,0 ' + 'm -4.5,3 l 4.5,0 ' + 'm -3,3 l 5,0' + 'm -4,3 l 5,0',
                height: 15,
                width: 12.6,
                heightElements: [6, 14],
                widthElements: [10.5, 21]
            },
            'TASK_TYPE_USER_1': {d: 'm {mx},{my} c 0.909,-0.845 1.594,-2.049 1.594,-3.385 0,-2.554 -1.805,-4.62199999 ' + '-4.357,-4.62199999 -2.55199998,0 -4.28799998,2.06799999 -4.28799998,4.62199999 0,1.348 ' + '0.974,2.562 1.89599998,3.405 -0.52899998,0.187 -5.669,2.097 -5.794,4.7560005 v 6.718 ' + 'h 17 v -6.718 c 0,-2.2980005 -5.5279996,-4.5950005 -6.0509996,-4.7760005 z' + 'm -8,6 l 0,5.5 m 11,0 l 0,-5'},
            'TASK_TYPE_USER_2': {d: 'm {mx},{my} m 2.162,1.009 c 0,2.4470005 -2.158,4.4310005 -4.821,4.4310005 ' + '-2.66499998,0 -4.822,-1.981 -4.822,-4.4310005 '},
            'TASK_TYPE_USER_3': {d: 'm {mx},{my} m -6.9,-3.80 c 0,0 2.25099998,-2.358 4.27399998,-1.177 2.024,1.181 4.221,1.537 ' + '4.124,0.965 -0.098,-0.57 -0.117,-3.79099999 -4.191,-4.13599999 -3.57499998,0.001 ' + '-4.20799998,3.36699999 -4.20699998,4.34799999 z'},
            'TASK_TYPE_MANUAL': {
                d: 'm {mx},{my} c 0.234,-0.01 5.604,0.008 8.029,0.004 0.808,0 1.271,-0.172 1.417,-0.752 0.227,-0.898 ' + '-0.334,-1.314 -1.338,-1.316 -2.467,-0.01 -7.886,-0.004 -8.108,-0.004 -0.014,-0.079 0.016,-0.533 0,-0.61 ' + '0.195,-0.042 8.507,0.006 9.616,0.002 0.877,-0.007 1.35,-0.438 1.353,-1.208 0.003,-0.768 -0.479,-1.09 ' + '-1.35,-1.091 -2.968,-0.002 -9.619,-0.013 -9.619,-0.013 v -0.591 c 0,0 5.052,-0.016 7.225,-0.016 ' + '0.888,-0.002 1.354,-0.416 1.351,-1.193 -0.006,-0.761 -0.492,-1.196 -1.361,-1.196 -3.473,-0.005 ' + '-10.86,-0.003 -11.0829995,-0.003 -0.022,-0.047 -0.045,-0.094 -0.069,-0.139 0.3939995,-0.319 ' + '2.0409995,-1.626 2.4149995,-2.017 0.469,-0.4870005 0.519,-1.1650005 0.162,-1.6040005 -0.414,-0.511 ' + '-0.973,-0.5 -1.48,-0.236 -1.4609995,0.764 -6.5999995,3.6430005 -7.7329995,4.2710005 -0.9,0.499 ' + '-1.516,1.253 -1.882,2.19 -0.37000002,0.95 -0.17,2.01 -0.166,2.979 0.004,0.718 -0.27300002,1.345 ' + '-0.055,2.063 0.629,2.087 2.425,3.312 4.859,3.318 4.6179995,0.014 9.2379995,-0.139 13.8569995,-0.158 ' + '0.755,-0.004 1.171,-0.301 1.182,-1.033 0.012,-0.754 -0.423,-0.969 -1.183,-0.973 -1.778,-0.01 ' + '-5.824,-0.004 -6.04,-0.004 10e-4,-0.084 0.003,-0.586 10e-4,-0.67 z'
            },
            'TASK_TYPE_INSTANTIATING_SEND': {d: 'm {mx},{my} l 0,8.4 l 12.6,0 l 0,-8.4 z l 6.3,3.6 l 6.3,-3.6'},
            'TASK_TYPE_SERVICE': {
                d: 'm {mx},{my} v -1.71335 c 0.352326,-0.0705 0.703932,-0.17838 1.047628,-0.32133 ' + '0.344416,-0.14465 0.665822,-0.32133 0.966377,-0.52145 l 1.19431,1.18005 1.567487,-1.57688 ' + '-1.195028,-1.18014 c 0.403376,-0.61394 0.683079,-1.29908 0.825447,-2.01824 l 1.622133,-0.01 ' + 'v -2.2196 l -1.636514,0.01 c -0.07333,-0.35153 -0.178319,-0.70024 -0.323564,-1.04372 ' + '-0.145244,-0.34406 -0.321407,-0.6644 -0.522735,-0.96217 l 1.131035,-1.13631 -1.583305,-1.56293 ' + '-1.129598,1.13589 c -0.614052,-0.40108 -1.302883,-0.68093 -2.022633,-0.82247 l 0.0093,-1.61852 ' + 'h -2.241173 l 0.0042,1.63124 c -0.353763,0.0736 -0.705369,0.17977 -1.049785,0.32371 -0.344415,0.14437 ' + '-0.665102,0.32092 -0.9635006,0.52046 l -1.1698628,-1.15823 -1.5667691,1.5792 1.1684265,1.15669 ' + 'c -0.4026573,0.61283 -0.68308,1.29797 -0.8247287,2.01713 l -1.6588041,0.003 v 2.22174 ' + 'l 1.6724648,-0.006 c 0.073327,0.35077 0.1797598,0.70243 0.3242851,1.04472 0.1452428,0.34448 ' + '0.3214064,0.6644 0.5227339,0.96066 l -1.1993431,1.19723 1.5840256,1.56011 1.1964668,-1.19348 ' + 'c 0.6140517,0.40346 1.3028827,0.68232 2.0233517,0.82331 l 7.19e-4,1.69892 h 2.226848 z ' + 'm 0.221462,-3.9957 c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 ' + '0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 ' + '0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z'
            },
            'TASK_TYPE_SERVICE_FILL': {d: 'm {mx},{my} c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 ' + '0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 ' + '0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z'},
            'TASK_TYPE_BUSINESS_RULE_HEADER': {d: 'm {mx},{my} 0,4 20,0 0,-4 z'},
            'TASK_TYPE_BUSINESS_RULE_MAIN': {d: 'm {mx},{my} 0,12 20,0 0,-12 z' + 'm 0,8 l 20,0 ' + 'm -13,-4 l 0,8'},
            'MESSAGE_FLOW_MARKER': {d: 'm {mx},{my} m -10.5 ,-7 l 0,14 l 21,0 l 0,-14 z l 10.5,6 l 10.5,-6'}
        };
        this.getRawPath = function getRawPath(pathId) {
            return this.pathMap[pathId].d;
        };
        this.getScaledPath = function getScaledPath(pathId, param) {
            var rawPath = this.pathMap[pathId];
            var mx, my;
            if (param.abspos) {
                mx = param.abspos.x;
                my = param.abspos.y;
            } else {
                mx = param.containerWidth * param.position.mx;
                my = param.containerHeight * param.position.my;
            }
            var coordinates = {};
            if (param.position) {
                var heightRatio = (param.containerHeight / rawPath.height) * param.yScaleFactor;
                var widthRatio = (param.containerWidth / rawPath.width) * param.xScaleFactor;
                for (var heightIndex = 0; heightIndex < rawPath.heightElements.length; heightIndex++) {
                    coordinates['y' + heightIndex] = rawPath.heightElements[heightIndex] * heightRatio;
                }
                for (var widthIndex = 0; widthIndex < rawPath.widthElements.length; widthIndex++) {
                    coordinates['x' + widthIndex] = rawPath.widthElements[widthIndex] * widthRatio;
                }
            }
            var path = format(rawPath.d, {mx: mx, my: my, e: coordinates});
            return path;
        };
    }

    var tokenRegex = /\{([^}]+)\}/g, objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g;

    function replacer(all, key, obj) {
        var res = obj;
        key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
            name = name || quotedName;
            if (res) {
                if (name in res) {
                    res = res[name];
                }
                typeof res == 'function' && isFunc && (res = res());
            }
        });
        res = (res == null || res == obj ? all : res) + '';
        return res;
    }

    function format(str, obj) {
        return String(str).replace(tokenRegex, function (all, key) {
            return replacer(all, key, obj);
        });
    }

    var DrawModule$1 = {
        __init__: ['bpmnRenderer'],
        bpmnRenderer: ['type', BpmnRenderer],
        textRenderer: ['type', TextRenderer],
        pathMap: ['type', PathMap]
    };

    function translate$1(template, replacements) {
        replacements = replacements || {};
        return template.replace(/{([^}]+)}/g, function (_, key) {
            return replacements[key] || '{' + key + '}';
        });
    }

    var translate$2 = {translate: ['value', translate$1]};
    var DEFAULT_LABEL_SIZE$1 = {width: 90, height: 20};
    var FLOW_LABEL_INDENT = 15;

    function isLabelExternal(semantic) {
        return is$1(semantic, 'bpmn:Event') || is$1(semantic, 'bpmn:Gateway') || is$1(semantic, 'bpmn:DataStoreReference') || is$1(semantic, 'bpmn:DataObjectReference') || is$1(semantic, 'bpmn:SequenceFlow') || is$1(semantic, 'bpmn:MessageFlow');
    }

    function hasExternalLabel(element) {
        return isLabel(element.label);
    }

    function getFlowLabelPosition(waypoints) {
        var mid = waypoints.length / 2 - 1;
        var first = waypoints[Math.floor(mid)];
        var second = waypoints[Math.ceil(mid + 0.01)];
        var position = getWaypointsMid(waypoints);
        var angle = Math.atan((second.y - first.y) / (second.x - first.x));
        var x = position.x, y = position.y;
        if (Math.abs(angle) < Math.PI / 2) {
            y -= FLOW_LABEL_INDENT;
        } else {
            x += FLOW_LABEL_INDENT;
        }
        return {x: x, y: y};
    }

    function getWaypointsMid(waypoints) {
        var mid = waypoints.length / 2 - 1;
        var first = waypoints[Math.floor(mid)];
        var second = waypoints[Math.ceil(mid + 0.01)];
        return {x: first.x + (second.x - first.x) / 2, y: first.y + (second.y - first.y) / 2};
    }

    function getExternalLabelMid(element) {
        if (element.waypoints) {
            return getFlowLabelPosition(element.waypoints);
        } else {
            return {x: element.x + element.width / 2, y: element.y + element.height + DEFAULT_LABEL_SIZE$1.height / 2};
        }
    }

    function getExternalLabelBounds(semantic, element) {
        var mid, size$$1, bounds, di = semantic.di, label = di.label;
        if (label && label.bounds) {
            bounds = label.bounds;
            size$$1 = {width: Math.max(DEFAULT_LABEL_SIZE$1.width, bounds.width), height: bounds.height};
            mid = {x: bounds.x + bounds.width / 2, y: bounds.y + bounds.height / 2};
        } else {
            mid = getExternalLabelMid(element);
            size$$1 = DEFAULT_LABEL_SIZE$1;
        }
        return assign({x: mid.x - size$$1.width / 2, y: mid.y - size$$1.height / 2}, size$$1);
    }

    function isLabel(element) {
        return element && element.labelTarget;
    }

    function pointDistance(a, b) {
        if (!a || !b) {
            return -1;
        }
        return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
    }

    function pointsOnLine(p, q, r, accuracy) {
        if (typeof accuracy === 'undefined') {
            accuracy = 5;
        }
        if (!p || !q || !r) {
            return false;
        }
        var val = (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x), dist = pointDistance(p, q);
        return Math.abs(val / dist) <= accuracy;
    }

    var ALIGNED_THRESHOLD = 2;

    function pointsAligned(a, b) {
        if (Math.abs(a.x - b.x) <= ALIGNED_THRESHOLD) {
            return 'h';
        }
        if (Math.abs(a.y - b.y) <= ALIGNED_THRESHOLD) {
            return 'v';
        }
        return false;
    }

    function pointInRect(p, rect, tolerance) {
        tolerance = tolerance || 0;
        return p.x > rect.x - tolerance && p.y > rect.y - tolerance && p.x < rect.x + rect.width + tolerance && p.y < rect.y + rect.height + tolerance;
    }

    function getMidPoint(p, q) {
        return {x: Math.round(p.x + ((q.x - p.x) / 2.0)), y: Math.round(p.y + ((q.y - p.y) / 2.0))};
    }

    var has$1 = 'hasOwnProperty', p2s = /,?([a-z]),?/gi, toFloat = parseFloat, math = Math, PI = math.PI,
        mmin = math.min, mmax = math.max, pow = math.pow, abs = math.abs,
        pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[-+]?\d+)?[\s]*,?[\s]*)+)/ig,
        pathValues = /(-?\d*\.?\d*(?:e[-+]?\\d+)?)[\s]*,?[\s]*/ig;

    function is$2(o, type) {
        type = String.prototype.toLowerCase.call(type);
        if (type == 'finite') {
            return isFinite(o);
        }
        if (type == 'array' && (o instanceof Array || Array.isArray && Array.isArray(o))) {
            return true;
        }
        return (type == 'null' && o === null) || (type == typeof o && o !== null) || (type == 'object' && o === Object(o)) || Object.prototype.toString.call(o).slice(8, -1).toLowerCase() == type;
    }

    function clone$1(obj) {
        if (typeof obj == 'function' || Object(obj) !== obj) {
            return obj;
        }
        var res = new obj.constructor;
        for (var key in obj) if (obj[has$1](key)) {
            res[key] = clone$1(obj[key]);
        }
        return res;
    }

    function repush(array, item) {
        for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
            return array.push(array.splice(i, 1)[0]);
        }
    }

    function cacher(f, scope, postprocessor) {
        function newf() {
            var arg = Array.prototype.slice.call(arguments, 0), args = arg.join('\u2400'),
                cache = newf.cache = newf.cache || {}, count = newf.count = newf.count || [];
            if (cache[has$1](args)) {
                repush(count, args);
                return postprocessor ? postprocessor(cache[args]) : cache[args];
            }
            count.length >= 1e3 && delete cache[count.shift()];
            count.push(args);
            cache[args] = f.apply(scope, arg);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }

        return newf;
    }

    function parsePathString(pathString) {
        if (!pathString) {
            return null;
        }
        var pth = paths(pathString);
        if (pth.arr) {
            return clone$1(pth.arr);
        }
        var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0}, data = [];
        if (is$2(pathString, 'array') && is$2(pathString[0], 'array')) {
            data = clone$1(pathString);
        }
        if (!data.length) {
            String(pathString).replace(pathCommand, function (a, b, c) {
                var params = [], name = b.toLowerCase();
                c.replace(pathValues, function (a, b) {
                    b && params.push(+b);
                });
                if (name == 'm' && params.length > 2) {
                    data.push([b].concat(params.splice(0, 2)));
                    name = 'l';
                    b = b == 'm' ? 'l' : 'L';
                }
                if (name == 'o' && params.length == 1) {
                    data.push([b, params[0]]);
                }
                if (name == 'r') {
                    data.push([b].concat(params));
                } else while (params.length >= paramCounts[name]) {
                    data.push([b].concat(params.splice(0, paramCounts[name])));
                    if (!paramCounts[name]) {
                        break;
                    }
                }
            });
        }
        data.toString = paths.toString;
        pth.arr = clone$1(data);
        return data;
    }

    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {sleep: 100};
        }
        setTimeout(function () {
            for (var key in p) if (p[has$1](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }

    function box(x, y, width, height) {
        if (x == null) {
            x = y = width = height = 0;
        }
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math.min(width, height) / 2,
            r2: math.max(width, height) / 2,
            r0: math.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [x, y, width, height].join(' ')
        };
    }

    function pathToString() {
        return this.join(',').replace(p2s, '$1');
    }

    function pathClone(pathArray) {
        var res = clone$1(pathArray);
        res.toString = pathToString;
        return res;
    }

    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t, t13 = pow(t1, 3), t12 = pow(t1, 2), t2 = t * t, t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y), ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y, cx = t1 * c2x + t * p2x, cy = t1 * c2y + t * p2y,
            alpha = (90 - math.atan2(mx - nx, my - ny) * 180 / PI);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    }

    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!is$2(p1x, 'array')) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveBBox.apply(null, p1x);
        return box(bbox.min.x, bbox.min.y, bbox.max.x - bbox.min.x, bbox.max.y - bbox.min.y);
    }

    function isPointInsideBBox(bbox, x, y) {
        return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }

    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }

    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4, t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }

    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2, n = 12,
            Tvalues = [-.1252, .1252, -.3678, .3678, -.5873, .5873, -.7699, .7699, -.9041, .9041, -.9816, .9816],
            Cvalues = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032, 0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2, xbase = base3(ct, x1, x2, x3, x4), ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }

    function intersectLines(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (mmax(x1, x2) < mmin(x3, x4) || mmin(x1, x2) > mmax(x3, x4) || mmax(y1, y2) < mmin(y3, y4) || mmin(y1, y2) > mmax(y3, y4)) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (!denominator) {
            return;
        }
        var px = nx / denominator, py = ny / denominator, px2 = +px.toFixed(2), py2 = +py.toFixed(2);
        if (px2 < +mmin(x1, x2).toFixed(2) || px2 > +mmax(x1, x2).toFixed(2) || px2 < +mmin(x3, x4).toFixed(2) || px2 > +mmax(x3, x4).toFixed(2) || py2 < +mmin(y1, y2).toFixed(2) || py2 > +mmax(y1, y2).toFixed(2) || py2 < +mmin(y3, y4).toFixed(2) || py2 > +mmax(y3, y4).toFixed(2)) {
            return;
        }
        return {x: px, y: py};
    }

    function findBezierIntersections(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1), bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1), l2 = bezlen.apply(0, bez2), n1 = ~~(l1 / 5), n2 = ~~(l2 / 5), dots1 = [],
            dots2 = [], xy = {}, res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i], di1 = dots1[i + 1], dj = dots2[j], dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .01 ? 'y' : 'x', cj = abs(dj1.x - dj.x) < .01 ? 'y' : 'x',
                    is = intersectLines(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(0)] == is.y.toFixed(0)) {
                        continue;
                    }
                    xy[is.x.toFixed(0)] = is.y.toFixed(0);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({x: is.x, y: is.y, t1: t1, t2: t2});
                        }
                    }
                }
            }
        }
        return res;
    }

    function findPathIntersections(path1, path2, justCount) {
        path1 = pathToCurve(path1);
        path2 = pathToCurve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2, res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == 'M') {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == 'C') {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == 'M') {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == 'C') {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = findBezierIntersections(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }

    function rectPath(x, y, w, h, r) {
        if (r) {
            return [['M', +x + (+r), y], ['l', w - r * 2, 0], ['a', r, r, 0, 0, 1, r, r], ['l', 0, h - r * 2], ['a', r, r, 0, 0, 1, -r, r], ['l', r * 2 - w, 0], ['a', r, r, 0, 0, 1, -r, -r], ['l', 0, r * 2 - h], ['a', r, r, 0, 0, 1, r, -r], ['z']];
        }
        var res = [['M', x, y], ['l', w, 0], ['l', 0, h], ['l', -w, 0], ['z']];
        res.toString = pathToString;
        return res;
    }

    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) {
            ry = rx;
        }
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) {
            var rad = Math.PI / 180, x1 = x + rx * Math.cos(-ry * rad), x2 = x + rx * Math.cos(-a * rad),
                y1 = y + rx * Math.sin(-ry * rad), y2 = y + rx * Math.sin(-a * rad),
                res = [['M', x1, y1], ['A', rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
        } else {
            res = [['M', x, y], ['m', 0, -ry], ['a', rx, ry, 0, 1, 1, 0, 2 * ry], ['a', rx, ry, 0, 1, 1, 0, -2 * ry], ['z']];
        }
        res.toString = pathToString;
        return res;
    }

    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
            return pathClone(pth.abs);
        }
        if (!is$2(pathArray, 'array') || !is$2(pathArray && pathArray[0], 'array')) {
            pathArray = parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
            return [['M', 0, 0]];
        }
        var res = [], x = 0, y = 0, mx = 0, my = 0, start = 0, pa0;
        if (pathArray[0][0] == 'M') {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res[0] = ['M', x, y];
        }
        var crz = pathArray.length == 3 && pathArray[0][0] == 'M' && pathArray[1][0].toUpperCase() == 'R' && pathArray[2][0].toUpperCase() == 'Z';
        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
            res.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch (r[0]) {
                    case'A':
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case'V':
                        r[1] = +pa[1] + y;
                        break;
                    case'H':
                        r[1] = +pa[1] + x;
                        break;
                    case'R':
                        var dots = [x, y].concat(pa.slice(1));
                        for (var j = 2, jj = dots.length; j < jj; j++) {
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res.pop();
                        res = res.concat(catmulRomToBezier(dots, crz));
                        break;
                    case'O':
                        res.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res = res.concat(dots);
                        break;
                    case'U':
                        res.pop();
                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = ['U'].concat(res[res.length - 1].slice(-2));
                        break;
                    case'M':
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for (j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +pa[j] + ((j % 2) ? x : y);
                        }
                }
            } else if (pa0 == 'R') {
                dots = [x, y].concat(pa.slice(1));
                res.pop();
                res = res.concat(catmulRomToBezier(dots, crz));
                r = ['R'].concat(pa.slice(-2));
            } else if (pa0 == 'O') {
                res.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
            } else if (pa0 == 'U') {
                res.pop();
                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = ['U'].concat(res[res.length - 1].slice(-2));
            } else {
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    r[k] = pa[k];
                }
            }
            pa0 = pa0.toUpperCase();
            if (pa0 != 'O') {
                switch (r[0]) {
                    case'Z':
                        x = +mx;
                        y = +my;
                        break;
                    case'H':
                        x = r[1];
                        break;
                    case'V':
                        y = r[1];
                        break;
                    case'M':
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
        }
        res.toString = pathToString;
        pth.abs = pathClone(res);
        return res;
    }

    function lineToCurve(x1, y1, x2, y2) {
        return [x1, y1, x2, y2, x2, y2];
    }

    function qubicToCurve(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3, _23 = 2 / 3;
        return [_13 * x1 + _23 * ax, _13 * y1 + _23 * ay, _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2];
    }

    function arcToCurve(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        var _120 = PI * 120 / 180, rad = PI / 180 * (+angle || 0), res = [], xy, rotate = cacher(function (x, y, rad) {
            var X = x * math.cos(rad) - y * math.sin(rad), Y = x * math.sin(rad) + y * math.cos(rad);
            return {x: X, y: Y};
        });
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var x = (x1 - x2) / 2, y = (y1 - y2) / 2;
            var h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
            if (h > 1) {
                h = math.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx, ry2 = ry * ry,
                k = (large_arc_flag == sweep_flag ? -1 : 1) * math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                cx = k * rx * y / ry + (x1 + x2) / 2, cy = k * -ry * x / rx + (y1 + y2) / 2,
                f1 = math.asin(((y1 - cy) / ry).toFixed(9)), f2 = math.asin(((y2 - cy) / ry).toFixed(9));
            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) {
                f1 = f1 - PI * 2;
            }
            if (!sweep_flag && f2 > f1) {
                f2 = f2 - PI * 2;
            }
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2, x2old = x2, y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math.cos(f2);
            y2 = cy + ry * math.sin(f2);
            res = arcToCurve(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math.cos(f1), s1 = math.sin(f1), c2 = math.cos(f2), s2 = math.sin(f2), t = math.tan(df / 4),
            hx = 4 / 3 * rx * t, hy = 4 / 3 * ry * t, m1 = [x1, y1], m2 = [x1 + hx * s1, y1 - hy * c1],
            m3 = [x2 + hx * s2, y2 - hy * c2], m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
            return [m2, m3, m4].concat(res);
        } else {
            res = [m2, m3, m4].concat(res).join().split(',');
            var newres = [];
            for (var i = 0, ii = res.length; i < ii; i++) {
                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
            }
            return newres;
        }
    }

    function catmulRomToBezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [{x: +crp[i - 2], y: +crp[i - 1]}, {x: +crp[i], y: +crp[i + 1]}, {
                x: +crp[i + 2],
                y: +crp[i + 3]
            }, {x: +crp[i + 4], y: +crp[i + 5]}];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(['C', (-p[0].x + 6 * p[1].x + p[2].x) / 6, (-p[0].y + 6 * p[1].y + p[2].y) / 6, (p[1].x + 6 * p[2].x - p[3].x) / 6, (p[1].y + 6 * p[2].y - p[3].y) / 6, p[2].x, p[2].y]);
        }
        return d;
    }

    function curveBBox(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [], bounds = [[], []], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for (var i = 0; i < 2; ++i) {
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) {
                    continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                    tvalues.push(t);
                }
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math.sqrt(b2ac);
            if (b2ac < 0) {
                continue;
            }
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
            }
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
            }
        }
        var j = tvalues.length, jlen = j, mt;
        while (j--) {
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
            bounds[1][j] = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
        }
        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;
        return {
            min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
            max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
        };
    }

    function pathToCurve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) {
            return pathClone(pth.curve);
        }
        var p = pathToAbsolute(path), p2 = path2 && pathToAbsolute(path2),
            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            processPath = function (path, d, pcom) {
                var nx, ny;
                if (!path) {
                    return ['C', d.x, d.y, d.x, d.y, d.x, d.y];
                }
                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
                switch (path[0]) {
                    case'M':
                        d.X = path[1];
                        d.Y = path[2];
                        break;
                    case'A':
                        path = ['C'].concat(arcToCurve.apply(0, [d.x, d.y].concat(path.slice(1))));
                        break;
                    case'S':
                        if (pcom == 'C' || pcom == 'S') {
                            nx = d.x * 2 - d.bx;
                            ny = d.y * 2 - d.by;
                        } else {
                            nx = d.x;
                            ny = d.y;
                        }
                        path = ['C', nx, ny].concat(path.slice(1));
                        break;
                    case'T':
                        if (pcom == 'Q' || pcom == 'T') {
                            d.qx = d.x * 2 - d.qx;
                            d.qy = d.y * 2 - d.qy;
                        } else {
                            d.qx = d.x;
                            d.qy = d.y;
                        }
                        path = ['C'].concat(qubicToCurve(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                        break;
                    case'Q':
                        d.qx = path[1];
                        d.qy = path[2];
                        path = ['C'].concat(qubicToCurve(d.x, d.y, path[1], path[2], path[3], path[4]));
                        break;
                    case'L':
                        path = ['C'].concat(lineToCurve(d.x, d.y, path[1], path[2]));
                        break;
                    case'H':
                        path = ['C'].concat(lineToCurve(d.x, d.y, path[1], d.y));
                        break;
                    case'V':
                        path = ['C'].concat(lineToCurve(d.x, d.y, d.x, path[1]));
                        break;
                    case'Z':
                        path = ['C'].concat(lineToCurve(d.x, d.y, d.X, d.Y));
                        break;
                }
                return path;
            }, fixArc = function (pp, i) {
                if (pp[i].length > 7) {
                    pp[i].shift();
                    var pi = pp[i];
                    while (pi.length) {
                        pcoms1[i] = 'A';
                        p2 && (pcoms2[i] = 'A');
                        pp.splice(i++, 0, ['C'].concat(pi.splice(0, 6)));
                    }
                    pp.splice(i, 1);
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            }, fixM = function (path1, path2, a1, a2, i) {
                if (path1 && path2 && path1[i][0] == 'M' && path2[i][0] != 'M') {
                    path2.splice(i, 0, ['M', a2.x, a2.y]);
                    a1.bx = 0;
                    a1.by = 0;
                    a1.x = path1[i][1];
                    a1.y = path1[i][2];
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            }, pcoms1 = [], pcoms2 = [], pfirst = '', pcom = '';
        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
            p[i] && (pfirst = p[i][0]);
            if (pfirst != 'C') {
                pcoms1[i] = pfirst;
                i && (pcom = pcoms1[i - 1]);
            }
            p[i] = processPath(p[i], attrs, pcom);
            if (pcoms1[i] != 'A' && pfirst == 'C') pcoms1[i] = 'C';
            fixArc(p, i);
            if (p2) {
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != 'C') {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);
                if (pcoms2[i] != 'A' && pfirst == 'C') {
                    pcoms2[i] = 'C';
                }
                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i], seg2 = p2 && p2[i], seglen = seg.length, seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) {
            pth.curve = pathClone(p);
        }
        return p2 ? [p, p2] : p;
    }

    var intersect = findPathIntersections;

    function roundBounds(bounds) {
        return {
            x: Math.round(bounds.x),
            y: Math.round(bounds.y),
            width: Math.round(bounds.width),
            height: Math.round(bounds.height)
        };
    }

    function roundPoint(point) {
        return {x: Math.round(point.x), y: Math.round(point.y)};
    }

    function asTRBL(bounds) {
        return {
            top: bounds.y,
            right: bounds.x + (bounds.width || 0),
            bottom: bounds.y + (bounds.height || 0),
            left: bounds.x
        };
    }

    function asBounds(trbl) {
        return {x: trbl.left, y: trbl.top, width: trbl.right - trbl.left, height: trbl.bottom - trbl.top};
    }

    function getMid(bounds) {
        return roundPoint({x: bounds.x + (bounds.width || 0) / 2, y: bounds.y + (bounds.height || 0) / 2});
    }

    function getOrientation(rect, reference, padding) {
        padding = padding || 0;
        if (!isObject(padding)) {
            padding = {x: padding, y: padding};
        }
        var rectOrientation = asTRBL(rect), referenceOrientation = asTRBL(reference);
        var top = rectOrientation.bottom + padding.y <= referenceOrientation.top,
            right = rectOrientation.left - padding.x >= referenceOrientation.right,
            bottom = rectOrientation.top - padding.y >= referenceOrientation.bottom,
            left = rectOrientation.right + padding.x <= referenceOrientation.left;
        var vertical = top ? 'top' : (bottom ? 'bottom' : null), horizontal = left ? 'left' : (right ? 'right' : null);
        if (horizontal && vertical) {
            return vertical + '-' + horizontal;
        } else {
            return horizontal || vertical || 'intersect';
        }
    }

    function getElementLineIntersection(elementPath, linePath, cropStart) {
        var intersections = getIntersections(elementPath, linePath);
        if (intersections.length === 1) {
            return roundPoint(intersections[0]);
        } else if (intersections.length === 2 && pointDistance(intersections[0], intersections[1]) < 1) {
            return roundPoint(intersections[0]);
        } else if (intersections.length > 1) {
            intersections = sortBy(intersections, function (i) {
                var distance = Math.floor(i.t2 * 100) || 1;
                distance = 100 - distance;
                distance = (distance < 10 ? '0' : '') + distance;
                return i.segment2 + '#' + distance;
            });
            return roundPoint(intersections[cropStart ? 0 : intersections.length - 1]);
        }
        return null;
    }

    function getIntersections(a, b) {
        return intersect(a, b);
    }

    function elementData(semantic, attrs) {
        return assign({id: semantic.id, type: semantic.$type, businessObject: semantic}, attrs);
    }

    function collectWaypoints(waypoints) {
        return map(waypoints, function (p) {
            return {x: p.x, y: p.y};
        });
    }

    function notYetDrawn(translate, semantic, refSemantic, property) {
        return new Error(translate('element {element} referenced by {referenced}#{property} not yet drawn', {
            element: elementToString(refSemantic),
            referenced: elementToString(semantic),
            property: property
        }));
    }

    function BpmnImporter(eventBus, canvas, elementFactory, elementRegistry, translate, textRenderer) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._elementFactory = elementFactory;
        this._elementRegistry = elementRegistry;
        this._translate = translate;
        this._textRenderer = textRenderer;
    }

    BpmnImporter.$inject = ['eventBus', 'canvas', 'elementFactory', 'elementRegistry', 'translate', 'textRenderer'];
    BpmnImporter.prototype.add = function (semantic, parentElement) {
        var di = semantic.di, element, translate = this._translate, hidden;
        var parentIndex;
        if (is$1(di, 'bpmndi:BPMNPlane')) {
            element = this._elementFactory.createRoot(elementData(semantic));
            this._canvas.setRootElement(element);
        } else if (is$1(di, 'bpmndi:BPMNShape')) {
            var collapsed = !isExpanded(semantic);
            hidden = parentElement && (parentElement.hidden || parentElement.collapsed);
            var bounds = semantic.di.bounds;
            element = this._elementFactory.createShape(elementData(semantic, {
                collapsed: collapsed,
                hidden: hidden,
                x: Math.round(bounds.x),
                y: Math.round(bounds.y),
                width: Math.round(bounds.width),
                height: Math.round(bounds.height)
            }));
            if (is$1(semantic, 'bpmn:BoundaryEvent')) {
                this._attachBoundary(semantic, element);
            }
            if (is$1(semantic, 'bpmn:Lane')) {
                parentIndex = 0;
            }
            if (is$1(semantic, 'bpmn:DataStoreReference')) {
                if (!isPointInsideBBox$1(parentElement, getMid(bounds))) {
                    parentElement = this._canvas.getRootElement();
                }
            }
            this._canvas.addShape(element, parentElement, parentIndex);
        } else if (is$1(di, 'bpmndi:BPMNEdge')) {
            var source = this._getSource(semantic), target = this._getTarget(semantic);
            hidden = parentElement && (parentElement.hidden || parentElement.collapsed);
            element = this._elementFactory.createConnection(elementData(semantic, {
                hidden: hidden,
                source: source,
                target: target,
                waypoints: collectWaypoints(semantic.di.waypoint)
            }));
            if (is$1(semantic, 'bpmn:DataAssociation')) {
                parentElement = null;
            }
            if (is$1(semantic, 'bpmn:SequenceFlow')) {
                parentIndex = 0;
            }
            this._canvas.addConnection(element, parentElement, parentIndex);
        } else {
            throw new Error(translate('unknown di {di} for element {semantic}', {
                di: elementToString(di),
                semantic: elementToString(semantic)
            }));
        }
        if (isLabelExternal(semantic) && semantic.name) {
            this.addLabel(semantic, element);
        }
        this._eventBus.fire('bpmnElement.added', {element: element});
        return element;
    };
    BpmnImporter.prototype._attachBoundary = function (boundarySemantic, boundaryElement) {
        var translate = this._translate;
        var hostSemantic = boundarySemantic.attachedToRef;
        if (!hostSemantic) {
            throw new Error(translate('missing {semantic}#attachedToRef', {semantic: elementToString(boundarySemantic)}));
        }
        var host = this._elementRegistry.get(hostSemantic.id), attachers = host && host.attachers;
        if (!host) {
            throw notYetDrawn(translate, boundarySemantic, hostSemantic, 'attachedToRef');
        }
        boundaryElement.host = host;
        if (!attachers) {
            host.attachers = attachers = [];
        }
        if (attachers.indexOf(boundaryElement) === -1) {
            attachers.push(boundaryElement);
        }
    };
    BpmnImporter.prototype.addLabel = function (semantic, element) {
        var bounds, text, label;
        bounds = getExternalLabelBounds(semantic, element);
        text = semantic.name;
        if (text) {
            bounds = this._textRenderer.getExternalLabelBounds(bounds, text);
        }
        label = this._elementFactory.createLabel(elementData(semantic, {
            id: semantic.id + '_label',
            labelTarget: element,
            type: 'label',
            hidden: element.hidden || !semantic.name,
            x: Math.round(bounds.x),
            y: Math.round(bounds.y),
            width: Math.round(bounds.width),
            height: Math.round(bounds.height)
        }));
        return this._canvas.addShape(label, element.parent);
    };
    BpmnImporter.prototype._getEnd = function (semantic, side) {
        var element, refSemantic, type = semantic.$type, translate = this._translate;
        refSemantic = semantic[side + 'Ref'];
        if (side === 'source' && type === 'bpmn:DataInputAssociation') {
            refSemantic = refSemantic && refSemantic[0];
        }
        if (side === 'source' && type === 'bpmn:DataOutputAssociation' || side === 'target' && type === 'bpmn:DataInputAssociation') {
            refSemantic = semantic.$parent;
        }
        element = refSemantic && this._getElement(refSemantic);
        if (element) {
            return element;
        }
        if (refSemantic) {
            throw notYetDrawn(translate, semantic, refSemantic, side + 'Ref');
        } else {
            throw new Error(translate('{semantic}#{side} Ref not specified', {
                semantic: elementToString(semantic),
                side: side
            }));
        }
    };
    BpmnImporter.prototype._getSource = function (semantic) {
        return this._getEnd(semantic, 'source');
    };
    BpmnImporter.prototype._getTarget = function (semantic) {
        return this._getEnd(semantic, 'target');
    };
    BpmnImporter.prototype._getElement = function (semantic) {
        return this._elementRegistry.get(semantic.id);
    };

    function isPointInsideBBox$1(bbox, point) {
        var x = point.x, y = point.y;
        return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }

    var ImportModule = {__depends__: [translate$2], bpmnImporter: ['type', BpmnImporter]};
    var CoreModule$1 = {__depends__: [DrawModule$1, ImportModule]};

    function __stopPropagation(event) {
        if (!event || typeof event.stopPropagation !== 'function') {
            return;
        }
        event.stopPropagation();
    }

    function getOriginal(event) {
        return event.originalEvent || event.srcEvent;
    }

    function stopPropagation(event, immediate) {
        __stopPropagation(event, immediate);
        __stopPropagation(getOriginal(event), immediate);
    }

    function toPoint(event) {
        if (event.pointers && event.pointers.length) {
            event = event.pointers[0];
        }
        if (event.touches && event.touches.length) {
            event = event.touches[0];
        }
        return event ? {x: event.clientX, y: event.clientY} : null;
    }

    function isMac() {
        return (/mac/i).test(navigator.platform);
    }

    function isPrimaryButton(event) {
        return !(getOriginal(event) || event).button;
    }

    function hasPrimaryModifier(event) {
        var originalEvent = getOriginal(event) || event;
        if (!isPrimaryButton(event)) {
            return false;
        }
        if (isMac()) {
            return originalEvent.metaKey;
        } else {
            return originalEvent.ctrlKey;
        }
    }

    function hasSecondaryModifier(event) {
        var originalEvent = getOriginal(event) || event;
        return isPrimaryButton(event) && originalEvent.shiftKey;
    }

    function allowAll(e) {
        return true;
    }

    var LOW_PRIORITY = 500;

    function InteractionEvents(eventBus, elementRegistry, styles) {
        var HIT_STYLE = styles.cls('djs-hit', ['no-fill', 'no-border'], {stroke: 'white', strokeWidth: 15});

        function fire(type, event, element) {
            if (isIgnored(type, event)) {
                return;
            }
            var target, gfx, returnValue;
            if (!element) {
                target = event.delegateTarget || event.target;
                if (target) {
                    gfx = target;
                    element = elementRegistry.get(gfx);
                }
            } else {
                gfx = elementRegistry.getGraphics(element);
            }
            if (!gfx || !element) {
                return;
            }
            returnValue = eventBus.fire(type, {element: element, gfx: gfx, originalEvent: event});
            if (returnValue === false) {
                event.stopPropagation();
                event.preventDefault();
            }
        }

        var handlers = {};

        function mouseHandler(localEventName) {
            return handlers[localEventName];
        }

        function isIgnored(localEventName, event) {
            var filter$$1 = ignoredFilters[localEventName] || isPrimaryButton;
            return !filter$$1(event);
        }

        var bindings = {
            mouseover: 'element.hover',
            mouseout: 'element.out',
            click: 'element.click',
            dblclick: 'element.dblclick',
            mousedown: 'element.mousedown',
            mouseup: 'element.mouseup',
            contextmenu: 'element.contextmenu'
        };
        var ignoredFilters = {'element.contextmenu': allowAll};

        function triggerMouseEvent(eventName, event, targetElement) {
            var localEventName = bindings[eventName];
            if (!localEventName) {
                throw new Error('unmapped DOM event name <' + eventName + '>');
            }
            return fire(localEventName, event, targetElement);
        }

        var elementSelector = 'svg, .djs-element';

        function registerEvent(node, event, localEvent, ignoredFilter) {
            var handler = handlers[localEvent] = function (event) {
                fire(localEvent, event);
            };
            if (ignoredFilter) {
                ignoredFilters[localEvent] = ignoredFilter;
            }
            handler.$delegate = delegateEvents.bind(node, elementSelector, event, handler);
        }

        function unregisterEvent(node, event, localEvent) {
            var handler = mouseHandler(localEvent);
            if (!handler) {
                return;
            }
            delegateEvents.unbind(node, event, handler.$delegate);
        }

        function registerEvents(svg) {
            forEach(bindings, function (val, key) {
                registerEvent(svg, key, val);
            });
        }

        function unregisterEvents(svg) {
            forEach(bindings, function (val, key) {
                unregisterEvent(svg, key, val);
            });
        }

        eventBus.on('canvas.destroy', function (event) {
            unregisterEvents(event.svg);
        });
        eventBus.on('canvas.init', function (event) {
            registerEvents(event.svg);
        });
        eventBus.on(['shape.added', 'connection.added'], function (event) {
            var element = event.element, gfx = event.gfx, hit;
            if (element.waypoints) {
                hit = createLine(element.waypoints);
            } else {
                hit = create('rect');
                attr$1(hit, {x: 0, y: 0, width: element.width, height: element.height});
            }
            attr$1(hit, HIT_STYLE);
            append(gfx, hit);
        });
        eventBus.on('shape.changed', LOW_PRIORITY, function (event) {
            var element = event.element, gfx = event.gfx, hit = query('.djs-hit', gfx);
            attr$1(hit, {width: element.width, height: element.height});
        });
        eventBus.on('connection.changed', function (event) {
            var element = event.element, gfx = event.gfx, hit = query('.djs-hit', gfx);
            updateLine(hit, element.waypoints);
        });
        this.fire = fire;
        this.triggerMouseEvent = triggerMouseEvent;
        this.mouseHandler = mouseHandler;
        this.registerEvent = registerEvent;
        this.unregisterEvent = unregisterEvent;
    }

    InteractionEvents.$inject = ['eventBus', 'elementRegistry', 'styles'];
    var InteractionEventsModule = {__init__: ['interactionEvents'], interactionEvents: ['type', InteractionEvents]};
    var LOW_PRIORITY$1 = 500;

    function Outline(eventBus, styles, elementRegistry) {
        this.offset = 6;
        var OUTLINE_STYLE = styles.cls('djs-outline', ['no-fill']);
        var self = this;

        function createOutline(gfx, bounds) {
            var outline = create('rect');
            attr$1(outline, assign({x: 10, y: 10, width: 100, height: 100}, OUTLINE_STYLE));
            append(gfx, outline);
            return outline;
        }

        eventBus.on(['shape.added', 'shape.changed'], LOW_PRIORITY$1, function (event) {
            var element = event.element, gfx = event.gfx;
            var outline = query('.djs-outline', gfx);
            if (!outline) {
                outline = createOutline(gfx, element);
            }
            self.updateShapeOutline(outline, element);
        });
        eventBus.on(['connection.added', 'connection.changed'], function (event) {
            var element = event.element, gfx = event.gfx;
            var outline = query('.djs-outline', gfx);
            if (!outline) {
                outline = createOutline(gfx, element);
            }
            self.updateConnectionOutline(outline, element);
        });
    }

    Outline.prototype.updateShapeOutline = function (outline, element) {
        attr$1(outline, {
            x: -this.offset,
            y: -this.offset,
            width: element.width + this.offset * 2,
            height: element.height + this.offset * 2
        });
    };
    Outline.prototype.updateConnectionOutline = function (outline, connection) {
        var bbox = getBBox(connection);
        attr$1(outline, {
            x: bbox.x - this.offset,
            y: bbox.y - this.offset,
            width: bbox.width + this.offset * 2,
            height: bbox.height + this.offset * 2
        });
    };
    Outline.$inject = ['eventBus', 'styles', 'elementRegistry'];
    var OutlineModule = {__init__: ['outline'], outline: ['type', Outline]};

    function Selection(eventBus) {
        this._eventBus = eventBus;
        this._selectedElements = [];
        var self = this;
        eventBus.on(['shape.remove', 'connection.remove'], function (e) {
            var element = e.element;
            self.deselect(element);
        });
        eventBus.on(['diagram.clear'], function (e) {
            self.select(null);
        });
    }

    Selection.$inject = ['eventBus'];
    Selection.prototype.deselect = function (element) {
        var selectedElements = this._selectedElements;
        var idx = selectedElements.indexOf(element);
        if (idx !== -1) {
            var oldSelection = selectedElements.slice();
            selectedElements.splice(idx, 1);
            this._eventBus.fire('selection.changed', {oldSelection: oldSelection, newSelection: selectedElements});
        }
    };
    Selection.prototype.get = function () {
        return this._selectedElements;
    };
    Selection.prototype.isSelected = function (element) {
        return this._selectedElements.indexOf(element) !== -1;
    };
    Selection.prototype.select = function (elements, add) {
        var selectedElements = this._selectedElements, oldSelection = selectedElements.slice();
        if (!isArray(elements)) {
            elements = elements ? [elements] : [];
        }
        if (add) {
            forEach(elements, function (element) {
                if (selectedElements.indexOf(element) !== -1) {
                    return;
                } else {
                    selectedElements.push(element);
                }
            });
        } else {
            this._selectedElements = selectedElements = elements.slice();
        }
        this._eventBus.fire('selection.changed', {oldSelection: oldSelection, newSelection: selectedElements});
    };
    var MARKER_HOVER = 'hover', MARKER_SELECTED = 'selected';

    function SelectionVisuals(events, canvas, selection, styles) {
        this._multiSelectionBox = null;

        function addMarker(e, cls) {
            canvas.addMarker(e, cls);
        }

        function removeMarker(e, cls) {
            canvas.removeMarker(e, cls);
        }

        events.on('element.hover', function (event) {
            addMarker(event.element, MARKER_HOVER);
        });
        events.on('element.out', function (event) {
            removeMarker(event.element, MARKER_HOVER);
        });
        events.on('selection.changed', function (event) {
            function deselect(s) {
                removeMarker(s, MARKER_SELECTED);
            }

            function select(s) {
                addMarker(s, MARKER_SELECTED);
            }

            var oldSelection = event.oldSelection, newSelection = event.newSelection;
            forEach(oldSelection, function (e) {
                if (newSelection.indexOf(e) === -1) {
                    deselect(e);
                }
            });
            forEach(newSelection, function (e) {
                if (oldSelection.indexOf(e) === -1) {
                    select(e);
                }
            });
        });
    }

    SelectionVisuals.$inject = ['eventBus', 'canvas', 'selection', 'styles'];

    function SelectionBehavior(eventBus, selection, canvas, elementRegistry) {
        eventBus.on('create.end', 500, function (e) {
            if (e.context.canExecute) {
                selection.select(e.context.shape);
            }
        });
        eventBus.on('connect.end', 500, function (e) {
            if (e.context.canExecute && e.context.target) {
                selection.select(e.context.target);
            }
        });
        eventBus.on('shape.move.end', 500, function (e) {
            var previousSelection = e.previousSelection || [];
            var shape = elementRegistry.get(e.context.shape.id);
            var inSelection = find(previousSelection, function (selectedShape) {
                return shape.id === selectedShape.id;
            });
            if (!inSelection) {
                selection.select(shape);
            }
        });
        eventBus.on('element.click', function (event) {
            var element = event.element;
            if (element === canvas.getRootElement()) {
                element = null;
            }
            var isSelected = selection.isSelected(element), isMultiSelect = selection.get().length > 1;
            var add = hasPrimaryModifier(event);
            if (isSelected && isMultiSelect) {
                if (add) {
                    return selection.deselect(element);
                } else {
                    return selection.select(element);
                }
            } else if (!isSelected) {
                selection.select(element, add);
            } else {
                selection.deselect(element);
            }
        });
    }

    SelectionBehavior.$inject = ['eventBus', 'selection', 'canvas', 'elementRegistry'];
    var SelectionModule = {
        __init__: ['selectionVisuals', 'selectionBehavior'],
        __depends__: [InteractionEventsModule, OutlineModule],
        selection: ['type', Selection],
        selectionVisuals: ['type', SelectionVisuals],
        selectionBehavior: ['type', SelectionBehavior]
    };

    function IdGenerator(prefix) {
        this._counter = 0;
        this._prefix = (prefix ? prefix + '-' : '') + Math.floor(Math.random() * 1000000000) + '-';
    }

    IdGenerator.prototype.next = function () {
        return this._prefix + (++this._counter);
    };
    var ids$1 = new IdGenerator('ov');
    var LOW_PRIORITY$2 = 500;

    function Overlays(config, eventBus, canvas, elementRegistry) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._elementRegistry = elementRegistry;
        this._ids = ids$1;
        this._overlayDefaults = assign({show: null, scale: true}, config && config.defaults);
        this._overlays = {};
        this._overlayContainers = [];
        this._overlayRoot = createRoot(canvas.getContainer());
        this._init();
    }

    Overlays.$inject = ['config.overlays', 'eventBus', 'canvas', 'elementRegistry'];
    Overlays.prototype.get = function (search) {
        if (isString(search)) {
            search = {id: search};
        }
        if (isString(search.element)) {
            search.element = this._elementRegistry.get(search.element);
        }
        if (search.element) {
            var container = this._getOverlayContainer(search.element, true);
            if (container) {
                return search.type ? filter(container.overlays, matchPattern({type: search.type})) : container.overlays.slice();
            } else {
                return [];
            }
        } else if (search.type) {
            return filter(this._overlays, matchPattern({type: search.type}));
        } else {
            return search.id ? this._overlays[search.id] : null;
        }
    };
    Overlays.prototype.add = function (element, type, overlay) {
        if (isObject(type)) {
            overlay = type;
            type = null;
        }
        if (!element.id) {
            element = this._elementRegistry.get(element);
        }
        if (!overlay.position) {
            throw new Error('must specifiy overlay position');
        }
        if (!overlay.html) {
            throw new Error('must specifiy overlay html');
        }
        if (!element) {
            throw new Error('invalid element specified');
        }
        var id = this._ids.next();
        overlay = assign({}, this._overlayDefaults, overlay, {
            id: id,
            type: type,
            element: element,
            html: overlay.html
        });
        this._addOverlay(overlay);
        return id;
    };
    Overlays.prototype.remove = function (filter$$1) {
        var overlays = this.get(filter$$1) || [];
        if (!isArray(overlays)) {
            overlays = [overlays];
        }
        var self = this;
        forEach(overlays, function (overlay) {
            var container = self._getOverlayContainer(overlay.element, true);
            if (overlay) {
                remove(overlay.html);
                remove(overlay.htmlContainer);
                delete overlay.htmlContainer;
                delete overlay.element;
                delete self._overlays[overlay.id];
            }
            if (container) {
                var idx = container.overlays.indexOf(overlay);
                if (idx !== -1) {
                    container.overlays.splice(idx, 1);
                }
            }
        });
    };
    Overlays.prototype.show = function () {
        setVisible(this._overlayRoot);
    };
    Overlays.prototype.hide = function () {
        setVisible(this._overlayRoot, false);
    };
    Overlays.prototype.clear = function () {
        this._overlays = {};
        this._overlayContainers = [];
        clear(this._overlayRoot);
    };
    Overlays.prototype._updateOverlayContainer = function (container) {
        var element = container.element, html = container.html;
        var x = element.x, y = element.y;
        if (element.waypoints) {
            var bbox = getBBox(element);
            x = bbox.x;
            y = bbox.y;
        }
        setPosition(html, x, y);
        attr(container.html, 'data-container-id', element.id);
    };
    Overlays.prototype._updateOverlay = function (overlay) {
        var position = overlay.position, htmlContainer = overlay.htmlContainer, element = overlay.element;
        var left = position.left, top = position.top;
        if (position.right !== undefined) {
            var width;
            if (element.waypoints) {
                width = getBBox(element).width;
            } else {
                width = element.width;
            }
            left = position.right * -1 + width;
        }
        if (position.bottom !== undefined) {
            var height;
            if (element.waypoints) {
                height = getBBox(element).height;
            } else {
                height = element.height;
            }
            top = position.bottom * -1 + height;
        }
        setPosition(htmlContainer, left || 0, top || 0);
    };
    Overlays.prototype._createOverlayContainer = function (element) {
        var html = domify('<div class="djs-overlays" style="position: absolute" />');
        this._overlayRoot.appendChild(html);
        var container = {html: html, element: element, overlays: []};
        this._updateOverlayContainer(container);
        this._overlayContainers.push(container);
        return container;
    };
    Overlays.prototype._updateRoot = function (viewbox) {
        var scale = viewbox.scale || 1;
        var matrix = 'matrix(' + [scale, 0, 0, scale, -1 * viewbox.x * scale, -1 * viewbox.y * scale].join(',') + ')';
        setTransform(this._overlayRoot, matrix);
    };
    Overlays.prototype._getOverlayContainer = function (element, raw) {
        var container = find(this._overlayContainers, function (c) {
            return c.element === element;
        });
        if (!container && !raw) {
            return this._createOverlayContainer(element);
        }
        return container;
    };
    Overlays.prototype._addOverlay = function (overlay) {
        var id = overlay.id, element = overlay.element, html = overlay.html, htmlContainer, overlayContainer;
        if (html.get && html.constructor.prototype.jquery) {
            html = html.get(0);
        }
        if (isString(html)) {
            html = domify(html);
        }
        overlayContainer = this._getOverlayContainer(element);
        htmlContainer = domify('<div class="djs-overlay" data-overlay-id="' + id + '" style="position: absolute">');
        htmlContainer.appendChild(html);
        if (overlay.type) {
            classes(htmlContainer).add('djs-overlay-' + overlay.type);
        }
        overlay.htmlContainer = htmlContainer;
        overlayContainer.overlays.push(overlay);
        overlayContainer.html.appendChild(htmlContainer);
        this._overlays[id] = overlay;
        this._updateOverlay(overlay);
        this._updateOverlayVisibilty(overlay, this._canvas.viewbox());
    };
    Overlays.prototype._updateOverlayVisibilty = function (overlay, viewbox) {
        var show = overlay.show, minZoom = show && show.minZoom, maxZoom = show && show.maxZoom,
            htmlContainer = overlay.htmlContainer, visible = true;
        if (show) {
            if ((isDefined(minZoom) && minZoom > viewbox.scale) || (isDefined(maxZoom) && maxZoom < viewbox.scale)) {
                visible = false;
            }
            setVisible(htmlContainer, visible);
        }
        this._updateOverlayScale(overlay, viewbox);
    };
    Overlays.prototype._updateOverlayScale = function (overlay, viewbox) {
        var shouldScale = overlay.scale, minScale, maxScale, htmlContainer = overlay.htmlContainer;
        var scale, transform = '';
        if (shouldScale !== true) {
            if (shouldScale === false) {
                minScale = 1;
                maxScale = 1;
            } else {
                minScale = shouldScale.min;
                maxScale = shouldScale.max;
            }
            if (isDefined(minScale) && viewbox.scale < minScale) {
                scale = (1 / viewbox.scale || 1) * minScale;
            }
            if (isDefined(maxScale) && viewbox.scale > maxScale) {
                scale = (1 / viewbox.scale || 1) * maxScale;
            }
        }
        if (isDefined(scale)) {
            transform = 'scale(' + scale + ',' + scale + ')';
        }
        setTransform(htmlContainer, transform);
    };
    Overlays.prototype._updateOverlaysVisibilty = function (viewbox) {
        var self = this;
        forEach(this._overlays, function (overlay) {
            self._updateOverlayVisibilty(overlay, viewbox);
        });
    };
    Overlays.prototype._init = function () {
        var eventBus = this._eventBus;
        var self = this;

        function updateViewbox(viewbox) {
            self._updateRoot(viewbox);
            self._updateOverlaysVisibilty(viewbox);
            self.show();
        }

        eventBus.on('canvas.viewbox.changing', function (event) {
            self.hide();
        });
        eventBus.on('canvas.viewbox.changed', function (event) {
            updateViewbox(event.viewbox);
        });
        eventBus.on(['shape.remove', 'connection.remove'], function (e) {
            var element = e.element;
            var overlays = self.get({element: element});
            forEach(overlays, function (o) {
                self.remove(o.id);
            });
            var container = self._getOverlayContainer(element);
            if (container) {
                remove(container.html);
                var i = self._overlayContainers.indexOf(container);
                if (i !== -1) {
                    self._overlayContainers.splice(i, 1);
                }
            }
        });
        eventBus.on('element.changed', LOW_PRIORITY$2, function (e) {
            var element = e.element;
            var container = self._getOverlayContainer(element, true);
            if (container) {
                forEach(container.overlays, function (overlay) {
                    self._updateOverlay(overlay);
                });
                self._updateOverlayContainer(container);
            }
        });
        eventBus.on('element.marker.update', function (e) {
            var container = self._getOverlayContainer(e.element, true);
            if (container) {
                classes(container.html)[e.add ? 'add' : 'remove'](e.marker);
            }
        });
        eventBus.on('diagram.clear', this.clear, this);
    };

    function createRoot(parent) {
        var root = domify('<div class="djs-overlay-container" style="position: absolute; width: 0; height: 0;" />');
        parent.insertBefore(root, parent.firstChild);
        return root;
    }

    function setPosition(el, x, y) {
        assign(el.style, {left: x + 'px', top: y + 'px'});
    }

    function setVisible(el, visible) {
        el.style.display = visible === false ? 'none' : '';
    }

    function setTransform(el, transform) {
        el.style['transform-origin'] = 'top left';
        ['', '-ms-', '-webkit-'].forEach(function (prefix) {
            el.style[prefix + 'transform'] = transform;
        });
    }

    var OverlaysModule = {__init__: ['overlays'], overlays: ['type', Overlays]};
    var BPMNIO_LOGO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 960"><path fill="#fff" d="M960 60v839c0 33-27 61-60 61H60c-33 0-60-27-60-60V60C0 27 27 0 60 0h839c34 0 61 27 61 60z"/><path fill="#52b415" d="M217 548a205 205 0 0 0-144 58 202 202 0 0 0-4 286 202 202 0 0 0 285 3 200 200 0 0 0 48-219 203 203 0 0 0-185-128zM752 6a206 206 0 0 0-192 285 206 206 0 0 0 269 111 207 207 0 0 0 111-260A204 204 0 0 0 752 6zM62 0A62 62 0 0 0 0 62v398l60 46a259 259 0 0 1 89-36c5-28 10-57 14-85l99 2 12 85a246 246 0 0 1 88 38l70-52 69 71-52 68c17 30 29 58 35 90l86 14-2 100-86 12a240 240 0 0 1-38 89l43 58h413c37 0 60-27 60-61V407a220 220 0 0 1-44 40l21 85-93 39-45-76a258 258 0 0 1-98 1l-45 76-94-39 22-85a298 298 0 0 1-70-69l-86 22-38-94 76-45a258 258 0 0 1-1-98l-76-45 40-94 85 22a271 271 0 0 1 41-47z"/></svg>';
    var BPMNIO_LOGO_URL = 'https://blog.52itstyle.vip/bpmn/bpmn.jpg';
    var BPMNIO_IMG = '<img width="100" height="100" src="' + BPMNIO_LOGO_URL + '" />';

    function css(attrs) {
        return attrs.join(';');
    }

    var LIGHTBOX_STYLES = css(['z-index: 1001', 'position: fixed', 'top: 0', 'left: 0', 'right: 0', 'bottom: 0']);
    var BACKDROP_STYLES = css(['width: 100%', 'height: 100%', 'background: rgba(0,0,0,0.2)']);
    var NOTICE_STYLES = css(['position: absolute', 'left: 50%', 'top: 40%', 'margin: 0 -130px', 'width: 260px', 'padding: 10px', 'background: white', 'border: solid 1px #AAA', 'border-radius: 3px', 'font-family: Helvetica, Arial, sans-serif', 'font-size: 14px', 'line-height: 1.2em']);
    var LIGHTBOX_MARKUP = '';
    var lightbox;

    function open() {
        if (!lightbox) {
            lightbox = domify(LIGHTBOX_MARKUP);
            delegateEvents.bind(lightbox, '.backdrop', 'click', function (event) {
                document.body.removeChild(lightbox);
            });
        }
        document.body.appendChild(lightbox);
    }

    function checkValidationError(err) {
        var pattern = /unparsable content <([^>]+)> detected([\s\S]*)$/;
        var match = pattern.exec(err.message);
        if (match) {
            err.message = 'unparsable content <' + match[1] + '> detected; ' + 'this may indicate an invalid BPMN 2.0 diagram file' + match[2];
        }
        return err;
    }

    var DEFAULT_OPTIONS = {width: '100%', height: '100%', position: 'relative'};

    function ensureUnit(val) {
        return val + (isNumber(val) ? 'px' : '');
    }

    function Viewer(options) {
        options = assign({}, DEFAULT_OPTIONS, options);
        this._moddle = this._createModdle(options);
        this._container = this._createContainer(options);
        addProjectLogo(this._container);
        this._init(this._container, this._moddle, options);
    }

    inherits_browser(Viewer, Diagram);
    Viewer.prototype.importXML = function (xml, done) {
        done = done || function () {
        };
        var self = this;
        xml = this._emit('import.parse.start', {xml: xml}) || xml;
        this._moddle.fromXML(xml, 'bpmn:Definitions', function (err, definitions, context) {
            definitions = self._emit('import.parse.complete', {
                error: err,
                definitions: definitions,
                context: context
            }) || definitions;
            var parseWarnings = context.warnings;
            if (err) {
                err = checkValidationError(err);
                self._emit('import.done', {error: err, warnings: parseWarnings});
                return done(err, parseWarnings);
            }
            self.importDefinitions(definitions, function (err, importWarnings) {
                var allWarnings = [].concat(parseWarnings, importWarnings || []);
                self._emit('import.done', {error: err, warnings: allWarnings});
                done(err, allWarnings);
            });
        });
    };
    Viewer.prototype.saveXML = function (options, done) {
        if (!done) {
            done = options;
            options = {};
        }
        var self = this;
        var definitions = this._definitions;
        if (!definitions) {
            return done(new Error('no definitions loaded'));
        }
        definitions = this._emit('saveXML.start', {definitions: definitions}) || definitions;
        this._moddle.toXML(definitions, options, function (err, xml) {
            try {
                xml = self._emit('saveXML.serialized', {error: err, xml: xml}) || xml;
                self._emit('saveXML.done', {error: err, xml: xml});
            } catch (e) {
                console.error('error in saveXML life-cycle listener', e);
            }
            done(err, xml);
        });
    };
    Viewer.prototype.saveSVG = function (options, done) {
        if (!done) {
            done = options;
            options = {};
        }
        this._emit('saveSVG.start');
        var svg, err;
        try {
            var canvas = this.get('canvas');
            var contentNode = canvas.getDefaultLayer(), defsNode = query('defs', canvas._svg);
            var contents = innerSVG(contentNode), defs = defsNode ? '<defs>' + innerSVG(defsNode) + '</defs>' : '';
            var bbox = contentNode.getBBox();
            svg = '<?xml version="1.0" encoding="utf-8"?>\n' + '<!-- created with bpmn-js / http://bpmn.io -->\n' + '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n' + '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'width="' + bbox.width + '" height="' + bbox.height + '" ' + 'viewBox="' + bbox.x + ' ' + bbox.y + ' ' + bbox.width + ' ' + bbox.height + '" version="1.1">' + defs + contents + '</svg>';
        } catch (e) {
            err = e;
        }
        this._emit('saveSVG.done', {error: err, svg: svg});
        done(err, svg);
    };
    Viewer.prototype.importDefinitions = function (definitions, done) {
        try {
            if (this._definitions) {
                this.clear();
            }
            this._definitions = definitions;
        } catch (e) {
            return done(e);
        }
        return importBpmnDiagram(this, definitions, done);
    };
    Viewer.prototype.getModules = function () {
        return this._modules;
    };
    Viewer.prototype.destroy = function () {
        Diagram.prototype.destroy.call(this);
        remove(this._container);
    };
    Viewer.prototype.on = function (event$$1, priority, callback, target) {
        return this.get('eventBus').on(event$$1, priority, callback, target);
    };
    Viewer.prototype.off = function (event$$1, callback) {
        this.get('eventBus').off(event$$1, callback);
    };
    Viewer.prototype.attachTo = function (parentNode) {
        if (!parentNode) {
            throw new Error('parentNode required');
        }
        this.detach();
        if (parentNode.get && parentNode.constructor.prototype.jquery) {
            parentNode = parentNode.get(0);
        }
        if (typeof parentNode === 'string') {
            parentNode = query(parentNode);
        }
        parentNode.appendChild(this._container);
        this._emit('attach', {});
        this.get('canvas').resized();
    };
    Viewer.prototype.getDefinitions = function () {
        return this._definitions;
    };
    Viewer.prototype.detach = function () {
        var container = this._container, parentNode = container.parentNode;
        if (!parentNode) {
            return;
        }
        this._emit('detach', {});
        parentNode.removeChild(container);
    };
    Viewer.prototype._init = function (container, moddle, options) {
        var baseModules = options.modules || this.getModules(), additionalModules = options.additionalModules || [],
            staticModules = [{bpmnjs: ['value', this], moddle: ['value', moddle]}];
        var diagramModules = [].concat(staticModules, baseModules, additionalModules);
        var diagramOptions = assign(omit(options, ['additionalModules']), {
            canvas: assign({}, options.canvas, {container: container}),
            modules: diagramModules
        });
        Diagram.call(this, diagramOptions);
        if (options && options.container) {
            this.attachTo(options.container);
        }
    };
    Viewer.prototype._emit = function (type, event$$1) {
        return this.get('eventBus').fire(type, event$$1);
    };
    Viewer.prototype._createContainer = function (options) {
        var container = domify('<div class="bjs-container"></div>');
        assign(container.style, {
            width: ensureUnit(options.width),
            height: ensureUnit(options.height),
            position: options.position
        });
        return container;
    };
    Viewer.prototype._createModdle = function (options) {
        var moddleOptions = assign({}, this._moddleExtensions, options.moddleExtensions);
        return new BpmnModdle$1(moddleOptions);
    };
    Viewer.prototype._modules = [CoreModule$1, translate$2, SelectionModule, OverlaysModule];
    Viewer.prototype._moddleExtensions = {};

    function addProjectLogo(container) {
        var img = BPMNIO_IMG;
        var linkMarkup = '';
        var linkElement = domify(linkMarkup);
        container.appendChild(linkElement);
        componentEvent.bind(linkElement, 'click', function (event$$1) {
            open();
            event$$1.preventDefault();
        });
    }

    function hasModifier(event) {
        return (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey);
    }

    function isCmd(event) {
        if (event.altKey) {
            return false;
        }
        return event.ctrlKey || event.metaKey;
    }

    function isKey(keys$$1, event) {
        keys$$1 = isArray(keys$$1) ? keys$$1 : [keys$$1];
        return keys$$1.indexOf(event.key) > -1;
    }

    function isShift(event) {
        return event.shiftKey;
    }

    var KEYDOWN_EVENT = 'keyboard.keydown';
    var DEFAULT_PRIORITY$1 = 1000;

    function Keyboard(config, eventBus) {
        var self = this;
        this._config = config || {};
        this._eventBus = eventBus;
        this._keyHandler = this._keyHandler.bind(this);
        eventBus.on('diagram.destroy', function () {
            self._fire('destroy');
            self.unbind();
        });
        eventBus.on('diagram.init', function () {
            self._fire('init');
        });
        eventBus.on('attach', function () {
            if (config && config.bindTo) {
                self.bind(config.bindTo);
            }
        });
        eventBus.on('detach', function () {
            self.unbind();
        });
    }

    Keyboard.$inject = ['config.keyboard', 'eventBus'];
    Keyboard.prototype._keyHandler = function (event$$1) {
        var target = event$$1.target, eventBusResult;
        if (isInput(target)) {
            return;
        }
        var context = {keyEvent: event$$1};
        eventBusResult = this._eventBus.fire(KEYDOWN_EVENT, context);
        if (eventBusResult) {
            event$$1.preventDefault();
        }
    };
    Keyboard.prototype.bind = function (node) {
        this.unbind();
        this._node = node;
        componentEvent.bind(node, 'keydown', this._keyHandler, true);
        this._fire('bind');
    };
    Keyboard.prototype.getBinding = function () {
        return this._node;
    };
    Keyboard.prototype.unbind = function () {
        var node = this._node;
        if (node) {
            this._fire('unbind');
            componentEvent.unbind(node, 'keydown', this._keyHandler, true);
        }
        this._node = null;
    };
    Keyboard.prototype._fire = function (event$$1) {
        this._eventBus.fire('keyboard.' + event$$1, {node: this._node});
    };
    Keyboard.prototype.addListener = function (priority, listener) {
        if (isFunction(priority)) {
            listener = priority;
            priority = DEFAULT_PRIORITY$1;
        }
        this._eventBus.on(KEYDOWN_EVENT, priority, listener);
    };
    Keyboard.prototype.hasModifier = hasModifier;
    Keyboard.prototype.isCmd = isCmd;
    Keyboard.prototype.isShift = isShift;
    Keyboard.prototype.isKey = isKey;

    function isInput(target) {
        return target && (matchesSelector$1(target, 'input, textarea') || target.contentEditable === 'true');
    }

    var LOW_PRIORITY$3 = 500;

    function KeyboardBindings(eventBus, keyboard) {
        var self = this;
        eventBus.on('editorActions.init', LOW_PRIORITY$3, function (event) {
            var editorActions = event.editorActions;
            self.registerBindings(keyboard, editorActions);
        });
    }

    KeyboardBindings.$inject = ['eventBus', 'keyboard'];
    KeyboardBindings.prototype.registerBindings = function (keyboard, editorActions) {
        function addListener(action, fn) {
            if (editorActions.isRegistered(action)) {
                keyboard.addListener(fn);
            }
        }

        addListener('undo', function (context) {
            var event = context.keyEvent;
            if (isCmd(event) && !isShift(event) && isKey(['z', 'Z'], event)) {
                editorActions.trigger('undo');
                return true;
            }
        });
        addListener('redo', function (context) {
            var event = context.keyEvent;
            if (isCmd(event) && (isKey(['y', 'Y'], event) || (isKey(['z', 'Z'], event) && isShift(event)))) {
                editorActions.trigger('redo');
                return true;
            }
        });
        addListener('copy', function (context) {
            var event = context.keyEvent;
            if (isCmd(event) && isKey(['c', 'C'], event)) {
                editorActions.trigger('copy');
                return true;
            }
        });
        addListener('paste', function (context) {
            var event = context.keyEvent;
            if (isCmd(event) && isKey(['v', 'V'], event)) {
                editorActions.trigger('paste');
                return true;
            }
        });
        addListener('stepZoom', function (context) {
            var event = context.keyEvent;
            if (isKey(['+', 'Add'], event) && isCmd(event)) {
                editorActions.trigger('stepZoom', {value: 1});
                return true;
            }
        });
        addListener('stepZoom', function (context) {
            var event = context.keyEvent;
            if (isKey(['-', 'Subtract'], event) && isCmd(event)) {
                editorActions.trigger('stepZoom', {value: -1});
                return true;
            }
        });
        addListener('zoom', function (context) {
            var event = context.keyEvent;
            if (isKey('0', event) && isCmd(event)) {
                editorActions.trigger('zoom', {value: 1});
                return true;
            }
        });
        addListener('removeSelection', function (context) {
            var event = context.keyEvent;
            if (isKey(['Delete', 'Del'], event)) {
                editorActions.trigger('removeSelection');
                return true;
            }
        });
    };
    var KeyboardModule = {
        __init__: ['keyboard', 'keyboardBindings'],
        keyboard: ['type', Keyboard],
        keyboardBindings: ['type', KeyboardBindings]
    };
    var DEFAULT_CONFIG = {moveSpeed: 50, moveSpeedAccelerated: 200};

    function KeyboardMove(config, keyboard, canvas) {
        var self = this;
        this._config = assign({}, DEFAULT_CONFIG, config || {});
        keyboard.addListener(arrowsListener);

        function arrowsListener(context) {
            var event = context.keyEvent, config = self._config;
            if (!keyboard.isCmd(event)) {
                return;
            }
            if (keyboard.isKey(['ArrowLeft', 'Left', 'ArrowUp', 'Up', 'ArrowDown', 'Down', 'ArrowRight', 'Right'], event)) {
                var speed = (keyboard.isShift(event) ? config.moveSpeedAccelerated : config.moveSpeed);
                var direction;
                switch (event.key) {
                    case'ArrowLeft':
                    case'Left':
                        direction = 'left';
                        break;
                    case'ArrowUp':
                    case'Up':
                        direction = 'up';
                        break;
                    case'ArrowRight':
                    case'Right':
                        direction = 'right';
                        break;
                    case'ArrowDown':
                    case'Down':
                        direction = 'down';
                        break;
                }
                self.moveCanvas({speed: speed, direction: direction});
                return true;
            }
        }

        this.moveCanvas = function (opts) {
            var dx = 0, dy = 0, speed = opts.speed;
            var actualSpeed = speed / Math.min(Math.sqrt(canvas.viewbox().scale), 1);
            switch (opts.direction) {
                case'left':
                    dx = actualSpeed;
                    break;
                case'up':
                    dy = actualSpeed;
                    break;
                case'right':
                    dx = -actualSpeed;
                    break;
                case'down':
                    dy = -actualSpeed;
                    break;
            }
            canvas.scroll({dx: dx, dy: dy});
        };
    }

    KeyboardMove.$inject = ['config.keyboardMove', 'keyboard', 'canvas'];
    var KeyboardMoveModule = {
        __depends__: [KeyboardModule],
        __init__: ['keyboardMove'],
        keyboardMove: ['type', KeyboardMove]
    };
    var CURSOR_CLS_PATTERN = /^djs-cursor-.*$/;

    function set$1(mode) {
        var classes$$1 = classes(document.body);
        classes$$1.removeMatching(CURSOR_CLS_PATTERN);
        if (mode) {
            classes$$1.add('djs-cursor-' + mode);
        }
    }

    function unset() {
        set$1(null);
    }

    var TRAP_PRIORITY = 5000;

    function install(eventBus, eventName) {
        eventName = eventName || 'element.click';

        function trap() {
            return false;
        }

        eventBus.once(eventName, TRAP_PRIORITY, trap);
        return function () {
            eventBus.off(eventName, trap);
        };
    }

    function center(bounds) {
        return {x: bounds.x + (bounds.width / 2), y: bounds.y + (bounds.height / 2)};
    }

    function delta(a, b) {
        return {x: a.x - b.x, y: a.y - b.y};
    }

    var THRESHOLD = 15;

    function MoveCanvas(eventBus, canvas) {
        var context;
        eventBus.on('element.mousedown', 500, function (e) {
            return handleStart(e.originalEvent);
        });

        function handleMove(event$$1) {
            var start = context.start, position = toPoint(event$$1), delta$$1 = delta(position, start);
            if (!context.dragging && length(delta$$1) > THRESHOLD) {
                context.dragging = true;
                install(eventBus);
                set$1('grab');
            }
            if (context.dragging) {
                var lastPosition = context.last || context.start;
                delta$$1 = delta(position, lastPosition);
                canvas.scroll({dx: delta$$1.x, dy: delta$$1.y});
                context.last = position;
            }
            event$$1.preventDefault();
        }

        function handleEnd(event$$1) {
            componentEvent.unbind(document, 'mousemove', handleMove);
            componentEvent.unbind(document, 'mouseup', handleEnd);
            context = null;
            unset();
        }

        function handleStart(event$$1) {
            if (closest(event$$1.target, '.djs-draggable')) {
                return;
            }
            if (event$$1.button || event$$1.ctrlKey || event$$1.shiftKey || event$$1.altKey) {
                return;
            }
            context = {start: toPoint(event$$1)};
            componentEvent.bind(document, 'mousemove', handleMove);
            componentEvent.bind(document, 'mouseup', handleEnd);
            return true;
        }
    }

    MoveCanvas.$inject = ['eventBus', 'canvas'];

    function length(point) {
        return Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2));
    }

    var MoveCanvasModule = {__init__: ['moveCanvas'], moveCanvas: ['type', MoveCanvas]};

    function log10(x) {
        return Math.log(x) / Math.log(10);
    }

    function getStepSize(range, steps) {
        var minLinearRange = log10(range.min), maxLinearRange = log10(range.max);
        var absoluteLinearRange = Math.abs(minLinearRange) + Math.abs(maxLinearRange);
        return absoluteLinearRange / steps;
    }

    function cap(range, scale) {
        return Math.max(range.min, Math.min(range.max, scale));
    }

    var sign = Math.sign || function (n) {
        return n >= 0 ? 1 : -1;
    };
    var RANGE = {min: 0.2, max: 4}, NUM_STEPS = 10;
    var DELTA_THRESHOLD = 0.1;
    var DEFAULT_SCALE = 0.75;

    function ZoomScroll(config, eventBus, canvas) {
        config = config || {};
        this._enabled = false;
        this._canvas = canvas;
        this._container = canvas._container;
        this._handleWheel = bind(this._handleWheel, this);
        this._totalDelta = 0;
        this._scale = config.scale || DEFAULT_SCALE;
        var self = this;
        eventBus.on('canvas.init', function (e) {
            self._init(config.enabled !== false);
        });
    }

    ZoomScroll.$inject = ['config.zoomScroll', 'eventBus', 'canvas'];
    ZoomScroll.prototype.scroll = function scroll(delta$$1) {
        this._canvas.scroll(delta$$1);
    };
    ZoomScroll.prototype.reset = function reset() {
        this._canvas.zoom('fit-viewport');
    };
    ZoomScroll.prototype.zoom = function zoom(delta$$1, position) {
        var stepSize = getStepSize(RANGE, NUM_STEPS * 2);
        this._totalDelta += delta$$1;
        if (Math.abs(this._totalDelta) > DELTA_THRESHOLD) {
            this._zoom(delta$$1, position, stepSize);
            this._totalDelta = 0;
        }
    };
    ZoomScroll.prototype._handleWheel = function handleWheel(event$$1) {
        if (closest(event$$1.target, '.djs-scrollable', true)) {
            return;
        }
        var element = this._container;
        event$$1.preventDefault();
        var isZoom = event$$1.ctrlKey;
        var isHorizontalScroll = event$$1.shiftKey;
        var factor = -1 * this._scale, delta$$1;
        if (isZoom) {
            factor *= event$$1.deltaMode === 0 ? 0.020 : 0.32;
        } else {
            factor *= event$$1.deltaMode === 0 ? 1.0 : 16.0;
        }
        if (isZoom) {
            var elementRect = element.getBoundingClientRect();
            var offset = {x: event$$1.clientX - elementRect.left, y: event$$1.clientY - elementRect.top};
            delta$$1 = (Math.sqrt(Math.pow(event$$1.deltaY, 2) + Math.pow(event$$1.deltaX, 2)) * sign(event$$1.deltaY) * factor);
            this.zoom(delta$$1, offset);
        } else {
            if (isHorizontalScroll) {
                delta$$1 = {dx: factor * event$$1.deltaY, dy: 0};
            } else {
                delta$$1 = {dx: factor * event$$1.deltaX, dy: factor * event$$1.deltaY};
            }
            this.scroll(delta$$1);
        }
    };
    ZoomScroll.prototype.stepZoom = function stepZoom(delta$$1, position) {
        var stepSize = getStepSize(RANGE, NUM_STEPS);
        this._zoom(delta$$1, position, stepSize);
    };
    ZoomScroll.prototype._zoom = function (delta$$1, position, stepSize) {
        var canvas = this._canvas;
        var direction = delta$$1 > 0 ? 1 : -1;
        var currentLinearZoomLevel = log10(canvas.zoom());
        var newLinearZoomLevel = Math.round(currentLinearZoomLevel / stepSize) * stepSize;
        newLinearZoomLevel += stepSize * direction;
        var newLogZoomLevel = Math.pow(10, newLinearZoomLevel);
        canvas.zoom(cap(RANGE, newLogZoomLevel), position);
    };
    ZoomScroll.prototype.toggle = function toggle(newEnabled) {
        var element = this._container;
        var handleWheel = this._handleWheel;
        var oldEnabled = this._enabled;
        if (typeof newEnabled === 'undefined') {
            newEnabled = !oldEnabled;
        }
        if (oldEnabled !== newEnabled) {
            componentEvent[newEnabled ? 'bind' : 'unbind'](element, 'wheel', handleWheel, false);
        }
        this._enabled = newEnabled;
        return newEnabled;
    };
    ZoomScroll.prototype._init = function (newEnabled) {
        this.toggle(newEnabled);
    };
    var ZoomScrollModule = {__init__: ['zoomScroll'], zoomScroll: ['type', ZoomScroll]};

    function NavigatedViewer(options) {
        Viewer.call(this, options);
    }

    inherits_browser(NavigatedViewer, Viewer);
    NavigatedViewer.prototype._navigationModules = [KeyboardMoveModule, MoveCanvasModule, ZoomScrollModule];
    NavigatedViewer.prototype._modules = [].concat(NavigatedViewer.prototype._modules, NavigatedViewer.prototype._navigationModules);
    var hammer = createCommonjsModule(function (module) {
        (function (window, document, exportName, undefined) {
            var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
            var TEST_ELEMENT = document.createElement('div');
            var TYPE_FUNCTION = 'function';
            var round = Math.round;
            var abs = Math.abs;
            var now = Date.now;

            function setTimeoutContext(fn, timeout, context) {
                return setTimeout(bindFn(fn, context), timeout);
            }

            function invokeArrayArg(arg, fn, context) {
                if (Array.isArray(arg)) {
                    each(arg, context[fn], context);
                    return true;
                }
                return false;
            }

            function each(obj, iterator, context) {
                var i;
                if (!obj) {
                    return;
                }
                if (obj.forEach) {
                    obj.forEach(iterator, context);
                } else if (obj.length !== undefined) {
                    i = 0;
                    while (i < obj.length) {
                        iterator.call(context, obj[i], i, obj);
                        i++;
                    }
                } else {
                    for (i in obj) {
                        obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
                    }
                }
            }

            function deprecate(method, name, message) {
                var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
                return function () {
                    var e = new Error('get-stack-trace');
                    var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
                    var log = window.console && (window.console.warn || window.console.log);
                    if (log) {
                        log.call(window.console, deprecationMessage, stack);
                    }
                    return method.apply(this, arguments);
                };
            }

            var assign;
            if (typeof Object.assign !== 'function') {
                assign = function assign(target) {
                    if (target === undefined || target === null) {
                        throw new TypeError('Cannot convert undefined or null to object');
                    }
                    var output = Object(target);
                    for (var index = 1; index < arguments.length; index++) {
                        var source = arguments[index];
                        if (source !== undefined && source !== null) {
                            for (var nextKey in source) {
                                if (source.hasOwnProperty(nextKey)) {
                                    output[nextKey] = source[nextKey];
                                }
                            }
                        }
                    }
                    return output;
                };
            } else {
                assign = Object.assign;
            }
            var extend = deprecate(function extend(dest, src, merge) {
                var keys = Object.keys(src);
                var i = 0;
                while (i < keys.length) {
                    if (!merge || (merge && dest[keys[i]] === undefined)) {
                        dest[keys[i]] = src[keys[i]];
                    }
                    i++;
                }
                return dest;
            }, 'extend', 'Use `assign`.');
            var merge = deprecate(function merge(dest, src) {
                return extend(dest, src, true);
            }, 'merge', 'Use `assign`.');

            function inherit(child, base, properties) {
                var baseP = base.prototype, childP;
                childP = child.prototype = Object.create(baseP);
                childP.constructor = child;
                childP._super = baseP;
                if (properties) {
                    assign(childP, properties);
                }
            }

            function bindFn(fn, context) {
                return function boundFn() {
                    return fn.apply(context, arguments);
                };
            }

            function boolOrFn(val, args) {
                if (typeof val == TYPE_FUNCTION) {
                    return val.apply(args ? args[0] || undefined : undefined, args);
                }
                return val;
            }

            function ifUndefined(val1, val2) {
                return (val1 === undefined) ? val2 : val1;
            }

            function addEventListeners(target, types, handler) {
                each(splitStr(types), function (type) {
                    target.addEventListener(type, handler, false);
                });
            }

            function removeEventListeners(target, types, handler) {
                each(splitStr(types), function (type) {
                    target.removeEventListener(type, handler, false);
                });
            }

            function hasParent(node, parent) {
                while (node) {
                    if (node == parent) {
                        return true;
                    }
                    node = node.parentNode;
                }
                return false;
            }

            function inStr(str, find) {
                return str.indexOf(find) > -1;
            }

            function splitStr(str) {
                return str.trim().split(/\s+/g);
            }

            function inArray(src, find, findByKey) {
                if (src.indexOf && !findByKey) {
                    return src.indexOf(find);
                } else {
                    var i = 0;
                    while (i < src.length) {
                        if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                            return i;
                        }
                        i++;
                    }
                    return -1;
                }
            }

            function toArray(obj) {
                return Array.prototype.slice.call(obj, 0);
            }

            function uniqueArray(src, key, sort) {
                var results = [];
                var values = [];
                var i = 0;
                while (i < src.length) {
                    var val = key ? src[i][key] : src[i];
                    if (inArray(values, val) < 0) {
                        results.push(src[i]);
                    }
                    values[i] = val;
                    i++;
                }
                if (sort) {
                    if (!key) {
                        results = results.sort();
                    } else {
                        results = results.sort(function sortUniqueArray(a, b) {
                            return a[key] > b[key];
                        });
                    }
                }
                return results;
            }

            function prefixed(obj, property) {
                var prefix, prop;
                var camelProp = property[0].toUpperCase() + property.slice(1);
                var i = 0;
                while (i < VENDOR_PREFIXES.length) {
                    prefix = VENDOR_PREFIXES[i];
                    prop = (prefix) ? prefix + camelProp : property;
                    if (prop in obj) {
                        return prop;
                    }
                    i++;
                }
                return undefined;
            }

            var _uniqueId = 1;

            function uniqueId() {
                return _uniqueId++;
            }

            function getWindowForElement(element) {
                var doc = element.ownerDocument || element;
                return (doc.defaultView || doc.parentWindow || window);
            }

            var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
            var SUPPORT_TOUCH = ('ontouchstart' in window);
            var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
            var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
            var INPUT_TYPE_TOUCH = 'touch';
            var INPUT_TYPE_PEN = 'pen';
            var INPUT_TYPE_MOUSE = 'mouse';
            var INPUT_TYPE_KINECT = 'kinect';
            var COMPUTE_INTERVAL = 25;
            var INPUT_START = 1;
            var INPUT_MOVE = 2;
            var INPUT_END = 4;
            var INPUT_CANCEL = 8;
            var DIRECTION_NONE = 1;
            var DIRECTION_LEFT = 2;
            var DIRECTION_RIGHT = 4;
            var DIRECTION_UP = 8;
            var DIRECTION_DOWN = 16;
            var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
            var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
            var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
            var PROPS_XY = ['x', 'y'];
            var PROPS_CLIENT_XY = ['clientX', 'clientY'];

            function Input(manager, callback) {
                var self = this;
                this.manager = manager;
                this.callback = callback;
                this.element = manager.element;
                this.target = manager.options.inputTarget;
                this.domHandler = function (ev) {
                    if (boolOrFn(manager.options.enable, [manager])) {
                        self.handler(ev);
                    }
                };
                this.init();
            }

            Input.prototype = {
                handler: function () {
                }, init: function () {
                    this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
                    this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
                    this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
                }, destroy: function () {
                    this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
                    this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
                    this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
                }
            };

            function createInputInstance(manager) {
                var Type;
                var inputClass = manager.options.inputClass;
                if (inputClass) {
                    Type = inputClass;
                } else if (SUPPORT_POINTER_EVENTS) {
                    Type = PointerEventInput;
                } else if (SUPPORT_ONLY_TOUCH) {
                    Type = TouchInput;
                } else if (!SUPPORT_TOUCH) {
                    Type = MouseInput;
                } else {
                    Type = TouchMouseInput;
                }
                return new (Type)(manager, inputHandler);
            }

            function inputHandler(manager, eventType, input) {
                var pointersLen = input.pointers.length;
                var changedPointersLen = input.changedPointers.length;
                var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
                var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
                input.isFirst = !!isFirst;
                input.isFinal = !!isFinal;
                if (isFirst) {
                    manager.session = {};
                }
                input.eventType = eventType;
                computeInputData(manager, input);
                manager.emit('hammer.input', input);
                manager.recognize(input);
                manager.session.prevInput = input;
            }

            function computeInputData(manager, input) {
                var session = manager.session;
                var pointers = input.pointers;
                var pointersLength = pointers.length;
                if (!session.firstInput) {
                    session.firstInput = simpleCloneInputData(input);
                }
                if (pointersLength > 1 && !session.firstMultiple) {
                    session.firstMultiple = simpleCloneInputData(input);
                } else if (pointersLength === 1) {
                    session.firstMultiple = false;
                }
                var firstInput = session.firstInput;
                var firstMultiple = session.firstMultiple;
                var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
                var center = input.center = getCenter(pointers);
                input.timeStamp = now();
                input.deltaTime = input.timeStamp - firstInput.timeStamp;
                input.angle = getAngle(offsetCenter, center);
                input.distance = getDistance(offsetCenter, center);
                computeDeltaXY(session, input);
                input.offsetDirection = getDirection(input.deltaX, input.deltaY);
                var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
                input.overallVelocityX = overallVelocity.x;
                input.overallVelocityY = overallVelocity.y;
                input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
                input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
                input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
                input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length > session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
                computeIntervalInputData(session, input);
                var target = manager.element;
                if (hasParent(input.srcEvent.target, target)) {
                    target = input.srcEvent.target;
                }
                input.target = target;
            }

            function computeDeltaXY(session, input) {
                var center = input.center;
                var offset = session.offsetDelta || {};
                var prevDelta = session.prevDelta || {};
                var prevInput = session.prevInput || {};
                if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
                    prevDelta = session.prevDelta = {x: prevInput.deltaX || 0, y: prevInput.deltaY || 0};
                    offset = session.offsetDelta = {x: center.x, y: center.y};
                }
                input.deltaX = prevDelta.x + (center.x - offset.x);
                input.deltaY = prevDelta.y + (center.y - offset.y);
            }

            function computeIntervalInputData(session, input) {
                var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity,
                    velocityX, velocityY, direction;
                if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
                    var deltaX = input.deltaX - last.deltaX;
                    var deltaY = input.deltaY - last.deltaY;
                    var v = getVelocity(deltaTime, deltaX, deltaY);
                    velocityX = v.x;
                    velocityY = v.y;
                    velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
                    direction = getDirection(deltaX, deltaY);
                    session.lastInterval = input;
                } else {
                    velocity = last.velocity;
                    velocityX = last.velocityX;
                    velocityY = last.velocityY;
                    direction = last.direction;
                }
                input.velocity = velocity;
                input.velocityX = velocityX;
                input.velocityY = velocityY;
                input.direction = direction;
            }

            function simpleCloneInputData(input) {
                var pointers = [];
                var i = 0;
                while (i < input.pointers.length) {
                    pointers[i] = {
                        clientX: round(input.pointers[i].clientX),
                        clientY: round(input.pointers[i].clientY)
                    };
                    i++;
                }
                return {
                    timeStamp: now(),
                    pointers: pointers,
                    center: getCenter(pointers),
                    deltaX: input.deltaX,
                    deltaY: input.deltaY
                };
            }

            function getCenter(pointers) {
                var pointersLength = pointers.length;
                if (pointersLength === 1) {
                    return {x: round(pointers[0].clientX), y: round(pointers[0].clientY)};
                }
                var x = 0, y = 0, i = 0;
                while (i < pointersLength) {
                    x += pointers[i].clientX;
                    y += pointers[i].clientY;
                    i++;
                }
                return {x: round(x / pointersLength), y: round(y / pointersLength)};
            }

            function getVelocity(deltaTime, x, y) {
                return {x: x / deltaTime || 0, y: y / deltaTime || 0};
            }

            function getDirection(x, y) {
                if (x === y) {
                    return DIRECTION_NONE;
                }
                if (abs(x) >= abs(y)) {
                    return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                }
                return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
            }

            function getDistance(p1, p2, props) {
                if (!props) {
                    props = PROPS_XY;
                }
                var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
                return Math.sqrt((x * x) + (y * y));
            }

            function getAngle(p1, p2, props) {
                if (!props) {
                    props = PROPS_XY;
                }
                var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
                return Math.atan2(y, x) * 180 / Math.PI;
            }

            function getRotation(start, end) {
                return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
            }

            function getScale(start, end) {
                return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
            }

            var MOUSE_INPUT_MAP = {mousedown: INPUT_START, mousemove: INPUT_MOVE, mouseup: INPUT_END};
            var MOUSE_ELEMENT_EVENTS = 'mousedown';
            var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

            function MouseInput() {
                this.evEl = MOUSE_ELEMENT_EVENTS;
                this.evWin = MOUSE_WINDOW_EVENTS;
                this.pressed = false;
                Input.apply(this, arguments);
            }

            inherit(MouseInput, Input, {
                handler: function MEhandler(ev) {
                    var eventType = MOUSE_INPUT_MAP[ev.type];
                    if (eventType & INPUT_START && ev.button === 0) {
                        this.pressed = true;
                    }
                    if (eventType & INPUT_MOVE && ev.which !== 1) {
                        eventType = INPUT_END;
                    }
                    if (!this.pressed) {
                        return;
                    }
                    if (eventType & INPUT_END) {
                        this.pressed = false;
                    }
                    this.callback(this.manager, eventType, {
                        pointers: [ev],
                        changedPointers: [ev],
                        pointerType: INPUT_TYPE_MOUSE,
                        srcEvent: ev
                    });
                }
            });
            var POINTER_INPUT_MAP = {
                pointerdown: INPUT_START,
                pointermove: INPUT_MOVE,
                pointerup: INPUT_END,
                pointercancel: INPUT_CANCEL,
                pointerout: INPUT_CANCEL
            };
            var IE10_POINTER_TYPE_ENUM = {
                2: INPUT_TYPE_TOUCH,
                3: INPUT_TYPE_PEN,
                4: INPUT_TYPE_MOUSE,
                5: INPUT_TYPE_KINECT
            };
            var POINTER_ELEMENT_EVENTS = 'pointerdown';
            var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
            if (window.MSPointerEvent && !window.PointerEvent) {
                POINTER_ELEMENT_EVENTS = 'MSPointerDown';
                POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
            }

            function PointerEventInput() {
                this.evEl = POINTER_ELEMENT_EVENTS;
                this.evWin = POINTER_WINDOW_EVENTS;
                Input.apply(this, arguments);
                this.store = (this.manager.session.pointerEvents = []);
            }

            inherit(PointerEventInput, Input, {
                handler: function PEhandler(ev) {
                    var store = this.store;
                    var removePointer = false;
                    var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
                    var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
                    var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
                    var isTouch = (pointerType == INPUT_TYPE_TOUCH);
                    var storeIndex = inArray(store, ev.pointerId, 'pointerId');
                    if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                        if (storeIndex < 0) {
                            store.push(ev);
                            storeIndex = store.length - 1;
                        }
                    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                        removePointer = true;
                    }
                    if (storeIndex < 0) {
                        return;
                    }
                    store[storeIndex] = ev;
                    this.callback(this.manager, eventType, {
                        pointers: store,
                        changedPointers: [ev],
                        pointerType: pointerType,
                        srcEvent: ev
                    });
                    if (removePointer) {
                        store.splice(storeIndex, 1);
                    }
                }
            });
            var SINGLE_TOUCH_INPUT_MAP = {
                touchstart: INPUT_START,
                touchmove: INPUT_MOVE,
                touchend: INPUT_END,
                touchcancel: INPUT_CANCEL
            };
            var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
            var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

            function SingleTouchInput() {
                this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
                this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
                this.started = false;
                Input.apply(this, arguments);
            }

            inherit(SingleTouchInput, Input, {
                handler: function TEhandler(ev) {
                    var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
                    if (type === INPUT_START) {
                        this.started = true;
                    }
                    if (!this.started) {
                        return;
                    }
                    var touches = normalizeSingleTouches.call(this, ev, type);
                    if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
                        this.started = false;
                    }
                    this.callback(this.manager, type, {
                        pointers: touches[0],
                        changedPointers: touches[1],
                        pointerType: INPUT_TYPE_TOUCH,
                        srcEvent: ev
                    });
                }
            });

            function normalizeSingleTouches(ev, type) {
                var all = toArray(ev.touches);
                var changed = toArray(ev.changedTouches);
                if (type & (INPUT_END | INPUT_CANCEL)) {
                    all = uniqueArray(all.concat(changed), 'identifier', true);
                }
                return [all, changed];
            }

            var TOUCH_INPUT_MAP = {
                touchstart: INPUT_START,
                touchmove: INPUT_MOVE,
                touchend: INPUT_END,
                touchcancel: INPUT_CANCEL
            };
            var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

            function TouchInput() {
                this.evTarget = TOUCH_TARGET_EVENTS;
                this.targetIds = {};
                Input.apply(this, arguments);
            }

            inherit(TouchInput, Input, {
                handler: function MTEhandler(ev) {
                    var type = TOUCH_INPUT_MAP[ev.type];
                    var touches = getTouches.call(this, ev, type);
                    if (!touches) {
                        return;
                    }
                    this.callback(this.manager, type, {
                        pointers: touches[0],
                        changedPointers: touches[1],
                        pointerType: INPUT_TYPE_TOUCH,
                        srcEvent: ev
                    });
                }
            });

            function getTouches(ev, type) {
                var allTouches = toArray(ev.touches);
                var targetIds = this.targetIds;
                if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
                    targetIds[allTouches[0].identifier] = true;
                    return [allTouches, allTouches];
                }
                var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [],
                    target = this.target;
                targetTouches = allTouches.filter(function (touch) {
                    return hasParent(touch.target, target);
                });
                if (type === INPUT_START) {
                    i = 0;
                    while (i < targetTouches.length) {
                        targetIds[targetTouches[i].identifier] = true;
                        i++;
                    }
                }
                i = 0;
                while (i < changedTouches.length) {
                    if (targetIds[changedTouches[i].identifier]) {
                        changedTargetTouches.push(changedTouches[i]);
                    }
                    if (type & (INPUT_END | INPUT_CANCEL)) {
                        delete targetIds[changedTouches[i].identifier];
                    }
                    i++;
                }
                if (!changedTargetTouches.length) {
                    return;
                }
                return [uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true), changedTargetTouches];
            }

            var DEDUP_TIMEOUT = 2500;
            var DEDUP_DISTANCE = 25;

            function TouchMouseInput() {
                Input.apply(this, arguments);
                var handler = bindFn(this.handler, this);
                this.touch = new TouchInput(this.manager, handler);
                this.mouse = new MouseInput(this.manager, handler);
                this.primaryTouch = null;
                this.lastTouches = [];
            }

            inherit(TouchMouseInput, Input, {
                handler: function TMEhandler(manager, inputEvent, inputData) {
                    var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
                        isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
                    if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
                        return;
                    }
                    if (isTouch) {
                        recordTouches.call(this, inputEvent, inputData);
                    } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
                        return;
                    }
                    this.callback(manager, inputEvent, inputData);
                }, destroy: function destroy() {
                    this.touch.destroy();
                    this.mouse.destroy();
                }
            });

            function recordTouches(eventType, eventData) {
                if (eventType & INPUT_START) {
                    this.primaryTouch = eventData.changedPointers[0].identifier;
                    setLastTouch.call(this, eventData);
                } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                    setLastTouch.call(this, eventData);
                }
            }

            function setLastTouch(eventData) {
                var touch = eventData.changedPointers[0];
                if (touch.identifier === this.primaryTouch) {
                    var lastTouch = {x: touch.clientX, y: touch.clientY};
                    this.lastTouches.push(lastTouch);
                    var lts = this.lastTouches;
                    var removeLastTouch = function () {
                        var i = lts.indexOf(lastTouch);
                        if (i > -1) {
                            lts.splice(i, 1);
                        }
                    };
                    setTimeout(removeLastTouch, DEDUP_TIMEOUT);
                }
            }

            function isSyntheticEvent(eventData) {
                var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
                for (var i = 0; i < this.lastTouches.length; i++) {
                    var t = this.lastTouches[i];
                    var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
                    if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
                        return true;
                    }
                }
                return false;
            }

            var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
            var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
            var TOUCH_ACTION_COMPUTE = 'compute';
            var TOUCH_ACTION_AUTO = 'auto';
            var TOUCH_ACTION_MANIPULATION = 'manipulation';
            var TOUCH_ACTION_NONE = 'none';
            var TOUCH_ACTION_PAN_X = 'pan-x';
            var TOUCH_ACTION_PAN_Y = 'pan-y';
            var TOUCH_ACTION_MAP = getTouchActionProps();

            function TouchAction(manager, value) {
                this.manager = manager;
                this.set(value);
            }

            TouchAction.prototype = {
                set: function (value) {
                    if (value == TOUCH_ACTION_COMPUTE) {
                        value = this.compute();
                    }
                    if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
                        this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
                    }
                    this.actions = value.toLowerCase().trim();
                }, update: function () {
                    this.set(this.manager.options.touchAction);
                }, compute: function () {
                    var actions = [];
                    each(this.manager.recognizers, function (recognizer) {
                        if (boolOrFn(recognizer.options.enable, [recognizer])) {
                            actions = actions.concat(recognizer.getTouchAction());
                        }
                    });
                    return cleanTouchActions(actions.join(' '));
                }, preventDefaults: function (input) {
                    var srcEvent = input.srcEvent;
                    var direction = input.offsetDirection;
                    if (this.manager.session.prevented) {
                        srcEvent.preventDefault();
                        return;
                    }
                    var actions = this.actions;
                    var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
                    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
                    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
                    if (hasNone) {
                        var isTapPointer = input.pointers.length === 1;
                        var isTapMovement = input.distance < 2;
                        var isTapTouchTime = input.deltaTime < 250;
                        if (isTapPointer && isTapMovement && isTapTouchTime) {
                            return;
                        }
                    }
                    if (hasPanX && hasPanY) {
                        return;
                    }
                    if (hasNone || (hasPanY && direction & DIRECTION_HORIZONTAL) || (hasPanX && direction & DIRECTION_VERTICAL)) {
                        return this.preventSrc(srcEvent);
                    }
                }, preventSrc: function (srcEvent) {
                    this.manager.session.prevented = true;
                    srcEvent.preventDefault();
                }
            };

            function cleanTouchActions(actions) {
                if (inStr(actions, TOUCH_ACTION_NONE)) {
                    return TOUCH_ACTION_NONE;
                }
                var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
                var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
                if (hasPanX && hasPanY) {
                    return TOUCH_ACTION_NONE;
                }
                if (hasPanX || hasPanY) {
                    return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
                }
                if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
                    return TOUCH_ACTION_MANIPULATION;
                }
                return TOUCH_ACTION_AUTO;
            }

            function getTouchActionProps() {
                if (!NATIVE_TOUCH_ACTION) {
                    return false;
                }
                var touchMap = {};
                var cssSupports = window.CSS && window.CSS.supports;
                ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
                    touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
                });
                return touchMap;
            }

            var STATE_POSSIBLE = 1;
            var STATE_BEGAN = 2;
            var STATE_CHANGED = 4;
            var STATE_ENDED = 8;
            var STATE_RECOGNIZED = STATE_ENDED;
            var STATE_CANCELLED = 16;
            var STATE_FAILED = 32;

            function Recognizer(options) {
                this.options = assign({}, this.defaults, options || {});
                this.id = uniqueId();
                this.manager = null;
                this.options.enable = ifUndefined(this.options.enable, true);
                this.state = STATE_POSSIBLE;
                this.simultaneous = {};
                this.requireFail = [];
            }

            Recognizer.prototype = {
                defaults: {}, set: function (options) {
                    assign(this.options, options);
                    this.manager && this.manager.touchAction.update();
                    return this;
                }, recognizeWith: function (otherRecognizer) {
                    if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
                        return this;
                    }
                    var simultaneous = this.simultaneous;
                    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                    if (!simultaneous[otherRecognizer.id]) {
                        simultaneous[otherRecognizer.id] = otherRecognizer;
                        otherRecognizer.recognizeWith(this);
                    }
                    return this;
                }, dropRecognizeWith: function (otherRecognizer) {
                    if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
                        return this;
                    }
                    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                    delete this.simultaneous[otherRecognizer.id];
                    return this;
                }, requireFailure: function (otherRecognizer) {
                    if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
                        return this;
                    }
                    var requireFail = this.requireFail;
                    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                    if (inArray(requireFail, otherRecognizer) === -1) {
                        requireFail.push(otherRecognizer);
                        otherRecognizer.requireFailure(this);
                    }
                    return this;
                }, dropRequireFailure: function (otherRecognizer) {
                    if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
                        return this;
                    }
                    otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
                    var index = inArray(this.requireFail, otherRecognizer);
                    if (index > -1) {
                        this.requireFail.splice(index, 1);
                    }
                    return this;
                }, hasRequireFailures: function () {
                    return this.requireFail.length > 0;
                }, canRecognizeWith: function (otherRecognizer) {
                    return !!this.simultaneous[otherRecognizer.id];
                }, emit: function (input) {
                    var self = this;
                    var state = this.state;

                    function emit(event) {
                        self.manager.emit(event, input);
                    }

                    if (state < STATE_ENDED) {
                        emit(self.options.event + stateStr(state));
                    }
                    emit(self.options.event);
                    if (input.additionalEvent) {
                        emit(input.additionalEvent);
                    }
                    if (state >= STATE_ENDED) {
                        emit(self.options.event + stateStr(state));
                    }
                }, tryEmit: function (input) {
                    if (this.canEmit()) {
                        return this.emit(input);
                    }
                    this.state = STATE_FAILED;
                }, canEmit: function () {
                    var i = 0;
                    while (i < this.requireFail.length) {
                        if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                            return false;
                        }
                        i++;
                    }
                    return true;
                }, recognize: function (inputData) {
                    var inputDataClone = assign({}, inputData);
                    if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
                        this.reset();
                        this.state = STATE_FAILED;
                        return;
                    }
                    if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
                        this.state = STATE_POSSIBLE;
                    }
                    this.state = this.process(inputDataClone);
                    if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
                        this.tryEmit(inputDataClone);
                    }
                }, process: function (inputData) {
                }, getTouchAction: function () {
                }, reset: function () {
                }
            };

            function stateStr(state) {
                if (state & STATE_CANCELLED) {
                    return 'cancel';
                } else if (state & STATE_ENDED) {
                    return 'end';
                } else if (state & STATE_CHANGED) {
                    return 'move';
                } else if (state & STATE_BEGAN) {
                    return 'start';
                }
                return '';
            }

            function directionStr(direction) {
                if (direction == DIRECTION_DOWN) {
                    return 'down';
                } else if (direction == DIRECTION_UP) {
                    return 'up';
                } else if (direction == DIRECTION_LEFT) {
                    return 'left';
                } else if (direction == DIRECTION_RIGHT) {
                    return 'right';
                }
                return '';
            }

            function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
                var manager = recognizer.manager;
                if (manager) {
                    return manager.get(otherRecognizer);
                }
                return otherRecognizer;
            }

            function AttrRecognizer() {
                Recognizer.apply(this, arguments);
            }

            inherit(AttrRecognizer, Recognizer, {
                defaults: {pointers: 1}, attrTest: function (input) {
                    var optionPointers = this.options.pointers;
                    return optionPointers === 0 || input.pointers.length === optionPointers;
                }, process: function (input) {
                    var state = this.state;
                    var eventType = input.eventType;
                    var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
                    var isValid = this.attrTest(input);
                    if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
                        return state | STATE_CANCELLED;
                    } else if (isRecognized || isValid) {
                        if (eventType & INPUT_END) {
                            return state | STATE_ENDED;
                        } else if (!(state & STATE_BEGAN)) {
                            return STATE_BEGAN;
                        }
                        return state | STATE_CHANGED;
                    }
                    return STATE_FAILED;
                }
            });

            function PanRecognizer() {
                AttrRecognizer.apply(this, arguments);
                this.pX = null;
                this.pY = null;
            }

            inherit(PanRecognizer, AttrRecognizer, {
                defaults: {event: 'pan', threshold: 10, pointers: 1, direction: DIRECTION_ALL},
                getTouchAction: function () {
                    var direction = this.options.direction;
                    var actions = [];
                    if (direction & DIRECTION_HORIZONTAL) {
                        actions.push(TOUCH_ACTION_PAN_Y);
                    }
                    if (direction & DIRECTION_VERTICAL) {
                        actions.push(TOUCH_ACTION_PAN_X);
                    }
                    return actions;
                },
                directionTest: function (input) {
                    var options = this.options;
                    var hasMoved = true;
                    var distance = input.distance;
                    var direction = input.direction;
                    var x = input.deltaX;
                    var y = input.deltaY;
                    if (!(direction & options.direction)) {
                        if (options.direction & DIRECTION_HORIZONTAL) {
                            direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                            hasMoved = x != this.pX;
                            distance = Math.abs(input.deltaX);
                        } else {
                            direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                            hasMoved = y != this.pY;
                            distance = Math.abs(input.deltaY);
                        }
                    }
                    input.direction = direction;
                    return hasMoved && distance > options.threshold && direction & options.direction;
                },
                attrTest: function (input) {
                    return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
                },
                emit: function (input) {
                    this.pX = input.deltaX;
                    this.pY = input.deltaY;
                    var direction = directionStr(input.direction);
                    if (direction) {
                        input.additionalEvent = this.options.event + direction;
                    }
                    this._super.emit.call(this, input);
                }
            });

            function PinchRecognizer() {
                AttrRecognizer.apply(this, arguments);
            }

            inherit(PinchRecognizer, AttrRecognizer, {
                defaults: {event: 'pinch', threshold: 0, pointers: 2},
                getTouchAction: function () {
                    return [TOUCH_ACTION_NONE];
                },
                attrTest: function (input) {
                    return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
                },
                emit: function (input) {
                    if (input.scale !== 1) {
                        var inOut = input.scale < 1 ? 'in' : 'out';
                        input.additionalEvent = this.options.event + inOut;
                    }
                    this._super.emit.call(this, input);
                }
            });

            function PressRecognizer() {
                Recognizer.apply(this, arguments);
                this._timer = null;
                this._input = null;
            }

            inherit(PressRecognizer, Recognizer, {
                defaults: {event: 'press', pointers: 1, time: 251, threshold: 9},
                getTouchAction: function () {
                    return [TOUCH_ACTION_AUTO];
                },
                process: function (input) {
                    var options = this.options;
                    var validPointers = input.pointers.length === options.pointers;
                    var validMovement = input.distance < options.threshold;
                    var validTime = input.deltaTime > options.time;
                    this._input = input;
                    if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
                        this.reset();
                    } else if (input.eventType & INPUT_START) {
                        this.reset();
                        this._timer = setTimeoutContext(function () {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.time, this);
                    } else if (input.eventType & INPUT_END) {
                        return STATE_RECOGNIZED;
                    }
                    return STATE_FAILED;
                },
                reset: function () {
                    clearTimeout(this._timer);
                },
                emit: function (input) {
                    if (this.state !== STATE_RECOGNIZED) {
                        return;
                    }
                    if (input && (input.eventType & INPUT_END)) {
                        this.manager.emit(this.options.event + 'up', input);
                    } else {
                        this._input.timeStamp = now();
                        this.manager.emit(this.options.event, this._input);
                    }
                }
            });

            function RotateRecognizer() {
                AttrRecognizer.apply(this, arguments);
            }

            inherit(RotateRecognizer, AttrRecognizer, {
                defaults: {event: 'rotate', threshold: 0, pointers: 2},
                getTouchAction: function () {
                    return [TOUCH_ACTION_NONE];
                },
                attrTest: function (input) {
                    return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
                }
            });

            function SwipeRecognizer() {
                AttrRecognizer.apply(this, arguments);
            }

            inherit(SwipeRecognizer, AttrRecognizer, {
                defaults: {
                    event: 'swipe',
                    threshold: 10,
                    velocity: 0.3,
                    direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
                    pointers: 1
                }, getTouchAction: function () {
                    return PanRecognizer.prototype.getTouchAction.call(this);
                }, attrTest: function (input) {
                    var direction = this.options.direction;
                    var velocity;
                    if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
                        velocity = input.overallVelocity;
                    } else if (direction & DIRECTION_HORIZONTAL) {
                        velocity = input.overallVelocityX;
                    } else if (direction & DIRECTION_VERTICAL) {
                        velocity = input.overallVelocityY;
                    }
                    return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
                }, emit: function (input) {
                    var direction = directionStr(input.offsetDirection);
                    if (direction) {
                        this.manager.emit(this.options.event + direction, input);
                    }
                    this.manager.emit(this.options.event, input);
                }
            });

            function TapRecognizer() {
                Recognizer.apply(this, arguments);
                this.pTime = false;
                this.pCenter = false;
                this._timer = null;
                this._input = null;
                this.count = 0;
            }

            inherit(TapRecognizer, Recognizer, {
                defaults: {
                    event: 'tap',
                    pointers: 1,
                    taps: 1,
                    interval: 300,
                    time: 250,
                    threshold: 9,
                    posThreshold: 10
                }, getTouchAction: function () {
                    return [TOUCH_ACTION_MANIPULATION];
                }, process: function (input) {
                    var options = this.options;
                    var validPointers = input.pointers.length === options.pointers;
                    var validMovement = input.distance < options.threshold;
                    var validTouchTime = input.deltaTime < options.time;
                    this.reset();
                    if ((input.eventType & INPUT_START) && (this.count === 0)) {
                        return this.failTimeout();
                    }
                    if (validMovement && validTouchTime && validPointers) {
                        if (input.eventType != INPUT_END) {
                            return this.failTimeout();
                        }
                        var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
                        var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                        this.pTime = input.timeStamp;
                        this.pCenter = input.center;
                        if (!validMultiTap || !validInterval) {
                            this.count = 1;
                        } else {
                            this.count += 1;
                        }
                        this._input = input;
                        var tapCount = this.count % options.taps;
                        if (tapCount === 0) {
                            if (!this.hasRequireFailures()) {
                                return STATE_RECOGNIZED;
                            } else {
                                this._timer = setTimeoutContext(function () {
                                    this.state = STATE_RECOGNIZED;
                                    this.tryEmit();
                                }, options.interval, this);
                                return STATE_BEGAN;
                            }
                        }
                    }
                    return STATE_FAILED;
                }, failTimeout: function () {
                    this._timer = setTimeoutContext(function () {
                        this.state = STATE_FAILED;
                    }, this.options.interval, this);
                    return STATE_FAILED;
                }, reset: function () {
                    clearTimeout(this._timer);
                }, emit: function () {
                    if (this.state == STATE_RECOGNIZED) {
                        this._input.tapCount = this.count;
                        this.manager.emit(this.options.event, this._input);
                    }
                }
            });

            function Hammer(element, options) {
                options = options || {};
                options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
                return new Manager(element, options);
            }

            Hammer.VERSION = '2.0.7';
            Hammer.defaults = {
                domEvents: false,
                touchAction: TOUCH_ACTION_COMPUTE,
                enable: true,
                inputTarget: null,
                inputClass: null,
                preset: [[RotateRecognizer, {enable: false}], [PinchRecognizer, {enable: false}, ['rotate']], [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}], [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']], [TapRecognizer], [TapRecognizer, {
                    event: 'doubletap',
                    taps: 2
                }, ['tap']], [PressRecognizer]],
                cssProps: {
                    userSelect: 'none',
                    touchSelect: 'none',
                    touchCallout: 'none',
                    contentZooming: 'none',
                    userDrag: 'none',
                    tapHighlightColor: 'rgba(0,0,0,0)'
                }
            };
            var STOP = 1;
            var FORCED_STOP = 2;

            function Manager(element, options) {
                this.options = assign({}, Hammer.defaults, options || {});
                this.options.inputTarget = this.options.inputTarget || element;
                this.handlers = {};
                this.session = {};
                this.recognizers = [];
                this.oldCssProps = {};
                this.element = element;
                this.input = createInputInstance(this);
                this.touchAction = new TouchAction(this, this.options.touchAction);
                toggleCssProps(this, true);
                each(this.options.recognizers, function (item) {
                    var recognizer = this.add(new (item[0])(item[1]));
                    item[2] && recognizer.recognizeWith(item[2]);
                    item[3] && recognizer.requireFailure(item[3]);
                }, this);
            }

            Manager.prototype = {
                set: function (options) {
                    assign(this.options, options);
                    if (options.touchAction) {
                        this.touchAction.update();
                    }
                    if (options.inputTarget) {
                        this.input.destroy();
                        this.input.target = options.inputTarget;
                        this.input.init();
                    }
                    return this;
                }, stop: function (force) {
                    this.session.stopped = force ? FORCED_STOP : STOP;
                }, recognize: function (inputData) {
                    var session = this.session;
                    if (session.stopped) {
                        return;
                    }
                    this.touchAction.preventDefaults(inputData);
                    var recognizer;
                    var recognizers = this.recognizers;
                    var curRecognizer = session.curRecognizer;
                    if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
                        curRecognizer = session.curRecognizer = null;
                    }
                    var i = 0;
                    while (i < recognizers.length) {
                        recognizer = recognizers[i];
                        if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || recognizer.canRecognizeWith(curRecognizer))) {
                            recognizer.recognize(inputData);
                        } else {
                            recognizer.reset();
                        }
                        if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                            curRecognizer = session.curRecognizer = recognizer;
                        }
                        i++;
                    }
                }, get: function (recognizer) {
                    if (recognizer instanceof Recognizer) {
                        return recognizer;
                    }
                    var recognizers = this.recognizers;
                    for (var i = 0; i < recognizers.length; i++) {
                        if (recognizers[i].options.event == recognizer) {
                            return recognizers[i];
                        }
                    }
                    return null;
                }, add: function (recognizer) {
                    if (invokeArrayArg(recognizer, 'add', this)) {
                        return this;
                    }
                    var existing = this.get(recognizer.options.event);
                    if (existing) {
                        this.remove(existing);
                    }
                    this.recognizers.push(recognizer);
                    recognizer.manager = this;
                    this.touchAction.update();
                    return recognizer;
                }, remove: function (recognizer) {
                    if (invokeArrayArg(recognizer, 'remove', this)) {
                        return this;
                    }
                    recognizer = this.get(recognizer);
                    if (recognizer) {
                        var recognizers = this.recognizers;
                        var index = inArray(recognizers, recognizer);
                        if (index !== -1) {
                            recognizers.splice(index, 1);
                            this.touchAction.update();
                        }
                    }
                    return this;
                }, on: function (events, handler) {
                    if (events === undefined) {
                        return;
                    }
                    if (handler === undefined) {
                        return;
                    }
                    var handlers = this.handlers;
                    each(splitStr(events), function (event) {
                        handlers[event] = handlers[event] || [];
                        handlers[event].push(handler);
                    });
                    return this;
                }, off: function (events, handler) {
                    if (events === undefined) {
                        return;
                    }
                    var handlers = this.handlers;
                    each(splitStr(events), function (event) {
                        if (!handler) {
                            delete handlers[event];
                        } else {
                            handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
                        }
                    });
                    return this;
                }, emit: function (event, data) {
                    if (this.options.domEvents) {
                        triggerDomEvent(event, data);
                    }
                    var handlers = this.handlers[event] && this.handlers[event].slice();
                    if (!handlers || !handlers.length) {
                        return;
                    }
                    data.type = event;
                    data.preventDefault = function () {
                        data.srcEvent.preventDefault();
                    };
                    var i = 0;
                    while (i < handlers.length) {
                        handlers[i](data);
                        i++;
                    }
                }, destroy: function () {
                    this.element && toggleCssProps(this, false);
                    this.handlers = {};
                    this.session = {};
                    this.input.destroy();
                    this.element = null;
                }
            };

            function toggleCssProps(manager, add) {
                var element = manager.element;
                if (!element.style) {
                    return;
                }
                var prop;
                each(manager.options.cssProps, function (value, name) {
                    prop = prefixed(element.style, name);
                    if (add) {
                        manager.oldCssProps[prop] = element.style[prop];
                        element.style[prop] = value;
                    } else {
                        element.style[prop] = manager.oldCssProps[prop] || '';
                    }
                });
                if (!add) {
                    manager.oldCssProps = {};
                }
            }

            function triggerDomEvent(event, data) {
                var gestureEvent = document.createEvent('Event');
                gestureEvent.initEvent(event, true, true);
                gestureEvent.gesture = data;
                data.target.dispatchEvent(gestureEvent);
            }

            assign(Hammer, {
                INPUT_START: INPUT_START,
                INPUT_MOVE: INPUT_MOVE,
                INPUT_END: INPUT_END,
                INPUT_CANCEL: INPUT_CANCEL,
                STATE_POSSIBLE: STATE_POSSIBLE,
                STATE_BEGAN: STATE_BEGAN,
                STATE_CHANGED: STATE_CHANGED,
                STATE_ENDED: STATE_ENDED,
                STATE_RECOGNIZED: STATE_RECOGNIZED,
                STATE_CANCELLED: STATE_CANCELLED,
                STATE_FAILED: STATE_FAILED,
                DIRECTION_NONE: DIRECTION_NONE,
                DIRECTION_LEFT: DIRECTION_LEFT,
                DIRECTION_RIGHT: DIRECTION_RIGHT,
                DIRECTION_UP: DIRECTION_UP,
                DIRECTION_DOWN: DIRECTION_DOWN,
                DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
                DIRECTION_VERTICAL: DIRECTION_VERTICAL,
                DIRECTION_ALL: DIRECTION_ALL,
                Manager: Manager,
                Input: Input,
                TouchAction: TouchAction,
                TouchInput: TouchInput,
                MouseInput: MouseInput,
                PointerEventInput: PointerEventInput,
                TouchMouseInput: TouchMouseInput,
                SingleTouchInput: SingleTouchInput,
                Recognizer: Recognizer,
                AttrRecognizer: AttrRecognizer,
                Tap: TapRecognizer,
                Pan: PanRecognizer,
                Swipe: SwipeRecognizer,
                Pinch: PinchRecognizer,
                Rotate: RotateRecognizer,
                Press: PressRecognizer,
                on: addEventListeners,
                off: removeEventListeners,
                each: each,
                merge: merge,
                extend: extend,
                assign: assign,
                inherit: inherit,
                bindFn: bindFn,
                prefixed: prefixed
            });
            var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {}));
            freeGlobal.Hammer = Hammer;
            if (typeof undefined === 'function' && undefined.amd) {
                undefined(function () {
                    return Hammer;
                });
            } else if (module.exports) {
                module.exports = Hammer;
            } else {
                window[exportName] = Hammer;
            }
        })(window, document, 'Hammer');
    });
    var MIN_ZOOM = 0.2, MAX_ZOOM = 4;
    var mouseEvents = ['mousedown', 'mouseup', 'mouseover', 'mouseout', 'click', 'dblclick'];

    function get$1(service, injector) {
        return injector.get(service, false);
    }

    function stopEvent(event$$1) {
        event$$1.preventDefault();
        event$$1.stopPropagation();
        if (typeof event$$1.stopImmediatePropagation === 'function') {
            event$$1.stopImmediatePropagation();
        }
    }

    function createTouchRecognizer(node) {
        function stopMouse(event$$1) {
            forEach(mouseEvents, function (e) {
                componentEvent.bind(node, e, stopEvent, true);
            });
        }

        function allowMouse(event$$1) {
            setTimeout(function () {
                forEach(mouseEvents, function (e) {
                    componentEvent.unbind(node, e, stopEvent, true);
                });
            }, 500);
        }

        componentEvent.bind(node, 'touchstart', stopMouse, true);
        componentEvent.bind(node, 'touchend', allowMouse, true);
        componentEvent.bind(node, 'touchcancel', allowMouse, true);
        var recognizer = new hammer.Manager(node, {inputClass: hammer.TouchInput, recognizers: []});
        var tap = new hammer.Tap();
        var pan = new hammer.Pan({threshold: 10});
        var press = new hammer.Press();
        var pinch = new hammer.Pinch();
        var doubleTap = new hammer.Tap({event: 'doubletap', taps: 2});
        pinch.requireFailure(pan);
        pinch.requireFailure(press);
        recognizer.add([pan, press, pinch, doubleTap, tap]);
        recognizer.reset = function (force) {
            var recognizers = this.recognizers, session = this.session;
            if (session.stopped) {
                return;
            }
            recognizer.stop(force);
            setTimeout(function () {
                var i, r;
                for (i = 0; (r = recognizers[i]); i++) {
                    r.reset();
                    r.state = 8;
                }
                session.curRecognizer = null;
            }, 0);
        };
        recognizer.on('hammer.input', function (event$$1) {
            if (event$$1.srcEvent.defaultPrevented) {
                recognizer.reset(true);
            }
        });
        return recognizer;
    }

    function TouchInteractionEvents(injector, canvas, eventBus, elementRegistry, interactionEvents) {
        var dragging = get$1('dragging', injector), move = get$1('move', injector),
            contextPad = get$1('contextPad', injector), palette = get$1('palette', injector);
        var recognizer;

        function handler(type) {
            return function (event$$1) {
                interactionEvents.fire(type, event$$1);
            };
        }

        function getGfx(target) {
            var node = closest(target, 'svg, .djs-element', true);
            return node;
        }

        function initEvents(svg) {
            recognizer = createTouchRecognizer(svg);
            recognizer.on('doubletap', handler('element.dblclick'));
            recognizer.on('tap', handler('element.click'));

            function startGrabCanvas(event$$1) {
                var lx = 0, ly = 0;

                function update(e) {
                    var dx = e.deltaX - lx, dy = e.deltaY - ly;
                    canvas.scroll({dx: dx, dy: dy});
                    lx = e.deltaX;
                    ly = e.deltaY;
                }

                function end(e) {
                    recognizer.off('panmove', update);
                    recognizer.off('panend', end);
                    recognizer.off('pancancel', end);
                }

                recognizer.on('panmove', update);
                recognizer.on('panend', end);
                recognizer.on('pancancel', end);
            }

            function startGrab(event$$1) {
                var gfx = getGfx(event$$1.target), element = gfx && elementRegistry.get(gfx);
                if (move && canvas.getRootElement() !== element) {
                    return move.start(event$$1, element, true);
                } else {
                    startGrabCanvas(event$$1);
                }
            }

            function startZoom(e) {
                var zoom = canvas.zoom(), mid = e.center;

                function update(e) {
                    var ratio = 1 - (1 - e.scale) / 1.50,
                        newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, ratio * zoom));
                    canvas.zoom(newZoom, mid);
                    stopEvent(e);
                }

                function end(e) {
                    recognizer.off('pinchmove', update);
                    recognizer.off('pinchend', end);
                    recognizer.off('pinchcancel', end);
                    recognizer.reset(true);
                }

                recognizer.on('pinchmove', update);
                recognizer.on('pinchend', end);
                recognizer.on('pinchcancel', end);
            }

            recognizer.on('panstart', startGrab);
            recognizer.on('press', startGrab);
            recognizer.on('pinchstart', startZoom);
        }

        if (dragging) {
            eventBus.on('drag.move', function (event$$1) {
                var originalEvent = event$$1.originalEvent;
                if (!originalEvent || originalEvent instanceof MouseEvent) {
                    return;
                }
                var position = toPoint(originalEvent);
                var node = document.elementFromPoint(position.x, position.y), gfx = getGfx(node),
                    element = gfx && elementRegistry.get(gfx);
                if (element !== event$$1.hover) {
                    if (event$$1.hover) {
                        dragging.out(event$$1);
                    }
                    if (element) {
                        dragging.hover({element: element, gfx: gfx});
                        event$$1.hover = element;
                        event$$1.hoverGfx = gfx;
                    }
                }
            });
        }
        if (contextPad) {
            eventBus.on('contextPad.create', function (event$$1) {
                var node = event$$1.pad.html;
                var padRecognizer = createTouchRecognizer(node);
                padRecognizer.on('panstart', function (event$$1) {
                    contextPad.trigger('dragstart', event$$1, true);
                });
                padRecognizer.on('press', function (event$$1) {
                    contextPad.trigger('dragstart', event$$1, true);
                });
                padRecognizer.on('tap', function (event$$1) {
                    contextPad.trigger('click', event$$1);
                });
            });
        }
        if (palette) {
            eventBus.on('palette.create', function (event$$1) {
                var node = event$$1.container;
                var padRecognizer = createTouchRecognizer(node);
                padRecognizer.on('panstart', function (event$$1) {
                    palette.trigger('dragstart', event$$1, true);
                });
                padRecognizer.on('press', function (event$$1) {
                    palette.trigger('dragstart', event$$1, true);
                });
                padRecognizer.on('tap', function (event$$1) {
                    palette.trigger('click', event$$1);
                });
            });
        }
        eventBus.on('canvas.init', function (event$$1) {
            initEvents(event$$1.svg);
        });
    }

    TouchInteractionEvents.$inject = ['injector', 'canvas', 'eventBus', 'elementRegistry', 'interactionEvents', 'touchFix'];

    function TouchFix(canvas, eventBus) {
        var self = this;
        eventBus.on('canvas.init', function (e) {
            self.addBBoxMarker(e.svg);
        });
    }

    TouchFix.$inject = ['canvas', 'eventBus'];
    TouchFix.prototype.addBBoxMarker = function (svg) {
        var markerStyle = {fill: 'none', class: 'outer-bound-marker'};
        var rect1 = create('rect');
        attr$1(rect1, {x: -10000, y: 10000, width: 10, height: 10});
        attr$1(rect1, markerStyle);
        append(svg, rect1);
        var rect2 = create('rect');
        attr$1(rect2, {x: 10000, y: 10000, width: 10, height: 10});
        attr$1(rect2, markerStyle);
        append(svg, rect2);
    };
    var TouchModule = {
        __depends__: [InteractionEventsModule],
        __init__: ['touchInteractionEvents'],
        touchInteractionEvents: ['type', TouchInteractionEvents],
        touchFix: ['type', TouchFix]
    };
    var TouchModule$1 = {__depends__: [TouchModule]};

    function last(arr) {
        return arr && arr[arr.length - 1];
    }

    function sortTopOrMiddle(element) {
        return element.y;
    }

    function sortLeftOrCenter(element) {
        return element.x;
    }

    var ALIGNMENT_SORTING = {
        left: sortLeftOrCenter, center: sortLeftOrCenter, right: function (element) {
            return element.x + element.width;
        }, top: sortTopOrMiddle, middle: sortTopOrMiddle, bottom: function (element) {
            return element.y + element.height;
        }
    };

    function AlignElements(modeling) {
        this._modeling = modeling;
    }

    AlignElements.$inject = ['modeling'];
    AlignElements.prototype._getOrientationDetails = function (type) {
        var vertical = ['top', 'bottom', 'middle'], axis = 'x', dimension = 'width';
        if (vertical.indexOf(type) !== -1) {
            axis = 'y';
            dimension = 'height';
        }
        return {axis: axis, dimension: dimension};
    };
    AlignElements.prototype._isType = function (type, types) {
        return types.indexOf(type) !== -1;
    };
    AlignElements.prototype._alignmentPosition = function (type, sortedElements) {
        var orientation = this._getOrientationDetails(type), axis = orientation.axis, dimension = orientation.dimension,
            alignment = {}, centers = {}, hasSharedCenters = false, centeredElements, firstElement, lastElement;

        function getMiddleOrTop(first, last) {
            return Math.round((first[axis] + last[axis] + last[dimension]) / 2);
        }

        if (this._isType(type, ['left', 'top'])) {
            alignment[type] = sortedElements[0][axis];
        } else if (this._isType(type, ['right', 'bottom'])) {
            lastElement = last(sortedElements);
            alignment[type] = lastElement[axis] + lastElement[dimension];
        } else if (this._isType(type, ['center', 'middle'])) {
            forEach(sortedElements, function (element) {
                var center = element[axis] + Math.round(element[dimension] / 2);
                if (centers[center]) {
                    centers[center].elements.push(element);
                } else {
                    centers[center] = {elements: [element], center: center};
                }
            });
            centeredElements = sortBy(centers, function (center) {
                if (center.elements.length > 1) {
                    hasSharedCenters = true;
                }
                return center.elements.length;
            });
            if (hasSharedCenters) {
                alignment[type] = last(centeredElements).center;
                return alignment;
            }
            firstElement = sortedElements[0];
            sortedElements = sortBy(sortedElements, function (element) {
                return element[axis] + element[dimension];
            });
            lastElement = last(sortedElements);
            alignment[type] = getMiddleOrTop(firstElement, lastElement);
        }
        return alignment;
    };
    AlignElements.prototype.trigger = function (elements, type) {
        var modeling = this._modeling;
        var filteredElements = filter(elements, function (element) {
            return !(element.waypoints || element.host || element.labelTarget);
        });
        var sortFn = ALIGNMENT_SORTING[type];
        var sortedElements = sortBy(filteredElements, sortFn);
        var alignment = this._alignmentPosition(type, sortedElements);
        modeling.alignElements(sortedElements, alignment);
    };
    var AlignElementsModule = {__init__: ['alignElements'], alignElements: ['type', AlignElements]};

    function isAny(element, types) {
        return some(types, function (t) {
            return is$1(element, t);
        });
    }

    function getParent(element, anyType) {
        if (typeof anyType === 'string') {
            anyType = [anyType];
        }
        while ((element = element.parent)) {
            if (isAny(element, anyType)) {
                return element;
            }
        }
        return null;
    }

    var DEFAULT_HORIZONTAL_DISTANCE = 50;
    var MAX_HORIZONTAL_DISTANCE = 250;
    var PLACEMENT_DETECTION_PAD = 10;

    function getFlowNodePosition(source, element) {
        var sourceTrbl = asTRBL(source);
        var sourceMid = getMid(source);
        var horizontalDistance = getFlowNodeDistance(source, element);
        var orientation = 'left', rowSize = 80, margin = 30;
        if (is$1(source, 'bpmn:BoundaryEvent')) {
            orientation = getOrientation(source, source.host, -25);
            if (orientation.indexOf('top') !== -1) {
                margin *= -1;
            }
        }

        function getVerticalDistance(orient) {
            if (orient.indexOf('top') != -1) {
                return -1 * rowSize;
            } else if (orient.indexOf('bottom') != -1) {
                return rowSize;
            } else {
                return 0;
            }
        }

        var position = {
            x: sourceTrbl.right + horizontalDistance + element.width / 2,
            y: sourceMid.y + getVerticalDistance(orientation)
        };
        var escapeDirection = {y: {margin: margin, rowSize: rowSize}};
        return deconflictPosition(source, element, position, escapeDirection);
    }

    function getFlowNodeDistance(source, element) {
        var sourceTrbl = asTRBL(source);

        function isReference(c) {
            return is$1(c, 'bpmn:SequenceFlow');
        }

        function toTargetNode(weight) {
            return function (shape) {
                return {
                    shape: shape, weight: weight, distanceTo: function (shape) {
                        var shapeTrbl = asTRBL(shape);
                        return shapeTrbl.left - sourceTrbl.right;
                    }
                };
            };
        }

        function toSourceNode(weight) {
            return function (shape) {
                return {
                    shape: shape, weight: weight, distanceTo: function (shape) {
                        var shapeTrbl = asTRBL(shape);
                        return sourceTrbl.left - shapeTrbl.right;
                    }
                };
            };
        }

        var nodes = reduce([].concat(getTargets(source, isReference).map(toTargetNode(5)), getSources(source, isReference).map(toSourceNode(1))), function (nodes, node) {
            nodes[node.shape.id + '__weight_' + node.weight] = node;
            return nodes;
        }, {});
        var distancesGrouped = reduce(nodes, function (result, node) {
            var shape = node.shape, weight = node.weight, distanceTo = node.distanceTo;
            var fav = result.fav, currentDistance, currentDistanceCount, currentDistanceEntry;
            currentDistance = distanceTo(shape);
            if (currentDistance < 0 || currentDistance > MAX_HORIZONTAL_DISTANCE) {
                return result;
            }
            currentDistanceEntry = result[String(currentDistance)] = result[String(currentDistance)] || {
                value: currentDistance,
                count: 0
            };
            currentDistanceCount = currentDistanceEntry.count += 1 * weight;
            if (!fav || fav.count < currentDistanceCount) {
                result.fav = currentDistanceEntry;
            }
            return result;
        }, {});
        if (distancesGrouped.fav) {
            return distancesGrouped.fav.value;
        } else {
            return DEFAULT_HORIZONTAL_DISTANCE;
        }
    }

    function getTextAnnotationPosition(source, element) {
        var sourceTrbl = asTRBL(source);
        var position = {x: sourceTrbl.right + element.width / 2, y: sourceTrbl.top - 50 - element.height / 2};
        var escapeDirection = {y: {margin: -30, rowSize: 20}};
        return deconflictPosition(source, element, position, escapeDirection);
    }

    function getDataElementPosition(source, element) {
        var sourceTrbl = asTRBL(source);
        var position = {x: sourceTrbl.right - 10 + element.width / 2, y: sourceTrbl.bottom + 40 + element.width / 2};
        var escapeDirection = {x: {margin: 30, rowSize: 30}};
        return deconflictPosition(source, element, position, escapeDirection);
    }

    function getDefaultPosition(source, element) {
        var sourceTrbl = asTRBL(source);
        var sourceMid = getMid(source);
        return {x: sourceTrbl.right + DEFAULT_HORIZONTAL_DISTANCE + element.width / 2, y: sourceMid.y};
    }

    function getAutoPlaceClosure(source, element) {
        var allConnected = getConnected(source);
        if (source.host) {
            allConnected = allConnected.concat(getConnected(source.host));
        }
        if (source.attachers) {
            allConnected = allConnected.concat(source.attachers.reduce(function (shapes, attacher) {
                return shapes.concat(getConnected(attacher));
            }, []));
        }
        return allConnected;
    }

    function getConnectedAtPosition(source, position, element) {
        var bounds = {
            x: position.x - (element.width / 2),
            y: position.y - (element.height / 2),
            width: element.width,
            height: element.height
        };
        var closure = getAutoPlaceClosure(source, element);
        return find(closure, function (target) {
            if (target === element) {
                return false;
            }
            var orientation = getOrientation(target, bounds, PLACEMENT_DETECTION_PAD);
            return orientation === 'intersect';
        });
    }

    function deconflictPosition(source, element, position, escapeDelta) {
        function nextPosition(existingElement) {
            var newPosition = {x: position.x, y: position.y};
            ['x', 'y'].forEach(function (axis) {
                var axisDelta = escapeDelta[axis];
                if (!axisDelta) {
                    return;
                }
                var dimension = axis === 'x' ? 'width' : 'height';
                var margin = axisDelta.margin, rowSize = axisDelta.rowSize;
                if (margin < 0) {
                    newPosition[axis] = Math.min(existingElement[axis] + margin - element[dimension] / 2, position[axis] - rowSize + margin);
                } else {
                    newPosition[axis] = Math.max(existingTarget[axis] + existingTarget[dimension] + margin + element[dimension] / 2, position[axis] + rowSize + margin);
                }
            });
            return newPosition;
        }

        var existingTarget;
        while ((existingTarget = getConnectedAtPosition(source, position, element))) {
            position = nextPosition(existingTarget);
        }
        return position;
    }

    function noneFilter() {
        return true;
    }

    function getConnected(element, connectionFilter) {
        return [].concat(getTargets(element, connectionFilter), getSources(element, connectionFilter));
    }

    function getSources(shape, connectionFilter) {
        if (!connectionFilter) {
            connectionFilter = noneFilter;
        }
        return shape.incoming.filter(connectionFilter).map(function (c) {
            return c.source;
        });
    }

    function getTargets(shape, connectionFilter) {
        if (!connectionFilter) {
            connectionFilter = noneFilter;
        }
        return shape.outgoing.filter(connectionFilter).map(function (c) {
            return c.target;
        });
    }

    function AutoPlace(eventBus, modeling) {
        function emit(event, payload) {
            return eventBus.fire(event, payload);
        }

        this.append = function (source, shape) {
            var position = emit('autoPlace', {source: source, shape: shape});
            if (!position) {
                position = getNewShapePosition(source, shape);
            }
            var newShape = modeling.appendShape(source, shape, position, source.parent);
            emit('autoPlace.end', {shape: newShape});
            return newShape;
        };
    }

    AutoPlace.$inject = ['eventBus', 'modeling'];

    function getNewShapePosition(source, element) {
        if (is$1(element, 'bpmn:TextAnnotation')) {
            return getTextAnnotationPosition(source, element);
        }
        if (isAny(element, ['bpmn:DataObjectReference', 'bpmn:DataStoreReference'])) {
            return getDataElementPosition(source, element);
        }
        if (is$1(element, 'bpmn:FlowNode')) {
            return getFlowNodePosition(source, element);
        }
        return getDefaultPosition(source, element);
    }

    function AutoPlaceSelectionBehavior(eventBus, selection) {
        eventBus.on('autoPlace.end', 500, function (e) {
            selection.select(e.shape);
        });
    }

    AutoPlaceSelectionBehavior.$inject = ['eventBus', 'selection'];
    var AutoPlaceModule = {
        __init__: ['autoPlaceSelectionBehavior'],
        autoPlace: ['type', AutoPlace],
        autoPlaceSelectionBehavior: ['type', AutoPlaceSelectionBehavior]
    };
    var DEFAULT_PRIORITY$2 = 1000;

    function CommandInterceptor(eventBus) {
        this._eventBus = eventBus;
    }

    CommandInterceptor.$inject = ['eventBus'];

    function unwrapEvent(fn, that) {
        return function (event) {
            return fn.call(that || null, event.context, event.command, event);
        };
    }

    CommandInterceptor.prototype.on = function (events, hook, priority, handlerFn, unwrap, that) {
        if (isFunction(hook) || isNumber(hook)) {
            that = unwrap;
            unwrap = handlerFn;
            handlerFn = priority;
            priority = hook;
            hook = null;
        }
        if (isFunction(priority)) {
            that = unwrap;
            unwrap = handlerFn;
            handlerFn = priority;
            priority = DEFAULT_PRIORITY$2;
        }
        if (isObject(unwrap)) {
            that = unwrap;
            unwrap = false;
        }
        if (!isFunction(handlerFn)) {
            throw new Error('handlerFn must be a function');
        }
        if (!isArray(events)) {
            events = [events];
        }
        var eventBus = this._eventBus;
        forEach(events, function (event) {
            var fullEvent = ['commandStack', event, hook].filter(function (e) {
                return e;
            }).join('.');
            eventBus.on(fullEvent, priority, unwrap ? unwrapEvent(handlerFn, that) : handlerFn, that);
        });
    };
    var hooks = ['canExecute', 'preExecute', 'preExecuted', 'execute', 'executed', 'postExecute', 'postExecuted', 'revert', 'reverted'];
    forEach(hooks, function (hook) {
        CommandInterceptor.prototype[hook] = function (events, priority, handlerFn, unwrap, that) {
            if (isFunction(events) || isNumber(events)) {
                that = unwrap;
                unwrap = handlerFn;
                handlerFn = priority;
                priority = events;
                events = null;
            }
            this.on(events, hook, priority, handlerFn, unwrap, that);
        };
    });

    function AutoResize(eventBus, elementRegistry, modeling, rules) {
        CommandInterceptor.call(this, eventBus);
        this._elementRegistry = elementRegistry;
        this._modeling = modeling;
        this._rules = rules;
        var self = this;
        this.postExecuted(['shape.create'], function (event) {
            var context = event.context, hints = context.hints, shape = context.shape,
                parent = context.parent || context.newParent;
            if (hints && (hints.root === false || hints.autoResize === false)) {
                return;
            }
            self._expand([shape], parent);
        });
        this.postExecuted(['elements.move'], function (event) {
            var context = event.context, elements = flatten(values(context.closure.topLevel)), hints = context.hints;
            var autoResize = hints ? hints.autoResize : true;
            if (autoResize === false) {
                return;
            }
            var expandings = groupBy(elements, function (element) {
                return element.parent.id;
            });
            forEach(expandings, function (elements, parentId) {
                if (isArray(autoResize)) {
                    elements = elements.filter(function (element) {
                        return autoResize.indexOf(element) !== -1;
                    });
                }
                self._expand(elements, parentId);
            });
        });
        this.postExecuted(['shape.toggleCollapse'], function (event) {
            var context = event.context, hints = context.hints, shape = context.shape;
            if (hints && (hints.root === false || hints.autoResize === false)) {
                return;
            }
            if (shape.collapsed) {
                return;
            }
            self._expand(shape.children || [], shape);
        });
        this.postExecuted(['shape.resize'], function (event) {
            var context = event.context, hints = context.hints, shape = context.shape, parent = shape.parent;
            if (hints && (hints.root === false || hints.autoResize === false)) {
                return;
            }
            if (parent) {
                self._expand([shape], parent);
            }
        });
    }

    AutoResize.$inject = ['eventBus', 'elementRegistry', 'modeling', 'rules'];
    inherits_browser(AutoResize, CommandInterceptor);
    AutoResize.prototype._getOptimalBounds = function (elements, target) {
        var offset = this.getOffset(target), padding = this.getPadding(target);
        var elementsTrbl = asTRBL(getBBox(elements)), targetTrbl = asTRBL(target);
        var newTrbl = {};
        if (elementsTrbl.top - targetTrbl.top < padding.top) {
            newTrbl.top = elementsTrbl.top - offset.top;
        }
        if (elementsTrbl.left - targetTrbl.left < padding.left) {
            newTrbl.left = elementsTrbl.left - offset.left;
        }
        if (targetTrbl.right - elementsTrbl.right < padding.right) {
            newTrbl.right = elementsTrbl.right + offset.right;
        }
        if (targetTrbl.bottom - elementsTrbl.bottom < padding.bottom) {
            newTrbl.bottom = elementsTrbl.bottom + offset.bottom;
        }
        return asBounds(assign({}, targetTrbl, newTrbl));
    };
    AutoResize.prototype._expand = function (elements, target) {
        if (typeof target === 'string') {
            target = this._elementRegistry.get(target);
        }
        var allowed = this._rules.allowed('element.autoResize', {elements: elements, target: target});
        if (!allowed) {
            return;
        }
        var newBounds = this._getOptimalBounds(elements, target);
        if (!boundsChanged(newBounds, target)) {
            return;
        }
        this.resize(target, newBounds);
        var parent = target.parent;
        if (parent) {
            this._expand([target], parent);
        }
    };
    AutoResize.prototype.getOffset = function (shape) {
        return {top: 60, bottom: 60, left: 100, right: 100};
    };
    AutoResize.prototype.getPadding = function (shape) {
        return {top: 2, bottom: 2, left: 15, right: 15};
    };
    AutoResize.prototype.resize = function (target, newBounds) {
        this._modeling.resizeShape(target, newBounds);
    };

    function boundsChanged(newBounds, oldBounds) {
        return (newBounds.x !== oldBounds.x || newBounds.y !== oldBounds.y || newBounds.width !== oldBounds.width || newBounds.height !== oldBounds.height);
    }

    function BpmnAutoResize(injector) {
        injector.invoke(AutoResize, this);
    }

    BpmnAutoResize.$inject = ['injector'];
    inherits_browser(BpmnAutoResize, AutoResize);
    BpmnAutoResize.prototype.resize = function (target, newBounds) {
        if (is$1(target, 'bpmn:Participant')) {
            this._modeling.resizeLane(target, newBounds);
        } else {
            this._modeling.resizeShape(target, newBounds);
        }
    };

    function RuleProvider(eventBus) {
        CommandInterceptor.call(this, eventBus);
        this.init();
    }

    RuleProvider.$inject = ['eventBus'];
    inherits_browser(RuleProvider, CommandInterceptor);
    RuleProvider.prototype.addRule = function (actions, priority, fn) {
        var self = this;
        if (typeof actions === 'string') {
            actions = [actions];
        }
        actions.forEach(function (action) {
            self.canExecute(action, priority, function (context, action, event) {
                return fn(context);
            }, true);
        });
    };
    RuleProvider.prototype.init = function () {
    };

    function AutoResizeProvider(eventBus) {
        RuleProvider.call(this, eventBus);
        var self = this;
        this.addRule('element.autoResize', function (context) {
            return self.canResize(context.elements, context.target);
        });
    }

    AutoResizeProvider.$inject = ['eventBus'];
    inherits_browser(AutoResizeProvider, RuleProvider);
    AutoResizeProvider.prototype.canResize = function (elements, target) {
        return false;
    };

    function BpmnAutoResizeProvider(eventBus, modeling) {
        AutoResizeProvider.call(this, eventBus);
        this._modeling = modeling;
    }

    inherits_browser(BpmnAutoResizeProvider, AutoResizeProvider);
    BpmnAutoResizeProvider.$inject = ['eventBus', 'modeling'];
    BpmnAutoResizeProvider.prototype.canResize = function (elements, target) {
        if (!is$1(target, 'bpmn:Participant') && !is$1(target, 'bpmn:Lane') && !(is$1(target, 'bpmn:SubProcess'))) {
            return false;
        }
        var canResize = true;
        forEach(elements, function (element) {
            if (is$1(element, 'bpmn:Lane') || element.labelTarget) {
                canResize = false;
                return;
            }
        });
        return canResize;
    };
    var AutoResizeModule = {
        __init__: ['bpmnAutoResize', 'bpmnAutoResizeProvider'],
        bpmnAutoResize: ['type', BpmnAutoResize],
        bpmnAutoResizeProvider: ['type', BpmnAutoResizeProvider]
    };
    var round$1 = Math.round;
    var DRAG_ACTIVE_CLS = 'djs-drag-active';

    function preventDefault(event$$1) {
        event$$1.preventDefault();
    }

    function isTouchEvent(event$$1) {
        return typeof TouchEvent !== 'undefined' && event$$1 instanceof TouchEvent;
    }

    function getLength(point) {
        return Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2));
    }

    function Dragging(eventBus, canvas, selection) {
        var defaultOptions = {threshold: 5, trapClick: true};
        var context;

        function toLocalPoint(globalPosition) {
            var viewbox = canvas.viewbox();
            var clientRect = canvas._container.getBoundingClientRect();
            return {
                x: viewbox.x + (globalPosition.x - clientRect.left) / viewbox.scale,
                y: viewbox.y + (globalPosition.y - clientRect.top) / viewbox.scale
            };
        }

        function fire(type, dragContext) {
            dragContext = dragContext || context;
            var event$$1 = eventBus.createEvent(assign({}, dragContext.payload, dragContext.data, {isTouch: dragContext.isTouch}));
            if (eventBus.fire('drag.' + type, event$$1) === false) {
                return false;
            }
            return eventBus.fire(dragContext.prefix + '.' + type, event$$1);
        }

        function move(event$$1, activate) {
            var payload = context.payload, displacement = context.displacement;
            var globalStart = context.globalStart, globalCurrent = toPoint(event$$1),
                globalDelta = delta(globalCurrent, globalStart);
            var localStart = context.localStart, localCurrent = toLocalPoint(globalCurrent),
                localDelta = delta(localCurrent, localStart);
            if (!context.active && (activate || getLength(globalDelta) > context.threshold)) {
                assign(payload, {
                    x: round$1(localStart.x + displacement.x),
                    y: round$1(localStart.y + displacement.y),
                    dx: 0,
                    dy: 0
                }, {originalEvent: event$$1});
                if (false === fire('start')) {
                    return cancel();
                }
                context.active = true;
                if (!context.keepSelection) {
                    payload.previousSelection = selection.get();
                    selection.select(null);
                }
                if (context.cursor) {
                    set$1(context.cursor);
                }
                canvas.addMarker(canvas.getRootElement(), DRAG_ACTIVE_CLS);
            }
            stopPropagation(event$$1);
            if (context.active) {
                assign(payload, {
                    x: round$1(localCurrent.x + displacement.x),
                    y: round$1(localCurrent.y + displacement.y),
                    dx: round$1(localDelta.x),
                    dy: round$1(localDelta.y)
                }, {originalEvent: event$$1});
                fire('move');
            }
        }

        function end(event$$1) {
            var previousContext, returnValue = true;
            if (context.active) {
                if (event$$1) {
                    context.payload.originalEvent = event$$1;
                    stopPropagation(event$$1);
                }
                returnValue = fire('end');
            }
            if (returnValue === false) {
                fire('rejected');
            }
            previousContext = cleanup(returnValue !== true);
            fire('ended', previousContext);
        }

        function checkCancel(event$$1) {
            if (event$$1.which === 27) {
                preventDefault(event$$1);
                cancel();
            }
        }

        function trapClickAndEnd(event$$1) {
            var untrap;
            if (context.active) {
                untrap = install(eventBus);
                setTimeout(untrap, 400);
                preventDefault(event$$1);
            }
            end(event$$1);
        }

        function trapTouch(event$$1) {
            move(event$$1);
        }

        function hover(event$$1) {
            var payload = context.payload;
            payload.hoverGfx = event$$1.gfx;
            payload.hover = event$$1.element;
            fire('hover');
        }

        function out(event$$1) {
            fire('out');
            var payload = context.payload;
            payload.hoverGfx = null;
            payload.hover = null;
        }

        function cancel(restore) {
            var previousContext;
            if (!context) {
                return;
            }
            var wasActive = context.active;
            if (wasActive) {
                fire('cancel');
            }
            previousContext = cleanup(restore);
            if (wasActive) {
                fire('canceled', previousContext);
            }
        }

        function cleanup(restore) {
            var previousContext, endDrag;
            fire('cleanup');
            unset();
            if (context.trapClick) {
                endDrag = trapClickAndEnd;
            } else {
                endDrag = end;
            }
            componentEvent.unbind(document, 'mousemove', move);
            componentEvent.unbind(document, 'dragstart', preventDefault);
            componentEvent.unbind(document, 'selectstart', preventDefault);
            componentEvent.unbind(document, 'mousedown', endDrag, true);
            componentEvent.unbind(document, 'mouseup', endDrag, true);
            componentEvent.unbind(document, 'keyup', checkCancel);
            componentEvent.unbind(document, 'touchstart', trapTouch, true);
            componentEvent.unbind(document, 'touchcancel', cancel, true);
            componentEvent.unbind(document, 'touchmove', move, true);
            componentEvent.unbind(document, 'touchend', end, true);
            eventBus.off('element.hover', hover);
            eventBus.off('element.out', out);
            canvas.removeMarker(canvas.getRootElement(), DRAG_ACTIVE_CLS);
            var previousSelection = context.payload.previousSelection;
            if (restore !== false && previousSelection && !selection.get().length) {
                selection.select(previousSelection);
            }
            previousContext = context;
            context = null;
            return previousContext;
        }

        function init(event$$1, relativeTo, prefix, options) {
            if (context) {
                cancel(false);
            }
            if (typeof relativeTo === 'string') {
                options = prefix;
                prefix = relativeTo;
                relativeTo = null;
            }
            options = assign({}, defaultOptions, options || {});
            var data = options.data || {}, originalEvent, globalStart, localStart, endDrag, isTouch;
            if (options.trapClick) {
                endDrag = trapClickAndEnd;
            } else {
                endDrag = end;
            }
            if (event$$1) {
                originalEvent = getOriginal(event$$1) || event$$1;
                globalStart = toPoint(event$$1);
                stopPropagation(event$$1);
                if (originalEvent.type === 'dragstart') {
                    preventDefault(originalEvent);
                }
            } else {
                originalEvent = null;
                globalStart = {x: 0, y: 0};
            }
            localStart = toLocalPoint(globalStart);
            if (!relativeTo) {
                relativeTo = localStart;
            }
            isTouch = isTouchEvent(originalEvent);
            context = assign({
                prefix: prefix,
                data: data,
                payload: {},
                globalStart: globalStart,
                displacement: delta(relativeTo, localStart),
                localStart: localStart,
                isTouch: isTouch
            }, options);
            if (!options.manual) {
                if (isTouch) {
                    componentEvent.bind(document, 'touchstart', trapTouch, true);
                    componentEvent.bind(document, 'touchcancel', cancel, true);
                    componentEvent.bind(document, 'touchmove', move, true);
                    componentEvent.bind(document, 'touchend', end, true);
                } else {
                    componentEvent.bind(document, 'mousemove', move);
                    componentEvent.bind(document, 'dragstart', preventDefault);
                    componentEvent.bind(document, 'selectstart', preventDefault);
                    componentEvent.bind(document, 'mousedown', endDrag, true);
                    componentEvent.bind(document, 'mouseup', endDrag, true);
                }
                componentEvent.bind(document, 'keyup', checkCancel);
                eventBus.on('element.hover', hover);
                eventBus.on('element.out', out);
            }
            fire('init');
            if (options.autoActivate) {
                move(event$$1, true);
            }
        }

        eventBus.on('diagram.destroy', cancel);
        this.init = init;
        this.move = move;
        this.hover = hover;
        this.out = out;
        this.end = end;
        this.cancel = cancel;
        this.context = function () {
            return context;
        };
        this.setOptions = function (options) {
            assign(defaultOptions, options);
        };
    }

    Dragging.$inject = ['eventBus', 'canvas', 'selection'];

    function getGfx(target) {
        var node = closest(target, 'svg, .djs-element', true);
        return node;
    }

    function HoverFix(eventBus, dragging, elementRegistry) {
        var self = this;
        eventBus.on('drag.start', function (event) {
            eventBus.once('drag.move', function () {
                eventBus.once('drag.move', function (event) {
                    self.ensureHover(event);
                });
            });
        });
        this.ensureHover = function (event) {
            if (event.hover) {
                return;
            }
            var originalEvent = event.originalEvent, position, target, element, gfx;
            if (!(originalEvent instanceof MouseEvent)) {
                return;
            }
            position = toPoint(originalEvent);
            target = document.elementFromPoint(position.x, position.y);
            gfx = getGfx(target);
            if (gfx) {
                element = elementRegistry.get(gfx);
                dragging.hover({element: element, gfx: gfx});
            }
        };
    }

    HoverFix.$inject = ['eventBus', 'dragging', 'elementRegistry'];
    var DraggingModule = {
        __init__: ['hoverFix'],
        __depends__: [SelectionModule],
        dragging: ['type', Dragging],
        hoverFix: ['type', HoverFix]
    };

    function MouseTracking(eventBus, canvas) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._init();
    }

    MouseTracking.$inject = ['eventBus', 'canvas'];
    MouseTracking.prototype.getHoverContext = function () {
        var viewbox = this._canvas.viewbox();
        return {
            element: this._hoverElement,
            point: {
                x: viewbox.x + Math.round(this._mouseX / viewbox.scale),
                y: viewbox.y + Math.round(this._mouseY / viewbox.scale)
            }
        };
    };
    MouseTracking.prototype._init = function () {
        var eventBus = this._eventBus, canvas = this._canvas;
        var container = canvas.getContainer();
        this._setMousePosition = bind(this._setMousePosition, this);
        container.addEventListener('mousemove', this._setMousePosition);
        eventBus.on('diagram.destroy', function () {
            container.removeEventListener('mousemove', this._setMousePosition);
        }, this);
        eventBus.on('element.hover', this._setHoverElement, this);
    };
    MouseTracking.prototype._setHoverElement = function (event) {
        this._hoverElement = event.element;
    };
    MouseTracking.prototype._setMousePosition = function (event) {
        this._mouseX = event.layerX;
        this._mouseY = event.layerY;
    };
    var MouseTrackingModule = {__init__: ['mouseTracking'], mouseTracking: ['type', MouseTracking]};

    function AutoScroll(config, eventBus, canvas, mouseTracking) {
        this._canvas = canvas;
        this._mouseTracking = mouseTracking;
        this._opts = assign({
            scrollThresholdIn: [20, 20, 20, 20],
            scrollThresholdOut: [0, 0, 0, 0],
            scrollRepeatTimeout: 15,
            scrollStep: 10
        }, config);
        var self = this;
        eventBus.on('drag.move', function (e) {
            var point = self._toBorderPoint(e);
            self.startScroll(point);
        });
        eventBus.on(['drag.cleanup'], function () {
            self.stopScroll();
        });
    }

    AutoScroll.$inject = ['config.autoScroll', 'eventBus', 'canvas', 'mouseTracking'];
    AutoScroll.prototype.startScroll = function (point) {
        var canvas = this._canvas;
        var opts = this._opts;
        var self = this;
        var clientRect = canvas.getContainer().getBoundingClientRect();
        var diff = [point.x, point.y, clientRect.width - point.x, clientRect.height - point.y];
        this.stopScroll();
        var dx = 0, dy = 0;
        for (var i = 0; i < 4; i++) {
            if (between(diff[i], opts.scrollThresholdOut[i], opts.scrollThresholdIn[i])) {
                if (i === 0) {
                    dx = opts.scrollStep;
                } else if (i == 1) {
                    dy = opts.scrollStep;
                } else if (i == 2) {
                    dx = -opts.scrollStep;
                } else if (i == 3) {
                    dy = -opts.scrollStep;
                }
            }
        }
        if (dx !== 0 || dy !== 0) {
            canvas.scroll({dx: dx, dy: dy});
            this._scrolling = setTimeout(function () {
                self.startScroll(point);
            }, opts.scrollRepeatTimeout);
        }
    };

    function between(val, start, end) {
        if (start < val && val < end) {
            return true;
        }
        return false;
    }

    AutoScroll.prototype.stopScroll = function () {
        clearTimeout(this._scrolling);
    };
    AutoScroll.prototype.setOptions = function (options) {
        this._opts = assign({}, this._opts, options);
    };
    AutoScroll.prototype._toBorderPoint = function (event) {
        var clientRect = this._canvas._container.getBoundingClientRect();
        var globalPosition = toPoint(event.originalEvent);
        return {x: globalPosition.x - clientRect.left, y: globalPosition.y - clientRect.top};
    };
    var AutoScrollModule = {
        __depends__: [DraggingModule, MouseTrackingModule],
        __init__: ['autoScroll'],
        autoScroll: ['type', AutoScroll]
    };

    function Rules(injector) {
        this._commandStack = injector.get('commandStack', false);
    }

    Rules.$inject = ['injector'];
    Rules.prototype.allowed = function (action, context) {
        var allowed = true;
        var commandStack = this._commandStack;
        if (commandStack) {
            allowed = commandStack.canExecute(action, context);
        }
        return allowed === undefined ? true : allowed;
    };
    var RulesModule = {__init__: ['rules'], rules: ['type', Rules]};
    var BENDPOINT_CLS = 'djs-bendpoint';
    var SEGMENT_DRAGGER_CLS = 'djs-segment-dragger';

    function toCanvasCoordinates(canvas, event) {
        var position = toPoint(event), clientRect = canvas._container.getBoundingClientRect(), offset;
        offset = {x: clientRect.left, y: clientRect.top};
        var viewbox = canvas.viewbox();
        return {
            x: viewbox.x + (position.x - offset.x) / viewbox.scale,
            y: viewbox.y + (position.y - offset.y) / viewbox.scale
        };
    }

    function addBendpoint(parentGfx, cls) {
        var groupGfx = create('g');
        classes$1(groupGfx).add(BENDPOINT_CLS);
        append(parentGfx, groupGfx);
        var visual = create('circle');
        attr$1(visual, {cx: 0, cy: 0, r: 4});
        classes$1(visual).add('djs-visual');
        append(groupGfx, visual);
        var hit = create('circle');
        attr$1(hit, {cx: 0, cy: 0, r: 10});
        classes$1(hit).add('djs-hit');
        append(groupGfx, hit);
        if (cls) {
            classes$1(groupGfx).add(cls);
        }
        return groupGfx;
    }

    function createParallelDragger(parentGfx, position, alignment) {
        var draggerGfx = create('g');
        append(parentGfx, draggerGfx);
        var width = 14, height = 3, padding = 6, hitWidth = width + padding, hitHeight = height + padding;
        var visual = create('rect');
        attr$1(visual, {x: -width / 2, y: -height / 2, width: width, height: height});
        classes$1(visual).add('djs-visual');
        append(draggerGfx, visual);
        var hit = create('rect');
        attr$1(hit, {x: -hitWidth / 2, y: -hitHeight / 2, width: hitWidth, height: hitHeight});
        classes$1(hit).add('djs-hit');
        append(draggerGfx, hit);
        rotate(draggerGfx, alignment === 'h' ? 90 : 0, 0, 0);
        return draggerGfx;
    }

    function addSegmentDragger(parentGfx, segmentStart, segmentEnd) {
        var groupGfx = create('g'), mid = getMidPoint(segmentStart, segmentEnd),
            alignment = pointsAligned(segmentStart, segmentEnd);
        append(parentGfx, groupGfx);
        createParallelDragger(groupGfx, mid, alignment);
        classes$1(groupGfx).add(SEGMENT_DRAGGER_CLS);
        classes$1(groupGfx).add(alignment === 'h' ? 'vertical' : 'horizontal');
        translate(groupGfx, mid.x, mid.y);
        return groupGfx;
    }

    var css_escape = createCommonjsModule(function (module, exports) {
        (function (root, factory) {
            {
                module.exports = factory(root);
            }
        }(typeof commonjsGlobal != 'undefined' ? commonjsGlobal : commonjsGlobal, function (root) {
            if (root.CSS && root.CSS.escape) {
                return root.CSS.escape;
            }
            var cssEscape = function (value) {
                if (arguments.length == 0) {
                    throw new TypeError('`CSS.escape` requires an argument.');
                }
                var string = String(value);
                var length = string.length;
                var index = -1;
                var codeUnit;
                var result = '';
                var firstCodeUnit = string.charCodeAt(0);
                while (++index < length) {
                    codeUnit = string.charCodeAt(index);
                    if (codeUnit == 0x0000) {
                        result += '\uFFFD';
                        continue;
                    }
                    if ((codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F || (index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) || (index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D)) {
                        result += '\\' + codeUnit.toString(16) + ' ';
                        continue;
                    }
                    if (index == 0 && length == 1 && codeUnit == 0x002D) {
                        result += '\\' + string.charAt(index);
                        continue;
                    }
                    if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
                        result += string.charAt(index);
                        continue;
                    }
                    result += '\\' + string.charAt(index);
                }
                return result;
            };
            if (!root.CSS) {
                root.CSS = {};
            }
            root.CSS.escape = cssEscape;
            return cssEscape;
        }));
    });
    var round$2 = Math.round, max = Math.max;

    function circlePath(center, r) {
        var x = center.x, y = center.y;
        return [['M', x, y], ['m', 0, -r], ['a', r, r, 0, 1, 1, 0, 2 * r], ['a', r, r, 0, 1, 1, 0, -2 * r], ['z']];
    }

    function linePath(points) {
        var segments = [];
        points.forEach(function (p, idx) {
            segments.push([idx === 0 ? 'M' : 'L', p.x, p.y]);
        });
        return segments;
    }

    var INTERSECTION_THRESHOLD = 10;

    function getBendpointIntersection(waypoints, reference) {
        var i, w;
        for (i = 0; (w = waypoints[i]); i++) {
            if (pointDistance(w, reference) <= INTERSECTION_THRESHOLD) {
                return {point: waypoints[i], bendpoint: true, index: i};
            }
        }
        return null;
    }

    function getPathIntersection(waypoints, reference) {
        var intersections = intersect(circlePath(reference, INTERSECTION_THRESHOLD), linePath(waypoints));
        var a = intersections[0], b = intersections[intersections.length - 1], idx;
        if (!a) {
            return null;
        }
        if (a !== b) {
            if (a.segment2 !== b.segment2) {
                idx = max(a.segment2, b.segment2) - 1;
                return {point: waypoints[idx], bendpoint: true, index: idx};
            }
            return {point: {x: (round$2(a.x + b.x) / 2), y: (round$2(a.y + b.y) / 2)}, index: a.segment2};
        }
        return {point: {x: round$2(a.x), y: round$2(a.y)}, index: a.segment2};
    }

    function getApproxIntersection(waypoints, reference) {
        return getBendpointIntersection(waypoints, reference) || getPathIntersection(waypoints, reference);
    }

    function Bendpoints(eventBus, canvas, interactionEvents, bendpointMove, connectionSegmentMove) {
        function getConnectionIntersection(waypoints, event$$1) {
            var localPosition = toCanvasCoordinates(canvas, event$$1),
                intersection = getApproxIntersection(waypoints, localPosition);
            return intersection;
        }

        function isIntersectionMiddle(intersection, waypoints, treshold) {
            var idx = intersection.index, p = intersection.point, p0, p1, mid, aligned, xDelta, yDelta;
            if (idx <= 0 || intersection.bendpoint) {
                return false;
            }
            p0 = waypoints[idx - 1];
            p1 = waypoints[idx];
            mid = getMidPoint(p0, p1), aligned = pointsAligned(p0, p1);
            xDelta = Math.abs(p.x - mid.x);
            yDelta = Math.abs(p.y - mid.y);
            return aligned && xDelta <= treshold && yDelta <= treshold;
        }

        function activateBendpointMove(event$$1, connection) {
            var waypoints = connection.waypoints, intersection = getConnectionIntersection(waypoints, event$$1);
            if (!intersection) {
                return;
            }
            if (isIntersectionMiddle(intersection, waypoints, 10)) {
                connectionSegmentMove.start(event$$1, connection, intersection.index);
            } else {
                bendpointMove.start(event$$1, connection, intersection.index, !intersection.bendpoint);
            }
            return true;
        }

        function bindInteractionEvents(node, eventName, element) {
            componentEvent.bind(node, eventName, function (event$$1) {
                interactionEvents.triggerMouseEvent(eventName, event$$1, element);
                event$$1.stopPropagation();
            });
        }

        function getBendpointsContainer(element, create$$1) {
            var layer = canvas.getLayer('overlays'),
                gfx = query('.djs-bendpoints[data-element-id="' + css_escape(element.id) + '"]', layer);
            if (!gfx && create$$1) {
                gfx = create('g');
                attr$1(gfx, {'data-element-id': element.id});
                classes$1(gfx).add('djs-bendpoints');
                append(layer, gfx);
                bindInteractionEvents(gfx, 'mousedown', element);
                bindInteractionEvents(gfx, 'click', element);
                bindInteractionEvents(gfx, 'dblclick', element);
            }
            return gfx;
        }

        function createBendpoints(gfx, connection) {
            connection.waypoints.forEach(function (p, idx) {
                var bendpoint = addBendpoint(gfx);
                append(gfx, bendpoint);
                translate(bendpoint, p.x, p.y);
            });
            addBendpoint(gfx, 'floating');
        }

        function createSegmentDraggers(gfx, connection) {
            var waypoints = connection.waypoints;
            var segmentStart, segmentEnd;
            for (var i = 1; i < waypoints.length; i++) {
                segmentStart = waypoints[i - 1];
                segmentEnd = waypoints[i];
                if (pointsAligned(segmentStart, segmentEnd)) {
                    addSegmentDragger(gfx, segmentStart, segmentEnd);
                }
            }
        }

        function clearBendpoints(gfx) {
            forEach(all('.' + BENDPOINT_CLS, gfx), function (node) {
                remove$1(node);
            });
        }

        function clearSegmentDraggers(gfx) {
            forEach(all('.' + SEGMENT_DRAGGER_CLS, gfx), function (node) {
                remove$1(node);
            });
        }

        function addHandles(connection) {
            var gfx = getBendpointsContainer(connection);
            if (!gfx) {
                gfx = getBendpointsContainer(connection, true);
                createBendpoints(gfx, connection);
                createSegmentDraggers(gfx, connection);
            }
            return gfx;
        }

        function updateHandles(connection) {
            var gfx = getBendpointsContainer(connection);
            if (gfx) {
                clearSegmentDraggers(gfx);
                clearBendpoints(gfx);
                createSegmentDraggers(gfx, connection);
                createBendpoints(gfx, connection);
            }
        }

        eventBus.on('connection.changed', function (event$$1) {
            updateHandles(event$$1.element);
        });
        eventBus.on('connection.remove', function (event$$1) {
            var gfx = getBendpointsContainer(event$$1.element);
            if (gfx) {
                remove$1(gfx);
            }
        });
        eventBus.on('element.marker.update', function (event$$1) {
            var element = event$$1.element, bendpointsGfx;
            if (!element.waypoints) {
                return;
            }
            bendpointsGfx = addHandles(element);
            if (event$$1.add) {
                classes$1(bendpointsGfx).add(event$$1.marker);
            } else {
                classes$1(bendpointsGfx).remove(event$$1.marker);
            }
        });
        eventBus.on('element.mousemove', function (event$$1) {
            var element = event$$1.element, waypoints = element.waypoints, bendpointsGfx, floating, intersection;
            if (waypoints) {
                bendpointsGfx = getBendpointsContainer(element, true);
                floating = query('.floating', bendpointsGfx);
                if (!floating) {
                    return;
                }
                intersection = getConnectionIntersection(waypoints, event$$1.originalEvent);
                if (intersection) {
                    translate(floating, intersection.point.x, intersection.point.y);
                }
            }
        });
        eventBus.on('element.mousedown', function (event$$1) {
            var originalEvent = event$$1.originalEvent, element = event$$1.element, waypoints = element.waypoints;
            if (!waypoints) {
                return;
            }
            return activateBendpointMove(originalEvent, element, waypoints);
        });
        eventBus.on('selection.changed', function (event$$1) {
            var newSelection = event$$1.newSelection, primary = newSelection[0];
            if (primary && primary.waypoints) {
                addHandles(primary);
            }
        });
        eventBus.on('element.hover', function (event$$1) {
            var element = event$$1.element;
            if (element.waypoints) {
                addHandles(element);
                interactionEvents.registerEvent(event$$1.gfx, 'mousemove', 'element.mousemove');
            }
        });
        eventBus.on('element.out', function (event$$1) {
            interactionEvents.unregisterEvent(event$$1.gfx, 'mousemove', 'element.mousemove');
        });
        eventBus.on('element.updateId', function (context) {
            var element = context.element, newId = context.newId;
            if (element.waypoints) {
                var bendpointContainer = getBendpointsContainer(element);
                if (bendpointContainer) {
                    attr$1(bendpointContainer, {'data-element-id': newId});
                }
            }
        });
        this.addHandles = addHandles;
        this.updateHandles = updateHandles;
        this.getBendpointsContainer = getBendpointsContainer;
    }

    Bendpoints.$inject = ['eventBus', 'canvas', 'interactionEvents', 'bendpointMove', 'connectionSegmentMove'];
    var MARKER_OK = 'connect-ok', MARKER_NOT_OK = 'connect-not-ok', MARKER_CONNECT_HOVER = 'connect-hover',
        MARKER_CONNECT_UPDATING = 'djs-updating';
    var COMMAND_BENDPOINT_UPDATE = 'connection.updateWaypoints', COMMAND_RECONNECT_START = 'connection.reconnectStart',
        COMMAND_RECONNECT_END = 'connection.reconnectEnd';
    var round$3 = Math.round;

    function BendpointMove(injector, eventBus, canvas, dragging, graphicsFactory, rules, modeling) {
        var connectionDocking = injector.get('connectionDocking', false);
        this.start = function (event, connection, bendpointIndex, insert) {
            var type, context, waypoints = connection.waypoints, gfx = canvas.getGraphics(connection);
            if (!insert && bendpointIndex === 0) {
                type = COMMAND_RECONNECT_START;
            } else if (!insert && bendpointIndex === waypoints.length - 1) {
                type = COMMAND_RECONNECT_END;
            } else {
                type = COMMAND_BENDPOINT_UPDATE;
            }
            context = {connection: connection, bendpointIndex: bendpointIndex, insert: insert, type: type};
            dragging.init(event, 'bendpoint.move', {
                data: {
                    connection: connection,
                    connectionGfx: gfx,
                    context: context
                }
            });
        };

        function redrawConnection(data) {
            graphicsFactory.update('connection', data.connection, data.connectionGfx);
        }

        function filterRedundantWaypoints(waypoints) {
            waypoints = waypoints.slice();
            var idx = 0, point, previousPoint, nextPoint;
            while (waypoints[idx]) {
                point = waypoints[idx];
                previousPoint = waypoints[idx - 1];
                nextPoint = waypoints[idx + 1];
                if (pointDistance(point, nextPoint) === 0 || pointsOnLine(previousPoint, nextPoint, point)) {
                    waypoints.splice(idx, 1);
                } else {
                    idx++;
                }
            }
            return waypoints;
        }

        eventBus.on('bendpoint.move.start', function (e) {
            var context = e.context, connection = context.connection, originalWaypoints = connection.waypoints,
                waypoints = originalWaypoints.slice(), insert = context.insert, idx = context.bendpointIndex;
            context.originalWaypoints = originalWaypoints;
            if (insert) {
                waypoints.splice(idx, 0, null);
            }
            connection.waypoints = waypoints;
            context.draggerGfx = addBendpoint(canvas.getLayer('overlays'));
            classes$1(context.draggerGfx).add('djs-dragging');
            canvas.addMarker(connection, MARKER_CONNECT_UPDATING);
        });
        eventBus.on('bendpoint.move.hover', function (e) {
            var context = e.context;
            context.hover = e.hover;
            if (e.hover) {
                canvas.addMarker(e.hover, MARKER_CONNECT_HOVER);
                var allowed = context.allowed = rules.allowed(context.type, context);
                if (allowed) {
                    canvas.removeMarker(context.hover, MARKER_NOT_OK);
                    canvas.addMarker(context.hover, MARKER_OK);
                    context.target = context.hover;
                } else if (allowed === false) {
                    canvas.removeMarker(context.hover, MARKER_OK);
                    canvas.addMarker(context.hover, MARKER_NOT_OK);
                    context.target = null;
                }
            }
        });
        eventBus.on(['bendpoint.move.out', 'bendpoint.move.cleanup'], function (e) {
            var hover = e.context.hover;
            if (hover) {
                canvas.removeMarker(hover, MARKER_CONNECT_HOVER);
                canvas.removeMarker(hover, e.context.target ? MARKER_OK : MARKER_NOT_OK);
            }
        });
        eventBus.on('bendpoint.move.move', function (e) {
            var context = e.context, moveType = context.type, connection = e.connection, source, target;
            connection.waypoints[context.bendpointIndex] = {x: e.x, y: e.y};
            if (connectionDocking) {
                if (context.hover) {
                    if (moveType === COMMAND_RECONNECT_START) {
                        source = context.hover;
                    }
                    if (moveType === COMMAND_RECONNECT_END) {
                        target = context.hover;
                    }
                }
                connection.waypoints = connectionDocking.getCroppedWaypoints(connection, source, target);
            }
            translate(context.draggerGfx, e.x, e.y);
            redrawConnection(e);
        });
        eventBus.on(['bendpoint.move.end', 'bendpoint.move.cancel'], function (e) {
            var context = e.context, hover = context.hover, connection = context.connection;
            remove$1(context.draggerGfx);
            context.newWaypoints = connection.waypoints.slice();
            connection.waypoints = context.originalWaypoints;
            canvas.removeMarker(connection, MARKER_CONNECT_UPDATING);
            if (hover) {
                canvas.removeMarker(hover, MARKER_OK);
                canvas.removeMarker(hover, MARKER_NOT_OK);
            }
        });
        eventBus.on('bendpoint.move.end', function (e) {
            var context = e.context, waypoints = context.newWaypoints, bendpointIndex = context.bendpointIndex,
                bendpoint = waypoints[bendpointIndex], allowed = context.allowed, hints;
            bendpoint.x = round$3(bendpoint.x);
            bendpoint.y = round$3(bendpoint.y);
            if (allowed && context.type === COMMAND_RECONNECT_START) {
                modeling.reconnectStart(context.connection, context.target, bendpoint);
            } else if (allowed && context.type === COMMAND_RECONNECT_END) {
                modeling.reconnectEnd(context.connection, context.target, bendpoint);
            } else if (allowed !== false && context.type === COMMAND_BENDPOINT_UPDATE) {
                hints = {bendpointMove: {insert: e.context.insert, bendpointIndex: bendpointIndex}};
                modeling.updateWaypoints(context.connection, filterRedundantWaypoints(waypoints), hints);
            } else {
                redrawConnection(e);
                return false;
            }
        });
        eventBus.on('bendpoint.move.cancel', function (e) {
            redrawConnection(e);
        });
    }

    BendpointMove.$inject = ['injector', 'eventBus', 'canvas', 'dragging', 'graphicsFactory', 'rules', 'modeling'];
    var MARKER_CONNECT_HOVER$1 = 'connect-hover', MARKER_CONNECT_UPDATING$1 = 'djs-updating';

    function axisAdd(point, axis, delta) {
        return axisSet(point, axis, point[axis] + delta);
    }

    function axisSet(point, axis, value) {
        return {x: (axis === 'x' ? value : point.x), y: (axis === 'y' ? value : point.y)};
    }

    function axisFenced(position, segmentStart, segmentEnd, axis) {
        var maxValue = Math.max(segmentStart[axis], segmentEnd[axis]),
            minValue = Math.min(segmentStart[axis], segmentEnd[axis]);
        var padding = 20;
        var fencedValue = Math.min(Math.max(minValue + padding, position[axis]), maxValue - padding);
        return axisSet(segmentStart, axis, fencedValue);
    }

    function flipAxis(axis) {
        return axis === 'x' ? 'y' : 'x';
    }

    function getDocking(point, referenceElement, moveAxis) {
        var referenceMid, inverseAxis;
        if (point.original) {
            return point.original;
        } else {
            referenceMid = getMid(referenceElement);
            inverseAxis = flipAxis(moveAxis);
            return axisSet(point, inverseAxis, referenceMid[inverseAxis]);
        }
    }

    function ConnectionSegmentMove(injector, eventBus, canvas, dragging, graphicsFactory, rules, modeling) {
        var connectionDocking = injector.get('connectionDocking', false);
        this.start = function (event, connection, idx) {
            var context, gfx = canvas.getGraphics(connection), segmentStartIndex = idx - 1, segmentEndIndex = idx,
                waypoints = connection.waypoints, segmentStart = waypoints[segmentStartIndex],
                segmentEnd = waypoints[segmentEndIndex], direction, axis;
            direction = pointsAligned(segmentStart, segmentEnd);
            if (!direction) {
                return;
            }
            axis = direction === 'v' ? 'y' : 'x';
            if (segmentStartIndex === 0) {
                segmentStart = getDocking(segmentStart, connection.source, axis);
            }
            if (segmentEndIndex === waypoints.length - 1) {
                segmentEnd = getDocking(segmentEnd, connection.target, axis);
            }
            context = {
                connection: connection,
                segmentStartIndex: segmentStartIndex,
                segmentEndIndex: segmentEndIndex,
                segmentStart: segmentStart,
                segmentEnd: segmentEnd,
                axis: axis
            };
            dragging.init(event, {
                x: (segmentStart.x + segmentEnd.x) / 2,
                y: (segmentStart.y + segmentEnd.y) / 2
            }, 'connectionSegment.move', {
                cursor: axis === 'x' ? 'resize-ew' : 'resize-ns',
                data: {connection: connection, connectionGfx: gfx, context: context}
            });
        };

        function cropConnection(connection, newWaypoints) {
            if (!connectionDocking) {
                return newWaypoints;
            }
            var oldWaypoints = connection.waypoints, croppedWaypoints;
            connection.waypoints = newWaypoints;
            croppedWaypoints = connectionDocking.getCroppedWaypoints(connection);
            connection.waypoints = oldWaypoints;
            return croppedWaypoints;
        }

        function redrawConnection(data) {
            graphicsFactory.update('connection', data.connection, data.connectionGfx);
        }

        function updateDragger(context, segmentOffset, event) {
            var newWaypoints = context.newWaypoints, segmentStartIndex = context.segmentStartIndex + segmentOffset,
                segmentStart = newWaypoints[segmentStartIndex],
                segmentEndIndex = context.segmentEndIndex + segmentOffset, segmentEnd = newWaypoints[segmentEndIndex],
                axis = flipAxis(context.axis);
            var draggerPosition = axisFenced(event, segmentStart, segmentEnd, axis);
            translate(context.draggerGfx, draggerPosition.x, draggerPosition.y);
        }

        function filterRedundantWaypoints(waypoints, segmentStartIndex) {
            var segmentOffset = 0;
            var filteredWaypoints = waypoints.filter(function (r, idx) {
                if (pointsOnLine(waypoints[idx - 1], waypoints[idx + 1], r)) {
                    segmentOffset = idx <= segmentStartIndex ? segmentOffset - 1 : segmentOffset;
                    return false;
                }
                return true;
            });
            return {waypoints: filteredWaypoints, segmentOffset: segmentOffset};
        }

        eventBus.on('connectionSegment.move.start', function (e) {
            var context = e.context, connection = e.connection, layer = canvas.getLayer('overlays');
            context.originalWaypoints = connection.waypoints.slice();
            context.draggerGfx = addSegmentDragger(layer, context.segmentStart, context.segmentEnd);
            classes$1(context.draggerGfx).add('djs-dragging');
            canvas.addMarker(connection, MARKER_CONNECT_UPDATING$1);
        });
        eventBus.on('connectionSegment.move.move', function (e) {
            var context = e.context, connection = context.connection, segmentStartIndex = context.segmentStartIndex,
                segmentEndIndex = context.segmentEndIndex, segmentStart = context.segmentStart,
                segmentEnd = context.segmentEnd, axis = context.axis;
            var newWaypoints = context.originalWaypoints.slice(),
                newSegmentStart = axisAdd(segmentStart, axis, e['d' + axis]),
                newSegmentEnd = axisAdd(segmentEnd, axis, e['d' + axis]);
            var waypointCount = newWaypoints.length, segmentOffset = 0;
            newWaypoints[segmentStartIndex] = newSegmentStart;
            newWaypoints[segmentEndIndex] = newSegmentEnd;
            var sourceToSegmentOrientation, targetToSegmentOrientation;
            if (segmentStartIndex < 2) {
                sourceToSegmentOrientation = getOrientation(connection.source, newSegmentStart);
                if (segmentStartIndex === 1) {
                    if (sourceToSegmentOrientation === 'intersect') {
                        newWaypoints.shift();
                        newWaypoints[0] = newSegmentStart;
                        segmentOffset--;
                    }
                } else {
                    if (sourceToSegmentOrientation !== 'intersect') {
                        newWaypoints.unshift(segmentStart);
                        segmentOffset++;
                    }
                }
            }
            if (segmentEndIndex > waypointCount - 3) {
                targetToSegmentOrientation = getOrientation(connection.target, newSegmentEnd);
                if (segmentEndIndex === waypointCount - 2) {
                    if (targetToSegmentOrientation === 'intersect') {
                        newWaypoints.pop();
                        newWaypoints[newWaypoints.length - 1] = newSegmentEnd;
                    }
                } else {
                    if (targetToSegmentOrientation !== 'intersect') {
                        newWaypoints.push(segmentEnd);
                    }
                }
            }
            context.newWaypoints = connection.waypoints = cropConnection(connection, newWaypoints);
            updateDragger(context, segmentOffset, e);
            context.newSegmentStartIndex = segmentStartIndex + segmentOffset;
            redrawConnection(e);
        });
        eventBus.on('connectionSegment.move.hover', function (e) {
            e.context.hover = e.hover;
            canvas.addMarker(e.hover, MARKER_CONNECT_HOVER$1);
        });
        eventBus.on(['connectionSegment.move.out', 'connectionSegment.move.cleanup'], function (e) {
            var hover = e.context.hover;
            if (hover) {
                canvas.removeMarker(hover, MARKER_CONNECT_HOVER$1);
            }
        });
        eventBus.on('connectionSegment.move.cleanup', function (e) {
            var context = e.context, connection = context.connection;
            if (context.draggerGfx) {
                remove$1(context.draggerGfx);
            }
            canvas.removeMarker(connection, MARKER_CONNECT_UPDATING$1);
        });
        eventBus.on(['connectionSegment.move.cancel', 'connectionSegment.move.end'], function (e) {
            var context = e.context, connection = context.connection;
            connection.waypoints = context.originalWaypoints;
            redrawConnection(e);
        });
        eventBus.on('connectionSegment.move.end', function (e) {
            var context = e.context, connection = context.connection, newWaypoints = context.newWaypoints,
                newSegmentStartIndex = context.newSegmentStartIndex;
            newWaypoints = newWaypoints.map(function (p) {
                return {original: p.original, x: Math.round(p.x), y: Math.round(p.y)};
            });
            var filtered = filterRedundantWaypoints(newWaypoints, newSegmentStartIndex);
            var filteredWaypoints = filtered.waypoints,
                croppedWaypoints = cropConnection(connection, filteredWaypoints),
                segmentOffset = filtered.segmentOffset;
            var hints = {
                segmentMove: {
                    segmentStartIndex: context.segmentStartIndex,
                    newSegmentStartIndex: newSegmentStartIndex + segmentOffset
                }
            };
            modeling.updateWaypoints(connection, croppedWaypoints, hints);
        });
    }

    ConnectionSegmentMove.$inject = ['injector', 'eventBus', 'canvas', 'dragging', 'graphicsFactory', 'rules', 'modeling'];
    var abs$1 = Math.abs, round$4 = Math.round;
    var TOLERANCE = 10;

    function BendpointSnapping(eventBus) {
        function snapTo(values$$1, value) {
            if (isArray(values$$1)) {
                var i = values$$1.length;
                while (i--) if (abs$1(values$$1[i] - value) <= TOLERANCE) {
                    return values$$1[i];
                }
            } else {
                values$$1 = +values$$1;
                var rem = value % values$$1;
                if (rem < TOLERANCE) {
                    return value - rem;
                }
                if (rem > values$$1 - TOLERANCE) {
                    return value - rem + values$$1;
                }
            }
            return value;
        }

        function mid(element) {
            if (element.width) {
                return {x: round$4(element.width / 2 + element.x), y: round$4(element.height / 2 + element.y)};
            }
        }

        function getConnectionSegmentSnaps(context) {
            var snapPoints = context.snapPoints, connection = context.connection, waypoints = connection.waypoints,
                segmentStart = context.segmentStart, segmentStartIndex = context.segmentStartIndex,
                segmentEnd = context.segmentEnd, segmentEndIndex = context.segmentEndIndex, axis = context.axis;
            if (snapPoints) {
                return snapPoints;
            }
            var referenceWaypoints = [waypoints[segmentStartIndex - 1], segmentStart, segmentEnd, waypoints[segmentEndIndex + 1]];
            if (segmentStartIndex < 2) {
                referenceWaypoints.unshift(mid(connection.source));
            }
            if (segmentEndIndex > waypoints.length - 3) {
                referenceWaypoints.unshift(mid(connection.target));
            }
            context.snapPoints = snapPoints = {horizontal: [], vertical: []};
            forEach(referenceWaypoints, function (p) {
                if (p) {
                    p = p.original || p;
                    if (axis === 'y') {
                        snapPoints.horizontal.push(p.y);
                    }
                    if (axis === 'x') {
                        snapPoints.vertical.push(p.x);
                    }
                }
            });
            return snapPoints;
        }

        eventBus.on('connectionSegment.move.move', 1500, function (event) {
            var context = event.context, snapPoints = getConnectionSegmentSnaps(context), x = event.x, y = event.y, sx,
                sy;
            if (!snapPoints) {
                return;
            }
            sx = snapTo(snapPoints.vertical, x);
            sy = snapTo(snapPoints.horizontal, y);
            var cx = (x - sx), cy = (y - sy);
            assign(event, {dx: event.dx - cx, dy: event.dy - cy, x: sx, y: sy});
        });

        function getBendpointSnaps(context) {
            var snapPoints = context.snapPoints, waypoints = context.connection.waypoints,
                bendpointIndex = context.bendpointIndex;
            if (snapPoints) {
                return snapPoints;
            }
            var referenceWaypoints = [waypoints[bendpointIndex - 1], waypoints[bendpointIndex + 1]];
            context.snapPoints = snapPoints = {horizontal: [], vertical: []};
            forEach(referenceWaypoints, function (p) {
                if (p) {
                    p = p.original || p;
                    snapPoints.horizontal.push(p.y);
                    snapPoints.vertical.push(p.x);
                }
            });
            return snapPoints;
        }

        eventBus.on('bendpoint.move.move', 1500, function (event) {
            var context = event.context, snapPoints = getBendpointSnaps(context), target = context.target,
                targetMid = target && mid(target), x = event.x, y = event.y, sx, sy;
            if (!snapPoints) {
                return;
            }
            sx = snapTo(targetMid ? snapPoints.vertical.concat([targetMid.x]) : snapPoints.vertical, x);
            sy = snapTo(targetMid ? snapPoints.horizontal.concat([targetMid.y]) : snapPoints.horizontal, y);
            var cx = (x - sx), cy = (y - sy);
            assign(event, {dx: event.dx - cx, dy: event.dy - cy, x: event.x - cx, y: event.y - cy});
        });
    }

    BendpointSnapping.$inject = ['eventBus'];
    var BendpointsModule = {
        __depends__: [DraggingModule, RulesModule],
        __init__: ['bendpoints', 'bendpointSnapping'],
        bendpoints: ['type', Bendpoints],
        bendpointMove: ['type', BendpointMove],
        connectionSegmentMove: ['type', ConnectionSegmentMove],
        bendpointSnapping: ['type', BendpointSnapping]
    };
    var min = Math.min, max$1 = Math.max;

    function preventDefault$1(e) {
        e.preventDefault();
    }

    function stopPropagation$1(e) {
        e.stopPropagation();
    }

    function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    }

    function toArray(nodeList) {
        return [].slice.call(nodeList);
    }

    function TextBox(options) {
        this.container = options.container;
        this.parent = domify('<div class="djs-direct-editing-parent">' + '<div class="djs-direct-editing-content" contenteditable="true"></div>' + '</div>');
        this.content = query('[contenteditable]', this.parent);
        this.keyHandler = options.keyHandler || function () {
        };
        this.resizeHandler = options.resizeHandler || function () {
        };
        this.autoResize = bind(this.autoResize, this);
        this.handlePaste = bind(this.handlePaste, this);
    }

    TextBox.prototype.create = function (bounds, style, value, options) {
        var self = this;
        var parent = this.parent, content = this.content, container = this.container;
        options = this.options = options || {};
        style = this.style = style || {};
        var parentStyle = pick(style, ['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'left', 'top', 'backgroundColor', 'position', 'overflow', 'border', 'wordWrap', 'textAlign', 'outline', 'transform']);
        assign(parent.style, {
            width: bounds.width + 'px',
            height: bounds.height + 'px',
            maxWidth: bounds.maxWidth + 'px',
            maxHeight: bounds.maxHeight + 'px',
            minWidth: bounds.minWidth + 'px',
            minHeight: bounds.minHeight + 'px',
            left: bounds.x + 'px',
            top: bounds.y + 'px',
            backgroundColor: '#ffffff',
            position: 'absolute',
            overflow: 'visible',
            border: '1px solid #ccc',
            boxSizing: 'border-box',
            wordWrap: 'normal',
            textAlign: 'center',
            outline: 'none'
        }, parentStyle);
        var contentStyle = pick(style, ['fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft']);
        assign(content.style, {
            boxSizing: 'border-box',
            width: '100%',
            outline: 'none',
            wordWrap: 'break-word'
        }, contentStyle);
        if (options.centerVertically) {
            assign(content.style, {position: 'absolute', top: '50%', transform: 'translate(0, -50%)'}, contentStyle);
        }
        content.innerText = value;
        componentEvent.bind(content, 'keydown', this.keyHandler);
        componentEvent.bind(content, 'mousedown', stopPropagation$1);
        componentEvent.bind(content, 'paste', self.handlePaste);
        if (options.autoResize) {
            componentEvent.bind(content, 'input', this.autoResize);
        }
        if (options.resizable) {
            this.resizable(style);
        }
        container.appendChild(parent);
        this.setSelection(content.lastChild, content.lastChild && content.lastChild.length);
        return parent;
    };
    TextBox.prototype.handlePaste = function (e) {
        var self = this;
        var options = this.options, style = this.style;
        e.preventDefault();
        var text;
        if (e.clipboardData) {
            text = e.clipboardData.getData('text/plain');
        } else {
            text = window.clipboardData.getData('Text');
        }
        var success = document.execCommand('insertHTML', false, text);
        if (!success) {
            var range = this.getSelection(), startContainer = range.startContainer, endContainer = range.endContainer,
                startOffset = range.startOffset, endOffset = range.endOffset,
                commonAncestorContainer = range.commonAncestorContainer;
            var childNodesArray = toArray(commonAncestorContainer.childNodes);
            var container, offset;
            if (isTextNode(commonAncestorContainer)) {
                var containerTextContent = startContainer.textContent;
                startContainer.textContent = containerTextContent.substring(0, startOffset) + text
                    + containerTextContent.substring(endOffset);
                container = startContainer;
                offset = startOffset + text.length;
            } else if (startContainer === this.content && endContainer === this.content) {
                var textNode = document.createTextNode(text);
                this.content.insertBefore(textNode, childNodesArray[startOffset]);
                container = textNode;
                offset = textNode.textContent.length;
            } else {
                var startContainerChildIndex = childNodesArray.indexOf(startContainer),
                    endContainerChildIndex = childNodesArray.indexOf(endContainer);
                childNodesArray.forEach(function (childNode, index) {
                    if (index === startContainerChildIndex) {
                        childNode.textContent = startContainer.textContent.substring(0, startOffset) + text + endContainer.textContent.substring(endOffset);
                    } else if (index > startContainerChildIndex && index <= endContainerChildIndex) {
                        remove(childNode);
                    }
                });
                container = startContainer;
                offset = startOffset + text.length;
            }
            if (container && offset !== undefined) {
                setTimeout(function () {
                    self.setSelection(container, offset);
                });
            }
        }
        if (options.autoResize) {
            var hasResized = this.autoResize(style);
            if (hasResized) {
                this.resizeHandler(hasResized);
            }
        }
    };
    TextBox.prototype.autoResize = function () {
        var parent = this.parent, content = this.content;
        var fontSize = parseInt(this.style.fontSize) || 12;
        if (content.scrollHeight > parent.offsetHeight || content.scrollHeight < parent.offsetHeight - fontSize) {
            var bounds = parent.getBoundingClientRect();
            var height = content.scrollHeight;
            parent.style.height = height + 'px';
            this.resizeHandler({width: bounds.width, height: bounds.height, dx: 0, dy: height - bounds.height});
        }
    };
    TextBox.prototype.resizable = function () {
        var self = this;
        var parent = this.parent, resizeHandle = this.resizeHandle;
        var minWidth = parseInt(this.style.minWidth) || 0, minHeight = parseInt(this.style.minHeight) || 0,
            maxWidth = parseInt(this.style.maxWidth) || Infinity,
            maxHeight = parseInt(this.style.maxHeight) || Infinity;
        if (!resizeHandle) {
            resizeHandle = this.resizeHandle = domify('<div class="djs-direct-editing-resize-handle"></div>');
            var startX, startY, startWidth, startHeight;
            var onMouseDown = function (e) {
                preventDefault$1(e);
                stopPropagation$1(e);
                startX = e.clientX;
                startY = e.clientY;
                var bounds = parent.getBoundingClientRect();
                startWidth = bounds.width;
                startHeight = bounds.height;
                componentEvent.bind(document, 'mousemove', onMouseMove);
                componentEvent.bind(document, 'mouseup', onMouseUp);
            };
            var onMouseMove = function (e) {
                preventDefault$1(e);
                stopPropagation$1(e);
                var newWidth = min(max$1(startWidth + e.clientX - startX, minWidth), maxWidth);
                var newHeight = min(max$1(startHeight + e.clientY - startY, minHeight), maxHeight);
                parent.style.width = newWidth + 'px';
                parent.style.height = newHeight + 'px';
                self.resizeHandler({
                    width: startWidth,
                    height: startHeight,
                    dx: e.clientX - startX,
                    dy: e.clientY - startY
                });
            };
            var onMouseUp = function (e) {
                preventDefault$1(e);
                stopPropagation$1(e);
                componentEvent.unbind(document, 'mousemove', onMouseMove, false);
                componentEvent.unbind(document, 'mouseup', onMouseUp, false);
            };
            componentEvent.bind(resizeHandle, 'mousedown', onMouseDown);
        }
        assign(resizeHandle.style, {
            position: 'absolute',
            bottom: '0px',
            right: '0px',
            cursor: 'nwse-resize',
            width: '0',
            height: '0',
            borderTop: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid transparent',
            borderRight: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid #ccc',
            borderBottom: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid #ccc',
            borderLeft: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid transparent'
        });
        parent.appendChild(resizeHandle);
    };
    TextBox.prototype.destroy = function () {
        var parent = this.parent, content = this.content, resizeHandle = this.resizeHandle;
        content.innerText = '';
        parent.removeAttribute('style');
        content.removeAttribute('style');
        componentEvent.unbind(content, 'keydown', this.keyHandler);
        componentEvent.unbind(content, 'mousedown', stopPropagation$1);
        componentEvent.unbind(content, 'input', this.autoResize);
        componentEvent.unbind(content, 'paste', this.handlePaste);
        if (resizeHandle) {
            resizeHandle.removeAttribute('style');
            remove(resizeHandle);
        }
        remove(parent);
    };
    TextBox.prototype.getValue = function () {
        return this.content.innerText;
    };
    TextBox.prototype.getSelection = function () {
        var selection = window.getSelection(), range = selection.getRangeAt(0);
        return range;
    };
    TextBox.prototype.setSelection = function (container, offset) {
        var range = document.createRange();
        if (container === null) {
            range.selectNodeContents(this.content);
        } else {
            range.setStart(container, offset);
            range.setEnd(container, offset);
        }
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    };

    function DirectEditing(eventBus, canvas) {
        this._eventBus = eventBus;
        this._providers = [];
        this._textbox = new TextBox({
            container: canvas.getContainer(),
            keyHandler: bind(this._handleKey, this),
            resizeHandler: bind(this._handleResize, this)
        });
    }

    DirectEditing.$inject = ['eventBus', 'canvas'];
    DirectEditing.prototype.registerProvider = function (provider) {
        this._providers.push(provider);
    };
    DirectEditing.prototype.isActive = function () {
        return !!this._active;
    };
    DirectEditing.prototype.cancel = function () {
        if (!this._active) {
            return;
        }
        this._fire('cancel');
        this.close();
    };
    DirectEditing.prototype._fire = function (event, context) {
        this._eventBus.fire('directEditing.' + event, context || {active: this._active});
    };
    DirectEditing.prototype.close = function () {
        this._textbox.destroy();
        this._fire('deactivate');
        this._active = null;
        this.resizable = undefined;
    };
    DirectEditing.prototype.complete = function () {
        var active = this._active;
        if (!active) {
            return;
        }
        var eleData = active.element.businessObject.data;
        var text = this.getValue();
        var bounds = this.$textbox.getBoundingClientRect();
        // if (text !== active.context.text || this.resizable) {
            active.provider.update(active.element, text, active.context.text, {
                x: bounds.top,
                y: bounds.left,
                width: bounds.width,
                height: bounds.height
            });
        // }
        active.element.businessObject.data = eleData;
        this._fire('complete');
        this.close();
    };
    DirectEditing.prototype.getValue = function () {
        return this._textbox.getValue();
    };
    DirectEditing.prototype._handleKey = function (e) {
        e.stopPropagation();
        var key = e.keyCode || e.charCode;
        if (key === 27) {
            e.preventDefault();
            return this.cancel();
        }
        if (key === 13 && !e.shiftKey) {
            e.preventDefault();
            return this.complete();
        }
    };
    DirectEditing.prototype._handleResize = function (event) {
        this._fire('resize', event);
    };
    DirectEditing.prototype.activate = function (element) {
        if (this.isActive()) {
            this.cancel();
        }
        var context;
        var provider = find(this._providers, function (p) {
            return (context = p.activate(element)) ? p : null;
        });
        if (context) {
            this.$textbox = this._textbox.create(context.bounds, context.style, context.text, context.options);
            this._active = {element: element, context: context, provider: provider};
            if (context.options && context.options.resizable) {
                this.resizable = true;
            }
            this._fire('activate');
        }
        return !!context;
    };
    var DirectEditingModule = {
        __depends__: [InteractionEventsModule],
        __init__: ['directEditing'],
        directEditing: ['type', DirectEditing]
    };
    var entrySelector = '.entry';

    function ContextPad(config, eventBus, overlays) {
        this._providers = [];
        this._eventBus = eventBus;
        this._overlays = overlays;
        var scale = isDefined(config && config.scale) ? config.scale : {min: 1, max: 1.5};
        this._overlaysConfig = {position: {right: -9, top: -6}, scale: scale};
        this._current = null;
        this._init();
    }

    ContextPad.$inject = ['config.contextPad', 'eventBus', 'overlays'];
    ContextPad.prototype._init = function () {
        var eventBus = this._eventBus;
        var self = this;
        eventBus.on('selection.changed', function (e) {
            var selection = e.newSelection;
            if (selection.length === 1) {
                self.open(selection[0]);
            } else {
                self.close();
            }
        });
        eventBus.on('elements.delete', function (event$$1) {
            var elements = event$$1.elements;
            forEach(elements, function (e) {
                if (self.isOpen(e)) {
                    self.close();
                }
            });
        });
        eventBus.on('element.changed', function (event$$1) {
            var element = event$$1.element, current = self._current;
            if (current && current.element === element) {
                self.open(element, true);
            }
        });
    };
    ContextPad.prototype.registerProvider = function (provider) {
        this._providers.push(provider);
    };
    ContextPad.prototype.getEntries = function (element) {
        var entries = {};
        forEach(this._providers, function (provider) {
            var e = provider.getContextPadEntries(element);
            forEach(e, function (entry, id) {
                entries[id] = entry;
            });
        });
        return entries;
    };
    ContextPad.prototype.trigger = function (action, event$$1, autoActivate) {
        var element = this._current.element, entries = this._current.entries, entry, handler, originalEvent,
            button = event$$1.delegateTarget || event$$1.target;
        if (!button) {
            return event$$1.preventDefault();
        }
        entry = entries[attr(button, 'data-action')];
        handler = entry.action;
        originalEvent = event$$1.originalEvent || event$$1;
        if (isFunction(handler)) {
            if (action === 'click') {
                return handler(originalEvent, element, autoActivate);
            }
        } else {
            if (handler[action]) {
                return handler[action](originalEvent, element, autoActivate);
            }
        }
        event$$1.preventDefault();
    };
    ContextPad.prototype.open = function (element, force) {
        if (!force && this.isOpen(element)) {
            return;
        }
        this.close();
        this._updateAndOpen(element);
    };
    ContextPad.prototype._updateAndOpen = function (element) {
        var entries = this.getEntries(element), pad = this.getPad(element), html = pad.html;
        forEach(entries, function (entry, id) {
            var grouping = entry.group || 'default',
                control = domify(entry.html || '<div class="entry" draggable="true"></div>'), container;
            attr(control, 'data-action', id);
            container = query('[data-group=' + grouping + ']', html);
            if (!container) {
                container = domify('<div class="group" data-group="' + grouping + '"></div>');
                html.appendChild(container);
            }
            container.appendChild(control);
            if (entry.className) {
                addClasses(control, entry.className);
            }
            if (entry.title) {
                attr(control, 'title', entry.title);
            }
            if (entry.imageUrl) {
                control.appendChild(domify('<img src="' + entry.imageUrl + '">'));
            }
        });
        classes(html).add('open');
        this._current = {element: element, pad: pad, entries: entries};
        this._eventBus.fire('contextPad.open', {current: this._current});
    };
    ContextPad.prototype.getPad = function (element) {
        if (this.isOpen()) {
            return this._current.pad;
        }
        var self = this;
        var overlays = this._overlays;
        var html = domify('<div class="djs-context-pad"></div>');
        var overlaysConfig = assign({html: html}, this._overlaysConfig);
        delegateEvents.bind(html, entrySelector, 'click', function (event$$1) {
            self.trigger('click', event$$1);
        });
        delegateEvents.bind(html, entrySelector, 'dragstart', function (event$$1) {
            self.trigger('dragstart', event$$1);
        });
        componentEvent.bind(html, 'mousedown', function (event$$1) {
            event$$1.stopPropagation();
        });
        this._overlayId = overlays.add(element, 'context-pad', overlaysConfig);
        var pad = overlays.get(this._overlayId);
        this._eventBus.fire('contextPad.create', {element: element, pad: pad});
        return pad;
    };
    ContextPad.prototype.close = function () {
        if (!this.isOpen()) {
            return;
        }
        this._overlays.remove(this._overlayId);
        this._overlayId = null;
        this._eventBus.fire('contextPad.close', {current: this._current});
        this._current = null;
    };
    ContextPad.prototype.isOpen = function (element) {
        return !!this._current && (!element ? true : this._current.element === element);
    };

    function addClasses(element, classNames) {
        var classes$$1 = classes(element);
        var actualClassNames = isArray(classNames) ? classNames : classNames.split(/\s+/g);
        actualClassNames.forEach(function (cls) {
            classes$$1.add(cls);
        });
    }

    var ContextPadModule = {__depends__: [InteractionEventsModule, OverlaysModule], contextPad: ['type', ContextPad]};
    var MARKER_OK$1 = 'connect-ok', MARKER_NOT_OK$1 = 'connect-not-ok';

    function Connect(eventBus, dragging, modeling, rules, canvas, graphicsFactory) {
        function canConnect(source, target) {
            return rules.allowed('connection.create', {source: source, target: target});
        }

        function crop(start, end, source, target) {
            var sourcePath = graphicsFactory.getShapePath(source),
                targetPath = target && graphicsFactory.getShapePath(target),
                connectionPath = graphicsFactory.getConnectionPath({waypoints: [start, end]});
            start = getElementLineIntersection(sourcePath, connectionPath, true) || start;
            end = (target && getElementLineIntersection(targetPath, connectionPath, false)) || end;
            return [start, end];
        }

        eventBus.on('connect.move', function (event) {
            var context = event.context, source = context.source, target = context.target, visual = context.visual,
                sourcePosition = context.sourcePosition, endPosition, waypoints;
            endPosition = {x: event.x, y: event.y};
            waypoints = crop(sourcePosition, endPosition, source, target);
            attr$1(visual, {'points': [waypoints[0].x, waypoints[0].y, waypoints[1].x, waypoints[1].y]});
        });
        eventBus.on('connect.hover', function (event) {
            var context = event.context, source = context.source, hover = event.hover, canExecute;
            canExecute = context.canExecute = canConnect(source, hover);
            if (canExecute === null) {
                return;
            }
            context.target = hover;
            canvas.addMarker(hover, canExecute ? MARKER_OK$1 : MARKER_NOT_OK$1);
        });
        eventBus.on(['connect.out', 'connect.cleanup'], function (event) {
            var context = event.context;
            if (context.target) {
                canvas.removeMarker(context.target, context.canExecute ? MARKER_OK$1 : MARKER_NOT_OK$1);
            }
            context.target = null;
            context.canExecute = false;
        });
        eventBus.on('connect.cleanup', function (event) {
            var context = event.context;
            if (context.visual) {
                remove$1(context.visual);
            }
        });
        eventBus.on('connect.start', function (event) {
            var context = event.context, visual;
            visual = create('polyline');
            attr$1(visual, {'stroke': '#333', 'strokeDasharray': [1], 'strokeWidth': 1, 'pointer-events': 'none'});
            append(canvas.getDefaultLayer(), visual);
            context.visual = visual;
        });
        eventBus.on('connect.end', function (event) {
            var context = event.context, source = context.source, sourcePosition = context.sourcePosition,
                target = context.target, targetPosition = {x: event.x, y: event.y},
                canExecute = context.canExecute || canConnect(source, target);
            if (!canExecute) {
                return false;
            }
            var attrs = null, hints = {connectionStart: sourcePosition, connectionEnd: targetPosition};
            if (typeof canExecute === 'object') {
                attrs = canExecute;
            }
            modeling.connect(source, target, attrs, hints);
        });
        this.start = function (event, source, sourcePosition, autoActivate) {
            if (typeof sourcePosition !== 'object') {
                autoActivate = sourcePosition;
                sourcePosition = getMid(source);
            }
            dragging.init(event, 'connect', {
                autoActivate: autoActivate,
                data: {shape: source, context: {source: source, sourcePosition: sourcePosition}}
            });
        };
    }

    Connect.$inject = ['eventBus', 'dragging', 'modeling', 'rules', 'canvas', 'graphicsFactory'];
    var ConnectModule = {__depends__: [SelectionModule, RulesModule, DraggingModule], connect: ['type', Connect]};
    var LOW_PRIORITY$4 = 750;
    var MARKER_OK$2 = 'drop-ok', MARKER_NOT_OK$2 = 'drop-not-ok', MARKER_ATTACH = 'attach-ok',
        MARKER_NEW_PARENT = 'new-parent';

    function Create(eventBus, dragging, rules, modeling, canvas, styles, graphicsFactory) {
        function canCreate(shape, target, source, position) {
            if (!target) {
                return false;
            }
            var ctx = {source: source, shape: shape, target: target, position: position};
            var create$$1, attach, connect;
            attach = rules.allowed('shape.attach', ctx);
            if (!attach) {
                create$$1 = rules.allowed('shape.create', ctx);
            }
            if (create$$1 || attach) {
                connect = source && rules.allowed('connection.create', {
                    source: source,
                    target: shape,
                    hints: {targetParent: target, targetAttach: attach}
                });
            }
            if (create$$1 || attach) {
                return {attach: attach, connect: connect};
            }
            return false;
        }

        function setMarker(element, marker) {
            [MARKER_ATTACH, MARKER_OK$2, MARKER_NOT_OK$2, MARKER_NEW_PARENT].forEach(function (m) {
                if (m === marker) {
                    canvas.addMarker(element, m);
                } else {
                    canvas.removeMarker(element, m);
                }
            });
        }

        function createVisual(shape) {
            var group, preview, visual;
            group = create('g');
            attr$1(group, styles.cls('djs-drag-group', ['no-events']));
            append(canvas.getDefaultLayer(), group);
            preview = create('g');
            classes$1(preview).add('djs-dragger');
            append(group, preview);
            translate(preview, shape.width / -2, shape.height / -2);
            var visualGroup = create('g');
            classes$1(visualGroup).add('djs-visual');
            append(preview, visualGroup);
            visual = visualGroup;
            graphicsFactory.drawShape(visual, shape);
            return group;
        }

        eventBus.on('create.move', function (event) {
            var context = event.context, hover = event.hover, shape = context.shape, source = context.source,
                canExecute;
            var position = {x: event.x, y: event.y};
            canExecute = context.canExecute = hover && canCreate(shape, hover, source, position);
            if (hover && canExecute !== null) {
                context.target = hover;
                if (canExecute && canExecute.attach) {
                    setMarker(hover, MARKER_ATTACH);
                } else {
                    setMarker(hover, canExecute ? MARKER_NEW_PARENT : MARKER_NOT_OK$2);
                }
            }
        });
        eventBus.on('create.move', LOW_PRIORITY$4, function (event) {
            var context = event.context, shape = context.shape, visual = context.visual;
            if (!visual) {
                visual = context.visual = createVisual(shape);
            }
            translate(visual, event.x, event.y);
        });
        eventBus.on(['create.end', 'create.out', 'create.cleanup'], function (event) {
            var context = event.context, target = context.target;
            if (target) {
                setMarker(target, null);
            }
        });
        eventBus.on('create.end', function (event) {
            var context = event.context, source = context.source, shape = context.shape, target = context.target,
                canExecute = context.canExecute, attach = canExecute && canExecute.attach,
                connect = canExecute && canExecute.connect, position = {x: event.x, y: event.y};
            if (!canExecute) {
                return false;
            }
            if (connect) {
                shape = modeling.appendShape(source, shape, position, target, {
                    attach: attach,
                    connection: connect === true ? {} : connect
                });
            } else {
                shape = modeling.createShape(shape, position, target, {attach: attach});
            }
            context.shape = shape;
        });
        eventBus.on('create.cleanup', function (event) {
            var context = event.context;
            if (context.visual) {
                remove$1(context.visual);
            }
        });
        this.start = function (event, shape, source) {
            dragging.init(event, 'create', {
                cursor: 'grabbing',
                autoActivate: true,
                data: {shape: shape, context: {shape: shape, source: source}}
            });
        };
    }

    Create.$inject = ['eventBus', 'dragging', 'rules', 'modeling', 'canvas', 'styles', 'graphicsFactory'];
    var CreateModule = {__depends__: [DraggingModule, SelectionModule, RulesModule], create: ['type', Create]};
    var DATA_REF = 'data-id';

    function PopupMenu(config, eventBus, canvas) {
        var scale = isDefined(config && config.scale) ? config.scale : {min: 1, max: 1.5};
        this._config = {scale: scale};
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._providers = {};
        this._current = {};
    }

    PopupMenu.$inject = ['config.popupMenu', 'eventBus', 'canvas'];
    PopupMenu.prototype.registerProvider = function (id, provider) {
        this._providers[id] = provider;
    };
    PopupMenu.prototype.isEmpty = function (element, providerId) {
        if (!element) {
            throw new Error('element parameter is missing');
        }
        if (!providerId) {
            throw new Error('providerId parameter is missing');
        }
        var provider = this._providers[providerId];
        var entries = provider.getEntries(element),
            headerEntries = provider.getHeaderEntries && provider.getHeaderEntries(element);
        var hasEntries = entries.length > 0, hasHeaderEntries = headerEntries && headerEntries.length > 0;
        return !hasEntries && !hasHeaderEntries;
    };
    PopupMenu.prototype.open = function (element, id, position) {
        var provider = this._providers[id];
        if (!element) {
            throw new Error('Element is missing');
        }
        if (!provider) {
            throw new Error('Provider is not registered: ' + id);
        }
        if (!position) {
            throw new Error('the position argument is missing');
        }
        if (this.isOpen()) {
            this.close();
        }
        this._emit('open');
        var current = this._current = {provider: provider, className: id, element: element, position: position};
        if (provider.getHeaderEntries) {
            current.headerEntries = provider.getHeaderEntries(element);
        }
        current.entries = provider.getEntries(element);
        current.container = this._createContainer();
        var headerEntries = current.headerEntries || [], entries = current.entries || [];
        if (headerEntries.length) {
            current.container.appendChild(this._createEntries(current.headerEntries, 'djs-popup-header'));
        }
        if (entries.length) {
            current.container.appendChild(this._createEntries(current.entries, 'djs-popup-body'));
        }
        var canvas = this._canvas, parent = canvas.getContainer();
        this._attachContainer(current.container, parent, position.cursor);
    };
    PopupMenu.prototype.close = function () {
        if (!this.isOpen()) {
            return;
        }
        this._emit('close');
        this._unbindHandlers();
        remove(this._current.container);
        this._current.container = null;
    };
    PopupMenu.prototype.isOpen = function () {
        return !!this._current.container;
    };
    PopupMenu.prototype.trigger = function (event) {
        event.preventDefault();
        var element = event.delegateTarget || event.target, entryId = attr(element, DATA_REF);
        var entry = this._getEntry(entryId);
        if (entry.action) {
            return entry.action.call(null, event, entry);
        }
    };
    PopupMenu.prototype._getEntry = function (entryId) {
        var search = matchPattern({id: entryId});
        var entry = find(this._current.entries, search) || find(this._current.headerEntries, search);
        if (!entry) {
            throw new Error('entry not found');
        }
        return entry;
    };
    PopupMenu.prototype._emit = function (eventName) {
        this._eventBus.fire('popupMenu.' + eventName);
    };
    PopupMenu.prototype._createContainer = function () {
        var container = domify('<div class="djs-popup">'), position = this._current.position,
            className = this._current.className;
        assign(container.style, {
            position: 'absolute',
            left: position.x + 'px',
            top: position.y + 'px',
            visibility: 'hidden'
        });
        classes(container).add(className);
        return container;
    };
    PopupMenu.prototype._attachContainer = function (container, parent, cursor) {
        var self = this;
        delegateEvents.bind(container, '.entry', 'click', function (event) {
            self.trigger(event);
        });
        this._updateScale(container);
        parent.appendChild(container);
        if (cursor) {
            this._assureIsInbounds(container, cursor);
        }
        this._bindHandlers();
    };
    PopupMenu.prototype._updateScale = function (container) {
        var zoom = this._canvas.zoom();
        var scaleConfig = this._config.scale, minScale, maxScale, scale = zoom;
        if (scaleConfig !== true) {
            if (scaleConfig === false) {
                minScale = 1;
                maxScale = 1;
            } else {
                minScale = scaleConfig.min;
                maxScale = scaleConfig.max;
            }
            if (isDefined(minScale) && zoom < minScale) {
                scale = minScale;
            }
            if (isDefined(maxScale) && zoom > maxScale) {
                scale = maxScale;
            }
        }
        setTransform$1(container, 'scale(' + scale + ')');
    };
    PopupMenu.prototype._assureIsInbounds = function (container, cursor) {
        var canvas = this._canvas, clientRect = canvas._container.getBoundingClientRect();
        var containerX = container.offsetLeft, containerY = container.offsetTop, containerWidth = container.scrollWidth,
            containerHeight = container.scrollHeight, overAxis = {}, left, top;
        var cursorPosition = {x: cursor.x - clientRect.left, y: cursor.y - clientRect.top};
        if (containerX + containerWidth > clientRect.width) {
            overAxis.x = true;
        }
        if (containerY + containerHeight > clientRect.height) {
            overAxis.y = true;
        }
        if (overAxis.x && overAxis.y) {
            left = cursorPosition.x - containerWidth + 'px';
            top = cursorPosition.y - containerHeight + 'px';
        } else if (overAxis.x) {
            left = cursorPosition.x - containerWidth + 'px';
            top = cursorPosition.y + 'px';
        } else if (overAxis.y && cursorPosition.y < containerHeight) {
            left = cursorPosition.x + 'px';
            top = 10 + 'px';
        } else if (overAxis.y) {
            left = cursorPosition.x + 'px';
            top = cursorPosition.y - containerHeight + 'px';
        }
        assign(container.style, {left: left, top: top}, {visibility: 'visible', 'z-index': 1000});
    };
    PopupMenu.prototype._createEntries = function (entries, className) {
        var entriesContainer = domify('<div>'), self = this;
        classes(entriesContainer).add(className);
        forEach(entries, function (entry) {
            var entryContainer = self._createEntry(entry, entriesContainer);
            entriesContainer.appendChild(entryContainer);
        });
        return entriesContainer;
    };
    PopupMenu.prototype._createEntry = function (entry) {
        if (!entry.id) {
            throw new Error('every entry must have the id property set');
        }
        var entryContainer = domify('<div>'), entryClasses = classes(entryContainer);
        entryClasses.add('entry');
        if (entry.className) {
            entry.className.split(' ').forEach(function (className) {
                entryClasses.add(className);
            });
        }
        attr(entryContainer, DATA_REF, entry.id);
        if (entry.label) {
            var label = domify('<span>');
            label.textContent = entry.label;
            entryContainer.appendChild(label);
        }
        if (entry.imageUrl) {
            entryContainer.appendChild(domify('<img src="' + entry.imageUrl + '" />'));
        }
        if (entry.active === true) {
            entryClasses.add('active');
        }
        if (entry.disabled === true) {
            entryClasses.add('disabled');
        }
        if (entry.title) {
            entryContainer.title = entry.title;
        }
        return entryContainer;
    };
    PopupMenu.prototype._bindHandlers = function () {
        var eventBus = this._eventBus, self = this;

        function close() {
            self.close();
        }

        eventBus.once('contextPad.close', close);
        eventBus.once('canvas.viewbox.changing', close);
        eventBus.once('commandStack.changed', close);
    };
    PopupMenu.prototype._unbindHandlers = function () {
        var eventBus = this._eventBus, self = this;

        function close() {
            self.close();
        }

        eventBus.off('contextPad.close', close);
        eventBus.off('canvas.viewbox.changed', close);
        eventBus.off('commandStack.changed', close);
    };

    function setTransform$1(element, transform) {
        element.style['transform-origin'] = 'top left';
        ['', '-ms-', '-webkit-'].forEach(function (prefix) {
            element.style[prefix + 'transform'] = transform;
        });
    }

    var PopupMenuModule = {__init__: ['popupMenu'], popupMenu: ['type', PopupMenu]};
    var round$5 = Math.round;

    function Replace(modeling) {
        this._modeling = modeling;
    }

    Replace.$inject = ['modeling'];
    Replace.prototype.replaceElement = function (oldElement, newElementData, options) {
        var modeling = this._modeling;
        var newElement = null;
        if (oldElement.waypoints) ; else {
            newElementData.x = round$5(oldElement.x + (newElementData.width || oldElement.width) / 2);
            newElementData.y = round$5(oldElement.y + (newElementData.height || oldElement.height) / 2);
            newElement = modeling.replaceShape(oldElement, newElementData, options);
        }
        return newElement;
    };
    var ReplaceModule = {__init__: ['replace'], replace: ['type', Replace]};
    var IGNORED_PROPERTIES = ['lanes', 'incoming', 'outgoing', 'artifacts', 'default', 'flowElements', 'dataInputAssociations', 'dataOutputAssociations'];

    function getProperties(descriptor, keepDefault) {
        var properties = [];
        forEach(descriptor.properties, function (property) {
            if (keepDefault && property.default) {
                return;
            }
            properties.push(property.ns.name);
        });
        return properties;
    }

    function isAllowedIn(extProp, type) {
        var allowedIn = extProp.meta.allowedIn;
        if (allowedIn.length === 1 && allowedIn[0] === '*') {
            return true;
        }
        return allowedIn.indexOf(type) !== -1;
    }

    function isType(element, types) {
        return some(types, function (type) {
            return typeof element === type;
        });
    }

    function ModelCloneHelper(eventBus, bpmnFactory) {
        this._eventBus = eventBus;
        this._bpmnFactory = bpmnFactory;
    }

    ModelCloneHelper.prototype.clone = function (refElement, newElement, properties) {
        var self = this;
        var context = {newElement: newElement, hasNestedProperty: false};
        properties = sortBy(properties, function (prop) {
            return prop === 'bpmn:extensionElements';
        });
        forEach(properties, function (propName) {
            var refElementProp = refElement.get(propName), newElementProp = newElement.get(propName),
                propDescriptor = newElement.$model.getPropertyDescriptor(newElement, propName), newProperty, name;
            if (newElementProp === refElementProp) {
                return;
            }
            if (propDescriptor && (propDescriptor.isId || propDescriptor.isReference)) {
                return;
            }
            if (isType(refElementProp, ['boolean', 'string', 'number']) || refElementProp === null) {
                newElement.set(propName, refElementProp);
                return;
            }
            if (isArray(refElementProp)) {
                forEach(refElementProp, function (extElement) {
                    var newProp;
                    context.refTopLevelProperty = extElement;
                    newProp = self._deepClone(extElement, context);
                    if (context.hasNestedProperty) {
                        newProp.$parent = newElement;
                        newElementProp.push(newProp);
                    }
                    context.hasNestedProperty = false;
                });
            } else {
                name = propName.replace(/bpmn:/, '');
                context.refTopLevelProperty = refElementProp;
                newProperty = self._deepClone(refElementProp, context);
                if (context.hasNestedProperty) {
                    newProperty.$parent = newElement;
                    newElement.set(name, newProperty);
                }
                context.hasNestedProperty = false;
            }
        });
        return newElement;
    };
    ModelCloneHelper.prototype._deepClone = function _deepClone(propertyElement, context) {
        var self = this;
        var eventBus = this._eventBus;
        var bpmnFactory = this._bpmnFactory;
        var newProp = bpmnFactory.create(propertyElement.$type);
        var properties = filter(Object.keys(propertyElement), function (prop) {
            var descriptor = newProp.$model.getPropertyDescriptor(newProp, prop);
            if (descriptor && (descriptor.isId || descriptor.isReference)) {
                return false;
            }
            if (IGNORED_PROPERTIES.indexOf(prop) !== -1) {
                return false;
            }
            return prop !== '$type';
        });
        if (!properties.length) {
            context.hasNestedProperty = true;
        }
        forEach(properties, function (propName) {
            if (propertyElement[propName] !== undefined && (propertyElement[propName].$type || isArray(propertyElement[propName]))) {
                if (isArray(propertyElement[propName])) {
                    newProp[propName] = [];
                    forEach(propertyElement[propName], function (property) {
                        var extProp = propertyElement.$model.getTypeDescriptor(property.$type), newDeepProp;
                        if (!extProp) {
                            return;
                        }
                        var canClone = eventBus.fire('property.clone', {
                            newElement: context.newElement,
                            refTopLevelProperty: context.refTopLevelProperty,
                            propertyDescriptor: extProp
                        });
                        if (!canClone) {
                            if (propertyElement.$type === 'bpmn:ExtensionElements' && extProp.meta && extProp.meta.allowedIn && !isAllowedIn(extProp, context.newElement.$type)) {
                                return false;
                            }
                        }
                        newDeepProp = self._deepClone(property, context);
                        newDeepProp.$parent = newProp;
                        if (!newProp[propName]) {
                            newProp[propName] = [];
                        }
                        context.hasNestedProperty = true;
                        newProp[propName].push(newDeepProp);
                    });
                } else if (propertyElement[propName].$type) {
                    newProp[propName] = self._deepClone(propertyElement[propName], context);
                    if (newProp[propName]) {
                        context.hasNestedProperty = true;
                        newProp[propName].$parent = newProp;
                    }
                }
            } else {
                context.hasNestedProperty = true;
                newProp[propName] = propertyElement[propName];
            }
        });
        return newProp;
    };
    var CUSTOM_PROPERTIES = ['cancelActivity', 'instantiate', 'eventGatewayType', 'triggeredByEvent', 'isInterrupting'];

    function toggeling(element, target) {
        var oldCollapsed = (element && has(element, 'collapsed') ? element.collapsed : !isExpanded(element));
        var targetCollapsed;
        if (target && (has(target, 'collapsed') || has(target, 'isExpanded'))) {
            targetCollapsed = (has(target, 'collapsed') ? target.collapsed : !target.isExpanded);
        } else {
            targetCollapsed = oldCollapsed;
        }
        if (oldCollapsed !== targetCollapsed) {
            element.collapsed = oldCollapsed;
            return true;
        }
        return false;
    }

    function BpmnReplace(bpmnFactory, replace, selection, modeling, eventBus) {
        var helper = new ModelCloneHelper(eventBus, bpmnFactory);

        function replaceElement(element, target, hints) {
            hints = hints || {};
            var type = target.type, oldBusinessObject = element.businessObject;
            if (isSubProcess(oldBusinessObject)) {
                if (type === 'bpmn:SubProcess') {
                    if (toggeling(element, target)) {
                        modeling.toggleCollapse(element);
                        return element;
                    }
                }
            }
            var newBusinessObject = bpmnFactory.create(type);
            var newElement = {type: type, businessObject: newBusinessObject};
            var elementProps = getProperties(oldBusinessObject.$descriptor),
                newElementProps = getProperties(newBusinessObject.$descriptor, true),
                copyProps = intersection(elementProps, newElementProps);
            assign(newBusinessObject, pick(target, CUSTOM_PROPERTIES));
            var properties = filter(copyProps, function (property) {
                var propName = property.replace(/bpmn:/, '');
                if (propName === 'eventDefinitions') {
                    return hasEventDefinition$1(element, target.eventDefinitionType);
                }
                if (propName === 'loopCharacteristics') {
                    return !isEventSubProcess(newBusinessObject);
                }
                if (property in newBusinessObject) {
                    return false;
                }
                if (propName === 'processRef' && target.isExpanded === false) {
                    return false;
                }
                if (propName === 'triggeredByEvent') {
                    return false;
                }
                return IGNORED_PROPERTIES.indexOf(propName) === -1;
            });
            newBusinessObject = helper.clone(oldBusinessObject, newBusinessObject, properties);
            if (target.eventDefinitionType) {
                if (!hasEventDefinition$1(newBusinessObject, target.eventDefinitionType)) {
                    newElement.eventDefinitionType = target.eventDefinitionType;
                }
            }
            if (is$1(oldBusinessObject, 'bpmn:Activity')) {
                if (isSubProcess(oldBusinessObject)) {
                    newElement.isExpanded = isExpanded(oldBusinessObject);
                } else if (target && has(target, 'isExpanded')) {
                    newElement.isExpanded = target.isExpanded;
                }
                if ((isExpanded(oldBusinessObject) && !is$1(oldBusinessObject, 'bpmn:Task')) && newElement.isExpanded) {
                    newElement.width = element.width;
                    newElement.height = element.height;
                }
            }
            if (isSubProcess(oldBusinessObject) && !isSubProcess(newBusinessObject)) {
                hints.moveChildren = false;
            }
            if (is$1(oldBusinessObject, 'bpmn:Participant')) {
                if (target.isExpanded === true) {
                    newBusinessObject.processRef = bpmnFactory.create('bpmn:Process');
                } else {
                    hints.moveChildren = false;
                }
                newElement.width = element.width;
                newElement.height = element.height;
            }
            newBusinessObject.name = oldBusinessObject.name;
            if (isAny(oldBusinessObject, ['bpmn:ExclusiveGateway', 'bpmn:InclusiveGateway', 'bpmn:Activity']) && isAny(newBusinessObject, ['bpmn:ExclusiveGateway', 'bpmn:InclusiveGateway', 'bpmn:Activity'])) {
                newBusinessObject.default = oldBusinessObject.default;
            }
            if ('fill' in oldBusinessObject.di || 'stroke' in oldBusinessObject.di) {
                assign(newElement, {colors: pick(oldBusinessObject.di, ['fill', 'stroke'])});
            }
            newElement = replace.replaceElement(element, newElement, hints);
            if (hints.select !== false) {
                selection.select(newElement);
            }
            return newElement;
        }

        this.replaceElement = replaceElement;
    }

    BpmnReplace.$inject = ['bpmnFactory', 'replace', 'selection', 'modeling', 'eventBus'];

    function isSubProcess(bo) {
        return is$1(bo, 'bpmn:SubProcess');
    }

    function hasEventDefinition$1(element, type) {
        var bo = getBusinessObject(element);
        return type && bo.get('eventDefinitions').some(function (definition) {
            return is$1(definition, type);
        });
    }

    function intersection(a1, a2) {
        return a1.filter(function (el) {
            return a2.indexOf(el) !== -1;
        });
    }

    var ReplaceModule$1 = {__depends__: [SelectionModule, ReplaceModule], bpmnReplace: ['type', BpmnReplace]};

    function isDifferentType(element) {
        return function (entry) {
            var target = entry.target;
            var businessObject = getBusinessObject(element),
                eventDefinition = businessObject.eventDefinitions && businessObject.eventDefinitions[0];
            var isTypeEqual = businessObject.$type === target.type;
            var isEventDefinitionEqual = ((eventDefinition && eventDefinition.$type) === target.eventDefinitionType);
            var isTriggeredByEventEqual = (businessObject.triggeredByEvent === target.triggeredByEvent);
            var isExpandedEqual = (target.isExpanded === undefined || target.isExpanded === isExpanded(businessObject));
            return !isTypeEqual || !isEventDefinitionEqual || !isTriggeredByEventEqual || !isExpandedEqual;
        };
    }

    var START_EVENT = [{
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {type: 'bpmn:StartEvent'}
    },
        {
            label: 'Intermediate Throw Event',
            actionName: 'replace-with-none-intermediate-throwing',
            className: 'bpmn-icon-intermediate-event-none',
            target: {type: 'bpmn:IntermediateThrowEvent'}
        },
        {
            label: 'End Event',
            actionName: 'replace-with-none-end',
            className: 'bpmn-icon-end-event-none',
            target: {type: 'bpmn:EndEvent'}
        }, {
            label: 'Message Start Event',
            actionName: 'replace-with-message-start',
            className: 'bpmn-icon-start-event-message',
            target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
        }, {
            label: 'Timer Start Event',
            actionName: 'replace-with-timer-start',
            className: 'bpmn-icon-start-event-timer',
            target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:TimerEventDefinition'}
        }, {
            label: 'Conditional Start Event',
            actionName: 'replace-with-conditional-start',
            className: 'bpmn-icon-start-event-condition',
            target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:ConditionalEventDefinition'}
        }, {
            label: 'Signal Start Event',
            actionName: 'replace-with-signal-start',
            className: 'bpmn-icon-start-event-signal',
            target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
        }];
    var INTERMEDIATE_EVENT = [{
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {type: 'bpmn:StartEvent'}
    }, {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-none',
        target: {type: 'bpmn:IntermediateThrowEvent'}
    }, {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {type: 'bpmn:EndEvent'}
    }, {
        label: 'Message Intermediate Catch Event',
        actionName: 'replace-with-message-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {type: 'bpmn:IntermediateCatchEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
    }, {
        label: 'Message Intermediate Throw Event',
        actionName: 'replace-with-message-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-message',
        target: {type: 'bpmn:IntermediateThrowEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
    }, {
        label: 'Timer Intermediate Catch Event',
        actionName: 'replace-with-timer-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {type: 'bpmn:IntermediateCatchEvent', eventDefinitionType: 'bpmn:TimerEventDefinition'}
    }, {
        label: 'Escalation Intermediate Throw Event',
        actionName: 'replace-with-escalation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-escalation',
        target: {type: 'bpmn:IntermediateThrowEvent', eventDefinitionType: 'bpmn:EscalationEventDefinition'}
    }, {
        label: 'Conditional Intermediate Catch Event',
        actionName: 'replace-with-conditional-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {type: 'bpmn:IntermediateCatchEvent', eventDefinitionType: 'bpmn:ConditionalEventDefinition'}
    }, {
        label: 'Link Intermediate Catch Event',
        actionName: 'replace-with-link-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-link',
        target: {type: 'bpmn:IntermediateCatchEvent', eventDefinitionType: 'bpmn:LinkEventDefinition'}
    }, {
        label: 'Link Intermediate Throw Event',
        actionName: 'replace-with-link-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-link',
        target: {type: 'bpmn:IntermediateThrowEvent', eventDefinitionType: 'bpmn:LinkEventDefinition'}
    }, {
        label: 'Compensation Intermediate Throw Event',
        actionName: 'replace-with-compensation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-compensation',
        target: {type: 'bpmn:IntermediateThrowEvent', eventDefinitionType: 'bpmn:CompensateEventDefinition'}
    }, {
        label: 'Signal Intermediate Catch Event',
        actionName: 'replace-with-signal-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {type: 'bpmn:IntermediateCatchEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
    }, {
        label: 'Signal Intermediate Throw Event',
        actionName: 'replace-with-signal-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-signal',
        target: {type: 'bpmn:IntermediateThrowEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
    }];
    var END_EVENT = [{
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {type: 'bpmn:StartEvent'}
    }, {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-none',
        target: {type: 'bpmn:IntermediateThrowEvent'}
    }, {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {type: 'bpmn:EndEvent'}
    }, {
        label: 'Message End Event',
        actionName: 'replace-with-message-end',
        className: 'bpmn-icon-end-event-message',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
    }, {
        label: 'Escalation End Event',
        actionName: 'replace-with-escalation-end',
        className: 'bpmn-icon-end-event-escalation',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:EscalationEventDefinition'}
    }, {
        label: 'Error End Event',
        actionName: 'replace-with-error-end',
        className: 'bpmn-icon-end-event-error',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:ErrorEventDefinition'}
    }, {
        label: 'Cancel End Event',
        actionName: 'replace-with-cancel-end',
        className: 'bpmn-icon-end-event-cancel',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:CancelEventDefinition'}
    }, {
        label: 'Compensation End Event',
        actionName: 'replace-with-compensation-end',
        className: 'bpmn-icon-end-event-compensation',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:CompensateEventDefinition'}
    }, {
        label: 'Signal End Event',
        actionName: 'replace-with-signal-end',
        className: 'bpmn-icon-end-event-signal',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
    }, {
        label: 'Terminate End Event',
        actionName: 'replace-with-terminate-end',
        className: 'bpmn-icon-end-event-terminate',
        target: {type: 'bpmn:EndEvent', eventDefinitionType: 'bpmn:TerminateEventDefinition'}
    }];
    var GATEWAY = [
        {
            label: 'Exclusive Gateway',
            actionName: 'replace-with-exclusive-gateway',
            className: 'bpmn-icon-gateway-xor',
            target: {type: 'bpmn:ExclusiveGateway'}
        }, {
            label: 'Parallel Gateway',
            actionName: 'replace-with-parallel-gateway',
            className: 'bpmn-icon-gateway-parallel',
            target: {type: 'bpmn:ParallelGateway'}
        }, {
            label: 'Inclusive Gateway',
            actionName: 'replace-with-inclusive-gateway',
            className: 'bpmn-icon-gateway-or',
            target: {type: 'bpmn:InclusiveGateway'}
        }, {
            label: 'Complex Gateway',
            actionName: 'replace-with-complex-gateway',
            className: 'bpmn-icon-gateway-complex',
            target: {type: 'bpmn:ComplexGateway'}
        }, {
            label: 'Event based Gateway',
            actionName: 'replace-with-event-based-gateway',
            className: 'bpmn-icon-gateway-eventbased',
            target: {type: 'bpmn:EventBasedGateway', instantiate: false, eventGatewayType: 'Exclusive'}
        }];
    var SUBPROCESS_EXPANDED = [{
        label: 'Transaction',
        actionName: 'replace-with-transaction',
        className: 'bpmn-icon-transaction',
        target: {type: 'bpmn:Transaction', isExpanded: true}
    }, {
        label: 'Event Sub Process',
        actionName: 'replace-with-event-subprocess',
        className: 'bpmn-icon-event-subprocess-expanded',
        target: {type: 'bpmn:SubProcess', triggeredByEvent: true, isExpanded: true}
    }, {
        label: 'Sub Process (collapsed)',
        actionName: 'replace-with-collapsed-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {type: 'bpmn:SubProcess', isExpanded: false}
    }];
    var TRANSACTION = [{
        label: 'Sub Process',
        actionName: 'replace-with-subprocess',
        className: 'bpmn-icon-subprocess-expanded',
        target: {type: 'bpmn:SubProcess', isExpanded: true}
    }, {
        label: 'Event Sub Process',
        actionName: 'replace-with-event-subprocess',
        className: 'bpmn-icon-event-subprocess-expanded',
        target: {type: 'bpmn:SubProcess', triggeredByEvent: true, isExpanded: true}
    }];
    var EVENT_SUB_PROCESS = [{
        label: 'Sub Process',
        actionName: 'replace-with-subprocess',
        className: 'bpmn-icon-subprocess-expanded',
        target: {type: 'bpmn:SubProcess', isExpanded: true}
    }, {
        label: 'Transaction',
        actionName: 'replace-with-transaction',
        className: 'bpmn-icon-transaction',
        target: {type: 'bpmn:Transaction', isExpanded: true}
    }];
    var TASK = [{
        label: 'Task',
        actionName: 'replace-with-task',
        className: 'bpmn-icon-task',
        target: {type: 'bpmn:Task'}
    }, {
        label: 'Send Task',
        actionName: 'replace-with-send-task',
        className: 'bpmn-icon-send',
        target: {type: 'bpmn:SendTask'}
    }, {
        label: 'Receive Task',
        actionName: 'replace-with-receive-task',
        className: 'bpmn-icon-receive',
        target: {type: 'bpmn:ReceiveTask'}
    }, {
        label: 'User Task',
        actionName: 'replace-with-user-task',
        className: 'bpmn-icon-user',
        target: {type: 'bpmn:UserTask'}
    }, {
        label: 'Manual Task',
        actionName: 'replace-with-manual-task',
        className: 'bpmn-icon-manual',
        target: {type: 'bpmn:ManualTask'}
    }, {
        label: 'Business Rule Task',
        actionName: 'replace-with-rule-task',
        className: 'bpmn-icon-business-rule',
        target: {type: 'bpmn:BusinessRuleTask'}
    }, {
        label: 'Service Task',
        actionName: 'replace-with-service-task',
        className: 'bpmn-icon-service',
        target: {type: 'bpmn:ServiceTask'}
    }, {
        label: 'Script Task',
        actionName: 'replace-with-script-task',
        className: 'bpmn-icon-script',
        target: {type: 'bpmn:ScriptTask'}
    }, {
        label: 'Call Activity',
        actionName: 'replace-with-call-activity',
        className: 'bpmn-icon-call-activity',
        target: {type: 'bpmn:CallActivity'}
    }, {
        label: 'Sub Process (collapsed)',
        actionName: 'replace-with-collapsed-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {type: 'bpmn:SubProcess', isExpanded: false}
    }, {
        label: 'Sub Process (expanded)',
        actionName: 'replace-with-expanded-subprocess',
        className: 'bpmn-icon-subprocess-expanded',
        target: {type: 'bpmn:SubProcess', isExpanded: true}
    }];
    var BOUNDARY_EVENT = [{
        label: 'Message Boundary Event',
        actionName: 'replace-with-message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
    }, {
        label: 'Timer Boundary Event',
        actionName: 'replace-with-timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:TimerEventDefinition'}
    }, {
        label: 'Escalation Boundary Event',
        actionName: 'replace-with-escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-escalation',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:EscalationEventDefinition'}
    }, {
        label: 'Conditional Boundary Event',
        actionName: 'replace-with-conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:ConditionalEventDefinition'}
    }, {
        label: 'Error Boundary Event',
        actionName: 'replace-with-error-boundary',
        className: 'bpmn-icon-intermediate-event-catch-error',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:ErrorEventDefinition'}
    }, {
        label: 'Cancel Boundary Event',
        actionName: 'replace-with-cancel-boundary',
        className: 'bpmn-icon-intermediate-event-catch-cancel',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:CancelEventDefinition'}
    }, {
        label: 'Signal Boundary Event',
        actionName: 'replace-with-signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
    }, {
        label: 'Compensation Boundary Event',
        actionName: 'replace-with-compensation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-compensation',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:CompensateEventDefinition'}
    }, {
        label: 'Message Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-message',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:MessageEventDefinition', cancelActivity: false}
    }, {
        label: 'Timer Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-timer',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:TimerEventDefinition', cancelActivity: false}
    }, {
        label: 'Escalation Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-escalation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition',
            cancelActivity: false
        }
    }, {
        label: 'Conditional Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-condition',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition',
            cancelActivity: false
        }
    }, {
        label: 'Signal Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-signal',
        target: {type: 'bpmn:BoundaryEvent', eventDefinitionType: 'bpmn:SignalEventDefinition', cancelActivity: false}
    }];
    var EVENT_SUB_PROCESS_START_EVENT = [{
        label: 'Message Start Event',
        actionName: 'replace-with-message-start',
        className: 'bpmn-icon-start-event-message',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:MessageEventDefinition'}
    }, {
        label: 'Timer Start Event',
        actionName: 'replace-with-timer-start',
        className: 'bpmn-icon-start-event-timer',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:TimerEventDefinition'}
    }, {
        label: 'Conditional Start Event',
        actionName: 'replace-with-conditional-start',
        className: 'bpmn-icon-start-event-condition',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:ConditionalEventDefinition'}
    }, {
        label: 'Signal Start Event',
        actionName: 'replace-with-signal-start',
        className: 'bpmn-icon-start-event-signal',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:SignalEventDefinition'}
    }, {
        label: 'Error Start Event',
        actionName: 'replace-with-error-start',
        className: 'bpmn-icon-start-event-error',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:ErrorEventDefinition'}
    }, {
        label: 'Escalation Start Event',
        actionName: 'replace-with-escalation-start',
        className: 'bpmn-icon-start-event-escalation',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:EscalationEventDefinition'}
    }, {
        label: 'Compensation Start Event',
        actionName: 'replace-with-compensation-start',
        className: 'bpmn-icon-start-event-compensation',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:CompensateEventDefinition'}
    }, {
        label: 'Message Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-message-start',
        className: 'bpmn-icon-start-event-non-interrupting-message',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:MessageEventDefinition', isInterrupting: false}
    }, {
        label: 'Timer Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-timer-start',
        className: 'bpmn-icon-start-event-non-interrupting-timer',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:TimerEventDefinition', isInterrupting: false}
    }, {
        label: 'Conditional Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-conditional-start',
        className: 'bpmn-icon-start-event-non-interrupting-condition',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:ConditionalEventDefinition', isInterrupting: false}
    }, {
        label: 'Signal Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-signal-start',
        className: 'bpmn-icon-start-event-non-interrupting-signal',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:SignalEventDefinition', isInterrupting: false}
    }, {
        label: 'Escalation Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-escalation-start',
        className: 'bpmn-icon-start-event-non-interrupting-escalation',
        target: {type: 'bpmn:StartEvent', eventDefinitionType: 'bpmn:EscalationEventDefinition', isInterrupting: false}
    }];
    var SEQUENCE_FLOW = [{
        label: 'Sequence Flow',
        actionName: 'replace-with-sequence-flow',
        className: 'bpmn-icon-connection'
    }, {
        label: 'Default Flow',
        actionName: 'replace-with-default-flow',
        className: 'bpmn-icon-default-flow'
    }, {
        label: 'Conditional Flow',
        actionName: 'replace-with-conditional-flow',
        className: 'bpmn-icon-conditional-flow'
    }];
    var PARTICIPANT = [{
        label: 'Expanded Pool',
        actionName: 'replace-with-expanded-pool',
        className: 'bpmn-icon-participant',
        target: {type: 'bpmn:Participant', isExpanded: true}
    }, {
        label: 'Collapsed Pool',
        actionName: 'replace-with-collapsed-pool',
        className: 'bpmn-icon-lane',
        target: {type: 'bpmn:Participant', isExpanded: false}
    }];

    function ReplaceMenuProvider(popupMenu, modeling, moddle, bpmnReplace, rules, translate) {
        this._popupMenu = popupMenu;
        this._modeling = modeling;
        this._moddle = moddle;
        this._bpmnReplace = bpmnReplace;
        this._rules = rules;
        this._translate = translate;
        this.register();
    }

    ReplaceMenuProvider.$inject = ['popupMenu', 'modeling', 'moddle', 'bpmnReplace', 'rules', 'translate'];
    ReplaceMenuProvider.prototype.register = function () {
        this._popupMenu.registerProvider('bpmn-replace', this);
    };
    ReplaceMenuProvider.prototype.getEntries = function (element) {
        var businessObject = element.businessObject;
        var rules = this._rules;
        var entries;
        if (!rules.allowed('shape.replace', {element: element})) {
            return [];
        }
        var differentType = isDifferentType(element);
        if (is$1(businessObject, 'bpmn:StartEvent') && !isEventSubProcess(businessObject.$parent)) {
            entries = filter(START_EVENT, differentType);
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:Participant')) {
            entries = filter(PARTICIPANT, function (entry) {
                return isExpanded(businessObject) !== entry.target.isExpanded;
            });
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:StartEvent') && isEventSubProcess(businessObject.$parent)) {
            entries = filter(EVENT_SUB_PROCESS_START_EVENT, function (entry) {
                var target = entry.target;
                var isInterrupting$$1 = target.isInterrupting !== false;
                var isInterruptingEqual = getBusinessObject(element).isInterrupting === isInterrupting$$1;
                return differentType(entry) || !differentType(entry) && !isInterruptingEqual;
            });
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:EndEvent')) {
            entries = filter(END_EVENT, function (entry) {
                var target = entry.target;
                if (target.eventDefinitionType == 'bpmn:CancelEventDefinition' && !is$1(businessObject.$parent, 'bpmn:Transaction')) {
                    return false;
                }
                return differentType(entry);
            });
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:BoundaryEvent')) {
            entries = filter(BOUNDARY_EVENT, function (entry) {
                var target = entry.target;
                if (target.eventDefinition == 'bpmn:CancelEventDefinition' && !is$1(businessObject.attachedToRef, 'bpmn:Transaction')) {
                    return false;
                }
                var cancelActivity = target.cancelActivity !== false;
                var isCancelActivityEqual = businessObject.cancelActivity == cancelActivity;
                return differentType(entry) || !differentType(entry) && !isCancelActivityEqual;
            });
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:IntermediateCatchEvent') || is$1(businessObject, 'bpmn:IntermediateThrowEvent')) {
            entries = filter(INTERMEDIATE_EVENT, differentType);
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:Gateway')) {
            entries = filter(GATEWAY, differentType);
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:Transaction')) {
            entries = filter(TRANSACTION, differentType);
            return this._createEntries(element, entries);
        }
        if (isEventSubProcess(businessObject) && isExpanded(businessObject)) {
            entries = filter(EVENT_SUB_PROCESS, differentType);
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:SubProcess') && isExpanded(businessObject)) {
            entries = filter(SUBPROCESS_EXPANDED, differentType);
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:AdHocSubProcess') && !isExpanded(businessObject)) {
            entries = filter(TASK, function (entry) {
                var target = entry.target;
                var isTargetSubProcess = target.type === 'bpmn:SubProcess';
                var isTargetExpanded = target.isExpanded === true;
                return isDifferentType(element, target) && (!isTargetSubProcess || isTargetExpanded);
            });
            return this._createEntries(element, entries);
        }
        if (is$1(businessObject, 'bpmn:SequenceFlow')) {
            return this._createSequenceFlowEntries(element, SEQUENCE_FLOW);
        }
        if (is$1(businessObject, 'bpmn:FlowNode')) {
            entries = filter(TASK, differentType);
            if (is$1(businessObject, 'bpmn:SubProcess') && !isExpanded(businessObject)) {
                entries = filter(entries, function (entry) {
                    return entry.label !== 'Sub Process (collapsed)';
                });
            }
            return this._createEntries(element, entries);
        }
        return [];
    };
    ReplaceMenuProvider.prototype.getHeaderEntries = function (element) {
        var headerEntries = [];
        if (is$1(element, 'bpmn:Activity') && !isEventSubProcess(element)) {
            headerEntries = headerEntries.concat(this._getLoopEntries(element));
        }
        if (is$1(element, 'bpmn:SubProcess') && !is$1(element, 'bpmn:Transaction') && !isEventSubProcess(element)) {
            headerEntries.push(this._getAdHocEntry(element));
        }
        return headerEntries;
    };
    ReplaceMenuProvider.prototype._createEntries = function (element, replaceOptions) {
        var menuEntries = [];
        var self = this;
        forEach(replaceOptions, function (definition) {
            var entry = self._createMenuEntry(definition, element);
            menuEntries.push(entry);
        });
        return menuEntries;
    };
    ReplaceMenuProvider.prototype._createSequenceFlowEntries = function (element, replaceOptions) {
        var businessObject = getBusinessObject(element);
        var menuEntries = [];
        var modeling = this._modeling, moddle = this._moddle;
        var self = this;
        forEach(replaceOptions, function (entry) {
            switch (entry.actionName) {
                case'replace-with-default-flow':
                    if (businessObject.sourceRef.default !== businessObject && (is$1(businessObject.sourceRef, 'bpmn:ExclusiveGateway') || is$1(businessObject.sourceRef, 'bpmn:InclusiveGateway') || is$1(businessObject.sourceRef, 'bpmn:ComplexGateway') || is$1(businessObject.sourceRef, 'bpmn:Activity'))) {
                        menuEntries.push(self._createMenuEntry(entry, element, function () {
                            modeling.updateProperties(element.source, {default: businessObject});
                        }));
                    }
                    break;
                case'replace-with-conditional-flow':
                    if (!businessObject.conditionExpression && is$1(businessObject.sourceRef, 'bpmn:Activity')) {
                        menuEntries.push(self._createMenuEntry(entry, element, function () {
                            var conditionExpression = moddle.create('bpmn:FormalExpression', {body: ''});
                            modeling.updateProperties(element, {conditionExpression: conditionExpression});
                        }));
                    }
                    break;
                default:
                    if (is$1(businessObject.sourceRef, 'bpmn:Activity') && businessObject.conditionExpression) {
                        return menuEntries.push(self._createMenuEntry(entry, element, function () {
                            modeling.updateProperties(element, {conditionExpression: undefined});
                        }));
                    }
                    if ((is$1(businessObject.sourceRef, 'bpmn:ExclusiveGateway') || is$1(businessObject.sourceRef, 'bpmn:InclusiveGateway') || is$1(businessObject.sourceRef, 'bpmn:ComplexGateway') || is$1(businessObject.sourceRef, 'bpmn:Activity')) && businessObject.sourceRef.default === businessObject) {
                        return menuEntries.push(self._createMenuEntry(entry, element, function () {
                            modeling.updateProperties(element.source, {default: undefined});
                        }));
                    }
            }
        });
        return menuEntries;
    };
    ReplaceMenuProvider.prototype._createMenuEntry = function (definition, element, action) {
        var translate = this._translate;
        var replaceElement = this._bpmnReplace.replaceElement;
        var replaceAction = function () {
            return replaceElement(element, definition.target);
        };
        action = action || replaceAction;
        var menuEntry = {
            label: translate(definition.label),
            className: definition.className,
            id: definition.actionName,
            action: action
        };
        return menuEntry;
    };
    ReplaceMenuProvider.prototype._getLoopEntries = function (element) {
        var self = this;
        var translate = this._translate;

        function toggleLoopEntry(event, entry) {
            var loopCharacteristics;
            if (entry.active) {
                loopCharacteristics = undefined;
            } else {
                loopCharacteristics = self._moddle.create(entry.options.loopCharacteristics);
                if (entry.options.isSequential) {
                    loopCharacteristics.isSequential = entry.options.isSequential;
                }
            }
            self._modeling.updateProperties(element, {loopCharacteristics: loopCharacteristics});
        }

        var businessObject = getBusinessObject(element), loopCharacteristics = businessObject.loopCharacteristics;
        var isSequential, isLoop, isParallel;
        if (loopCharacteristics) {
            isSequential = loopCharacteristics.isSequential;
            isLoop = loopCharacteristics.isSequential === undefined;
            isParallel = loopCharacteristics.isSequential !== undefined && !loopCharacteristics.isSequential;
        }
        var loopEntries = [{
            id: 'toggle-parallel-mi',
            className: 'bpmn-icon-parallel-mi-marker',
            title: translate('Parallel Multi Instance'),
            active: isParallel,
            action: toggleLoopEntry,
            options: {loopCharacteristics: 'bpmn:MultiInstanceLoopCharacteristics', isSequential: false}
        }, {
            id: 'toggle-sequential-mi',
            className: 'bpmn-icon-sequential-mi-marker',
            title: translate('Sequential Multi Instance'),
            active: isSequential,
            action: toggleLoopEntry,
            options: {loopCharacteristics: 'bpmn:MultiInstanceLoopCharacteristics', isSequential: true}
        }, {
            id: 'toggle-loop',
            className: 'bpmn-icon-loop-marker',
            title: translate('Loop'),
            active: isLoop,
            action: toggleLoopEntry,
            options: {loopCharacteristics: 'bpmn:StandardLoopCharacteristics'}
        }];
        return loopEntries;
    };
    ReplaceMenuProvider.prototype._getAdHocEntry = function (element) {
        var translate = this._translate;
        var businessObject = getBusinessObject(element);
        var isAdHoc = is$1(businessObject, 'bpmn:AdHocSubProcess');
        var replaceElement = this._bpmnReplace.replaceElement;
        var adHocEntry = {
            id: 'toggle-adhoc',
            className: 'bpmn-icon-ad-hoc-marker',
            title: translate('Ad-hoc'),
            active: isAdHoc,
            action: function (event, entry) {
                if (isAdHoc) {
                    return replaceElement(element, {type: 'bpmn:SubProcess'});
                } else {
                    return replaceElement(element, {type: 'bpmn:AdHocSubProcess'});
                }
            }
        };
        return adHocEntry;
    };
    var PopupMenuModule$1 = {
        __depends__: [PopupMenuModule, ReplaceModule$1],
        __init__: ['replaceMenuProvider'],
        replaceMenuProvider: ['type', ReplaceMenuProvider]
    };
    var max$2 = Math.max, min$1 = Math.min;
    var DEFAULT_CHILD_BOX_PADDING = 20;

    function substractTRBL(trblA, trblB) {
        return {
            top: trblA.top - trblB.top,
            right: trblA.right - trblB.right,
            bottom: trblA.bottom - trblB.bottom,
            left: trblA.left - trblB.left
        };
    }

    function resizeBounds(bounds, direction, delta) {
        var dx = delta.x, dy = delta.y;
        switch (direction) {
            case'nw':
                return {x: bounds.x + dx, y: bounds.y + dy, width: bounds.width - dx, height: bounds.height - dy};
            case'sw':
                return {x: bounds.x + dx, y: bounds.y, width: bounds.width - dx, height: bounds.height + dy};
            case'ne':
                return {x: bounds.x, y: bounds.y + dy, width: bounds.width + dx, height: bounds.height - dy};
            case'se':
                return {x: bounds.x, y: bounds.y, width: bounds.width + dx, height: bounds.height + dy};
            default:
                throw new Error('unrecognized direction: ' + direction);
        }
    }

    function resizeTRBL(bounds, resize) {
        return {
            x: bounds.x + (resize.left || 0),
            y: bounds.y + (resize.top || 0),
            width: bounds.width - (resize.left || 0) + (resize.right || 0),
            height: bounds.height - (resize.top || 0) + (resize.bottom || 0)
        };
    }

    function applyConstraints(attr, trbl, resizeConstraints) {
        var value = trbl[attr], minValue = resizeConstraints.min && resizeConstraints.min[attr],
            maxValue = resizeConstraints.max && resizeConstraints.max[attr];
        if (isNumber(minValue)) {
            value = (/top|left/.test(attr) ? min$1 : max$2)(value, minValue);
        }
        if (isNumber(maxValue)) {
            value = (/top|left/.test(attr) ? max$2 : min$1)(value, maxValue);
        }
        return value;
    }

    function ensureConstraints(currentBounds, resizeConstraints) {
        if (!resizeConstraints) {
            return currentBounds;
        }
        var currentTrbl = asTRBL(currentBounds);
        return asBounds({
            top: applyConstraints('top', currentTrbl, resizeConstraints),
            right: applyConstraints('right', currentTrbl, resizeConstraints),
            bottom: applyConstraints('bottom', currentTrbl, resizeConstraints),
            left: applyConstraints('left', currentTrbl, resizeConstraints)
        });
    }

    function getMinResizeBounds(direction, currentBounds, minDimensions, childrenBounds) {
        var currentBox = asTRBL(currentBounds);
        var minBox = {
            top: /n/.test(direction) ? currentBox.bottom - minDimensions.height : currentBox.top,
            left: /w/.test(direction) ? currentBox.right - minDimensions.width : currentBox.left,
            bottom: /s/.test(direction) ? currentBox.top + minDimensions.height : currentBox.bottom,
            right: /e/.test(direction) ? currentBox.left + minDimensions.width : currentBox.right
        };
        var childrenBox = childrenBounds ? asTRBL(childrenBounds) : minBox;
        var combinedBox = {
            top: min$1(minBox.top, childrenBox.top),
            left: min$1(minBox.left, childrenBox.left),
            bottom: max$2(minBox.bottom, childrenBox.bottom),
            right: max$2(minBox.right, childrenBox.right)
        };
        return asBounds(combinedBox);
    }

    function asPadding(mayBePadding, defaultValue) {
        if (typeof mayBePadding !== 'undefined') {
            return mayBePadding;
        } else {
            return DEFAULT_CHILD_BOX_PADDING;
        }
    }

    function addPadding(bbox, padding) {
        var left, right, top, bottom;
        if (typeof padding === 'object') {
            left = asPadding(padding.left);
            right = asPadding(padding.right);
            top = asPadding(padding.top);
            bottom = asPadding(padding.bottom);
        } else {
            left = right = top = bottom = asPadding(padding);
        }
        return {
            x: bbox.x - left,
            y: bbox.y - top,
            width: bbox.width + left + right,
            height: bbox.height + top + bottom
        };
    }

    function isBBoxChild(element) {
        if (element.waypoints) {
            return false;
        }
        if (element.type === 'label') {
            return false;
        }
        return true;
    }

    function computeChildrenBBox(shapeOrChildren, padding) {
        var elements;
        if (shapeOrChildren.length === undefined) {
            elements = filter(shapeOrChildren.children, isBBoxChild);
        } else {
            elements = shapeOrChildren;
        }
        if (elements.length) {
            return addPadding(getBBox(elements), padding);
        }
    }

    var abs$2 = Math.abs;

    function getTRBLResize(oldBounds, newBounds) {
        return substractTRBL(asTRBL(newBounds), asTRBL(oldBounds));
    }

    var LANE_PARENTS = ['bpmn:Participant', 'bpmn:Process', 'bpmn:SubProcess'];
    var LANE_INDENTATION = 30;

    function collectLanes(shape, collectedShapes) {
        collectedShapes = collectedShapes || [];
        shape.children.filter(function (s) {
            if (is$1(s, 'bpmn:Lane')) {
                collectLanes(s, collectedShapes);
                collectedShapes.push(s);
            }
        });
        return collectedShapes;
    }

    function getChildLanes(shape) {
        return shape.children.filter(function (c) {
            return is$1(c, 'bpmn:Lane');
        });
    }

    function getLanesRoot(shape) {
        return getParent(shape, LANE_PARENTS) || shape;
    }

    function computeLanesResize(shape, newBounds) {
        var rootElement = getLanesRoot(shape);
        var initialShapes = is$1(rootElement, 'bpmn:Process') ? [] : [rootElement];
        var allLanes = collectLanes(rootElement, initialShapes), shapeTrbl = asTRBL(shape),
            shapeNewTrbl = asTRBL(newBounds), trblResize = getTRBLResize(shape, newBounds), resizeNeeded = [];
        allLanes.forEach(function (other) {
            if (other === shape) {
                return;
            }
            var topResize = 0, rightResize = trblResize.right, bottomResize = 0, leftResize = trblResize.left;
            var otherTrbl = asTRBL(other);
            if (trblResize.top) {
                if (abs$2(otherTrbl.bottom - shapeTrbl.top) < 10) {
                    bottomResize = shapeNewTrbl.top - otherTrbl.bottom;
                }
                if (abs$2(otherTrbl.top - shapeTrbl.top) < 5) {
                    topResize = shapeNewTrbl.top - otherTrbl.top;
                }
            }
            if (trblResize.bottom) {
                if (abs$2(otherTrbl.top - shapeTrbl.bottom) < 10) {
                    topResize = shapeNewTrbl.bottom - otherTrbl.top;
                }
                if (abs$2(otherTrbl.bottom - shapeTrbl.bottom) < 5) {
                    bottomResize = shapeNewTrbl.bottom - otherTrbl.bottom;
                }
            }
            if (topResize || rightResize || bottomResize || leftResize) {
                resizeNeeded.push({
                    shape: other,
                    newBounds: resizeTRBL(other, {
                        top: topResize,
                        right: rightResize,
                        bottom: bottomResize,
                        left: leftResize
                    })
                });
            }
        });
        return resizeNeeded;
    }

    function ContextPadProvider(config, injector, eventBus, contextPad, modeling, elementFactory, connect, create, popupMenu, canvas, rules, translate) {
        config = config || {};
        contextPad.registerProvider(this);
        this._contextPad = contextPad;
        this._modeling = modeling;
        this._elementFactory = elementFactory;
        this._connect = connect;
        this._create = create;
        this._popupMenu = popupMenu;
        this._canvas = canvas;
        this._rules = rules;
        this._translate = translate;
        if (config.autoPlace !== false) {
            this._autoPlace = injector.get('autoPlace', false);
        }
        eventBus.on('create.end', 250, function (event) {
            var shape = event.context.shape;
            if (!hasPrimaryModifier(event)) {
                return;
            }
            var entries = contextPad.getEntries(shape);
            if (entries.replace) {
                entries.replace.action.click(event, shape);
            }
        });
    }

    ContextPadProvider.$inject = ['config.contextPad', 'injector', 'eventBus', 'contextPad', 'modeling', 'elementFactory', 'connect', 'create', 'popupMenu', 'canvas', 'rules', 'translate'];
    ContextPadProvider.prototype.getContextPadEntries = function (element) {
        var contextPad = this._contextPad, modeling = this._modeling, elementFactory = this._elementFactory,
            connect = this._connect, create = this._create, popupMenu = this._popupMenu, canvas = this._canvas,
            rules = this._rules, autoPlace = this._autoPlace, translate = this._translate;
        var actions = {};
        if (element.type === 'label') {
            return actions;
        }
        var businessObject = element.businessObject;

        function startConnect(event, element) {
            connect.start(event, element);
        }

        function removeElement(e) {
            modeling.removeElements([element]);
        }

        function getReplaceMenuPosition(element) {
            var Y_OFFSET = 5;
            var diagramContainer = canvas.getContainer(), pad = contextPad.getPad(element).html;
            var diagramRect = diagramContainer.getBoundingClientRect(), padRect = pad.getBoundingClientRect();
            var top = padRect.top - diagramRect.top;
            var left = padRect.left - diagramRect.left;
            var pos = {x: left, y: top + padRect.height + Y_OFFSET};
            return pos;
        }

        function appendAction(type, className, title, options) {
            if (typeof title !== 'string') {
                options = title;
                title = translate('Append {type}', {type: type.replace(/^bpmn:/, '')});
            }

            function appendStart(event, element) {
                var shape = elementFactory.createShape(assign({type: type}, options));
                create.start(event, shape, element);
            }

            var append = autoPlace ? function (event, element) {
                var shape = elementFactory.createShape(assign({type: type}, options));
                autoPlace.append(element, shape);
            } : appendStart;
            return {
                group: 'model',
                className: className,
                title: title,
                action: {dragstart: appendStart, click: append}
            };
        }

        function splitLaneHandler(count) {
            return function (event, element) {
                modeling.splitLane(element, count);
                contextPad.open(element, true);
            };
        }

        if (isAny(businessObject, ['bpmn:Lane', 'bpmn:Participant']) && isExpanded(businessObject)) {
            var childLanes = getChildLanes(element);
            assign(actions, {
                'lane-insert-above': {
                    group: 'lane-insert-above',
                    className: 'bpmn-icon-lane-insert-above',
                    title: translate('Add Lane above'),
                    action: {
                        click: function (event, element) {
                            modeling.addLane(element, 'top');
                        }
                    }
                }
            });
            if (childLanes.length < 2) {
                if (element.height >= 120) {
                    assign(actions, {
                        'lane-divide-two': {
                            group: 'lane-divide',
                            className: 'bpmn-icon-lane-divide-two',
                            title: translate('Divide into two Lanes'),
                            action: {click: splitLaneHandler(2)}
                        }
                    });
                }
                if (element.height >= 180) {
                    assign(actions, {
                        'lane-divide-three': {
                            group: 'lane-divide',
                            className: 'bpmn-icon-lane-divide-three',
                            title: translate('Divide into three Lanes'),
                            action: {click: splitLaneHandler(3)}
                        }
                    });
                }
            }
            assign(actions, {
                'lane-insert-below': {
                    group: 'lane-insert-below',
                    className: 'bpmn-icon-lane-insert-below',
                    title: translate('Add Lane below'),
                    action: {
                        click: function (event, element) {
                            modeling.addLane(element, 'bottom');
                        }
                    }
                }
            });
        }
        if (is$1(businessObject, 'bpmn:FlowNode')) {
            if (is$1(businessObject, 'bpmn:EventBasedGateway')) {
                assign(actions, {
                    'append.receive-task': appendAction('bpmn:ReceiveTask', 'bpmn-icon-receive-task'),
                    'append.message-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-message', translate('Append MessageIntermediateCatchEvent'), {eventDefinitionType: 'bpmn:MessageEventDefinition'}),
                    'append.timer-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-timer', translate('Append TimerIntermediateCatchEvent'), {eventDefinitionType: 'bpmn:TimerEventDefinition'}),
                    'append.condtion-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-condition', translate('Append ConditionIntermediateCatchEvent'), {eventDefinitionType: 'bpmn:ConditionalEventDefinition'}),
                    'append.signal-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-signal', translate('Append SignalIntermediateCatchEvent'), {eventDefinitionType: 'bpmn:SignalEventDefinition'})
                });
            } else if (isEventType(businessObject, 'bpmn:BoundaryEvent', 'bpmn:CompensateEventDefinition')) {
                assign(actions, {'append.compensation-activity': appendAction('bpmn:Task', 'bpmn-icon-task', translate('Append compensation activity'), {isForCompensation: true})});
            } else if (!is$1(businessObject, 'bpmn:EndEvent') && !businessObject.isForCompensation && !isEventType(businessObject, 'bpmn:IntermediateThrowEvent', 'bpmn:LinkEventDefinition') && !isEventSubProcess(businessObject)) {
                assign(actions, {
                    'append.end-event': appendAction('bpmn:EndEvent', 'bpmn-icon-end-event-none', translate('结束环节')),
                    'append.exclusive-gateway': appendAction('bpmn:ExclusiveGateway', 'bpmn-icon-gateway-xor', translate('排他网关')),
                    'append.parallel-gateway': appendAction('bpmn:ParallelGateway', 'bpmn-icon-gateway-parallel', translate('并行网关')),
                    'append.user-task': appendAction('bpmn:UserTask', 'bpmn-icon-user', translate('人工任务')),
                    'append.service-task': appendAction('bpmn:ServiceTask', 'bpmn-icon-service', translate('服务任务')),
                    'append.call-activity': appendAction('bpmn:CallActivity', 'bpmn-icon-call-activity', translate('调用子流程')),
                    // 'append.sub-process': appendAction('bpmn:SubProcess', 'bpmn-icon-subprocess-expanded', translate('子流程'), {isExpanded: true}),
                    /*'append.intermediate-event': appendAction('bpmn:IntermediateThrowEvent', 'bpmn-icon-intermediate-event-none', translate('Append Intermediate/Boundary Event'))*/
                });
            }
        }
        // if (!popupMenu.isEmpty(element, 'bpmn-replace')) {
        //     assign(actions, {
        //         'replace': {
        //             group: 'edit',
        //             className: 'bpmn-icon-screw-wrench',
        //             title: translate('类型选择'),
        //             action: {
        //                 click: function (event, element) {
        //                     var position = assign(getReplaceMenuPosition(element), {cursor: {x: event.x, y: event.y}});
        //                     popupMenu.open(element, 'bpmn-replace', position);
        //                     // ElementConfig(event, element);
        //                 }
        //             }
        //         }
        //     });
        // }
        // if (!isAny(element, ['bpmn:StartEvent', 'bpmn:EndEvent'])) {
        //     if (!popupMenu.isEmpty(element, 'bpmn-replace')) {
        //         assign(actions, {
        //             'config': {
        //                 group: 'config',
        //                 className: 'bpmn-icon-screw-wrench',
        //                 title: translate('节点配置'),
        //                 action: {
        //                     click: function (event, element) {
        //                         var position = assign(getReplaceMenuPosition(element), {cursor: {x: event.x, y: event.y}});
        //                         popupMenu.open(element, 'bpmn-replace', position);
        //                     }
        //                 }
        //             }
        //         });
        //     }
        // }
        if (!isAny(element, ['bpmn:EndEvent', 'bpmn:SequenceFlow'])) {
            if (!popupMenu.isEmpty(element, 'bpmn-replace')) {
                assign(actions, {
                    'connect': {
                        group: 'connect',
                        className: 'bpmn-icon-connection-multi',
                        title: translate('连接线'),
                        action: {click: startConnect, dragstart: startConnect}
                    }
                });
            }
        }
        // if (isAny(businessObject, ['bpmn:FlowNode', 'bpmn:InteractionNode', 'bpmn:DataObjectReference', 'bpmn:DataStoreReference'])) {
        //     assign(actions, {
        //         // 'append.text-annotation': appendAction('bpmn:TextAnnotation', 'bpmn-icon-text-annotation'),
        //         'connect': {
        //             group: 'connect',
        //             className: 'bpmn-icon-connection-multi',
        //             title: translate('连接线'),
        //             action: {click: startConnect, dragstart: startConnect}
        //         }
        //     });
        // }
        if (isAny(businessObject, ['bpmn:DataObjectReference', 'bpmn:DataStoreReference'])) {
            assign(actions, {
                'connect': {
                    group: 'connect',
                    className: 'bpmn-icon-connection-multi',
                    title: translate('Connect using DataInputAssociation'),
                    action: {click: startConnect, dragstart: startConnect}
                }
            });
        }
        var deleteAllowed = rules.allowed('elements.delete', {elements: [element]});
        if (isArray(deleteAllowed)) {
            deleteAllowed = deleteAllowed[0] === element;
        }
        if (deleteAllowed) {
            assign(actions, {
                'delete': {
                    group: 'edit',
                    className: 'bpmn-icon-trash',
                    title: translate('移除'),
                    action: {click: removeElement}
                }
            });
        }
        return actions;
    };

    function isEventType(eventBo, type, definition) {
        var isType = eventBo.$instanceOf(type);
        var isDefinition = false;
        var definitions = eventBo.eventDefinitions || [];
        forEach(definitions, function (def) {
            if (def.$type === definition) {
                isDefinition = true;
            }
        });
        return isType && isDefinition;
    }

    var ContextPadModule$1 = {
        __depends__: [DirectEditingModule, ContextPadModule, SelectionModule, ConnectModule, CreateModule, PopupMenuModule$1],
        __init__: ['contextPadProvider'],
        contextPadProvider: ['type', ContextPadProvider]
    };

    function Clipboard() {
    }

    Clipboard.prototype.get = function () {
        return this._data;
    };
    Clipboard.prototype.set = function (data) {
        this._data = data;
    };
    Clipboard.prototype.clear = function () {
        var data = this._data;
        delete this._data;
        return data;
    };
    Clipboard.prototype.isEmpty = function () {
        return !this._data;
    };
    var ClipboardModule = {clipboard: ['type', Clipboard]};

    function getTopLevel(elements) {
        var topLevel = {}, parents = [], result = [], clearedParents = [];
        forEach(elements, function (element) {
            var parent = element.parent;
            if (!topLevel[parent.id]) {
                topLevel[parent.id] = [];
            }
            if (parents.indexOf(parent.id) === -1) {
                parents.push(parent.id);
            }
            topLevel[parent.id].push(element);
        });
        forEach(parents, function (parent) {
            forEach(topLevel[parent], function (element) {
                if (topLevel[element.id]) {
                    clearedParents.push(element.id);
                }
            });
        });
        forEach(parents, function (parent) {
            var idx = clearedParents.indexOf(parent);
            if (idx === -1) {
                result = result.concat(topLevel[parent]);
            }
        });
        return result;
    }

    function CopyPaste(eventBus, modeling, elementFactory, rules, clipboard, canvas) {
        this._eventBus = eventBus;
        this._modeling = modeling;
        this._elementFactory = elementFactory;
        this._rules = rules;
        this._canvas = canvas;
        this._clipboard = clipboard;
        this._descriptors = [];
        this.registerDescriptor(function (element, descriptor) {
            descriptor.priority = 1;
            descriptor.id = element.id;
            if (element.parent) {
                descriptor.parent = element.parent.id;
            }
            if (element.labelTarget) {
                descriptor.priority = 4;
                descriptor.labelTarget = element.labelTarget.id;
            }
            if (element.host) {
                descriptor.priority = 2;
                descriptor.host = element.host.id;
            }
            if (typeof element.x === 'number') {
                descriptor.x = element.x;
                descriptor.y = element.y;
            }
            if (element.width) {
                descriptor.width = element.width;
                descriptor.height = element.height;
            }
            if (element.waypoints) {
                descriptor.priority = 3;
                descriptor.waypoints = [];
                forEach(element.waypoints, function (waypoint) {
                    var wp = {x: waypoint.x, y: waypoint.y};
                    if (waypoint.original) {
                        wp.original = {x: waypoint.original.x, y: waypoint.original.y};
                    }
                    descriptor.waypoints.push(wp);
                });
            }
            if (element.source && element.target) {
                descriptor.source = element.source.id;
                descriptor.target = element.target.id;
            }
            return descriptor;
        });
    }

    CopyPaste.$inject = ['eventBus', 'modeling', 'elementFactory', 'rules', 'clipboard', 'canvas'];
    CopyPaste.prototype.copy = function (selectedElements) {
        var clipboard = this._clipboard, tree, bbox;
        if (!isArray(selectedElements)) {
            selectedElements = selectedElements ? [selectedElements] : [];
        }
        if (!selectedElements.length) {
            return;
        }
        tree = this.createTree(selectedElements);
        bbox = this._bbox = center(getBBox(tree.allShapes));
        delete tree.allShapes;
        forEach(tree, function (elements) {
            forEach(elements, function (element) {
                var delta$$1, labelTarget;
                if (element.labelTarget) {
                    labelTarget = find(elements, matchPattern({id: element.labelTarget}));
                    if (labelTarget.waypoints) {
                        delta$$1 = delta(element, labelTarget.waypoints[0]);
                    } else {
                        delta$$1 = delta(element, labelTarget);
                    }
                } else if (element.priority === 3) {
                    delta$$1 = [];
                    forEach(element.waypoints, function (waypoint) {
                        var waypointDelta = delta(waypoint, bbox);
                        delta$$1.push(waypointDelta);
                    });
                } else {
                    delta$$1 = delta(element, bbox);
                }
                element.delta = delta$$1;
            });
        });
        this._eventBus.fire('elements.copy', {context: {tree: tree}});
        if (Object.keys(tree).length === 0) {
            clipboard.clear();
        } else {
            clipboard.set(tree);
        }
        this._eventBus.fire('elements.copied', {context: {tree: tree}});
        return tree;
    };
    CopyPaste.prototype.paste = function (context) {
        var clipboard = this._clipboard, modeling = this._modeling, eventBus = this._eventBus, rules = this._rules;
        var tree = clipboard.get(), topParent = context.element, position = context.point, newTree, canPaste;
        if (clipboard.isEmpty()) {
            return;
        }
        newTree = reduce(tree, function (pasteTree, elements, depthStr) {
            var depth = parseInt(depthStr, 10);
            if (isNaN(depth)) {
                return pasteTree;
            }
            pasteTree[depth] = elements;
            return pasteTree;
        }, {});
        canPaste = rules.allowed('elements.paste', {tree: newTree, target: topParent});
        if (!canPaste) {
            eventBus.fire('elements.paste.rejected', {context: {tree: newTree, position: position, target: topParent}});
            return;
        }
        modeling.pasteElements(newTree, topParent, position);
    };
    CopyPaste.prototype._computeDelta = function (elements, element) {
        var bbox = this._bbox, delta$$1 = {};
        if (element.labelTarget) {
            return delta(element, element.labelTarget);
        }
        if (element.priority === 3) {
            delta$$1 = [];
            forEach(element.waypoints, function (waypoint) {
                var waypointDelta = delta(waypoint, bbox);
                delta$$1.push(waypointDelta);
            });
        } else {
            delta$$1 = delta(element, bbox);
        }
        return delta$$1;
    };
    CopyPaste.prototype.hasRelations = function (elements, element) {
        var source, target, labelTarget;
        if (element.waypoints) {
            source = find(elements, matchPattern({id: element.source.id}));
            target = find(elements, matchPattern({id: element.target.id}));
            if (!source || !target) {
                return false;
            }
        }
        if (element.labelTarget) {
            labelTarget = find(elements, matchPattern({id: element.labelTarget.id}));
            if (!labelTarget) {
                return false;
            }
        }
        return true;
    };
    CopyPaste.prototype.registerDescriptor = function (descriptor) {
        if (typeof descriptor !== 'function') {
            throw new Error('the descriptor must be a function');
        }
        if (this._descriptors.indexOf(descriptor) !== -1) {
            throw new Error('this descriptor is already registered');
        }
        this._descriptors.push(descriptor);
    };
    CopyPaste.prototype._executeDescriptors = function (data) {
        if (!data.descriptor) {
            data.descriptor = {};
        }
        forEach(this._descriptors, function (descriptor) {
            data.descriptor = descriptor(data.element, data.descriptor);
        });
        return data;
    };
    CopyPaste.prototype.createTree = function (elements) {
        var rules = this._rules, self = this;
        var tree = {}, includedElements = [], _elements;
        var topLevel = getTopLevel(elements);
        tree.allShapes = [];

        function canCopy(collection, element) {
            return rules.allowed('element.copy', {collection: collection, element: element});
        }

        function includeElement(data) {
            var idx = findIndex(includedElements, matchPattern({element: data.element})), element;
            if (idx !== -1) {
                element = includedElements[idx];
            } else {
                return includedElements.push(data);
            }
            if (element.depth < data.depth) {
                includedElements.splice(idx, 1);
                includedElements.push(data);
            }
        }

        eachElement(topLevel, function (element, i, depth) {
            var nestedChildren = element.children;
            if (element.labelTarget) {
                return;
            }

            function getNested(lists) {
                forEach(lists, function (list) {
                    if (list && list.length) {
                        forEach(list, function (elem) {
                            forEach(elem.labels, function (label) {
                                includeElement({element: label, depth: depth});
                            });
                            includeElement({element: elem, depth: depth});
                        });
                    }
                });
            }

            forEach(element.labels, function (label) {
                includeElement({element: label, depth: depth});
            });
            getNested([element.attachers, element.incoming, element.outgoing]);
            includeElement({element: element, depth: depth});
            if (nestedChildren) {
                return nestedChildren;
            }
        });
        includedElements = map(includedElements, function (data) {
            return self._executeDescriptors(data);
        });
        includedElements = sortBy(includedElements, function (data) {
            return data.descriptor.priority;
        });
        _elements = map(includedElements, function (data) {
            return data.element;
        });
        forEach(includedElements, function (data) {
            var depth = data.depth;
            if (!self.hasRelations(tree.allShapes, data.element)) {
                return;
            }
            if (!canCopy(_elements, data.element)) {
                return;
            }
            tree.allShapes.push(data.element);
            if (!tree[depth]) {
                tree[depth] = [];
            }
            tree[depth].push(data.descriptor);
        });
        return tree;
    };
    var CopyPasteModule = {
        __depends__: [ClipboardModule, RulesModule, MouseTrackingModule],
        __init__: ['copyPaste'],
        copyPaste: ['type', CopyPaste]
    };

    function setProperties(descriptor, data, properties) {
        forEach(properties, function (property) {
            if (data[property] !== undefined) {
                descriptor[property] = data[property];
            }
        });
    }

    function removeProperties(element, properties) {
        forEach(properties, function (prop) {
            if (element[prop]) {
                delete element[prop];
            }
        });
    }

    function BpmnCopyPaste(bpmnFactory, eventBus, copyPaste, clipboard, canvas, bpmnRules) {
        var helper = new ModelCloneHelper(eventBus, bpmnFactory);
        copyPaste.registerDescriptor(function (element, descriptor) {
            var businessObject = descriptor.oldBusinessObject = getBusinessObject(element);
            var colors = {};
            descriptor.type = element.type;
            setProperties(descriptor, businessObject.di, ['isExpanded']);
            setProperties(colors, businessObject.di, ['fill', 'stroke']);
            descriptor.colors = colors;
            if (element.type === 'label') {
                return descriptor;
            }
            setProperties(descriptor, businessObject, ['processRef', 'triggeredByEvent']);
            if (businessObject.default) {
                descriptor.default = businessObject.default.id;
            }
            return descriptor;
        });
        eventBus.on('element.paste', function (context) {
            var descriptor = context.descriptor, createdElements = context.createdElements, parent = descriptor.parent,
                rootElement = canvas.getRootElement(), oldBusinessObject = descriptor.oldBusinessObject,
                newBusinessObject, source, target, canConnect;
            newBusinessObject = bpmnFactory.create(oldBusinessObject.$type);
            var properties = getProperties(oldBusinessObject.$descriptor);
            properties = filter(properties, function (property) {
                return IGNORED_PROPERTIES.indexOf(property.replace(/bpmn:/, '')) === -1;
            });
            descriptor.businessObject = helper.clone(oldBusinessObject, newBusinessObject, properties);
            if (descriptor.type === 'label') {
                return;
            }
            if (is$1(parent, 'bpmn:Process')) {
                descriptor.parent = is$1(rootElement, 'bpmn:Collaboration') ? rootElement : parent;
            }
            if (descriptor.type === 'bpmn:DataOutputAssociation' || descriptor.type === 'bpmn:DataInputAssociation' || descriptor.type === 'bpmn:MessageFlow') {
                descriptor.parent = rootElement;
            }
            if (is$1(parent, 'bpmn:Lane')) {
                descriptor.parent = parent.parent;
            }
            if (descriptor.waypoints) {
                source = createdElements[descriptor.source];
                target = createdElements[descriptor.target];
                if (source && target) {
                    source = source.element;
                    target = target.element;
                }
                canConnect = bpmnRules.canConnect(source, target);
                if (canConnect) {
                    descriptor.type = canConnect.type;
                }
            }
            delete newBusinessObject.id;
            bpmnFactory._ensureId(newBusinessObject);
            if (descriptor.type === 'bpmn:Participant' && descriptor.processRef) {
                descriptor.processRef = newBusinessObject.processRef = bpmnFactory.create('bpmn:Process');
            }
            setProperties(newBusinessObject, descriptor, ['isExpanded', 'triggeredByEvent']);
            removeProperties(descriptor, ['triggeredByEvent']);
        });
    }

    BpmnCopyPaste.$inject = ['bpmnFactory', 'eventBus', 'copyPaste', 'clipboard', 'canvas', 'bpmnRules'];
    var CopyPasteModule$1 = {
        __depends__: [CopyPasteModule],
        __init__: ['bpmnCopyPaste'],
        bpmnCopyPaste: ['type', BpmnCopyPaste]
    };
    var AXIS_DIMENSIONS = {horizontal: ['x', 'width'], vertical: ['y', 'height']};
    var THRESHOLD$1 = 5;

    function DistributeElements(modeling) {
        this._modeling = modeling;
        this._filters = [];
        this.registerFilter(function (elements, axis, dimension) {
            var elementsSize = 0, numOfShapes = 0, avgDimension;
            forEach(elements, function (element) {
                if (element.waypoints || element.labelTarget) {
                    return;
                }
                elementsSize += element[dimension];
                numOfShapes += 1;
            });
            avgDimension = Math.round(elementsSize / numOfShapes);
            return filter(elements, function (element) {
                return element[dimension] < (avgDimension + 50);
            });
        });
    }

    DistributeElements.$inject = ['modeling'];
    DistributeElements.prototype.registerFilter = function (filterFn) {
        if (typeof filterFn !== 'function') {
            throw new Error('the filter has to be a function');
        }
        this._filters.push(filterFn);
    };
    DistributeElements.prototype.trigger = function (elements, orientation) {
        var modeling = this._modeling;
        var groups, distributableElements;
        if (elements.length < 3) {
            return;
        }
        this._setOrientation(orientation);
        distributableElements = this._filterElements(elements);
        groups = this._createGroups(distributableElements);
        if (groups.length <= 2) {
            return;
        }
        modeling.distributeElements(groups, this._axis, this._dimension);
        return groups;
    };
    DistributeElements.prototype._filterElements = function (elements) {
        var filters = this._filters, axis = this._axis, dimension = this._dimension,
            distributableElements = [].concat(elements);
        if (!filters.length) {
            return elements;
        }
        forEach(filters, function (filterFn) {
            distributableElements = filterFn(distributableElements, axis, dimension);
        });
        return distributableElements;
    };
    DistributeElements.prototype._createGroups = function (elements) {
        var rangeGroups = [], self = this, axis = this._axis, dimension = this._dimension;
        if (!axis) {
            throw new Error('must have a defined "axis" and "dimension"');
        }
        var sortedElements = sortBy(elements, axis);
        forEach(sortedElements, function (element, idx) {
            var elementRange = self._findRange(element, axis, dimension), range;
            var previous = rangeGroups[rangeGroups.length - 1];
            if (previous && self._hasIntersection(previous.range, elementRange)) {
                rangeGroups[rangeGroups.length - 1].elements.push(element);
            } else {
                range = {range: elementRange, elements: [element]};
                rangeGroups.push(range);
            }
        });
        return rangeGroups;
    };
    DistributeElements.prototype._setOrientation = function (direction) {
        var orientation = AXIS_DIMENSIONS[direction];
        this._axis = orientation[0];
        this._dimension = orientation[1];
    };
    DistributeElements.prototype._hasIntersection = function (rangeA, rangeB) {
        return Math.max(rangeA.min, rangeA.max) >= Math.min(rangeB.min, rangeB.max) && Math.min(rangeA.min, rangeA.max) <= Math.max(rangeB.min, rangeB.max);
    };
    DistributeElements.prototype._findRange = function (element) {
        var axis = element[this._axis], dimension = element[this._dimension];
        return {min: axis + THRESHOLD$1, max: axis + dimension - THRESHOLD$1};
    };
    var DistributeElementsModule = {__init__: ['distributeElements'], distributeElements: ['type', DistributeElements]};

    function BpmnDistributeElements(distributeElements) {
        distributeElements.registerFilter(function (elements) {
            return filter(elements, function (element) {
                var cannotDistribute = isAny(element, ['bpmn:Association', 'bpmn:BoundaryEvent', 'bpmn:DataInputAssociation', 'bpmn:DataOutputAssociation', 'bpmn:Lane', 'bpmn:MessageFlow', 'bpmn:Participant', 'bpmn:SequenceFlow', 'bpmn:TextAnnotation']);
                return !(element.labelTarget || cannotDistribute);
            });
        });
    }

    BpmnDistributeElements.$inject = ['distributeElements'];
    var DistributeElementsModule$1 = {
        __depends__: [DistributeElementsModule],
        __init__: ['bpmnDistributeElements'],
        bpmnDistributeElements: ['type', BpmnDistributeElements]
    };
    var NOT_REGISTERED_ERROR = 'is not a registered action', IS_REGISTERED_ERROR = 'is already registered';

    function EditorActions(eventBus, injector) {
        this._actions = {};
        var self = this;
        eventBus.on('diagram.init', function () {
            self._registerDefaultActions(injector);
            eventBus.fire('editorActions.init', {editorActions: self});
        });
    }

    EditorActions.$inject = ['eventBus', 'injector'];
    EditorActions.prototype._registerDefaultActions = function (injector) {
        var commandStack = injector.get('commandStack', false);
        var modeling = injector.get('modeling', false);
        var selection = injector.get('selection', false);
        var zoomScroll = injector.get('zoomScroll', false);
        var copyPaste = injector.get('copyPaste', false);
        var canvas = injector.get('canvas', false);
        var rules = injector.get('rules', false);
        var mouseTracking = injector.get('mouseTracking', false);
        var keyboardMove = injector.get('keyboardMove', false);
        var keyboardMoveSelection = injector.get('keyboardMoveSelection', false);
        if (commandStack) {
            this.register('undo', function () {
                commandStack.undo();
            });
            this.register('redo', function () {
                commandStack.redo();
            });
        }
        if (copyPaste && selection) {
            this.register('copy', function () {
                var selectedElements = selection.get();
                copyPaste.copy(selectedElements);
            });
        }
        if (mouseTracking && copyPaste) {
            this.register('paste', function () {
                var context = mouseTracking.getHoverContext();
                copyPaste.paste(context);
            });
        }
        if (zoomScroll) {
            this.register('stepZoom', function (opts) {
                zoomScroll.stepZoom(opts.value);
            });
        }
        if (canvas) {
            this.register('zoom', function (opts) {
                canvas.zoom(opts.value);
            });
        }
        if (modeling && selection && rules) {
            this.register('removeSelection', function () {
                var selectedElements = selection.get();
                if (!selectedElements.length) {
                    return;
                }
                var allowed = rules.allowed('elements.delete', {elements: selectedElements}), removableElements;
                if (allowed === false) {
                    return;
                } else if (isArray(allowed)) {
                    removableElements = allowed;
                } else {
                    removableElements = selectedElements;
                }
                if (removableElements.length) {
                    modeling.removeElements(removableElements.slice());
                }
            });
        }
        if (keyboardMove) {
            this.register('moveCanvas', function (opts) {
                keyboardMove.moveCanvas(opts);
            });
        }
        if (keyboardMoveSelection) {
            this.register('moveSelection', function (opts) {
                keyboardMoveSelection.moveSelection(opts.direction, opts.accelerated);
            });
        }
    };
    EditorActions.prototype.trigger = function (action, opts) {
        if (!this._actions[action]) {
            throw error$2(action, NOT_REGISTERED_ERROR);
        }
        return this._actions[action](opts);
    };
    EditorActions.prototype.register = function (actions, listener) {
        var self = this;
        if (typeof actions === 'string') {
            return this._registerAction(actions, listener);
        }
        forEach(actions, function (listener, action) {
            self._registerAction(action, listener);
        });
    };
    EditorActions.prototype._registerAction = function (action, listener) {
        if (this.isRegistered(action)) {
            throw error$2(action, IS_REGISTERED_ERROR);
        }
        this._actions[action] = listener;
    };
    EditorActions.prototype.unregister = function (action) {
        if (!this.isRegistered(action)) {
            throw error$2(action, NOT_REGISTERED_ERROR);
        }
        this._actions[action] = undefined;
    };
    EditorActions.prototype.getActions = function () {
        return Object.keys(this._actions);
    };
    EditorActions.prototype.isRegistered = function (action) {
        return !!this._actions[action];
    };

    function error$2(action, message) {
        return new Error(action + ' ' + message);
    }

    var EditorActionsModule = {__init__: ['editorActions'], editorActions: ['type', EditorActions]};

    function BpmnEditorActions(injector) {
        injector.invoke(EditorActions, this);
    }

    inherits_browser(BpmnEditorActions, EditorActions);
    BpmnEditorActions.$inject = ['injector'];
    BpmnEditorActions.prototype._registerDefaultActions = function (injector) {
        EditorActions.prototype._registerDefaultActions.call(this, injector);
        var canvas = injector.get('canvas', false);
        var elementRegistry = injector.get('elementRegistry', false);
        var selection = injector.get('selection', false);
        var spaceTool = injector.get('spaceTool', false);
        var lassoTool = injector.get('lassoTool', false);
        var handTool = injector.get('handTool', false);
        var globalConnect = injector.get('globalConnect', false);
        var distributeElements = injector.get('distributeElements', false);
        var alignElements = injector.get('alignElements', false);
        var directEditing = injector.get('directEditing', false);
        var searchPad = injector.get('searchPad', false);
        var modeling = injector.get('modeling', false);
        if (canvas && elementRegistry && selection) {
            this._registerAction('selectElements', function () {
                var rootElement = canvas.getRootElement();
                var elements = elementRegistry.filter(function (element) {
                    return element !== rootElement;
                });
                selection.select(elements);
                return elements;
            });
        }
        if (spaceTool) {
            this._registerAction('spaceTool', function () {
                spaceTool.toggle();
            });
        }
        if (lassoTool) {
            this._registerAction('lassoTool', function () {
                lassoTool.toggle();
            });
        }
        if (handTool) {
            this._registerAction('handTool', function () {
                handTool.toggle();
            });
        }
        if (globalConnect) {
            this._registerAction('globalConnectTool', function () {
                globalConnect.toggle();
            });
        }
        if (selection && distributeElements) {
            this._registerAction('distributeElements', function (opts) {
                var currentSelection = selection.get(), type = opts.type;
                if (currentSelection.length) {
                    distributeElements.trigger(currentSelection, type);
                }
            });
        }
        if (selection && alignElements) {
            this._registerAction('alignElements', function (opts) {
                var currentSelection = selection.get(), aligneableElements = [], type = opts.type;
                if (currentSelection.length) {
                    aligneableElements = filter(currentSelection, function (element) {
                        return !is$1(element, 'bpmn:Lane');
                    });
                    alignElements.trigger(aligneableElements, type);
                }
            });
        }
        if (selection && modeling) {
            this._registerAction('setColor', function (opts) {
                var currentSelection = selection.get();
                if (currentSelection.length) {
                    modeling.setColor(currentSelection, opts);
                }
            });
        }
        if (selection && directEditing) {
            this._registerAction('directEditing', function () {
                var currentSelection = selection.get();
                if (currentSelection.length) {
                    directEditing.activate(currentSelection[0]);
                }
            });
        }
        if (searchPad) {
            this._registerAction('find', function () {
                searchPad.toggle();
            });
        }
        if (canvas && modeling) {
            this._registerAction('moveToOrigin', function () {
                var rootElement = canvas.getRootElement(), boundingBox, elements;
                if (is$1(rootElement, 'bpmn:Collaboration')) {
                    elements = elementRegistry.filter(function (element) {
                        return is$1(element.parent, 'bpmn:Collaboration');
                    });
                } else {
                    elements = elementRegistry.filter(function (element) {
                        return element !== rootElement && !is$1(element.parent, 'bpmn:SubProcess');
                    });
                }
                boundingBox = getBBox(elements);
                modeling.moveElements(elements, {x: -boundingBox.x, y: -boundingBox.y}, rootElement);
            });
        }
    };
    var EditorActionsModule$1 = {__depends__: [EditorActionsModule], editorActions: ['type', BpmnEditorActions]};

    function BpmnKeyboardBindings(injector) {
        injector.invoke(KeyboardBindings, this);
    }

    inherits_browser(BpmnKeyboardBindings, KeyboardBindings);
    BpmnKeyboardBindings.$inject = ['injector'];
    BpmnKeyboardBindings.prototype.registerBindings = function (keyboard, editorActions) {
        KeyboardBindings.prototype.registerBindings.call(this, keyboard, editorActions);

        function addListener(action, fn) {
            if (editorActions.isRegistered(action)) {
                keyboard.addListener(fn);
            }
        }

        addListener('selectElements', function (context) {
            var event = context.keyEvent;
            if (keyboard.isKey(['a', 'A'], event) && keyboard.isCmd(event)) {
                editorActions.trigger('selectElements');
                return true;
            }
        });
        addListener('find', function (context) {
            var event = context.keyEvent;
            if (keyboard.isKey(['f', 'F'], event) && keyboard.isCmd(event)) {
                editorActions.trigger('find');
                return true;
            }
        });
        addListener('spaceTool', function (context) {
            var event = context.keyEvent;
            if (keyboard.hasModifier(event)) {
                return;
            }
            if (keyboard.isKey(['s', 'S'], event)) {
                editorActions.trigger('spaceTool');
                return true;
            }
        });
        addListener('lassoTool', function (context) {
            var event = context.keyEvent;
            if (keyboard.hasModifier(event)) {
                return;
            }
            if (keyboard.isKey(['l', 'L'], event)) {
                editorActions.trigger('lassoTool');
                return true;
            }
        });
        addListener('handTool', function (context) {
            var event = context.keyEvent;
            if (keyboard.hasModifier(event)) {
                return;
            }
            if (keyboard.isKey(['h', 'H'], event)) {
                editorActions.trigger('handTool');
                return true;
            }
        });
        addListener('globalConnectTool', function (context) {
            var event = context.keyEvent;
            if (keyboard.hasModifier(event)) {
                return;
            }
            if (keyboard.isKey(['c', 'C'], event)) {
                editorActions.trigger('globalConnectTool');
                return true;
            }
        });
        addListener('directEditing', function (context) {
            var event = context.keyEvent;
            if (keyboard.hasModifier(event)) {
                return;
            }
            if (keyboard.isKey(['e', 'E'], event)) {
                editorActions.trigger('directEditing');
                return true;
            }
        });
    };
    var KeyboardModule$1 = {
        __depends__: [KeyboardModule],
        __init__: ['keyboardBindings'],
        keyboardBindings: ['type', BpmnKeyboardBindings]
    };
    var DEFAULT_CONFIG$1 = {moveSpeed: 1, moveSpeedAccelerated: 10};
    var HIGHER_PRIORITY = 1500;
    var LEFT = 'left';
    var UP = 'up';
    var RIGHT = 'right';
    var DOWN = 'down';
    var KEY_TO_DIRECTION = {
        ArrowLeft: LEFT,
        Left: LEFT,
        ArrowUp: UP,
        Up: UP,
        ArrowRight: RIGHT,
        Right: RIGHT,
        ArrowDown: DOWN,
        Down: DOWN
    };
    var DIRECTIONS_DELTA = {
        left: function (speed) {
            return {x: -speed, y: 0};
        }, up: function (speed) {
            return {x: 0, y: -speed};
        }, right: function (speed) {
            return {x: speed, y: 0};
        }, down: function (speed) {
            return {x: 0, y: speed};
        }
    };

    function KeyboardMoveSelection(config, keyboard, modeling, selection) {
        var self = this;
        this._config = assign({}, DEFAULT_CONFIG$1, config || {});
        keyboard.addListener(HIGHER_PRIORITY, function (event) {
            var keyEvent = event.keyEvent;
            var direction = KEY_TO_DIRECTION[keyEvent.key];
            if (!direction) {
                return;
            }
            if (keyboard.isCmd(keyEvent)) {
                return;
            }
            var accelerated = keyboard.isShift(keyEvent);
            self.moveSelection(direction, accelerated);
            return true;
        });
        this.moveSelection = function (direction, accelerated) {
            var selectedElements = selection.get();
            if (!selectedElements.length) {
                return;
            }
            var speed = this._config[accelerated ? 'moveSpeedAccelerated' : 'moveSpeed'];
            var delta = DIRECTIONS_DELTA[direction](speed);
            modeling.moveElements(selectedElements, delta);
        };
    }

    KeyboardMoveSelection.$inject = ['config.keyboardMoveSelection', 'keyboard', 'modeling', 'selection'];
    var KeyboardMoveSelectionModule = {
        __depends__: [KeyboardModule, SelectionModule],
        __init__: ['keyboardMoveSelection'],
        keyboardMoveSelection: ['type', KeyboardMoveSelection]
    };

    function ChangeSupport(eventBus, canvas, elementRegistry, graphicsFactory) {
        eventBus.on('element.changed', function (event) {
            var element = event.element;
            if (element.parent || element === canvas.getRootElement()) {
                event.gfx = elementRegistry.getGraphics(element);
            }
            if (!event.gfx) {
                return;
            }
            eventBus.fire(getType(element) + '.changed', event);
        });
        eventBus.on('elements.changed', function (event) {
            var elements = event.elements;
            elements.forEach(function (e) {
                eventBus.fire('element.changed', {element: e});
            });
            graphicsFactory.updateContainments(elements);
        });
        eventBus.on('shape.changed', function (event) {
            graphicsFactory.update('shape', event.element, event.gfx);
        });
        eventBus.on('connection.changed', function (event) {
            graphicsFactory.update('connection', event.element, event.gfx);
        });
    }

    ChangeSupport.$inject = ['eventBus', 'canvas', 'elementRegistry', 'graphicsFactory'];
    var ChangeSupportModule = {__init__: ['changeSupport'], changeSupport: ['type', ChangeSupport]};

    function PreviewSupport(elementRegistry, canvas, styles) {
        this._elementRegistry = elementRegistry;
        this._canvas = canvas;
        this._styles = styles;
    }

    PreviewSupport.$inject = ['elementRegistry', 'canvas', 'styles'];
    PreviewSupport.prototype.getGfx = function (element) {
        return this._elementRegistry.getGraphics(element);
    };
    PreviewSupport.prototype.addDragger = function (shape, group) {
        var gfx = this.getGfx(shape);
        var dragger = clone(gfx);
        var bbox = gfx.getBoundingClientRect();
        if (isConnection(shape)) {
            removeMarkers(dragger);
        }
        attr$1(dragger, this._styles.cls('djs-dragger', [], {x: bbox.top, y: bbox.left}));
        append(group, dragger);
        return dragger;
    };
    PreviewSupport.prototype.addFrame = function (shape, group) {
        var frame = create('rect', {
            class: 'djs-resize-overlay',
            width: shape.width,
            height: shape.height,
            x: shape.x,
            y: shape.y
        });
        append(group, frame);
        return frame;
    };

    function removeMarkers(gfx) {
        if (gfx.children) {
            forEach(gfx.children, function (child) {
                removeMarkers(child);
            });
        }
        gfx.style.markerStart = '';
        gfx.style.markerEnd = '';
    }

    function isConnection(element) {
        return element.waypoints;
    }

    var PreviewSupportModule = {__init__: ['previewSupport'], previewSupport: ['type', PreviewSupport]};
    var DEFAULT_MIN_WIDTH = 10;

    function Resize(eventBus, rules, modeling, dragging) {
        this._dragging = dragging;
        this._rules = rules;
        var self = this;

        function handleMove(context, delta) {
            var shape = context.shape, direction = context.direction, resizeConstraints = context.resizeConstraints,
                newBounds;
            context.delta = delta;
            newBounds = resizeBounds(shape, direction, delta);
            context.newBounds = ensureConstraints(newBounds, resizeConstraints);
            context.canExecute = self.canResize(context);
        }

        function handleStart(context) {
            var resizeConstraints = context.resizeConstraints, minBounds = context.minBounds;
            if (resizeConstraints !== undefined) {
                return;
            }
            if (minBounds === undefined) {
                minBounds = self.computeMinResizeBox(context);
            }
            context.resizeConstraints = {min: asTRBL(minBounds)};
        }

        function handleEnd(context) {
            var shape = context.shape, canExecute = context.canExecute, newBounds = context.newBounds;
            if (canExecute) {
                newBounds = roundBounds(newBounds);
                modeling.resizeShape(shape, newBounds);
            }
        }

        eventBus.on('resize.start', function (event) {
            handleStart(event.context);
        });
        eventBus.on('resize.move', function (event) {
            var delta = {x: event.dx, y: event.dy};
            handleMove(event.context, delta);
        });
        eventBus.on('resize.end', function (event) {
            handleEnd(event.context);
        });
    }

    Resize.prototype.canResize = function (context) {
        var rules = this._rules;
        var ctx = pick(context, ['newBounds', 'shape', 'delta', 'direction']);
        return rules.allowed('shape.resize', ctx);
    };
    Resize.prototype.activate = function (event, shape, contextOrDirection) {
        var dragging = this._dragging, context, direction;
        if (typeof contextOrDirection === 'string') {
            contextOrDirection = {direction: contextOrDirection};
        }
        context = assign({shape: shape}, contextOrDirection);
        direction = context.direction;
        if (!direction) {
            throw new Error('must provide a direction (nw|se|ne|sw)');
        }
        dragging.init(event, 'resize', {
            autoActivate: true,
            cursor: 'resize-' + (/nw|se/.test(direction) ? 'nwse' : 'nesw'),
            data: {shape: shape, context: context}
        });
    };
    Resize.prototype.computeMinResizeBox = function (context) {
        var shape = context.shape, direction = context.direction, minDimensions, childrenBounds;
        minDimensions = context.minDimensions || {width: DEFAULT_MIN_WIDTH, height: DEFAULT_MIN_WIDTH};
        childrenBounds = computeChildrenBBox(shape, context.childrenBoxPadding);
        return getMinResizeBounds(direction, shape, minDimensions, childrenBounds);
    };
    Resize.$inject = ['eventBus', 'rules', 'modeling', 'dragging'];
    var MARKER_RESIZING = 'djs-resizing', MARKER_RESIZE_NOT_OK = 'resize-not-ok';
    var LOW_PRIORITY$5 = 500;

    function ResizePreview(eventBus, canvas, previewSupport) {
        function updateFrame(context) {
            var shape = context.shape, bounds = context.newBounds, frame = context.frame;
            if (!frame) {
                frame = context.frame = previewSupport.addFrame(shape, canvas.getDefaultLayer());
                canvas.addMarker(shape, MARKER_RESIZING);
            }
            if (bounds.width > 5) {
                attr$1(frame, {x: bounds.x, width: bounds.width});
            }
            if (bounds.height > 5) {
                attr$1(frame, {y: bounds.y, height: bounds.height});
            }
            if (context.canExecute) {
                classes$1(frame).remove(MARKER_RESIZE_NOT_OK);
            } else {
                classes$1(frame).add(MARKER_RESIZE_NOT_OK);
            }
        }

        function removeFrame(context) {
            var shape = context.shape, frame = context.frame;
            if (frame) {
                remove$1(context.frame);
            }
            canvas.removeMarker(shape, MARKER_RESIZING);
        }

        eventBus.on('resize.move', LOW_PRIORITY$5, function (event) {
            updateFrame(event.context);
        });
        eventBus.on('resize.cleanup', function (event) {
            removeFrame(event.context);
        });
    }

    ResizePreview.$inject = ['eventBus', 'canvas', 'previewSupport'];
    var HANDLE_OFFSET = -2, HANDLE_SIZE = 5, HANDLE_HIT_SIZE = 20;
    var CLS_RESIZER = 'djs-resizer';

    function ResizeHandles(eventBus, canvas, selection, resize) {
        this._resize = resize;
        this._canvas = canvas;
        var self = this;
        eventBus.on('selection.changed', function (e) {
            var newSelection = e.newSelection;
            self.removeResizers();
            if (newSelection.length === 1) {
                forEach(newSelection, bind(self.addResizer, self));
            }
        });
        eventBus.on('shape.changed', function (e) {
            var shape = e.element;
            if (selection.isSelected(shape)) {
                self.removeResizers();
                self.addResizer(shape);
            }
        });
    }

    ResizeHandles.prototype.makeDraggable = function (element, gfx, direction) {
        var resize = this._resize;

        function startResize(event$$1) {
            if (isPrimaryButton(event$$1)) {
                resize.activate(event$$1, element, direction);
            }
        }

        componentEvent.bind(gfx, 'mousedown', startResize);
        componentEvent.bind(gfx, 'touchstart', startResize);
    };
    ResizeHandles.prototype._createResizer = function (element, x, y, rotation, direction) {
        var resizersParent = this._getResizersParent();
        var group = create('g');
        classes$1(group).add(CLS_RESIZER);
        classes$1(group).add(CLS_RESIZER + '-' + element.id);
        classes$1(group).add(CLS_RESIZER + '-' + direction);
        append(resizersParent, group);
        var origin = -HANDLE_SIZE + HANDLE_OFFSET;
        var visual = create('rect');
        attr$1(visual, {x: origin, y: origin, width: HANDLE_SIZE, height: HANDLE_SIZE});
        classes$1(visual).add(CLS_RESIZER + '-visual');
        append(group, visual);
        var hit = create('rect');
        attr$1(hit, {x: origin, y: origin, width: HANDLE_HIT_SIZE, height: HANDLE_HIT_SIZE});
        classes$1(hit).add(CLS_RESIZER + '-hit');
        append(group, hit);
        transform$1(group, x, y, rotation);
        return group;
    };
    ResizeHandles.prototype.createResizer = function (element, direction) {
        var resizer;
        var trbl = asTRBL(element);
        if (direction === 'nw') {
            resizer = this._createResizer(element, trbl.left, trbl.top, 0, direction);
        } else if (direction === 'ne') {
            resizer = this._createResizer(element, trbl.right, trbl.top, 90, direction);
        } else if (direction === 'se') {
            resizer = this._createResizer(element, trbl.right, trbl.bottom, 180, direction);
        } else {
            resizer = this._createResizer(element, trbl.left, trbl.bottom, 270, direction);
        }
        this.makeDraggable(element, resizer, direction);
    };
    ResizeHandles.prototype.addResizer = function (shape) {
        var resize = this._resize;
        if (!resize.canResize({shape: shape})) {
            return;
        }
        this.createResizer(shape, 'nw');
        this.createResizer(shape, 'ne');
        this.createResizer(shape, 'se');
        this.createResizer(shape, 'sw');
    };
    ResizeHandles.prototype.removeResizers = function () {
        var resizersParent = this._getResizersParent();
        clear$1(resizersParent);
    };
    ResizeHandles.prototype._getResizersParent = function () {
        return this._canvas.getLayer('resizers');
    };
    ResizeHandles.$inject = ['eventBus', 'canvas', 'selection', 'resize'];
    var ResizeModule = {
        __depends__: [RulesModule, DraggingModule, PreviewSupportModule],
        __init__: ['resize', 'resizePreview', 'resizeHandles'],
        resize: ['type', Resize],
        resizePreview: ['type', ResizePreview],
        resizeHandles: ['type', ResizeHandles]
    };

    function getLabelAttr(semantic) {
        if (is$1(semantic, 'bpmn:FlowElement') || is$1(semantic, 'bpmn:Participant') || is$1(semantic, 'bpmn:Lane') || is$1(semantic, 'bpmn:SequenceFlow') || is$1(semantic, 'bpmn:MessageFlow')) {
            return 'name';
        }
        if (is$1(semantic, 'bpmn:TextAnnotation')) {
            return 'text';
        }
    }

    function getLabel(element) {
        var semantic = element.businessObject, attr = getLabelAttr(semantic);
        if (attr) {
            return semantic[attr] || '';
        }
    }

    function setLabel(element, text, isExternal) {
        var semantic = element.businessObject, attr = getLabelAttr(semantic);
        if (attr) {
            semantic[attr] = text;
        }
        return element;
    }

    function LabelEditingProvider(eventBus, canvas, directEditing, modeling, resizeHandles, textRenderer) {
        this._canvas = canvas;
        this._modeling = modeling;
        this._textRenderer = textRenderer;
        directEditing.registerProvider(this);
        eventBus.on('element.dblclick', function (event) {
            activateDirectEdit(event.element, true);
        });
        eventBus.on(['element.mousedown', 'drag.init', 'canvas.viewbox.changing', 'autoPlace', 'popupMenu.open'], function (event) {
            if (directEditing.isActive()) {
                directEditing.complete();
            }
        });
        eventBus.on(['commandStack.changed'], function (e) {
            if (directEditing.isActive()) {
                directEditing.cancel();
            }
        });
        eventBus.on('directEditing.activate', function (event) {
            resizeHandles.removeResizers();
        });
        eventBus.on('create.end', 500, function (event) {
            var element = event.shape, canExecute = event.context.canExecute, isTouch = event.isTouch;
            if (isTouch) {
                return;
            }
            if (!canExecute) {
                return;
            }
            activateDirectEdit(element);
        });
        eventBus.on('autoPlace.end', 500, function (event) {
            activateDirectEdit(event.shape);
        });

        function activateDirectEdit(element, force) {
            if (force || isAny(element, ['bpmn:Task', 'bpmn:TextAnnotation']) || isCollapsedSubProcess(element)) {
                // directEditing.activate(element);
            }
        }
    }

    LabelEditingProvider.$inject = ['eventBus', 'canvas', 'directEditing', 'modeling', 'resizeHandles', 'textRenderer'];
    LabelEditingProvider.prototype.activate = function (element) {
        var text = getLabel(element);
        if (text === undefined) {
            return;
        }
        var context = {text: text};
        var bounds = this.getEditingBBox(element);
        assign(context, bounds);
        var options = {};
        if (isAny(element, ['bpmn:Task', 'bpmn:Participant', 'bpmn:Lane', 'bpmn:CallActivity']) || isCollapsedSubProcess(element)) {
            assign(options, {centerVertically: true});
        }
        if (isLabelExternal(element)) {
            assign(options, {autoResize: true});
        }
        if (is$1(element, 'bpmn:TextAnnotation')) {
            assign(options, {resizable: true, autoResize: true});
        }
        assign(context, {options: options});
        return context;
    };
    LabelEditingProvider.prototype.getEditingBBox = function (element) {
        var canvas = this._canvas;
        var target = element.label || element;
        var bbox = canvas.getAbsoluteBBox(target);
        var mid = {x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2};
        var bounds = {x: bbox.x, y: bbox.y};
        var zoom = canvas.zoom();
        var defaultStyle = this._textRenderer.getDefaultStyle(), externalStyle = this._textRenderer.getExternalStyle();
        var externalFontSize = externalStyle.fontSize * zoom, externalLineHeight = externalStyle.lineHeight,
            defaultFontSize = defaultStyle.fontSize * zoom, defaultLineHeight = defaultStyle.lineHeight;
        var style = {
            fontFamily: this._textRenderer.getDefaultStyle().fontFamily,
            fontWeight: this._textRenderer.getDefaultStyle().fontWeight
        };
        if (is$1(element, 'bpmn:Lane') || isExpandedPool(element)) {
            assign(bounds, {
                width: bbox.height,
                height: 30 * zoom,
                x: bbox.x - bbox.height / 2 + (15 * zoom),
                y: mid.y - (30 * zoom) / 2
            });
            assign(style, {
                fontSize: defaultFontSize + 'px',
                lineHeight: defaultLineHeight,
                paddingTop: (7 * zoom) + 'px',
                paddingBottom: (7 * zoom) + 'px',
                paddingLeft: (5 * zoom) + 'px',
                paddingRight: (5 * zoom) + 'px',
                transform: 'rotate(-90deg)'
            });
        }
        if (isAny(element, ['bpmn:Task', 'bpmn:CallActivity']) || isCollapsedPool(element) || isCollapsedSubProcess(element)) {
            assign(bounds, {width: bbox.width, height: bbox.height});
            assign(style, {
                fontSize: defaultFontSize + 'px',
                lineHeight: defaultLineHeight,
                paddingTop: (7 * zoom) + 'px',
                paddingBottom: (7 * zoom) + 'px',
                paddingLeft: (5 * zoom) + 'px',
                paddingRight: (5 * zoom) + 'px'
            });
        }
        if (isExpandedSubProcess(element)) {
            assign(bounds, {width: bbox.width, x: bbox.x});
            assign(style, {
                fontSize: defaultFontSize + 'px',
                lineHeight: defaultLineHeight,
                paddingTop: (7 * zoom) + 'px',
                paddingBottom: (7 * zoom) + 'px',
                paddingLeft: (5 * zoom) + 'px',
                paddingRight: (5 * zoom) + 'px'
            });
        }
        var width = 90 * zoom, paddingTop = 7 * zoom, paddingBottom = 4 * zoom;
        if (target.labelTarget) {
            assign(bounds, {
                width: width,
                height: bbox.height + paddingTop + paddingBottom,
                x: mid.x - width / 2,
                y: bbox.y - paddingTop
            });
            assign(style, {
                fontSize: externalFontSize + 'px',
                lineHeight: externalLineHeight,
                paddingTop: paddingTop + 'px',
                paddingBottom: paddingBottom + 'px'
            });
        }
        if (isLabelExternal(target) && !hasExternalLabel(target) && !isLabel(target)) {
            var externalLabelMid = getExternalLabelMid(element);
            var absoluteBBox = canvas.getAbsoluteBBox({
                x: externalLabelMid.x,
                y: externalLabelMid.y,
                width: 0,
                height: 0
            });
            var height = externalFontSize + paddingTop + paddingBottom;
            assign(bounds, {
                width: width,
                height: height,
                x: absoluteBBox.x - width / 2,
                y: absoluteBBox.y - height / 2
            });
            assign(style, {
                fontSize: externalFontSize + 'px',
                lineHeight: externalLineHeight,
                paddingTop: paddingTop + 'px',
                paddingBottom: paddingBottom + 'px'
            });
        }
        if (is$1(element, 'bpmn:TextAnnotation')) {
            assign(bounds, {width: bbox.width, height: bbox.height, minWidth: 30 * zoom, minHeight: 10 * zoom});
            assign(style, {
                textAlign: 'left',
                paddingTop: (5 * zoom) + 'px',
                paddingBottom: (7 * zoom) + 'px',
                paddingLeft: (7 * zoom) + 'px',
                paddingRight: (5 * zoom) + 'px',
                fontSize: defaultFontSize + 'px',
                lineHeight: defaultLineHeight
            });
        }
        return {bounds: bounds, style: style};
    };
    LabelEditingProvider.prototype.update = function (element, newLabel, activeContextText, bounds) {
        var newBounds, bbox;
        if (is$1(element, 'bpmn:TextAnnotation')) {
            bbox = this._canvas.getAbsoluteBBox(element);
            newBounds = {
                x: element.x,
                y: element.y,
                width: element.width / bbox.width * bounds.width,
                height: element.height / bbox.height * bounds.height
            };
        }
        if (isEmptyText(newLabel)) {
            newLabel = null;
        }
        this._modeling.updateLabel(element, newLabel, newBounds);
    };

    function isCollapsedSubProcess(element) {
        return is$1(element, 'bpmn:SubProcess') && !isExpanded(element);
    }

    function isExpandedSubProcess(element) {
        return is$1(element, 'bpmn:SubProcess') && isExpanded(element);
    }

    function isCollapsedPool(element) {
        return is$1(element, 'bpmn:Participant') && !isExpanded(element);
    }

    function isExpandedPool(element) {
        return is$1(element, 'bpmn:Participant') && isExpanded(element);
    }

    function isEmptyText(label) {
        return !label || !label.trim();
    }

    var MARKER_HIDDEN = 'djs-element-hidden', MARKER_LABEL_HIDDEN = 'djs-label-hidden';

    function LabelEditingPreview(eventBus, canvas, elementRegistry, pathMap) {
        var self = this;
        var defaultLayer = canvas.getDefaultLayer();
        var element, absoluteElementBBox, gfx;
        eventBus.on('directEditing.activate', function (context) {
            var activeProvider = context.active;
            element = activeProvider.element.label || activeProvider.element;
            if (is$1(element, 'bpmn:TextAnnotation')) {
                absoluteElementBBox = canvas.getAbsoluteBBox(element);
                gfx = create('g');
                var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {mx: 0.0, my: 0.0}
                });
                var path = self.path = create('path');
                attr$1(path, {d: textPathData, strokeWidth: 1, stroke: getStrokeColor$1(element)});
                append(gfx, path);
                append(defaultLayer, gfx);
                translate(gfx, element.x, element.y);
            }
            if (is$1(element, 'bpmn:TextAnnotation') || element.labelTarget) {
                canvas.addMarker(element, MARKER_HIDDEN);
            } else if (is$1(element, 'bpmn:Task') || is$1(element, 'bpmn:CallActivity') || is$1(element, 'bpmn:SubProcess') || is$1(element, 'bpmn:Participant')) {
                canvas.addMarker(element, MARKER_LABEL_HIDDEN);
            }
        });
        eventBus.on('directEditing.resize', function (context) {
            if (is$1(element, 'bpmn:TextAnnotation')) {
                var height = context.height, dy = context.dy;
                var newElementHeight = Math.max(element.height / absoluteElementBBox.height * (height + dy), 0);
                var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                    xScaleFactor: 1,
                    yScaleFactor: 1,
                    containerWidth: element.width,
                    containerHeight: newElementHeight,
                    position: {mx: 0.0, my: 0.0}
                });
                attr$1(self.path, {d: textPathData});
            }
        });
        eventBus.on(['directEditing.complete', 'directEditing.cancel'], function (context) {
            var activeProvider = context.active;
            if (activeProvider) {
                canvas.removeMarker(activeProvider.element.label || activeProvider.element, MARKER_HIDDEN);
                canvas.removeMarker(element, MARKER_LABEL_HIDDEN);
            }
            element = undefined;
            absoluteElementBBox = undefined;
            if (gfx) {
                remove$1(gfx);
                gfx = undefined;
            }
        });
    }

    LabelEditingPreview.$inject = ['eventBus', 'canvas', 'elementRegistry', 'pathMap'];

    function getStrokeColor$1(element, defaultColor) {
        var bo = getBusinessObject(element);
        return bo.di.get('stroke') || defaultColor || 'black';
    }

    var LabelEditingModule = {
        __depends__: [ChangeSupportModule, ResizeModule, DirectEditingModule],
        __init__: ['labelEditingProvider', 'labelEditingPreview'],
        labelEditingProvider: ['type', LabelEditingProvider],
        labelEditingPreview: ['type', LabelEditingPreview]
    };

    function AdaptiveLabelPositioningBehavior(eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);
        this.postExecuted(['connection.create', 'connection.layout', 'connection.reconnectEnd', 'connection.reconnectStart', 'connection.updateWaypoints'], function (event) {
            var context = event.context, connection = context.connection;
            var source = connection.source, target = connection.target;
            checkLabelAdjustment(source);
            checkLabelAdjustment(target);
        });
        this.postExecuted(['label.create'], function (event) {
            checkLabelAdjustment(event.context.shape.labelTarget);
        });

        function checkLabelAdjustment(element) {
            if (!hasExternalLabel(element)) {
                return;
            }
            var optimalPosition = getOptimalPosition(element);
            if (!optimalPosition) {
                return;
            }
            adjustLabelPosition(element, optimalPosition);
        }

        var ELEMENT_LABEL_DISTANCE = 10;

        function adjustLabelPosition(element, orientation) {
            var elementMid = getMid(element), label = element.label, labelMid = getMid(label);
            var elementTrbl = asTRBL(element);
            var newLabelMid;
            switch (orientation) {
                case'top':
                    newLabelMid = {x: elementMid.x, y: elementTrbl.top - ELEMENT_LABEL_DISTANCE - label.height / 2};
                    break;
                case'left':
                    newLabelMid = {x: elementTrbl.left - ELEMENT_LABEL_DISTANCE - label.width / 2, y: elementMid.y};
                    break;
                case'bottom':
                    newLabelMid = {x: elementMid.x, y: elementTrbl.bottom + ELEMENT_LABEL_DISTANCE + label.height / 2};
                    break;
                case'right':
                    newLabelMid = {x: elementTrbl.right + ELEMENT_LABEL_DISTANCE + label.width / 2, y: elementMid.y};
                    break;
            }
            var delta$$1 = delta(newLabelMid, labelMid);
            modeling.moveShape(label, delta$$1);
        }
    }

    inherits_browser(AdaptiveLabelPositioningBehavior, CommandInterceptor);
    AdaptiveLabelPositioningBehavior.$inject = ['eventBus', 'modeling'];

    function getOptimalPosition(element) {
        var labelMid = getMid(element.label);
        var elementMid = getMid(element);
        var labelOrientation = getApproximateOrientation(elementMid, labelMid);
        if (!isAligned(labelOrientation)) {
            return;
        }
        var takenAlignments = [].concat(element.incoming.map(function (c) {
            return c.waypoints[c.waypoints.length - 2];
        }), element.outgoing.map(function (c) {
            return c.waypoints[1];
        })).map(function (point) {
            return getApproximateOrientation(elementMid, point);
        });
        var freeAlignments = ALIGNMENTS.filter(function (alignment) {
            return takenAlignments.indexOf(alignment) === -1;
        });
        if (freeAlignments.indexOf(labelOrientation) !== -1) {
            return;
        }
        return freeAlignments[0];
    }

    var ALIGNMENTS = ['top', 'bottom', 'left', 'right'];

    function getApproximateOrientation(p0, p1) {
        return getOrientation(p1, p0, 5);
    }

    function isAligned(orientation) {
        return ALIGNMENTS.indexOf(orientation) !== -1;
    }

    function AppendBehavior(eventBus, elementFactory, bpmnRules) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.append', function (context) {
            var source = context.source, shape = context.shape;
            if (!context.position) {
                if (is$1(shape, 'bpmn:TextAnnotation')) {
                    context.position = {x: source.x + source.width / 2 + 75, y: source.y - (50) - shape.height / 2};
                } else {
                    context.position = {
                        x: source.x + source.width + 80 + shape.width / 2,
                        y: source.y + source.height / 2
                    };
                }
            }
        }, true);
    }

    inherits_browser(AppendBehavior, CommandInterceptor);
    AppendBehavior.$inject = ['eventBus', 'elementFactory', 'bpmnRules'];

    function BoundaryEventBehavior(eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);

        function getBoundaryEvents(element) {
            return filter(element.attachers, function (attacher) {
                return is$1(attacher, 'bpmn:BoundaryEvent');
            });
        }

        this.postExecute('connection.create', function (event) {
            var source = event.context.source, target = event.context.target,
                boundaryEvents = getBoundaryEvents(target);
            if (is$1(source, 'bpmn:EventBasedGateway') && is$1(target, 'bpmn:ReceiveTask') && boundaryEvents.length > 0) {
                modeling.removeElements(boundaryEvents);
            }
        });
        this.postExecute('connection.reconnectStart', function (event) {
            var oldSource = event.context.oldSource, newSource = event.context.newSource;
            if (is$1(oldSource, 'bpmn:Gateway') && is$1(newSource, 'bpmn:EventBasedGateway')) {
                forEach(newSource.outgoing, function (connection) {
                    var target = connection.target, attachedboundaryEvents = getBoundaryEvents(target);
                    if (is$1(target, 'bpmn:ReceiveTask') && attachedboundaryEvents.length > 0) {
                        modeling.removeElements(attachedboundaryEvents);
                    }
                });
            }
        });
    }

    BoundaryEventBehavior.$inject = ['eventBus', 'modeling'];
    inherits_browser(BoundaryEventBehavior, CommandInterceptor);

    function CopyPasteBehavior(eventBus, modeling, canvas) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('elements.paste', 1500, function (context) {
            var topParent = context.topParent;
            if (!topParent.parent) {
                context.topParent = canvas.getRootElement();
            }
            if (is$1(topParent, 'bpmn:Lane')) {
                do {
                    topParent = context.topParent = topParent.parent;
                } while (is$1(topParent, 'bpmn:Lane') || !is$1(topParent, 'bpmn:Participant'));
            }
        }, true);
        this.postExecute('elements.paste', function (context) {
            var tree = context.tree, createdElements = tree.createdElements;
            forEach(createdElements, function (data) {
                var element = data.element, businessObject = element.businessObject, descriptor = data.descriptor,
                    defaultFlow;
                if ((is$1(businessObject, 'bpmn:ExclusiveGateway') || is$1(businessObject, 'bpmn:InclusiveGateway') || is$1(businessObject, 'bpmn:Activity')) && descriptor.default) {
                    defaultFlow = createdElements[descriptor.default];
                    if (defaultFlow) {
                        defaultFlow = defaultFlow.element;
                    } else {
                        defaultFlow = undefined;
                    }
                    delete element.default;
                    modeling.updateProperties(element, {default: defaultFlow});
                }
            });
        }, true);
    }

    CopyPasteBehavior.$inject = ['eventBus', 'modeling', 'canvas'];
    inherits_browser(CopyPasteBehavior, CommandInterceptor);

    function CreateBoundaryEventBehavior(eventBus, modeling, elementFactory, bpmnFactory) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.create', function (context) {
            var shape = context.shape, host = context.host, businessObject, boundaryEvent;
            var attrs = {cancelActivity: true};
            if (host && is$1(shape, 'bpmn:IntermediateThrowEvent')) {
                attrs.attachedToRef = host.businessObject;
                businessObject = bpmnFactory.create('bpmn:BoundaryEvent', attrs);
                boundaryEvent = {type: 'bpmn:BoundaryEvent', businessObject: businessObject};
                context.shape = elementFactory.createShape(boundaryEvent);
            }
        }, true);
    }

    CreateBoundaryEventBehavior.$inject = ['eventBus', 'modeling', 'elementFactory', 'bpmnFactory'];
    inherits_browser(CreateBoundaryEventBehavior, CommandInterceptor);

    function CreateDataObjectBehavior(eventBus, bpmnFactory, moddle) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.create', function (event) {
            var context = event.context, shape = context.shape;
            if (is$1(shape, 'bpmn:DataObjectReference') && shape.type !== 'label') {
                var dataObject = bpmnFactory.create('bpmn:DataObject');
                shape.businessObject.dataObjectRef = dataObject;
            }
        });
    }

    CreateDataObjectBehavior.$inject = ['eventBus', 'bpmnFactory', 'moddle'];
    inherits_browser(CreateDataObjectBehavior, CommandInterceptor);

    function CreateParticipantBehavior(eventBus, modeling, elementFactory, bpmnFactory, canvas) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.create', function (context) {
            var parent = context.parent, shape = context.shape, position = context.position;
            var rootElement = canvas.getRootElement();
            if (is$1(parent, 'bpmn:Process') && is$1(shape, 'bpmn:Participant') && !is$1(rootElement, 'bpmn:Collaboration')) {
                var collaborationElement = modeling.makeCollaboration();
                context.position = position;
                context.parent = collaborationElement;
                context.processRoot = parent;
            }
        }, true);
        this.execute('shape.create', function (context) {
            var processRoot = context.processRoot, shape = context.shape;
            if (processRoot) {
                context.oldProcessRef = shape.businessObject.processRef;
                shape.businessObject.processRef = processRoot.businessObject;
            }
        }, true);
        this.revert('shape.create', function (context) {
            var processRoot = context.processRoot, shape = context.shape;
            if (processRoot) {
                shape.businessObject.processRef = context.oldProcessRef;
            }
        }, true);
        this.postExecute('shape.create', function (context) {
            var processRoot = context.processRoot, shape = context.shape;
            if (processRoot) {
                var processChildren = processRoot.children.slice();
                modeling.moveElements(processChildren, {x: 0, y: 0}, shape);
            }
        }, true);
    }

    CreateParticipantBehavior.$inject = ['eventBus', 'modeling', 'elementFactory', 'bpmnFactory', 'canvas'];
    inherits_browser(CreateParticipantBehavior, CommandInterceptor);
    var TARGET_REF_PLACEHOLDER_NAME = '__targetRef_placeholder';

    function DataInputAssociationBehavior(eventBus, bpmnFactory) {
        CommandInterceptor.call(this, eventBus);
        this.executed(['connection.create', 'connection.delete', 'connection.move', 'connection.reconnectEnd'], ifDataInputAssociation(fixTargetRef));
        this.reverted(['connection.create', 'connection.delete', 'connection.move', 'connection.reconnectEnd'], ifDataInputAssociation(fixTargetRef));

        function usesTargetRef(element, targetRef, removedConnection) {
            var inputAssociations = element.get('dataInputAssociations');
            return find(inputAssociations, function (association) {
                return association !== removedConnection && association.targetRef === targetRef;
            });
        }

        function getTargetRef(element, create) {
            var properties = element.get('properties');
            var targetRefProp = find(properties, function (p) {
                return p.name === TARGET_REF_PLACEHOLDER_NAME;
            });
            if (!targetRefProp && create) {
                targetRefProp = bpmnFactory.create('bpmn:Property', {name: TARGET_REF_PLACEHOLDER_NAME});
                add(properties, targetRefProp);
            }
            return targetRefProp;
        }

        function cleanupTargetRef(element, connection) {
            var targetRefProp = getTargetRef(element);
            if (!targetRefProp) {
                return;
            }
            if (!usesTargetRef(element, targetRefProp, connection)) {
                remove$2(element.get('properties'), targetRefProp);
            }
        }

        function fixTargetRef(event) {
            var context = event.context, connection = context.connection, connectionBo = connection.businessObject,
                target = connection.target, targetBo = target && target.businessObject, newTarget = context.newTarget,
                newTargetBo = newTarget && newTarget.businessObject, oldTarget = context.oldTarget || context.target,
                oldTargetBo = oldTarget && oldTarget.businessObject;
            var dataAssociation = connection.businessObject, targetRefProp;
            if (oldTargetBo && oldTargetBo !== targetBo) {
                cleanupTargetRef(oldTargetBo, connectionBo);
            }
            if (newTargetBo && newTargetBo !== targetBo) {
                cleanupTargetRef(newTargetBo, connectionBo);
            }
            if (targetBo) {
                targetRefProp = getTargetRef(targetBo, true);
                dataAssociation.targetRef = targetRefProp;
            } else {
                dataAssociation.targetRef = null;
            }
        }
    }

    DataInputAssociationBehavior.$inject = ['eventBus', 'bpmnFactory'];
    inherits_browser(DataInputAssociationBehavior, CommandInterceptor);

    function ifDataInputAssociation(fn) {
        return function (event) {
            var context = event.context, connection = context.connection;
            if (is$1(connection, 'bpmn:DataInputAssociation')) {
                return fn(event);
            }
        };
    }

    function UpdateSemanticParentHandler(bpmnUpdater) {
        this._bpmnUpdater = bpmnUpdater;
    }

    UpdateSemanticParentHandler.$inject = ['bpmnUpdater'];
    UpdateSemanticParentHandler.prototype.execute = function (context) {
        var dataStoreBo = context.dataStoreBo, newSemanticParent = context.newSemanticParent,
            newDiParent = context.newDiParent;
        context.oldSemanticParent = dataStoreBo.$parent;
        context.oldDiParent = dataStoreBo.di.$parent;
        this._bpmnUpdater.updateSemanticParent(dataStoreBo, newSemanticParent);
        this._bpmnUpdater.updateDiParent(dataStoreBo.di, newDiParent);
    };
    UpdateSemanticParentHandler.prototype.revert = function (context) {
        var dataStoreBo = context.dataStoreBo, oldSemanticParent = context.oldSemanticParent,
            oldDiParent = context.oldDiParent;
        this._bpmnUpdater.updateSemanticParent(dataStoreBo, oldSemanticParent);
        this._bpmnUpdater.updateDiParent(dataStoreBo.di, oldDiParent);
    };

    function DataStoreBehavior(canvas, commandStack, elementRegistry, eventBus) {
        CommandInterceptor.call(this, eventBus);
        commandStack.registerHandler('dataStore.updateContainment', UpdateSemanticParentHandler);

        function getFirstParticipant() {
            return elementRegistry.filter(function (element) {
                return is$1(element, 'bpmn:Participant');
            })[0];
        }

        function getDataStores(element) {
            return element.children.filter(function (child) {
                return is$1(child, 'bpmn:DataStoreReference') && !child.labelTarget;
            });
        }

        function updateDataStoreParent(dataStore, newDataStoreParent) {
            var dataStoreBo = dataStore.businessObject || dataStore;
            newDataStoreParent = newDataStoreParent || getFirstParticipant();
            if (newDataStoreParent) {
                var newDataStoreParentBo = newDataStoreParent.businessObject || newDataStoreParent;
                commandStack.execute('dataStore.updateContainment', {
                    dataStoreBo: dataStoreBo,
                    newSemanticParent: newDataStoreParentBo.processRef || newDataStoreParentBo,
                    newDiParent: newDataStoreParentBo.di
                });
            }
        }

        this.preExecute('shape.create', function (event) {
            var context = event.context, shape = context.shape;
            if (is$1(shape, 'bpmn:DataStoreReference') && shape.type !== 'label') {
                if (!context.hints) {
                    context.hints = {};
                }
                context.hints.autoResize = false;
            }
        });
        this.preExecute('elements.move', function (event) {
            var context = event.context, shapes = context.shapes;
            var dataStoreReferences = shapes.filter(function (shape) {
                return is$1(shape, 'bpmn:DataStoreReference');
            });
            if (dataStoreReferences.length) {
                if (!context.hints) {
                    context.hints = {};
                }
                context.hints.autoResize = shapes.filter(function (shape) {
                    return !is$1(shape, 'bpmn:DataStoreReference');
                });
            }
        });
        this.postExecute('shape.create', function (event) {
            var context = event.context, shape = context.shape, parent = shape.parent;
            if (is$1(shape, 'bpmn:DataStoreReference') && shape.type !== 'label' && is$1(parent, 'bpmn:Collaboration')) {
                updateDataStoreParent(shape);
            }
        });
        this.postExecute('shape.move', function (event) {
            var context = event.context, shape = context.shape, oldParent = context.oldParent, parent = shape.parent;
            if (is$1(oldParent, 'bpmn:Collaboration')) {
                return;
            }
            if (is$1(shape, 'bpmn:DataStoreReference') && shape.type !== 'label' && is$1(parent, 'bpmn:Collaboration')) {
                var participant = is$1(oldParent, 'bpmn:Participant') ? oldParent : getAncestor(oldParent, 'bpmn:Participant');
                updateDataStoreParent(shape, participant);
            }
        });
        this.postExecute('shape.delete', function (event) {
            var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
            if (isAny(shape, ['bpmn:Participant', 'bpmn:SubProcess']) && is$1(rootElement, 'bpmn:Collaboration')) {
                getDataStores(rootElement).filter(function (dataStore) {
                    return isDescendant(dataStore, shape);
                }).forEach(function (dataStore) {
                    updateDataStoreParent(dataStore);
                });
            }
        });
        this.postExecute('canvas.updateRoot', function (event) {
            var context = event.context, oldRoot = context.oldRoot, newRoot = context.newRoot;
            var dataStores = getDataStores(oldRoot);
            dataStores.forEach(function (dataStore) {
                if (is$1(newRoot, 'bpmn:Process')) {
                    updateDataStoreParent(dataStore, newRoot);
                }
            });
        });
    }

    DataStoreBehavior.$inject = ['canvas', 'commandStack', 'elementRegistry', 'eventBus',];
    inherits_browser(DataStoreBehavior, CommandInterceptor);

    function isDescendant(descendant, ancestor) {
        var descendantBo = descendant.businessObject || descendant, ancestorBo = ancestor.businessObject || ancestor;
        while (descendantBo.$parent) {
            if (descendantBo.$parent === ancestorBo.processRef || ancestorBo) {
                return true;
            }
            descendantBo = descendantBo.$parent;
        }
        return false;
    }

    function getAncestor(element, type) {
        while (element.parent) {
            if (is$1(element.parent, type)) {
                return element.parent;
            }
            element = element.parent;
        }
    }

    var LOW_PRIORITY$6 = 500;

    function DeleteLaneBehavior(eventBus, modeling, spaceTool) {
        CommandInterceptor.call(this, eventBus);

        function compensateLaneDelete(shape, oldParent) {
            var siblings = getChildLanes(oldParent);
            var topAffected = [];
            var bottomAffected = [];
            eachElement(siblings, function (element) {
                if (element.y > shape.y) {
                    bottomAffected.push(element);
                } else {
                    topAffected.push(element);
                }
                return element.children;
            });
            if (!siblings.length) {
                return;
            }
            var offset;
            if (bottomAffected.length && topAffected.length) {
                offset = shape.height / 2;
            } else {
                offset = shape.height;
            }
            var topAdjustments, bottomAdjustments;
            if (topAffected.length) {
                topAdjustments = spaceTool.calculateAdjustments(topAffected, 'y', offset, shape.y - 10);
                spaceTool.makeSpace(topAdjustments.movingShapes, topAdjustments.resizingShapes, {x: 0, y: offset}, 's');
            }
            if (bottomAffected.length) {
                bottomAdjustments = spaceTool.calculateAdjustments(bottomAffected, 'y', -offset, shape.y + shape.height + 10);
                spaceTool.makeSpace(bottomAdjustments.movingShapes, bottomAdjustments.resizingShapes, {
                    x: 0,
                    y: -offset
                }, 'n');
            }
        }

        this.postExecuted('shape.delete', LOW_PRIORITY$6, function (event) {
            var context = event.context, hints = context.hints, shape = context.shape, oldParent = context.oldParent;
            if (!is$1(shape, 'bpmn:Lane')) {
                return;
            }
            if (hints && hints.nested) {
                return;
            }
            compensateLaneDelete(shape, oldParent);
        });
    }

    DeleteLaneBehavior.$inject = ['eventBus', 'modeling', 'spaceTool'];
    inherits_browser(DeleteLaneBehavior, CommandInterceptor);

    function DropOnFlowBehavior(eventBus, bpmnRules, modeling) {
        CommandInterceptor.call(this, eventBus);

        function insertShape(shape, targetFlow, position) {
            var waypoints = targetFlow.waypoints, waypointsBefore, waypointsAfter, dockingPoint, source, target,
                incomingConnection, outgoingConnection, oldOutgoing = shape.outgoing.slice(),
                oldIncoming = shape.incoming.slice();
            var intersection = getApproxIntersection(waypoints, position);
            if (intersection) {
                waypointsBefore = waypoints.slice(0, intersection.index);
                waypointsAfter = waypoints.slice(intersection.index + (intersection.bendpoint ? 1 : 0));
                if (!waypointsBefore.length || !waypointsAfter.length) {
                    return;
                }
                dockingPoint = intersection.bendpoint ? waypoints[intersection.index] : position;
                if (!isPointInsideBBox$2(shape, waypointsBefore[waypointsBefore.length - 1])) {
                    waypointsBefore.push(copy(dockingPoint));
                }
                if (!isPointInsideBBox$2(shape, waypointsAfter[0])) {
                    waypointsAfter.unshift(copy(dockingPoint));
                }
            }
            source = targetFlow.source;
            target = targetFlow.target;
            if (bpmnRules.canConnect(source, shape, targetFlow)) {
                modeling.reconnectEnd(targetFlow, shape, waypointsBefore || position);
                incomingConnection = targetFlow;
            }
            if (bpmnRules.canConnect(shape, target, targetFlow)) {
                if (!incomingConnection) {
                    modeling.reconnectStart(targetFlow, shape, waypointsAfter || position);
                    outgoingConnection = targetFlow;
                } else {
                    outgoingConnection = modeling.connect(shape, target, {
                        type: targetFlow.type,
                        waypoints: waypointsAfter
                    });
                }
            }
            var duplicateConnections = [].concat(incomingConnection && filter(oldIncoming, function (connection) {
                return connection.source === incomingConnection.source;
            }) || [], outgoingConnection && filter(oldOutgoing, function (connection) {
                return connection.source === outgoingConnection.source;
            }) || []);
            if (duplicateConnections.length) {
                modeling.removeElements(duplicateConnections);
            }
        }

        this.preExecute('elements.move', function (context) {
            var newParent = context.newParent, shapes = context.shapes, delta = context.delta, shape = shapes[0];
            if (!shape || !newParent) {
                return;
            }
            if (newParent && newParent.waypoints) {
                context.newParent = newParent = newParent.parent;
            }
            var shapeMid = getMid$1(shape);
            var newShapeMid = {x: shapeMid.x + delta.x, y: shapeMid.y + delta.y};
            var connection = find(newParent.children, function (element) {
                var canInsert = bpmnRules.canInsert(shapes, element);
                return canInsert && getApproxIntersection(element.waypoints, newShapeMid);
            });
            if (connection) {
                context.targetFlow = connection;
                context.position = newShapeMid;
            }
        }, true);
        this.postExecuted('elements.move', function (context) {
            var shapes = context.shapes, targetFlow = context.targetFlow, position = context.position;
            if (targetFlow) {
                insertShape(shapes[0], targetFlow, position);
            }
        }, true);
        this.preExecute('shape.create', function (context) {
            var parent = context.parent, shape = context.shape;
            if (bpmnRules.canInsert(shape, parent)) {
                context.targetFlow = parent;
                context.parent = parent.parent;
            }
        }, true);
        this.postExecuted('shape.create', function (context) {
            var shape = context.shape, targetFlow = context.targetFlow, position = context.position;
            if (targetFlow) {
                insertShape(shape, targetFlow, position);
            }
        }, true);
    }

    inherits_browser(DropOnFlowBehavior, CommandInterceptor);
    DropOnFlowBehavior.$inject = ['eventBus', 'bpmnRules', 'modeling'];

    function isPointInsideBBox$2(bbox, point) {
        var x = point.x, y = point.y;
        return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }

    function copy(obj) {
        return assign({}, obj);
    }

    function getMid$1(bounds) {
        return {x: Math.round(bounds.x + bounds.width / 2), y: Math.round(bounds.y + bounds.height / 2)};
    }

    function lineIntersect(l1s, l1e, l2s, l2e) {
        var denominator, a, b, c, numerator;
        denominator = ((l2e.y - l2s.y) * (l1e.x - l1s.x)) - ((l2e.x - l2s.x) * (l1e.y - l1s.y));
        if (denominator == 0) {
            return null;
        }
        a = l1s.y - l2s.y;
        b = l1s.x - l2s.x;
        numerator = ((l2e.x - l2s.x) * a) - ((l2e.y - l2s.y) * b);
        c = numerator / denominator;
        return {x: Math.round(l1s.x + (c * (l1e.x - l1s.x))), y: Math.round(l1s.y + (c * (l1e.y - l1s.y)))};
    }

    function ImportDockingFix(eventBus) {
        function adjustDocking(startPoint, nextPoint, elementMid) {
            var elementTop = {x: elementMid.x, y: elementMid.y - 50};
            var elementLeft = {x: elementMid.x - 50, y: elementMid.y};
            var verticalIntersect = lineIntersect(startPoint, nextPoint, elementMid, elementTop),
                horizontalIntersect = lineIntersect(startPoint, nextPoint, elementMid, elementLeft);
            var centerIntersect;
            if (verticalIntersect && horizontalIntersect) {
                if (getDistance(verticalIntersect, elementMid) > getDistance(horizontalIntersect, elementMid)) {
                    centerIntersect = horizontalIntersect;
                } else {
                    centerIntersect = verticalIntersect;
                }
            } else {
                centerIntersect = verticalIntersect || horizontalIntersect;
            }
            startPoint.original = centerIntersect;
        }

        function fixDockings(connection) {
            var waypoints = connection.waypoints;
            adjustDocking(waypoints[0], waypoints[1], getMid(connection.source));
            adjustDocking(waypoints[waypoints.length - 1], waypoints[waypoints.length - 2], getMid(connection.target));
        }

        eventBus.on('bpmnElement.added', function (e) {
            var element = e.element;
            if (element.waypoints) {
                fixDockings(element);
            }
        });
    }

    ImportDockingFix.$inject = ['eventBus'];

    function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    }

    function vectorLength(v) {
        return Math.sqrt(Math.pow(v.x, 2) + Math.pow(v.y, 2));
    }

    function getAngle(line) {
        return Math.atan((line[1].y - line[0].y) / (line[1].x - line[0].x));
    }

    function rotateVector(vector, angle) {
        return (!angle) ? vector : {
            x: Math.cos(angle) * vector.x - Math.sin(angle) * vector.y,
            y: Math.sin(angle) * vector.x + Math.cos(angle) * vector.y
        };
    }

    function getDistancePointPoint(point1, point2) {
        return vectorLength({x: point1.x - point2.x, y: point1.y - point2.y});
    }

    var sqrt = Math.sqrt, min$2 = Math.min, max$3 = Math.max, abs$3 = Math.abs;

    function sq(n) {
        return Math.pow(n, 2);
    }

    function getDistance$1(p1, p2) {
        return sqrt(sq(p1.x - p2.x) + sq(p1.y - p2.y));
    }

    function getAttachment(point, line) {
        var idx = 0, segmentStart, segmentEnd, segmentStartDistance, segmentEndDistance, attachmentPosition,
            minDistance, intersections, attachment, attachmentDistance, closestAttachmentDistance, closestAttachment;
        for (idx = 0; idx < line.length - 1; idx++) {
            segmentStart = line[idx];
            segmentEnd = line[idx + 1];
            if (pointsEqual(segmentStart, segmentEnd)) {
                intersections = [segmentStart];
            } else {
                segmentStartDistance = getDistance$1(point, segmentStart);
                segmentEndDistance = getDistance$1(point, segmentEnd);
                minDistance = min$2(segmentStartDistance, segmentEndDistance);
                intersections = getCircleSegmentIntersections(segmentStart, segmentEnd, point, minDistance);
            }
            if (intersections.length < 1) {
                throw new Error('expected between [1, 2] circle -> line intersections');
            }
            if (intersections.length === 1) {
                attachment = {
                    type: 'bendpoint',
                    position: intersections[0],
                    segmentIndex: idx,
                    bendpointIndex: pointsEqual(segmentStart, intersections[0]) ? idx : idx + 1
                };
            }
            if (intersections.length === 2) {
                attachmentPosition = mid(intersections[0], intersections[1]);
                attachment = {
                    type: 'segment',
                    position: attachmentPosition,
                    segmentIndex: idx,
                    relativeLocation: getDistance$1(segmentStart, attachmentPosition) / getDistance$1(segmentStart, segmentEnd)
                };
            }
            attachmentDistance = getDistance$1(attachment.position, point);
            if (!closestAttachment || closestAttachmentDistance > attachmentDistance) {
                closestAttachment = attachment;
                closestAttachmentDistance = attachmentDistance;
            }
        }
        return closestAttachment;
    }

    function getCircleSegmentIntersections(s1, s2, cc, cr) {
        var baX = s2.x - s1.x;
        var baY = s2.y - s1.y;
        var caX = cc.x - s1.x;
        var caY = cc.y - s1.y;
        var a = baX * baX + baY * baY;
        var bBy2 = baX * caX + baY * caY;
        var c = caX * caX + caY * caY - cr * cr;
        var pBy2 = bBy2 / a;
        var q = c / a;
        var disc = pBy2 * pBy2 - q;
        if (disc < 0 && disc > -0.000001) {
            disc = 0;
        }
        if (disc < 0) {
            return [];
        }
        var tmpSqrt = sqrt(disc);
        var abScalingFactor1 = -pBy2 + tmpSqrt;
        var abScalingFactor2 = -pBy2 - tmpSqrt;
        var i1 = {x: s1.x - baX * abScalingFactor1, y: s1.y - baY * abScalingFactor1};
        if (disc === 0) {
            return [i1];
        }
        var i2 = {x: s1.x - baX * abScalingFactor2, y: s1.y - baY * abScalingFactor2};
        return [i1, i2].filter(function (p) {
            return isPointInSegment(p, s1, s2);
        });
    }

    function isPointInSegment(p, segmentStart, segmentEnd) {
        return (fenced(p.x, segmentStart.x, segmentEnd.x) && fenced(p.y, segmentStart.y, segmentEnd.y));
    }

    function fenced(n, rangeStart, rangeEnd) {
        return (n >= min$2(rangeStart, rangeEnd) - EQUAL_THRESHOLD && n <= max$3(rangeStart, rangeEnd) + EQUAL_THRESHOLD);
    }

    function mid(p1, p2) {
        return {x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2};
    }

    var EQUAL_THRESHOLD = 0.1;

    function pointsEqual(p1, p2) {
        return (abs$3(p1.x - p2.x) <= EQUAL_THRESHOLD && abs$3(p1.y - p2.y) <= EQUAL_THRESHOLD);
    }

    function findNewLabelLineStartIndex(oldWaypoints, newWaypoints, attachment, hints) {
        var index = attachment.segmentIndex;
        var offset = newWaypoints.length - oldWaypoints.length;
        if (hints.segmentMove) {
            var oldSegmentStartIndex = hints.segmentMove.segmentStartIndex,
                newSegmentStartIndex = hints.segmentMove.newSegmentStartIndex;
            if (index === oldSegmentStartIndex) {
                return newSegmentStartIndex;
            }
            if (index >= newSegmentStartIndex) {
                return (index + offset < newSegmentStartIndex) ? newSegmentStartIndex : index + offset;
            }
            return index;
        }
        if (hints.bendpointMove) {
            var insert = hints.bendpointMove.insert, bendpointIndex = hints.bendpointMove.bendpointIndex, newIndex;
            if (offset === 0) {
                return index;
            }
            if (index >= bendpointIndex) {
                newIndex = insert ? index + 1 : index - 1;
            }
            if (index < bendpointIndex) {
                newIndex = index;
                if (insert && attachment.type !== 'bendpoint' && bendpointIndex - 1 === index) {
                    var rel = relativePositionMidWaypoint(newWaypoints, bendpointIndex);
                    if (rel < attachment.relativeLocation) {
                        newIndex++;
                    }
                }
            }
            return newIndex;
        }
        if (offset === 0) {
            return index;
        }
        if (hints.connectionStart) {
            return (index === 0) ? 0 : null;
        }
        if (hints.connectionEnd) {
            return (index === oldWaypoints.length - 2) ? newWaypoints.length - 2 : null;
        }
        return null;
    }

    function getLabelAdjustment(label, newWaypoints, oldWaypoints, hints) {
        var x = 0, y = 0;
        var labelPosition = getLabelMid(label);
        var attachment = getAttachment(labelPosition, oldWaypoints), oldLabelLineIndex = attachment.segmentIndex,
            newLabelLineIndex = findNewLabelLineStartIndex(oldWaypoints, newWaypoints, attachment, hints);
        if (newLabelLineIndex === null) {
            return {x: x, y: y};
        }
        if (newLabelLineIndex < 0 || newLabelLineIndex > newWaypoints.length - 2) {
            return {x: x, y: y};
        }
        var oldLabelLine = getLine(oldWaypoints, oldLabelLineIndex),
            newLabelLine = getLine(newWaypoints, newLabelLineIndex), oldFoot = attachment.position;
        var relativeFootPosition = getRelativeFootPosition(oldLabelLine, oldFoot),
            angleDelta = getAngleDelta(oldLabelLine, newLabelLine);
        if (attachment.type === 'bendpoint') {
            var offset = newWaypoints.length - oldWaypoints.length, oldBendpointIndex = attachment.bendpointIndex,
                oldBendpoint = oldWaypoints[oldBendpointIndex];
            if (newWaypoints.indexOf(oldBendpoint) !== -1) {
                return {x: x, y: y};
            }
            if (offset === 0) {
                var newBendpoint = newWaypoints[oldBendpointIndex];
                return {x: newBendpoint.x - attachment.position.x, y: newBendpoint.y - attachment.position.y};
            }
            if (offset < 0 && oldBendpointIndex !== 0 && oldBendpointIndex < oldWaypoints.length - 1) {
                relativeFootPosition = relativePositionMidWaypoint(oldWaypoints, oldBendpointIndex);
            }
        }
        var newFoot = {
            x: (newLabelLine[1].x - newLabelLine[0].x) * relativeFootPosition + newLabelLine[0].x,
            y: (newLabelLine[1].y - newLabelLine[0].y) * relativeFootPosition + newLabelLine[0].y
        };
        var newLabelVector = rotateVector({x: labelPosition.x - oldFoot.x, y: labelPosition.y - oldFoot.y}, angleDelta);
        x = newFoot.x + newLabelVector.x - labelPosition.x;
        y = newFoot.y + newLabelVector.y - labelPosition.y;
        return roundPoint({x: x, y: y});
    }

    function relativePositionMidWaypoint(waypoints, idx) {
        var distanceSegment1 = getDistancePointPoint(waypoints[idx - 1], waypoints[idx]),
            distanceSegment2 = getDistancePointPoint(waypoints[idx], waypoints[idx + 1]);
        var relativePosition = distanceSegment1 / (distanceSegment1 + distanceSegment2);
        return relativePosition;
    }

    function getLabelMid(label) {
        return {x: label.x + label.width / 2, y: label.y + label.height / 2};
    }

    function getAngleDelta(l1, l2) {
        var a1 = getAngle(l1), a2 = getAngle(l2);
        return a2 - a1;
    }

    function getLine(waypoints, idx) {
        return [waypoints[idx], waypoints[idx + 1]];
    }

    function getRelativeFootPosition(line, foot) {
        var length = getDistancePointPoint(line[0], line[1]), lengthToFoot = getDistancePointPoint(line[0], foot);
        return length === 0 ? 0 : lengthToFoot / length;
    }

    var DEFAULT_LABEL_DIMENSIONS = {width: 90, height: 20};
    var NAME_PROPERTY = 'name';
    var TEXT_PROPERTY = 'text';

    function LabelBehavior(eventBus, modeling, bpmnFactory, textRenderer) {
        CommandInterceptor.call(this, eventBus);
        this.postExecute('element.updateProperties', function (e) {
            var context = e.context, element = context.element, properties = context.properties;
            if (NAME_PROPERTY in properties) {
                modeling.updateLabel(element, properties[NAME_PROPERTY]);
            }
            if (TEXT_PROPERTY in properties && is$1(element, 'bpmn:TextAnnotation')) {
                var newBounds = textRenderer.getTextAnnotationBounds({
                    x: element.x,
                    y: element.y,
                    width: element.width,
                    height: element.height
                }, properties[TEXT_PROPERTY] || '');
                modeling.updateLabel(element, properties.text, newBounds);
            }
        });
        this.postExecute(['shape.create', 'connection.create'], function (e) {
            var context = e.context;
            var element = context.shape || context.connection, businessObject = element.businessObject;
            if (!isLabelExternal(element)) {
                return;
            }
            if (!businessObject.name) {
                return;
            }
            var labelCenter = getExternalLabelMid(element);
            var labelDimensions = textRenderer.getExternalLabelBounds(DEFAULT_LABEL_DIMENSIONS, businessObject.name || '');
            modeling.createLabel(element, labelCenter, {
                id: businessObject.id + '_label',
                businessObject: businessObject,
                width: labelDimensions.width,
                height: labelDimensions.height
            });
        });
        this.postExecute('shape.delete', function (event) {
            var context = event.context, labelTarget = context.labelTarget, hints = context.hints || {};
            if (labelTarget && hints.unsetLabel !== false) {
                modeling.updateLabel(labelTarget, null, null, {removeShape: false});
            }
        });
        this.postExecute(['label.create'], function (event) {
            var context = event.context, element = context.shape, businessObject, di;
            if (!element.labelTarget) {
                return;
            }
            if (!is$1(element.labelTarget || element, 'bpmn:BaseElement')) {
                return;
            }
            businessObject = element.businessObject, di = businessObject.di;
            if (!di.label) {
                di.label = bpmnFactory.create('bpmndi:BPMNLabel', {bounds: bpmnFactory.create('dc:Bounds')});
            }
            assign(di.label.bounds, {x: element.x, y: element.y, width: element.width, height: element.height});
        });

        function getVisibleLabelAdjustment(event) {
            var command = event.command, context = event.context, connection = context.connection,
                label = connection.label, hints = assign({}, context.hints),
                newWaypoints = context.newWaypoints || connection.waypoints, oldWaypoints = context.oldWaypoints;
            if (typeof hints.startChanged === 'undefined') {
                hints.startChanged = (command === 'connection.reconnectStart');
            }
            if (typeof hints.endChanged === 'undefined') {
                hints.endChanged = (command === 'connection.reconnectEnd');
            }
            return getLabelAdjustment(label, newWaypoints, oldWaypoints, hints);
        }

        this.postExecute(['connection.layout', 'connection.reconnectEnd', 'connection.reconnectStart', 'connection.updateWaypoints'], function (event) {
            var label = event.context.connection.label, labelAdjustment;
            if (!label) {
                return;
            }
            labelAdjustment = getVisibleLabelAdjustment(event);
            modeling.moveShape(label, labelAdjustment);
        });
        this.postExecute(['shape.replace'], function (event) {
            var context = event.context, newShape = context.newShape, oldShape = context.oldShape;
            var businessObject = getBusinessObject(newShape);
            if (businessObject && isLabelExternal(businessObject) && oldShape.label && newShape.label) {
                newShape.label.x = oldShape.label.x;
                newShape.label.y = oldShape.label.y;
            }
        });
    }

    inherits_browser(LabelBehavior, CommandInterceptor);
    LabelBehavior.$inject = ['eventBus', 'modeling', 'bpmnFactory', 'textRenderer'];
    var COLLAB_ERR_MSG = 'flow elements must be children of pools/participants',
        PROCESS_ERR_MSG = 'participants cannot be pasted onto a non-empty process diagram';

    function ModelingFeedback(eventBus, tooltips, translate) {
        function showError(position, message, timeout) {
            tooltips.add({
                position: {x: position.x + 5, y: position.y + 5},
                type: 'error',
                timeout: timeout || 2000,
                html: '<div>' + message + '</div>'
            });
        }

        eventBus.on(['shape.move.rejected', 'create.rejected'], function (event) {
            var context = event.context, shape = context.shape, target = context.target;
            if (is$1(target, 'bpmn:Collaboration') && is$1(shape, 'bpmn:FlowNode')) {
                showError(event, translate(COLLAB_ERR_MSG));
            }
        });
        eventBus.on(['elements.paste.rejected'], function (event) {
            var context = event.context, position = context.position, target = context.target;
            if (is$1(target, 'bpmn:Collaboration')) {
                showError(position, translate(COLLAB_ERR_MSG));
            }
            if (is$1(target, 'bpmn:Process')) {
                showError(position, translate(PROCESS_ERR_MSG), 3000);
            }
        });
    }

    ModelingFeedback.$inject = ['eventBus', 'tooltips', 'translate'];

    function ReplaceConnectionBehavior(eventBus, modeling, bpmnRules) {
        CommandInterceptor.call(this, eventBus);

        function fixConnection(connection) {
            var source = connection.source, target = connection.target, parent = connection.parent;
            if (!parent) {
                return;
            }
            var replacementType, remove;
            if (is$1(connection, 'bpmn:SequenceFlow')) {
                if (!bpmnRules.canConnectSequenceFlow(source, target)) {
                    remove = true;
                }
                if (bpmnRules.canConnectMessageFlow(source, target)) {
                    replacementType = 'bpmn:MessageFlow';
                }
            }
            if (is$1(connection, 'bpmn:MessageFlow')) {
                if (!bpmnRules.canConnectMessageFlow(source, target)) {
                    remove = true;
                }
                if (bpmnRules.canConnectSequenceFlow(source, target)) {
                    replacementType = 'bpmn:SequenceFlow';
                }
            }
            if (is$1(connection, 'bpmn:Association') && !bpmnRules.canConnectAssociation(source, target)) {
                remove = true;
            }
            if (remove) {
                modeling.removeConnection(connection);
            }
            if (replacementType) {
                modeling.connect(source, target, {type: replacementType, waypoints: connection.waypoints.slice()});
            }
        }

        this.postExecuted('elements.move', function (context) {
            var closure = context.closure, allConnections = closure.allConnections;
            forEach(allConnections, fixConnection);
        }, true);
        this.postExecuted(['connection.reconnectStart', 'connection.reconnectEnd'], function (event) {
            var connection = event.context.connection;
            fixConnection(connection);
        });
        this.postExecuted('element.updateProperties', function (event) {
            var context = event.context, properties = context.properties, element = context.element,
                businessObject = element.businessObject, connection;
            if (properties.default) {
                connection = find(element.outgoing, matchPattern({id: element.businessObject.default.id}));
                if (connection) {
                    modeling.updateProperties(connection, {conditionExpression: undefined});
                }
            }
            if (properties.conditionExpression && businessObject.sourceRef.default === businessObject) {
                modeling.updateProperties(element.source, {default: undefined});
            }
        });
    }

    inherits_browser(ReplaceConnectionBehavior, CommandInterceptor);
    ReplaceConnectionBehavior.$inject = ['eventBus', 'modeling', 'bpmnRules'];

    function RemoveParticipantBehavior(eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.delete', function (context) {
            var shape = context.shape, parent = shape.parent;
            if (is$1(shape, 'bpmn:Participant')) {
                context.collaborationRoot = parent;
            }
        }, true);
        this.postExecute('shape.delete', function (context) {
            var collaborationRoot = context.collaborationRoot;
            if (collaborationRoot && !collaborationRoot.businessObject.participants.length) {
                modeling.makeProcess();
            }
        }, true);
    }

    RemoveParticipantBehavior.$inject = ['eventBus', 'modeling'];
    inherits_browser(RemoveParticipantBehavior, CommandInterceptor);

    function ReplaceElementBehaviour(eventBus, bpmnReplace, bpmnRules, elementRegistry, selection, modeling) {
        CommandInterceptor.call(this, eventBus);
        this._bpmnReplace = bpmnReplace;
        this._elementRegistry = elementRegistry;
        this._selection = selection;
        this._modeling = modeling;
        this.postExecuted(['elements.move'], 500, function (event) {
            var context = event.context, target = context.newParent, newHost = context.newHost, elements = [];
            forEach(context.closure.topLevel, function (topLevelElements) {
                if (isEventSubProcess(topLevelElements)) {
                    elements = elements.concat(topLevelElements.children);
                } else {
                    elements = elements.concat(topLevelElements);
                }
            });
            if (elements.length === 1 && newHost) {
                target = newHost;
            }
            var canReplace = bpmnRules.canReplace(elements, target);
            if (canReplace) {
                this.replaceElements(elements, canReplace.replacements, newHost);
            }
        }, this);
        this.postExecute(['shape.replace'], 1500, function (e) {
            var context = e.context, oldShape = context.oldShape, newShape = context.newShape,
                attachers = oldShape.attachers, canReplace;
            if (attachers && attachers.length) {
                canReplace = bpmnRules.canReplace(attachers, newShape);
                this.replaceElements(attachers, canReplace.replacements);
            }
        }, this);
        this.postExecuted(['shape.replace'], 1500, function (e) {
            var context = e.context, oldShape = context.oldShape, newShape = context.newShape;
            modeling.unclaimId(oldShape.businessObject.id, oldShape.businessObject);
            modeling.updateProperties(newShape, {id: oldShape.id});
        });
    }

    inherits_browser(ReplaceElementBehaviour, CommandInterceptor);
    ReplaceElementBehaviour.prototype.replaceElements = function (elements, newElements, newHost) {
        var elementRegistry = this._elementRegistry, bpmnReplace = this._bpmnReplace, selection = this._selection,
            modeling = this._modeling;
        forEach(newElements, function (replacement) {
            var newElement = {type: replacement.newElementType};
            var oldElement = elementRegistry.get(replacement.oldElementId);
            if (newHost && is$1(oldElement, 'bpmn:BoundaryEvent')) {
                modeling.updateAttachment(oldElement, null);
            }
            var idx = elements.indexOf(oldElement);
            elements[idx] = bpmnReplace.replaceElement(oldElement, newElement, {select: false});
            if (newHost && is$1(elements[idx], 'bpmn:BoundaryEvent')) {
                modeling.updateAttachment(elements[idx], newHost);
            }
        });
        if (newElements) {
            selection.select(elements);
        }
    };
    ReplaceElementBehaviour.$inject = ['eventBus', 'bpmnReplace', 'bpmnRules', 'elementRegistry', 'selection', 'modeling'];
    var SLIGHTLY_HIGHER_PRIORITY = 1001;

    function ResizeLaneBehavior(eventBus, modeling) {
        eventBus.on('resize.start', SLIGHTLY_HIGHER_PRIORITY + 500, function (event) {
            var context = event.context, shape = context.shape;
            if (is$1(shape, 'bpmn:Lane') || is$1(shape, 'bpmn:Participant')) {
                context.balanced = !hasPrimaryModifier(event);
            }
        });
        eventBus.on('resize.end', SLIGHTLY_HIGHER_PRIORITY, function (event) {
            var context = event.context, shape = context.shape, canExecute = context.canExecute,
                newBounds = context.newBounds;
            if (is$1(shape, 'bpmn:Lane') || is$1(shape, 'bpmn:Participant')) {
                if (canExecute) {
                    newBounds = roundBounds(newBounds);
                    modeling.resizeLane(shape, newBounds, context.balanced);
                }
                return false;
            }
        });
    }

    ResizeLaneBehavior.$inject = ['eventBus', 'modeling'];

    function RemoveElementBehavior(eventBus, bpmnRules, modeling) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('shape.delete', function (e) {
            var shape = e.context.shape;
            if (shape.incoming.length !== 1 || shape.outgoing.length !== 1) {
                return;
            }
            var inConnection = shape.incoming[0], outConnection = shape.outgoing[0];
            if (!is$1(inConnection, 'bpmn:SequenceFlow') || !is$1(outConnection, 'bpmn:SequenceFlow')) {
                return;
            }
            if (bpmnRules.canConnect(inConnection.source, outConnection.target, inConnection)) {
                var newWaypoints = getNewWaypoints(inConnection.waypoints, outConnection.waypoints);
                modeling.reconnectEnd(inConnection, outConnection.target, newWaypoints);
            }
        });
    }

    inherits_browser(RemoveElementBehavior, CommandInterceptor);
    RemoveElementBehavior.$inject = ['eventBus', 'bpmnRules', 'modeling'];

    function getDocking$1(point) {
        return point.original || point;
    }

    function getNewWaypoints(inWaypoints, outWaypoints) {
        var intersection = lineIntersect(getDocking$1(inWaypoints[inWaypoints.length - 2]), getDocking$1(inWaypoints[inWaypoints.length - 1]), getDocking$1(outWaypoints[1]), getDocking$1(outWaypoints[0]));
        if (intersection) {
            return [].concat(inWaypoints.slice(0, inWaypoints.length - 1), [intersection], outWaypoints.slice(1));
        } else {
            return [getDocking$1(inWaypoints[0]), getDocking$1(outWaypoints[outWaypoints.length - 1])];
        }
    }

    var LOW_PRIORITY$7 = 500;

    function ToggleElementCollapseBehaviour(eventBus, elementFactory, modeling, resize) {
        CommandInterceptor.call(this, eventBus);

        function hideEmptyLables(children) {
            if (children.length) {
                children.forEach(function (child) {
                    if (child.type === 'label' && !child.businessObject.name) {
                        child.hidden = true;
                    }
                });
            }
        }

        function expandedBounds(shape, defaultSize) {
            var children = shape.children, newBounds = defaultSize, visibleElements, visibleBBox;
            visibleElements = filterVisible(children).concat([shape]);
            visibleBBox = computeChildrenBBox(visibleElements);
            if (visibleBBox) {
                newBounds.width = Math.max(visibleBBox.width, newBounds.width);
                newBounds.height = Math.max(visibleBBox.height, newBounds.height);
                newBounds.x = visibleBBox.x + (visibleBBox.width - newBounds.width) / 2;
                newBounds.y = visibleBBox.y + (visibleBBox.height - newBounds.height) / 2;
            } else {
                newBounds.x = shape.x + (shape.width - newBounds.width) / 2;
                newBounds.y = shape.y + (shape.height - newBounds.height) / 2;
            }
            return newBounds;
        }

        function collapsedBounds(shape, defaultSize) {
            return {
                x: shape.x + (shape.width - defaultSize.width) / 2,
                y: shape.y + (shape.height - defaultSize.height) / 2,
                width: defaultSize.width,
                height: defaultSize.height
            };
        }

        this.executed(['shape.toggleCollapse'], LOW_PRIORITY$7, function (e) {
            var context = e.context, shape = context.shape;
            if (!is$1(shape, 'bpmn:SubProcess')) {
                return;
            }
            if (!shape.collapsed) {
                hideEmptyLables(shape.children);
                getBusinessObject(shape).di.isExpanded = true;
            } else {
                getBusinessObject(shape).di.isExpanded = false;
            }
        });
        this.reverted(['shape.toggleCollapse'], LOW_PRIORITY$7, function (e) {
            var context = e.context;
            var shape = context.shape;
            if (!shape.collapsed) {
                getBusinessObject(shape).di.isExpanded = true;
            } else {
                getBusinessObject(shape).di.isExpanded = false;
            }
        });
        this.postExecuted(['shape.toggleCollapse'], LOW_PRIORITY$7, function (e) {
            var shape = e.context.shape, defaultSize = elementFactory._getDefaultSize(shape), newBounds;
            if (shape.collapsed) {
                newBounds = collapsedBounds(shape, defaultSize);
            } else {
                newBounds = expandedBounds(shape, defaultSize);
            }
            modeling.resizeShape(shape, newBounds);
        });
    }

    inherits_browser(ToggleElementCollapseBehaviour, CommandInterceptor);
    ToggleElementCollapseBehaviour.$inject = ['eventBus', 'elementFactory', 'modeling'];

    function filterVisible(elements) {
        return elements.filter(function (e) {
            return !e.hidden;
        });
    }

    function UnclaimIdBehavior(eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('elements.delete', function (event) {
            var context = event.context, elements = context.elements;
            forEach(elements, function (element) {
                modeling.unclaimId(element.businessObject.id, element.businessObject);
            });
        });
    }

    inherits_browser(UnclaimIdBehavior, CommandInterceptor);
    UnclaimIdBehavior.$inject = ['eventBus', 'modeling'];
    var LOW_PRIORITY$8 = 500, HIGH_PRIORITY = 5000;

    function UpdateFlowNodeRefsBehavior(eventBus, modeling, translate) {
        CommandInterceptor.call(this, eventBus);
        var context;

        function initContext() {
            context = context || new UpdateContext();
            context.enter();
            return context;
        }

        function getContext() {
            if (!context) {
                throw new Error(translate('out of bounds release'));
            }
            return context;
        }

        function releaseContext() {
            if (!context) {
                throw new Error(translate('out of bounds release'));
            }
            var triggerUpdate = context.leave();
            if (triggerUpdate) {
                modeling.updateLaneRefs(context.flowNodes, context.lanes);
                context = null;
            }
            return triggerUpdate;
        }

        var laneRefUpdateEvents = ['spaceTool', 'lane.add', 'lane.resize', 'lane.split', 'elements.move', 'elements.delete', 'shape.create', 'shape.delete', 'shape.move', 'shape.resize'];
        this.preExecute(laneRefUpdateEvents, HIGH_PRIORITY, function (event) {
            initContext();
        });
        this.postExecuted(laneRefUpdateEvents, LOW_PRIORITY$8, function (event) {
            releaseContext();
        });
        this.preExecute(['shape.create', 'shape.move', 'shape.delete', 'shape.resize'], function (event) {
            var context = event.context, shape = context.shape;
            var updateContext = getContext();
            if (shape.labelTarget) {
                return;
            }
            if (is$1(shape, 'bpmn:Lane')) {
                updateContext.addLane(shape);
            }
            if (is$1(shape, 'bpmn:FlowNode')) {
                updateContext.addFlowNode(shape);
            }
        });
    }

    UpdateFlowNodeRefsBehavior.$inject = ['eventBus', 'modeling', 'translate'];
    inherits_browser(UpdateFlowNodeRefsBehavior, CommandInterceptor);

    function UpdateContext() {
        this.flowNodes = [];
        this.lanes = [];
        this.counter = 0;
        this.addLane = function (lane) {
            this.lanes.push(lane);
        };
        this.addFlowNode = function (flowNode) {
            this.flowNodes.push(flowNode);
        };
        this.enter = function () {
            this.counter++;
        };
        this.leave = function () {
            this.counter--;
            return !this.counter;
        };
    }

    function DeleteSequenceFlowBehavior(eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);
        this.preExecute('connection.delete', function (event) {
            var context = event.context, connection = context.connection, source = connection.source;
            if (isDefaultFlow(connection, source)) {
                modeling.updateProperties(source, {'default': null});
            }
        });
    }

    inherits_browser(DeleteSequenceFlowBehavior, CommandInterceptor);
    DeleteSequenceFlowBehavior.$inject = ['eventBus', 'modeling'];

    function isDefaultFlow(connection, source) {
        if (!is$1(connection, 'bpmn:SequenceFlow')) {
            return false;
        }
        var sourceBo = getBusinessObject(source), sequenceFlow = getBusinessObject(connection);
        return sourceBo.get('default') === sequenceFlow;
    }

    var BehaviorModule = {
        __init__: ['adaptiveLabelPositioningBehavior', 'appendBehavior', 'boundaryEventBehavior', 'copyPasteBehavior', 'createBoundaryEventBehavior', 'createDataObjectBehavior', 'dataStoreBehavior', 'createParticipantBehavior', 'dataInputAssociationBehavior', 'deleteLaneBehavior', 'dropOnFlowBehavior', 'importDockingFix', 'labelBehavior', 'modelingFeedback', 'removeElementBehavior', 'removeParticipantBehavior', 'replaceConnectionBehavior', 'replaceElementBehaviour', 'resizeLaneBehavior', 'toggleElementCollapseBehaviour', 'unclaimIdBehavior', 'unsetDefaultFlowBehavior', 'updateFlowNodeRefsBehavior'],
        adaptiveLabelPositioningBehavior: ['type', AdaptiveLabelPositioningBehavior],
        appendBehavior: ['type', AppendBehavior],
        boundaryEventBehavior: ['type', BoundaryEventBehavior],
        copyPasteBehavior: ['type', CopyPasteBehavior],
        createBoundaryEventBehavior: ['type', CreateBoundaryEventBehavior],
        createDataObjectBehavior: ['type', CreateDataObjectBehavior],
        createParticipantBehavior: ['type', CreateParticipantBehavior],
        dataInputAssociationBehavior: ['type', DataInputAssociationBehavior],
        dataStoreBehavior: ['type', DataStoreBehavior],
        deleteLaneBehavior: ['type', DeleteLaneBehavior],
        dropOnFlowBehavior: ['type', DropOnFlowBehavior],
        importDockingFix: ['type', ImportDockingFix],
        labelBehavior: ['type', LabelBehavior],
        modelingFeedback: ['type', ModelingFeedback],
        replaceConnectionBehavior: ['type', ReplaceConnectionBehavior],
        removeParticipantBehavior: ['type', RemoveParticipantBehavior],
        replaceElementBehaviour: ['type', ReplaceElementBehaviour],
        resizeLaneBehavior: ['type', ResizeLaneBehavior],
        removeElementBehavior: ['type', RemoveElementBehavior],
        toggleElementCollapseBehaviour: ['type', ToggleElementCollapseBehaviour],
        unclaimIdBehavior: ['type', UnclaimIdBehavior],
        updateFlowNodeRefsBehavior: ['type', UpdateFlowNodeRefsBehavior],
        unsetDefaultFlowBehavior: ['type', DeleteSequenceFlowBehavior]
    };

    function getBoundaryAttachment(position, targetBounds) {
        var orientation = getOrientation(position, targetBounds, -15);
        if (orientation !== 'intersect') {
            return orientation;
        } else {
            return null;
        }
    }

    var abs$4 = Math.abs, min$3 = Math.min, max$4 = Math.max;

    function addToTrbl(trbl, attr, value, choice) {
        var current = trbl[attr];
        trbl[attr] = current === undefined ? value : choice(value, current);
    }

    function addMin(trbl, attr, value) {
        return addToTrbl(trbl, attr, value, min$3);
    }

    function addMax(trbl, attr, value) {
        return addToTrbl(trbl, attr, value, max$4);
    }

    var LANE_MIN_HEIGHT = 60, LANE_MIN_WIDTH = 300, LANE_RIGHT_PADDING = 20, LANE_LEFT_PADDING = 50,
        LANE_TOP_PADDING = 20, LANE_BOTTOM_PADDING = 20;

    function getParticipantSizeConstraints(laneShape, resizeDirection, balanced) {
        var lanesRoot = getLanesRoot(laneShape);
        var isFirst = true, isLast = true;
        var allLanes = collectLanes(lanesRoot, [lanesRoot]);
        var laneTrbl = asTRBL(laneShape);
        var maxTrbl = {}, minTrbl = {};
        if (/e/.test(resizeDirection)) {
            minTrbl.right = laneTrbl.left + LANE_MIN_WIDTH;
        } else if (/w/.test(resizeDirection)) {
            minTrbl.left = laneTrbl.right - LANE_MIN_WIDTH;
        }
        allLanes.forEach(function (other) {
            var otherTrbl = asTRBL(other);
            if (/n/.test(resizeDirection)) {
                if (otherTrbl.top < (laneTrbl.top - 10)) {
                    isFirst = false;
                }
                if (balanced && abs$4(laneTrbl.top - otherTrbl.bottom) < 10) {
                    addMax(maxTrbl, 'top', otherTrbl.top + LANE_MIN_HEIGHT);
                }
                if (abs$4(laneTrbl.top - otherTrbl.top) < 5) {
                    addMin(minTrbl, 'top', otherTrbl.bottom - LANE_MIN_HEIGHT);
                }
            }
            if (/s/.test(resizeDirection)) {
                if (otherTrbl.bottom > (laneTrbl.bottom + 10)) {
                    isLast = false;
                }
                if (balanced && abs$4(laneTrbl.bottom - otherTrbl.top) < 10) {
                    addMin(maxTrbl, 'bottom', otherTrbl.bottom - LANE_MIN_HEIGHT);
                }
                if (abs$4(laneTrbl.bottom - otherTrbl.bottom) < 5) {
                    addMax(minTrbl, 'bottom', otherTrbl.top + LANE_MIN_HEIGHT);
                }
            }
        });
        var flowElements = lanesRoot.children.filter(function (s) {
            return !s.hidden && !s.waypoints && (is$1(s, 'bpmn:FlowElement') || is$1(s, 'bpmn:Artifact'));
        });
        flowElements.forEach(function (flowElement) {
            var flowElementTrbl = asTRBL(flowElement);
            if (isFirst && /n/.test(resizeDirection)) {
                addMin(minTrbl, 'top', flowElementTrbl.top - LANE_TOP_PADDING);
            }
            if (/e/.test(resizeDirection)) {
                addMax(minTrbl, 'right', flowElementTrbl.right + LANE_RIGHT_PADDING);
            }
            if (isLast && /s/.test(resizeDirection)) {
                addMax(minTrbl, 'bottom', flowElementTrbl.bottom + LANE_BOTTOM_PADDING);
            }
            if (/w/.test(resizeDirection)) {
                addMin(minTrbl, 'left', flowElementTrbl.left - LANE_LEFT_PADDING);
            }
        });
        return {min: minTrbl, max: maxTrbl};
    }

    function BpmnRules(eventBus) {
        RuleProvider.call(this, eventBus);
    }

    inherits_browser(BpmnRules, RuleProvider);
    BpmnRules.$inject = ['eventBus'];
    BpmnRules.prototype.init = function () {
        this.addRule('connection.start', function (context) {
            var source = context.source;
            return canStartConnection(source);
        });
        this.addRule('connection.create', function (context) {
            var source = context.source, target = context.target, hints = context.hints || {},
                targetParent = hints.targetParent, targetAttach = hints.targetAttach;
            if (targetAttach) {
                return false;
            }
            if (targetParent) {
                target.parent = targetParent;
            }
            try {
                return canConnect(source, target);
            } finally {
                if (targetParent) {
                    target.parent = null;
                }
            }
        });
        this.addRule('connection.reconnectStart', function (context) {
            var connection = context.connection, source = context.hover || context.source, target = connection.target;
            return canConnect(source, target, connection);
        });
        this.addRule('connection.reconnectEnd', function (context) {
            var connection = context.connection, source = connection.source, target = context.hover || context.target;
            return canConnect(source, target, connection);
        });
        this.addRule('connection.updateWaypoints', function (context) {
            return null;
        });
        this.addRule('shape.resize', function (context) {
            var shape = context.shape, newBounds = context.newBounds;
            return canResize(shape, newBounds);
        });
        this.addRule('elements.move', function (context) {
            var target = context.target, shapes = context.shapes, position = context.position;
            return canAttach(shapes, target, null, position) || canReplace(shapes, target, position) || canMove(shapes, target, position) || canInsert(shapes, target, position);
        });
        this.addRule('shape.create', function (context) {
            return canCreate(context.shape, context.target, context.source, context.position);
        });
        this.addRule('shape.attach', function (context) {
            return canAttach(context.shape, context.target, null, context.position);
        });
        this.addRule('element.copy', function (context) {
            var collection = context.collection, element = context.element;
            return canCopy(collection, element);
        });
        this.addRule('element.paste', function (context) {
            var parent = context.parent, element = context.element, position = context.position,
                source = context.source, target = context.target;
            if (source || target) {
                return canConnect(source, target);
            }
            return canAttach([element], parent, null, position) || canCreate(element, parent, null, position);
        });
        this.addRule('elements.paste', function (context) {
            var tree = context.tree, target = context.target;
            return canPaste(tree, target);
        });
    };
    BpmnRules.prototype.canConnectMessageFlow = canConnectMessageFlow;
    BpmnRules.prototype.canConnectSequenceFlow = canConnectSequenceFlow;
    BpmnRules.prototype.canConnectDataAssociation = canConnectDataAssociation;
    BpmnRules.prototype.canConnectAssociation = canConnectAssociation;
    BpmnRules.prototype.canMove = canMove;
    BpmnRules.prototype.canAttach = canAttach;
    BpmnRules.prototype.canReplace = canReplace;
    BpmnRules.prototype.canDrop = canDrop;
    BpmnRules.prototype.canInsert = canInsert;
    BpmnRules.prototype.canCreate = canCreate;
    BpmnRules.prototype.canConnect = canConnect;
    BpmnRules.prototype.canResize = canResize;
    BpmnRules.prototype.canCopy = canCopy;

    function canStartConnection(element) {
        if (nonExistingOrLabel(element)) {
            return null;
        }
        return isAny(element, ['bpmn:FlowNode', 'bpmn:InteractionNode', 'bpmn:DataObjectReference', 'bpmn:DataStoreReference']);
    }

    function nonExistingOrLabel(element) {
        return !element || isLabel(element);
    }

    function isSame(a, b) {
        return a === b;
    }

    function getOrganizationalParent(element) {
        do {
            if (is$1(element, 'bpmn:Process')) {
                return getBusinessObject(element);
            }
            if (is$1(element, 'bpmn:Participant')) {
                return (getBusinessObject(element).processRef || getBusinessObject(element));
            }
        } while ((element = element.parent));
    }

    function isTextAnnotation(element) {
        return is$1(element, 'bpmn:TextAnnotation');
    }

    function isCompensationBoundary(element) {
        return is$1(element, 'bpmn:BoundaryEvent') && hasEventDefinition$2(element, 'bpmn:CompensateEventDefinition');
    }

    function isForCompensation(e) {
        return getBusinessObject(e).isForCompensation;
    }

    function isSameOrganization(a, b) {
        var parentA = getOrganizationalParent(a), parentB = getOrganizationalParent(b);
        return parentA === parentB;
    }

    function isMessageFlowSource(element) {
        return (is$1(element, 'bpmn:InteractionNode') && (!is$1(element, 'bpmn:Event') || (is$1(element, 'bpmn:ThrowEvent') && hasEventDefinitionOrNone(element, 'bpmn:MessageEventDefinition'))));
    }

    function isMessageFlowTarget(element) {
        return (is$1(element, 'bpmn:InteractionNode') && !isForCompensation(element) && (!is$1(element, 'bpmn:Event') || (is$1(element, 'bpmn:CatchEvent') && hasEventDefinitionOrNone(element, 'bpmn:MessageEventDefinition'))));
    }

    function getScopeParent(element) {
        var parent = element;
        while ((parent = parent.parent)) {
            if (is$1(parent, 'bpmn:FlowElementsContainer')) {
                return getBusinessObject(parent);
            }
            if (is$1(parent, 'bpmn:Participant')) {
                return getBusinessObject(parent).processRef;
            }
        }
        return null;
    }

    function isSameScope(a, b) {
        var scopeParentA = getScopeParent(a), scopeParentB = getScopeParent(b);
        return scopeParentA && (scopeParentA === scopeParentB);
    }

    function hasEventDefinition$2(element, eventDefinition) {
        var bo = getBusinessObject(element);
        return !!find(bo.eventDefinitions || [], function (definition) {
            return is$1(definition, eventDefinition);
        });
    }

    function hasEventDefinitionOrNone(element, eventDefinition) {
        var bo = getBusinessObject(element);
        return (bo.eventDefinitions || []).every(function (definition) {
            return is$1(definition, eventDefinition);
        });
    }

    function isSequenceFlowSource(element) {
        return (is$1(element, 'bpmn:FlowNode') && !is$1(element, 'bpmn:EndEvent') && !isEventSubProcess(element) && !(is$1(element, 'bpmn:IntermediateThrowEvent') && hasEventDefinition$2(element, 'bpmn:LinkEventDefinition')) && !isCompensationBoundary(element) && !isForCompensation(element));
    }

    function isSequenceFlowTarget(element) {
        return (is$1(element, 'bpmn:FlowNode') && !is$1(element, 'bpmn:StartEvent') && !is$1(element, 'bpmn:BoundaryEvent') && !isEventSubProcess(element) && !(is$1(element, 'bpmn:IntermediateCatchEvent') && hasEventDefinition$2(element, 'bpmn:LinkEventDefinition')) && !isForCompensation(element));
    }

    function isEventBasedTarget(element) {
        return (is$1(element, 'bpmn:ReceiveTask') || (is$1(element, 'bpmn:IntermediateCatchEvent') && (hasEventDefinition$2(element, 'bpmn:MessageEventDefinition') || hasEventDefinition$2(element, 'bpmn:TimerEventDefinition') || hasEventDefinition$2(element, 'bpmn:ConditionalEventDefinition') || hasEventDefinition$2(element, 'bpmn:SignalEventDefinition'))));
    }

    function isConnection$1(element) {
        return element.waypoints;
    }

    function getParents(element) {
        var parents = [];
        while (element) {
            element = element.parent;
            if (element) {
                parents.push(element);
            }
        }
        return parents;
    }

    function isParent(possibleParent, element) {
        var allParents = getParents(element);
        return allParents.indexOf(possibleParent) !== -1;
    }

    function canConnect(source, target, connection) {
        if (nonExistingOrLabel(source) || nonExistingOrLabel(target)) {
            return null;
        }
        if (!is$1(connection, 'bpmn:DataAssociation')) {
            if (canConnectMessageFlow(source, target)) {
                return {type: 'bpmn:MessageFlow'};
            }
            if (canConnectSequenceFlow(source, target)) {
                return {type: 'bpmn:SequenceFlow'};
            }
        }
        var connectDataAssociation = canConnectDataAssociation(source, target);
        if (connectDataAssociation) {
            return connectDataAssociation;
        }
        if (isCompensationBoundary(source) && isForCompensation(target)) {
            return {type: 'bpmn:Association', associationDirection: 'One'};
        }
        if (canConnectAssociation(source, target)) {
            return {type: 'bpmn:Association'};
        }
        return false;
    }

    function canDrop(element, target, position) {
        if (isLabel(element)) {
            return true;
        }
        if (is$1(target, 'bpmn:Participant') && !isExpanded(target)) {
            return false;
        }
        if (is$1(element, 'bpmn:Participant')) {
            return is$1(target, 'bpmn:Process') || is$1(target, 'bpmn:Collaboration');
        }
        if (is$1(element, 'bpmn:Lane')) {
            return is$1(target, 'bpmn:Participant') || is$1(target, 'bpmn:Lane');
        }
        if (is$1(element, 'bpmn:BoundaryEvent')) {
            return false;
        }
        if (is$1(element, 'bpmn:FlowElement') && !is$1(element, 'bpmn:DataStoreReference')) {
            if (is$1(target, 'bpmn:FlowElementsContainer')) {
                return isExpanded(target);
            }
            return isAny(target, ['bpmn:Participant', 'bpmn:Lane']);
        }
        if (isAny(element, ['bpmn:Artifact', 'bpmn:DataAssociation', 'bpmn:DataStoreReference'])) {
            return isAny(target, ['bpmn:Collaboration', 'bpmn:Lane', 'bpmn:Participant', 'bpmn:Process', 'bpmn:SubProcess']);
        }
        if (is$1(element, 'bpmn:MessageFlow')) {
            return is$1(target, 'bpmn:Collaboration') || element.source.parent == target || element.target.parent == target;
        }
        return false;
    }

    function canPaste(tree, target) {
        var topLevel = tree[0], participants;
        if (is$1(target, 'bpmn:Collaboration')) {
            return every(topLevel, function (e) {
                return e.type === 'bpmn:Participant';
            });
        }
        if (is$1(target, 'bpmn:Process')) {
            participants = some(topLevel, function (e) {
                return e.type === 'bpmn:Participant';
            });
            return !(participants && target.children.length > 0);
        }
        if (is$1(target, 'bpmn:Participant') && !isExpanded(target)) {
            return false;
        }
        if (is$1(target, 'bpmn:FlowElementsContainer')) {
            return isExpanded(target);
        }
        return isAny(target, ['bpmn:Collaboration', 'bpmn:Lane', 'bpmn:Participant', 'bpmn:Process', 'bpmn:SubProcess']);
    }

    function isBoundaryEvent(element) {
        return !isLabel(element) && is$1(element, 'bpmn:BoundaryEvent');
    }

    function isLane(element) {
        return is$1(element, 'bpmn:Lane');
    }

    function isBoundaryCandidate(element) {
        return isBoundaryEvent(element) || (is$1(element, 'bpmn:IntermediateThrowEvent') && !element.parent);
    }

    function isReceiveTaskAfterEventBasedGateway(element) {
        return (is$1(element, 'bpmn:ReceiveTask') && find(element.incoming, function (incoming) {
            return is$1(incoming.source, 'bpmn:EventBasedGateway');
        }));
    }

    function canAttach(elements, target, source, position) {
        if (!Array.isArray(elements)) {
            elements = [elements];
        }
        if (source) {
            return false;
        }
        if (elements.length !== 1) {
            return false;
        }
        var element = elements[0];
        if (isLabel(element)) {
            return false;
        }
        if (!isBoundaryCandidate(element)) {
            return false;
        }
        if (!target) {
            return true;
        }
        if (isEventSubProcess(target)) {
            return false;
        }
        if (!is$1(target, 'bpmn:Activity') || isForCompensation(target)) {
            return false;
        }
        if (position && !getBoundaryAttachment(position, target)) {
            return false;
        }
        if (isReceiveTaskAfterEventBasedGateway(target)) {
            return false;
        }
        return 'attach';
    }

    function canReplace(elements, target, position) {
        if (!target) {
            return false;
        }
        var canExecute = {replacements: []};
        forEach(elements, function (element) {
            if (!isEventSubProcess(target)) {
                if (is$1(element, 'bpmn:StartEvent') && element.type !== 'label' && canDrop(element, target)) {
                    if (!isInterrupting(element)) {
                        canExecute.replacements.push({oldElementId: element.id, newElementType: 'bpmn:StartEvent'});
                    }
                    if (hasErrorEventDefinition(element) || hasEscalationEventDefinition(element) || hasCompensateEventDefinition(element)) {
                        canExecute.replacements.push({oldElementId: element.id, newElementType: 'bpmn:StartEvent'});
                    }
                }
            }
            if (!is$1(target, 'bpmn:Transaction')) {
                if (hasEventDefinition$2(element, 'bpmn:CancelEventDefinition') && element.type !== 'label') {
                    if (is$1(element, 'bpmn:EndEvent') && canDrop(element, target)) {
                        canExecute.replacements.push({oldElementId: element.id, newElementType: 'bpmn:EndEvent'});
                    }
                    if (is$1(element, 'bpmn:BoundaryEvent') && canAttach(element, target, null, position)) {
                        canExecute.replacements.push({oldElementId: element.id, newElementType: 'bpmn:BoundaryEvent'});
                    }
                }
            }
        });
        return canExecute.replacements.length ? canExecute : false;
    }

    function canMove(elements, target) {
        if (some(elements, isBoundaryEvent)) {
            return false;
        }
        if (some(elements, isLane)) {
            return false;
        }
        if (!target) {
            return true;
        }
        return elements.every(function (element) {
            return canDrop(element, target);
        });
    }

    function canCreate(shape, target, source, position) {
        if (!target) {
            return false;
        }
        if (isLabel(target)) {
            return null;
        }
        if (isSame(source, target)) {
            return false;
        }
        if (source && isParent(source, target)) {
            return false;
        }
        return canDrop(shape, target, position) || canInsert(shape, target, position);
    }

    function canResize(shape, newBounds) {
        if (is$1(shape, 'bpmn:SubProcess')) {
            return (isExpanded(shape) && (!newBounds || (newBounds.width >= 100 && newBounds.height >= 80)));
        }
        if (is$1(shape, 'bpmn:Lane')) {
            return !newBounds || (newBounds.width >= 130 && newBounds.height >= 60);
        }
        if (is$1(shape, 'bpmn:Participant')) {
            return !newBounds || (newBounds.width >= 250 && newBounds.height >= 50);
        }
        if (isTextAnnotation(shape)) {
            return true;
        }
        return false;
    }

    function isOneTextAnnotation(source, target) {
        var sourceTextAnnotation = isTextAnnotation(source), targetTextAnnotation = isTextAnnotation(target);
        return ((sourceTextAnnotation || targetTextAnnotation) && (sourceTextAnnotation !== targetTextAnnotation));
    }

    function canConnectAssociation(source, target) {
        if (isConnection$1(source) || isConnection$1(target)) {
            return false;
        }
        if (isCompensationBoundary(source) && isForCompensation(target)) {
            return true;
        }
        if (isParent(target, source) || isParent(source, target)) {
            return false;
        }
        return isOneTextAnnotation(source, target);
    }

    function canConnectMessageFlow(source, target) {
        return isMessageFlowSource(source) && isMessageFlowTarget(target) && !isSameOrganization(source, target);
    }

    function canConnectSequenceFlow(source, target) {
        return isSequenceFlowSource(source) && isSequenceFlowTarget(target) && isSameScope(source, target) && !(is$1(source, 'bpmn:EventBasedGateway') && !isEventBasedTarget(target));
    }

    function canConnectDataAssociation(source, target) {
        if (isAny(source, ['bpmn:DataObjectReference', 'bpmn:DataStoreReference']) && isAny(target, ['bpmn:Activity', 'bpmn:ThrowEvent'])) {
            return {type: 'bpmn:DataInputAssociation'};
        }
        if (isAny(target, ['bpmn:DataObjectReference', 'bpmn:DataStoreReference']) && isAny(source, ['bpmn:Activity', 'bpmn:CatchEvent'])) {
            return {type: 'bpmn:DataOutputAssociation'};
        }
        return false;
    }

    function canInsert(shape, flow, position) {
        if (!flow) {
            return false;
        }
        if (Array.isArray(shape)) {
            if (shape.length !== 1) {
                return false;
            }
            shape = shape[0];
        }
        if (flow.source === shape || flow.target === shape) {
            return false;
        }
        return (isAny(flow, ['bpmn:SequenceFlow', 'bpmn:MessageFlow']) && !isLabel(flow) && is$1(shape, 'bpmn:FlowNode') && !is$1(shape, 'bpmn:BoundaryEvent') && canDrop(shape, flow.parent, position));
    }

    function contains(collection, element) {
        return (collection && element) && collection.indexOf(element) !== -1;
    }

    function canCopy(collection, element) {
        if (is$1(element, 'bpmn:Lane') && !contains(collection, element.parent)) {
            return false;
        }
        if (is$1(element, 'bpmn:BoundaryEvent') && !contains(collection, element.host)) {
            return false;
        }
        return true;
    }

    var RulesModule$1 = {__depends__: [RulesModule], __init__: ['bpmnRules'], bpmnRules: ['type', BpmnRules]};

    function OrderingProvider(eventBus) {
        CommandInterceptor.call(this, eventBus);
        var self = this;
        this.preExecute(['shape.create', 'connection.create'], function (event) {
            var context = event.context, element = context.shape || context.connection, parent = context.parent;
            var ordering = self.getOrdering(element, parent);
            if (ordering) {
                if (ordering.parent !== undefined) {
                    context.parent = ordering.parent;
                }
                context.parentIndex = ordering.index;
            }
        });
        this.preExecute(['shape.move', 'connection.move'], function (event) {
            var context = event.context, element = context.shape || context.connection,
                parent = context.newParent || element.parent;
            var ordering = self.getOrdering(element, parent);
            if (ordering) {
                if (ordering.parent !== undefined) {
                    context.newParent = ordering.parent;
                }
                context.newParentIndex = ordering.index;
            }
        });
    }

    OrderingProvider.prototype.getOrdering = function (element, newParent) {
        return null;
    };
    inherits_browser(OrderingProvider, CommandInterceptor);

    function BpmnOrderingProvider(eventBus, canvas, translate) {
        OrderingProvider.call(this, eventBus);
        var orders = [{type: 'bpmn:SubProcess', order: {level: 6}}, {
            type: 'bpmn:SequenceFlow',
            order: {level: 3, containers: ['bpmn:Participant', 'bpmn:FlowElementsContainer']}
        }, {
            type: 'bpmn:DataAssociation',
            order: {level: 9, containers: ['bpmn:Collaboration', 'bpmn:Process']}
        }, {type: 'bpmn:MessageFlow', order: {level: 9, containers: ['bpmn:Collaboration']}}, {
            type: 'bpmn:Association',
            order: {level: 6, containers: ['bpmn:Participant', 'bpmn:FlowElementsContainer', 'bpmn:Collaboration']}
        }, {type: 'bpmn:BoundaryEvent', order: {level: 8}}, {
            type: 'bpmn:FlowElement',
            order: {level: 5}
        }, {type: 'bpmn:Participant', order: {level: -2}}, {type: 'bpmn:Lane', order: {level: -1}}];

        function computeOrder(element) {
            if (element.labelTarget) {
                return {level: 10};
            }
            var entry = find(orders, function (o) {
                return isAny(element, [o.type]);
            });
            return entry && entry.order || {level: 1};
        }

        function getOrder(element) {
            var order = element.order;
            if (!order) {
                element.order = order = computeOrder(element);
            }
            return order;
        }

        function findActualParent(element, newParent, containers) {
            var actualParent = newParent;
            while (actualParent) {
                if (isAny(actualParent, containers)) {
                    break;
                }
                actualParent = actualParent.parent;
            }
            if (!actualParent) {
                throw new Error(translate('no parent for {element} in {parent}', {
                    element: element.id,
                    parent: newParent.id
                }));
            }
            return actualParent;
        }

        this.getOrdering = function (element, newParent) {
            if (element.labelTarget) {
                return {parent: canvas.getRootElement(), index: -1};
            }
            var elementOrder = getOrder(element);
            if (elementOrder.containers) {
                newParent = findActualParent(element, newParent, elementOrder.containers);
            }
            var currentIndex = newParent.children.indexOf(element);
            var insertIndex = findIndex(newParent.children, function (child) {
                if (!element.labelTarget && child.labelTarget) {
                    return false;
                }
                return elementOrder.level < getOrder(child).level;
            });
            if (insertIndex !== -1) {
                if (currentIndex !== -1 && currentIndex < insertIndex) {
                    insertIndex -= 1;
                }
            }
            return {index: insertIndex, parent: newParent};
        };
    }

    BpmnOrderingProvider.$inject = ['eventBus', 'canvas', 'translate'];
    inherits_browser(BpmnOrderingProvider, OrderingProvider);
    var OrderingModule = {
        __depends__: [translate$2],
        __init__: ['bpmnOrderingProvider'],
        bpmnOrderingProvider: ['type', BpmnOrderingProvider]
    };

    function CommandStack(eventBus, injector) {
        this._handlerMap = {};
        this._stack = [];
        this._stackIdx = -1;
        this._currentExecution = {actions: [], dirty: []};
        this._injector = injector;
        this._eventBus = eventBus;
        this._uid = 1;
        eventBus.on(['diagram.destroy', 'diagram.clear'], function () {
            this.clear(false);
        }, this);
    }

    CommandStack.$inject = ['eventBus', 'injector'];
    CommandStack.prototype.execute = function (command, context) {
        if (!command) {
            throw new Error('command required');
        }
        var action = {command: command, context: context};
        this._pushAction(action);
        this._internalExecute(action);
        this._popAction(action);
    };
    CommandStack.prototype.canExecute = function (command, context) {
        var action = {command: command, context: context};
        var handler = this._getHandler(command);
        var result = this._fire(command, 'canExecute', action);
        if (result === undefined) {
            if (!handler) {
                return false;
            }
            if (handler.canExecute) {
                result = handler.canExecute(context);
            }
        }
        return result;
    };
    CommandStack.prototype.clear = function (emit) {
        this._stack.length = 0;
        this._stackIdx = -1;
        if (emit !== false) {
            this._fire('changed');
        }
    };
    CommandStack.prototype.undo = function () {
        var action = this._getUndoAction(), next;
        if (action) {
            this._pushAction(action);
            while (action) {
                this._internalUndo(action);
                next = this._getUndoAction();
                if (!next || next.id !== action.id) {
                    break;
                }
                action = next;
            }
            this._popAction();
        }
    };
    CommandStack.prototype.redo = function () {
        var action = this._getRedoAction(), next;
        if (action) {
            this._pushAction(action);
            while (action) {
                this._internalExecute(action, true);
                next = this._getRedoAction();
                if (!next || next.id !== action.id) {
                    break;
                }
                action = next;
            }
            this._popAction();
        }
    };
    CommandStack.prototype.register = function (command, handler) {
        this._setHandler(command, handler);
    };
    CommandStack.prototype.registerHandler = function (command, handlerCls) {
        if (!command || !handlerCls) {
            throw new Error('command and handlerCls must be defined');
        }
        var handler = this._injector.instantiate(handlerCls);
        this.register(command, handler);
    };
    CommandStack.prototype.canUndo = function () {
        return !!this._getUndoAction();
    };
    CommandStack.prototype.canRedo = function () {
        return !!this._getRedoAction();
    };
    CommandStack.prototype._getRedoAction = function () {
        return this._stack[this._stackIdx + 1];
    };
    CommandStack.prototype._getUndoAction = function () {
        return this._stack[this._stackIdx];
    };
    CommandStack.prototype._internalUndo = function (action) {
        var self = this;
        var command = action.command, context = action.context;
        var handler = this._getHandler(command);
        this._atomicDo(function () {
            self._fire(command, 'revert', action);
            if (handler.revert) {
                self._markDirty(handler.revert(context));
            }
            self._revertedAction(action);
            self._fire(command, 'reverted', action);
        });
    };
    CommandStack.prototype._fire = function (command, qualifier, event) {
        if (arguments.length < 3) {
            event = qualifier;
            qualifier = null;
        }
        var names = qualifier ? [command + '.' + qualifier, qualifier] : [command], i, name, result;
        event = this._eventBus.createEvent(event);
        for (i = 0; (name = names[i]); i++) {
            result = this._eventBus.fire('commandStack.' + name, event);
            if (event.cancelBubble) {
                break;
            }
        }
        return result;
    };
    CommandStack.prototype._createId = function () {
        return this._uid++;
    };
    CommandStack.prototype._atomicDo = function (fn) {
        var execution = this._currentExecution;
        execution.atomic = true;
        try {
            fn();
        } finally {
            execution.atomic = false;
        }
    };
    CommandStack.prototype._internalExecute = function (action, redo) {
        var self = this;
        var command = action.command, context = action.context;
        var handler = this._getHandler(command);
        if (!handler) {
            throw new Error('no command handler registered for <' + command + '>');
        }
        this._pushAction(action);
        if (!redo) {
            this._fire(command, 'preExecute', action);
            if (handler.preExecute) {
                handler.preExecute(context);
            }
            this._fire(command, 'preExecuted', action);
        }
        this._atomicDo(function () {
            self._fire(command, 'execute', action);
            if (handler.execute) {
                self._markDirty(handler.execute(context));
            }
            self._executedAction(action, redo);
            self._fire(command, 'executed', action);
        });
        if (!redo) {
            this._fire(command, 'postExecute', action);
            if (handler.postExecute) {
                handler.postExecute(context);
            }
            this._fire(command, 'postExecuted', action);
        }
        this._popAction(action);
    };
    CommandStack.prototype._pushAction = function (action) {
        var execution = this._currentExecution, actions = execution.actions;
        var baseAction = actions[0];
        if (execution.atomic) {
            throw new Error('illegal invocation in <execute> or <revert> phase (action: ' + action.command + ')');
        }
        if (!action.id) {
            action.id = (baseAction && baseAction.id) || this._createId();
        }
        actions.push(action);
    };
    CommandStack.prototype._popAction = function () {
        var execution = this._currentExecution, actions = execution.actions, dirty = execution.dirty;
        actions.pop();
        if (!actions.length) {
            this._eventBus.fire('elements.changed', {elements: uniqueBy('id', dirty)});
            dirty.length = 0;
            this._fire('changed');
        }
    };
    CommandStack.prototype._markDirty = function (elements) {
        var execution = this._currentExecution;
        if (!elements) {
            return;
        }
        elements = isArray(elements) ? elements : [elements];
        execution.dirty = execution.dirty.concat(elements);
    };
    CommandStack.prototype._executedAction = function (action, redo) {
        var stackIdx = ++this._stackIdx;
        if (!redo) {
            this._stack.splice(stackIdx, this._stack.length, action);
        }
    };
    CommandStack.prototype._revertedAction = function (action) {
        this._stackIdx--;
    };
    CommandStack.prototype._getHandler = function (command) {
        return this._handlerMap[command];
    };
    CommandStack.prototype._setHandler = function (command, handler) {
        if (!command || !handler) {
            throw new Error('command and handler required');
        }
        if (this._handlerMap[command]) {
            throw new Error('overriding handler for command <' + command + '>');
        }
        this._handlerMap[command] = handler;
    };
    var CommandModule = {commandStack: ['type', CommandStack]};
    var ids$2 = new IdGenerator('tt');

    function createRoot$1(parent) {
        var root = domify('<div class="djs-tooltip-container" style="position: absolute; width: 0; height: 0;" />');
        parent.insertBefore(root, parent.firstChild);
        return root;
    }

    function setPosition$1(el, x, y) {
        assign(el.style, {left: x + 'px', top: y + 'px'});
    }

    function setVisible$1(el, visible) {
        el.style.display = visible === false ? 'none' : '';
    }

    var tooltipClass = 'djs-tooltip', tooltipSelector = '.' + tooltipClass;

    function Tooltips(eventBus, canvas) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._ids = ids$2;
        this._tooltipDefaults = {show: {minZoom: 0.7, maxZoom: 5.0}};
        this._tooltips = {};
        this._tooltipRoot = createRoot$1(canvas.getContainer());
        var self = this;
        delegateEvents.bind(this._tooltipRoot, tooltipSelector, 'mousedown', function (event) {
            event.stopPropagation();
        });
        delegateEvents.bind(this._tooltipRoot, tooltipSelector, 'mouseover', function (event) {
            self.trigger('mouseover', event);
        });
        delegateEvents.bind(this._tooltipRoot, tooltipSelector, 'mouseout', function (event) {
            self.trigger('mouseout', event);
        });
        this._init();
    }

    Tooltips.$inject = ['eventBus', 'canvas'];
    Tooltips.prototype.add = function (tooltip) {
        if (!tooltip.position) {
            throw new Error('must specifiy tooltip position');
        }
        if (!tooltip.html) {
            throw new Error('must specifiy tooltip html');
        }
        var id = this._ids.next();
        tooltip = assign({}, this._tooltipDefaults, tooltip, {id: id});
        this._addTooltip(tooltip);
        if (tooltip.timeout) {
            this.setTimeout(tooltip);
        }
        return id;
    };
    Tooltips.prototype.trigger = function (action, event) {
        var node = event.delegateTarget || event.target;
        var tooltip = this.get(attr(node, 'data-tooltip-id'));
        if (!tooltip) {
            return;
        }
        if (action === 'mouseover' && tooltip.timeout) {
            this.clearTimeout(tooltip);
        }
        if (action === 'mouseout' && tooltip.timeout) {
            tooltip.timeout = 1000;
            this.setTimeout(tooltip);
        }
    };
    Tooltips.prototype.get = function (id) {
        if (typeof id !== 'string') {
            id = id.id;
        }
        return this._tooltips[id];
    };
    Tooltips.prototype.clearTimeout = function (tooltip) {
        tooltip = this.get(tooltip);
        if (!tooltip) {
            return;
        }
        var removeTimer = tooltip.removeTimer;
        if (removeTimer) {
            clearTimeout(removeTimer);
            tooltip.removeTimer = null;
        }
    };
    Tooltips.prototype.setTimeout = function (tooltip) {
        tooltip = this.get(tooltip);
        if (!tooltip) {
            return;
        }
        this.clearTimeout(tooltip);
        var self = this;
        tooltip.removeTimer = setTimeout(function () {
            self.remove(tooltip);
        }, tooltip.timeout);
    };
    Tooltips.prototype.remove = function (id) {
        var tooltip = this.get(id);
        if (tooltip) {
            remove(tooltip.html);
            remove(tooltip.htmlContainer);
            delete tooltip.htmlContainer;
            delete this._tooltips[tooltip.id];
        }
    };
    Tooltips.prototype.show = function () {
        setVisible$1(this._tooltipRoot);
    };
    Tooltips.prototype.hide = function () {
        setVisible$1(this._tooltipRoot, false);
    };
    Tooltips.prototype._updateRoot = function (viewbox) {
        var a = viewbox.scale || 1;
        var d = viewbox.scale || 1;
        var matrix = 'matrix(' + a + ',0,0,' + d + ',' + (-1 * viewbox.x * a) + ',' + (-1 * viewbox.y * d) + ')';
        this._tooltipRoot.style.transform = matrix;
        this._tooltipRoot.style['-ms-transform'] = matrix;
    };
    Tooltips.prototype._addTooltip = function (tooltip) {
        var id = tooltip.id, html = tooltip.html, htmlContainer, tooltipRoot = this._tooltipRoot;
        if (html.get && html.constructor.prototype.jquery) {
            html = html.get(0);
        }
        if (isString(html)) {
            html = domify(html);
        }
        htmlContainer = domify('<div data-tooltip-id="' + id + '" class="' + tooltipClass + '" style="position: absolute">');
        htmlContainer.appendChild(html);
        if (tooltip.type) {
            classes(htmlContainer).add('djs-tooltip-' + tooltip.type);
        }
        if (tooltip.className) {
            classes(htmlContainer).add(tooltip.className);
        }
        tooltip.htmlContainer = htmlContainer;
        tooltipRoot.appendChild(htmlContainer);
        this._tooltips[id] = tooltip;
        this._updateTooltip(tooltip);
    };
    Tooltips.prototype._updateTooltip = function (tooltip) {
        var position = tooltip.position, htmlContainer = tooltip.htmlContainer;
        setPosition$1(htmlContainer, position.x, position.y);
    };
    Tooltips.prototype._updateTooltipVisibilty = function (viewbox) {
        forEach(this._tooltips, function (tooltip) {
            var show = tooltip.show, htmlContainer = tooltip.htmlContainer, visible = true;
            if (show) {
                if (show.minZoom > viewbox.scale || show.maxZoom < viewbox.scale) {
                    visible = false;
                }
                setVisible$1(htmlContainer, visible);
            }
        });
    };
    Tooltips.prototype._init = function () {
        var self = this;

        function updateViewbox(viewbox) {
            self._updateRoot(viewbox);
            self._updateTooltipVisibilty(viewbox);
            self.show();
        }

        this._eventBus.on('canvas.viewbox.changing', function (event) {
            self.hide();
        });
        this._eventBus.on('canvas.viewbox.changed', function (event) {
            updateViewbox(event.viewbox);
        });
    };
    var TooltipsModule = {__init__: ['tooltips'], tooltips: ['type', Tooltips]};

    function saveClear(collection, removeFn) {
        if (typeof removeFn !== 'function') {
            throw new Error('removeFn iterator must be a function');
        }
        if (!collection) {
            return;
        }
        var e;
        while ((e = collection[0])) {
            removeFn(e);
        }
        return collection;
    }

    var LOW_PRIORITY$9 = 250, HIGH_PRIORITY$1 = 1400;

    function LabelSupport(injector, eventBus, modeling) {
        CommandInterceptor.call(this, eventBus);
        var movePreview = injector.get('movePreview', false);
        eventBus.on('shape.move.start', HIGH_PRIORITY$1, function (e) {
            var context = e.context, shapes = context.shapes, validatedShapes = context.validatedShapes;
            context.shapes = removeLabels(shapes);
            context.validatedShapes = removeLabels(validatedShapes);
        });
        movePreview && eventBus.on('shape.move.start', LOW_PRIORITY$9, function (e) {
            var context = e.context, shapes = context.shapes;
            var labels = [];
            forEach(shapes, function (element) {
                forEach(element.labels, function (label) {
                    if (!label.hidden && context.shapes.indexOf(label) === -1) {
                        labels.push(label);
                    }
                    if (element.labelTarget) {
                        labels.push(element);
                    }
                });
            });
            forEach(labels, function (label) {
                movePreview.makeDraggable(context, label, true);
            });
        });
        this.preExecuted('elements.move', HIGH_PRIORITY$1, function (e) {
            var context = e.context, closure = context.closure, enclosedElements = closure.enclosedElements;
            var enclosedLabels = [];
            forEach(enclosedElements, function (element) {
                forEach(element.labels, function (label) {
                    if (!enclosedElements[label.id]) {
                        enclosedLabels.push(label);
                    }
                });
            });
            closure.addAll(enclosedLabels);
        });
        this.preExecute(['connection.delete', 'shape.delete'], function (e) {
            var context = e.context, element = context.connection || context.shape;
            saveClear(element.labels, function (label) {
                modeling.removeShape(label, {nested: true});
            });
        });
        this.execute('shape.delete', function (e) {
            var context = e.context, shape = context.shape, labelTarget = shape.labelTarget;
            if (labelTarget) {
                context.labelTargetIndex = indexOf$1(labelTarget.labels, shape);
                context.labelTarget = labelTarget;
                shape.labelTarget = null;
            }
        });
        this.revert('shape.delete', function (e) {
            var context = e.context, shape = context.shape, labelTarget = context.labelTarget,
                labelTargetIndex = context.labelTargetIndex;
            if (labelTarget) {
                add(labelTarget.labels, shape, labelTargetIndex);
                shape.labelTarget = labelTarget;
            }
        });
    }

    inherits_browser(LabelSupport, CommandInterceptor);
    LabelSupport.$inject = ['injector', 'eventBus', 'modeling'];

    function removeLabels(elements) {
        return filter(elements, function (element) {
            return elements.indexOf(element.labelTarget) === -1;
        });
    }

    var LabelSupportModule = {__init__: ['labelSupport'], labelSupport: ['type', LabelSupport]};

    function getNewAttachPoint(point, oldBounds, newBounds) {
        var oldCenter = center(oldBounds), newCenter = center(newBounds), oldDelta = delta(point, oldCenter);
        var newDelta = {
            x: oldDelta.x * (newBounds.width / oldBounds.width),
            y: oldDelta.y * (newBounds.height / oldBounds.height)
        };
        return roundPoint({x: newCenter.x + newDelta.x, y: newCenter.y + newDelta.y});
    }

    function getNewAttachShapeDelta(shape, oldBounds, newBounds) {
        var shapeCenter = center(shape), oldCenter = center(oldBounds), newCenter = center(newBounds),
            shapeDelta = delta(shape, shapeCenter), oldCenterDelta = delta(shapeCenter, oldCenter);
        var newCenterDelta = {
            x: oldCenterDelta.x * (newBounds.width / oldBounds.width),
            y: oldCenterDelta.y * (newBounds.height / oldBounds.height)
        };
        var newShapeCenter = {x: newCenter.x + newCenterDelta.x, y: newCenter.y + newCenterDelta.y};
        return roundPoint({x: newShapeCenter.x + shapeDelta.x - shape.x, y: newShapeCenter.y + shapeDelta.y - shape.y});
    }

    var LOW_PRIORITY$a = 251, HIGH_PRIORITY$2 = 1401;

    function AttachSupport(injector, eventBus, rules, modeling) {
        CommandInterceptor.call(this, eventBus);
        var movePreview = injector.get('movePreview', false);
        eventBus.on('shape.move.start', HIGH_PRIORITY$2, function (e) {
            var context = e.context, shapes = context.shapes, validatedShapes = context.validatedShapes;
            context.shapes = addAttached(shapes);
            context.validatedShapes = removeAttached(validatedShapes);
        });
        movePreview && eventBus.on('shape.move.start', LOW_PRIORITY$a, function (e) {
            var context = e.context, shapes = context.shapes, attachers = getAttachers(shapes);
            forEach(attachers, function (attacher) {
                movePreview.makeDraggable(context, attacher, true);
                forEach(attacher.labels, function (label) {
                    movePreview.makeDraggable(context, label, true);
                });
            });
        });
        this.preExecuted('elements.move', HIGH_PRIORITY$2, function (e) {
            var context = e.context, closure = context.closure, shapes = context.shapes,
                attachers = getAttachers(shapes);
            forEach(attachers, function (attacher) {
                closure.add(attacher, closure.topLevel[attacher.host.id]);
            });
        });
        this.postExecuted('elements.move', function (e) {
            var context = e.context, shapes = context.shapes, newHost = context.newHost, attachers;
            if (shapes.length > 1) {
                return;
            }
            if (newHost) {
                attachers = shapes;
            } else {
                attachers = filter(shapes, function (s) {
                    return !!s.host;
                });
            }
            forEach(attachers, function (attacher) {
                modeling.updateAttachment(attacher, newHost);
            });
        });
        this.postExecuted('elements.move', function (e) {
            var shapes = e.context.shapes;
            forEach(shapes, function (shape) {
                forEach(shape.attachers, function (attacher) {
                    forEach(attacher.outgoing.slice(), function (connection) {
                        var allowed = rules.allowed('connection.reconnectStart', {
                            connection: connection,
                            source: connection.source,
                            target: connection.target
                        });
                        if (!allowed) {
                            modeling.removeConnection(connection);
                        }
                    });
                    forEach(attacher.incoming.slice(), function (connection) {
                        var allowed = rules.allowed('connection.reconnectEnd', {
                            connection: connection,
                            source: connection.source,
                            target: connection.target
                        });
                        if (!allowed) {
                            modeling.removeConnection(connection);
                        }
                    });
                });
            });
        });
        this.postExecute('shape.create', function (e) {
            var context = e.context, shape = context.shape, host = context.host;
            if (host) {
                modeling.updateAttachment(shape, host);
            }
        });
        this.postExecute('shape.replace', function (e) {
            var context = e.context, oldShape = context.oldShape, newShape = context.newShape;
            saveClear(oldShape.attachers, function (attacher) {
                var allowed = rules.allowed('elements.move', {target: newShape, shapes: [attacher]});
                if (allowed === 'attach') {
                    modeling.updateAttachment(attacher, newShape);
                } else {
                    modeling.removeShape(attacher);
                }
            });
            if (newShape.attachers.length) {
                forEach(newShape.attachers, function (attacher) {
                    var delta = getNewAttachShapeDelta(attacher, oldShape, newShape);
                    modeling.moveShape(attacher, delta, attacher.parent);
                });
            }
        });
        this.postExecute('shape.resize', function (event) {
            var context = event.context, shape = context.shape, oldBounds = context.oldBounds,
                newBounds = context.newBounds, attachers = shape.attachers;
            forEach(attachers, function (attacher) {
                var delta = getNewAttachShapeDelta(attacher, oldBounds, newBounds);
                modeling.moveShape(attacher, delta, attacher.parent);
                forEach(attacher.labels, function (label) {
                    modeling.moveShape(label, delta, label.parent);
                });
            });
        });
        this.preExecute('shape.delete', function (event) {
            var shape = event.context.shape;
            saveClear(shape.attachers, function (attacher) {
                modeling.removeShape(attacher);
            });
            if (shape.host) {
                modeling.updateAttachment(shape, null);
            }
        });
        eventBus.on('spaceTool.move', function (event) {
            var context = event.context, initialized = context.initialized,
                attachSupportInitialized = context.attachSupportInitialized;
            if (!initialized || attachSupportInitialized) {
                return;
            }
            var movingShapes = context.movingShapes;
            var staticAttachers = filter(movingShapes, function (shape) {
                var host = shape.host;
                return host && movingShapes.indexOf(host) === -1;
            });
            forEach(staticAttachers, function (shape) {
                remove$2(movingShapes, shape);
                forEach(shape.labels, function (label) {
                    remove$2(movingShapes, shape.label);
                });
            });
            context.attachSupportInitialized = true;
        });
    }

    inherits_browser(AttachSupport, CommandInterceptor);
    AttachSupport.$inject = ['injector', 'eventBus', 'rules', 'modeling'];

    function getAttachers(shapes) {
        return flatten(map(shapes, function (s) {
            return s.attachers || [];
        }));
    }

    function addAttached(elements) {
        var attachers = getAttachers(elements);
        return unionBy('id', elements, attachers);
    }

    function removeAttached(elements) {
        var ids = groupBy(elements, 'id');
        return filter(elements, function (element) {
            while (element) {
                if (element.host && ids[element.host.id]) {
                    return false;
                }
                element = element.parent;
            }
            return true;
        });
    }

    var AttachSupportModule = {
        __depends__: [RulesModule],
        __init__: ['attachSupport'],
        attachSupport: ['type', AttachSupport]
    };
    var LOW_PRIORITY$b = 250;

    function ToolManager(eventBus, dragging) {
        this._eventBus = eventBus;
        this._dragging = dragging;
        this._tools = [];
        this._active = null;
    }

    ToolManager.$inject = ['eventBus', 'dragging'];
    ToolManager.prototype.registerTool = function (name, events) {
        var tools = this._tools;
        if (!events) {
            throw new Error('A tool has to be registered with it\'s "events"');
        }
        tools.push(name);
        this.bindEvents(name, events);
    };
    ToolManager.prototype.isActive = function (tool) {
        return tool && this._active === tool;
    };
    ToolManager.prototype.length = function (tool) {
        return this._tools.length;
    };
    ToolManager.prototype.setActive = function (tool) {
        var eventBus = this._eventBus;
        if (this._active !== tool) {
            this._active = tool;
            eventBus.fire('tool-manager.update', {tool: tool});
        }
    };
    ToolManager.prototype.bindEvents = function (name, events) {
        var eventBus = this._eventBus, dragging = this._dragging;
        var eventsToRegister = [];
        eventBus.on(events.tool + '.init', function (event) {
            var context = event.context;
            if (!context.reactivate && this.isActive(name)) {
                this.setActive(null);
                dragging.cancel();
                return;
            }
            this.setActive(name);
        }, this);
        forEach(events, function (event) {
            eventsToRegister.push(event + '.ended');
            eventsToRegister.push(event + '.canceled');
        });
        eventBus.on(eventsToRegister, LOW_PRIORITY$b, function (event) {
            var originalEvent = event.originalEvent;
            if (!this._active) {
                return;
            }
            if (originalEvent && closest(originalEvent.target, '.group[data-group="tools"]')) {
                return;
            }
            this.setActive(null);
        }, this);
    };
    var ToolManagerModule = {
        __depends__: [DraggingModule],
        __init__: ['toolManager'],
        toolManager: ['type', ToolManager]
    };

    function getDirection(axis, offset) {
        if (axis === 'x') {
            if (offset > 0) {
                return 'e';
            }
            if (offset < 0) {
                return 'w';
            }
        }
        if (axis === 'y') {
            if (offset > 0) {
                return 's';
            }
            if (offset < 0) {
                return 'n';
            }
        }
        return null;
    }

    function resizeBounds$1(bounds, direction, delta) {
        var dx = delta.x, dy = delta.y;
        switch (direction) {
            case'n':
                return {x: bounds.x, y: bounds.y + dy, width: bounds.width, height: bounds.height - dy};
            case's':
                return {x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height + dy};
            case'w':
                return {x: bounds.x + dx, y: bounds.y, width: bounds.width - dx, height: bounds.height};
            case'e':
                return {x: bounds.x, y: bounds.y, width: bounds.width + dx, height: bounds.height};
            default:
                throw new Error('unrecognized direction: ' + direction);
        }
    }

    var abs$5 = Math.abs, round$6 = Math.round;
    var HIGH_PRIORITY$3 = 1500, SPACE_TOOL_CURSOR = 'crosshair';
    var AXIS_TO_DIMENSION = {x: 'width', y: 'height'}, AXIS_INVERTED = {x: 'y', y: 'x'};

    function SpaceTool(eventBus, dragging, canvas, modeling, rules, toolManager) {
        this._canvas = canvas;
        this._dragging = dragging;
        this._modeling = modeling;
        this._rules = rules;
        this._toolManager = toolManager;
        var self = this;
        toolManager.registerTool('space', {tool: 'spaceTool.selection', dragging: 'spaceTool'});
        eventBus.on('spaceTool.selection.end', function (event) {
            var target = event.originalEvent.target;
            if (!event.hover && !(target instanceof SVGElement)) {
                return;
            }
            eventBus.once('spaceTool.selection.ended', function () {
                self.activateMakeSpace(event.originalEvent);
            });
        });
        eventBus.on('spaceTool.move', HIGH_PRIORITY$3, function (event) {
            var context = event.context;
            if (!context.initialized) {
                context.initialized = self.initializeMakeSpace(event, context);
            }
        });
        eventBus.on('spaceTool.end', function (event) {
            var context = event.context, axis = context.axis, direction = context.direction,
                movingShapes = context.movingShapes, resizingShapes = context.resizingShapes;
            if (!context.initialized) {
                return;
            }
            var delta = {x: round$6(event.dx), y: round$6(event.dy)};
            delta[AXIS_INVERTED[axis]] = 0;
            var insideBounds = true;
            forEach(resizingShapes, function (shape) {
                if ((direction === 'w' && event.x > shape.x + shape.width) || (direction === 'e' && event.x < shape.x) || (direction === 'n' && event.y > shape.y + shape.height) || (direction === 's' && event.y < shape.y)) {
                    insideBounds = false;
                    return;
                }
            });
            if (insideBounds) {
                self.makeSpace(movingShapes, resizingShapes, delta, direction);
            }
            eventBus.once('spaceTool.ended', function (event) {
                self.activateSelection(event.originalEvent, true, true);
            });
        });
    }

    SpaceTool.$inject = ['eventBus', 'dragging', 'canvas', 'modeling', 'rules', 'toolManager'];
    SpaceTool.prototype.activateSelection = function (event, autoActivate, reactivate) {
        this._dragging.init(event, 'spaceTool.selection', {
            trapClick: false,
            cursor: SPACE_TOOL_CURSOR,
            autoActivate: autoActivate,
            data: {context: {reactivate: reactivate}}
        });
    };
    SpaceTool.prototype.activateMakeSpace = function (event) {
        this._dragging.init(event, 'spaceTool', {autoActivate: true, cursor: SPACE_TOOL_CURSOR, data: {context: {}}});
    };
    SpaceTool.prototype.makeSpace = function (movingShapes, resizingShapes, delta, direction) {
        return this._modeling.createSpace(movingShapes, resizingShapes, delta, direction);
    };
    SpaceTool.prototype.initializeMakeSpace = function (event, context) {
        var axis = abs$5(event.dx) > abs$5(event.dy) ? 'x' : 'y', offset = event['d' + axis],
            spacePos = event[axis] - offset;
        if (abs$5(offset) < 5) {
            return false;
        }
        if (offset < 0) {
            offset *= -1;
        }
        if (hasPrimaryModifier(event)) {
            offset *= -1;
        }
        var rootShape = this._canvas.getRootElement();
        var allShapes = selfAndAllChildren(rootShape, true);
        var adjustments = this.calculateAdjustments(allShapes, axis, offset, spacePos);
        assign(context, adjustments, {axis: axis, direction: getDirection(axis, offset)});
        set$1('resize-' + (axis === 'x' ? 'ew' : 'ns'));
        return true;
    };
    SpaceTool.prototype.calculateAdjustments = function (elements, axis, offset, spacePos) {
        var movingShapes = [], resizingShapes = [];
        var rules = this._rules;
        elements.forEach(function (shape) {
            var shapeStart = shape[axis], shapeEnd = shapeStart + shape[AXIS_TO_DIMENSION[axis]];
            if (!shape.parent) {
                return;
            }
            if (shape.waypoints) {
                return;
            }
            if (offset > 0 && shapeStart > spacePos) {
                return movingShapes.push(shape);
            }
            if (offset < 0 && shapeEnd < spacePos) {
                return movingShapes.push(shape);
            }
            if (shapeStart < spacePos && shapeEnd > spacePos && rules.allowed('shape.resize', {shape: shape})) {
                return resizingShapes.push(shape);
            }
        });
        return {movingShapes: movingShapes, resizingShapes: resizingShapes};
    };
    SpaceTool.prototype.toggle = function () {
        if (this.isActive()) {
            this._dragging.cancel();
        } else {
            this.activateSelection();
        }
    };
    SpaceTool.prototype.isActive = function () {
        var context = this._dragging.context();
        return context && /^spaceTool/.test(context.prefix);
    };
    var MARKER_DRAGGING = 'djs-dragging', MARKER_RESIZING$1 = 'djs-resizing';
    var LOW_PRIORITY$c = 250;

    function SpaceToolPreview(eventBus, elementRegistry, canvas, styles, previewSupport) {
        function addPreviewGfx(collection, dragGroup) {
            forEach(collection, function (element) {
                previewSupport.addDragger(element, dragGroup);
                canvas.addMarker(element, MARKER_DRAGGING);
            });
        }

        eventBus.on('spaceTool.selection.start', function (event) {
            var space = canvas.getLayer('space'), context = event.context;
            var orientation = {x: 'M 0,-10000 L 0,10000', y: 'M -10000,0 L 10000,0'};
            var crosshairGroup = create('g');
            attr$1(crosshairGroup, styles.cls('djs-crosshair-group', ['no-events']));
            append(space, crosshairGroup);
            var pathX = create('path');
            attr$1(pathX, 'd', orientation.x);
            classes$1(pathX).add('djs-crosshair');
            append(crosshairGroup, pathX);
            var pathY = create('path');
            attr$1(pathY, 'd', orientation.y);
            classes$1(pathY).add('djs-crosshair');
            append(crosshairGroup, pathY);
            context.crosshairGroup = crosshairGroup;
        });
        eventBus.on('spaceTool.selection.move', function (event) {
            var crosshairGroup = event.context.crosshairGroup;
            translate(crosshairGroup, event.x, event.y);
        });
        eventBus.on('spaceTool.selection.cleanup', function (event) {
            var context = event.context, crosshairGroup = context.crosshairGroup;
            if (crosshairGroup) {
                remove$1(crosshairGroup);
            }
        });
        eventBus.on('spaceTool.move', LOW_PRIORITY$c, function (event) {
            var context = event.context, line = context.line, axis = context.axis, movingShapes = context.movingShapes,
                resizingShapes = context.resizingShapes;
            if (!context.initialized) {
                return;
            }
            if (!context.dragGroup) {
                var spaceLayer = canvas.getLayer('space');
                line = create('path');
                attr$1(line, 'd', 'M0,0 L0,0');
                classes$1(line).add('djs-crosshair');
                append(spaceLayer, line);
                context.line = line;
                var dragGroup = create('g');
                attr$1(dragGroup, styles.cls('djs-drag-group', ['no-events']));
                append(canvas.getDefaultLayer(), dragGroup);
                addPreviewGfx(movingShapes, dragGroup);
                var movingConnections = context.movingConnections = elementRegistry.filter(function (element) {
                    var sourceIsMoving = false;
                    forEach(movingShapes, function (shape) {
                        forEach(shape.outgoing, function (connection) {
                            if (element === connection) {
                                sourceIsMoving = true;
                            }
                        });
                    });
                    var targetIsMoving = false;
                    forEach(movingShapes, function (shape) {
                        forEach(shape.incoming, function (connection) {
                            if (element === connection) {
                                targetIsMoving = true;
                            }
                        });
                    });
                    var sourceIsResizing = false;
                    forEach(resizingShapes, function (shape) {
                        forEach(shape.outgoing, function (connection) {
                            if (element === connection) {
                                sourceIsResizing = true;
                            }
                        });
                    });
                    var targetIsResizing = false;
                    forEach(resizingShapes, function (shape) {
                        forEach(shape.incoming, function (connection) {
                            if (element === connection) {
                                targetIsResizing = true;
                            }
                        });
                    });
                    return isConnection$2(element) && (sourceIsMoving || sourceIsResizing) && (targetIsMoving || targetIsResizing);
                });
                addPreviewGfx(movingConnections, dragGroup);
                context.dragGroup = dragGroup;
            }
            if (!context.frameGroup) {
                var frameGroup = create('g');
                attr$1(frameGroup, styles.cls('djs-frame-group', ['no-events']));
                append(canvas.getDefaultLayer(), frameGroup);
                var frames = [];
                forEach(resizingShapes, function (shape) {
                    var frame = previewSupport.addFrame(shape, frameGroup);
                    frames.push({
                        element: frame,
                        initialWidth: frame.getBBox().width,
                        initialHeight: frame.getBBox().height
                    });
                    canvas.addMarker(shape, MARKER_RESIZING$1);
                });
                context.frameGroup = frameGroup;
                context.frames = frames;
            }
            var orientation = {
                x: 'M' + event.x + ', -10000 L' + event.x + ', 10000',
                y: 'M -10000, ' + event.y + ' L 10000, ' + event.y
            };
            attr$1(line, {path: orientation[axis], display: ''});
            var opposite = {x: 'y', y: 'x'};
            var delta = {x: event.dx, y: event.dy};
            delta[opposite[context.axis]] = 0;
            translate(context.dragGroup, delta.x, delta.y);
            forEach(context.frames, function (frame) {
                if (frame.initialWidth + delta.x > 5) {
                    attr$1(frame.element, {width: frame.initialWidth + delta.x});
                }
                if (frame.initialHeight + delta.y > 5) {
                    attr$1(frame.element, {height: frame.initialHeight + delta.y});
                }
            });
        });
        eventBus.on('spaceTool.cleanup', function (event) {
            var context = event.context, movingShapes = context.movingShapes,
                movingConnections = context.movingConnections, resizingShapes = context.resizingShapes,
                line = context.line, dragGroup = context.dragGroup, frameGroup = context.frameGroup;
            forEach(movingShapes, function (shape) {
                canvas.removeMarker(shape, MARKER_DRAGGING);
            });
            forEach(movingConnections, function (connection) {
                canvas.removeMarker(connection, MARKER_DRAGGING);
            });
            if (dragGroup) {
                remove$1(line);
                remove$1(dragGroup);
            }
            forEach(resizingShapes, function (shape) {
                canvas.removeMarker(shape, MARKER_RESIZING$1);
            });
            if (frameGroup) {
                remove$1(frameGroup);
            }
        });
    }

    SpaceToolPreview.$inject = ['eventBus', 'elementRegistry', 'canvas', 'styles', 'previewSupport'];

    function isConnection$2(element) {
        return element.waypoints;
    }

    var SpaceToolModule = {
        __init__: ['spaceToolPreview'],
        __depends__: [DraggingModule, RulesModule, ToolManagerModule, PreviewSupportModule],
        spaceTool: ['type', SpaceTool],
        spaceToolPreview: ['type', SpaceToolPreview]
    };

    function BpmnFactory(moddle) {
        this._model = moddle;
    }

    BpmnFactory.$inject = ['moddle'];
    BpmnFactory.prototype._needsId = function (element) {
        return isAny(element, ['bpmn:RootElement', 'bpmn:FlowElement', 'bpmn:MessageFlow', 'bpmn:DataAssociation', 'bpmn:Artifact', 'bpmn:Participant', 'bpmn:Lane', 'bpmn:LaneSet', 'bpmn:Process', 'bpmn:Collaboration', 'bpmndi:BPMNShape', 'bpmndi:BPMNEdge', 'bpmndi:BPMNDiagram', 'bpmndi:BPMNPlane', 'bpmn:Property']);
    };
    BpmnFactory.prototype._ensureId = function (element) {
        var prefix = (element.$type || '').replace(/^[^:]*:/g, '') + '_';
        if (!element.id && this._needsId(element)) {
            element.id = this._model.ids.nextPrefixed(prefix, element);
        }
    };
    BpmnFactory.prototype.create = function (type, attrs) {
        var element = this._model.create(type, attrs || {});
        this._ensureId(element);
        return element;
    };
    BpmnFactory.prototype.createDiLabel = function () {
        return this.create('bpmndi:BPMNLabel', {bounds: this.createDiBounds()});
    };
    BpmnFactory.prototype.createDiShape = function (semantic, bounds, attrs) {
        return this.create('bpmndi:BPMNShape', assign({
            bpmnElement: semantic,
            bounds: this.createDiBounds(bounds)
        }, attrs));
    };
    BpmnFactory.prototype.createDiBounds = function (bounds) {
        return this.create('dc:Bounds', bounds);
    };
    BpmnFactory.prototype.createDiWaypoints = function (waypoints) {
        var self = this;
        return map(waypoints, function (pos) {
            return self.createDiWaypoint(pos);
        });
    };
    BpmnFactory.prototype.createDiWaypoint = function (point) {
        return this.create('dc:Point', pick(point, ['x', 'y']));
    };
    BpmnFactory.prototype.createDiEdge = function (semantic, waypoints, attrs) {
        return this.create('bpmndi:BPMNEdge', assign({bpmnElement: semantic}, attrs));
    };
    BpmnFactory.prototype.createDiPlane = function (semantic) {
        return this.create('bpmndi:BPMNPlane', {bpmnElement: semantic});
    };

    function BpmnUpdater(eventBus, bpmnFactory, connectionDocking, translate) {
        CommandInterceptor.call(this, eventBus);
        this._bpmnFactory = bpmnFactory;
        this._translate = translate;
        var self = this;

        function cropConnection(e) {
            var context = e.context, connection;
            if (!context.cropped) {
                connection = context.connection;
                connection.waypoints = connectionDocking.getCroppedWaypoints(connection);
                context.cropped = true;
            }
        }

        this.executed(['connection.layout', 'connection.create', 'connection.reconnectEnd', 'connection.reconnectStart'], cropConnection);
        this.reverted(['connection.layout'], function (e) {
            delete e.context.cropped;
        });

        function updateParent(e) {
            var context = e.context;
            self.updateParent(context.shape || context.connection, context.oldParent);
        }

        function reverseUpdateParent(e) {
            var context = e.context;
            var element = context.shape || context.connection, oldParent = context.parent || context.newParent;
            self.updateParent(element, oldParent);
        }

        this.executed(['shape.move', 'shape.create', 'shape.delete', 'connection.create', 'connection.move', 'connection.delete'], ifBpmn(updateParent));
        this.reverted(['shape.move', 'shape.create', 'shape.delete', 'connection.create', 'connection.move', 'connection.delete'], ifBpmn(reverseUpdateParent));

        function updateRoot(event) {
            var context = event.context, oldRoot = context.oldRoot, children = oldRoot.children;
            forEach(children, function (child) {
                if (is$1(child, 'bpmn:BaseElement')) {
                    self.updateParent(child);
                }
            });
        }

        this.executed(['canvas.updateRoot'], updateRoot);
        this.reverted(['canvas.updateRoot'], updateRoot);

        function updateBounds(e) {
            var shape = e.context.shape;
            if (!is$1(shape, 'bpmn:BaseElement')) {
                return;
            }
            self.updateBounds(shape);
        }

        this.executed(['shape.move', 'shape.create', 'shape.resize'], ifBpmn(function (event) {
            if (event.context.shape.type === 'label') {
                return;
            }
            updateBounds(event);
        }));
        this.reverted(['shape.move', 'shape.create', 'shape.resize'], ifBpmn(function (event) {
            if (event.context.shape.type === 'label') {
                return;
            }
            updateBounds(event);
        }));
        eventBus.on('shape.changed', function (event) {
            if (event.element.type === 'label') {
                updateBounds({context: {shape: event.element}});
            }
        });

        function updateConnection(e) {
            self.updateConnection(e.context);
        }

        this.executed(['connection.create', 'connection.move', 'connection.delete', 'connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(updateConnection));
        this.reverted(['connection.create', 'connection.move', 'connection.delete', 'connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(updateConnection));

        function updateConnectionWaypoints(e) {
            self.updateConnectionWaypoints(e.context.connection);
        }

        this.executed(['connection.layout', 'connection.move', 'connection.updateWaypoints', 'connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(updateConnectionWaypoints));
        this.reverted(['connection.layout', 'connection.move', 'connection.updateWaypoints', 'connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(updateConnectionWaypoints));
        this.executed(['connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(function (e) {
            var context = e.context, connection = context.connection, businessObject = getBusinessObject(connection),
                oldSource = getBusinessObject(context.oldSource), oldTarget = getBusinessObject(context.oldTarget),
                newSource = getBusinessObject(connection.source), newTarget = getBusinessObject(connection.target);
            if (oldSource === newSource || oldTarget === newTarget) {
                return;
            }
            if (oldSource && oldSource.default === businessObject) {
                context.default = oldSource.default;
                oldSource.default = undefined;
            }
            if ((businessObject.sourceRef && businessObject.sourceRef.default) && !(is$1(newTarget, 'bpmn:Activity') || is$1(newTarget, 'bpmn:EndEvent') || is$1(newTarget, 'bpmn:Gateway') || is$1(newTarget, 'bpmn:IntermediateThrowEvent'))) {
                context.default = businessObject.sourceRef.default;
                businessObject.sourceRef.default = undefined;
            }
            if (oldSource && (businessObject.conditionExpression) && !(is$1(newSource, 'bpmn:Activity') || is$1(newSource, 'bpmn:Gateway'))) {
                context.conditionExpression = businessObject.conditionExpression;
                businessObject.conditionExpression = undefined;
            }
            if (oldTarget && (businessObject.conditionExpression) && !(is$1(newTarget, 'bpmn:Activity') || is$1(newTarget, 'bpmn:EndEvent') || is$1(newTarget, 'bpmn:Gateway') || is$1(newTarget, 'bpmn:IntermediateThrowEvent'))) {
                context.conditionExpression = businessObject.conditionExpression;
                businessObject.conditionExpression = undefined;
            }
        }));
        this.reverted(['connection.reconnectEnd', 'connection.reconnectStart'], ifBpmn(function (e) {
            var context = e.context, connection = context.connection, businessObject = getBusinessObject(connection),
                newSource = getBusinessObject(connection.source);
            if (context.default) {
                if (is$1(newSource, 'bpmn:ExclusiveGateway') || is$1(newSource, 'bpmn:InclusiveGateway') || is$1(newSource, 'bpmn:Activity')) {
                    newSource.default = context.default;
                }
            }
            if (context.conditionExpression && is$1(newSource, 'bpmn:Activity')) {
                businessObject.conditionExpression = context.conditionExpression;
            }
        }));

        function updateAttachment(e) {
            self.updateAttachment(e.context);
        }

        this.executed(['element.updateAttachment'], ifBpmn(updateAttachment));
        this.reverted(['element.updateAttachment'], ifBpmn(updateAttachment));
    }

    inherits_browser(BpmnUpdater, CommandInterceptor);
    BpmnUpdater.$inject = ['eventBus', 'bpmnFactory', 'connectionDocking', 'translate'];
    BpmnUpdater.prototype.updateAttachment = function (context) {
        var shape = context.shape, businessObject = shape.businessObject, host = shape.host;
        businessObject.attachedToRef = host && host.businessObject;
    };
    BpmnUpdater.prototype.updateParent = function (element, oldParent) {
        if (element instanceof Label) {
            return;
        }
        if (is$1(element, 'bpmn:DataStoreReference') && element.parent && is$1(element.parent, 'bpmn:Collaboration')) {
            return;
        }
        var parentShape = element.parent;
        var businessObject = element.businessObject, parentBusinessObject = parentShape && parentShape.businessObject,
            parentDi = parentBusinessObject && parentBusinessObject.di;
        if (is$1(element, 'bpmn:FlowNode')) {
            this.updateFlowNodeRefs(businessObject, parentBusinessObject, oldParent && oldParent.businessObject);
        }
        if (is$1(element, 'bpmn:DataOutputAssociation')) {
            if (element.source) {
                parentBusinessObject = element.source.businessObject;
            } else {
                parentBusinessObject = null;
            }
        }
        if (is$1(element, 'bpmn:DataInputAssociation')) {
            if (element.target) {
                parentBusinessObject = element.target.businessObject;
            } else {
                parentBusinessObject = null;
            }
        }
        this.updateSemanticParent(businessObject, parentBusinessObject);
        if (is$1(element, 'bpmn:DataObjectReference') && businessObject.dataObjectRef) {
            this.updateSemanticParent(businessObject.dataObjectRef, parentBusinessObject);
        }
        this.updateDiParent(businessObject.di, parentDi);
    };
    BpmnUpdater.prototype.updateBounds = function (shape) {
        var di = shape.businessObject.di;
        var target = (shape instanceof Label) ? this._getLabel(di) : di;
        var bounds = target.bounds;
        if (!bounds) {
            bounds = this._bpmnFactory.createDiBounds();
            target.set('bounds', bounds);
        }
        assign(bounds, {x: shape.x, y: shape.y, width: shape.width, height: shape.height});
    };
    BpmnUpdater.prototype.updateFlowNodeRefs = function (businessObject, newContainment, oldContainment) {
        if (oldContainment === newContainment) {
            return;
        }
        var oldRefs, newRefs;
        if (is$1(oldContainment, 'bpmn:Lane')) {
            oldRefs = oldContainment.get('flowNodeRef');
            remove$2(oldRefs, businessObject);
        }
        if (is$1(newContainment, 'bpmn:Lane')) {
            newRefs = newContainment.get('flowNodeRef');
            add(newRefs, businessObject);
        }
    };
    BpmnUpdater.prototype.updateDiConnection = function (di, newSource, newTarget) {
        if (di.sourceElement && di.sourceElement.bpmnElement !== newSource) {
            di.sourceElement = newSource && newSource.di;
        }
        if (di.targetElement && di.targetElement.bpmnElement !== newTarget) {
            di.targetElement = newTarget && newTarget.di;
        }
    };
    BpmnUpdater.prototype.updateDiParent = function (di, parentDi) {
        if (parentDi && !is$1(parentDi, 'bpmndi:BPMNPlane')) {
            parentDi = parentDi.$parent;
        }
        if (di.$parent === parentDi) {
            return;
        }
        var planeElements = (parentDi || di.$parent).get('planeElement');
        if (parentDi) {
            planeElements.push(di);
            di.$parent = parentDi;
        } else {
            remove$2(planeElements, di);
            di.$parent = null;
        }
    };

    function getDefinitions(element) {
        while (element && !is$1(element, 'bpmn:Definitions')) {
            element = element.$parent;
        }
        return element;
    }

    BpmnUpdater.prototype.getLaneSet = function (container) {
        var laneSet, laneSets;
        if (is$1(container, 'bpmn:Lane')) {
            laneSet = container.childLaneSet;
            if (!laneSet) {
                laneSet = this._bpmnFactory.create('bpmn:LaneSet');
                container.childLaneSet = laneSet;
                laneSet.$parent = container;
            }
            return laneSet;
        }
        if (is$1(container, 'bpmn:Participant')) {
            container = container.processRef;
        }
        laneSets = container.get('laneSets');
        laneSet = laneSets[0];
        if (!laneSet) {
            laneSet = this._bpmnFactory.create('bpmn:LaneSet');
            laneSet.$parent = container;
            laneSets.push(laneSet);
        }
        return laneSet;
    };
    BpmnUpdater.prototype.updateSemanticParent = function (businessObject, newParent, visualParent) {
        var containment, translate = this._translate;
        if (businessObject.$parent === newParent) {
            return;
        }
        if (is$1(businessObject, 'bpmn:Lane')) {
            if (newParent) {
                newParent = this.getLaneSet(newParent);
            }
            containment = 'lanes';
        } else if (is$1(businessObject, 'bpmn:FlowElement')) {
            if (newParent) {
                if (is$1(newParent, 'bpmn:Participant')) {
                    newParent = newParent.processRef;
                } else if (is$1(newParent, 'bpmn:Lane')) {
                    do {
                        newParent = newParent.$parent.$parent;
                    } while (is$1(newParent, 'bpmn:Lane'));
                }
            }
            containment = 'flowElements';
        } else if (is$1(businessObject, 'bpmn:Artifact')) {
            while (newParent && !is$1(newParent, 'bpmn:Process') && !is$1(newParent, 'bpmn:SubProcess') && !is$1(newParent, 'bpmn:Collaboration')) {
                if (is$1(newParent, 'bpmn:Participant')) {
                    newParent = newParent.processRef;
                    break;
                } else {
                    newParent = newParent.$parent;
                }
            }
            containment = 'artifacts';
        } else if (is$1(businessObject, 'bpmn:MessageFlow')) {
            containment = 'messageFlows';
        } else if (is$1(businessObject, 'bpmn:Participant')) {
            containment = 'participants';
            var process = businessObject.processRef, definitions;
            if (process) {
                definitions = getDefinitions(businessObject.$parent || newParent);
                if (businessObject.$parent) {
                    remove$2(definitions.get('rootElements'), process);
                    process.$parent = null;
                }
                if (newParent) {
                    add(definitions.get('rootElements'), process);
                    process.$parent = definitions;
                }
            }
        } else if (is$1(businessObject, 'bpmn:DataOutputAssociation')) {
            containment = 'dataOutputAssociations';
        } else if (is$1(businessObject, 'bpmn:DataInputAssociation')) {
            containment = 'dataInputAssociations';
        }
        if (!containment) {
            throw new Error(translate('no parent for {element} in {parent}', {
                element: businessObject.id,
                parent: newParent.id
            }));
        }
        var children;
        if (businessObject.$parent) {
            children = businessObject.$parent.get(containment);
            remove$2(children, businessObject);
        }
        if (!newParent) {
            businessObject.$parent = null;
        } else {
            children = newParent.get(containment);
            children.push(businessObject);
            businessObject.$parent = newParent;
        }
        if (visualParent) {
            var diChildren = visualParent.get(containment);
            remove$2(children, businessObject);
            if (newParent) {
                if (!diChildren) {
                    diChildren = [];
                    newParent.set(containment, diChildren);
                }
                diChildren.push(businessObject);
            }
        }
    };
    BpmnUpdater.prototype.updateConnectionWaypoints = function (connection) {
        connection.businessObject.di.set('waypoint', this._bpmnFactory.createDiWaypoints(connection.waypoints));
    };
    BpmnUpdater.prototype.updateConnection = function (context) {
        var connection = context.connection, businessObject = getBusinessObject(connection),
            newSource = getBusinessObject(connection.source), newTarget = getBusinessObject(connection.target),
            visualParent;
        if (!is$1(businessObject, 'bpmn:DataAssociation')) {
            var inverseSet = is$1(businessObject, 'bpmn:SequenceFlow');
            if (businessObject.sourceRef !== newSource) {
                if (inverseSet) {
                    remove$2(businessObject.sourceRef && businessObject.sourceRef.get('outgoing'), businessObject);
                    if (newSource && newSource.get('outgoing')) {
                        newSource.get('outgoing').push(businessObject);
                    }
                }
                businessObject.sourceRef = newSource;
            }
            if (businessObject.targetRef !== newTarget) {
                if (inverseSet) {
                    remove$2(businessObject.targetRef && businessObject.targetRef.get('incoming'), businessObject);
                    if (newTarget && newTarget.get('incoming')) {
                        newTarget.get('incoming').push(businessObject);
                    }
                }
                businessObject.targetRef = newTarget;
            }
        } else if (is$1(businessObject, 'bpmn:DataInputAssociation')) {
            businessObject.get('sourceRef')[0] = newSource;
            visualParent = context.parent || context.newParent || newTarget;
            this.updateSemanticParent(businessObject, newTarget, parent.businessObject);
        } else if (is$1(businessObject, 'bpmn:DataOutputAssociation')) {
            visualParent = context.parent || context.newParent || newSource;
            this.updateSemanticParent(businessObject, newSource, visualParent);
            businessObject.targetRef = newTarget;
        }
        this.updateConnectionWaypoints(connection);
        this.updateDiConnection(businessObject.di, newSource, newTarget);
    };
    BpmnUpdater.prototype._getLabel = function (di) {
        if (!di.label) {
            di.label = this._bpmnFactory.createDiLabel();
        }
        return di.label;
    };

    function ifBpmn(fn) {
        return function (event) {
            var context = event.context, element = context.shape || context.connection;
            if (is$1(element, 'bpmn:BaseElement')) {
                fn(event);
            }
        };
    }

    function ElementFactory$1(bpmnFactory, moddle, translate) {
        ElementFactory.call(this);
        this._bpmnFactory = bpmnFactory;
        this._moddle = moddle;
        this._translate = translate;
    }

    inherits_browser(ElementFactory$1, ElementFactory);
    ElementFactory$1.$inject = ['bpmnFactory', 'moddle', 'translate'];
    ElementFactory$1.prototype.baseCreate = ElementFactory.prototype.create;
    ElementFactory$1.prototype.create = function (elementType, attrs) {
        if (elementType === 'label') {
            return this.baseCreate(elementType, assign({type: 'label'}, DEFAULT_LABEL_SIZE$1, attrs));
        }
        return this.createBpmnElement(elementType, attrs);
    };
    ElementFactory$1.prototype.createBpmnElement = function (elementType, attrs) {
        var size$$1, translate = this._translate;
        attrs = attrs || {};
        var businessObject = attrs.businessObject;
        if (!businessObject) {
            if (!attrs.type) {
                throw new Error(translate('no shape type specified'));
            }
            businessObject = this._bpmnFactory.create(attrs.type);
        }
        if (!businessObject.di) {
            if (elementType === 'root') {
                businessObject.di = this._bpmnFactory.createDiPlane(businessObject, [], {id: businessObject.id + '_di'});
            } else if (elementType === 'connection') {
                businessObject.di = this._bpmnFactory.createDiEdge(businessObject, [], {id: businessObject.id + '_di'});
            } else {
                businessObject.di = this._bpmnFactory.createDiShape(businessObject, {}, {id: businessObject.id + '_di'});
            }
        }
        if (attrs.colors) {
            assign(businessObject.di, attrs.colors);
            delete attrs.colors;
        }
        applyAttributes(businessObject, attrs, ['processRef', 'isInterrupting', 'associationDirection', 'isForCompensation']);
        if (attrs.isExpanded) {
            applyAttribute(businessObject.di, attrs, 'isExpanded');
        }
        if (is$1(businessObject, 'bpmn:ExclusiveGateway')) {
            businessObject.di.isMarkerVisible = true;
        }
        var eventDefinitions, newEventDefinition;
        if (attrs.eventDefinitionType) {
            eventDefinitions = businessObject.get('eventDefinitions') || [];
            newEventDefinition = this._moddle.create(attrs.eventDefinitionType);
            if (attrs.eventDefinitionType === 'bpmn:ConditionalEventDefinition') {
                newEventDefinition.condition = this._moddle.create('bpmn:FormalExpression');
            }
            eventDefinitions.push(newEventDefinition);
            newEventDefinition.$parent = businessObject;
            businessObject.eventDefinitions = eventDefinitions;
            delete attrs.eventDefinitionType;
        }
        size$$1 = this._getDefaultSize(businessObject);
        attrs = assign({businessObject: businessObject, id: businessObject.id}, size$$1, attrs);
        return this.baseCreate(elementType, attrs);
    };
    ElementFactory$1.prototype._getDefaultSize = function (semantic) {
        if (is$1(semantic, 'bpmn:SubProcess')) {
            if (isExpanded(semantic)) {
                return {width: 350, height: 200};
            } else {
                return {width: 100, height: 80};
            }
        }
        if (is$1(semantic, 'bpmn:Task')) {
            return {width: 100, height: 80};
        }
        if (is$1(semantic, 'bpmn:Gateway')) {
            return {width: 50, height: 50};
        }
        if (is$1(semantic, 'bpmn:Event')) {
            return {width: 36, height: 36};
        }
        if (is$1(semantic, 'bpmn:Participant')) {
            if (!isExpanded(semantic)) {
                return {width: 400, height: 100};
            } else {
                return {width: 600, height: 250};
            }
        }
        if (is$1(semantic, 'bpmn:Lane')) {
            return {width: 400, height: 100};
        }
        if (is$1(semantic, 'bpmn:DataObjectReference')) {
            return {width: 36, height: 50};
        }
        if (is$1(semantic, 'bpmn:DataStoreReference')) {
            return {width: 50, height: 50};
        }
        if (is$1(semantic, 'bpmn:TextAnnotation')) {
            return {width: 100, height: 30};
        }
        return {width: 100, height: 80};
    };
    ElementFactory$1.prototype.createParticipantShape = function (collapsed) {
        var attrs = {type: 'bpmn:Participant'};
        if (!collapsed) {
            attrs.processRef = this._bpmnFactory.create('bpmn:Process');
        }
        return this.createShape(attrs);
    };

    function applyAttributes(element, attrs, attributeNames) {
        forEach(attributeNames, function (property) {
            if (attrs[property] !== undefined) {
                applyAttribute(element, attrs, property);
            }
        });
    }

    function applyAttribute(element, attrs, attributeName) {
        element[attributeName] = attrs[attributeName];
        delete attrs[attributeName];
    }

    function AppendShapeHandler(modeling) {
        this._modeling = modeling;
    }

    AppendShapeHandler.$inject = ['modeling'];
    AppendShapeHandler.prototype.preExecute = function (context) {
        var source = context.source;
        if (!source) {
            throw new Error('source required');
        }
        var target = context.target || source.parent, shape = context.shape;
        shape = context.shape = this._modeling.createShape(shape, context.position, target, {attach: context.attach});
        context.shape = shape;
    };
    AppendShapeHandler.prototype.postExecute = function (context) {
        var parent = context.connectionParent || context.shape.parent;
        if (!existsConnection(context.source, context.shape)) {
            this._modeling.connect(context.source, context.shape, context.connection, parent);
        }
    };

    function existsConnection(source, target) {
        return some(source.outgoing, function (c) {
            return c.target === target;
        });
    }

    var round$7 = Math.round;

    function CreateShapeHandler(canvas) {
        this._canvas = canvas;
    }

    CreateShapeHandler.$inject = ['canvas'];
    CreateShapeHandler.prototype.execute = function (context) {
        var shape = context.shape, positionOrBounds = context.position, parent = context.parent,
            parentIndex = context.parentIndex;
        if (!parent) {
            throw new Error('parent required');
        }
        if (!positionOrBounds) {
            throw new Error('position required');
        }
        if (positionOrBounds.width !== undefined) {
            assign(shape, positionOrBounds);
        } else {
            assign(shape, {
                x: positionOrBounds.x - round$7(shape.width / 2),
                y: positionOrBounds.y - round$7(shape.height / 2)
            });
        }
        this._canvas.addShape(shape, parent, parentIndex);
        return shape;
    };
    CreateShapeHandler.prototype.revert = function (context) {
        this._canvas.removeShape(context.shape);
    };

    function DeleteShapeHandler(canvas, modeling) {
        this._canvas = canvas;
        this._modeling = modeling;
    }

    DeleteShapeHandler.$inject = ['canvas', 'modeling'];
    DeleteShapeHandler.prototype.preExecute = function (context) {
        var modeling = this._modeling;
        var shape = context.shape;
        saveClear(shape.incoming, function (connection) {
            modeling.removeConnection(connection, {nested: true});
        });
        saveClear(shape.outgoing, function (connection) {
            modeling.removeConnection(connection, {nested: true});
        });
        saveClear(shape.children, function (child) {
            if (isConnection$3(child)) {
                modeling.removeConnection(child, {nested: true});
            } else {
                modeling.removeShape(child, {nested: true});
            }
        });
    };
    DeleteShapeHandler.prototype.execute = function (context) {
        var canvas = this._canvas;
        var shape = context.shape, oldParent = shape.parent;
        context.oldParent = oldParent;
        context.oldParentIndex = indexOf$1(oldParent.children, shape);
        canvas.removeShape(shape);
        return shape;
    };
    DeleteShapeHandler.prototype.revert = function (context) {
        var canvas = this._canvas;
        var shape = context.shape, oldParent = context.oldParent, oldParentIndex = context.oldParentIndex;
        add(oldParent.children, shape, oldParentIndex);
        canvas.addShape(shape, oldParent);
        return shape;
    };

    function isConnection$3(element) {
        return element.waypoints;
    }

    function getResizedSourceAnchor(connection, shape, oldBounds) {
        var waypoints = safeGetWaypoints(connection), oldAnchor = waypoints[0];
        return getNewAttachPoint(oldAnchor.original || oldAnchor, oldBounds, shape);
    }

    function getResizedTargetAnchor(connection, shape, oldBounds) {
        var waypoints = safeGetWaypoints(connection), oldAnchor = waypoints[waypoints.length - 1];
        return getNewAttachPoint(oldAnchor.original || oldAnchor, oldBounds, shape);
    }

    function getMovedSourceAnchor(connection, source, moveDelta) {
        return getResizedSourceAnchor(connection, source, substractPosition(source, moveDelta));
    }

    function getMovedTargetAnchor(connection, target, moveDelta) {
        return getResizedTargetAnchor(connection, target, substractPosition(target, moveDelta));
    }

    function substractPosition(bounds, delta) {
        return {x: bounds.x - delta.x, y: bounds.y - delta.y, width: bounds.width, height: bounds.height};
    }

    function safeGetWaypoints(connection) {
        var waypoints = connection.waypoints;
        if (!waypoints.length) {
            throw new Error('connection#' + connection.id + ': no waypoints');
        }
        return waypoints;
    }

    function MoveClosure() {
        this.allShapes = {};
        this.allConnections = {};
        this.enclosedElements = {};
        this.enclosedConnections = {};
        this.topLevel = {};
    }

    MoveClosure.prototype.add = function (element, isTopLevel) {
        return this.addAll([element], isTopLevel);
    };
    MoveClosure.prototype.addAll = function (elements, isTopLevel) {
        var newClosure = getClosure(elements, !!isTopLevel, this);
        assign(this, newClosure);
        return this;
    };

    function MoveHelper(modeling) {
        this._modeling = modeling;
    }

    MoveHelper.prototype.moveRecursive = function (elements, delta, newParent) {
        if (!elements) {
            return [];
        } else {
            return this.moveClosure(this.getClosure(elements), delta, newParent);
        }
    };
    MoveHelper.prototype.moveClosure = function (closure, delta, newParent, newHost, primaryShape) {
        var modeling = this._modeling;
        var allShapes = closure.allShapes, allConnections = closure.allConnections,
            enclosedConnections = closure.enclosedConnections, topLevel = closure.topLevel, keepParent = false;
        if (primaryShape && primaryShape.parent === newParent) {
            keepParent = true;
        }
        forEach(allShapes, function (shape) {
            modeling.moveShape(shape, delta, topLevel[shape.id] && !keepParent && newParent, {
                recurse: false,
                layout: false
            });
        });
        forEach(allConnections, function (c) {
            var sourceMoved = !!allShapes[c.source.id], targetMoved = !!allShapes[c.target.id];
            if (enclosedConnections[c.id] && sourceMoved && targetMoved) {
                modeling.moveConnection(c, delta, topLevel[c.id] && !keepParent && newParent);
            } else {
                modeling.layoutConnection(c, {
                    connectionStart: sourceMoved && getMovedSourceAnchor(c, c.source, delta),
                    connectionEnd: targetMoved && getMovedTargetAnchor(c, c.target, delta)
                });
            }
        });
    };
    MoveHelper.prototype.getClosure = function (elements) {
        return new MoveClosure().addAll(elements, true);
    };

    function MoveShapeHandler(modeling) {
        this._modeling = modeling;
        this._helper = new MoveHelper(modeling);
    }

    MoveShapeHandler.$inject = ['modeling'];
    MoveShapeHandler.prototype.execute = function (context) {
        var shape = context.shape, delta = context.delta, newParent = context.newParent || shape.parent,
            newParentIndex = context.newParentIndex, oldParent = shape.parent;
        context.oldBounds = pick(shape, ['x', 'y', 'width', 'height']);
        context.oldParent = oldParent;
        context.oldParentIndex = remove$2(oldParent.children, shape);
        add(newParent.children, shape, newParentIndex);
        assign(shape, {parent: newParent, x: shape.x + delta.x, y: shape.y + delta.y});
        return shape;
    };
    MoveShapeHandler.prototype.postExecute = function (context) {
        var shape = context.shape, delta = context.delta, hints = context.hints;
        var modeling = this._modeling;
        if (hints.layout !== false) {
            forEach(shape.incoming, function (c) {
                modeling.layoutConnection(c, {connectionEnd: getMovedTargetAnchor(c, shape, delta)});
            });
            forEach(shape.outgoing, function (c) {
                modeling.layoutConnection(c, {connectionStart: getMovedSourceAnchor(c, shape, delta)});
            });
        }
        if (hints.recurse !== false) {
            this.moveChildren(context);
        }
    };
    MoveShapeHandler.prototype.revert = function (context) {
        var shape = context.shape, oldParent = context.oldParent, oldParentIndex = context.oldParentIndex,
            delta = context.delta;
        add(oldParent.children, shape, oldParentIndex);
        assign(shape, {parent: oldParent, x: shape.x - delta.x, y: shape.y - delta.y});
        return shape;
    };
    MoveShapeHandler.prototype.moveChildren = function (context) {
        var delta = context.delta, shape = context.shape;
        this._helper.moveRecursive(shape.children, delta, null);
    };
    MoveShapeHandler.prototype.getNewParent = function (context) {
        return context.newParent || context.shape.parent;
    };

    function ResizeShapeHandler(modeling) {
        this._modeling = modeling;
    }

    ResizeShapeHandler.$inject = ['modeling'];
    ResizeShapeHandler.prototype.execute = function (context) {
        var shape = context.shape, newBounds = context.newBounds, minBounds = context.minBounds;
        if (newBounds.x === undefined || newBounds.y === undefined || newBounds.width === undefined || newBounds.height === undefined) {
            throw new Error('newBounds must have {x, y, width, height} properties');
        }
        if (minBounds && (newBounds.width < minBounds.width || newBounds.height < minBounds.height)) {
            throw new Error('width and height cannot be less than minimum height and width');
        } else if (!minBounds && newBounds.width < 10 || newBounds.height < 10) {
            throw new Error('width and height cannot be less than 10px');
        }
        context.oldBounds = {width: shape.width, height: shape.height, x: shape.x, y: shape.y};
        assign(shape, {width: newBounds.width, height: newBounds.height, x: newBounds.x, y: newBounds.y});
        return shape;
    };
    ResizeShapeHandler.prototype.postExecute = function (context) {
        var shape = context.shape, oldBounds = context.oldBounds;
        var modeling = this._modeling;
        forEach(shape.incoming, function (c) {
            modeling.layoutConnection(c, {connectionEnd: getResizedTargetAnchor(c, shape, oldBounds)});
        });
        forEach(shape.outgoing, function (c) {
            modeling.layoutConnection(c, {connectionStart: getResizedSourceAnchor(c, shape, oldBounds)});
        });
    };
    ResizeShapeHandler.prototype.revert = function (context) {
        var shape = context.shape, oldBounds = context.oldBounds;
        assign(shape, {width: oldBounds.width, height: oldBounds.height, x: oldBounds.x, y: oldBounds.y});
        return shape;
    };

    function ReplaceShapeHandler(modeling, rules) {
        this._modeling = modeling;
        this._rules = rules;
    }

    ReplaceShapeHandler.$inject = ['modeling', 'rules'];
    ReplaceShapeHandler.prototype.preExecute = function (context) {
        var self = this, modeling = this._modeling, rules = this._rules;
        var oldShape = context.oldShape, newData = context.newData, hints = context.hints, newShape;

        function canReconnect(type, source, target, connection) {
            return rules.allowed(type, {source: source, target: target, connection: connection});
        }

        var position = {x: newData.x, y: newData.y};
        newShape = context.newShape = context.newShape || self.createShape(newData, position, oldShape.parent, hints);
        if (oldShape.host) {
            modeling.updateAttachment(newShape, oldShape.host);
        }
        var children;
        if (hints.moveChildren !== false) {
            children = oldShape.children.slice();
            modeling.moveElements(children, {x: 0, y: 0}, newShape);
        }
        var incoming = oldShape.incoming.slice(), outgoing = oldShape.outgoing.slice();
        forEach(incoming, function (connection) {
            var waypoints = connection.waypoints, docking = waypoints[waypoints.length - 1], source = connection.source,
                allowed = canReconnect('connection.reconnectEnd', source, newShape, connection);
            if (allowed) {
                self.reconnectEnd(connection, newShape, docking);
            }
        });
        forEach(outgoing, function (connection) {
            var waypoints = connection.waypoints, docking = waypoints[0], target = connection.target,
                allowed = canReconnect('connection.reconnectStart', newShape, target, connection);
            if (allowed) {
                self.reconnectStart(connection, newShape, docking);
            }
        });
    };
    ReplaceShapeHandler.prototype.postExecute = function (context) {
        var modeling = this._modeling;
        var oldShape = context.oldShape, newShape = context.newShape;
        forEach(newShape.incoming, function (c) {
            modeling.layoutConnection(c, {endChanged: true});
        });
        forEach(newShape.outgoing, function (c) {
            modeling.layoutConnection(c, {startChanged: true});
        });
        modeling.removeShape(oldShape);
    };
    ReplaceShapeHandler.prototype.execute = function (context) {
    };
    ReplaceShapeHandler.prototype.revert = function (context) {
    };
    ReplaceShapeHandler.prototype.createShape = function (shape, position, target, hints) {
        var modeling = this._modeling;
        return modeling.createShape(shape, position, target, hints);
    };
    ReplaceShapeHandler.prototype.reconnectStart = function (connection, newSource, dockingPoint) {
        var modeling = this._modeling;
        modeling.reconnectStart(connection, newSource, dockingPoint);
    };
    ReplaceShapeHandler.prototype.reconnectEnd = function (connection, newTarget, dockingPoint) {
        var modeling = this._modeling;
        modeling.reconnectEnd(connection, newTarget, dockingPoint);
    };

    function ToggleShapeCollapseHandler(modeling) {
        this._modeling = modeling;
    }

    ToggleShapeCollapseHandler.$inject = ['modeling'];
    ToggleShapeCollapseHandler.prototype.execute = function (context) {
        var shape = context.shape, children = shape.children;
        context.oldChildrenVisibility = getElementsVisibility(children);
        shape.collapsed = !shape.collapsed;
        setHidden(children, shape.collapsed);
        return [shape].concat(children);
    };
    ToggleShapeCollapseHandler.prototype.revert = function (context) {
        var shape = context.shape, oldChildrenVisibility = context.oldChildrenVisibility;
        var children = shape.children;
        restoreVisibility(children, oldChildrenVisibility);
        shape.collapsed = !shape.collapsed;
        return [shape].concat(children);
    };

    function getElementsVisibility(elements) {
        var result = {};
        elements.forEach(function (e) {
            result[e.id] = e.hidden;
        });
        return result;
    }

    function setHidden(elements, newHidden) {
        elements.forEach(function (element) {
            element.hidden = newHidden;
        });
    }

    function restoreVisibility(elements, lastState) {
        elements.forEach(function (e) {
            e.hidden = lastState[e.id];
        });
    }

    function SpaceToolHandler(modeling) {
        this._modeling = modeling;
    }

    SpaceToolHandler.$inject = ['modeling'];
    SpaceToolHandler.prototype.preExecute = function (context) {
        var modeling = this._modeling, resizingShapes = context.resizingShapes, delta = context.delta,
            direction = context.direction;
        forEach(resizingShapes, function (shape) {
            var newBounds = resizeBounds$1(shape, direction, delta);
            modeling.resizeShape(shape, newBounds);
        });
    };
    SpaceToolHandler.prototype.postExecute = function (context) {
        var modeling = this._modeling, movingShapes = context.movingShapes, delta = context.delta;
        modeling.moveElements(movingShapes, delta, undefined, {autoResize: false, attach: false});
    };
    SpaceToolHandler.prototype.execute = function (context) {
    };
    SpaceToolHandler.prototype.revert = function (context) {
    };

    function CreateLabelHandler(canvas) {
        CreateShapeHandler.call(this, canvas);
    }

    inherits_browser(CreateLabelHandler, CreateShapeHandler);
    CreateLabelHandler.$inject = ['canvas'];
    var originalExecute = CreateShapeHandler.prototype.execute;
    CreateLabelHandler.prototype.execute = function (context) {
        var label = context.shape;
        ensureValidDimensions(label);
        label.labelTarget = context.labelTarget;
        return originalExecute.call(this, context);
    };
    var originalRevert = CreateShapeHandler.prototype.revert;
    CreateLabelHandler.prototype.revert = function (context) {
        context.shape.labelTarget = null;
        return originalRevert.call(this, context);
    };

    function ensureValidDimensions(label) {
        ['width', 'height'].forEach(function (prop) {
            if (typeof label[prop] === 'undefined') {
                label[prop] = 0;
            }
        });
    }

    function CreateConnectionHandler(canvas, layouter) {
        this._canvas = canvas;
        this._layouter = layouter;
    }

    CreateConnectionHandler.$inject = ['canvas', 'layouter'];
    CreateConnectionHandler.prototype.execute = function (context) {
        var connection = context.connection, source = context.source, target = context.target, parent = context.parent,
            parentIndex = context.parentIndex, hints = context.hints;
        if (!source || !target) {
            throw new Error('source and target required');
        }
        if (!parent) {
            throw new Error('parent required');
        }
        connection.source = source;
        connection.target = target;
        if (!connection.waypoints) {
            connection.waypoints = this._layouter.layoutConnection(connection, hints);
        }
        this._canvas.addConnection(connection, parent, parentIndex);
        return connection;
    };
    CreateConnectionHandler.prototype.revert = function (context) {
        var connection = context.connection;
        this._canvas.removeConnection(connection);
        connection.source = null;
        connection.target = null;
    };

    function DeleteConnectionHandler(canvas, modeling) {
        this._canvas = canvas;
        this._modeling = modeling;
    }

    DeleteConnectionHandler.$inject = ['canvas', 'modeling'];
    DeleteConnectionHandler.prototype.execute = function (context) {
        var connection = context.connection, parent = connection.parent;
        context.parent = parent;
        context.parentIndex = indexOf$1(parent.children, connection);
        context.source = connection.source;
        context.target = connection.target;
        this._canvas.removeConnection(connection);
        connection.source = null;
        connection.target = null;
        return connection;
    };
    DeleteConnectionHandler.prototype.revert = function (context) {
        var connection = context.connection, parent = context.parent, parentIndex = context.parentIndex;
        connection.source = context.source;
        connection.target = context.target;
        add(parent.children, connection, parentIndex);
        this._canvas.addConnection(connection, parent);
        return connection;
    };

    function MoveConnectionHandler() {
    }

    MoveConnectionHandler.prototype.execute = function (context) {
        var connection = context.connection, delta = context.delta;
        var newParent = context.newParent || connection.parent, newParentIndex = context.newParentIndex,
            oldParent = connection.parent;
        context.oldParent = oldParent;
        context.oldParentIndex = remove$2(oldParent.children, connection);
        add(newParent.children, connection, newParentIndex);
        connection.parent = newParent;
        forEach(connection.waypoints, function (p) {
            p.x += delta.x;
            p.y += delta.y;
            if (p.original) {
                p.original.x += delta.x;
                p.original.y += delta.y;
            }
        });
        return connection;
    };
    MoveConnectionHandler.prototype.revert = function (context) {
        var connection = context.connection, newParent = connection.parent, oldParent = context.oldParent,
            oldParentIndex = context.oldParentIndex, delta = context.delta;
        remove$2(newParent.children, connection);
        add(oldParent.children, connection, oldParentIndex);
        connection.parent = oldParent;
        forEach(connection.waypoints, function (p) {
            p.x -= delta.x;
            p.y -= delta.y;
            if (p.original) {
                p.original.x -= delta.x;
                p.original.y -= delta.y;
            }
        });
        return connection;
    };

    function LayoutConnectionHandler(layouter, canvas) {
        this._layouter = layouter;
        this._canvas = canvas;
    }

    LayoutConnectionHandler.$inject = ['layouter', 'canvas'];
    LayoutConnectionHandler.prototype.execute = function (context) {
        var connection = context.connection;
        var oldWaypoints = connection.waypoints;
        assign(context, {oldWaypoints: oldWaypoints});
        connection.waypoints = this._layouter.layoutConnection(connection, context.hints);
        return connection;
    };
    LayoutConnectionHandler.prototype.revert = function (context) {
        var connection = context.connection;
        connection.waypoints = context.oldWaypoints;
        return connection;
    };

    function UpdateWaypointsHandler() {
    }

    UpdateWaypointsHandler.prototype.execute = function (context) {
        var connection = context.connection, newWaypoints = context.newWaypoints;
        context.oldWaypoints = connection.waypoints;
        connection.waypoints = newWaypoints;
        return connection;
    };
    UpdateWaypointsHandler.prototype.revert = function (context) {
        var connection = context.connection, oldWaypoints = context.oldWaypoints;
        connection.waypoints = oldWaypoints;
        return connection;
    };

    function ReconnectConnectionHandler() {
    }

    ReconnectConnectionHandler.$inject = [];
    ReconnectConnectionHandler.prototype.execute = function (context) {
        var newSource = context.newSource, newTarget = context.newTarget, connection = context.connection,
            dockingOrPoints = context.dockingOrPoints, oldWaypoints = connection.waypoints, newWaypoints;
        if (!newSource && !newTarget) {
            throw new Error('newSource or newTarget are required');
        }
        if (newSource && newTarget) {
            throw new Error('must specify either newSource or newTarget');
        }
        context.oldWaypoints = oldWaypoints;
        if (isArray(dockingOrPoints)) {
            newWaypoints = dockingOrPoints;
        } else {
            newWaypoints = oldWaypoints.slice();
            newWaypoints.splice(newSource ? 0 : -1, 1, dockingOrPoints);
        }
        if (newSource) {
            context.oldSource = connection.source;
            connection.source = newSource;
        }
        if (newTarget) {
            context.oldTarget = connection.target;
            connection.target = newTarget;
        }
        connection.waypoints = newWaypoints;
        return connection;
    };
    ReconnectConnectionHandler.prototype.revert = function (context) {
        var newSource = context.newSource, newTarget = context.newTarget, connection = context.connection;
        if (newSource) {
            connection.source = context.oldSource;
        }
        if (newTarget) {
            connection.target = context.oldTarget;
        }
        connection.waypoints = context.oldWaypoints;
        return connection;
    };

    function MoveElementsHandler(modeling) {
        this._helper = new MoveHelper(modeling);
    }

    MoveElementsHandler.$inject = ['modeling'];
    MoveElementsHandler.prototype.preExecute = function (context) {
        context.closure = this._helper.getClosure(context.shapes);
    };
    MoveElementsHandler.prototype.postExecute = function (context) {
        var hints = context.hints, primaryShape;
        if (hints && hints.primaryShape) {
            primaryShape = hints.primaryShape;
            hints.oldParent = primaryShape.parent;
        }
        this._helper.moveClosure(context.closure, context.delta, context.newParent, context.newHost, primaryShape);
    };

    function DeleteElementsHandler(modeling, elementRegistry) {
        this._modeling = modeling;
        this._elementRegistry = elementRegistry;
    }

    DeleteElementsHandler.$inject = ['modeling', 'elementRegistry'];
    DeleteElementsHandler.prototype.postExecute = function (context) {
        var modeling = this._modeling, elementRegistry = this._elementRegistry, elements = context.elements;
        forEach(elements, function (element) {
            if (!elementRegistry.get(element.id)) {
                return;
            }
            if (element.waypoints) {
                modeling.removeConnection(element);
            } else {
                modeling.removeShape(element);
            }
        });
    };

    function DistributeElements$1(modeling) {
        this._modeling = modeling;
    }

    DistributeElements$1.$inject = ['modeling'];
    var OFF_AXIS = {x: 'y', y: 'x'};
    DistributeElements$1.prototype.preExecute = function (context) {
        var modeling = this._modeling;
        var groups = context.groups, axis = context.axis, dimension = context.dimension;

        function updateRange(group, element) {
            group.range.min = Math.min(element[axis], group.range.min);
            group.range.max = Math.max(element[axis] + element[dimension], group.range.max);
        }

        function center(element) {
            return element[axis] + element[dimension] / 2;
        }

        function lastIdx(arr) {
            return arr.length - 1;
        }

        function rangeDiff(range) {
            return range.max - range.min;
        }

        function centerElement(refCenter, element) {
            var delta = {y: 0};
            delta[axis] = refCenter - center(element);
            if (delta[axis]) {
                delta[OFF_AXIS[axis]] = 0;
                modeling.moveElements([element], delta, element.parent);
            }
        }

        var firstGroup = groups[0], lastGroupIdx = lastIdx(groups), lastGroup = groups[lastGroupIdx];
        var margin, spaceInBetween, groupsSize = 0;
        forEach(groups, function (group, idx) {
            var sortedElements, refElem, refCenter;
            if (group.elements.length < 2) {
                if (idx && idx !== groups.length - 1) {
                    updateRange(group, group.elements[0]);
                    groupsSize += rangeDiff(group.range);
                }
                return;
            }
            sortedElements = sortBy(group.elements, axis);
            refElem = sortedElements[0];
            if (idx === lastGroupIdx) {
                refElem = sortedElements[lastIdx(sortedElements)];
            }
            refCenter = center(refElem);
            group.range = null;
            forEach(sortedElements, function (element) {
                centerElement(refCenter, element);
                if (group.range === null) {
                    group.range = {min: element[axis], max: element[axis] + element[dimension]};
                    return;
                }
                updateRange(group, element);
            });
            if (idx && idx !== groups.length - 1) {
                groupsSize += rangeDiff(group.range);
            }
        });
        spaceInBetween = Math.abs(lastGroup.range.min - firstGroup.range.max);
        margin = Math.round((spaceInBetween - groupsSize) / (groups.length - 1));
        if (margin < groups.length - 1) {
            return;
        }
        forEach(groups, function (group, groupIdx) {
            var delta = {}, prevGroup;
            if (group === firstGroup || group === lastGroup) {
                return;
            }
            prevGroup = groups[groupIdx - 1];
            group.range.max = 0;
            forEach(group.elements, function (element, idx) {
                delta[OFF_AXIS[axis]] = 0;
                delta[axis] = (prevGroup.range.max - element[axis]) + margin;
                if (group.range.min !== element[axis]) {
                    delta[axis] += element[axis] - group.range.min;
                }
                if (delta[axis]) {
                    modeling.moveElements([element], delta, element.parent);
                }
                group.range.max = Math.max(element[axis] + element[dimension], idx ? group.range.max : 0);
            });
        });
    };
    DistributeElements$1.prototype.postExecute = function (context) {
    };

    function AlignElements$1(modeling, canvas) {
        this._modeling = modeling;
        this._canvas = canvas;
    }

    AlignElements$1.$inject = ['modeling', 'canvas'];
    AlignElements$1.prototype.preExecute = function (context) {
        var modeling = this._modeling;
        var elements = context.elements, alignment = context.alignment;
        forEach(elements, function (element) {
            var delta = {x: 0, y: 0};
            if (alignment.left) {
                delta.x = alignment.left - element.x;
            } else if (alignment.right) {
                delta.x = (alignment.right - element.width) - element.x;
            } else if (alignment.center) {
                delta.x = (alignment.center - Math.round(element.width / 2)) - element.x;
            } else if (alignment.top) {
                delta.y = alignment.top - element.y;
            } else if (alignment.bottom) {
                delta.y = (alignment.bottom - element.height) - element.y;
            } else if (alignment.middle) {
                delta.y = (alignment.middle - Math.round(element.height / 2)) - element.y;
            }
            modeling.moveElements([element], delta, element.parent);
        });
    };
    AlignElements$1.prototype.postExecute = function (context) {
    };

    function UpdateAttachmentHandler(modeling) {
        this._modeling = modeling;
    }

    UpdateAttachmentHandler.$inject = ['modeling'];
    UpdateAttachmentHandler.prototype.execute = function (context) {
        var shape = context.shape, newHost = context.newHost, oldHost = shape.host;
        context.oldHost = oldHost;
        context.attacherIdx = removeAttacher(oldHost, shape);
        addAttacher(newHost, shape);
        shape.host = newHost;
        return shape;
    };
    UpdateAttachmentHandler.prototype.revert = function (context) {
        var shape = context.shape, newHost = context.newHost, oldHost = context.oldHost,
            attacherIdx = context.attacherIdx;
        shape.host = oldHost;
        removeAttacher(newHost, shape);
        addAttacher(oldHost, shape, attacherIdx);
        return shape;
    };

    function removeAttacher(host, attacher) {
        return remove$2(host && host.attachers, attacher);
    }

    function addAttacher(host, attacher, idx) {
        if (!host) {
            return;
        }
        var attachers = host.attachers;
        if (!attachers) {
            host.attachers = attachers = [];
        }
        add(attachers, attacher, idx);
    }

    function removeProperties$1(element, properties) {
        forEach(properties, function (prop) {
            if (element[prop]) {
                delete element[prop];
            }
        });
    }

    function PasteHandler(eventBus, canvas, selection, elementFactory, modeling, rules) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._selection = selection;
        this._elementFactory = elementFactory;
        this._modeling = modeling;
        this._rules = rules;
    }

    PasteHandler.$inject = ['eventBus', 'canvas', 'selection', 'elementFactory', 'modeling', 'rules'];
    PasteHandler.prototype.preExecute = function (context) {
        var eventBus = this._eventBus, self = this;
        var tree = context.tree, topParent = context.topParent, position = context.position;
        tree.createdElements = {};
        tree.labels = [];
        forEach(tree, function (elements, depthStr) {
            var depth = parseInt(depthStr, 10);
            if (isNaN(depth)) {
                return;
            }
            if (!depth) {
                elements = map(elements, function (descriptor) {
                    descriptor.parent = topParent;
                    return descriptor;
                });
            }
            elements = sortBy(elements, 'priority');
            forEach(elements, function (descriptor) {
                var id = descriptor.id, parent = descriptor.parent, hints = {}, newPosition;
                var element = assign({}, descriptor);
                if (depth) {
                    element.parent = self._getCreatedElement(parent, tree);
                }
                if (!parent) {
                    return;
                }
                eventBus.fire('element.paste', {createdElements: tree.createdElements, descriptor: element});
                parent = element.parent;
                if (element.waypoints) {
                    element = self._createConnection(element, parent, position, tree);
                    if (element) {
                        tree.createdElements[id] = {element: element, descriptor: descriptor};
                    }
                    return;
                }
                if (element.parent !== topParent) {
                    hints.root = false;
                }
                if (element.host) {
                    hints.attach = true;
                    parent = self._getCreatedElement(element.host, tree);
                }
                if (element.labelTarget) {
                    return tree.labels.push(element);
                }
                newPosition = {
                    x: Math.round(position.x + element.delta.x + (element.width / 2)),
                    y: Math.round(position.y + element.delta.y + (element.height / 2))
                };
                removeProperties$1(element, ['id', 'parent', 'delta', 'host', 'priority']);
                element = self._createShape(element, parent, newPosition, hints);
                if (element) {
                    tree.createdElements[id] = {element: element, descriptor: descriptor};
                }
            });
        });
    };
    PasteHandler.prototype.postExecute = function (context) {
        var modeling = this._modeling, selection = this._selection, self = this;
        var tree = context.tree, labels = tree.labels, topLevelElements = [];
        forEach(labels, function (labelDescriptor) {
            var labelTarget = self._getCreatedElement(labelDescriptor.labelTarget, tree), labels, labelTargetPos,
                newPosition;
            if (!labelTarget) {
                return;
            }
            labels = labelTarget.labels;
            if (!labels || !labels.length) {
                return;
            }
            labelTargetPos = {x: labelTarget.x, y: labelTarget.y};
            if (labelTarget.waypoints) {
                labelTargetPos = labelTarget.waypoints[0];
            }
            forEach(labels, function (label) {
                newPosition = {
                    x: Math.round((labelTargetPos.x - label.x) + labelDescriptor.delta.x),
                    y: Math.round((labelTargetPos.y - label.y) + labelDescriptor.delta.y)
                };
                modeling.moveShape(label, newPosition, labelTarget.parent);
            });
        });
        forEach(tree[0], function (descriptor) {
            var id = descriptor.id, toplevel = tree.createdElements[id];
            if (toplevel) {
                topLevelElements.push(toplevel.element);
            }
        });
        selection.select(topLevelElements);
    };
    PasteHandler.prototype._createConnection = function (element, parent, parentCenter, tree) {
        var modeling = this._modeling, rules = this._rules;
        var connection, source, target, canPaste;
        element.waypoints = map(element.waypoints, function (waypoint, idx) {
            return {
                x: Math.round(parentCenter.x + element.delta[idx].x),
                y: Math.round(parentCenter.y + element.delta[idx].y)
            };
        });
        source = this._getCreatedElement(element.source, tree);
        target = this._getCreatedElement(element.target, tree);
        if (!source || !target) {
            return null;
        }
        canPaste = rules.allowed('element.paste', {source: source, target: target});
        if (!canPaste) {
            return null;
        }
        removeProperties$1(element, ['id', 'parent', 'delta', 'source', 'target', 'width', 'height', 'priority']);
        connection = modeling.createConnection(source, target, element, parent);
        return connection;
    };
    PasteHandler.prototype._createShape = function (element, parent, position, isAttach, hints) {
        var modeling = this._modeling, elementFactory = this._elementFactory, rules = this._rules;
        var canPaste = rules.allowed('element.paste', {element: element, position: position, parent: parent});
        if (!canPaste) {
            return null;
        }
        var shape = elementFactory.createShape(element);
        modeling.createShape(shape, position, parent, isAttach, hints);
        return shape;
    };
    PasteHandler.prototype._getCreatedElement = function (id, tree) {
        return tree.createdElements[id] && tree.createdElements[id].element;
    };

    function Modeling(eventBus, elementFactory, commandStack) {
        this._eventBus = eventBus;
        this._elementFactory = elementFactory;
        this._commandStack = commandStack;
        var self = this;
        eventBus.on('diagram.init', function () {
            self.registerHandlers(commandStack);
        });
    }

    Modeling.$inject = ['eventBus', 'elementFactory', 'commandStack'];
    Modeling.prototype.getHandlers = function () {
        return {
            'shape.append': AppendShapeHandler,
            'shape.create': CreateShapeHandler,
            'shape.delete': DeleteShapeHandler,
            'shape.move': MoveShapeHandler,
            'shape.resize': ResizeShapeHandler,
            'shape.replace': ReplaceShapeHandler,
            'shape.toggleCollapse': ToggleShapeCollapseHandler,
            'spaceTool': SpaceToolHandler,
            'label.create': CreateLabelHandler,
            'connection.create': CreateConnectionHandler,
            'connection.delete': DeleteConnectionHandler,
            'connection.move': MoveConnectionHandler,
            'connection.layout': LayoutConnectionHandler,
            'connection.updateWaypoints': UpdateWaypointsHandler,
            'connection.reconnectStart': ReconnectConnectionHandler,
            'connection.reconnectEnd': ReconnectConnectionHandler,
            'elements.move': MoveElementsHandler,
            'elements.delete': DeleteElementsHandler,
            'elements.distribute': DistributeElements$1,
            'elements.align': AlignElements$1,
            'element.updateAttachment': UpdateAttachmentHandler,
            'elements.paste': PasteHandler
        };
    };
    Modeling.prototype.registerHandlers = function (commandStack) {
        forEach(this.getHandlers(), function (handler, id) {
            commandStack.registerHandler(id, handler);
        });
    };
    Modeling.prototype.moveShape = function (shape, delta, newParent, newParentIndex, hints) {
        if (typeof newParentIndex === 'object') {
            hints = newParentIndex;
            newParentIndex = null;
        }
        var context = {
            shape: shape,
            delta: delta,
            newParent: newParent,
            newParentIndex: newParentIndex,
            hints: hints || {}
        };
        this._commandStack.execute('shape.move', context);
    };
    Modeling.prototype.updateAttachment = function (shape, newHost) {
        var context = {shape: shape, newHost: newHost};
        this._commandStack.execute('element.updateAttachment', context);
    };
    Modeling.prototype.moveElements = function (shapes, delta, target, hints) {
        hints = hints || {};
        var attach = hints.attach;
        var newParent = target, newHost;
        if (attach === true) {
            newHost = target;
            newParent = target.parent;
        } else if (attach === false) {
            newHost = null;
        }
        var context = {shapes: shapes, delta: delta, newParent: newParent, newHost: newHost, hints: hints};
        this._commandStack.execute('elements.move', context);
    };
    Modeling.prototype.moveConnection = function (connection, delta, newParent, newParentIndex, hints) {
        if (typeof newParentIndex === 'object') {
            hints = newParentIndex;
            newParentIndex = undefined;
        }
        var context = {
            connection: connection,
            delta: delta,
            newParent: newParent,
            newParentIndex: newParentIndex,
            hints: hints || {}
        };
        this._commandStack.execute('connection.move', context);
    };
    Modeling.prototype.layoutConnection = function (connection, hints) {
        var context = {connection: connection, hints: hints || {}};
        this._commandStack.execute('connection.layout', context);
    };
    Modeling.prototype.createConnection = function (source, target, parentIndex, connection, parent, hints) {
        if (typeof parentIndex === 'object') {
            hints = parent;
            parent = connection;
            connection = parentIndex;
            parentIndex = undefined;
        }
        connection = this._create('connection', connection);
        var context = {
            source: source,
            target: target,
            parent: parent,
            parentIndex: parentIndex,
            connection: connection,
            hints: hints
        };
        this._commandStack.execute('connection.create', context);
        return context.connection;
    };
    Modeling.prototype.createShape = function (shape, position, target, parentIndex, hints) {
        if (typeof parentIndex !== 'number') {
            hints = parentIndex;
            parentIndex = undefined;
        }
        hints = hints || {};
        var attach = hints.attach, parent, host;
        shape = this._create('shape', shape);
        if (attach) {
            parent = target.parent;
            host = target;
        } else {
            parent = target;
        }
        var context = {
            position: position,
            shape: shape,
            parent: parent,
            parentIndex: parentIndex,
            host: host,
            hints: hints
        };
        this._commandStack.execute('shape.create', context);
        return context.shape;
    };
    Modeling.prototype.createLabel = function (labelTarget, position, label, parent) {
        label = this._create('label', label);
        var context = {
            labelTarget: labelTarget,
            position: position,
            parent: parent || labelTarget.parent,
            shape: label
        };
        this._commandStack.execute('label.create', context);
        return context.shape;
    };
    Modeling.prototype.appendShape = function (source, shape, position, target, hints) {
        hints = hints || {};
        shape = this._create('shape', shape);
        var context = {
            source: source,
            position: position,
            target: target,
            shape: shape,
            connection: hints.connection,
            connectionParent: hints.connectionParent,
            attach: hints.attach
        };
        this._commandStack.execute('shape.append', context);
        return context.shape;
    };
    Modeling.prototype.removeElements = function (elements) {
        var context = {elements: elements};
        this._commandStack.execute('elements.delete', context);
    };
    Modeling.prototype.distributeElements = function (groups, axis, dimension) {
        var context = {groups: groups, axis: axis, dimension: dimension};
        this._commandStack.execute('elements.distribute', context);
    };
    Modeling.prototype.removeShape = function (shape, hints) {
        var context = {shape: shape, hints: hints || {}};
        this._commandStack.execute('shape.delete', context);
    };
    Modeling.prototype.removeConnection = function (connection, hints) {
        var context = {connection: connection, hints: hints || {}};
        this._commandStack.execute('connection.delete', context);
    };
    Modeling.prototype.replaceShape = function (oldShape, newShape, hints) {
        var context = {oldShape: oldShape, newData: newShape, hints: hints || {}};
        this._commandStack.execute('shape.replace', context);
        return context.newShape;
    };
    Modeling.prototype.pasteElements = function (tree, topParent, position) {
        var context = {tree: tree, topParent: topParent, position: position};
        this._commandStack.execute('elements.paste', context);
    };
    Modeling.prototype.alignElements = function (elements, alignment) {
        var context = {elements: elements, alignment: alignment};
        this._commandStack.execute('elements.align', context);
    };
    Modeling.prototype.resizeShape = function (shape, newBounds, minBounds) {
        var context = {shape: shape, newBounds: newBounds, minBounds: minBounds};
        this._commandStack.execute('shape.resize', context);
    };
    Modeling.prototype.createSpace = function (movingShapes, resizingShapes, delta, direction) {
        var context = {movingShapes: movingShapes, resizingShapes: resizingShapes, delta: delta, direction: direction};
        this._commandStack.execute('spaceTool', context);
    };
    Modeling.prototype.updateWaypoints = function (connection, newWaypoints, hints) {
        var context = {connection: connection, newWaypoints: newWaypoints, hints: hints || {}};
        this._commandStack.execute('connection.updateWaypoints', context);
    };
    Modeling.prototype.reconnectStart = function (connection, newSource, dockingOrPoints) {
        var context = {connection: connection, newSource: newSource, dockingOrPoints: dockingOrPoints};
        this._commandStack.execute('connection.reconnectStart', context);
    };
    Modeling.prototype.reconnectEnd = function (connection, newTarget, dockingOrPoints) {
        var context = {connection: connection, newTarget: newTarget, dockingOrPoints: dockingOrPoints};
        this._commandStack.execute('connection.reconnectEnd', context);
    };
    Modeling.prototype.connect = function (source, target, attrs, hints) {
        return this.createConnection(source, target, attrs || {}, source.parent, hints);
    };
    Modeling.prototype._create = function (type, attrs) {
        if (attrs instanceof Base) {
            return attrs;
        } else {
            return this._elementFactory.create(type, attrs);
        }
    };
    Modeling.prototype.toggleCollapse = function (shape, hints) {
        var context = {shape: shape, hints: hints || {}};
        this._commandStack.execute('shape.toggleCollapse', context);
    };
    var DEFAULT_FLOW = 'default', ID = 'id', DI = 'di';
    var NULL_DIMENSIONS = {width: 0, height: 0};

    function UpdatePropertiesHandler(elementRegistry, moddle, translate, modeling, textRenderer) {
        this._elementRegistry = elementRegistry;
        this._moddle = moddle;
        this._translate = translate;
        this._modeling = modeling;
        this._textRenderer = textRenderer;
    }

    UpdatePropertiesHandler.$inject = ['elementRegistry', 'moddle', 'translate', 'modeling', 'textRenderer'];
    UpdatePropertiesHandler.prototype.execute = function (context) {
        var element = context.element, changed = [element], translate = this._translate;
        if (!element) {
            throw new Error(translate('element required'));
        }
        var elementRegistry = this._elementRegistry, ids = this._moddle.ids;
        var businessObject = element.businessObject, properties = unwrapBusinessObjects(context.properties),
            oldProperties = context.oldProperties || getProperties$1(businessObject, properties);
        if (isIdChange(properties, businessObject)) {
            ids.unclaim(businessObject[ID]);
            elementRegistry.updateId(element, properties[ID]);
            ids.claim(properties[ID], businessObject);
        }
        if (DEFAULT_FLOW in properties) {
            if (properties[DEFAULT_FLOW]) {
                changed.push(elementRegistry.get(properties[DEFAULT_FLOW].id));
            }
            if (businessObject[DEFAULT_FLOW]) {
                changed.push(elementRegistry.get(businessObject[DEFAULT_FLOW].id));
            }
        }
        setProperties$1(businessObject, properties);
        context.oldProperties = oldProperties;
        context.changed = changed;
        return changed;
    };
    UpdatePropertiesHandler.prototype.postExecute = function (context) {
        var element = context.element, label = element.label;
        var text = label && getBusinessObject(label).name;
        if (!text) {
            return;
        }
        var newLabelBounds = this._textRenderer.getExternalLabelBounds(label, text);
        this._modeling.resizeShape(label, newLabelBounds, NULL_DIMENSIONS);
    };
    UpdatePropertiesHandler.prototype.revert = function (context) {
        var element = context.element, properties = context.properties, oldProperties = context.oldProperties,
            businessObject = element.businessObject, elementRegistry = this._elementRegistry, ids = this._moddle.ids;
        setProperties$1(businessObject, oldProperties);
        if (isIdChange(properties, businessObject)) {
            ids.unclaim(properties[ID]);
            elementRegistry.updateId(element, oldProperties[ID]);
            ids.claim(oldProperties[ID], businessObject);
        }
        return context.changed;
    };

    function isIdChange(properties, businessObject) {
        return ID in properties && properties[ID] !== businessObject[ID];
    }

    function getProperties$1(businessObject, properties) {
        var propertyNames = keys(properties);
        return reduce(propertyNames, function (result, key) {
            if (key !== DI) {
                result[key] = businessObject.get(key);
            } else {
                result[key] = getDiProperties(businessObject.di, keys(properties.di));
            }
            return result;
        }, {});
    }

    function getDiProperties(di, propertyNames) {
        return reduce(propertyNames, function (result, key) {
            result[key] = di.get(key);
            return result;
        }, {});
    }

    function setProperties$1(businessObject, properties) {
        forEach(properties, function (value, key) {
            if (key !== DI) {
                businessObject.set(key, value);
            } else {
                if (businessObject.di) {
                    setDiProperties(businessObject.di, value);
                }
            }
        });
    }

    function setDiProperties(di, properties) {
        forEach(properties, function (value, key) {
            di.set(key, value);
        });
    }

    var referencePropertyNames = ['default'];

    function unwrapBusinessObjects(properties) {
        var unwrappedProps = assign({}, properties);
        referencePropertyNames.forEach(function (name) {
            if (name in properties) {
                unwrappedProps[name] = getBusinessObject(unwrappedProps[name]);
            }
        });
        return unwrappedProps;
    }

    function UpdateCanvasRootHandler(canvas, modeling) {
        this._canvas = canvas;
        this._modeling = modeling;
    }

    UpdateCanvasRootHandler.$inject = ['canvas', 'modeling'];
    UpdateCanvasRootHandler.prototype.execute = function (context) {
        var canvas = this._canvas;
        var newRoot = context.newRoot, newRootBusinessObject = newRoot.businessObject,
            oldRoot = canvas.getRootElement(), oldRootBusinessObject = oldRoot.businessObject,
            bpmnDefinitions = oldRootBusinessObject.$parent, diPlane = oldRootBusinessObject.di;
        canvas.setRootElement(newRoot, true);
        add(bpmnDefinitions.rootElements, newRootBusinessObject);
        newRootBusinessObject.$parent = bpmnDefinitions;
        remove$2(bpmnDefinitions.rootElements, oldRootBusinessObject);
        oldRootBusinessObject.$parent = null;
        oldRootBusinessObject.di = null;
        diPlane.bpmnElement = newRootBusinessObject;
        newRootBusinessObject.di = diPlane;
        context.oldRoot = oldRoot;
    };
    UpdateCanvasRootHandler.prototype.revert = function (context) {
        var canvas = this._canvas;
        var newRoot = context.newRoot, newRootBusinessObject = newRoot.businessObject, oldRoot = context.oldRoot,
            oldRootBusinessObject = oldRoot.businessObject, bpmnDefinitions = newRootBusinessObject.$parent,
            diPlane = newRootBusinessObject.di;
        canvas.setRootElement(oldRoot, true);
        remove$2(bpmnDefinitions.rootElements, newRootBusinessObject);
        newRootBusinessObject.$parent = null;
        add(bpmnDefinitions.rootElements, oldRootBusinessObject);
        oldRootBusinessObject.$parent = bpmnDefinitions;
        newRootBusinessObject.di = null;
        diPlane.bpmnElement = oldRootBusinessObject;
        oldRootBusinessObject.di = diPlane;
    };

    function AddLaneHandler(modeling, spaceTool) {
        this._modeling = modeling;
        this._spaceTool = spaceTool;
    }

    AddLaneHandler.$inject = ['modeling', 'spaceTool'];
    AddLaneHandler.prototype.preExecute = function (context) {
        var spaceTool = this._spaceTool, modeling = this._modeling;
        var shape = context.shape, location = context.location;
        var lanesRoot = getLanesRoot(shape);
        var isRoot = lanesRoot === shape, laneParent = isRoot ? shape : shape.parent;
        var existingChildLanes = getChildLanes(laneParent);
        if (!existingChildLanes.length) {
            modeling.createShape({type: 'bpmn:Lane'}, {
                x: shape.x + LANE_INDENTATION,
                y: shape.y,
                width: shape.width - LANE_INDENTATION,
                height: shape.height
            }, laneParent);
        }
        var allAffected = [];
        eachElement(lanesRoot, function (element) {
            allAffected.push(element);
            if (element === shape) {
                return [];
            }
            return filter(element.children, function (c) {
                return c !== shape;
            });
        });
        var offset = location === 'top' ? -120 : 120,
            lanePosition = location === 'top' ? shape.y : shape.y + shape.height,
            spacePos = lanePosition + (location === 'top' ? 10 : -10), direction = location === 'top' ? 'n' : 's';
        var adjustments = spaceTool.calculateAdjustments(allAffected, 'y', offset, spacePos);
        spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {x: 0, y: offset}, direction);
        context.newLane = modeling.createShape({type: 'bpmn:Lane'}, {
            x: shape.x + (isRoot ? LANE_INDENTATION : 0),
            y: lanePosition - (location === 'top' ? 120 : 0),
            width: shape.width - (isRoot ? LANE_INDENTATION : 0),
            height: 120
        }, laneParent);
    };

    function SplitLaneHandler(modeling, translate) {
        this._modeling = modeling;
        this._translate = translate;
    }

    SplitLaneHandler.$inject = ['modeling', 'translate'];
    SplitLaneHandler.prototype.preExecute = function (context) {
        var modeling = this._modeling, translate = this._translate;
        var shape = context.shape, newLanesCount = context.count;
        var childLanes = getChildLanes(shape), existingLanesCount = childLanes.length;
        if (existingLanesCount > newLanesCount) {
            throw new Error(translate('more than {count} child lanes', {count: newLanesCount}));
        }
        var newLanesHeight = Math.round(shape.height / newLanesCount);
        var laneY, laneHeight, laneBounds, newLaneAttrs, idx;
        for (idx = 0; idx < newLanesCount; idx++) {
            laneY = shape.y + idx * newLanesHeight;
            if (idx === newLanesCount - 1) {
                laneHeight = shape.height - (newLanesHeight * idx);
            } else {
                laneHeight = newLanesHeight;
            }
            laneBounds = {
                x: shape.x + LANE_INDENTATION,
                y: laneY,
                width: shape.width - LANE_INDENTATION,
                height: laneHeight
            };
            if (idx < existingLanesCount) {
                modeling.resizeShape(childLanes[idx], laneBounds);
            } else {
                newLaneAttrs = {type: 'bpmn:Lane'};
                modeling.createShape(newLaneAttrs, laneBounds, shape);
            }
        }
    };

    function ResizeLaneHandler(modeling, spaceTool) {
        this._modeling = modeling;
        this._spaceTool = spaceTool;
    }

    ResizeLaneHandler.$inject = ['modeling', 'spaceTool'];
    ResizeLaneHandler.prototype.preExecute = function (context) {
        var shape = context.shape, newBounds = context.newBounds, balanced = context.balanced;
        if (balanced !== false) {
            this.resizeBalanced(shape, newBounds);
        } else {
            this.resizeSpace(shape, newBounds);
        }
    };
    ResizeLaneHandler.prototype.resizeBalanced = function (shape, newBounds) {
        var modeling = this._modeling;
        var resizeNeeded = computeLanesResize(shape, newBounds);
        modeling.resizeShape(shape, newBounds);
        resizeNeeded.forEach(function (r) {
            modeling.resizeShape(r.shape, r.newBounds);
        });
    };
    ResizeLaneHandler.prototype.resizeSpace = function (shape, newBounds) {
        var spaceTool = this._spaceTool;
        var shapeTrbl = asTRBL(shape), newTrbl = asTRBL(newBounds);
        var trblDiff = substractTRBL(newTrbl, shapeTrbl);
        var lanesRoot = getLanesRoot(shape);
        var allAffected = [], allLanes = [];
        eachElement(lanesRoot, function (element) {
            allAffected.push(element);
            if (is$1(element, 'bpmn:Lane') || is$1(element, 'bpmn:Participant')) {
                allLanes.push(element);
            }
            return element.children;
        });
        var change, spacePos, direction, offset, adjustments;
        if (trblDiff.bottom || trblDiff.top) {
            change = trblDiff.bottom || trblDiff.top;
            spacePos = shape.y + (trblDiff.bottom ? shape.height : 0) + (trblDiff.bottom ? -10 : 10);
            direction = trblDiff.bottom ? 's' : 'n';
            offset = trblDiff.top > 0 || trblDiff.bottom < 0 ? -change : change;
            adjustments = spaceTool.calculateAdjustments(allAffected, 'y', offset, spacePos);
            spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {x: 0, y: change}, direction);
        }
        if (trblDiff.left || trblDiff.right) {
            change = trblDiff.right || trblDiff.left;
            spacePos = shape.x + (trblDiff.right ? shape.width : 0) + (trblDiff.right ? -10 : 100);
            direction = trblDiff.right ? 'e' : 'w';
            offset = trblDiff.left > 0 || trblDiff.right < 0 ? -change : change;
            adjustments = spaceTool.calculateAdjustments(allLanes, 'x', offset, spacePos);
            spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {x: change, y: 0}, direction);
        }
    };
    var FLOW_NODE_REFS_ATTR = 'flowNodeRef', LANES_ATTR = 'lanes';

    function UpdateFlowNodeRefsHandler(elementRegistry) {
        this._elementRegistry = elementRegistry;
    }

    UpdateFlowNodeRefsHandler.$inject = ['elementRegistry'];
    UpdateFlowNodeRefsHandler.prototype.computeUpdates = function (flowNodeShapes, laneShapes) {
        var handledNodes = {};
        var updates = [];
        var participantCache = {};
        var allFlowNodeShapes = [];

        function isInLaneShape(element, laneShape) {
            var laneTrbl = asTRBL(laneShape);
            var elementMid = {x: element.x + element.width / 2, y: element.y + element.height / 2};
            return elementMid.x > laneTrbl.left && elementMid.x < laneTrbl.right && elementMid.y > laneTrbl.top && elementMid.y < laneTrbl.bottom;
        }

        function addFlowNodeShape(flowNodeShape) {
            if (!handledNodes[flowNodeShape.id]) {
                allFlowNodeShapes.push(flowNodeShape);
                handledNodes[flowNodeShape.id] = flowNodeShape;
            }
        }

        function getAllLaneShapes(flowNodeShape) {
            var root = getLanesRoot(flowNodeShape);
            if (!participantCache[root.id]) {
                participantCache[root.id] = collectLanes(root);
            }
            return participantCache[root.id];
        }

        function getNewLanes(flowNodeShape) {
            if (!flowNodeShape.parent) {
                return [];
            }
            var allLaneShapes = getAllLaneShapes(flowNodeShape);
            return allLaneShapes.filter(function (l) {
                return isInLaneShape(flowNodeShape, l);
            }).map(function (shape) {
                return shape.businessObject;
            });
        }

        laneShapes.forEach(function (laneShape) {
            var root = getLanesRoot(laneShape);
            if (!root || handledNodes[root.id]) {
                return;
            }
            var children = root.children.filter(function (c) {
                return is$1(c, 'bpmn:FlowNode');
            });
            children.forEach(addFlowNodeShape);
            handledNodes[root.id] = root;
        });
        flowNodeShapes.forEach(addFlowNodeShape);
        allFlowNodeShapes.forEach(function (flowNodeShape) {
            var flowNode = flowNodeShape.businessObject;
            var lanes = flowNode.get(LANES_ATTR), remove$$1 = lanes.slice(), add$$1 = getNewLanes(flowNodeShape);
            updates.push({flowNode: flowNode, remove: remove$$1, add: add$$1});
        });
        laneShapes.forEach(function (laneShape) {
            var lane = laneShape.businessObject;
            if (!laneShape.parent) {
                lane.get(FLOW_NODE_REFS_ATTR).forEach(function (flowNode) {
                    updates.push({flowNode: flowNode, remove: [lane], add: []});
                });
            }
        });
        return updates;
    };
    UpdateFlowNodeRefsHandler.prototype.execute = function (context) {
        var updates = context.updates;
        if (!updates) {
            updates = context.updates = this.computeUpdates(context.flowNodeShapes, context.laneShapes);
        }
        updates.forEach(function (update) {
            var flowNode = update.flowNode, lanes = flowNode.get(LANES_ATTR);
            update.remove.forEach(function (oldLane) {
                remove$2(lanes, oldLane);
                remove$2(oldLane.get(FLOW_NODE_REFS_ATTR), flowNode);
            });
            update.add.forEach(function (newLane) {
                add(lanes, newLane);
                add(newLane.get(FLOW_NODE_REFS_ATTR), flowNode);
            });
        });
    };
    UpdateFlowNodeRefsHandler.prototype.revert = function (context) {
        var updates = context.updates;
        updates.forEach(function (update) {
            var flowNode = update.flowNode, lanes = flowNode.get(LANES_ATTR);
            update.add.forEach(function (newLane) {
                remove$2(lanes, newLane);
                remove$2(newLane.get(FLOW_NODE_REFS_ATTR), flowNode);
            });
            update.remove.forEach(function (oldLane) {
                add(lanes, oldLane);
                add(oldLane.get(FLOW_NODE_REFS_ATTR), flowNode);
            });
        });
    };

    function IdClaimHandler(moddle) {
        this._moddle = moddle;
    }

    IdClaimHandler.$inject = ['moddle'];
    IdClaimHandler.prototype.execute = function (context) {
        var ids = this._moddle.ids, id = context.id, element = context.element, claiming = context.claiming;
        if (claiming) {
            ids.claim(id, element);
        } else {
            ids.unclaim(id);
        }
    };
    IdClaimHandler.prototype.revert = function (context) {
        var ids = this._moddle.ids, id = context.id, element = context.element, claiming = context.claiming;
        if (claiming) {
            ids.unclaim(id);
        } else {
            ids.claim(id, element);
        }
    };
    var DEFAULT_COLORS = {fill: undefined, stroke: undefined};

    function SetColorHandler(commandStack) {
        this._commandStack = commandStack;
    }

    SetColorHandler.$inject = ['commandStack'];
    SetColorHandler.prototype.postExecute = function (context) {
        var elements = context.elements, colors = context.colors || DEFAULT_COLORS;
        var self = this;
        var di = {};
        if ('fill' in colors) {
            assign(di, {fill: colors.fill});
        }
        if ('stroke' in colors) {
            assign(di, {stroke: colors.stroke});
        }
        forEach(elements, function (element) {
            self._commandStack.execute('element.updateProperties', {element: element, properties: {di: di}});
        });
    };
    var NULL_DIMENSIONS$1 = {width: 0, height: 0};

    function UpdateLabelHandler(modeling, textRenderer) {
        function setText(element, text) {
            var label = element.label || element;
            var labelTarget = element.labelTarget || element;
            setLabel(label, text, labelTarget !== label);
            return [label, labelTarget];
        }

        function preExecute(ctx) {
            var element = ctx.element, businessObject = element.businessObject, newLabel = ctx.newLabel;
            if (!isLabel(element) && isLabelExternal(element) && !hasExternalLabel(element) && !isEmptyText$1(newLabel)) {
                var paddingTop = 7;
                var labelCenter = getExternalLabelMid(element);
                labelCenter = {x: labelCenter.x, y: labelCenter.y + paddingTop};
                modeling.createLabel(element, labelCenter, {
                    id: businessObject.id + '_label',
                    businessObject: businessObject
                });
            }
        }

        function execute(ctx) {
            ctx.oldLabel = getLabel(ctx.element);
            return setText(ctx.element, ctx.newLabel);
        }

        function revert(ctx) {
            return setText(ctx.element, ctx.oldLabel);
        }

        function postExecute(ctx) {
            var element = ctx.element, label = element.label || element, newLabel = ctx.newLabel,
                newBounds = ctx.newBounds, hints = ctx.hints || {};
            if (isLabel(label) && isEmptyText$1(newLabel)) {
                if (hints.removeShape !== false) {
                    modeling.removeShape(label, {unsetLabel: false});
                }
                return;
            }
            if (!isLabelExternal(element) && !is$1(element, 'bpmn:TextAnnotation')) {
                return;
            }
            var bo = getBusinessObject(label);
            var text = bo.name || bo.text;
            if (!text) {
                return;
            }
            if (typeof newBounds === 'undefined') {
                newBounds = textRenderer.getExternalLabelBounds(label, text);
            }
            if (newBounds) {
                modeling.resizeShape(label, newBounds, NULL_DIMENSIONS$1);
            }
        }

        this.preExecute = preExecute;
        this.execute = execute;
        this.revert = revert;
        this.postExecute = postExecute;
    }

    UpdateLabelHandler.$inject = ['modeling', 'textRenderer'];

    function isEmptyText$1(label) {
        return !label || !label.trim();
    }

    function Modeling$1(eventBus, elementFactory, commandStack, bpmnRules) {
        Modeling.call(this, eventBus, elementFactory, commandStack);
        this._bpmnRules = bpmnRules;
    }

    inherits_browser(Modeling$1, Modeling);
    Modeling$1.$inject = ['eventBus', 'elementFactory', 'commandStack', 'bpmnRules'];
    Modeling$1.prototype.getHandlers = function () {
        var handlers = Modeling.prototype.getHandlers.call(this);
        handlers['element.updateProperties'] = UpdatePropertiesHandler;
        handlers['canvas.updateRoot'] = UpdateCanvasRootHandler;
        handlers['lane.add'] = AddLaneHandler;
        handlers['lane.resize'] = ResizeLaneHandler;
        handlers['lane.split'] = SplitLaneHandler;
        handlers['lane.updateRefs'] = UpdateFlowNodeRefsHandler;
        handlers['id.updateClaim'] = IdClaimHandler;
        handlers['element.setColor'] = SetColorHandler;
        handlers['element.updateLabel'] = UpdateLabelHandler;
        return handlers;
    };
    Modeling$1.prototype.updateLabel = function (element, newLabel, newBounds, hints) {
        this._commandStack.execute('element.updateLabel', {
            element: element,
            newLabel: newLabel,
            newBounds: newBounds,
            hints: hints || {}
        });
    };
    Modeling$1.prototype.connect = function (source, target, attrs, hints) {
        var bpmnRules = this._bpmnRules;
        if (!attrs) {
            attrs = bpmnRules.canConnect(source, target);
        }
        if (!attrs) {
            return;
        }
        return this.createConnection(source, target, attrs, source.parent, hints);
    };
    Modeling$1.prototype.updateProperties = function (element, properties) {
        this._commandStack.execute('element.updateProperties', {element: element, properties: properties});
    };
    Modeling$1.prototype.resizeLane = function (laneShape, newBounds, balanced) {
        this._commandStack.execute('lane.resize', {shape: laneShape, newBounds: newBounds, balanced: balanced});
    };
    Modeling$1.prototype.addLane = function (targetLaneShape, location) {
        var context = {shape: targetLaneShape, location: location};
        this._commandStack.execute('lane.add', context);
        return context.newLane;
    };
    Modeling$1.prototype.splitLane = function (targetLane, count) {
        this._commandStack.execute('lane.split', {shape: targetLane, count: count});
    };
    Modeling$1.prototype.makeCollaboration = function () {
        var collaborationElement = this._create('root', {type: 'bpmn:Collaboration'});
        var context = {newRoot: collaborationElement};
        this._commandStack.execute('canvas.updateRoot', context);
        return collaborationElement;
    };
    Modeling$1.prototype.updateLaneRefs = function (flowNodeShapes, laneShapes) {
        this._commandStack.execute('lane.updateRefs', {flowNodeShapes: flowNodeShapes, laneShapes: laneShapes});
    };
    Modeling$1.prototype.makeProcess = function () {
        var processElement = this._create('root', {type: 'bpmn:Process'});
        var context = {newRoot: processElement};
        this._commandStack.execute('canvas.updateRoot', context);
    };
    Modeling$1.prototype.claimId = function (id, moddleElement) {
        this._commandStack.execute('id.updateClaim', {id: id, element: moddleElement, claiming: true});
    };
    Modeling$1.prototype.unclaimId = function (id, moddleElement) {
        this._commandStack.execute('id.updateClaim', {id: id, element: moddleElement});
    };
    Modeling$1.prototype.setColor = function (elements, colors) {
        if (!elements.length) {
            elements = [elements];
        }
        this._commandStack.execute('element.setColor', {elements: elements, colors: colors});
    };

    function BaseLayouter() {
    }

    BaseLayouter.prototype.layoutConnection = function (connection, hints) {
        hints = hints || {};
        return [hints.connectionStart || getMid(connection.source), hints.connectionEnd || getMid(connection.target)];
    };
    var MIN_SEGMENT_LENGTH = 20, POINT_ORIENTATION_PADDING = 5;
    var round$8 = Math.round;
    var INTERSECTION_THRESHOLD$1 = 20, ORIENTATION_THRESHOLD = {'h:h': 20, 'v:v': 20, 'h:v': -10, 'v:h': -10};

    function needsTurn(orientation, startDirection) {
        return !{t: /top/, r: /right/, b: /bottom/, l: /left/, h: /./, v: /./}[startDirection].test(orientation);
    }

    function canLayoutStraight(direction, targetOrientation) {
        return {
            t: /top/,
            r: /right/,
            b: /bottom/,
            l: /left/,
            h: /left|right/,
            v: /top|bottom/
        }[direction].test(targetOrientation);
    }

    function getSegmentBendpoints(a, b, directions) {
        var orientation = getOrientation(b, a, POINT_ORIENTATION_PADDING);
        var startDirection = directions.split(':')[0];
        var xmid = round$8((b.x - a.x) / 2 + a.x), ymid = round$8((b.y - a.y) / 2 + a.y);
        var segmentEnd, segmentDirections;
        var layoutStraight = canLayoutStraight(startDirection, orientation),
            layoutHorizontal = /h|r|l/.test(startDirection), layoutTurn = false;
        var turnNextDirections = false;
        if (layoutStraight) {
            segmentEnd = layoutHorizontal ? {x: xmid, y: a.y} : {x: a.x, y: ymid};
            segmentDirections = layoutHorizontal ? 'h:h' : 'v:v';
        } else {
            layoutTurn = needsTurn(orientation, startDirection);
            segmentDirections = layoutHorizontal ? 'h:v' : 'v:h';
            if (layoutTurn) {
                if (layoutHorizontal) {
                    turnNextDirections = ymid === a.y;
                    segmentEnd = {
                        x: a.x + MIN_SEGMENT_LENGTH * (/l/.test(startDirection) ? -1 : 1),
                        y: turnNextDirections ? ymid + MIN_SEGMENT_LENGTH : ymid
                    };
                } else {
                    turnNextDirections = xmid === a.x;
                    segmentEnd = {
                        x: turnNextDirections ? xmid + MIN_SEGMENT_LENGTH : xmid,
                        y: a.y + MIN_SEGMENT_LENGTH * (/t/.test(startDirection) ? -1 : 1)
                    };
                }
            } else {
                segmentEnd = {x: xmid, y: ymid};
            }
        }
        return {
            waypoints: getBendpoints(a, segmentEnd, segmentDirections).concat(segmentEnd),
            directions: segmentDirections,
            turnNextDirections: turnNextDirections
        };
    }

    function getStartSegment(a, b, directions) {
        return getSegmentBendpoints(a, b, directions);
    }

    function getEndSegment(a, b, directions) {
        var invertedSegment = getSegmentBendpoints(b, a, invertDirections(directions));
        return {
            waypoints: invertedSegment.waypoints.slice().reverse(),
            directions: invertDirections(invertedSegment.directions),
            turnNextDirections: invertedSegment.turnNextDirections
        };
    }

    function getMidSegment(startSegment, endSegment) {
        var startDirection = startSegment.directions.split(':')[1], endDirection = endSegment.directions.split(':')[0];
        if (startSegment.turnNextDirections) {
            startDirection = startDirection == 'h' ? 'v' : 'h';
        }
        if (endSegment.turnNextDirections) {
            endDirection = endDirection == 'h' ? 'v' : 'h';
        }
        var directions = startDirection + ':' + endDirection;
        var bendpoints = getBendpoints(startSegment.waypoints[startSegment.waypoints.length - 1], endSegment.waypoints[0], directions);
        return {waypoints: bendpoints, directions: directions};
    }

    function invertDirections(directions) {
        return directions.split(':').reverse().join(':');
    }

    function getSimpleBendpoints(a, b, directions) {
        var xmid = round$8((b.x - a.x) / 2 + a.x), ymid = round$8((b.y - a.y) / 2 + a.y);
        if (directions === 'h:v') {
            return [{x: b.x, y: a.y}];
        }
        if (directions === 'v:h') {
            return [{x: a.x, y: b.y}];
        }
        if (directions === 'h:h') {
            return [{x: xmid, y: a.y}, {x: xmid, y: b.y}];
        }
        if (directions === 'v:v') {
            return [{x: a.x, y: ymid}, {x: b.x, y: ymid}];
        }
        throw new Error('invalid directions: can only handle varians of [hv]:[hv]');
    }

    function getBendpoints(a, b, directions) {
        directions = directions || 'h:h';
        if (!isValidDirections(directions)) {
            throw new Error('unknown directions: <' + directions + '>: ' + 'must be specified as <start>:<end> ' + 'with start/end in { h,v,t,r,b,l }');
        }
        if (isExplicitDirections(directions)) {
            var startSegment = getStartSegment(a, b, directions), endSegment = getEndSegment(a, b, directions),
                midSegment = getMidSegment(startSegment, endSegment);
            return [].concat(startSegment.waypoints, midSegment.waypoints, endSegment.waypoints);
        }
        return getSimpleBendpoints(a, b, directions);
    }

    function connectPoints(a, b, directions) {
        var points = getBendpoints(a, b, directions);
        points.unshift(a);
        points.push(b);
        return withoutRedundantPoints(points);
    }

    function connectRectangles(source, target, start, end, hints) {
        var preferredLayouts = hints && hints.preferredLayouts || [];
        var preferredLayout = without(preferredLayouts, 'straight')[0] || 'h:h';
        var threshold = ORIENTATION_THRESHOLD[preferredLayout] || 0;
        var orientation = getOrientation(source, target, threshold);
        var directions = getDirections(orientation, preferredLayout);
        start = start || getMid(source);
        end = end || getMid(target);
        var directionSplit = directions.split(':');
        var startDocking = getDockingPoint(start, source, directionSplit[0], invertOrientation(orientation)),
            endDocking = getDockingPoint(end, target, directionSplit[1], orientation);
        return connectPoints(startDocking, endDocking, directions);
    }

    function repairConnection(source, target, start, end, waypoints, hints) {
        if (isArray(start)) {
            waypoints = start;
            hints = end;
            start = getMid(source);
            end = getMid(target);
        }
        hints = assign({preferredLayouts: []}, hints);
        waypoints = waypoints || [];
        var preferredLayouts = hints.preferredLayouts, preferStraight = preferredLayouts.indexOf('straight') !== -1,
            repairedWaypoints;
        if (preferStraight) {
            repairedWaypoints = layoutStraight(source, target, start, end, hints);
        }
        if (!repairedWaypoints) {
            if (hints.connectionEnd) {
                repairedWaypoints = _repairConnectionSide(target, source, end, waypoints.slice().reverse());
                repairedWaypoints = repairedWaypoints && repairedWaypoints.reverse();
            } else if (hints.connectionStart) {
                repairedWaypoints = _repairConnectionSide(source, target, start, waypoints);
            } else if (waypoints && waypoints.length) {
                repairedWaypoints = waypoints;
            }
        }
        if (!repairedWaypoints) {
            repairedWaypoints = connectRectangles(source, target, start, end, hints);
        }
        return repairedWaypoints;
    }

    function inRange(a, start, end) {
        return a >= start && a <= end;
    }

    function isInRange(axis, a, b) {
        var size$$1 = {x: 'width', y: 'height'};
        return inRange(a[axis], b[axis], b[axis] + b[size$$1[axis]]);
    }

    function layoutStraight(source, target, start, end, hints) {
        var axis = {}, primaryAxis, orientation;
        orientation = getOrientation(source, target);
        if (!/^(top|bottom|left|right)$/.test(orientation)) {
            return null;
        }
        if (/top|bottom/.test(orientation)) {
            primaryAxis = 'x';
        }
        if (/left|right/.test(orientation)) {
            primaryAxis = 'y';
        }
        if (hints.preserveDocking === 'target') {
            if (!isInRange(primaryAxis, end, source)) {
                return null;
            }
            axis[primaryAxis] = end[primaryAxis];
            return [{
                x: axis.x !== undefined ? axis.x : start.x,
                y: axis.y !== undefined ? axis.y : start.y,
                original: {x: axis.x !== undefined ? axis.x : start.x, y: axis.y !== undefined ? axis.y : start.y}
            }, {x: end.x, y: end.y}];
        } else {
            if (!isInRange(primaryAxis, start, target)) {
                return null;
            }
            axis[primaryAxis] = start[primaryAxis];
            return [{x: start.x, y: start.y}, {
                x: axis.x !== undefined ? axis.x : end.x,
                y: axis.y !== undefined ? axis.y : end.y,
                original: {x: axis.x !== undefined ? axis.x : end.x, y: axis.y !== undefined ? axis.y : end.y}
            }];
        }
    }

    function _repairConnectionSide(moved, other, newDocking, points) {
        function needsRelayout(moved, other, points) {
            if (points.length < 3) {
                return true;
            }
            if (points.length > 4) {
                return false;
            }
            return !!find(points, function (p, idx) {
                var q = points[idx - 1];
                return q && pointDistance(p, q) < 3;
            });
        }

        function repairBendpoint(candidate, oldPeer, newPeer) {
            var alignment = pointsAligned(oldPeer, candidate);
            switch (alignment) {
                case'v':
                    return {x: candidate.x, y: newPeer.y};
                case'h':
                    return {x: newPeer.x, y: candidate.y};
            }
            return {x: candidate.x, y: candidate.y};
        }

        function removeOverlapping(points, a, b) {
            var i;
            for (i = points.length - 2; i !== 0; i--) {
                if (pointInRect(points[i], a, INTERSECTION_THRESHOLD$1) || pointInRect(points[i], b, INTERSECTION_THRESHOLD$1)) {
                    return points.slice(i);
                }
            }
            return points;
        }

        if (needsRelayout(moved, other, points)) {
            return null;
        }
        var oldDocking = points[0], newPoints = points.slice(), slicedPoints;
        newPoints[0] = newDocking;
        newPoints[1] = repairBendpoint(newPoints[1], oldDocking, newDocking);
        slicedPoints = removeOverlapping(newPoints, moved, other);
        if (slicedPoints !== newPoints) {
            return _repairConnectionSide(moved, other, newDocking, slicedPoints);
        }
        return newPoints;
    }

    function getDirections(orientation, defaultLayout) {
        if (isExplicitDirections(defaultLayout)) {
            return defaultLayout;
        }
        switch (orientation) {
            case'intersect':
                return 't:t';
            case'top':
            case'bottom':
                return 'v:v';
            case'left':
            case'right':
                return 'h:h';
            default:
                return defaultLayout;
        }
    }

    function isValidDirections(directions) {
        return directions && /^h|v|t|r|b|l:h|v|t|r|b|l$/.test(directions);
    }

    function isExplicitDirections(directions) {
        return directions && /t|r|b|l/.test(directions);
    }

    function invertOrientation(orientation) {
        return {
            'top': 'bottom',
            'bottom': 'top',
            'left': 'right',
            'right': 'left',
            'top-left': 'bottom-right',
            'bottom-right': 'top-left',
            'top-right': 'bottom-left',
            'bottom-left': 'top-right',
        }[orientation];
    }

    function getDockingPoint(point, rectangle, dockingDirection, targetOrientation) {
        if (dockingDirection === 'h') {
            dockingDirection = /left/.test(targetOrientation) ? 'l' : 'r';
        }
        if (dockingDirection === 'v') {
            dockingDirection = /top/.test(targetOrientation) ? 't' : 'b';
        }
        if (dockingDirection === 't') {
            return {original: point, x: point.x, y: rectangle.y};
        }
        if (dockingDirection === 'r') {
            return {original: point, x: rectangle.x + rectangle.width, y: point.y};
        }
        if (dockingDirection === 'b') {
            return {original: point, x: point.x, y: rectangle.y + rectangle.height};
        }
        if (dockingDirection === 'l') {
            return {original: point, x: rectangle.x, y: point.y};
        }
        throw new Error('unexpected dockingDirection: <' + dockingDirection + '>');
    }

    function withoutRedundantPoints(waypoints) {
        return waypoints.reduce(function (points, p, idx) {
            var previous = points[points.length - 1], next = waypoints[idx + 1];
            if (!pointsOnLine(previous, next, p, 0)) {
                points.push(p);
            }
            return points;
        }, []);
    }

    function BpmnLayouter() {
    }

    inherits_browser(BpmnLayouter, BaseLayouter);
    BpmnLayouter.prototype.layoutConnection = function (connection, hints) {
        hints = hints || {};
        var source = connection.source, target = connection.target, waypoints = connection.waypoints,
            start = hints.connectionStart, end = hints.connectionEnd;
        var manhattanOptions, updatedWaypoints;
        if (!start) {
            start = getConnectionDocking(waypoints && waypoints[0], source);
        }
        if (!end) {
            end = getConnectionDocking(waypoints && waypoints[waypoints.length - 1], target);
        }
        if (is$1(connection, 'bpmn:Association') || is$1(connection, 'bpmn:DataAssociation')) {
            if (waypoints && !isCompensationAssociation(connection)) {
                return [].concat([start], waypoints.slice(1, -1), [end]);
            }
        }
        if (is$1(connection, 'bpmn:MessageFlow')) {
            manhattanOptions = getMessageFlowManhattanOptions(source, target);
        } else if (is$1(connection, 'bpmn:SequenceFlow') || isCompensationAssociation(connection)) {
            if (source === target) {
                manhattanOptions = {preferredLayouts: ['b:l']};
            } else if (is$1(source, 'bpmn:BoundaryEvent')) {
                manhattanOptions = {preferredLayouts: getBoundaryEventPreferredLayouts(source, target)};
            } else if (is$1(source, 'bpmn:Gateway')) {
                manhattanOptions = {preferredLayouts: ['v:h']};
            } else if (is$1(target, 'bpmn:Gateway')) {
                manhattanOptions = {preferredLayouts: ['h:v']};
            } else {
                manhattanOptions = {preferredLayouts: ['h:h']};
            }
        }
        if (manhattanOptions) {
            manhattanOptions = assign(manhattanOptions, hints);
            updatedWaypoints = withoutRedundantPoints(repairConnection(source, target, start, end, waypoints, manhattanOptions));
        }
        return updatedWaypoints || [start, end];
    };

    function getAttachOrientation(attachedElement) {
        var hostElement = attachedElement.host, padding = -10;
        return getOrientation(getMid(attachedElement), hostElement, padding);
    }

    function getMessageFlowManhattanOptions(source, target) {
        return {preferredLayouts: ['straight', 'v:v'], preserveDocking: getMessageFlowPreserveDocking(source, target)};
    }

    function getMessageFlowPreserveDocking(source, target) {
        if (is$1(target, 'bpmn:Participant')) {
            return 'source';
        }
        if (is$1(source, 'bpmn:Participant')) {
            return 'target';
        }
        if (isExpandedSubProcess$1(target)) {
            return 'source';
        }
        if (isExpandedSubProcess$1(source)) {
            return 'target';
        }
        if (is$1(target, 'bpmn:Event')) {
            return 'target';
        }
        if (is$1(source, 'bpmn:Event')) {
            return 'source';
        }
        return null;
    }

    function getConnectionDocking(point, shape) {
        return point ? (point.original || point) : getMid(shape);
    }

    function isCompensationAssociation(connection) {
        var source = connection.source, target = connection.target;
        return is$1(target, 'bpmn:Activity') && is$1(source, 'bpmn:BoundaryEvent') && target.businessObject.isForCompensation;
    }

    function isExpandedSubProcess$1(element) {
        return is$1(element, 'bpmn:SubProcess') && isExpanded(element);
    }

    function isSame$1(a, b) {
        return a === b;
    }

    function isAnyOrientation(orientation, orientations) {
        return orientations.indexOf(orientation) !== -1;
    }

    var oppositeOrientationMapping = {
        'top': 'bottom',
        'top-right': 'bottom-left',
        'top-left': 'bottom-right',
        'right': 'left',
        'bottom': 'top',
        'bottom-right': 'top-left',
        'bottom-left': 'top-right',
        'left': 'right'
    };
    var orientationDirectionMapping = {top: 't', right: 'r', bottom: 'b', left: 'l'};

    function getHorizontalOrientation(orientation) {
        var matches = /right|left/.exec(orientation);
        return matches && matches[0];
    }

    function getVerticalOrientation(orientation) {
        var matches = /top|bottom/.exec(orientation);
        return matches && matches[0];
    }

    function isOppositeOrientation(a, b) {
        return oppositeOrientationMapping[a] === b;
    }

    function isOppositeHorizontalOrientation(a, b) {
        var horizontalOrientation = getHorizontalOrientation(a);
        var oppositeHorizontalOrientation = oppositeOrientationMapping[horizontalOrientation];
        return b.indexOf(oppositeHorizontalOrientation) !== -1;
    }

    function isOppositeVerticalOrientation(a, b) {
        var verticalOrientation = getVerticalOrientation(a);
        var oppositeVerticalOrientation = oppositeOrientationMapping[verticalOrientation];
        return b.indexOf(oppositeVerticalOrientation) !== -1;
    }

    function isHorizontalOrientation(orientation) {
        return orientation === 'right' || orientation === 'left';
    }

    function getBoundaryEventPreferredLayouts(source, target) {
        var sourceMid = getMid(source), targetMid = getMid(target), attachOrientation = getAttachOrientation(source),
            sourceLayout, targetlayout;
        var isLoop = isSame$1(source.host, target);
        var attachedToSide = isAnyOrientation(attachOrientation, ['top', 'right', 'bottom', 'left']);
        var isHorizontalAttachOrientation = isHorizontalOrientation(attachOrientation);
        var targetOrientation = getOrientation(targetMid, sourceMid, {
            x: source.width / 2 + target.width / 2,
            y: source.height / 2 + target.height / 2
        });
        if (attachedToSide) {
            sourceLayout = orientationDirectionMapping[isHorizontalAttachOrientation ? getHorizontalOrientation(attachOrientation) : getVerticalOrientation(attachOrientation)];
        } else {
            if (isLoop || isSame$1(getVerticalOrientation(attachOrientation), getVerticalOrientation(targetOrientation)) || isOppositeOrientation(getHorizontalOrientation(attachOrientation), getHorizontalOrientation(targetOrientation))) {
                sourceLayout = orientationDirectionMapping[getVerticalOrientation(attachOrientation)];
            } else {
                sourceLayout = orientationDirectionMapping[getHorizontalOrientation(attachOrientation)];
            }
        }
        if (attachedToSide) {
            if (isLoop || (isHorizontalAttachOrientation ? isOppositeHorizontalOrientation(attachOrientation, targetOrientation) : isOppositeVerticalOrientation(attachOrientation, targetOrientation))) {
                targetlayout = isHorizontalAttachOrientation ? 'h' : 'v';
            } else {
                targetlayout = isHorizontalAttachOrientation ? 'v' : 'h';
            }
        } else {
            if (isHorizontalOrientation(targetOrientation) || (isSame$1(getVerticalOrientation(attachOrientation), getVerticalOrientation(targetOrientation)) && getHorizontalOrientation(targetOrientation))) {
                targetlayout = 'h';
            } else {
                targetlayout = 'v';
            }
        }
        return [sourceLayout + ':' + targetlayout];
    }

    function dockingToPoint(docking) {
        return assign({original: docking.point.original || docking.point}, docking.actual);
    }

    function CroppingConnectionDocking(elementRegistry, graphicsFactory) {
        this._elementRegistry = elementRegistry;
        this._graphicsFactory = graphicsFactory;
    }

    CroppingConnectionDocking.$inject = ['elementRegistry', 'graphicsFactory'];
    CroppingConnectionDocking.prototype.getCroppedWaypoints = function (connection, source, target) {
        source = source || connection.source;
        target = target || connection.target;
        var sourceDocking = this.getDockingPoint(connection, source, true),
            targetDocking = this.getDockingPoint(connection, target);
        var croppedWaypoints = connection.waypoints.slice(sourceDocking.idx + 1, targetDocking.idx);
        croppedWaypoints.unshift(dockingToPoint(sourceDocking));
        croppedWaypoints.push(dockingToPoint(targetDocking));
        return croppedWaypoints;
    };
    CroppingConnectionDocking.prototype.getDockingPoint = function (connection, shape, dockStart) {
        var waypoints = connection.waypoints, dockingIdx, dockingPoint, croppedPoint;
        dockingIdx = dockStart ? 0 : waypoints.length - 1;
        dockingPoint = waypoints[dockingIdx];
        croppedPoint = this._getIntersection(shape, connection, dockStart);
        return {point: dockingPoint, actual: croppedPoint || dockingPoint, idx: dockingIdx};
    };
    CroppingConnectionDocking.prototype._getIntersection = function (shape, connection, takeFirst) {
        var shapePath = this._getShapePath(shape), connectionPath = this._getConnectionPath(connection);
        return getElementLineIntersection(shapePath, connectionPath, takeFirst);
    };
    CroppingConnectionDocking.prototype._getConnectionPath = function (connection) {
        return this._graphicsFactory.getConnectionPath(connection);
    };
    CroppingConnectionDocking.prototype._getShapePath = function (shape) {
        return this._graphicsFactory.getShapePath(shape);
    };
    CroppingConnectionDocking.prototype._getGfx = function (element) {
        return this._elementRegistry.getGraphics(element);
    };
    var ModelingModule = {
        __init__: ['modeling', 'bpmnUpdater'],
        __depends__: [BehaviorModule, RulesModule$1, OrderingModule, ReplaceModule$1, CommandModule, TooltipsModule, LabelSupportModule, AttachSupportModule, SelectionModule, ChangeSupportModule, SpaceToolModule],
        bpmnFactory: ['type', BpmnFactory],
        bpmnUpdater: ['type', BpmnUpdater],
        elementFactory: ['type', ElementFactory$1],
        modeling: ['type', Modeling$1],
        layouter: ['type', BpmnLayouter],
        connectionDocking: ['type', CroppingConnectionDocking]
    };
    var LOW_PRIORITY$d = 500, MEDIUM_PRIORITY = 1250, HIGH_PRIORITY$4 = 1500;
    var round$9 = Math.round;

    function mid$1(element) {
        return {x: element.x + round$9(element.width / 2), y: element.y + round$9(element.height / 2)};
    }

    function MoveEvents(eventBus, dragging, modeling, selection, rules) {
        function canMove(shapes, delta, position, target) {
            return rules.allowed('elements.move', {shapes: shapes, delta: delta, position: position, target: target});
        }

        eventBus.on('shape.move.start', HIGH_PRIORITY$4, function (event) {
            var context = event.context, shape = event.shape, shapes = selection.get().slice();
            if (shapes.indexOf(shape) === -1) {
                shapes = [shape];
            }
            shapes = removeNested(shapes);
            assign(context, {shapes: shapes, validatedShapes: shapes, shape: shape});
        });
        eventBus.on('shape.move.start', MEDIUM_PRIORITY, function (event) {
            var context = event.context, validatedShapes = context.validatedShapes, canExecute;
            canExecute = context.canExecute = canMove(validatedShapes);
            if (!canExecute) {
                return false;
            }
        });
        eventBus.on('shape.move.move', LOW_PRIORITY$d, function (event) {
            var context = event.context, validatedShapes = context.validatedShapes, hover = event.hover,
                delta = {x: event.dx, y: event.dy}, position = {x: event.x, y: event.y}, canExecute;
            canExecute = canMove(validatedShapes, delta, position, hover);
            context.delta = delta;
            context.canExecute = canExecute;
            if (canExecute === null) {
                context.target = null;
                return;
            }
            context.target = hover;
        });
        eventBus.on('shape.move.end', function (event) {
            var context = event.context;
            var delta = context.delta, canExecute = context.canExecute, isAttach = canExecute === 'attach',
                shapes = context.shapes;
            if (!canExecute) {
                return false;
            }
            delta.x = round$9(delta.x);
            delta.y = round$9(delta.y);
            modeling.moveElements(shapes, delta, context.target, {primaryShape: context.shape, attach: isAttach});
        });
        eventBus.on('element.mousedown', function (event) {
            var originalEvent = getOriginal(event);
            if (!originalEvent) {
                throw new Error('must supply DOM mousedown event');
            }
            return start(originalEvent, event.element);
        });

        function start(event, element, activate) {
            if (element.waypoints || !element.parent) {
                return;
            }
            var referencePoint = mid$1(element);
            dragging.init(event, referencePoint, 'shape.move', {
                cursor: 'grabbing',
                autoActivate: activate,
                data: {shape: element, context: {}}
            });
            return true;
        }

        this.start = start;
    }

    MoveEvents.$inject = ['eventBus', 'dragging', 'modeling', 'selection', 'rules'];

    function removeNested(elements) {
        var ids = groupBy(elements, 'id');
        return filter(elements, function (element) {
            while ((element = element.parent)) {
                if (ids[element.id]) {
                    return false;
                }
            }
            return true;
        });
    }

    var LOW_PRIORITY$e = 499;
    var MARKER_DRAGGING$1 = 'djs-dragging', MARKER_OK$3 = 'drop-ok', MARKER_NOT_OK$3 = 'drop-not-ok',
        MARKER_NEW_PARENT$1 = 'new-parent', MARKER_ATTACH$1 = 'attach-ok';

    function MovePreview(eventBus, elementRegistry, canvas, styles, previewSupport) {
        function getVisualDragShapes(shapes) {
            var elements = getAllDraggedElements(shapes);
            var filteredElements = removeEdges(elements);
            return filteredElements;
        }

        function getAllDraggedElements(shapes) {
            var allShapes = selfAndAllChildren(shapes, true);
            var allConnections = map(allShapes, function (shape) {
                return (shape.incoming || []).concat(shape.outgoing || []);
            });
            return flatten(allShapes.concat(allConnections));
        }

        function setMarker(element, marker) {
            [MARKER_ATTACH$1, MARKER_OK$3, MARKER_NOT_OK$3, MARKER_NEW_PARENT$1].forEach(function (m) {
                if (m === marker) {
                    canvas.addMarker(element, m);
                } else {
                    canvas.removeMarker(element, m);
                }
            });
        }

        function makeDraggable(context, element, addMarker) {
            previewSupport.addDragger(element, context.dragGroup);
            if (addMarker) {
                canvas.addMarker(element, MARKER_DRAGGING$1);
            }
            if (context.allDraggedElements) {
                context.allDraggedElements.push(element);
            } else {
                context.allDraggedElements = [element];
            }
        }

        eventBus.on('shape.move.start', LOW_PRIORITY$e, function (event) {
            var context = event.context, dragShapes = context.shapes, allDraggedElements = context.allDraggedElements;
            var visuallyDraggedShapes = getVisualDragShapes(dragShapes);
            if (!context.dragGroup) {
                var dragGroup = create('g');
                attr$1(dragGroup, styles.cls('djs-drag-group', ['no-events']));
                var defaultLayer = canvas.getDefaultLayer();
                append(defaultLayer, dragGroup);
                context.dragGroup = dragGroup;
            }
            visuallyDraggedShapes.forEach(function (shape) {
                previewSupport.addDragger(shape, context.dragGroup);
            });
            if (!allDraggedElements) {
                allDraggedElements = getAllDraggedElements(dragShapes);
            } else {
                allDraggedElements = flatten([allDraggedElements, getAllDraggedElements(dragShapes)]);
            }
            forEach(allDraggedElements, function (e) {
                canvas.addMarker(e, MARKER_DRAGGING$1);
            });
            context.allDraggedElements = allDraggedElements;
            context.differentParents = haveDifferentParents(dragShapes);
        });
        eventBus.on('shape.move.move', LOW_PRIORITY$e, function (event) {
            var context = event.context, dragGroup = context.dragGroup, target = context.target,
                parent = context.shape.parent, canExecute = context.canExecute;
            if (target) {
                if (canExecute === 'attach') {
                    setMarker(target, MARKER_ATTACH$1);
                } else if (context.canExecute && target && target.id !== parent.id) {
                    setMarker(target, MARKER_NEW_PARENT$1);
                } else {
                    setMarker(target, context.canExecute ? MARKER_OK$3 : MARKER_NOT_OK$3);
                }
            }
            translate(dragGroup, event.dx, event.dy);
        });
        eventBus.on(['shape.move.out', 'shape.move.cleanup'], function (event) {
            var context = event.context, target = context.target;
            if (target) {
                setMarker(target, null);
            }
        });
        eventBus.on('shape.move.cleanup', function (event) {
            var context = event.context, allDraggedElements = context.allDraggedElements, dragGroup = context.dragGroup;
            forEach(allDraggedElements, function (e) {
                canvas.removeMarker(e, MARKER_DRAGGING$1);
            });
            if (dragGroup) {
                clear$1(dragGroup);
            }
        });
        this.makeDraggable = makeDraggable;
    }

    MovePreview.$inject = ['eventBus', 'elementRegistry', 'canvas', 'styles', 'previewSupport'];

    function removeEdges(elements) {
        var filteredElements = filter(elements, function (element) {
            if (!isConnection$4(element)) {
                return true;
            } else {
                return (find(elements, matchPattern({id: element.source.id})) && find(elements, matchPattern({id: element.target.id})));
            }
        });
        return filteredElements;
    }

    function haveDifferentParents(elements) {
        return size(groupBy(elements, function (e) {
            return e.parent && e.parent.id;
        })) !== 1;
    }

    function isConnection$4(element) {
        return element.waypoints;
    }

    var MoveModule = {
        __depends__: [InteractionEventsModule, SelectionModule, OutlineModule, RulesModule, DraggingModule, PreviewSupportModule],
        __init__: ['move', 'movePreview'],
        move: ['type', MoveEvents],
        movePreview: ['type', MovePreview]
    };
    var TOGGLE_SELECTOR = '.djs-palette-toggle', ENTRY_SELECTOR = '.entry',
        ELEMENT_SELECTOR = TOGGLE_SELECTOR + ', ' + ENTRY_SELECTOR;
    var PALETTE_OPEN_CLS = 'open', PALETTE_TWO_COLUMN_CLS = 'two-column';

    function Palette(eventBus, canvas) {
        this._eventBus = eventBus;
        this._canvas = canvas;
        this._providers = [];
        var self = this;
        eventBus.on('tool-manager.update', function (event$$1) {
            var tool = event$$1.tool;
            self.updateToolHighlight(tool);
        });
        eventBus.on('i18n.changed', function () {
            self._update();
        });
        eventBus.on('diagram.init', function () {
            self._diagramInitialized = true;
            if (self._providers.length) {
                self._init();
                self._update();
            }
        });
    }

    Palette.$inject = ['eventBus', 'canvas'];
    Palette.prototype.registerProvider = function (provider) {
        this._providers.push(provider);
        if (!this._diagramInitialized) {
            return;
        }
        if (!this._container) {
            this._init();
        }
        this._update();
    };
    Palette.prototype.getEntries = function () {
        var entries = {};
        forEach(this._providers, function (provider) {
            var e = provider.getPaletteEntries();
            forEach(e, function (entry, id) {
                entries[id] = entry;
            });
        });
        return entries;
    };
    Palette.prototype._init = function () {
        var canvas = this._canvas, eventBus = this._eventBus;
        var parent = canvas.getContainer(), container = this._container = domify(Palette.HTML_MARKUP), self = this;
        parent.appendChild(container);
        delegateEvents.bind(container, ELEMENT_SELECTOR, 'click', function (event$$1) {
            var target = event$$1.delegateTarget;
            if (matchesSelector$1(target, TOGGLE_SELECTOR)) {
                return self.toggle();
            }
            self.trigger('click', event$$1);
        });
        componentEvent.bind(container, 'mousedown', function (event$$1) {
            event$$1.stopPropagation();
        });
        delegateEvents.bind(container, ENTRY_SELECTOR, 'dragstart', function (event$$1) {
            self.trigger('dragstart', event$$1);
        });
        eventBus.on('canvas.resized', this._layoutChanged, this);
        eventBus.fire('palette.create', {container: container});
    };
    Palette.prototype._toggleState = function (state) {
        state = state || {};
        var parent = this._getParentContainer(), container = this._container;
        var eventBus = this._eventBus;
        var twoColumn;
        var cls = classes(container);
        if ('twoColumn' in state) {
            twoColumn = state.twoColumn;
        } else {
            twoColumn = this._needsCollapse(parent.clientHeight, this._entries || {});
        }
        cls.toggle(PALETTE_TWO_COLUMN_CLS, twoColumn);
        if ('open' in state) {
            cls.toggle(PALETTE_OPEN_CLS, state.open);
        }
        eventBus.fire('palette.changed', {twoColumn: twoColumn, open: this.isOpen()});
    };
    Palette.prototype._update = function () {
        var entriesContainer = query('.djs-palette-entries', this._container),
            entries = this._entries = this.getEntries();
        clear(entriesContainer);
        forEach(entries, function (entry, id) {
            var grouping = entry.group || 'default';
            var container = query('[data-group=' + grouping + ']', entriesContainer);
            if (!container) {
                container = domify('<div class="group" data-group="' + grouping + '"></div>');
                entriesContainer.appendChild(container);
            }
            var html = entry.html || (entry.separator ? '<hr class="separator" />' : '<div class="entry" draggable="true"></div>');
            var control = domify(html);
            container.appendChild(control);
            if (!entry.separator) {
                attr(control, 'data-action', id);
                if (entry.title) {
                    attr(control, 'title', entry.title);
                }
                if (entry.className) {
                    addClasses$1(control, entry.className);
                }
                if (entry.imageUrl) {
                    control.appendChild(domify('<img src="' + entry.imageUrl + '">'));
                }
            }
        });
        this.open();
    };
    Palette.prototype.trigger = function (action, event$$1, autoActivate) {
        var entries = this._entries, entry, handler, originalEvent, button = event$$1.delegateTarget || event$$1.target;
        if (!button) {
            return event$$1.preventDefault();
        }
        entry = entries[attr(button, 'data-action')];
        if (!entry) {
            return;
        }
        handler = entry.action;
        originalEvent = event$$1.originalEvent || event$$1;
        if (isFunction(handler)) {
            if (action === 'click') {
                handler(originalEvent, autoActivate);
            }
        } else {
            if (handler[action]) {
                handler[action](originalEvent, autoActivate);
            }
        }
        event$$1.preventDefault();
    };
    Palette.prototype._layoutChanged = function () {
        this._toggleState({});
    };
    Palette.prototype._needsCollapse = function (availableHeight, entries) {
        var margin = 20 + 10 + 20;
        var entriesHeight = Object.keys(entries).length * 46;
        return availableHeight < entriesHeight + margin;
    };
    Palette.prototype.close = function () {
        this._toggleState({open: false, twoColumn: false});
    };
    Palette.prototype.open = function () {
        this._toggleState({open: true});
    };
    Palette.prototype.toggle = function (open) {
        if (this.isOpen()) {
            this.close();
        } else {
            this.open();
        }
    };
    Palette.prototype.isActiveTool = function (tool) {
        return tool && this._activeTool === tool;
    };
    Palette.prototype.updateToolHighlight = function (name) {
        var entriesContainer, toolsContainer;
        if (!this._toolsContainer) {
            entriesContainer = query('.djs-palette-entries', this._container);
            this._toolsContainer = query('[data-group=tools]', entriesContainer);
        }
        toolsContainer = this._toolsContainer;
        forEach(toolsContainer.children, function (tool) {
            var actionName = tool.getAttribute('data-action');
            if (!actionName) {
                return;
            }
            var toolClasses = classes(tool);
            actionName = actionName.replace('-tool', '');
            if (toolClasses.contains('entry') && actionName === name) {
                toolClasses.add('highlighted-entry');
            } else {
                toolClasses.remove('highlighted-entry');
            }
        });
    };
    Palette.prototype.isOpen = function () {
        return classes(this._container).has(PALETTE_OPEN_CLS);
    };
    Palette.prototype._getParentContainer = function () {
        return this._canvas.getContainer();
    };
    Palette.HTML_MARKUP = '<div class="djs-palette">' + '<div class="djs-palette-entries"></div>' + '<div class="djs-palette-toggle"></div>' + '</div>';

    function addClasses$1(element, classNames) {
        var classes$$1 = classes(element);
        var actualClassNames = isArray(classNames) ? classNames : classNames.split(/\s+/g);
        actualClassNames.forEach(function (cls) {
            classes$$1.add(cls);
        });
    }

    var PaletteModule = {__init__: ['palette'], palette: ['type', Palette]};
    var LASSO_TOOL_CURSOR = 'crosshair';

    function LassoTool(eventBus, canvas, dragging, elementRegistry, selection, toolManager) {
        this._selection = selection;
        this._dragging = dragging;
        var self = this;
        var visuals = {
            create: function (context) {
                var container = canvas.getDefaultLayer(), frame;
                frame = context.frame = create('rect');
                attr$1(frame, {class: 'djs-lasso-overlay', width: 1, height: 1, x: 0, y: 0});
                append(container, frame);
            }, update: function (context) {
                var frame = context.frame, bbox = context.bbox;
                attr$1(frame, {x: bbox.x, y: bbox.y, width: bbox.width, height: bbox.height});
            }, remove: function (context) {
                if (context.frame) {
                    remove$1(context.frame);
                }
            }
        };
        toolManager.registerTool('lasso', {tool: 'lasso.selection', dragging: 'lasso'});
        eventBus.on('lasso.selection.end', function (event) {
            var target = event.originalEvent.target;
            if (!event.hover && !(target instanceof SVGElement)) {
                return;
            }
            eventBus.once('lasso.selection.ended', function () {
                self.activateLasso(event.originalEvent, true);
            });
        });
        eventBus.on('lasso.end', function (event) {
            var bbox = toBBox(event);
            var elements = elementRegistry.filter(function (element) {
                return element;
            });
            self.select(elements, bbox);
        });
        eventBus.on('lasso.start', function (event) {
            var context = event.context;
            context.bbox = toBBox(event);
            visuals.create(context);
        });
        eventBus.on('lasso.move', function (event) {
            var context = event.context;
            context.bbox = toBBox(event);
            visuals.update(context);
        });
        eventBus.on('lasso.cleanup', function (event) {
            var context = event.context;
            visuals.remove(context);
        });
        eventBus.on('element.mousedown', 1500, function (event) {
            if (hasSecondaryModifier(event)) {
                self.activateLasso(event.originalEvent);
                return true;
            }
        });
    }

    LassoTool.$inject = ['eventBus', 'canvas', 'dragging', 'elementRegistry', 'selection', 'toolManager'];
    LassoTool.prototype.activateLasso = function (event, autoActivate) {
        this._dragging.init(event, 'lasso', {
            autoActivate: autoActivate,
            cursor: LASSO_TOOL_CURSOR,
            data: {context: {}}
        });
    };
    LassoTool.prototype.activateSelection = function (event) {
        this._dragging.init(event, 'lasso.selection', {
            trapClick: false,
            cursor: LASSO_TOOL_CURSOR,
            data: {context: {}}
        });
    };
    LassoTool.prototype.select = function (elements, bbox) {
        var selectedElements = getEnclosedElements(elements, bbox);
        this._selection.select(values(selectedElements));
    };
    LassoTool.prototype.toggle = function () {
        if (this.isActive()) {
            this._dragging.cancel();
        } else {
            this.activateSelection();
        }
    };
    LassoTool.prototype.isActive = function () {
        var context = this._dragging.context();
        return context && /^lasso/.test(context.prefix);
    };

    function toBBox(event) {
        var start = {x: event.x - event.dx, y: event.y - event.dy};
        var end = {x: event.x, y: event.y};
        var bbox;
        if ((start.x <= end.x && start.y < end.y) || (start.x < end.x && start.y <= end.y)) {
            bbox = {x: start.x, y: start.y, width: end.x - start.x, height: end.y - start.y};
        } else if ((start.x >= end.x && start.y < end.y) || (start.x > end.x && start.y <= end.y)) {
            bbox = {x: end.x, y: start.y, width: start.x - end.x, height: end.y - start.y};
        } else if ((start.x <= end.x && start.y > end.y) || (start.x < end.x && start.y >= end.y)) {
            bbox = {x: start.x, y: end.y, width: end.x - start.x, height: start.y - end.y};
        } else if ((start.x >= end.x && start.y > end.y) || (start.x > end.x && start.y >= end.y)) {
            bbox = {x: end.x, y: end.y, width: start.x - end.x, height: start.y - end.y};
        } else {
            bbox = {x: end.x, y: end.y, width: 0, height: 0};
        }
        return bbox;
    }

    var LassoToolModule = {__depends__: [ToolManagerModule], __init__: ['lassoTool'], lassoTool: ['type', LassoTool]};
    var HIGH_PRIORITY$5 = 1500;
    var HAND_CURSOR = 'grab';

    function HandTool(eventBus, canvas, dragging, toolManager) {
        this._dragging = dragging;
        toolManager.registerTool('hand', {tool: 'hand', dragging: 'hand.move'});
        eventBus.on('element.mousedown', HIGH_PRIORITY$5, function (event) {
            if (hasPrimaryModifier(event)) {
                this.activateMove(event.originalEvent);
                return false;
            }
        }, this);
        eventBus.on('hand.end', function (event) {
            var target = event.originalEvent.target;
            if (!event.hover && !(target instanceof SVGElement)) {
                return false;
            }
            eventBus.once('hand.ended', function () {
                this.activateMove(event.originalEvent, {reactivate: true});
            }, this);
        }, this);
        eventBus.on('hand.move.move', function (event) {
            var scale = canvas.viewbox().scale;
            canvas.scroll({dx: event.dx * scale, dy: event.dy * scale});
        });
        eventBus.on('hand.move.end', function (event) {
            var context = event.context, reactivate = context.reactivate;
            if (!hasPrimaryModifier(event) && reactivate) {
                eventBus.once('hand.move.ended', function (event) {
                    this.activateHand(event.originalEvent, true, true);
                }, this);
            }
            return false;
        }, this);
    }

    HandTool.$inject = ['eventBus', 'canvas', 'dragging', 'toolManager'];
    HandTool.prototype.activateMove = function (event, autoActivate, context) {
        if (typeof autoActivate === 'object') {
            context = autoActivate;
            autoActivate = false;
        }
        this._dragging.init(event, 'hand.move', {
            autoActivate: autoActivate,
            cursor: HAND_CURSOR,
            data: {context: context || {}}
        });
    };
    HandTool.prototype.activateHand = function (event, autoActivate, reactivate) {
        this._dragging.init(event, 'hand', {
            trapClick: false,
            autoActivate: autoActivate,
            cursor: HAND_CURSOR,
            data: {context: {reactivate: reactivate}}
        });
    };
    HandTool.prototype.toggle = function () {
        if (this.isActive()) {
            this._dragging.cancel();
        } else {
            this.activateHand();
        }
    };
    HandTool.prototype.isActive = function () {
        var context = this._dragging.context();
        return context && /^hand/.test(context.prefix);
    };
    var HandToolModule = {__depends__: [ToolManagerModule], __init__: ['handTool'], handTool: ['type', HandTool]};
    var MARKER_OK$4 = 'connect-ok', MARKER_NOT_OK$4 = 'connect-not-ok';

    function GlobalConnect(eventBus, dragging, connect, canvas, toolManager, rules) {
        var self = this;
        this._dragging = dragging;
        this._rules = rules;
        toolManager.registerTool('global-connect', {tool: 'global-connect', dragging: 'global-connect.drag'});
        eventBus.on('global-connect.hover', function (event) {
            var context = event.context, startTarget = event.hover;
            var canStartConnect = context.canStartConnect = self.canStartConnect(startTarget);
            if (canStartConnect === null) {
                return;
            }
            context.startTarget = startTarget;
            canvas.addMarker(startTarget, canStartConnect ? MARKER_OK$4 : MARKER_NOT_OK$4);
        });
        eventBus.on(['global-connect.out', 'global-connect.cleanup'], function (event) {
            var startTarget = event.context.startTarget, canStartConnect = event.context.canStartConnect;
            if (startTarget) {
                canvas.removeMarker(startTarget, canStartConnect ? MARKER_OK$4 : MARKER_NOT_OK$4);
            }
        });
        eventBus.on(['global-connect.ended'], function (event) {
            var context = event.context, startTarget = context.startTarget, startPosition = {x: event.x, y: event.y};
            var canStartConnect = self.canStartConnect(startTarget);
            if (!canStartConnect) {
                return;
            }
            eventBus.once('element.out', function () {
                eventBus.once(['connect.ended', 'connect.canceled'], function () {
                    eventBus.fire('global-connect.drag.ended');
                });
                connect.start(null, startTarget, startPosition);
            });
            return false;
        });
    }

    GlobalConnect.$inject = ['eventBus', 'dragging', 'connect', 'canvas', 'toolManager', 'rules'];
    GlobalConnect.prototype.start = function (event) {
        this._dragging.init(event, 'global-connect', {trapClick: false, data: {context: {}}});
    };
    GlobalConnect.prototype.toggle = function () {
        if (this.isActive()) {
            this._dragging.cancel();
        } else {
            this.start();
        }
    };
    GlobalConnect.prototype.isActive = function () {
        var context = this._dragging.context();
        return context && /^global-connect/.test(context.prefix);
    };
    GlobalConnect.prototype.canStartConnect = function (startTarget) {
        return this._rules.allowed('connection.start', {source: startTarget});
    };
    var GlobalConnectModule = {
        __depends__: [ConnectModule, RulesModule, DraggingModule, ToolManagerModule],
        globalConnect: ['type', GlobalConnect]
    };

    function PaletteProvider(palette, create, elementFactory, spaceTool, lassoTool, handTool, globalConnect, translate) {
        this._palette = palette;
        this._create = create;
        this._elementFactory = elementFactory;
        this._spaceTool = spaceTool;
        this._lassoTool = lassoTool;
        this._handTool = handTool;
        this._globalConnect = globalConnect;
        this._translate = translate;
        palette.registerProvider(this);
    }

    PaletteProvider.$inject = ['palette', 'create', 'elementFactory', 'spaceTool', 'lassoTool', 'handTool', 'globalConnect', 'translate'];
    PaletteProvider.prototype.getPaletteEntries = function (element) {
        var actions = {}, create = this._create, elementFactory = this._elementFactory, spaceTool = this._spaceTool,
            lassoTool = this._lassoTool, handTool = this._handTool, globalConnect = this._globalConnect,
            translate = this._translate;

        function createAction(type, group, className, title, options) {
            function createListener(event) {
                var shape = elementFactory.createShape(assign({type: type}, options));
                if (options) {
                    shape.businessObject.di.isExpanded = options.isExpanded;
                }
                create.start(event, shape);
            }

            var shortType = type.replace(/^bpmn:/, '');
            return {
                group: group,
                className: className,
                title: title || translate('Create {type}', {type: shortType}),
                action: {dragstart: createListener, click: createListener}
            };
        }

        function createParticipant(event, collapsed) {
            create.start(event, elementFactory.createParticipantShape(collapsed));
        }

        assign(actions, {
            'hand-tool': {
                group: 'tools',
                className: 'bpmn-icon-hand-tool',
                title: translate('抓取'),
                action: {
                    click: function (event) {
                        handTool.activateHand(event);
                    }
                }
            },
            'lasso-tool': {
                group: 'tools',
                className: 'bpmn-icon-lasso-tool',
                title: translate('套索工具'),
                action: {
                    click: function (event) {
                        lassoTool.activateSelection(event);
                    }
                }
            },
            'space-tool': {
                group: 'tools',
                className: 'bpmn-icon-space-tool',
                title: translate('空间工具'),
                action: {
                    click: function (event) {
                        spaceTool.activateSelection(event);
                    }
                }
            },
            'global-connect-tool': {
                group: 'tools',
                className: 'bpmn-icon-connection-multi',
                title: translate('连接线'),
                action: {
                    click: function (event) {
                        globalConnect.toggle(event);
                    }
                }
            },
            'tool-separator': {group: 'tools', separator: true},
            'create.start-event': createAction('bpmn:StartEvent', 'event', 'bpmn-icon-start-event-none', translate('开始节点')),/*'create.intermediate-event':createAction('bpmn:IntermediateThrowEvent','event','bpmn-icon-intermediate-event-none',translate('Create Intermediate/Boundary Event')),*/
            'create.end-event': createAction('bpmn:EndEvent', 'event', 'bpmn-icon-end-event-none', translate('结束节点')),
            'create.task': createAction('bpmn:UserTask', 'activity', 'bpmn-icon-user', translate('人工任务')),
            'create.service-task': createAction('bpmn:ServiceTask', 'activity', 'bpmn-icon-service', translate('服务任务')),
            'create.exclusive-gateway': createAction('bpmn:ExclusiveGateway', 'gateway', 'bpmn-icon-gateway-xor', translate('排他网关')),
            'create.parallel-gateway': createAction('bpmn:ParallelGateway', 'gateway', 'bpmn-icon-gateway-parallel', translate('并行网关')),
            /*'create.data-object':createAction('bpmn:DataObjectReference','data-object','bpmn-icon-data-object'),'create.data-store':createAction('bpmn:DataStoreReference','data-store','bpmn-icon-data-store'),*/
            'create.call-activity': createAction('bpmn:CallActivity', 'activity', 'bpmn-icon-call-activity', translate('调用子流程')),
            // 'create.subprocess-expanded': createAction('bpmn:SubProcess', 'activity', 'bpmn-icon-subprocess-expanded', translate('子流程'), {isExpanded: true}),
            // 'create.participant-expanded': {
            //     group: 'collaboration',s
            //     className: 'bpmn-icon-participant',
            //     title: translate('泳道'),
            //     action: {dragstart: createParticipant, click: createParticipant}
            // }
        });
        return actions;
    };
    var PaletteModule$1 = {
        __depends__: [PaletteModule, CreateModule, SpaceToolModule, LassoToolModule, HandToolModule, GlobalConnectModule, translate$2],
        __init__: ['paletteProvider'],
        paletteProvider: ['type', PaletteProvider]
    };
    var LOW_PRIORITY$f = 250;

    function BpmnReplacePreview(eventBus, elementRegistry, elementFactory, canvas, previewSupport) {
        CommandInterceptor.call(this, eventBus);

        function replaceVisual(context) {
            var replacements = context.canExecute.replacements;
            forEach(replacements, function (replacement) {
                var id = replacement.oldElementId;
                var newElement = {type: replacement.newElementType};
                if (context.visualReplacements[id]) {
                    return;
                }
                var element = elementRegistry.get(id);
                assign(newElement, {x: element.x, y: element.y});
                var tempShape = elementFactory.createShape(newElement);
                canvas.addShape(tempShape, element.parent);
                var gfx = query('[data-element-id="' + css_escape(element.id) + '"]', context.dragGroup);
                if (gfx) {
                    attr$1(gfx, {display: 'none'});
                }
                var dragger = previewSupport.addDragger(tempShape, context.dragGroup);
                context.visualReplacements[id] = dragger;
                canvas.removeShape(tempShape);
            });
        }

        function restoreVisual(context) {
            var visualReplacements = context.visualReplacements;
            forEach(visualReplacements, function (dragger, id) {
                var originalGfx = query('[data-element-id="' + css_escape(id) + '"]', context.dragGroup);
                if (originalGfx) {
                    attr$1(originalGfx, {display: 'inline'});
                }
                dragger.remove();
                if (visualReplacements[id]) {
                    delete visualReplacements[id];
                }
            });
        }

        eventBus.on('shape.move.move', LOW_PRIORITY$f, function (event) {
            var context = event.context, canExecute = context.canExecute;
            if (!context.visualReplacements) {
                context.visualReplacements = {};
            }
            if (canExecute.replacements) {
                replaceVisual(context);
            } else {
                restoreVisual(context);
            }
        });
    }

    BpmnReplacePreview.$inject = ['eventBus', 'elementRegistry', 'elementFactory', 'canvas', 'previewSupport'];
    inherits_browser(BpmnReplacePreview, CommandInterceptor);
    var ReplacePreviewModule = {
        __depends__: [PreviewSupportModule],
        __init__: ['bpmnReplacePreview'],
        bpmnReplacePreview: ['type', BpmnReplacePreview]
    };
    var abs$6 = Math.abs, round$a = Math.round;

    function snapTo(value, values, tolerance) {
        tolerance = tolerance === undefined ? 10 : tolerance;
        var idx, snapValue;
        for (idx = 0; idx < values.length; idx++) {
            snapValue = values[idx];
            if (abs$6(snapValue - value) <= tolerance) {
                return snapValue;
            }
        }
    }

    function topLeft(bounds) {
        return {x: bounds.x, y: bounds.y};
    }

    function mid$2(bounds, defaultValue) {
        if (!bounds || isNaN(bounds.x) || isNaN(bounds.y)) {
            return defaultValue;
        }
        return {x: round$a(bounds.x + bounds.width / 2), y: round$a(bounds.y + bounds.height / 2)};
    }

    function bottomRight(bounds) {
        return {x: bounds.x + bounds.width, y: bounds.y + bounds.height};
    }

    function isSnapped(event, axis) {
        var snapped = event.snapped;
        if (!snapped) {
            return false;
        }
        if (typeof axis === 'string') {
            return snapped[axis];
        }
        return snapped.x && snapped.y;
    }

    function setSnapped(event, axis, value) {
        if (typeof axis !== 'string') {
            throw new Error('axis must be in [x, y]');
        }
        if (typeof value !== 'number' && value !== false) {
            throw new Error('value must be Number or false');
        }
        var delta, previousValue = event[axis];
        var snapped = event.snapped = (event.snapped || {});
        if (value === false) {
            snapped[axis] = false;
        } else {
            snapped[axis] = true;
            delta = value - previousValue;
            event[axis] += delta;
            event['d' + axis] += delta;
        }
        return previousValue;
    }

    function SnapContext() {
        this._targets = {};
        this._snapOrigins = {};
        this._snapLocations = [];
        this._defaultSnaps = {};
    }

    SnapContext.prototype.getSnapOrigin = function (snapLocation) {
        return this._snapOrigins[snapLocation];
    };
    SnapContext.prototype.setSnapOrigin = function (snapLocation, initialValue) {
        this._snapOrigins[snapLocation] = initialValue;
        if (this._snapLocations.indexOf(snapLocation) === -1) {
            this._snapLocations.push(snapLocation);
        }
    };
    SnapContext.prototype.addDefaultSnap = function (type, point) {
        var snapValues = this._defaultSnaps[type];
        if (!snapValues) {
            snapValues = this._defaultSnaps[type] = [];
        }
        snapValues.push(point);
    };
    SnapContext.prototype.getSnapLocations = function () {
        return this._snapLocations;
    };
    SnapContext.prototype.setSnapLocations = function (snapLocations) {
        this._snapLocations = snapLocations;
    };
    SnapContext.prototype.pointsForTarget = function (target) {
        var targetId = target.id || target;
        var snapPoints = this._targets[targetId];
        if (!snapPoints) {
            snapPoints = this._targets[targetId] = new SnapPoints();
            snapPoints.initDefaults(this._defaultSnaps);
        }
        return snapPoints;
    };

    function SnapPoints(defaultSnaps) {
        this._snapValues = {};
    }

    SnapPoints.prototype.add = function (snapLocation, point) {
        var snapValues = this._snapValues[snapLocation];
        if (!snapValues) {
            snapValues = this._snapValues[snapLocation] = {x: [], y: []};
        }
        if (snapValues.x.indexOf(point.x) === -1) {
            snapValues.x.push(point.x);
        }
        if (snapValues.y.indexOf(point.y) === -1) {
            snapValues.y.push(point.y);
        }
    };
    SnapPoints.prototype.snap = function (point, snapLocation, axis, tolerance) {
        var snappingValues = this._snapValues[snapLocation];
        return snappingValues && snapTo(point[axis], snappingValues[axis], tolerance);
    };
    SnapPoints.prototype.initDefaults = function (defaultSnaps) {
        var self = this;
        forEach(defaultSnaps || {}, function (snapPoints, snapLocation) {
            forEach(snapPoints, function (point) {
                self.add(snapLocation, point);
            });
        });
    };
    var HIGHER_PRIORITY$1 = 1250;

    function Snapping(eventBus, canvas) {
        this._canvas = canvas;
        var self = this;
        eventBus.on(['shape.move.start', 'create.start'], function (event) {
            self.initSnap(event);
        });
        eventBus.on(['shape.move.move', 'shape.move.end', 'create.move', 'create.end'], HIGHER_PRIORITY$1, function (event) {
            if (event.originalEvent && event.originalEvent.ctrlKey) {
                return;
            }
            if (isSnapped(event)) {
                return;
            }
            self.snap(event);
        });
        eventBus.on(['shape.move.cleanup', 'create.cleanup'], function (event) {
            self.hide();
        });
        this._asyncHide = debounce(bind(this.hide, this), 1000);
    }

    Snapping.$inject = ['eventBus', 'canvas'];
    Snapping.prototype.initSnap = function (event) {
        var context = event.context, shape = context.shape, snapContext = context.snapContext;
        if (!snapContext) {
            snapContext = context.snapContext = new SnapContext();
        }
        var snapMid = mid$2(shape, event);
        snapContext.setSnapOrigin('mid', {x: snapMid.x - event.x, y: snapMid.y - event.y});
        return snapContext;
    };
    Snapping.prototype.snap = function (event) {
        var context = event.context, snapContext = context.snapContext, shape = context.shape, target = context.target,
            snapLocations = snapContext.getSnapLocations();
        if (!target) {
            return;
        }
        var snapPoints = snapContext.pointsForTarget(target);
        if (!snapPoints.initialized) {
            this.addTargetSnaps(snapPoints, shape, target);
            snapPoints.initialized = true;
        }
        var snapping = {x: isSnapped(event, 'x'), y: isSnapped(event, 'y')};
        forEach(snapLocations, function (location) {
            var snapOrigin = snapContext.getSnapOrigin(location);
            var snapCurrent = {x: event.x + snapOrigin.x, y: event.y + snapOrigin.y};
            forEach(['x', 'y'], function (axis) {
                var locationSnapping;
                if (!snapping[axis]) {
                    locationSnapping = snapPoints.snap(snapCurrent, location, axis, 7);
                    if (locationSnapping !== undefined) {
                        snapping[axis] = {value: locationSnapping, originValue: locationSnapping - snapOrigin[axis]};
                    }
                }
            });
            if (snapping.x && snapping.y) {
                return false;
            }
        });
        this.showSnapLine('vertical', snapping.x && snapping.x.value);
        this.showSnapLine('horizontal', snapping.y && snapping.y.value);
        forEach(['x', 'y'], function (axis) {
            var axisSnapping = snapping[axis];
            if (typeof axisSnapping === 'object') {
                setSnapped(event, axis, axisSnapping.originValue);
            }
        });
    };
    Snapping.prototype._createLine = function (orientation) {
        var root = this._canvas.getLayer('snap');
        var line = create('path');
        attr$1(line, {d: 'M0,0 L0,0'});
        classes$1(line).add('djs-snap-line');
        append(root, line);
        return {
            update: function (position) {
                if (typeof position !== 'number') {
                    attr$1(line, {display: 'none'});
                } else {
                    if (orientation === 'horizontal') {
                        attr$1(line, {d: 'M-100000,' + position + ' L+100000,' + position, display: ''});
                    } else {
                        attr$1(line, {d: 'M ' + position + ',-100000 L ' + position + ', +100000', display: ''});
                    }
                }
            }
        };
    };
    Snapping.prototype._createSnapLines = function () {
        this._snapLines = {horizontal: this._createLine('horizontal'), vertical: this._createLine('vertical')};
    };
    Snapping.prototype.showSnapLine = function (orientation, position) {
        var line = this.getSnapLine(orientation);
        if (line) {
            line.update(position);
        }
        this._asyncHide();
    };
    Snapping.prototype.getSnapLine = function (orientation) {
        if (!this._snapLines) {
            this._createSnapLines();
        }
        return this._snapLines[orientation];
    };
    Snapping.prototype.hide = function () {
        forEach(this._snapLines, function (l) {
            l.update();
        });
    };
    Snapping.prototype.addTargetSnaps = function (snapPoints, shape, target) {
        var siblings = this.getSiblings(shape, target);
        forEach(siblings, function (s) {
            snapPoints.add('mid', mid$2(s));
        });
    };
    Snapping.prototype.getSiblings = function (element, target) {
        return target && filter(target.children, function (e) {
            return !e.hidden && !e.labelTarget && e.host !== element && e !== element;
        });
    };
    var round$b = Math.round;
    var HIGH_PRIORITY$6 = 1500;

    function BpmnSnapping(eventBus, canvas, bpmnRules, elementRegistry) {
        Snapping.call(this, eventBus, canvas);
        eventBus.on('create.start', function (event) {
            var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
            if (is$1(shape, 'bpmn:Participant') && is$1(rootElement, 'bpmn:Process')) {
                initParticipantSnapping(context, shape, rootElement.children);
            }
        });
        eventBus.on(['create.move', 'create.end'], HIGH_PRIORITY$6, function (event) {
            var context = event.context, shape = context.shape, participantSnapBox = context.participantSnapBox;
            if (!isSnapped(event) && participantSnapBox) {
                snapParticipant(participantSnapBox, shape, event);
            }
        });
        eventBus.on('shape.move.start', function (event) {
            var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
            if (is$1(shape, 'bpmn:Participant') && is$1(rootElement, 'bpmn:Process')) {
                initParticipantSnapping(context, shape, rootElement.children);
            }
        });

        function canAttach(shape, target, position) {
            return bpmnRules.canAttach([shape], target, null, position) === 'attach';
        }

        function canConnect(source, target) {
            return bpmnRules.canConnect(source, target);
        }

        eventBus.on(['create.move', 'create.end', 'shape.move.move', 'shape.move.end'], HIGH_PRIORITY$6, function (event) {
            var context = event.context, target = context.target, shape = context.shape;
            if (target && !isSnapped(event) && canAttach(shape, target, event)) {
                snapBoundaryEvent(event, shape, target);
            }
        });
        eventBus.on(['shape.move.hover', 'shape.move.move', 'shape.move.end', 'create.hover', 'create.move', 'create.end'], HIGH_PRIORITY$6, function (event) {
            var context = event.context, shape = context.shape, hover = event.hover;
            if (is$1(hover, 'bpmn:Lane') && !isAny(shape, ['bpmn:Lane', 'bpmn:Participant'])) {
                event.hover = getLanesRoot(hover);
                event.hoverGfx = elementRegistry.getGraphics(event.hover);
            }
        });
        eventBus.on(['connect.move', 'connect.hover', 'connect.end'], HIGH_PRIORITY$6, function (event) {
            var context = event.context, source = context.source, target = context.target;
            var connection = canConnect(source, target) || {};
            if (!context.initialSourcePosition) {
                context.initialSourcePosition = context.sourcePosition;
            }
            if (target && (connection.type === 'bpmn:Association' || connection.type === 'bpmn:DataOutputAssociation' || connection.type === 'bpmn:DataInputAssociation' || connection.type === 'bpmn:SequenceFlow')) {
                context.sourcePosition = mid$2(source);
                snapToPosition(event, mid$2(target));
            } else if (connection.type === 'bpmn:MessageFlow') {
                if (is$1(source, 'bpmn:Event')) {
                    context.sourcePosition = mid$2(source);
                }
                if (is$1(target, 'bpmn:Event')) {
                    snapToPosition(event, mid$2(target));
                }
            } else {
                context.sourcePosition = context.initialSourcePosition;
            }
        });
        eventBus.on('resize.start', HIGH_PRIORITY$6, function (event) {
            var context = event.context, shape = context.shape;
            if (is$1(shape, 'bpmn:SubProcess') && isExpanded(shape)) {
                context.minDimensions = {width: 140, height: 120};
            }
            if (is$1(shape, 'bpmn:Participant')) {
                context.minDimensions = {width: 300, height: 150};
            }
            if (is$1(shape, 'bpmn:Lane') || is$1(shape, 'bpmn:Participant')) {
                context.resizeConstraints = getParticipantSizeConstraints(shape, context.direction, context.balanced);
            }
            if (is$1(shape, 'bpmn:TextAnnotation')) {
                context.minDimensions = {width: 50, height: 30};
            }
        });
    }

    inherits_browser(BpmnSnapping, Snapping);
    BpmnSnapping.$inject = ['eventBus', 'canvas', 'bpmnRules', 'elementRegistry'];
    BpmnSnapping.prototype.initSnap = function (event) {
        var context = event.context, shape = event.shape, shapeMid, shapeBounds, shapeTopLeft, shapeBottomRight,
            snapContext;
        snapContext = Snapping.prototype.initSnap.call(this, event);
        if (is$1(shape, 'bpmn:Participant')) {
            snapContext.setSnapLocations(['top-left', 'bottom-right', 'mid']);
        }
        if (shape) {
            shapeMid = mid$2(shape, event);
            shapeBounds = {
                width: shape.width,
                height: shape.height,
                x: isNaN(shape.x) ? round$b(shapeMid.x - shape.width / 2) : shape.x,
                y: isNaN(shape.y) ? round$b(shapeMid.y - shape.height / 2) : shape.y
            };
            shapeTopLeft = topLeft(shapeBounds);
            shapeBottomRight = bottomRight(shapeBounds);
            snapContext.setSnapOrigin('top-left', {x: shapeTopLeft.x - event.x, y: shapeTopLeft.y - event.y});
            snapContext.setSnapOrigin('bottom-right', {
                x: shapeBottomRight.x - event.x,
                y: shapeBottomRight.y - event.y
            });
            forEach(shape.outgoing, function (c) {
                var docking = c.waypoints[0];
                docking = docking.original || docking;
                snapContext.setSnapOrigin(c.id + '-docking', {x: docking.x - event.x, y: docking.y - event.y});
            });
            forEach(shape.incoming, function (c) {
                var docking = c.waypoints[c.waypoints.length - 1];
                docking = docking.original || docking;
                snapContext.setSnapOrigin(c.id + '-docking', {x: docking.x - event.x, y: docking.y - event.y});
            });
        }
        var source = context.source;
        if (source) {
            snapContext.addDefaultSnap('mid', mid$2(source));
        }
    };
    BpmnSnapping.prototype.addTargetSnaps = function (snapPoints, shape, target) {
        if (is$1(shape, 'bpmn:BoundaryEvent') && shape.type !== 'label') {
            target = target.parent;
        }
        if (is$1(target, 'bpmn:SequenceFlow')) {
            this.addTargetSnaps(snapPoints, shape, target.parent);
        }
        var siblings = this.getSiblings(shape, target) || [];
        forEach(siblings, function (sibling) {
            if (is$1(sibling, 'bpmn:Lane')) {
                return;
            }
            if (sibling.waypoints) {
                forEach(sibling.waypoints.slice(1, -1), function (waypoint, i) {
                    var nextWaypoint = sibling.waypoints[i + 2], previousWaypoint = sibling.waypoints[i];
                    if (!nextWaypoint || !previousWaypoint) {
                        throw new Error('waypoints must exist');
                    }
                    if (nextWaypoint.x === waypoint.x || nextWaypoint.y === waypoint.y || previousWaypoint.x === waypoint.x || previousWaypoint.y === waypoint.y) {
                        snapPoints.add('mid', waypoint);
                    }
                });
                return;
            }
            snapPoints.add('mid', mid$2(sibling));
            if (is$1(sibling, 'bpmn:Participant')) {
                snapPoints.add('top-left', topLeft(sibling));
                snapPoints.add('bottom-right', bottomRight(sibling));
            }
        });
        forEach(shape.incoming, function (c) {
            if (siblings.indexOf(c.source) === -1) {
                snapPoints.add('mid', mid$2(c.source));
            }
            var docking = c.waypoints[0];
            snapPoints.add(c.id + '-docking', docking.original || docking);
        });
        forEach(shape.outgoing, function (c) {
            if (siblings.indexOf(c.target) === -1) {
                snapPoints.add('mid', mid$2(c.target));
            }
            var docking = c.waypoints[c.waypoints.length - 1];
            snapPoints.add(c.id + '-docking', docking.original || docking);
        });
    };

    function initParticipantSnapping(context, shape, elements) {
        if (!elements.length) {
            return;
        }
        var snapBox = getBBox(elements.filter(function (e) {
            return !e.labelTarget && !e.waypoints;
        }));
        snapBox.x -= 50;
        snapBox.y -= 20;
        snapBox.width += 70;
        snapBox.height += 40;
        shape.width = Math.max(shape.width, snapBox.width);
        shape.height = Math.max(shape.height, snapBox.height);
        context.participantSnapBox = snapBox;
    }

    function snapParticipant(snapBox, shape, event, offset) {
        offset = offset || 0;
        var shapeHalfWidth = shape.width / 2 - offset, shapeHalfHeight = shape.height / 2;
        var currentTopLeft = {x: event.x - shapeHalfWidth - offset, y: event.y - shapeHalfHeight};
        var currentBottomRight = {x: event.x + shapeHalfWidth + offset, y: event.y + shapeHalfHeight};
        var snapTopLeft = snapBox, snapBottomRight = bottomRight(snapBox);
        if (currentTopLeft.x >= snapTopLeft.x) {
            setSnapped(event, 'x', snapTopLeft.x + offset + shapeHalfWidth);
        } else if (currentBottomRight.x <= snapBottomRight.x) {
            setSnapped(event, 'x', snapBottomRight.x - offset - shapeHalfWidth);
        }
        if (currentTopLeft.y >= snapTopLeft.y) {
            setSnapped(event, 'y', snapTopLeft.y + shapeHalfHeight);
        } else if (currentBottomRight.y <= snapBottomRight.y) {
            setSnapped(event, 'y', snapBottomRight.y - shapeHalfHeight);
        }
    }

    function snapBoundaryEvent(event, shape, target) {
        var targetTRBL = asTRBL(target);
        var direction = getBoundaryAttachment(event, target);
        if (/top/.test(direction)) {
            setSnapped(event, 'y', targetTRBL.top);
        } else if (/bottom/.test(direction)) {
            setSnapped(event, 'y', targetTRBL.bottom);
        }
        if (/left/.test(direction)) {
            setSnapped(event, 'x', targetTRBL.left);
        } else if (/right/.test(direction)) {
            setSnapped(event, 'x', targetTRBL.right);
        }
    }

    function snapToPosition(event, position) {
        setSnapped(event, 'x', position.x);
        setSnapped(event, 'y', position.y);
    }

    var SnappingModule = {__init__: ['snapping'], snapping: ['type', BpmnSnapping]};

    function SearchPad(canvas, eventBus, overlays, selection) {
        this._open = false;
        this._results = [];
        this._eventMaps = [];
        this._canvas = canvas;
        this._eventBus = eventBus;
        this._overlays = overlays;
        this._selection = selection;
        this._container = domify(SearchPad.BOX_HTML);
        this._searchInput = query(SearchPad.INPUT_SELECTOR, this._container);
        this._resultsContainer = query(SearchPad.RESULTS_CONTAINER_SELECTOR, this._container);
        this._canvas.getContainer().appendChild(this._container);
        eventBus.on(['canvas.destroy', 'diagram.destroy'], this.close, this);
    }

    SearchPad.$inject = ['canvas', 'eventBus', 'overlays', 'selection'];
    SearchPad.prototype._bindEvents = function () {
        var self = this;

        function listen(el, selector, type, fn) {
            self._eventMaps.push({el: el, type: type, listener: delegateEvents.bind(el, selector, type, fn)});
        }

        listen(document, 'html', 'click', function (e) {
            self.close();
        }, true);
        listen(this._container, SearchPad.INPUT_SELECTOR, 'click', function (e) {
            e.stopPropagation();
            e.delegateTarget.focus();
        });
        listen(this._container, SearchPad.RESULT_SELECTOR, 'mouseover', function (e) {
            e.stopPropagation();
            self._scrollToNode(e.delegateTarget);
            self._preselect(e.delegateTarget);
        });
        listen(this._container, SearchPad.RESULT_SELECTOR, 'click', function (e) {
            e.stopPropagation();
            self._select(e.delegateTarget);
        });
        listen(this._container, SearchPad.INPUT_SELECTOR, 'keydown', function (e) {
            if (e.keyCode === 38) {
                e.preventDefault();
            }
            if (e.keyCode === 40) {
                e.preventDefault();
            }
        });
        listen(this._container, SearchPad.INPUT_SELECTOR, 'keyup', function (e) {
            if (e.keyCode === 27) {
                return self.close();
            }
            if (e.keyCode === 13) {
                var selected = self._getCurrentResult();
                return selected ? self._select(selected) : self.close();
            }
            if (e.keyCode === 38) {
                return self._scrollToDirection(true);
            }
            if (e.keyCode === 40) {
                return self._scrollToDirection();
            }
            if (e.keyCode === 37 || e.keyCode === 39) {
                return;
            }
            self._search(e.delegateTarget.value);
        });
    };
    SearchPad.prototype._unbindEvents = function () {
        this._eventMaps.forEach(function (m) {
            delegateEvents.unbind(m.el, m.type, m.listener);
        });
    };
    SearchPad.prototype._search = function (pattern) {
        var self = this;
        this._clearResults();
        if (!pattern || pattern === '') {
            return;
        }
        var searchResults = this._searchProvider.find(pattern);
        if (!searchResults.length) {
            return;
        }
        searchResults.forEach(function (result) {
            var id = result.element.id;
            var node = self._createResultNode(result, id);
            self._results[id] = {element: result.element, node: node};
        });
        var node = query(SearchPad.RESULT_SELECTOR, this._resultsContainer);
        this._scrollToNode(node);
        this._preselect(node);
    };
    SearchPad.prototype._scrollToDirection = function (previous) {
        var selected = this._getCurrentResult();
        if (!selected) {
            return;
        }
        var node = previous ? selected.previousElementSibling : selected.nextElementSibling;
        if (node) {
            this._scrollToNode(node);
            this._preselect(node);
        }
    };
    SearchPad.prototype._scrollToNode = function (node) {
        if (!node || node === this._getCurrentResult()) {
            return;
        }
        var nodeOffset = node.offsetTop;
        var containerScroll = this._resultsContainer.scrollTop;
        var bottomScroll = nodeOffset - this._resultsContainer.clientHeight + node.clientHeight;
        if (nodeOffset < containerScroll) {
            this._resultsContainer.scrollTop = nodeOffset;
        } else if (containerScroll < bottomScroll) {
            this._resultsContainer.scrollTop = bottomScroll;
        }
    };
    SearchPad.prototype._clearResults = function () {
        clear(this._resultsContainer);
        this._results = [];
        this._resetOverlay();
        this._eventBus.fire('searchPad.cleared');
    };
    SearchPad.prototype._getCurrentResult = function () {
        return query(SearchPad.RESULT_SELECTED_SELECTOR, this._resultsContainer);
    };
    SearchPad.prototype._createResultNode = function (result, id) {
        var node = domify(SearchPad.RESULT_HTML);
        if (result.primaryTokens.length > 0) {
            createInnerTextNode(node, result.primaryTokens, SearchPad.RESULT_PRIMARY_HTML);
        }
        createInnerTextNode(node, result.secondaryTokens, SearchPad.RESULT_SECONDARY_HTML);
        attr(node, SearchPad.RESULT_ID_ATTRIBUTE, id);
        this._resultsContainer.appendChild(node);
        return node;
    };
    SearchPad.prototype.registerProvider = function (provider) {
        this._searchProvider = provider;
    };
    SearchPad.prototype.open = function () {
        if (!this._searchProvider) {
            throw new Error('no search provider registered');
        }
        if (this.isOpen()) {
            return;
        }
        this._bindEvents();
        this._open = true;
        classes(this._container).add('open');
        this._searchInput.focus();
        this._eventBus.fire('searchPad.opened');
    };
    SearchPad.prototype.close = function () {
        if (!this.isOpen()) {
            return;
        }
        this._unbindEvents();
        this._open = false;
        classes(this._container).remove('open');
        this._clearResults();
        this._searchInput.value = '';
        this._searchInput.blur();
        this._resetOverlay();
        this._eventBus.fire('searchPad.closed');
    };
    SearchPad.prototype.toggle = function () {
        this.isOpen() ? this.close() : this.open();
    };
    SearchPad.prototype.isOpen = function () {
        return this._open;
    };
    SearchPad.prototype._preselect = function (node) {
        var selectedNode = this._getCurrentResult();
        if (node === selectedNode) {
            return;
        }
        if (selectedNode) {
            classes(selectedNode).remove(SearchPad.RESULT_SELECTED_CLASS);
        }
        var id = attr(node, SearchPad.RESULT_ID_ATTRIBUTE);
        var element = this._results[id].element;
        classes(node).add(SearchPad.RESULT_SELECTED_CLASS);
        this._resetOverlay(element);
        this._centerViewbox(element);
        this._selection.select(element);
        this._eventBus.fire('searchPad.preselected', element);
    };
    SearchPad.prototype._select = function (node) {
        var id = attr(node, SearchPad.RESULT_ID_ATTRIBUTE);
        var element = this._results[id].element;
        this.close();
        this._resetOverlay();
        this._centerViewbox(element);
        this._selection.select(element);
        this._eventBus.fire('searchPad.selected', element);
    };
    SearchPad.prototype._centerViewbox = function (element) {
        var viewbox = this._canvas.viewbox();
        var box = getBBox(element);
        var newViewbox = {
            x: (box.x + box.width / 2) - viewbox.outer.width / 2,
            y: (box.y + box.height / 2) - viewbox.outer.height / 2,
            width: viewbox.outer.width,
            height: viewbox.outer.height
        };
        this._canvas.viewbox(newViewbox);
        this._canvas.zoom(viewbox.scale);
    };
    SearchPad.prototype._resetOverlay = function (element) {
        if (this._overlayId) {
            this._overlays.remove(this._overlayId);
        }
        if (element) {
            var box = getBBox(element);
            var overlay = constructOverlay(box);
            this._overlayId = this._overlays.add(element, overlay);
        }
    };

    function constructOverlay(box) {
        var offset = 6;
        var w = box.width + offset * 2;
        var h = box.height + offset * 2;
        var styles = ['width: ' + w + 'px', 'height: ' + h + 'px'].join('; ');
        return {
            position: {bottom: h - offset, right: w - offset},
            show: true,
            html: '<div style="' + styles + '" class="' + SearchPad.OVERLAY_CLASS + '"></div>'
        };
    }

    function createInnerTextNode(parentNode, tokens, template) {
        var text = createHtmlText(tokens);
        var childNode = domify(template);
        childNode.innerHTML = text;
        parentNode.appendChild(childNode);
    }

    function createHtmlText(tokens) {
        var htmlText = '';
        tokens.forEach(function (t) {
            if (t.matched) {
                htmlText += '<strong class="' + SearchPad.RESULT_HIGHLIGHT_CLASS + '">' + t.matched + '</strong>';
            } else {
                htmlText += t.normal;
            }
        });
        return htmlText !== '' ? htmlText : null;
    }

    SearchPad.CONTAINER_SELECTOR = '.djs-search-container';
    SearchPad.INPUT_SELECTOR = '.djs-search-input input';
    SearchPad.RESULTS_CONTAINER_SELECTOR = '.djs-search-results';
    SearchPad.RESULT_SELECTOR = '.djs-search-result';
    SearchPad.RESULT_SELECTED_CLASS = 'djs-search-result-selected';
    SearchPad.RESULT_SELECTED_SELECTOR = '.' + SearchPad.RESULT_SELECTED_CLASS;
    SearchPad.RESULT_ID_ATTRIBUTE = 'data-result-id';
    SearchPad.RESULT_HIGHLIGHT_CLASS = 'djs-search-highlight';
    SearchPad.OVERLAY_CLASS = 'djs-search-overlay';
    SearchPad.BOX_HTML = '<div class="djs-search-container djs-draggable djs-scrollable">' + '<div class="djs-search-input">' + '<input type="text"/>' + '</div>' + '<div class="djs-search-results"></div>' + '</div>';
    SearchPad.RESULT_HTML = '<div class="djs-search-result"></div>';
    SearchPad.RESULT_PRIMARY_HTML = '<div class="djs-search-result-primary"></div>';
    SearchPad.RESULT_SECONDARY_HTML = '<p class="djs-search-result-secondary"></p>';
    var SearchPadModule = {__depends__: [OverlaysModule, SelectionModule], searchPad: ['type', SearchPad]};

    function BpmnSearchProvider(elementRegistry, searchPad, canvas) {
        this._elementRegistry = elementRegistry;
        this._canvas = canvas;
        searchPad.registerProvider(this);
    }

    BpmnSearchProvider.$inject = ['elementRegistry', 'searchPad', 'canvas'];
    BpmnSearchProvider.prototype.find = function (pattern) {
        var rootElement = this._canvas.getRootElement();
        var elements = this._elementRegistry.filter(function (element) {
            if (element.labelTarget) {
                return false;
            }
            return true;
        });
        elements = filter(elements, function (element) {
            return element !== rootElement;
        });
        elements = map(elements, function (element) {
            return {
                primaryTokens: matchAndSplit(getLabel(element), pattern),
                secondaryTokens: matchAndSplit(element.id, pattern),
                element: element
            };
        });
        elements = filter(elements, function (element) {
            return hasMatched(element.primaryTokens) || hasMatched(element.secondaryTokens);
        });
        elements = sortBy(elements, function (element) {
            return getLabel(element.element) + element.element.id;
        });
        return elements;
    };

    function hasMatched(tokens) {
        var matched = filter(tokens, function (t) {
            return !!t.matched;
        });
        return matched.length > 0;
    }

    function matchAndSplit(text, pattern) {
        var tokens = [], originalText = text;
        if (!text) {
            return tokens;
        }
        text = text.toLowerCase();
        pattern = pattern.toLowerCase();
        var i = text.indexOf(pattern);
        if (i > -1) {
            if (i !== 0) {
                tokens.push({normal: originalText.substr(0, i)});
            }
            tokens.push({matched: originalText.substr(i, pattern.length)});
            if (pattern.length + i < text.length) {
                tokens.push({normal: originalText.substr(pattern.length + i, text.length)});
            }
        } else {
            tokens.push({normal: originalText});
        }
        return tokens;
    }

    var SearchModule = {
        __depends__: [SearchPadModule],
        __init__: ['bpmnSearch'],
        bpmnSearch: ['type', BpmnSearchProvider]
    };
    var initialDiagram = '<?xml version="1.0" encoding="UTF-8"?>' + '<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" ' + 'xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" ' + 'xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" ' + 'targetNamespace="http://bpmn.io/schema/bpmn" ' + 'id="Definitions_1">' + '<bpmn:process id="Process_1" isExecutable="false">' + '<bpmn:startEvent id="StartEvent_1"/>' + '</bpmn:process>' + '<bpmndi:BPMNDiagram id="BPMNDiagram_1">' + '<bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">' + '<bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">' + '<dc:Bounds height="36.0" width="36.0" x="173.0" y="102.0"/>' + '</bpmndi:BPMNShape>' + '</bpmndi:BPMNPlane>' + '</bpmndi:BPMNDiagram>' + '</bpmn:definitions>';

    function Modeler(options) {
        Viewer.call(this, options);
        this.on('import.parse.complete', function (event) {
            if (!event.error) {
                this._collectIds(event.definitions, event.context);
            }
        }, this);
        this.on('diagram.destroy', function () {
            this.get('moddle').ids.clear();
        }, this);
    }

    inherits_browser(Modeler, Viewer);
    Modeler.Viewer = Viewer;
    Modeler.NavigatedViewer = NavigatedViewer;
    Modeler.prototype.createDiagram = function (done) {
        return this.importXML(initialDiagram, done);
    };
    Modeler.prototype._createModdle = function (options) {
        var moddle = Viewer.prototype._createModdle.call(this, options);
        moddle.ids = new ids([32, 36, 1]);
        return moddle;
    };
    Modeler.prototype._collectIds = function (definitions, context) {
        var moddle = definitions.$model, ids$$1 = moddle.ids, id;
        ids$$1.clear();
        for (id in context.elementsById) {
            ids$$1.claim(id, context.elementsById[id]);
        }
    };
    Modeler.prototype._interactionModules = [KeyboardMoveModule, MoveCanvasModule, TouchModule$1, ZoomScrollModule];
    Modeler.prototype._modelingModules = [AlignElementsModule, AutoPlaceModule, AutoScrollModule, AutoResizeModule, BendpointsModule, ContextPadModule$1, CopyPasteModule$1, DistributeElementsModule$1, EditorActionsModule$1, KeyboardModule$1, KeyboardMoveSelectionModule, LabelEditingModule, ModelingModule, MoveModule, PaletteModule$1, ReplacePreviewModule, ResizeModule, SnappingModule, SearchModule];
    Modeler.prototype._modules = [].concat(Modeler.prototype._modules, Modeler.prototype._interactionModules, Modeler.prototype._modelingModules);
    return Modeler;
})));
